{
  "generated_at": "2026-07-20T03:13:13Z",
  "total_count": 1183,
  "downloaded_count": 1183,
  "failed_count": 0,
  "total_size_bytes": 32952938839,
  "category_counts": {
    "Acoustic": 98,
    "Atmospheric": 100,
    "Beach": 29,
    "Chimes & Bowls": 19,
    "Cinematic": 100,
    "Classical": 100,
    "Drone": 62,
    "Electronic": 100,
    "Forest": 20,
    "Grooves": 100,
    "Lofi": 100,
    "Nightsounds": 22,
    "Piano": 100,
    "Post Rock": 100,
    "Rain": 24,
    "Rainforest": 23,
    "River": 19,
    "Thunder": 32,
    "Underwater": 17,
    "Wind": 18
  },
  "items": [
    {
      "track_id": "6a54f67e6ff4d00262502701",
      "name": "Knowing Glance",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.28,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/KnowingGlance_Focus_Creativity_Acoustic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=Sq8TMx3iB99OY046RNJwf7HOCmWeo7pFcblwk71%2Bk%2FU%3D",
      "cdn_url": "https://audio2.brain.fm/KnowingGlance_Focus_Creativity_Acoustic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "KnowingGlance_Focus_Creativity_Acoustic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "KnowingGlance_Focus_Creativity_Acoustic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/KnowingGlance_Focus_Creativity_Acoustic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28023384,
      "sha256": "fea1f6ceb61881e97b74ed650bab67e61fcd187d38fccde445c590058a28a56f",
      "download_error": null
    },
    {
      "track_id": "6a4bb6e54518fc4e1e406266",
      "name": "In Daybreak",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 91,
      "brightness_level": 0.62,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/InDaybreak_Focus_DeepWork_Acoustic_30_91bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=JxSGwmcsy%2BGLwd1bBQyNkK%2FdLLMUuAMbckqm5%2FqhGCA%3D",
      "cdn_url": "https://audio2.brain.fm/InDaybreak_Focus_DeepWork_Acoustic_30_91bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InDaybreak_Focus_DeepWork_Acoustic_30_91bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InDaybreak_Focus_DeepWork_Acoustic_30_91bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/InDaybreak_Focus_DeepWork_Acoustic_30_91bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30835387,
      "sha256": "bd47899bb0a492caf5497116526926777de0a5705a5fe6626752540e807ca2aa",
      "download_error": null
    },
    {
      "track_id": "6a3017667a8f5056573c8fc7",
      "name": "Out In The Meadows",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.45,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.95,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/OutInTheMeadows_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=gA4A%2BzqBTSUrofPf1O7xuo%2FK15eHqTPP4jzaaMvgcQk%3D",
      "cdn_url": "https://audio2.brain.fm/OutInTheMeadows_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OutInTheMeadows_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OutInTheMeadows_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/OutInTheMeadows_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29049863,
      "sha256": "b15cb11d0f9486d3f1fdac10e6d9964214b1625ff4bc37398b6fc9ac845f9b25",
      "download_error": null
    },
    {
      "track_id": "6a1dca81b7f8597b461238f8",
      "name": "Candor Check",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.55,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Candor%20Check_Focus_Learning_Acoustic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=yswG5848DjNoAFpd9OeilxWevbf6IjThCOj9kdsqb6Q%3D",
      "cdn_url": "https://audio2.brain.fm/Candor%20Check_Focus_Learning_Acoustic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Candor Check_Focus_Learning_Acoustic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Candor-Check_Focus_Learning_Acoustic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Candor-Check_Focus_Learning_Acoustic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29705893,
      "sha256": "bde368fecb23d81525bd6c770cb2d7f0329ab38114acb38b8d639fb52313b51d",
      "download_error": null
    },
    {
      "track_id": "6a0b8b70e6017bccd74b7e82",
      "name": "Just Like New",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 74,
      "brightness_level": 0.55,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/JustLikeNew_Focus_Learning_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=rap0v6SFA44bNGNxG2DQITX1eZce%2B2DHVSmsdh3SkOc%3D",
      "cdn_url": "https://audio2.brain.fm/JustLikeNew_Focus_Learning_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JustLikeNew_Focus_Learning_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "JustLikeNew_Focus_Learning_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/JustLikeNew_Focus_Learning_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29206940,
      "sha256": "5225aa31461ef5fb2f6302b5e22cc69a7ae0cb0f366f69c34331fa014a96c101",
      "download_error": null
    },
    {
      "track_id": "69f8b9651c706aff1baf1470",
      "name": "Cashew Gallery",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.28,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/CashewGallery_Focus_Creativity_Acoustic_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=3gMZQ8fIEoNbvx82q39WQoqLD0CRs9ErPiXgQKeq2lo%3D",
      "cdn_url": "https://audio2.brain.fm/CashewGallery_Focus_Creativity_Acoustic_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CashewGallery_Focus_Creativity_Acoustic_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CashewGallery_Focus_Creativity_Acoustic_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/CashewGallery_Focus_Creativity_Acoustic_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27359616,
      "sha256": "0eacc4ab46cf5c6d70d4cae496b721f12816c3b4f12cd714bfb0e99c900fae1d",
      "download_error": null
    },
    {
      "track_id": "69f8b87a1c706aff1baf0ae2",
      "name": "Down River",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.51,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/DownRiver_Focus_Creativity_Acoustic_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=c8HUVT6qScJF7Rg5ohqZswtYI4HWm5kjx1r8rwUSXDc%3D",
      "cdn_url": "https://audio2.brain.fm/DownRiver_Focus_Creativity_Acoustic_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DownRiver_Focus_Creativity_Acoustic_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DownRiver_Focus_Creativity_Acoustic_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/DownRiver_Focus_Creativity_Acoustic_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27551210,
      "sha256": "2b6a11f5b01ed365a651b54a39416b7bd927dc8163d56816c3f316a0e4510843",
      "download_error": null
    },
    {
      "track_id": "69e68571dce2120639c6e3fb",
      "name": "Shady Creek",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.48,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/ShadyCreek_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=MSnNZevOY0fCwt%2FjSNBKo0HgAo46Ki9nMykhDpEvFtE%3D",
      "cdn_url": "https://audio2.brain.fm/ShadyCreek_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ShadyCreek_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ShadyCreek_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/ShadyCreek_Focus_DeepWork_Acoustic_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26620087,
      "sha256": "4be5553ff0c5033812083dbced72b9145a2498b094302c867bf832f84cf95d9f",
      "download_error": null
    },
    {
      "track_id": "69e6855bdce2120639c6e345",
      "name": "What I've Felt",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.55,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/What%20I've%20Felt_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=186VT7zeKEirney2FI91gcnAc9piAUearoiGS5EjMXs%3D",
      "cdn_url": "https://audio2.brain.fm/What%20I've%20Felt_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "What I've Felt_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "What-I-ve-Felt_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/What-I-ve-Felt_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30229285,
      "sha256": "5e1e2bc1452352609cd92b497283cd60a2be3fff49044d8edd78560cca360977",
      "download_error": null
    },
    {
      "track_id": "69d026bf9b9914998a32d062",
      "name": "Showcase",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.59,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Showcase_Focus_Creativity_Acoustic_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=pNMruCHefzFDJJvet8chfLzstijPiOPcW8jDs6ts4IE%3D",
      "cdn_url": "https://audio2.brain.fm/Showcase_Focus_Creativity_Acoustic_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Showcase_Focus_Creativity_Acoustic_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Showcase_Focus_Creativity_Acoustic_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Showcase_Focus_Creativity_Acoustic_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29085510,
      "sha256": "17206eec3abe00fb1f20bda86a101966e86b4429290d84b5a5e673b2ea3b3117",
      "download_error": null
    },
    {
      "track_id": "69d0268d9b9914998a32ce66",
      "name": "A Painting",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.51,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/A%20Painting_Focus_Creativity_Acoustic_30_86bpm_LowNELNrmlzd2_VBR5.mp3?expiration=1792292120270&token=JxXvnGLN%2FFi9bkF4JyX43S7Jsz4eTE15vH8Qc6xMx%2F4%3D",
      "cdn_url": "https://audio2.brain.fm/A%20Painting_Focus_Creativity_Acoustic_30_86bpm_LowNELNrmlzd2_VBR5.mp3",
      "remote_filename": "A Painting_Focus_Creativity_Acoustic_30_86bpm_LowNELNrmlzd2_VBR5.mp3",
      "filename": "A-Painting_Focus_Creativity_Acoustic_30_86bpm_LowNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/A-Painting_Focus_Creativity_Acoustic_30_86bpm_LowNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29993501,
      "sha256": "a91ef62f99a2a87e52bcfabc9f23309bf8576948cfb324ad2d0908457acfdf3b",
      "download_error": null
    },
    {
      "track_id": "69c2bc671b6ecfe6c4a71e1c",
      "name": "Dark Stone",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 77,
      "brightness_level": 0.52,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/DarkStone_Focus_Creativity_Acoustic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=u8PtX0tMku%2Bt3l8BMLRhup8942D0JfnE01eq6roCJe4%3D",
      "cdn_url": "https://audio2.brain.fm/DarkStone_Focus_Creativity_Acoustic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DarkStone_Focus_Creativity_Acoustic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DarkStone_Focus_Creativity_Acoustic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/DarkStone_Focus_Creativity_Acoustic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30487153,
      "sha256": "45e651341d176379573ecc8584e4b11572acb493abeb97817447e336011ca05e",
      "download_error": null
    },
    {
      "track_id": "69aee27973bfe2099d5179a4",
      "name": "Setting It Up",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.74,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/SettingItUp_Focus_Creativity_Acoustic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=DnT0OTX%2BMqq2KV4K%2F9otyG0A1MMlAtoWOrMiggK8nPA%3D",
      "cdn_url": "https://audio2.brain.fm/SettingItUp_Focus_Creativity_Acoustic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SettingItUp_Focus_Creativity_Acoustic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SettingItUp_Focus_Creativity_Acoustic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/SettingItUp_Focus_Creativity_Acoustic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30916637,
      "sha256": "955744607c47f6272c3e880f3c3f07ae8dff55672beee3c213e9a41fea55481b",
      "download_error": null
    },
    {
      "track_id": "699cafd59033fe9e7ccfbc18",
      "name": "Seedling",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.17,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Seedling_Focus_DeepWork_Acoustic_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=xGclFONNHVBDWmAW0V6Mkwx5gZz3A7gu5Lq55CFJIdw%3D",
      "cdn_url": "https://audio2.brain.fm/Seedling_Focus_DeepWork_Acoustic_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Seedling_Focus_DeepWork_Acoustic_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Seedling_Focus_DeepWork_Acoustic_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Seedling_Focus_DeepWork_Acoustic_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21749250,
      "sha256": "9f7f81eaae7d67a76d778f7af441f59d727914e5a0c215b90dfdb63da70461c6",
      "download_error": null
    },
    {
      "track_id": "699cad3c9033fe9e7ccfa6fd",
      "name": "Sunrise Again",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.42,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/SunriseAgain_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=psZPHub655bVB%2FJ4KM5EIXyfOYhQsDtlx%2Bdx%2BQq4sIc%3D",
      "cdn_url": "https://audio2.brain.fm/SunriseAgain_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SunriseAgain_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SunriseAgain_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/SunriseAgain_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27741007,
      "sha256": "d72aa2faaa2a34e306c31838f1c90347a3249a44af1450b95a49ce01a4136067",
      "download_error": null
    },
    {
      "track_id": "698a15f48a4a8f35be583d69",
      "name": "Face to Face",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.28,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/FacetoFace_Focus_Creativity_Acoustic_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=Le2ZWaTAtx3QfiP7hhXqfUhvkjxVyftoIBfLyqO8VfI%3D",
      "cdn_url": "https://audio2.brain.fm/FacetoFace_Focus_Creativity_Acoustic_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FacetoFace_Focus_Creativity_Acoustic_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FacetoFace_Focus_Creativity_Acoustic_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/FacetoFace_Focus_Creativity_Acoustic_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25694228,
      "sha256": "3aa9e6a3de22dcf1ec338834fc00293788ee3804037395b48709b95c93066c16",
      "download_error": null
    },
    {
      "track_id": "698a15b08a4a8f35be5839c3",
      "name": "On the Road",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.49,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.87,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/OntheRoad_Focus_DeepWork_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=DCLJkVAQjXO3TYKs3w29UCX4Nu7FuCbZcf0PGy2LHak%3D",
      "cdn_url": "https://audio2.brain.fm/OntheRoad_Focus_DeepWork_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OntheRoad_Focus_DeepWork_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OntheRoad_Focus_DeepWork_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/OntheRoad_Focus_DeepWork_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26061921,
      "sha256": "4aa78fe2e682d970b4756f6fd06c61693c5363c09c5cd1ee207b0565076825c9",
      "download_error": null
    },
    {
      "track_id": "6977b601597917b519504df4",
      "name": "Old Friends",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.51,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/OldFriends_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=cujTkFfCP%2FmIiRC4ZxDSvLoywJJ1cdCKd1beeoa3zWM%3D",
      "cdn_url": "https://audio2.brain.fm/OldFriends_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OldFriends_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OldFriends_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/OldFriends_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29424347,
      "sha256": "da6402c5274e2d8da952d3160ce9feed8321be9133469d8a55a595e5fc1c2074",
      "download_error": null
    },
    {
      "track_id": "69655bdd212c8d55194eee2c",
      "name": "Comets",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.28,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.86,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Comets_Focus_DeepWork_Acoustic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=pfMW6a3uLHCtxzG%2BILtpIWkMxJ0MIHy%2FFnpcCoX6Tq0%3D",
      "cdn_url": "https://audio2.brain.fm/Comets_Focus_DeepWork_Acoustic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Comets_Focus_DeepWork_Acoustic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Comets_Focus_DeepWork_Acoustic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Comets_Focus_DeepWork_Acoustic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25431868,
      "sha256": "1edfcaeffee799becd1e0eafe6151f4d4c11368b3bf15399176a76d88c81fe23",
      "download_error": null
    },
    {
      "track_id": "69655a83212c8d55194ee79b",
      "name": "Any Given Option",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/AnyGivenOption_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=pLLocw%2Fg%2FxnpYTtBwYNibhS%2Baat8%2BfAJAZ1QgdmKmOw%3D",
      "cdn_url": "https://audio2.brain.fm/AnyGivenOption_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AnyGivenOption_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AnyGivenOption_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/AnyGivenOption_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28954148,
      "sha256": "bb19a444851b4dfeae757e35d2424348441f22cbfeca96de3e7f9c90d9a15e94",
      "download_error": null
    },
    {
      "track_id": "69655a408afa49f5711b8f40",
      "name": "Quiet Youth",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.59,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/QuietYouth_Focus_DeepWork_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=GJz7CjRMwUMCtEl5veL%2BYAk%2BvsjP0wAK%2F41ajvZQEho%3D",
      "cdn_url": "https://audio2.brain.fm/QuietYouth_Focus_DeepWork_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "QuietYouth_Focus_DeepWork_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "QuietYouth_Focus_DeepWork_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/QuietYouth_Focus_DeepWork_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30733642,
      "sha256": "6780beeb495d66e881422683f835a29adcf84b02dade48183f3f90e632b86ffc",
      "download_error": null
    },
    {
      "track_id": "6952f3499e729f65562d10ac",
      "name": "Steady Improvements",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.62,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/SteadyImprovements_Focus_Creativity_Acoustic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=KlmrKNfE1QXdFGDoaVInd2n%2BrNEwAWwXT%2BBWHjADQkI%3D",
      "cdn_url": "https://audio2.brain.fm/SteadyImprovements_Focus_Creativity_Acoustic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SteadyImprovements_Focus_Creativity_Acoustic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SteadyImprovements_Focus_Creativity_Acoustic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/SteadyImprovements_Focus_Creativity_Acoustic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30198264,
      "sha256": "10eb553bb9e3b7cfdfcfe9cb5ed96e67d2c4f5fa060f4e9ace8341d78320daa8",
      "download_error": null
    },
    {
      "track_id": "69405992913e2d2bff955913",
      "name": "Living Water",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.54,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/LivingWater_Focus_DeepWork_Acoustic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=So4ww6sna1f2ArcYd5gA9lT%2F04LDXUfGRJb5%2FF7HIbU%3D",
      "cdn_url": "https://audio2.brain.fm/LivingWater_Focus_DeepWork_Acoustic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LivingWater_Focus_DeepWork_Acoustic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LivingWater_Focus_DeepWork_Acoustic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/LivingWater_Focus_DeepWork_Acoustic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30979345,
      "sha256": "a42cf1d2e5a4775ad4cf453bf618deb016a332d331404cc87fc39192a8e617ef",
      "download_error": null
    },
    {
      "track_id": "692dbe92b8f361da92eba2e7",
      "name": "Crescented",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.33,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Crescented_Focus_Creativity_Acoustic_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=EuUQiiG6b44vDMflfbPsgfhdn9gLG0m%2BxmPdxNeU5N0%3D",
      "cdn_url": "https://audio2.brain.fm/Crescented_Focus_Creativity_Acoustic_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Crescented_Focus_Creativity_Acoustic_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Crescented_Focus_Creativity_Acoustic_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Crescented_Focus_Creativity_Acoustic_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26327986,
      "sha256": "10e1bc10a6e4cfd3d44cf33ce691b676fa8c1eee58f9c63cbabf953d27507b75",
      "download_error": null
    },
    {
      "track_id": "691b3c06a1c962ea641efb8f",
      "name": "Snow Cadence",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.57,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/SnowCadence_Focus_Learning_Acoustic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=0fn%2BRWFMZpf0510AGTJgptMDD%2B6GfMQJ7vVH7GKA8co%3D",
      "cdn_url": "https://audio2.brain.fm/SnowCadence_Focus_Learning_Acoustic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SnowCadence_Focus_Learning_Acoustic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SnowCadence_Focus_Learning_Acoustic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/SnowCadence_Focus_Learning_Acoustic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26197689,
      "sha256": "856adfeebbbeaf03224c97fe441e3ad851bde97710e983ddf50790b654f77083",
      "download_error": null
    },
    {
      "track_id": "69091a33312eb1fe04659795",
      "name": "Gentle Mornings",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 83,
      "brightness_level": 0.59,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/GentleMornings_Focus_DeepWork_Acoustic_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=6GX9IITJcip7dJbk4A9P3K9hA1WWgU5%2Fr4HJ5hMRip8%3D",
      "cdn_url": "https://audio2.brain.fm/GentleMornings_Focus_DeepWork_Acoustic_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GentleMornings_Focus_DeepWork_Acoustic_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GentleMornings_Focus_DeepWork_Acoustic_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/GentleMornings_Focus_DeepWork_Acoustic_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29031177,
      "sha256": "20d48c0030ee0833e6dbe04fc7ccdec81ca1bafdd42066b430e805873e4fa0b4",
      "download_error": null
    },
    {
      "track_id": "690918a2312eb1fe04659013",
      "name": "What You're Looking For",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 83,
      "brightness_level": 0.41,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/What%20You're%20Looking%20For_Focus_Creativity_Acoustic_30_83bpm_MedNELNrmlzd2_VBR5.mp3?expiration=1792292120270&token=cIYXSgeIuNQSXwMB2vzn8pshktm7knQk0C5%2BYuu0sbk%3D",
      "cdn_url": "https://audio2.brain.fm/What%20You're%20Looking%20For_Focus_Creativity_Acoustic_30_83bpm_MedNELNrmlzd2_VBR5.mp3",
      "remote_filename": "What You're Looking For_Focus_Creativity_Acoustic_30_83bpm_MedNELNrmlzd2_VBR5.mp3",
      "filename": "What-You-re-Looking-For_Focus_Creativity_Acoustic_30_83bpm_MedNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/What-You-re-Looking-For_Focus_Creativity_Acoustic_30_83bpm_MedNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28885423,
      "sha256": "cbd1f84cc111166d0fc65a90d96d8227572574c3160257514ead7a06cf140571",
      "download_error": null
    },
    {
      "track_id": "68f665b8e8a4cc0a7401c3b6",
      "name": "All That's Left",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.12,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/AllThat'sLeft_Focus_DeepWork_Acoustic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=zew7YU%2BwEUm1gdn1SvMYc7df1mndtOFiuKci23nYJ90%3D",
      "cdn_url": "https://audio2.brain.fm/AllThat'sLeft_Focus_DeepWork_Acoustic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AllThat'sLeft_Focus_DeepWork_Acoustic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AllThat-sLeft_Focus_DeepWork_Acoustic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/AllThat-sLeft_Focus_DeepWork_Acoustic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30852242,
      "sha256": "20d4fa368a43cda2789be8cb9611e6b724c53af678a9d13ff527e15ab0e9aa05",
      "download_error": null
    },
    {
      "track_id": "68e3d6f52d873930bbbf79bc",
      "name": "Whatever's Next",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.41,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Whatever's%20Next_Focus_Creativity_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=MZFcsy%2FCJxBQUPhmTVSVv5dNQb8d5AYR%2FRrVXC%2FiKLE%3D",
      "cdn_url": "https://audio2.brain.fm/Whatever's%20Next_Focus_Creativity_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Whatever's Next_Focus_Creativity_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Whatever-s-Next_Focus_Creativity_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Whatever-s-Next_Focus_Creativity_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28445508,
      "sha256": "42fde7f230862bf9a0ab3ca012cefbe6d2d612cff9f4a106e2f2b2d0904dea59",
      "download_error": null
    },
    {
      "track_id": "68d179c7d9158d8853b175e0",
      "name": "French Fruit",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 91,
      "brightness_level": 0.61,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/FrenchFruit_Focus_Creativity_Acoustic_30_91bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=MSmyxp92%2B1P0lsyA7r%2Fvd492bnQ0RO1YmgovS02cQEg%3D",
      "cdn_url": "https://audio2.brain.fm/FrenchFruit_Focus_Creativity_Acoustic_30_91bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FrenchFruit_Focus_Creativity_Acoustic_30_91bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FrenchFruit_Focus_Creativity_Acoustic_30_91bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/FrenchFruit_Focus_Creativity_Acoustic_30_91bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29851087,
      "sha256": "077b52a80b91168cfddd4623c7bb93641256b1a3684044e7de12739df9ed2989",
      "download_error": null
    },
    {
      "track_id": "68d17847a2277468b10cd417",
      "name": "A Light Rain",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.3,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/A%20Light%20Rain_Focus_Learning_Acoustic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=67OBSxKVNfuYVSrr5Dn034ftEJRZyNwgh026E5Q8IA8%3D",
      "cdn_url": "https://audio2.brain.fm/A%20Light%20Rain_Focus_Learning_Acoustic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "A Light Rain_Focus_Learning_Acoustic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "A-Light-Rain_Focus_Learning_Acoustic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/A-Light-Rain_Focus_Learning_Acoustic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26764800,
      "sha256": "f5a8bc866c497eae9bf515d2a4f019d726291eedf95d5f8d5f4eb79279364ab6",
      "download_error": null
    },
    {
      "track_id": "68bf2419bab547755c78738f",
      "name": "A Simpler Way",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 74,
      "brightness_level": 0.52,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/ASimplerWay_Focus_DeepWork_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=fbGWES4kbcI%2BOvUsBHcEEoaQgJAhaEZH7QnyufhWR8E%3D",
      "cdn_url": "https://audio2.brain.fm/ASimplerWay_Focus_DeepWork_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ASimplerWay_Focus_DeepWork_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ASimplerWay_Focus_DeepWork_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/ASimplerWay_Focus_DeepWork_Acoustic_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29680610,
      "sha256": "9059993becebdba4812f7378d24af18cb3115bd4c5904a35599e00215fc61b0d",
      "download_error": null
    },
    {
      "track_id": "68bf239295e372361f91f115",
      "name": "Eyes Closed",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.38,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/EyesClosed_Focus_Learning_Acoustic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=fVH30oyTAGaj88gxSLDurxeOJEMe0%2FZHKYYxzrc5czA%3D",
      "cdn_url": "https://audio2.brain.fm/EyesClosed_Focus_Learning_Acoustic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EyesClosed_Focus_Learning_Acoustic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EyesClosed_Focus_Learning_Acoustic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/EyesClosed_Focus_Learning_Acoustic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25819144,
      "sha256": "925ffe6e126489aa535f207c4353faab98d38f0efe7cc8650934ac1839fa791d",
      "download_error": null
    },
    {
      "track_id": "68aca49d605d1de9ea68bbaf",
      "name": "Never Leave",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.58,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/NeverLeave_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=Q2tqqBRfT0a%2BUpnLSXU4caOANlbb%2Fm1mGtEQnGorIzA%3D",
      "cdn_url": "https://audio2.brain.fm/NeverLeave_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NeverLeave_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NeverLeave_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/NeverLeave_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30636120,
      "sha256": "ca5e9d99677855ac0133d8960154dfa106201886601cba0cc4d277772ecd82b7",
      "download_error": null
    },
    {
      "track_id": "689a231ecc7f78cc36b7bb53",
      "name": "Grassroots",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.59,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Grassroots_Focus_DeepWork_Acoustic_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=3QzlUtlupjMvYD41eKpF2mi44BBv6UGYNe%2FQs3A5SI0%3D",
      "cdn_url": "https://audio2.brain.fm/Grassroots_Focus_DeepWork_Acoustic_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Grassroots_Focus_DeepWork_Acoustic_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Grassroots_Focus_DeepWork_Acoustic_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Grassroots_Focus_DeepWork_Acoustic_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31063608,
      "sha256": "9fe28664675c324167e4ee6dbd018e009ae71a31a5635a4f6f8ab864b7b0b386",
      "download_error": null
    },
    {
      "track_id": "689a22e5cc7f78cc36b7ba6a",
      "name": "Rolling Creek",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.42,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/RollingCreek_Focus_Creativity_Acoustic_98BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=xzwxHaxSOx3lzo1Lh9MiTSwbBGKirThsuQamtm1iqKM%3D",
      "cdn_url": "https://audio2.brain.fm/RollingCreek_Focus_Creativity_Acoustic_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RollingCreek_Focus_Creativity_Acoustic_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RollingCreek_Focus_Creativity_Acoustic_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/RollingCreek_Focus_Creativity_Acoustic_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26062151,
      "sha256": "5c6752da809a1a2cf76feb803760806d631bb7af9eb375c0d8651c39a727be25",
      "download_error": null
    },
    {
      "track_id": "6888c938c24bb893747ef731",
      "name": "Starlit Moon",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.7,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/StarlitMoon_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=6L8IHL8q4IuB0mVLJ%2Fbi42jJ2vto8YYfwTi5p1hR5Xs%3D",
      "cdn_url": "https://audio2.brain.fm/StarlitMoon_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StarlitMoon_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StarlitMoon_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/StarlitMoon_Focus_Creativity_Acoustic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28179617,
      "sha256": "5d8041564960843d986066f9e68c2403a98c363f0b2400f6f778760357124df9",
      "download_error": null
    },
    {
      "track_id": "6888c7ffb997579cf699b4bd",
      "name": "Together",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.6,
      "complexity_level": 0.92,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Together_Focus_Learning_Acoustic_30_87bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=LS2smmy6bZXt0fGgR08OWPY%2FssLHN6mEr2dnpkNxlM8%3D",
      "cdn_url": "https://audio2.brain.fm/Together_Focus_Learning_Acoustic_30_87bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Together_Focus_Learning_Acoustic_30_87bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Together_Focus_Learning_Acoustic_30_87bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Together_Focus_Learning_Acoustic_30_87bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28850356,
      "sha256": "6fae3d8351597f088ab86edcd97ef0f13af909c2d9a87c8c1a721e53ff271e1e",
      "download_error": null
    },
    {
      "track_id": "6888c7f2c24bb893747ef35d",
      "name": "Clarified",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.27,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Clarified_Focus_DeepWork_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=f1lup9PAKYCXtuEhaTcAnAf33jT4FwemaEhPFngUy84%3D",
      "cdn_url": "https://audio2.brain.fm/Clarified_Focus_DeepWork_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Clarified_Focus_DeepWork_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Clarified_Focus_DeepWork_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Clarified_Focus_DeepWork_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29732132,
      "sha256": "2cb194810a03ab1e4dfd32fdd4301f5b51f9e8d73d905bd3d6bac6a0a800261d",
      "download_error": null
    },
    {
      "track_id": "6862ec12da2d247f1a9c6cf7",
      "name": "Not Held Back",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Not%20Held%20Back_Focus_Creativity_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=wdk%2BP%2By19erV0z4urryTZgXQKs4ZmV6Bs%2B5Ne%2BlBFdg%3D",
      "cdn_url": "https://audio2.brain.fm/Not%20Held%20Back_Focus_Creativity_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Not Held Back_Focus_Creativity_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Not-Held-Back_Focus_Creativity_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Not-Held-Back_Focus_Creativity_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27697262,
      "sha256": "cda26af3465f7b717adfa167c73477c99fcb95e6f08c21afa795be266d422234",
      "download_error": null
    },
    {
      "track_id": "68505cff5de2e833e430b4bb",
      "name": "Daiquiri",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.39,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Daiquiri_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=6GdeX5%2FvHTrtqL5MfsJP4eIdNOt53QXbmAW8GpBBY2A%3D",
      "cdn_url": "https://audio2.brain.fm/Daiquiri_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Daiquiri_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Daiquiri_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Daiquiri_Focus_Learning_Acoustic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29059936,
      "sha256": "25cde74097d21b0d9055928f31ba5c4e07fb4ececb4ba7caabc4484ddc92da31",
      "download_error": null
    },
    {
      "track_id": "68505b53f6a8ec82782214af",
      "name": "Indistinct",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.69,
      "complexity_level": 0.55,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Indistinct_Focus_DeepWork_Acoustic_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=so96NM1VxYGgH1DjhGD8ighJwO%2FELexP4%2Bx0w52TYF4%3D",
      "cdn_url": "https://audio2.brain.fm/Indistinct_Focus_DeepWork_Acoustic_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Indistinct_Focus_DeepWork_Acoustic_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Indistinct_Focus_DeepWork_Acoustic_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Indistinct_Focus_DeepWork_Acoustic_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30691058,
      "sha256": "10d80af88ee597171a06a2fdc7441486f6d2e6b1c5923993e384b12bdaa3d237",
      "download_error": null
    },
    {
      "track_id": "683dc6b7dd2246ed9c7c7f49",
      "name": "Allied",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.31,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Allied_Focus_DeepWork_Acoustic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=5PK8UYivRHWComQBXurVuD7lk29pVJdVp5Dtts%2B6w2I%3D",
      "cdn_url": "https://audio2.brain.fm/Allied_Focus_DeepWork_Acoustic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Allied_Focus_DeepWork_Acoustic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Allied_Focus_DeepWork_Acoustic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Allied_Focus_DeepWork_Acoustic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30098198,
      "sha256": "963e4a2e7e2e05ee812de1b72f778b8e9bd3fd2d081ff35d1f42ce6e73cf9a24",
      "download_error": null
    },
    {
      "track_id": "683dc6a3dd2246ed9c7c7ec1",
      "name": "Building Something",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.42,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Building%20Something_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=IiyiKVkEgFnTfEbAr1t0T%2F%2Faj2%2FlhsxH16xAej2dFMU%3D",
      "cdn_url": "https://audio2.brain.fm/Building%20Something_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Building Something_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Building-Something_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Building-Something_Focus_Creativity_Acoustic_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27999726,
      "sha256": "d548c5e6ad0bd2556f71ae1a289eeb719e4ef30bf6f8aa3d1067dab820e88c6e",
      "download_error": null
    },
    {
      "track_id": "682b547fd2f1d1682decf196",
      "name": "Just Around",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.8,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Just%20Around_Focus_Creativity_Acoustic_30_86bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=y89h4atDHZK8roOMyYqFZyS0xJNEIkatzJG%2FvAXy5y4%3D",
      "cdn_url": "https://audio2.brain.fm/Just%20Around_Focus_Creativity_Acoustic_30_86bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Just Around_Focus_Creativity_Acoustic_30_86bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Just-Around_Focus_Creativity_Acoustic_30_86bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Just-Around_Focus_Creativity_Acoustic_30_86bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30455254,
      "sha256": "12199074bfcfa6815555a8ed638dac66e935fbd6ae4809f4af15f94f06754f2c",
      "download_error": null
    },
    {
      "track_id": "680659a3563464c2de5fb28e",
      "name": "Morning Dew",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.67,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Morning%20Dew_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=A7sUn6B9lcakiUXEG7L%2BSgslVoOHTqiRycGqOpkCVos%3D",
      "cdn_url": "https://audio2.brain.fm/Morning%20Dew_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Morning Dew_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Morning-Dew_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Morning-Dew_Focus_DeepWork_Acoustic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29349454,
      "sha256": "5a2ade4b4c0bc55674afe94195525ef8151198bb820f96da7b219bfd94496bfe",
      "download_error": null
    },
    {
      "track_id": "67f3eae0a0de2348f748e0c3",
      "name": "Adjournment",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.47,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Adjournment_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=9IMBt4Cv%2BBLalIgJdHLJzKnueu%2F%2BALotUcrU9cqCSOE%3D",
      "cdn_url": "https://audio2.brain.fm/Adjournment_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Adjournment_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Adjournment_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Adjournment_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29230676,
      "sha256": "b598ef853e10f4f255465b5562d5df8e7fd1264ef88e8850350e156a77417207",
      "download_error": null
    },
    {
      "track_id": "67bc87e6dd31a1be1772662d",
      "name": "Just Fine",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.48,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Just%20Fine_Focus_DeepWork_Acoustic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=FhiP%2FKCtHDrs%2FAojYI65l25oOTeHZSDuwPy82ol3a%2FI%3D",
      "cdn_url": "https://audio2.brain.fm/Just%20Fine_Focus_DeepWork_Acoustic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Just Fine_Focus_DeepWork_Acoustic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Just-Fine_Focus_DeepWork_Acoustic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Just-Fine_Focus_DeepWork_Acoustic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27744315,
      "sha256": "032c8b04777a240d1013fd0fc4f66d6426d8429a6975f0d9d39137f6797f2db0",
      "download_error": null
    },
    {
      "track_id": "67aa5b7655e93dd343692279",
      "name": "Round Trip",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.62,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Round%20Trip_Focus_DeepWork_Acoustic_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=4hTduARCEeV4hrursqKptDkE6ArmAd7JDjbVxZskm%2FY%3D",
      "cdn_url": "https://audio2.brain.fm/Round%20Trip_Focus_DeepWork_Acoustic_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Round Trip_Focus_DeepWork_Acoustic_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Round-Trip_Focus_DeepWork_Acoustic_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Round-Trip_Focus_DeepWork_Acoustic_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31200673,
      "sha256": "78a3e061ed13b8323c9299700582f86a60be857c627f06e999216b13b31157ca",
      "download_error": null
    },
    {
      "track_id": "67a10f7c03677edafb63f4a8",
      "name": "Late Summer Rain",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.41,
      "complexity_level": 0.53,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Late%20Summer%20Rain_Focus_DeepWork_Acoustic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=sDaqw4kjN8TfL0YNt272WUgDJveIN9SrDBccp5ePM2k%3D",
      "cdn_url": "https://audio2.brain.fm/Late%20Summer%20Rain_Focus_DeepWork_Acoustic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Late Summer Rain_Focus_DeepWork_Acoustic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Late-Summer-Rain_Focus_DeepWork_Acoustic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Late-Summer-Rain_Focus_DeepWork_Acoustic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28367792,
      "sha256": "556b94f74d967fe7d8e54f11d64864cffcafa14c93cc749aa80a04d218be0b87",
      "download_error": null
    },
    {
      "track_id": "67855b3ef76968728486ac02",
      "name": "Fortuned",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.75,
      "complexity_level": 0.9,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Fortuned_Focus_Learning_Acoustic_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=n8mEIBha9pcaDCg1qY7zdsV4ueFfBX0Az4px%2FbvV%2Fqg%3D",
      "cdn_url": "https://audio2.brain.fm/Fortuned_Focus_Learning_Acoustic_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fortuned_Focus_Learning_Acoustic_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fortuned_Focus_Learning_Acoustic_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Fortuned_Focus_Learning_Acoustic_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29431495,
      "sha256": "bce4b8a18ce230014fd61709c751a78d75c2008509ac23be52412e5ad7466fc3",
      "download_error": null
    },
    {
      "track_id": "66cc931d47ed87e8383b706e",
      "name": "Streams",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.88,
      "complexity_level": 0.95,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Streams_Focus_Creativity_Acoustic_30_108bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=cBVikMQhw2hijITPExU4oEpYa1Sea60z%2Buy7ygzOPmk%3D",
      "cdn_url": "https://audio2.brain.fm/Streams_Focus_Creativity_Acoustic_30_108bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Streams_Focus_Creativity_Acoustic_30_108bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Streams_Focus_Creativity_Acoustic_30_108bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Streams_Focus_Creativity_Acoustic_30_108bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30831758,
      "sha256": "c2350f8e98491469ba0f7775463569ca6c2fe18280a03b3b2d549acca3929459",
      "download_error": null
    },
    {
      "track_id": "66b6632087e215f954f17d67",
      "name": "Safe Travels",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.39,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/SafeTravels_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=inXeBwmVNkgzn5rllFzlXXXvHJepBSxN8CnBiKJhzhY%3D",
      "cdn_url": "https://audio2.brain.fm/SafeTravels_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SafeTravels_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SafeTravels_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/SafeTravels_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31010358,
      "sha256": "df45830df90801023e0f09987d44496aed7597a7645558c56b1c1fb466b8f0d4",
      "download_error": null
    },
    {
      "track_id": "66b6630e87e215f954f17d0a",
      "name": "New Perspective",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.46,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/NewPerspective_Focus_DeepWork_Acoustic_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=rxrignWDovSXpO5bsQoteTWz9C%2Fs1C5e%2F7ijI6offjc%3D",
      "cdn_url": "https://audio2.brain.fm/NewPerspective_Focus_DeepWork_Acoustic_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NewPerspective_Focus_DeepWork_Acoustic_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NewPerspective_Focus_DeepWork_Acoustic_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/NewPerspective_Focus_DeepWork_Acoustic_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27590098,
      "sha256": "23ad796d329ff5f97927b117eb52cc58f14fb562a3a3c95d4e929ccf7763382e",
      "download_error": null
    },
    {
      "track_id": "66a3fd0c0108b74ee99597fd",
      "name": "Mutantes",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.89,
      "complexity_level": 0.68,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Mutantes_Focus_Creativity_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=xNfIn4OIIYpwahUnBvNoCrxRkY9Kik2TpoDfWRvR%2Fdk%3D",
      "cdn_url": "https://audio2.brain.fm/Mutantes_Focus_Creativity_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Mutantes_Focus_Creativity_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Mutantes_Focus_Creativity_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Mutantes_Focus_Creativity_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29424840,
      "sha256": "ca81be6d84bdd3efc1a4006b77a3172f935a1f337ef9cbb76c6c8df5331004fc",
      "download_error": null
    },
    {
      "track_id": "66a3fcfc0108b74ee9959786",
      "name": "Out West",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.87,
      "complexity_level": 0.89,
      "style": "normal",
      "neural_effect_level": 0.62,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/OutWest_Focus_Learning_Acoustic_30_112bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=%2BtiQHahhHStBvw6NfSruQcD1ckXO8syBoCM%2BSFFpf7I%3D",
      "cdn_url": "https://audio2.brain.fm/OutWest_Focus_Learning_Acoustic_30_112bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OutWest_Focus_Learning_Acoustic_30_112bpm_Nrmlzd2_VBR5.mp3",
      "filename": "OutWest_Focus_Learning_Acoustic_30_112bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/OutWest_Focus_Learning_Acoustic_30_112bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30647987,
      "sha256": "3a7656d8f71c045d690438b4bca729c958fee97dd4f9115fd6a34be126c2a219",
      "download_error": null
    },
    {
      "track_id": "66918bf0de19d0f1c74ea918",
      "name": "Lounging",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.6,
      "complexity_level": 0.43,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Lounging_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=EDAO%2FRPwV1dfXEmyKI5sSatG5IR5SlCHT%2BreSeGjeB4%3D",
      "cdn_url": "https://audio2.brain.fm/Lounging_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lounging_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Lounging_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Lounging_Focus_DeepWork_Acoustic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28578512,
      "sha256": "e2bad75e62cb610ca893e1e64d44e7ceab40af2437f09dae5f5c224cc69cabdd",
      "download_error": null
    },
    {
      "track_id": "66918be5de19d0f1c74ea8db",
      "name": "Streamside",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.89,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Streamside_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=a7y3cSgl4rZRLanOMSas%2B4pi%2Ft6vTGYZb5wXZ7YceUs%3D",
      "cdn_url": "https://audio2.brain.fm/Streamside_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Streamside_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Streamside_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Streamside_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30116651,
      "sha256": "52765c25aa92e36fe06208561ad5c5b152ae56cc73959d766c67610befd39027",
      "download_error": null
    },
    {
      "track_id": "6683fd92d98e4183c363e81e",
      "name": "Town Square",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.76,
      "complexity_level": 0.84,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/TownSquare_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=KGHuez4ncJV2AP4BZsVx3HkAqNZ8fDPLktFY%2F3QwFA4%3D",
      "cdn_url": "https://audio2.brain.fm/TownSquare_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TownSquare_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "TownSquare_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/TownSquare_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28613047,
      "sha256": "0a8fde36062ce3ba6254eb2d325027b06b6c30098070e0b24d6b060b87225f1c",
      "download_error": null
    },
    {
      "track_id": "666c9d5e2ea307b6e2e44d3e",
      "name": "Fiddle Leaf",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.78,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/FiddleLeaf_Focus_Creativity_Acoustic_30_87bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=AXetbEDSlXWuC%2B0KbzDtBUE5d2vaMDJUNUKgFsM1ekY%3D",
      "cdn_url": "https://audio2.brain.fm/FiddleLeaf_Focus_Creativity_Acoustic_30_87bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FiddleLeaf_Focus_Creativity_Acoustic_30_87bpm_Nrmlzd2_VBR5.mp3",
      "filename": "FiddleLeaf_Focus_Creativity_Acoustic_30_87bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/FiddleLeaf_Focus_Creativity_Acoustic_30_87bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29708024,
      "sha256": "c2a08fd28c2700fd36a7f6a5cf315f7a83b8da03c72050017c94c2775851ad47",
      "download_error": null
    },
    {
      "track_id": "666c9d35644ac8615d52ad7f",
      "name": "Glistening",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.82,
      "complexity_level": 0.62,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Glistening_Focus_Creativity_Acoustic_30_75bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=WmgJcSZpmzgz9VZFYizvByXmrmRw%2FG1YEVE0jEQP8dI%3D",
      "cdn_url": "https://audio2.brain.fm/Glistening_Focus_Creativity_Acoustic_30_75bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Glistening_Focus_Creativity_Acoustic_30_75bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Glistening_Focus_Creativity_Acoustic_30_75bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Glistening_Focus_Creativity_Acoustic_30_75bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30227697,
      "sha256": "62bf115b9295fa44e2fe266b6553a68dcf2062c321b66f928730c25ace2ac419",
      "download_error": null
    },
    {
      "track_id": "666c9d0a62b2df66d1d11885",
      "name": "Simpler Times",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.76,
      "complexity_level": 0.62,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Simpler%20Times_Focus_Learning_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=aFqXMoCulELG3sUBxviZ32y0hsCC6tnWquuHK4RnDaw%3D",
      "cdn_url": "https://audio2.brain.fm/Simpler%20Times_Focus_Learning_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Simpler Times_Focus_Learning_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Simpler-Times_Focus_Learning_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Simpler-Times_Focus_Learning_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29662049,
      "sha256": "6e05608eb25be5153ab0d76c91c4467892c416c174641df60cee836bf6d0ba73",
      "download_error": null
    },
    {
      "track_id": "666c9ce9644ac8615d52ac8f",
      "name": "Sintra",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.75,
      "complexity_level": 0.85,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Sintra_Focus_Learning_Acoustic_30_105bpm_Nrmlzd_VBR5.mp3?expiration=1792292120270&token=ZhBT7%2F7jHUPNAFlI4vK3sBNwaPf3gOG%2B1Dc41wUgBao%3D",
      "cdn_url": "https://audio2.brain.fm/Sintra_Focus_Learning_Acoustic_30_105bpm_Nrmlzd_VBR5.mp3",
      "remote_filename": "Sintra_Focus_Learning_Acoustic_30_105bpm_Nrmlzd_VBR5.mp3",
      "filename": "Sintra_Focus_Learning_Acoustic_30_105bpm_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Sintra_Focus_Learning_Acoustic_30_105bpm_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31062054,
      "sha256": "8f5be1566a33b3ccaf0df64a0f2511c028d8e352e093b81d24aa63d23a4d3deb",
      "download_error": null
    },
    {
      "track_id": "666c9cc12ea307b6e2e44cc1",
      "name": "Tangle",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 102,
      "brightness_level": 0.64,
      "complexity_level": 0.46,
      "style": "normal",
      "neural_effect_level": 0.62,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Tangle_Focus_Learning_Acoustic_30_102bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=xlO2X%2BDutYnBD0xGsQX2K5q1rPgx4hvmXnaqStM%2Bco8%3D",
      "cdn_url": "https://audio2.brain.fm/Tangle_Focus_Learning_Acoustic_30_102bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tangle_Focus_Learning_Acoustic_30_102bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Tangle_Focus_Learning_Acoustic_30_102bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Tangle_Focus_Learning_Acoustic_30_102bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27105048,
      "sha256": "c73b6a6c80e8ad7284e221d1d92e9c1d223808d7fa5375085e3c8bd99e230ed8",
      "download_error": null
    },
    {
      "track_id": "666c9ca262b2df66d1d1171a",
      "name": "Orison",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.95,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Orison_Focus_Creativity_Acoustic_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=SwgdxIfS8rtRZoETJdmtXhccPmFDUTrOgHG%2B7xuQQ7k%3D",
      "cdn_url": "https://audio2.brain.fm/Orison_Focus_Creativity_Acoustic_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Orison_Focus_Creativity_Acoustic_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Orison_Focus_Creativity_Acoustic_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Orison_Focus_Creativity_Acoustic_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25838704,
      "sha256": "96e83f2d65f9109feba0ab21f701a2990830ef42229ff9302232c4c6ba2ee8b6",
      "download_error": null
    },
    {
      "track_id": "665a23084dfb90cc19dcdd7e",
      "name": "Cabin in Winter",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.96,
      "complexity_level": 0.84,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/CabininWinter_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=MPDIZQVRwal3daXaXKcC0UXI8fvlGJ5PtVo9sAjWObw%3D",
      "cdn_url": "https://audio2.brain.fm/CabininWinter_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CabininWinter_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CabininWinter_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/CabininWinter_Focus_DeepWork_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29972287,
      "sha256": "c67376ec616eb97135cbe401ab51e4a51eb761cc2d36b7c9cee5376f9e96c379",
      "download_error": null
    },
    {
      "track_id": "665a22fd4dfb90cc19dcdd21",
      "name": "Rococo",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.82,
      "complexity_level": 0.6,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Rococo_Focus_DeepWork_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=EFKDE9NOS9Z2w%2FnTM%2FQbelg5fS25XKAaPT5l%2FtwDR8E%3D",
      "cdn_url": "https://audio2.brain.fm/Rococo_Focus_DeepWork_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Rococo_Focus_DeepWork_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Rococo_Focus_DeepWork_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Rococo_Focus_DeepWork_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32205168,
      "sha256": "dd366b8c0449ab0738b665afccfa5f5b2f3be380486d80e1b59251f6b8443319",
      "download_error": null
    },
    {
      "track_id": "664779bf30b208e2323ed54f",
      "name": "Pale Moon",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.85,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Pale%20Moon_Focus_Creativity_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=Wig0OQEf1Thk5b4VNJxL%2F3I%2FA1fXR%2BBAmLDi2%2Fj9tMI%3D",
      "cdn_url": "https://audio2.brain.fm/Pale%20Moon_Focus_Creativity_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pale Moon_Focus_Creativity_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Pale-Moon_Focus_Creativity_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Pale-Moon_Focus_Creativity_Acoustic_30_86bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30818247,
      "sha256": "d2369b249d62eda5337e0beeef861bcc62869ca547dd7451dacc9c4d109d27d3",
      "download_error": null
    },
    {
      "track_id": "664779ae30b208e2323ed4d4",
      "name": "Evening Garden",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.86,
      "complexity_level": 0.81,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Evening%20Garden_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=sk62Cnf0peYbsTCzngSioZ3ZiEw8iVG1k41o4RQtczw%3D",
      "cdn_url": "https://audio2.brain.fm/Evening%20Garden_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Evening Garden_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Evening-Garden_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Evening-Garden_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29869113,
      "sha256": "cdf068ab6f5f28adfd66845f61b9c7eb49620c0d86c3a909106b15540326656f",
      "download_error": null
    },
    {
      "track_id": "663535314eae15761ad4fa6c",
      "name": "Revivalist",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 1,
      "complexity_level": 0.98,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Revivalist_Focus_Learning_Acoustic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=bKeEGhj5gnARs76mWccfBMgXMkug1lf%2FxQGlcte4QJ0%3D",
      "cdn_url": "https://audio2.brain.fm/Revivalist_Focus_Learning_Acoustic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Revivalist_Focus_Learning_Acoustic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Revivalist_Focus_Learning_Acoustic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Revivalist_Focus_Learning_Acoustic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30905374,
      "sha256": "b00229fde0c6f13e9682d504c70803a0acc76111b5d52fe77f23b9cfd7769781",
      "download_error": null
    },
    {
      "track_id": "65fdaa72cc7d1e000a587fcd",
      "name": "Front Porch",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.74,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/FrontPorch_Focus_DeepWork_Acoustic_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=ROvl6rm4tKZqcyd6rg8SOhE%2FNVilhaXmOGzJ%2F02MsDY%3D",
      "cdn_url": "https://audio2.brain.fm/FrontPorch_Focus_DeepWork_Acoustic_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FrontPorch_Focus_DeepWork_Acoustic_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FrontPorch_Focus_DeepWork_Acoustic_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/FrontPorch_Focus_DeepWork_Acoustic_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29125344,
      "sha256": "fc0a67cf8b11b3ef5c0e8f1a4384136099331e2ba8810603a9222afee8872ed8",
      "download_error": null
    },
    {
      "track_id": "65d9204a970b46000863ed8a",
      "name": "Urban Ash",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.84,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Urban%20Ash_Focus_DeepWork_Acoustic_30_116bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=NSSnkJFbqU%2FInqyQzip14bdQ5n%2FnVGEG8o%2BsOl%2F53KY%3D",
      "cdn_url": "https://audio2.brain.fm/Urban%20Ash_Focus_DeepWork_Acoustic_30_116bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Urban Ash_Focus_DeepWork_Acoustic_30_116bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Urban-Ash_Focus_DeepWork_Acoustic_30_116bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Urban-Ash_Focus_DeepWork_Acoustic_30_116bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28239659,
      "sha256": "5493d4f0d52e1f750ff716d4c1045b6f6fa286aa002ea7c98a55f87fc30152bf",
      "download_error": null
    },
    {
      "track_id": "65c690dd1bf8f200086e0e0e",
      "name": "Forging a Path",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 1,
      "complexity_level": 0.97,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/ForgingaPath_Focus_Learning_Acoustic_30_118bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=5teMZsB8B3%2BXwz0v60dmLrpSzkWZeF4WDo5CaqTWG8I%3D",
      "cdn_url": "https://audio2.brain.fm/ForgingaPath_Focus_Learning_Acoustic_30_118bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ForgingaPath_Focus_Learning_Acoustic_30_118bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ForgingaPath_Focus_Learning_Acoustic_30_118bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/ForgingaPath_Focus_Learning_Acoustic_30_118bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28634750,
      "sha256": "e28d48bf656672d8a38de51da761a18a241a1a205935d12a66c73110a2a1c4e5",
      "download_error": null
    },
    {
      "track_id": "65b3fa68349c8a0009283ea4",
      "name": "All is Well",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.97,
      "complexity_level": 0.95,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/AllisWell_Focus_Learning_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=Y5Xv5OVRP0kFSWE13y2F%2B7XOK9NGzw8y8FJDmb71%2F%2FU%3D",
      "cdn_url": "https://audio2.brain.fm/AllisWell_Focus_Learning_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AllisWell_Focus_Learning_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AllisWell_Focus_Learning_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/AllisWell_Focus_Learning_Acoustic_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27872796,
      "sha256": "a30e6117aa23dc0d3c381495d797ab18161737be19620d68114189cf24d93788",
      "download_error": null
    },
    {
      "track_id": "65b3f9e8cdef020008e0bf24",
      "name": "Moonlight Serenade",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.69,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/MoonlightSerenade_Focus_Creativity_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=pmLERomAMyeKFShmuyjj88xQYaBycPVyXStRGHfLrak%3D",
      "cdn_url": "https://audio2.brain.fm/MoonlightSerenade_Focus_Creativity_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MoonlightSerenade_Focus_Creativity_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MoonlightSerenade_Focus_Creativity_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/MoonlightSerenade_Focus_Creativity_Acoustic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29312412,
      "sha256": "1271c19a0165656694ce055b3c368db0eae762762bbaae072cdd101a190bcd24",
      "download_error": null
    },
    {
      "track_id": "658c8f9a7a6b3300085e0bbb",
      "name": "Tip Toes",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.9,
      "complexity_level": 0.99,
      "style": "normal",
      "neural_effect_level": 0.62,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Tip%20Toes_Focus_Learning_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=1G8XXbi3jNN2jjZ8c6RkmjVH4TOZiEvU5SrBa9n8Fcs%3D",
      "cdn_url": "https://audio2.brain.fm/Tip%20Toes_Focus_Learning_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tip Toes_Focus_Learning_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Tip-Toes_Focus_Learning_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Tip-Toes_Focus_Learning_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28718808,
      "sha256": "41f29baf044410e23e5b4dd2e42e703cbeceab8fb77256ed4492afc597df0642",
      "download_error": null
    },
    {
      "track_id": "658c8f499a74fb00089d4317",
      "name": "Nostalgia",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.72,
      "complexity_level": 0.89,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Nostalgia_Focus_DeepWork_Acoustic_30_115bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=7iJX%2FQWEeN7iLNKGzRCTvXM5KlVbApFuUQ1sN9vrzTY%3D",
      "cdn_url": "https://audio2.brain.fm/Nostalgia_Focus_DeepWork_Acoustic_30_115bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Nostalgia_Focus_DeepWork_Acoustic_30_115bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Nostalgia_Focus_DeepWork_Acoustic_30_115bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Nostalgia_Focus_DeepWork_Acoustic_30_115bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30877531,
      "sha256": "43148cec2b1f789db77398e50ddee6e424d3f876048cfe983b27a31fe550518e",
      "download_error": null
    },
    {
      "track_id": "656de8a96aee1714cf2283ec",
      "name": "Elements (Alternate Mix)",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 6171,
      "beats_per_minute": 130,
      "brightness_level": 0.85,
      "complexity_level": 0.7,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_expanded_VBR5.mp3?expiration=1792292120270&token=G8Pq7opz9VGKqbzvDwZye2%2BWzVRy2D49jZh8T2xzFno%3D",
      "cdn_url": "https://audio2.brain.fm/Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_expanded_VBR5.mp3",
      "remote_filename": "Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_expanded_VBR5.mp3",
      "filename": "Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_expanded_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_expanded_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 104327905,
      "sha256": "3835da3f569a7a350db343f01609bd0916c410f2f26cbf43e1ee08a49c4ae5da",
      "download_error": null
    },
    {
      "track_id": "656de89b6aee17a4302283a9",
      "name": "Elements",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.85,
      "complexity_level": 0.7,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=dZ5DvtpN4PTIN1EKoAK9cwzsPHYIdLFB2Z9rvfcXhyY%3D",
      "cdn_url": "https://audio2.brain.fm/Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Elements_Focus_Learning_Acoustic_30_130bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30406897,
      "sha256": "75e9229143f6b1bab0286f3171e204bd8f7d57e61fe9eab9640b11c0a2c97f63",
      "download_error": null
    },
    {
      "track_id": "655bc777f308171013bb053d",
      "name": "Tall Tales",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.87,
      "complexity_level": 0.74,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/TallTales_Focus_Creativity_Acoustic_30_124bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=Ysa8wgGjV%2Bj6U%2BAOLl3H9bmZQBwJ6wHmJjhq9Ivu0ME%3D",
      "cdn_url": "https://audio2.brain.fm/TallTales_Focus_Creativity_Acoustic_30_124bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TallTales_Focus_Creativity_Acoustic_30_124bpm_Nrmlzd2_VBR5.mp3",
      "filename": "TallTales_Focus_Creativity_Acoustic_30_124bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/TallTales_Focus_Creativity_Acoustic_30_124bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29894000,
      "sha256": "f4d0ee7e59333c087f460e3d844558c3cb8365afa5220b96ddcf8bffda025a29",
      "download_error": null
    },
    {
      "track_id": "654aa8a96986434a94b4176f",
      "name": "Walden Pond (Extended Mix)",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 6669,
      "beats_per_minute": 125,
      "brightness_level": 0.74,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_expanded_VBR5.mp3?expiration=1792292120270&token=Oh%2B%2BBu7BabL6IOCs1hAu40BPU3ai%2FK6D%2BAzGlvK2Iyw%3D",
      "cdn_url": "https://audio2.brain.fm/WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_expanded_VBR5.mp3",
      "remote_filename": "WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_expanded_VBR5.mp3",
      "filename": "WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_expanded_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_expanded_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 104591147,
      "sha256": "cc957f39019ff52b33aaecca51569cdcd8852c482abb5a42596e44b67013f8fb",
      "download_error": null
    },
    {
      "track_id": "654aa897698643a30cb41739",
      "name": "Walden Pond",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 125,
      "brightness_level": 0.74,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=8SJJ5U19%2FqLVisAGHGTxBlcabtMOpd4DSf796dgo36U%3D",
      "cdn_url": "https://audio2.brain.fm/WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_VBR5.mp3",
      "filename": "WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/WaldenPond_Focus_DeepWork_Acoustic_30_125bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28131685,
      "sha256": "11b9989138bfd9fcc3e4e23f96cd0ea37d8a4c6edbcd329d2cd74bd04aff2d97",
      "download_error": null
    },
    {
      "track_id": "654aa76069864341c4b41301",
      "name": "Catskills (Extended Mix)",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 6376,
      "beats_per_minute": 105,
      "brightness_level": 0.88,
      "complexity_level": 0.95,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_expanded_VBR5.mp3?expiration=1792292120270&token=WLSqelo%2FiFaW64fE8Su6fL5Sg%2BbbWkvBL%2FDhOBS0aBo%3D",
      "cdn_url": "https://audio2.brain.fm/Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_expanded_VBR5.mp3",
      "remote_filename": "Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_expanded_VBR5.mp3",
      "filename": "Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_expanded_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_expanded_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 101170699,
      "sha256": "8c32c5db8a78bff3569923d1fd083e5c21f141ba85242eb81a570556f5f3f603",
      "download_error": null
    },
    {
      "track_id": "654aa74f62cef539b98bb253",
      "name": "Catskills",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.88,
      "complexity_level": 0.95,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=eoncw7XF4ca9RCcGdoE2xJ8cIYADcPqsbaZvR2fs%2FcI%3D",
      "cdn_url": "https://audio2.brain.fm/Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Catskills_Focus_Learning_Acoustic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28580580,
      "sha256": "195420806026358a609ae5a7431a32ca2900e013e1322f4483da11649f57ee6c",
      "download_error": null
    },
    {
      "track_id": "651dda4f7f63d33a35158375",
      "name": "Treasure Map",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.84,
      "complexity_level": 0.71,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Treasure%20Map_Focus_Creativity_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=j31QBi4K%2FX%2FCUDw1LupzYQp1b3tQPFz99ZC5f0jVzi4%3D",
      "cdn_url": "https://audio2.brain.fm/Treasure%20Map_Focus_Creativity_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Treasure Map_Focus_Creativity_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Treasure-Map_Focus_Creativity_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Treasure-Map_Focus_Creativity_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31301985,
      "sha256": "0323135cc7b00e1e4c894a5106930a16cce8b44e491ad7438f9cad65c0834e67",
      "download_error": null
    },
    {
      "track_id": "650ca2c7d380a674050796cf",
      "name": "Open Book",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 83,
      "brightness_level": 0.93,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/OpenBook_Focus_Creativity_Acoustic_30_83bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=pkVSrPlbYt7ts1FAoNLVj9r5OJXMygvVGM0vgXafhFQ%3D",
      "cdn_url": "https://audio2.brain.fm/OpenBook_Focus_Creativity_Acoustic_30_83bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OpenBook_Focus_Creativity_Acoustic_30_83bpm_Nrmlzd2_VBR5.mp3",
      "filename": "OpenBook_Focus_Creativity_Acoustic_30_83bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/OpenBook_Focus_Creativity_Acoustic_30_83bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32552912,
      "sha256": "a59f8eac737ccbe7e49b7f6a09333ae5f0c7fc1e128dbf5ffeabcfa5a823682a",
      "download_error": null
    },
    {
      "track_id": "64f9e85b0faeaa864cbd618e",
      "name": "Old Castle",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.76,
      "complexity_level": 0.74,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/OldCastle_Focus_Learning_Acoustic_30_92bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=v6iDIwNPAJVUBuFnTXUZITfpPm%2B4tgMo5ErDqq6IPgM%3D",
      "cdn_url": "https://audio2.brain.fm/OldCastle_Focus_Learning_Acoustic_30_92bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OldCastle_Focus_Learning_Acoustic_30_92bpm_Nrmlzd2_VBR5.mp3",
      "filename": "OldCastle_Focus_Learning_Acoustic_30_92bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/OldCastle_Focus_Learning_Acoustic_30_92bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30528374,
      "sha256": "c3d916c536c618547f48e89a299b268c5d826107c7846f7fc5199196a1affcbd",
      "download_error": null
    },
    {
      "track_id": "64dcfebe177f87bfb69c8bdb",
      "name": "Autumn Resonance",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.94,
      "complexity_level": 0.87,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/AutumnResonance_Focus_Learning_Acoustic_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=zIvfOZW4E%2B18ZkAXB5XSNW%2FYybyBrBIxd9pd1VXzYhM%3D",
      "cdn_url": "https://audio2.brain.fm/AutumnResonance_Focus_Learning_Acoustic_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AutumnResonance_Focus_Learning_Acoustic_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AutumnResonance_Focus_Learning_Acoustic_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/AutumnResonance_Focus_Learning_Acoustic_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30642827,
      "sha256": "6165f4a035ce3d4f531ebd009bce5741ba7f178e68b13fd3648566b1c12bec17",
      "download_error": null
    },
    {
      "track_id": "64dcfe9b3a44d073d88cba70",
      "name": "Sunny Side",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.91,
      "complexity_level": 0.86,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/SunnySide_Focus_Learning_Acoustic_30_95bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=UF%2B57YMWYUzhy9IsphQWQWGeVQWhoxyyeRz98TKWthA%3D",
      "cdn_url": "https://audio2.brain.fm/SunnySide_Focus_Learning_Acoustic_30_95bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SunnySide_Focus_Learning_Acoustic_30_95bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SunnySide_Focus_Learning_Acoustic_30_95bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/SunnySide_Focus_Learning_Acoustic_30_95bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30440597,
      "sha256": "b5cf7cc8b38cfdb7d85cd30ada8a47765e942b9f5cd405d366c188653c05e4ee",
      "download_error": null
    },
    {
      "track_id": "64dcfe38177f872a4d9c8a31",
      "name": "Yuma",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.94,
      "complexity_level": 0.98,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Yuma_Focus_Creativity_Acoustic_30_96bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=o%2B9%2Fexess%2BhUeFZ5r7q0WM2Y3RCQ8YZlyghiyZt3Jqc%3D",
      "cdn_url": "https://audio2.brain.fm/Yuma_Focus_Creativity_Acoustic_30_96bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Yuma_Focus_Creativity_Acoustic_30_96bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Yuma_Focus_Creativity_Acoustic_30_96bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Yuma_Focus_Creativity_Acoustic_30_96bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27572016,
      "sha256": "d517f4e80ea15bed289321b0f6be848b0a779be3ecdc0cda97de7fe64d9be0bc",
      "download_error": null
    },
    {
      "track_id": "64b93834becc0001242efa9f",
      "name": "Childhood Games",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.73,
      "complexity_level": 0.88,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/ChildhoodGames_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=GPU%2FwLdSd1r5lEUdgJedh7jTQ6LlyXClXhuqcjlaFio%3D",
      "cdn_url": "https://audio2.brain.fm/ChildhoodGames_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ChildhoodGames_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "ChildhoodGames_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/ChildhoodGames_Focus_Learning_Acoustic_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28979145,
      "sha256": "5bb27272505d1446c567910fd142679aaa6a3db33b2e492225ef6698b93be6f2",
      "download_error": null
    },
    {
      "track_id": "646f743afd5c8401a4a11e3f",
      "name": "Climbing Higher",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.44,
      "complexity_level": 0.77,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/ClimbingHigher_Focus_Learning_Acoustic_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=DNfxkXbEpEzpUw0WcyrJ6fB5%2B75cASZq4LHEzvg0dSM%3D",
      "cdn_url": "https://audio2.brain.fm/ClimbingHigher_Focus_Learning_Acoustic_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ClimbingHigher_Focus_Learning_Acoustic_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ClimbingHigher_Focus_Learning_Acoustic_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/ClimbingHigher_Focus_Learning_Acoustic_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28108671,
      "sha256": "fa2f8186b3189fda03d0850626a97c8c0b4641fd7d04642dce4367c8821343dd",
      "download_error": null
    },
    {
      "track_id": "644ad6db3ecf73778200f885",
      "name": "Dry County",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.81,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/DryCounty_Focus_Learning_Acoustic_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=E1bHJtoMO6dM00D0mt17XXsKZyn6zKaZsksBTBhIHhg%3D",
      "cdn_url": "https://audio2.brain.fm/DryCounty_Focus_Learning_Acoustic_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DryCounty_Focus_Learning_Acoustic_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DryCounty_Focus_Learning_Acoustic_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/DryCounty_Focus_Learning_Acoustic_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30411283,
      "sha256": "31aef4f7a1ec43de3628d89b8430938603dc5b381ee2855c0a4f971c19d69891",
      "download_error": null
    },
    {
      "track_id": "64302d0e23c3be8c9c3fbbb9",
      "name": "Seaside Village",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.74,
      "complexity_level": 0.85,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/SeasideVillage_Focus_Creativity_Acoustic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=wilxrm3ce7SfMCDA3RM0s12hFG%2B5qK0clg97QygjzuU%3D",
      "cdn_url": "https://audio2.brain.fm/SeasideVillage_Focus_Creativity_Acoustic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SeasideVillage_Focus_Creativity_Acoustic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SeasideVillage_Focus_Creativity_Acoustic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/SeasideVillage_Focus_Creativity_Acoustic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29292082,
      "sha256": "8e3573ceac0fafe89dea7072ac2958e306fad4597b8d5541acdf347cc8afe511",
      "download_error": null
    },
    {
      "track_id": "643029cf23c3be72503facee",
      "name": "Chasing Whispers",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.87,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/ChasingWhispers_Focus_Creativity_Acoustic_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=Sz5TAytPNr2w3KmHdxkrfozss9XrolgJqVE8YgSgrPo%3D",
      "cdn_url": "https://audio2.brain.fm/ChasingWhispers_Focus_Creativity_Acoustic_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ChasingWhispers_Focus_Creativity_Acoustic_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ChasingWhispers_Focus_Creativity_Acoustic_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/ChasingWhispers_Focus_Creativity_Acoustic_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30747369,
      "sha256": "a8215d4716a8aa657be59f903f408688476f21e3c336305c2ee4ffb109be039d",
      "download_error": null
    },
    {
      "track_id": "643029915ee24c7115a0562e",
      "name": "Brasilia",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.74,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Brasilia_Focus_Creativity_Acoustic_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=v93DMAxOsx8k%2FNMafYS0M087m%2F5pWYZEI%2Bd2kR5yCIU%3D",
      "cdn_url": "https://audio2.brain.fm/Brasilia_Focus_Creativity_Acoustic_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Brasilia_Focus_Creativity_Acoustic_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Brasilia_Focus_Creativity_Acoustic_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Brasilia_Focus_Creativity_Acoustic_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31603266,
      "sha256": "3b27b0c2c16894b81565e3c8190c295a9f490b96fd251172339a02cefff7e2fd",
      "download_error": null
    },
    {
      "track_id": "643029035ee24c2437a05497",
      "name": "Appalachian Trail",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 97,
      "brightness_level": 0.81,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/AppalachianTrail_Focus_Creativity_Acoustic_30_97bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=S1dJhk%2FdlCQxmTO97cmVvDeYDmGgevSY1XGmqUpQl3I%3D",
      "cdn_url": "https://audio2.brain.fm/AppalachianTrail_Focus_Creativity_Acoustic_30_97bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AppalachianTrail_Focus_Creativity_Acoustic_30_97bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AppalachianTrail_Focus_Creativity_Acoustic_30_97bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/AppalachianTrail_Focus_Creativity_Acoustic_30_97bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27669283,
      "sha256": "f2167245d30eafc383522e4562d5e66102f01537eaba5b396cd84f5aa03c3a6b",
      "download_error": null
    },
    {
      "track_id": "64258f787fc6943422ae895b",
      "name": "Settling",
      "category": "Acoustic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.68,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/acoustic.json",
      "source_url": "https://audio2.brain.fm/Settling_Focus_DeepWork_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292120270&token=lazMtbwAOhca7g25i15pnu1QBlYDIQfnrthU6tmBkvA%3D",
      "cdn_url": "https://audio2.brain.fm/Settling_Focus_DeepWork_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Settling_Focus_DeepWork_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Settling_Focus_DeepWork_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/acoustic/Settling_Focus_DeepWork_Acoustic_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28346754,
      "sha256": "cdfea053c9767dcc9c1e4bf9e24ca1f098bb4bcfde573ef96cbbfed3ad75ccb9",
      "download_error": null
    },
    {
      "track_id": "6a54f6706ff4d00262502665",
      "name": "Tangerine Dreams",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.28,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TangerineDreams_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=6hAaIvzOJoYAxxOjhAZnYEsnJM%2BUlZv8BxkLoCStSgc%3D",
      "cdn_url": "https://audio2.brain.fm/TangerineDreams_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TangerineDreams_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TangerineDreams_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TangerineDreams_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26797679,
      "sha256": "2a84f8c424ffe87efe66ee810294d16847cec7f64e7da19bd777600993da66a5",
      "download_error": null
    },
    {
      "track_id": "6a54f6636ff4d0026250261f",
      "name": "Smoke On The Horizon",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.17,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/SmokeontheHorizon_Focus_Learning_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=WJpmC%2F%2FQW2B4jCclQO%2BAIk4fbRKvlBsz5S4kO558Fas%3D",
      "cdn_url": "https://audio2.brain.fm/SmokeontheHorizon_Focus_Learning_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SmokeontheHorizon_Focus_Learning_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SmokeontheHorizon_Focus_Learning_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/SmokeontheHorizon_Focus_Learning_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26335436,
      "sha256": "27dcf5a654917bcbf25606e21a8ce2f09f9313dd03d053ea5de42fd7f78bf2e1",
      "download_error": null
    },
    {
      "track_id": "6a4281c578a0a113b2ff3d43",
      "name": "Between Dreams",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.7,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/BetweenDreams_Focus_Creativity_Atmospheric_30_96BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=hKHm7SA2drp%2FXFCxUgJa9A286jLVf3YvJUJ6CfJtMyA%3D",
      "cdn_url": "https://audio2.brain.fm/BetweenDreams_Focus_Creativity_Atmospheric_30_96BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BetweenDreams_Focus_Creativity_Atmospheric_30_96BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BetweenDreams_Focus_Creativity_Atmospheric_30_96BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/BetweenDreams_Focus_Creativity_Atmospheric_30_96BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26420274,
      "sha256": "a2c7de1045c336abeb9fff10ef5eaa7d0a3609b7d7dec85261e2e3e0ba61a631",
      "download_error": null
    },
    {
      "track_id": "6a3017fd7a8f5056573c9544",
      "name": "Contentment",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.17,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Contentment_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=ML8Uuzu7PamppQeBqiyKdEUHEDwSQdMfTW1Jt8ikIQ4%3D",
      "cdn_url": "https://audio2.brain.fm/Contentment_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Contentment_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Contentment_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Contentment_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21040619,
      "sha256": "a91b3e9012d356ba1541475ccfe012811f67b7e498232ac90851897275949376",
      "download_error": null
    },
    {
      "track_id": "6a1dcaafb7f8597b46123b32",
      "name": "Sea Oddity",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.64,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/SeaOddity_Focus_Creativity_Atmospheric_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=49cTMoDheWJZ9T7Na8L0%2FXXu5W9tLkXcCvoFODuDLko%3D",
      "cdn_url": "https://audio2.brain.fm/SeaOddity_Focus_Creativity_Atmospheric_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SeaOddity_Focus_Creativity_Atmospheric_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SeaOddity_Focus_Creativity_Atmospheric_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/SeaOddity_Focus_Creativity_Atmospheric_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28310704,
      "sha256": "e247d1a86f3e0442963bfc5c6295d2e094177c6a756355197c902fdec960304a",
      "download_error": null
    },
    {
      "track_id": "6a1dca56b7f8597b46123760",
      "name": "Fallout",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 102,
      "brightness_level": 0.65,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TheFallOut_Focus_DeepWork_Atmospheric_30_102BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=QPvmgnIaKcHAggohJ61ezGzGdhoLYQUl8srlI1d2kaY%3D",
      "cdn_url": "https://audio2.brain.fm/TheFallOut_Focus_DeepWork_Atmospheric_30_102BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheFallOut_Focus_DeepWork_Atmospheric_30_102BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheFallOut_Focus_DeepWork_Atmospheric_30_102BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TheFallOut_Focus_DeepWork_Atmospheric_30_102BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24879047,
      "sha256": "1d834b34ed37bdbac15055401f85a9a78b3329ce5c3de3de2be90d50cafecf98",
      "download_error": null
    },
    {
      "track_id": "6a0b8c05e6017bccd74b8646",
      "name": "Store Consciousness",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.3,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/StoreConciousness_Focus_Creativity_Atmospheric_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=mIfnZWF28Zdq7KK7mkC2p54GY%2B5DzCTC2DU2qOAQ8w4%3D",
      "cdn_url": "https://audio2.brain.fm/StoreConciousness_Focus_Creativity_Atmospheric_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StoreConciousness_Focus_Creativity_Atmospheric_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StoreConciousness_Focus_Creativity_Atmospheric_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/StoreConciousness_Focus_Creativity_Atmospheric_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23965423,
      "sha256": "821c6b71b6ab3cdab6d4a363e0750b1de8d81cbf37e49f37df770b5ce1e0f6d4",
      "download_error": null
    },
    {
      "track_id": "6a0b8beae6017bccd74b846f",
      "name": "Lumen Lands",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.35,
      "complexity_level": 81,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/LumenLands_Focus_Creativity_Atmospheric_30_88BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=AiFJmDLGnrVPKOlwcBFGretZOd0tf0mzl24bZ%2Fr8E%2Fk%3D",
      "cdn_url": "https://audio2.brain.fm/LumenLands_Focus_Creativity_Atmospheric_30_88BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LumenLands_Focus_Creativity_Atmospheric_30_88BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LumenLands_Focus_Creativity_Atmospheric_30_88BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/LumenLands_Focus_Creativity_Atmospheric_30_88BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27006438,
      "sha256": "441a0a7a8085024133973f03d136d01433e7b29083bcc19f7106458db94e9a42",
      "download_error": null
    },
    {
      "track_id": "6a0b8b25e6017bccd74b7b8a",
      "name": "Between The Bells",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.42,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/BetweenTheBells_Focus_DeepWork_Atmospheric_30_75BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=RBxbYZ6uTYjvt%2BKAqXulI%2BhDPvAk6Wk3Ho%2BeCLDuRyM%3D",
      "cdn_url": "https://audio2.brain.fm/BetweenTheBells_Focus_DeepWork_Atmospheric_30_75BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BetweenTheBells_Focus_DeepWork_Atmospheric_30_75BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BetweenTheBells_Focus_DeepWork_Atmospheric_30_75BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/BetweenTheBells_Focus_DeepWork_Atmospheric_30_75BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26771889,
      "sha256": "dc499d22b4de0169dad0574e2db31857c912d7208b0438b2d145fafed76af2d9",
      "download_error": null
    },
    {
      "track_id": "69f8b9231c706aff1baf1176",
      "name": "As Things Truly Are",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.28,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/AsThingsTrulyAre_Focus_DeepWork_Atmospheric_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=DSbRuFpJhMRfzdUh0Ggt3qjjekTrJIu7Fq8iZXK2lfQ%3D",
      "cdn_url": "https://audio2.brain.fm/AsThingsTrulyAre_Focus_DeepWork_Atmospheric_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AsThingsTrulyAre_Focus_DeepWork_Atmospheric_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AsThingsTrulyAre_Focus_DeepWork_Atmospheric_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/AsThingsTrulyAre_Focus_DeepWork_Atmospheric_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26122160,
      "sha256": "05a0f94c35cdbe7a5306995fafe18619855ba25279a42f314eb6dcd6e96fff12",
      "download_error": null
    },
    {
      "track_id": "69f8b8881c706aff1baf0b54",
      "name": "The Eternal Day",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 106,
      "brightness_level": 0.59,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TheEternalDay_Focus_Atmospheric_Creativity_30_106BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=Adbwd%2BtGs5wues%2FX1GoQI6BAJVV6a5JaIlw2%2FcQd7ps%3D",
      "cdn_url": "https://audio2.brain.fm/TheEternalDay_Focus_Atmospheric_Creativity_30_106BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheEternalDay_Focus_Atmospheric_Creativity_30_106BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheEternalDay_Focus_Atmospheric_Creativity_30_106BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TheEternalDay_Focus_Atmospheric_Creativity_30_106BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27475765,
      "sha256": "96663908d6d1d7b5bee6fbda43340cc71acaa53b40f460389d04c0aaf6fdd4a0",
      "download_error": null
    },
    {
      "track_id": "69e68692dce2120639c6ee15",
      "name": "Blooming Rose",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.26,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/BloomingRose_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=E3OmVjoXlG%2BbRerxt1ppr2U2sL2R8R1k2S3ZRW8ebx8%3D",
      "cdn_url": "https://audio2.brain.fm/BloomingRose_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BloomingRose_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BloomingRose_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/BloomingRose_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22051248,
      "sha256": "fb46a3eef99c3c476ffc4654d0defaceb4504f6d2af26d3c1db6131af25712ad",
      "download_error": null
    },
    {
      "track_id": "69e68533dce2120639c6e20f",
      "name": "Arriving On Time",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.16,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.83,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/ArrivingOnTime_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=iixR3Q7AuVlBVKICo6X8c1H1m5XSUfJFMk1Jl2taZXY%3D",
      "cdn_url": "https://audio2.brain.fm/ArrivingOnTime_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ArrivingOnTime_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ArrivingOnTime_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/ArrivingOnTime_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23376254,
      "sha256": "9d8b9d08b2f7a91944e3b4bc644c98fd6d5a8562d9991c94a4716d764efe8934",
      "download_error": null
    },
    {
      "track_id": "69e684f5dce2120639c6e024",
      "name": "True Freedom",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.36,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TrueFreedom_Focus_Learning_Atmospheric_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=ilRDZslgOCvMWNbJu9oeCEikG4WsCrzz%2BOBfquVInAo%3D",
      "cdn_url": "https://audio2.brain.fm/TrueFreedom_Focus_Learning_Atmospheric_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TrueFreedom_Focus_Learning_Atmospheric_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TrueFreedom_Focus_Learning_Atmospheric_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TrueFreedom_Focus_Learning_Atmospheric_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27827400,
      "sha256": "b336c496bfae17b897671fa9ce152cb58ef18a2eb3836a56cc26aabc53bbfff7",
      "download_error": null
    },
    {
      "track_id": "69d028449b9914998a32dcfe",
      "name": "Moving Towards Peace",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.48,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/MovingTowardsPeace_Focus_DeepWork_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=dx3qr47y4CnfiQNaTEebB5%2Fg9sqlngDqfJ9ranhej14%3D",
      "cdn_url": "https://audio2.brain.fm/MovingTowardsPeace_Focus_DeepWork_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MovingTowardsPeace_Focus_DeepWork_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MovingTowardsPeace_Focus_DeepWork_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/MovingTowardsPeace_Focus_DeepWork_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27525313,
      "sha256": "adb3b92c9ca0883c7fdbb0f7f47d2a64777ddbd5d8d7a2c06f85930ace911d72",
      "download_error": null
    },
    {
      "track_id": "69d027f69b9914998a32da42",
      "name": "Mind in a Mirror",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.48,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/MindinaMirror_Focus_Chill_Atmospheric_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=WyjSN4auMX3CG35I4ecUKyNr26UaeeITcJ1NY8MSJ2M%3D",
      "cdn_url": "https://audio2.brain.fm/MindinaMirror_Focus_Chill_Atmospheric_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MindinaMirror_Focus_Chill_Atmospheric_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MindinaMirror_Focus_Chill_Atmospheric_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/MindinaMirror_Focus_Chill_Atmospheric_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29949274,
      "sha256": "06de4fd8bbb5d36b90b6cfa493881d303e5be08e631b5eeafe854d1ed228071e",
      "download_error": null
    },
    {
      "track_id": "69d027059b9914998a32d251",
      "name": "The Systems Of Planets",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.48,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TheSystemsOfPlanets_Focus_Atmospheric_Creativity_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=dwr1ZHRLurSj5Hi%2FHNYSrfsb0vVPEOLuAhjvo%2BFUT%2Bg%3D",
      "cdn_url": "https://audio2.brain.fm/TheSystemsOfPlanets_Focus_Atmospheric_Creativity_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheSystemsOfPlanets_Focus_Atmospheric_Creativity_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheSystemsOfPlanets_Focus_Atmospheric_Creativity_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TheSystemsOfPlanets_Focus_Atmospheric_Creativity_30_108BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26479992,
      "sha256": "ae14a65f22af2bcfa939a9217024a8c0e8afbb0ce44abe7b3dd1f43146b8f7ec",
      "download_error": null
    },
    {
      "track_id": "69d026449b9914998a32cb87",
      "name": "Overlaps",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.22,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Overlaps_Focus_DeepWork_Atmospheric_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=he%2F4hDFmBpzXgpJrQCZJAtJLo93S020EDmxYs2u0yno%3D",
      "cdn_url": "https://audio2.brain.fm/Overlaps_Focus_DeepWork_Atmospheric_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Overlaps_Focus_DeepWork_Atmospheric_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Overlaps_Focus_DeepWork_Atmospheric_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Overlaps_Focus_DeepWork_Atmospheric_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25267177,
      "sha256": "4f40313a455ed51ff3f7facf33896cb051d454c0717732dd59ac1bf39c7b26d3",
      "download_error": null
    },
    {
      "track_id": "69c2bd2c1b6ecfe6c4a72556",
      "name": "Humble Beginnings",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.39,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/HumbleBeginnings_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=nbjF1VeUpA89YrPfOM5%2FkL9Ru054WSWhf7uDsEKtwEk%3D",
      "cdn_url": "https://audio2.brain.fm/HumbleBeginnings_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HumbleBeginnings_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HumbleBeginnings_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/HumbleBeginnings_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24729360,
      "sha256": "7602b72baf2dfc08d68c5cf2c9b235c510e50f231ebb862366e8c40f877ace0b",
      "download_error": null
    },
    {
      "track_id": "69c2b2ce1b6ecfe6c4a6cfb4",
      "name": "Celestial Event",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.32,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/CelestialEvent_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=B5O%2FcRbZCZkRl9JqmkW7pTRkek3EJTVcaTkVmcP14N4%3D",
      "cdn_url": "https://audio2.brain.fm/CelestialEvent_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CelestialEvent_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CelestialEvent_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/CelestialEvent_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24082387,
      "sha256": "325f5d5ee93c36472d067268f177e8ab4b3a1b6f3790e75128cee93c1e00cde1",
      "download_error": null
    },
    {
      "track_id": "69aee2b673bfe2099d517b1e",
      "name": "Infinite Suspension",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.43,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/InfiniteSuspension_Focus_Atmospheric_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=KVmVj4ow92%2FoQ24ZQbEpew%2FYjJXePTyzOgq8IHqfDLA%3D",
      "cdn_url": "https://audio2.brain.fm/InfiniteSuspension_Focus_Atmospheric_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InfiniteSuspension_Focus_Atmospheric_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InfiniteSuspension_Focus_Atmospheric_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/InfiniteSuspension_Focus_Atmospheric_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27958143,
      "sha256": "a2ba28a4cefc1e478f26f4a579358acb77eb7867501a90f7b3dba7b656c72ffa",
      "download_error": null
    },
    {
      "track_id": "69aee06b73bfe2099d516bdb",
      "name": "To Be a Child Again",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 104,
      "brightness_level": 0.43,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/ToBeAChildAgain_Focus_Creativity_Atmospheric_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=RaczjuusmNiCWHG%2BZO5NsJEHg5USDzqsp5pNJkPNf5I%3D",
      "cdn_url": "https://audio2.brain.fm/ToBeAChildAgain_Focus_Creativity_Atmospheric_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ToBeAChildAgain_Focus_Creativity_Atmospheric_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ToBeAChildAgain_Focus_Creativity_Atmospheric_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/ToBeAChildAgain_Focus_Creativity_Atmospheric_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26400371,
      "sha256": "64ac5fb382d68f4e7a287938709961dd944bb3199ccf5c9bf6c39e85836708c1",
      "download_error": null
    },
    {
      "track_id": "699cad4f9033fe9e7ccfa786",
      "name": "Cosmic Catharsis",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.41,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/CosmicCatharsis_Focus_Atmospheric_Learning_30_72BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=SaL%2F8l3weBX5JlbnfT11eiFnyHIem14pf9GsksBw%2B38%3D",
      "cdn_url": "https://audio2.brain.fm/CosmicCatharsis_Focus_Atmospheric_Learning_30_72BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CosmicCatharsis_Focus_Atmospheric_Learning_30_72BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CosmicCatharsis_Focus_Atmospheric_Learning_30_72BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/CosmicCatharsis_Focus_Atmospheric_Learning_30_72BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25417520,
      "sha256": "93e90b3877245fa57434c00a56497bf98867f387f7e22266db93e4c854b3d328",
      "download_error": null
    },
    {
      "track_id": "699cac029033fe9e7ccf9b8e",
      "name": "White Sun Red Clouds",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.42,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/WhiteSunRedClouds_Focus_Creativity_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=MWSpNQKGAxH9bU49nE3dN53Lr5x25NObn1JfvXHUYPU%3D",
      "cdn_url": "https://audio2.brain.fm/WhiteSunRedClouds_Focus_Creativity_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WhiteSunRedClouds_Focus_Creativity_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WhiteSunRedClouds_Focus_Creativity_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/WhiteSunRedClouds_Focus_Creativity_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26192489,
      "sha256": "1bea63baa8708717725c77868a6f19a07d3822a4ce1ec15c049c4fbe90facf8c",
      "download_error": null
    },
    {
      "track_id": "699cabac9033fe9e7ccf98bb",
      "name": "Highest Peak",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.32,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/HighestPeak_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=9OgUfVCMCBvIF1Zwz4bhOw2uCGtW66i24JYDMjYW3l8%3D",
      "cdn_url": "https://audio2.brain.fm/HighestPeak_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HighestPeak_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HighestPeak_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/HighestPeak_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23463062,
      "sha256": "e4626ebea796a40cb3a2b8fc76c747121964df7630af3bb7d2e5725154eabbc2",
      "download_error": null
    },
    {
      "track_id": "698a15a18a4a8f35be5838c4",
      "name": "Fractured",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.25,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Fractured_Focus_Creativity_Atmospheric_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=KD0D%2FhjJ31EiDs8HxvDaMjcdNCahpshhVw5AcPbNebQ%3D",
      "cdn_url": "https://audio2.brain.fm/Fractured_Focus_Creativity_Atmospheric_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fractured_Focus_Creativity_Atmospheric_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fractured_Focus_Creativity_Atmospheric_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Fractured_Focus_Creativity_Atmospheric_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27775875,
      "sha256": "fd3cb595d6d8c9979e163dce587ecd34a9ad23b7a2b3956e9e10b047cd17613e",
      "download_error": null
    },
    {
      "track_id": "698a15198a4a8f35be58337b",
      "name": "Clean Slate",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.35,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/CleanSlate_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=ps9ZmCtWgPUQKBBOsldf2H9ItdxgcM%2BT6slX%2B3simLc%3D",
      "cdn_url": "https://audio2.brain.fm/CleanSlate_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CleanSlate_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CleanSlate_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/CleanSlate_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24908304,
      "sha256": "f27e009ddee573834f04395aaeb53e8abee8935c843d0ee15248a73340b04831",
      "download_error": null
    },
    {
      "track_id": "6977c123236f65de4c7e6026",
      "name": "Rogue Star",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.45,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/RogueStar_Focus_Atmospheric_DeepWork_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=BBlVL%2Bu4r4u3ibkomrT3LqDhKxHE3XgI8iftJi5yrW0%3D",
      "cdn_url": "https://audio2.brain.fm/RogueStar_Focus_Atmospheric_DeepWork_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RogueStar_Focus_Atmospheric_DeepWork_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RogueStar_Focus_Atmospheric_DeepWork_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/RogueStar_Focus_Atmospheric_DeepWork_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26639299,
      "sha256": "65e095e6d68c085b7301f22dbaa4689065f5ffb75e2ed9bcd3a0657bb32b3263",
      "download_error": null
    },
    {
      "track_id": "6977b5d0236f65de4c7e30f0",
      "name": "Biometer",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.41,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Biometer_Focus_Creativity_Atmospheric_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=cXDt2XDRQLRelxkYxH5Kj3peeK7RwCFg3saYUDfqG9g%3D",
      "cdn_url": "https://audio2.brain.fm/Biometer_Focus_Creativity_Atmospheric_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Biometer_Focus_Creativity_Atmospheric_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Biometer_Focus_Creativity_Atmospheric_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Biometer_Focus_Creativity_Atmospheric_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24485861,
      "sha256": "39ddf1f5d4533232449a50d03ad37b1218a84cb2e9d7493bc35f38742aa825b7",
      "download_error": null
    },
    {
      "track_id": "6977b58d597917b519504b55",
      "name": "Neptune Diamonds",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.17,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/NeptuneDiamonds_Focus_DeepWork_Atmospheric_30_85BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=7NkWQMHZRQ5c7Fm7HaIyA35bZjmxYt%2BPizgaWD9px2E%3D",
      "cdn_url": "https://audio2.brain.fm/NeptuneDiamonds_Focus_DeepWork_Atmospheric_30_85BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NeptuneDiamonds_Focus_DeepWork_Atmospheric_30_85BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NeptuneDiamonds_Focus_DeepWork_Atmospheric_30_85BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/NeptuneDiamonds_Focus_DeepWork_Atmospheric_30_85BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24192201,
      "sha256": "c6f5da7b6f3b80b9208eec044cccc919ca7b183b923f8f0114df3554965b3d93",
      "download_error": null
    },
    {
      "track_id": "69655a92212c8d55194ee7e7",
      "name": "Galene",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.41,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Galene_Focus_Learning_Atmospheric_80_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=6irrokjcKBMMML%2FLJ1qHigbKNfpgnprK1QDo%2B%2Ffb9gs%3D",
      "cdn_url": "https://audio2.brain.fm/Galene_Focus_Learning_Atmospheric_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Galene_Focus_Learning_Atmospheric_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Galene_Focus_Learning_Atmospheric_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Galene_Focus_Learning_Atmospheric_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27670630,
      "sha256": "b76ed718175b55d05f48271566514221fb74f56293b299bc19bd39ff91000c13",
      "download_error": null
    },
    {
      "track_id": "69655a11212c8d55194ee532",
      "name": "No Beginning No End",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.11,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.83,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/NoBeginningNoEnd_Focus_DeepWork_Atmospheric_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=MdT2%2FNTDJq%2FMKFQULK17U68ioN3Y1VF0065LSMOY0hE%3D",
      "cdn_url": "https://audio2.brain.fm/NoBeginningNoEnd_Focus_DeepWork_Atmospheric_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NoBeginningNoEnd_Focus_DeepWork_Atmospheric_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NoBeginningNoEnd_Focus_DeepWork_Atmospheric_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/NoBeginningNoEnd_Focus_DeepWork_Atmospheric_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24084306,
      "sha256": "96dc6418cbc92e313eaa3d10f49018fdcaa4aa4dff2e957294394175db38098d",
      "download_error": null
    },
    {
      "track_id": "6952f39f9e729f65562d120d",
      "name": "Solving The Riddle",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 101,
      "brightness_level": 0.3,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/SolvingTheRiddle_Focus_Atmospheric_DeepWork_30_101BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=mefjyJ%2BVOxqDKK1BeY6En6bum4dCkesiXl%2FFwMXqJII%3D",
      "cdn_url": "https://audio2.brain.fm/SolvingTheRiddle_Focus_Atmospheric_DeepWork_30_101BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SolvingTheRiddle_Focus_Atmospheric_DeepWork_30_101BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SolvingTheRiddle_Focus_Atmospheric_DeepWork_30_101BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/SolvingTheRiddle_Focus_Atmospheric_DeepWork_30_101BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26380549,
      "sha256": "fd99ab6b7c4de95c524108d463a57dd228c9bdda39736290fa669a6918ea3687",
      "download_error": null
    },
    {
      "track_id": "6952f3059e729f65562d0f89",
      "name": "Free O2",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.38,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/FreeO2_Focus_Creativity_Atmospheric_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=5WlJoNphH5mluc7Uze4axa5YXP7OKZ0cEqpDH2qdd68%3D",
      "cdn_url": "https://audio2.brain.fm/FreeO2_Focus_Creativity_Atmospheric_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FreeO2_Focus_Creativity_Atmospheric_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FreeO2_Focus_Creativity_Atmospheric_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/FreeO2_Focus_Creativity_Atmospheric_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25722086,
      "sha256": "dadb8aed68854aa7ee099a285153600610623758287f43d3eb73b6fe024369b8",
      "download_error": null
    },
    {
      "track_id": "692dbd1eb8f361da92eb9cd5",
      "name": "Uncommon Beauty",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.22,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/UncommonBeauty_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=pFJYAb9TFvESagsZ87Q5V5Lb0UHIGAD%2Fb5omtKN3090%3D",
      "cdn_url": "https://audio2.brain.fm/UncommonBeauty_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UncommonBeauty_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UncommonBeauty_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/UncommonBeauty_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24030240,
      "sha256": "3fcdacfdab9429e4a7ed3f68fe9c6c0c79551e9799426b2fe9ba279e71342842",
      "download_error": null
    },
    {
      "track_id": "692dbce066ea27cd5c91128a",
      "name": "End of a Cycle",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.26,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/EndOfACycle_Focus_DeepWork_Atmospheric_30_98BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292122464&token=dxLlYGmxziG3igCpn84gjWIgw5dTIt30pCKqNMf0okE%3D",
      "cdn_url": "https://audio2.brain.fm/EndOfACycle_Focus_DeepWork_Atmospheric_30_98BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "EndOfACycle_Focus_DeepWork_Atmospheric_30_98BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "EndOfACycle_Focus_DeepWork_Atmospheric_30_98BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/EndOfACycle_Focus_DeepWork_Atmospheric_30_98BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24198398,
      "sha256": "ed83fad9386274f6d43a98935b4396937ef349ee0ae06007ccb687089fb72645",
      "download_error": null
    },
    {
      "track_id": "691b3b52331c372ce8748026",
      "name": "Mechanism",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 121,
      "brightness_level": 0.38,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Mechanism_Focus_DeepWork_Atmospheric_30_121BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=%2F02CgVsKgEUFHKm6e%2B6qNMSMacARILDtbDSMl%2FJfP5w%3D",
      "cdn_url": "https://audio2.brain.fm/Mechanism_Focus_DeepWork_Atmospheric_30_121BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Mechanism_Focus_DeepWork_Atmospheric_30_121BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Mechanism_Focus_DeepWork_Atmospheric_30_121BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Mechanism_Focus_DeepWork_Atmospheric_30_121BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27530048,
      "sha256": "e702a4a9468b43642c77e6e2d78b847ce031a9b543aa81f93907c04f41360a81",
      "download_error": null
    },
    {
      "track_id": "6909188026bc41a99c8632b2",
      "name": "Homestar",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.38,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Homestar_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=vxRCd8ZxOa9NKiCoOOIlMpewYtoIWEMpzBI01SsY5bw%3D",
      "cdn_url": "https://audio2.brain.fm/Homestar_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Homestar_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Homestar_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Homestar_Focus_DeepWork_Atmospheric_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26609274,
      "sha256": "68a5dda10b1f9e5e38f638b93545c70484096a8dcf2c17588b4e5df6ec4a10b7",
      "download_error": null
    },
    {
      "track_id": "68f6647ee8a4cc0a7401bdcc",
      "name": "The Earth Underwater",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.43,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TheEarthUnderWater_Focus_Creativity_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=shVY3x4aCf5nQU5jrJAcUeP3Jpa%2B1tJ%2B9ARrNnYzO88%3D",
      "cdn_url": "https://audio2.brain.fm/TheEarthUnderWater_Focus_Creativity_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheEarthUnderWater_Focus_Creativity_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheEarthUnderWater_Focus_Creativity_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TheEarthUnderWater_Focus_Creativity_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26416744,
      "sha256": "be63c302fa092f3f83a03b4fe677914669ce1ec89f461c1daa5c5cbd8004e458",
      "download_error": null
    },
    {
      "track_id": "68f663fac7a40a338f845911",
      "name": "Resurgence",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.38,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Resurgence_Focus_DeepWork_Atmospheric_30_96BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292122464&token=gQ6q6Ek%2FnE2q8ma1oDGEgSnI%2FfT34HDe99w00m%2FI8Rk%3D",
      "cdn_url": "https://audio2.brain.fm/Resurgence_Focus_DeepWork_Atmospheric_30_96BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Resurgence_Focus_DeepWork_Atmospheric_30_96BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "Resurgence_Focus_DeepWork_Atmospheric_30_96BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Resurgence_Focus_DeepWork_Atmospheric_30_96BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27704058,
      "sha256": "8ecac0533d71eb3385ff754e4641c8ad298052e38bd8cfbd2b7d2dfa76e29881",
      "download_error": null
    },
    {
      "track_id": "68e3d7152d873930bbbf7a63",
      "name": "A Quiet Shift",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.49,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/AQuietShift_Focus_Creativity_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=2fyFfhgkf419U863PZ%2F8QXodFNIS3nsXuJnldpkKILE%3D",
      "cdn_url": "https://audio2.brain.fm/AQuietShift_Focus_Creativity_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AQuietShift_Focus_Creativity_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AQuietShift_Focus_Creativity_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/AQuietShift_Focus_Creativity_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25841588,
      "sha256": "13307808c92596966c6111ad1ca60872a6f18a069e565407e11f186f72fd6215",
      "download_error": null
    },
    {
      "track_id": "68d17877a2277468b10cd55c",
      "name": "Undercurrents",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.36,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Undercurrents_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=RoXcyAJ6oT81Zn0V%2FUe%2BqPhq21GLFWAFjY9AArpRSMY%3D",
      "cdn_url": "https://audio2.brain.fm/Undercurrents_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Undercurrents_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Undercurrents_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Undercurrents_Focus_DeepWork_Atmospheric_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23732695,
      "sha256": "ed3a051b001b826d9cc17d6d650537c83bf1c7f80d0960d1aa01485b62c0fe0b",
      "download_error": null
    },
    {
      "track_id": "68bf23dc95e372361f91f25f",
      "name": "Good Tidings",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.17,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/GoodTidings_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=ko77piu8smdxV3Vxgc19UZMZpi7i5i1Bss8AuQF73SQ%3D",
      "cdn_url": "https://audio2.brain.fm/GoodTidings_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GoodTidings_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GoodTidings_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/GoodTidings_Focus_DeepWork_Atmospheric_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25475328,
      "sha256": "adf26d3d998d5c2cc3733c4bf4565a9b091e492632bbf14a69d3afdae0c7af63",
      "download_error": null
    },
    {
      "track_id": "68bf23cc95e372361f91f209",
      "name": "Inside the Mind",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.46,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/InsideTheMind_Focus_Creativity_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=VSvY5Jo73PPtcr%2B7Vjf7sTdnq8pvqs5G8s1sFAVIfao%3D",
      "cdn_url": "https://audio2.brain.fm/InsideTheMind_Focus_Creativity_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InsideTheMind_Focus_Creativity_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InsideTheMind_Focus_Creativity_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/InsideTheMind_Focus_Creativity_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25022759,
      "sha256": "417abdbdad48fbf4c902f1f8d1ff429269eb9c87a6db4decd8c790e8afce9abb",
      "download_error": null
    },
    {
      "track_id": "68aca4e8870c986ca59c0a27",
      "name": "Beginning To Blossom",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 102,
      "brightness_level": 0.25,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/BeginningToBlossom_Focus_Creativity_Atmospheric_30_102BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=pO%2FiBeFenCTqI86WJ1aQwZlS0wpHoxPxAWEYEitHTgA%3D",
      "cdn_url": "https://audio2.brain.fm/BeginningToBlossom_Focus_Creativity_Atmospheric_30_102BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BeginningToBlossom_Focus_Creativity_Atmospheric_30_102BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BeginningToBlossom_Focus_Creativity_Atmospheric_30_102BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/BeginningToBlossom_Focus_Creativity_Atmospheric_30_102BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26084550,
      "sha256": "e528d15853d5400a88373f21b07351cfc6771b368770a4c8a66fe7ce4c50980e",
      "download_error": null
    },
    {
      "track_id": "689a230d9446c76349a3b4ff",
      "name": "Energy Flux",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.51,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/EnergyFlux_Focus_Creativity_Atmospheric_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=%2FaekptDAlLYtNJAxnQfUO1AOJAdLnUbMTxdbU03BBWQ%3D",
      "cdn_url": "https://audio2.brain.fm/EnergyFlux_Focus_Creativity_Atmospheric_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EnergyFlux_Focus_Creativity_Atmospheric_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EnergyFlux_Focus_Creativity_Atmospheric_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/EnergyFlux_Focus_Creativity_Atmospheric_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27724459,
      "sha256": "e9fcec750533b24ab3df56218fa176a703b00b2899b8c22de603e191907caa9e",
      "download_error": null
    },
    {
      "track_id": "689a2298cc7f78cc36b7b950",
      "name": "Imperceivable Waves",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.31,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/ImperceivableWaves_Focus_DeepWork_Atmospheric_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=QvZf7h6an7uYmHbpWL%2BwDD94ZRYjovpEFLWaVljrP5k%3D",
      "cdn_url": "https://audio2.brain.fm/ImperceivableWaves_Focus_DeepWork_Atmospheric_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ImperceivableWaves_Focus_DeepWork_Atmospheric_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ImperceivableWaves_Focus_DeepWork_Atmospheric_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/ImperceivableWaves_Focus_DeepWork_Atmospheric_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24974757,
      "sha256": "3c66a5b24b62011fa77ec29e2dfcaa112236eb9c324bb35769c20f09573004ba",
      "download_error": null
    },
    {
      "track_id": "6888c7d8b997579cf699b46a",
      "name": "Illusory",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.38,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Illusory_Focus_Learning_Atmospheric_30_126BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=47aHOL2AwbUYMHnuI3uQiTDcVjw9Rmsex06sR99tPmI%3D",
      "cdn_url": "https://audio2.brain.fm/Illusory_Focus_Learning_Atmospheric_30_126BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Illusory_Focus_Learning_Atmospheric_30_126BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Illusory_Focus_Learning_Atmospheric_30_126BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Illusory_Focus_Learning_Atmospheric_30_126BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25785968,
      "sha256": "fbb0b83a84aa071802eac27cfc936f30ce66f0d209c490d890e48db54d9851ac",
      "download_error": null
    },
    {
      "track_id": "6875505a7e95e87bea7297c9",
      "name": "Safe At Last",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.11,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/SafeAtLast_Focus_DeepWork_Atmospheric_30_108BPM_LowNEL.wav_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=j0WdzFw8rk0T5xDdxyMzgKIiJ429viInwXtVfd0x210%3D",
      "cdn_url": "https://audio2.brain.fm/SafeAtLast_Focus_DeepWork_Atmospheric_30_108BPM_LowNEL.wav_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SafeAtLast_Focus_DeepWork_Atmospheric_30_108BPM_LowNEL.wav_Nrmlzd2_VBR5.mp3",
      "filename": "SafeAtLast_Focus_DeepWork_Atmospheric_30_108BPM_LowNEL.wav_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/SafeAtLast_Focus_DeepWork_Atmospheric_30_108BPM_LowNEL.wav_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25426786,
      "sha256": "46fbdcb50f3d9de7f843df8326f8d418660f6273b2b793851a02353abbcaba2a",
      "download_error": null
    },
    {
      "track_id": "6862f10c7689f5af5f045688",
      "name": "Feather Fall",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.45,
      "complexity_level": 1.04,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/FeatherFall_Focus_Creativity_Atmospheric_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=D4G0V1Ngz6pV6Kba8kGFjVRNRTPvH2XOkvP67D2ADcU%3D",
      "cdn_url": "https://audio2.brain.fm/FeatherFall_Focus_Creativity_Atmospheric_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FeatherFall_Focus_Creativity_Atmospheric_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FeatherFall_Focus_Creativity_Atmospheric_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/FeatherFall_Focus_Creativity_Atmospheric_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26112365,
      "sha256": "3e9cfb0af74d1b99aff82493e5090281da26097bdbf92bf98f906c1de42c8837",
      "download_error": null
    },
    {
      "track_id": "6862ee4bda2d247f1a9c715e",
      "name": "An Opening",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 128,
      "brightness_level": 0.16,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/AnOpening_Focus_DeepWork_Atmospheric_30_128BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292122464&token=E1kqFsYI37ylntldfvA3D8O%2FyLhoMcF87b8sVFRQPMw%3D",
      "cdn_url": "https://audio2.brain.fm/AnOpening_Focus_DeepWork_Atmospheric_30_128BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "AnOpening_Focus_DeepWork_Atmospheric_30_128BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "AnOpening_Focus_DeepWork_Atmospheric_30_128BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/AnOpening_Focus_DeepWork_Atmospheric_30_128BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25583007,
      "sha256": "05172d1ccfbfbe975f16f5b033f003ff7d2047895ccab32c5ec37300b7a07ab6",
      "download_error": null
    },
    {
      "track_id": "683dc82d7e70e7db4e0af259",
      "name": "Deep in the Mystic Forest",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 79,
      "brightness_level": 0.51,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/DeepInsideTheMysticForest_Focus_Creativity_Atmospheric_30_79BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=QI9nujiPErduog%2BCp5LArcgyBjmqVeC3e9QRmzF7UE0%3D",
      "cdn_url": "https://audio2.brain.fm/DeepInsideTheMysticForest_Focus_Creativity_Atmospheric_30_79BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DeepInsideTheMysticForest_Focus_Creativity_Atmospheric_30_79BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DeepInsideTheMysticForest_Focus_Creativity_Atmospheric_30_79BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/DeepInsideTheMysticForest_Focus_Creativity_Atmospheric_30_79BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25526694,
      "sha256": "c375220556a2476ec37f25add7e391dfeefe17bd571cb5668997492b174fa243",
      "download_error": null
    },
    {
      "track_id": "683dc76add2246ed9c7c81c2",
      "name": "Full Clarity",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.28,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/FullClarity_Focus_Learning_Atmospheric_30_118BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=DSUeKvaB52vSOkj9FBj8Ibu4bcop%2F0SyXkpnG%2FxTGYM%3D",
      "cdn_url": "https://audio2.brain.fm/FullClarity_Focus_Learning_Atmospheric_30_118BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FullClarity_Focus_Learning_Atmospheric_30_118BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FullClarity_Focus_Learning_Atmospheric_30_118BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/FullClarity_Focus_Learning_Atmospheric_30_118BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22370967,
      "sha256": "f92a0c6d6a6200e555dd5875b2c7e5ecb394628c2214059c6608418a50545de4",
      "download_error": null
    },
    {
      "track_id": "682b54568ab5a645af48388c",
      "name": "Between the Space",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.3,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/BetweenTheSpace_Focus_Creativity_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=TH0%2FoDESl%2BdjMX8WuOMgZ4M6VoXXyh4YwoAIfLUIkpA%3D",
      "cdn_url": "https://audio2.brain.fm/BetweenTheSpace_Focus_Creativity_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BetweenTheSpace_Focus_Creativity_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BetweenTheSpace_Focus_Creativity_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/BetweenTheSpace_Focus_Creativity_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24707858,
      "sha256": "781eb4246d5e824154f157e4f65f48b137668e5a7986f0d01f753418403da11e",
      "download_error": null
    },
    {
      "track_id": "6818d1f3c7fc795ec060f0b9",
      "name": "Ideas Are Brewing",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 133,
      "brightness_level": 0.48,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/IdeasAreBrewing_Focus_Creativity_Atmospheric_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=Z4AHEqk0OK5IkHfRWnZa5bgPt4PGxenan5k2w8rbyyw%3D",
      "cdn_url": "https://audio2.brain.fm/IdeasAreBrewing_Focus_Creativity_Atmospheric_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "IdeasAreBrewing_Focus_Creativity_Atmospheric_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "IdeasAreBrewing_Focus_Creativity_Atmospheric_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/IdeasAreBrewing_Focus_Creativity_Atmospheric_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26227377,
      "sha256": "ffe83ebe38d8e1a19483c0a9f7026ef3f5669e8f848bac051d2030b902c5e9c7",
      "download_error": null
    },
    {
      "track_id": "6806595c563464c2de5fb054",
      "name": "Movement in Stillness",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.32,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/MovementInStillness_Focus_Creativity_Atmospheric_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=qB1PF%2FSsKsyOA28uCVEUHxAfry1WYpN0Egu%2BnnLCmgI%3D",
      "cdn_url": "https://audio2.brain.fm/MovementInStillness_Focus_Creativity_Atmospheric_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MovementInStillness_Focus_Creativity_Atmospheric_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MovementInStillness_Focus_Creativity_Atmospheric_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/MovementInStillness_Focus_Creativity_Atmospheric_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23667338,
      "sha256": "46e97f0c4411f02acde0a003be9bea3e1637857c8cf0e892a252c88c47b36fb5",
      "download_error": null
    },
    {
      "track_id": "67f3ea16a0de2348f748db1e",
      "name": "Back in the Day",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.22,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.22,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/BackInTheDay_Focus_Learning_Atmospheric_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=yBkPvk1ycN8oVRgxLyWbkgZ%2F3oDD9wDOt5N025zBXYE%3D",
      "cdn_url": "https://audio2.brain.fm/BackInTheDay_Focus_Learning_Atmospheric_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BackInTheDay_Focus_Learning_Atmospheric_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BackInTheDay_Focus_Learning_Atmospheric_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/BackInTheDay_Focus_Learning_Atmospheric_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26995329,
      "sha256": "77a270a7a0a9a9e978a4d0de8476ab04fb3748705e7375b6e50dc4d5930b74fa",
      "download_error": null
    },
    {
      "track_id": "67e17d665177e5bfbd17f3cd",
      "name": "Hovering",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.27,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Hovering_Focus_Creativity_Atmospheric_30_92BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292122464&token=j%2BJCFwyI903nalZl2hm3qVlz7CNriSstnxA%2Fu%2FZLPH8%3D",
      "cdn_url": "https://audio2.brain.fm/Hovering_Focus_Creativity_Atmospheric_30_92BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Hovering_Focus_Creativity_Atmospheric_30_92BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "Hovering_Focus_Creativity_Atmospheric_30_92BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Hovering_Focus_Creativity_Atmospheric_30_92BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23545446,
      "sha256": "fdfac7f975364fffa28317d85f2b8677898e7038064900d6b65c10758728a624",
      "download_error": null
    },
    {
      "track_id": "67cf034d593aad5348b95ca7",
      "name": "Thin Rain",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.22,
      "complexity_level": 0.65,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/ThinRain_Focus_DeepWork_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=ztCaLeRk8GiXMwenirQCZceusVe4OPuRfhP7Le9wpuM%3D",
      "cdn_url": "https://audio2.brain.fm/ThinRain_Focus_DeepWork_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThinRain_Focus_DeepWork_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThinRain_Focus_DeepWork_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/ThinRain_Focus_DeepWork_Atmospheric_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24597106,
      "sha256": "055db1f4d4d81efd592afb10ba1a640c00b551acaee469a4c421acb95ce54a32",
      "download_error": null
    },
    {
      "track_id": "67cf0300593aad5348b95af0",
      "name": "Disintegrate",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 131,
      "brightness_level": 0.11,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Disintegrate_Focus_DeepWork_Atmospheric_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=X7ZkxlsZOmOrrKjLr4Gisnv8W6avbIagrK2o4htrOjE%3D",
      "cdn_url": "https://audio2.brain.fm/Disintegrate_Focus_DeepWork_Atmospheric_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Disintegrate_Focus_DeepWork_Atmospheric_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Disintegrate_Focus_DeepWork_Atmospheric_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Disintegrate_Focus_DeepWork_Atmospheric_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24141837,
      "sha256": "3064fcea3fac2c9704b44af5a148b6ea4563d7988bd1e42c07b41c508ef586ef",
      "download_error": null
    },
    {
      "track_id": "67bc8814dd31a1be17726712",
      "name": "Shifting Hues",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/ShiftingHues_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=9j4NcAP5Ged4sMABZ0dUokMDiyYHfeQQrtAIWVYiN2Y%3D",
      "cdn_url": "https://audio2.brain.fm/ShiftingHues_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ShiftingHues_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ShiftingHues_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/ShiftingHues_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29747050,
      "sha256": "cbc8a9106e3541faa277838cc377794127bbef05d85c996cfd12186c271c5610",
      "download_error": null
    },
    {
      "track_id": "67aa5b5755e93dd34369218c",
      "name": "Letting Go",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.29,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/LettingGo_Focus_DeepWork_Atmospheric__30_86BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=NjPcyucZy11emFDtBUxyH1O362Klz%2BrRaPdoW01NJ3o%3D",
      "cdn_url": "https://audio2.brain.fm/LettingGo_Focus_DeepWork_Atmospheric__30_86BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LettingGo_Focus_DeepWork_Atmospheric__30_86BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LettingGo_Focus_DeepWork_Atmospheric__30_86BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/LettingGo_Focus_DeepWork_Atmospheric__30_86BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25999144,
      "sha256": "57b4b753498731a74583fd05f501d06c3a7814c0da2a83df13ca0a2f11513dc0",
      "download_error": null
    },
    {
      "track_id": "67855b29f76968728486ab54",
      "name": "Come In Peace",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.36,
      "complexity_level": 0.53,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/ComeInPeace_Focus_DeepWork_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=bT%2BA6G4s5fF7kHuSN3yfHLng8%2BD6r55rdAH1ZXsjX6Y%3D",
      "cdn_url": "https://audio2.brain.fm/ComeInPeace_Focus_DeepWork_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ComeInPeace_Focus_DeepWork_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ComeInPeace_Focus_DeepWork_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/ComeInPeace_Focus_DeepWork_Atmospheric_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25421546,
      "sha256": "e8d841b1b2100cbd5ff494c081085b1d6e7c8638d492dcbcdfac7dd146949e96",
      "download_error": null
    },
    {
      "track_id": "67730044698f763bc2b459b1",
      "name": "Weaving Light",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.07,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/WeavingLight_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=tpXGeFIW%2Fj22J1BOW90fzEf731DYAI17T2lQ0o%2BoApc%3D",
      "cdn_url": "https://audio2.brain.fm/WeavingLight_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WeavingLight_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WeavingLight_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/WeavingLight_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21059675,
      "sha256": "39f734b08cf0e48b9dfdb3ee935a21e83e12016eb29eead517eb6e990263e81b",
      "download_error": null
    },
    {
      "track_id": "67730017ece704f031421d7d",
      "name": "Nature Systems",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.24,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/NatureSystems_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=bNHwG%2FwdmW7%2Fm%2BY40EjhKkserM2FZuskt4oTfxnDL4k%3D",
      "cdn_url": "https://audio2.brain.fm/NatureSystems_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NatureSystems_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NatureSystems_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/NatureSystems_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24861840,
      "sha256": "4dfd116ee59e02c976ecb1f43d6bae1c8362739b4cb68490278a882bf567e8d6",
      "download_error": null
    },
    {
      "track_id": "6773000b0c139ab77519e761",
      "name": "Dissolve",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.23,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Dissolve_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=m23uc47wRDo1tv%2FoveAidnACGjn6z7Dp8pjDh%2FdRqaI%3D",
      "cdn_url": "https://audio2.brain.fm/Dissolve_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dissolve_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dissolve_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Dissolve_Focus_Learning_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23204146,
      "sha256": "61400ca9dbecd1f2d89ef74b5ef82b22b4b529b4c76b8d2a4899e70edb0c41fe",
      "download_error": null
    },
    {
      "track_id": "67730000698f763bc2b4591d",
      "name": "Soft Colours",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.38,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.64,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/SoftColours_Focus_Creativity_Atmospheric_30_120BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=YfwXl1dxgybf7nBX8TxaAIgRVKD4cmJkCA7dpdOtx9c%3D",
      "cdn_url": "https://audio2.brain.fm/SoftColours_Focus_Creativity_Atmospheric_30_120BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SoftColours_Focus_Creativity_Atmospheric_30_120BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SoftColours_Focus_Creativity_Atmospheric_30_120BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/SoftColours_Focus_Creativity_Atmospheric_30_120BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22761175,
      "sha256": "20980b858544fa376966f72bd01f1fef52e7451652063295ee68ee6ca49456fd",
      "download_error": null
    },
    {
      "track_id": "6772fff5ece704f031421d4d",
      "name": "Early Light",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.83,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/EarlyLight_Focus_Creativity_Atmospheric_30_105BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=59BOlxMbbLPRoqv6jrVNFXEMb33jtz5SzPOfcYnCdI4%3D",
      "cdn_url": "https://audio2.brain.fm/EarlyLight_Focus_Creativity_Atmospheric_30_105BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EarlyLight_Focus_Creativity_Atmospheric_30_105BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EarlyLight_Focus_Creativity_Atmospheric_30_105BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/EarlyLight_Focus_Creativity_Atmospheric_30_105BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27230911,
      "sha256": "37092fbf889e5f8f50d3fa7238de159331a09988bb9d707c5306b265e1157e45",
      "download_error": null
    },
    {
      "track_id": "67603f564e4445c8c4dba3b7",
      "name": "Remnants",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.18,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Remnants_Focus_DeepWork_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=xLfmNYos2sMt%2B2sgna39sAprpm9ACyB%2FQIFcHMeZbDs%3D",
      "cdn_url": "https://audio2.brain.fm/Remnants_Focus_DeepWork_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Remnants_Focus_DeepWork_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Remnants_Focus_DeepWork_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Remnants_Focus_DeepWork_Atmospheric_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23700072,
      "sha256": "7201cc0e751b66acacfa2b6261bdeec92a4d71bb34c107e6e747c1e3db0d9819",
      "download_error": null
    },
    {
      "track_id": "67603f26b9509f31638d2097",
      "name": "Flux",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.14,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Flux_Focus_Creativity_Atmospheric_30_126BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=t7%2BvnxW1FmdxSVAZfzrHg1DVO5BLtZ0mw9i7HTpR%2BfQ%3D",
      "cdn_url": "https://audio2.brain.fm/Flux_Focus_Creativity_Atmospheric_30_126BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Flux_Focus_Creativity_Atmospheric_30_126BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Flux_Focus_Creativity_Atmospheric_30_126BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Flux_Focus_Creativity_Atmospheric_30_126BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22561550,
      "sha256": "5ae8e23b9046639e441beb60cd49388b500619a19747f17b80fa0ac84348e710",
      "download_error": null
    },
    {
      "track_id": "674de016657c71542c999a3b",
      "name": "Sacred",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 122,
      "brightness_level": 0.18,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Sacred_Focus_Learning_Atmospheric_30_122BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=eVCdWBf9ThgkXHnfvgA3VbxfjdAmgoZdh83u6ZgX5cw%3D",
      "cdn_url": "https://audio2.brain.fm/Sacred_Focus_Learning_Atmospheric_30_122BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sacred_Focus_Learning_Atmospheric_30_122BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sacred_Focus_Learning_Atmospheric_30_122BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Sacred_Focus_Learning_Atmospheric_30_122BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21798824,
      "sha256": "635cfbacd885cb67c2855242de7c29fd9c2652b69f492acd8ba140d704a1d52d",
      "download_error": null
    },
    {
      "track_id": "674ddfec657c71542c99990f",
      "name": "Great Discovery",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.27,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/GreatDiscovery_Focus_Creativity_Atmospheric_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=SVh8taeiCk3lHuOgMl8gusPEZg40Mrm7mLM%2FM41BmYE%3D",
      "cdn_url": "https://audio2.brain.fm/GreatDiscovery_Focus_Creativity_Atmospheric_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GreatDiscovery_Focus_Creativity_Atmospheric_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GreatDiscovery_Focus_Creativity_Atmospheric_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/GreatDiscovery_Focus_Creativity_Atmospheric_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25313765,
      "sha256": "5080c19323e1014f7c15e7526c69f8012ff892dd3157e67ccf4ffe419431668f",
      "download_error": null
    },
    {
      "track_id": "674ddfe1ed827e850ea89a0b",
      "name": "Bloomings",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 127,
      "brightness_level": 0.42,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Bloomings_Focus_Creativity_Atmospheric_30_127BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=StH17UQQK8wjuZoO6j3BToW8ZH2IcTUSWmeGRiqVkmU%3D",
      "cdn_url": "https://audio2.brain.fm/Bloomings_Focus_Creativity_Atmospheric_30_127BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bloomings_Focus_Creativity_Atmospheric_30_127BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Bloomings_Focus_Creativity_Atmospheric_30_127BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Bloomings_Focus_Creativity_Atmospheric_30_127BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25160343,
      "sha256": "15208712d8ea212e345be178d8d2354520ee47cdabd63b47194319d2b1ce5381",
      "download_error": null
    },
    {
      "track_id": "674ddfd6ed827e850ea899de",
      "name": "Awash",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.35,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.98,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Awash_Focus_Learning_Atmospheric_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=Rp4nKlrcIIp7smVmfA97jpvtIBqzUzE8E6gb2hF8cNQ%3D",
      "cdn_url": "https://audio2.brain.fm/Awash_Focus_Learning_Atmospheric_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Awash_Focus_Learning_Atmospheric_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Awash_Focus_Learning_Atmospheric_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Awash_Focus_Learning_Atmospheric_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25545586,
      "sha256": "b42e105b54286c3ac2bae0247d75040b52a6f05d3860a318a4b2323e360d3363",
      "download_error": null
    },
    {
      "track_id": "674ddfbe657c71542c99984f",
      "name": "Chasm",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.38,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Chasm_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=Khzt5Hs4Ajx6MjMMo%2F8C1AVjBWSBZbMbUdtnq34NYFA%3D",
      "cdn_url": "https://audio2.brain.fm/Chasm_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Chasm_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Chasm_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Chasm_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25839966,
      "sha256": "ebbbbbebaf1de1eb8422a5764700895ae827b47a18bf69c0d111e816b57c5911",
      "download_error": null
    },
    {
      "track_id": "674ddfb15dec417226950a8f",
      "name": "Underneath",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.22,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Underneath_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=%2Bw9bXLWMUUQpg1rypbYeKc%2BHSgZwYG0yjZLPtgg6S9A%3D",
      "cdn_url": "https://audio2.brain.fm/Underneath_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Underneath_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Underneath_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Underneath_Focus_Learning_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26368498,
      "sha256": "0633dc0992964e3fa2016e2116c0f73d5d74e0e21002fa1ee545e1a30b7cf0e6",
      "download_error": null
    },
    {
      "track_id": "674ddf9a657c71542c99978e",
      "name": "In Solitude",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.24,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/InSolitude_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=qCPxE6cK8pRj37LtRDRLsQaoa1G15BpYCwqeSncaAa8%3D",
      "cdn_url": "https://audio2.brain.fm/InSolitude_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InSolitude_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InSolitude_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/InSolitude_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23494641,
      "sha256": "561f9512dd66304bfd5b428c432b33ba5679fadb53ea092bdc3472b3f3c09534",
      "download_error": null
    },
    {
      "track_id": "674ddf82657c71542c9996e0",
      "name": "Bardo",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.3,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Bardo_Focus_Creativity_Atmospheric_30_72BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=ZG9U%2BVbWEgPS4NtzGLleNOd9WgJLNfft4EBniVY4q2o%3D",
      "cdn_url": "https://audio2.brain.fm/Bardo_Focus_Creativity_Atmospheric_30_72BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bardo_Focus_Creativity_Atmospheric_30_72BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Bardo_Focus_Creativity_Atmospheric_30_72BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Bardo_Focus_Creativity_Atmospheric_30_72BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26578189,
      "sha256": "4e32072816c098ae0544ecfc82ed1e87e3cc835f7bc44ae91d74e47c98aec775",
      "download_error": null
    },
    {
      "track_id": "674ddf77ed827e850ea89976",
      "name": "A Memory",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.6,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/AMemory_Focus_Creativity_Atmospheric_30_92BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=4BLQCa3ftUrEEgt8yNDiMdahEm%2FP8YRBIfga2JaUaGE%3D",
      "cdn_url": "https://audio2.brain.fm/AMemory_Focus_Creativity_Atmospheric_30_92BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AMemory_Focus_Creativity_Atmospheric_30_92BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AMemory_Focus_Creativity_Atmospheric_30_92BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/AMemory_Focus_Creativity_Atmospheric_30_92BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25941200,
      "sha256": "21e26afbac257993bb3aae9dca439375e43d4a7de956c9dcdd99bea31bad3da2",
      "download_error": null
    },
    {
      "track_id": "673b5e8281e56c199c2a9e73",
      "name": "Time Cycles",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.11,
      "complexity_level": 0.75,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TimeCycles_Focus_Learning_Atmospheric_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=9kqdROrQziDTutvkhP1BJhWfY5XkklOc%2B1moep8OtGY%3D",
      "cdn_url": "https://audio2.brain.fm/TimeCycles_Focus_Learning_Atmospheric_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TimeCycles_Focus_Learning_Atmospheric_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TimeCycles_Focus_Learning_Atmospheric_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TimeCycles_Focus_Learning_Atmospheric_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22345150,
      "sha256": "594d09737b4e571715e39ef19a1f861a2f697ed2364e3564fd839e84be0236cd",
      "download_error": null
    },
    {
      "track_id": "673b5e3e593072f908bc7765",
      "name": "Springtime Sky",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.46,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/SpringtimeSky_Focus_Creativity_Atmospheric_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=bUtyu4kymr%2FBLnqtyzOqWPTIlE9Dc83iNTkJHnwuP7k%3D",
      "cdn_url": "https://audio2.brain.fm/SpringtimeSky_Focus_Creativity_Atmospheric_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SpringtimeSky_Focus_Creativity_Atmospheric_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SpringtimeSky_Focus_Creativity_Atmospheric_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/SpringtimeSky_Focus_Creativity_Atmospheric_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25668628,
      "sha256": "762c64ffc3ec74bdd82ebefe7581c0500fd0fb436489f528247c7384d31b8672",
      "download_error": null
    },
    {
      "track_id": "673b5e1b81e56c199c2a9d42",
      "name": "Winter Movements",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 102,
      "brightness_level": 0.33,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/WinterMovements_Focus_Creativity_Atmospheric_30_102BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=enWm9PxZk3xVNsRrkGfNQOjFzEjvVP3GQwmjYJqcXNg%3D",
      "cdn_url": "https://audio2.brain.fm/WinterMovements_Focus_Creativity_Atmospheric_30_102BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WinterMovements_Focus_Creativity_Atmospheric_30_102BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WinterMovements_Focus_Creativity_Atmospheric_30_102BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/WinterMovements_Focus_Creativity_Atmospheric_30_102BPM_Nrmlzd2_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24263296,
      "sha256": "9ac5bb9f05306585fca1db25f743466c194d74b9db58c53dca6d169a51244416",
      "download_error": null
    },
    {
      "track_id": "6728ec1ba39954546e6e5581",
      "name": "Swimmingly",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.38,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Swimmingly_Focus_DeepWork_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=VIcJ8n6jWx7wG7aakshn5QVjHDHXJzdCRZgaUb2Wjqs%3D",
      "cdn_url": "https://audio2.brain.fm/Swimmingly_Focus_DeepWork_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Swimmingly_Focus_DeepWork_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Swimmingly_Focus_DeepWork_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Swimmingly_Focus_DeepWork_Atmospheric_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24162043,
      "sha256": "b3393eaadfe2ca2b05d9ae832f07b525e86f40a120f8b59a3fd0398842c5777f",
      "download_error": null
    },
    {
      "track_id": "6728ebefa39954546e6e5556",
      "name": "The Day After",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 104,
      "brightness_level": 0.4,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TheDayAfter_Focus_Learning_Atmospheric_30_104BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=qNXLucSgzzVUODa%2FOecjDg1UrDoG%2BYxup0UQTnnU1K4%3D",
      "cdn_url": "https://audio2.brain.fm/TheDayAfter_Focus_Learning_Atmospheric_30_104BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheDayAfter_Focus_Learning_Atmospheric_30_104BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheDayAfter_Focus_Learning_Atmospheric_30_104BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TheDayAfter_Focus_Learning_Atmospheric_30_104BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27369492,
      "sha256": "a51e8fdb309d9ee2ff90e45309235c33ead20a20a27f7a93d160cd86ba3f303d",
      "download_error": null
    },
    {
      "track_id": "6728ebcea39954546e6e54c9",
      "name": "Paradigm",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.3,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Paradigm_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=fVQGLDXBJrVCTuevtlwWm0aVOftyu49IE5FXLkzvzqs%3D",
      "cdn_url": "https://audio2.brain.fm/Paradigm_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Paradigm_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Paradigm_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Paradigm_Focus_Learning_Atmospheric_30_96BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23485737,
      "sha256": "d3adf9465942dcf51439b3be7d22c5688cd3542baf10246dc24a76397b3e7f0c",
      "download_error": null
    },
    {
      "track_id": "6728eb7febed2a29b0df4395",
      "name": "Waning Moon",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.36,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Waning%20Moon%20Ambient%20Focus%20Light%20Work%20Conor%2090bpm_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=D9r6Haxa8u3ZnwEhUpHohnMmRhgjeZZHr%2F8x7DWyRrQ%3D",
      "cdn_url": "https://audio2.brain.fm/Waning%20Moon%20Ambient%20Focus%20Light%20Work%20Conor%2090bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Waning Moon Ambient Focus Light Work Conor 90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Waning-Moon-Ambient-Focus-Light-Work-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Waning-Moon-Ambient-Focus-Light-Work-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23800249,
      "sha256": "5ca17bd328281e2cd01ab907f11a2ff5efb367558d1128267ddec21d9aa55145",
      "download_error": null
    },
    {
      "track_id": "6728eb77ebed2a29b0df4354",
      "name": "Arctic Lights",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.88,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Arctic%20Lights%20Ambient%20Focus%20Creative%20Flow%20Conor%20100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=WN6yJBuwakKhKpe8JcVzmrmwibjx8h3A8D%2BNdfTYtxk%3D",
      "cdn_url": "https://audio2.brain.fm/Arctic%20Lights%20Ambient%20Focus%20Creative%20Flow%20Conor%20100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Arctic Lights Ambient Focus Creative Flow Conor 100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Arctic-Lights-Ambient-Focus-Creative-Flow-Conor-100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Arctic-Lights-Ambient-Focus-Creative-Flow-Conor-100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27628220,
      "sha256": "439c34c32f95afcfb01127d04aebeba41d9f03688f7802c423d15554f62906cc",
      "download_error": null
    },
    {
      "track_id": "6716a1a5ae8c98e954dc5b37",
      "name": "Prelude",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.24,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Prelude_Focus_Learning_Atmospheric_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=TeMFw%2BcjRuuvd30iR6%2FmroA0Vuuqrp%2FekwK8FbPXd8s%3D",
      "cdn_url": "https://audio2.brain.fm/Prelude_Focus_Learning_Atmospheric_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Prelude_Focus_Learning_Atmospheric_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Prelude_Focus_Learning_Atmospheric_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Prelude_Focus_Learning_Atmospheric_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23366823,
      "sha256": "975ceceac4ad0219575ccf64c10749f494788804d553feb1a5c36dd7d2e90585",
      "download_error": null
    },
    {
      "track_id": "6716a13bae8c98e954dc58c9",
      "name": "Unmoved",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.27,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Unmoved_Focus_Creativity_Atmospheric_30_88BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=%2FpP64DMdsAX5wm%2BJHh27ZzwHp0P3tkTsu%2BOsqC8fiio%3D",
      "cdn_url": "https://audio2.brain.fm/Unmoved_Focus_Creativity_Atmospheric_30_88BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unmoved_Focus_Creativity_Atmospheric_30_88BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unmoved_Focus_Creativity_Atmospheric_30_88BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Unmoved_Focus_Creativity_Atmospheric_30_88BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24580936,
      "sha256": "9316a5472665e037209d3eb3c5ca62ffd6db12ade8c080a64615032c10a5fc8b",
      "download_error": null
    },
    {
      "track_id": "6716a12eae8c98e954dc585c",
      "name": "Time Shifts",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.23,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/TimeShifts_Focus_Learning_Atmospheric_30_116BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=lLcwnMmaOUm%2BBXZU3ur7ctWroUaqHz1y8ksBc14SeBw%3D",
      "cdn_url": "https://audio2.brain.fm/TimeShifts_Focus_Learning_Atmospheric_30_116BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TimeShifts_Focus_Learning_Atmospheric_30_116BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TimeShifts_Focus_Learning_Atmospheric_30_116BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/TimeShifts_Focus_Learning_Atmospheric_30_116BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25432309,
      "sha256": "4b4e03a2e4c6e1d1761ecef331c8f9aa6bbde00ae041cb66f4507ceafcebb7f3",
      "download_error": null
    },
    {
      "track_id": "6716a116ae8c98e954dc57cb",
      "name": "Fleeting",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.45,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Fleeting_Focus_Creativity_Atmospheric_30_94BPM_MidNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=EqBlglvA%2BdWvgWEW3jEXXcCOrNRP4Gbdu67KReNMekc%3D",
      "cdn_url": "https://audio2.brain.fm/Fleeting_Focus_Creativity_Atmospheric_30_94BPM_MidNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fleeting_Focus_Creativity_Atmospheric_30_94BPM_MidNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fleeting_Focus_Creativity_Atmospheric_30_94BPM_MidNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Fleeting_Focus_Creativity_Atmospheric_30_94BPM_MidNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25129194,
      "sha256": "e4016e9d539ef46a9c1da8aa1c1415eaa062c4afb984d721738be51e747b5f03",
      "download_error": null
    },
    {
      "track_id": "6703e2b1a1f0c0804124fb97",
      "name": "Deep Beneath the Earth",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.42,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/DeepBeneathTheEarth_Focus_DeepWork_Atmospheric_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=%2BGF4vO85htnY5t5Jfu1HIdWcf10H0RkB%2B9ZyE%2FbYMYQ%3D",
      "cdn_url": "https://audio2.brain.fm/DeepBeneathTheEarth_Focus_DeepWork_Atmospheric_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DeepBeneathTheEarth_Focus_DeepWork_Atmospheric_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DeepBeneathTheEarth_Focus_DeepWork_Atmospheric_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/DeepBeneathTheEarth_Focus_DeepWork_Atmospheric_30_98BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26176199,
      "sha256": "8d9d22edb5703509b0b3a0c737059e41662b0ab9df606b511d9928e293416cb6",
      "download_error": null
    },
    {
      "track_id": "6703e1fea1f0c0804124fa27",
      "name": "Northern Lights",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.57,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/NorthernLights_Focus_Creativity_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=R94ZllPdNR81FgiUSqS1YrNO0Viy1rMxAV%2F8AFgu05Y%3D",
      "cdn_url": "https://audio2.brain.fm/NorthernLights_Focus_Creativity_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NorthernLights_Focus_Creativity_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NorthernLights_Focus_Creativity_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/NorthernLights_Focus_Creativity_Atmospheric_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22982620,
      "sha256": "5a22513d5e686f6d1bf323572fc6fcaf09b31c6aa663eb6dee8d5b76e3c38388",
      "download_error": null
    },
    {
      "track_id": "6703e1f3a1f0c0804124f9f8",
      "name": "Dreaming",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 146,
      "brightness_level": 0.52,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Dreaming_Focus_Creativity_Atmospheric_30_146BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=k1EQGCOZ0iNb0W8%2F2ArZsBNIfE2GVY9wmKfUgyXDwDU%3D",
      "cdn_url": "https://audio2.brain.fm/Dreaming_Focus_Creativity_Atmospheric_30_146BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dreaming_Focus_Creativity_Atmospheric_30_146BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dreaming_Focus_Creativity_Atmospheric_30_146BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Dreaming_Focus_Creativity_Atmospheric_30_146BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28596099,
      "sha256": "231a33175f253f4b69ad9d165dee0dbaa88c3ede85e35885f3fa92ed2e2ecd9e",
      "download_error": null
    },
    {
      "track_id": "66f178fad7073bdb17919b28",
      "name": "Vastness",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.27,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Vastness_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=YKJraZnzOV2k2AfXE5b5kUWfi8jmMSWCaFpT%2FzKDx20%3D",
      "cdn_url": "https://audio2.brain.fm/Vastness_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Vastness_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Vastness_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Vastness_Focus_Learning_Atmospheric_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23691566,
      "sha256": "dafd731e2a7effaadc480b0009700b46b85c36aa78196e20c8605fd683040f89",
      "download_error": null
    },
    {
      "track_id": "66f17586d7073bdb179192d1",
      "name": "Creation",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.53,
      "complexity_level": 0.55,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Creation_Focus_Creativity_Electronic_30_96BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=urfJVjkFsNGBjXkXKlS4D0qaw3kqfvndmQGk0%2F%2FB%2Bl4%3D",
      "cdn_url": "https://audio2.brain.fm/Creation_Focus_Creativity_Electronic_30_96BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Creation_Focus_Creativity_Electronic_30_96BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Creation_Focus_Creativity_Electronic_30_96BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Creation_Focus_Creativity_Electronic_30_96BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25383698,
      "sha256": "1530d55028e729ed496110e01481ccf4931bf5ab99e4668f34abbf66468613e2",
      "download_error": null
    },
    {
      "track_id": "66f173b2d7073bdb17918f2b",
      "name": "All Encompassing",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.3,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/All%20Encompassing_Focus_DeepWork_Atmospheric_30_116BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=IBGCjZqTxg6bga0ogbJOIAYbLMGwDjKn4DVxICxtKEA%3D",
      "cdn_url": "https://audio2.brain.fm/All%20Encompassing_Focus_DeepWork_Atmospheric_30_116BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "All Encompassing_Focus_DeepWork_Atmospheric_30_116BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "filename": "All-Encompassing_Focus_DeepWork_Atmospheric_30_116BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/All-Encompassing_Focus_DeepWork_Atmospheric_30_116BPM_Nrmlzd2_MidNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24484108,
      "sha256": "f5ed3750d34b5cfb6d7881defa23de387e2d25cc57cfe12cce563620785de104",
      "download_error": null
    },
    {
      "track_id": "66df021eedad688793836d37",
      "name": "Seventh Heaven",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.5,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/SeventhHeaven_Focus_Learning_Atmospheric_30_92BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=14kiOzDjVXfPR%2Fa%2F3mD0PCzolbJ9jr5c0btm1G%2FoHxI%3D",
      "cdn_url": "https://audio2.brain.fm/SeventhHeaven_Focus_Learning_Atmospheric_30_92BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SeventhHeaven_Focus_Learning_Atmospheric_30_92BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SeventhHeaven_Focus_Learning_Atmospheric_30_92BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/SeventhHeaven_Focus_Learning_Atmospheric_30_92BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28434112,
      "sha256": "20a7e4307ced72ff1e73f9766cb86eddead5ce5e5bdd039f08aa10eb77f3d94d",
      "download_error": null
    },
    {
      "track_id": "66df0161edad688793836aa2",
      "name": "Cosmic Dust",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.68,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/DarkMatter_Focus_DeepWork_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=kZ0o02vK6WWE2BlbPKBZg1getE1FIZrebWcpjDD45Yc%3D",
      "cdn_url": "https://audio2.brain.fm/DarkMatter_Focus_DeepWork_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DarkMatter_Focus_DeepWork_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DarkMatter_Focus_DeepWork_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/DarkMatter_Focus_DeepWork_Atmospheric_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26426889,
      "sha256": "0a2008854487172a519a08f7b13bd16f2789bdea7ae3f5c049f4bb4e68b49dfd",
      "download_error": null
    },
    {
      "track_id": "66cc94b547ed87e8383b7660",
      "name": "Melt",
      "category": "Atmospheric",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 139,
      "brightness_level": 0.48,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/atmospheric.json",
      "source_url": "https://audio2.brain.fm/Melt_Focus_Learning_Atmospheric_30_139BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292122464&token=0Gy4YewKfXwOpn6EMXBCweE362WaqYr4DrXPw%2B1EIdY%3D",
      "cdn_url": "https://audio2.brain.fm/Melt_Focus_Learning_Atmospheric_30_139BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Melt_Focus_Learning_Atmospheric_30_139BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Melt_Focus_Learning_Atmospheric_30_139BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/atmospheric/Melt_Focus_Learning_Atmospheric_30_139BPM_Nrmlzd2_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25263519,
      "sha256": "266b90274a62834a14541c90201e8cb6de647b5c222b57d12d6a2161407f5824",
      "download_error": null
    },
    {
      "track_id": "6a30184b7a8f5056573c9883",
      "name": "Cliffside Views",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.39,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/CliffsideViews_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=rXGmUCkt3QPqEqVFTgap7K%2FDpuYk7tnBf0LBO62qPU8%3D",
      "cdn_url": "https://audio2.brain.fm/CliffsideViews_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CliffsideViews_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CliffsideViews_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/CliffsideViews_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26507563,
      "sha256": "c2534d63dcaad1c6e4e62843037f1bb8a66fd836a6525ab1297c12947f920def",
      "download_error": null
    },
    {
      "track_id": "6a0b8ba7e6017bccd74b8191",
      "name": "Ruins of Atlantis",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.46,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/RuinsofAtlantis_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=oiKpkq3dnqIWxoyUindrLI7tqXI2cUguys0bLvQCdPM%3D",
      "cdn_url": "https://audio2.brain.fm/RuinsofAtlantis_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RuinsofAtlantis_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RuinsofAtlantis_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/RuinsofAtlantis_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28832813,
      "sha256": "618de2c83a6f0f2355024375d8955b3ea7b5a6697a1f7ccff45aa45a34cbd9ac",
      "download_error": null
    },
    {
      "track_id": "698a162e8a4a8f35be584084",
      "name": "Coastal Stillness",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.2,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/CoastalStillness_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=kqm5OyeUR1bqgsOmvxvQDdhJJTgU2eG%2FaWGJvdPcL2Q%3D",
      "cdn_url": "https://audio2.brain.fm/CoastalStillness_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CoastalStillness_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CoastalStillness_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/CoastalStillness_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28232778,
      "sha256": "52e0c3b8ef2e97848e45ab20dd779b63121a15ec5fc3aebf017a6189e2a67a0d",
      "download_error": null
    },
    {
      "track_id": "6952f3f3b1c39edafb0decdc",
      "name": "Sunlit Tide",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.16,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/SunlitTide_Focus_DeepWork_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=V1WISPnQB6yECS6VQFWuV0RaT4BIC2JEIIEbXMY08RY%3D",
      "cdn_url": "https://audio2.brain.fm/SunlitTide_Focus_DeepWork_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SunlitTide_Focus_DeepWork_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SunlitTide_Focus_DeepWork_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/SunlitTide_Focus_DeepWork_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27868100,
      "sha256": "81614ec4d90e5630c56558f857e7b1e15b216feed78a6ff895fe57fe4e9d6d95",
      "download_error": null
    },
    {
      "track_id": "69405a9976a1c1f80ff93e38",
      "name": "Drift Current",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/DriftCurrent_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=9LvMQOHUWpONvIiCRR7tIn2C8ZEWkezIdVS3lw69esE%3D",
      "cdn_url": "https://audio2.brain.fm/DriftCurrent_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DriftCurrent_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DriftCurrent_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/DriftCurrent_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27826767,
      "sha256": "ecf4eb7d555d1b128c0c14ac4ddbc30c971f489c1b3f5286934dbb997eb37729",
      "download_error": null
    },
    {
      "track_id": "64302de123c3be44ab3fc0e1",
      "name": "Waves of Rapture",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.99,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/WavesofRapture_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=A63XrjL1NxG0xoWZ%2B4UGog0HVYh9lRKRzBFDwotPOzI%3D",
      "cdn_url": "https://audio2.brain.fm/WavesofRapture_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WavesofRapture_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WavesofRapture_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/WavesofRapture_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27779969,
      "sha256": "c157d7db6311d92234e092c8e6393f142da2f0d869ed8dff417a47be51029fb8",
      "download_error": null
    },
    {
      "track_id": "64302dd223c3befb153fc08f",
      "name": "Waves of Healing",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 1,
      "complexity_level": 0.46,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/WavesofHealing_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=BpINT8F7uthcDhuv32x1nTTycoOLWWuKCv7ZGqdhm4M%3D",
      "cdn_url": "https://audio2.brain.fm/WavesofHealing_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WavesofHealing_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WavesofHealing_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/WavesofHealing_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27731620,
      "sha256": "415e6b32023819906f813b601b0e691da284847a8541d6362ad8aca26eb77594",
      "download_error": null
    },
    {
      "track_id": "64302d3e5ee24c948fa06e85",
      "name": "Sparkling Waters",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.76,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/SparklingWaters_Focus_Learning_Beach_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=SaXps7RIQJHH%2BEUWVtsTRNWhixKGg7G2mTXHzVEAohg%3D",
      "cdn_url": "https://audio2.brain.fm/SparklingWaters_Focus_Learning_Beach_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SparklingWaters_Focus_Learning_Beach_30_120bpm_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "SparklingWaters_Focus_Learning_Beach_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/SparklingWaters_Focus_Learning_Beach_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26712511,
      "sha256": "26a99a1bc7188526457980f696a345512d43dadb3f5a335c72f42c0669d137fd",
      "download_error": null
    },
    {
      "track_id": "64302c925ee24c4730a06b3b",
      "name": "Pacific Dream",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.95,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.21,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/PacificDream_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=QrWg5kBdCLTIcU2GOyjeT8nsQ5PNsjaWHunGA9yiKAI%3D",
      "cdn_url": "https://audio2.brain.fm/PacificDream_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PacificDream_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PacificDream_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/PacificDream_Focus_DeepWork_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28163099,
      "sha256": "0cde31b743706db9d4c51def12e371d4b74cf8c42ef108d08203e3db677dc7ca",
      "download_error": null
    },
    {
      "track_id": "64302c865ee24c48eca06b0f",
      "name": "Ocean Focus",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.93,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/OceanFocus_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=BPJ1AAkFjg5h8r2LYBaDppeszyf%2B3mwx3Xj%2BVo0GEvE%3D",
      "cdn_url": "https://audio2.brain.fm/OceanFocus_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OceanFocus_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OceanFocus_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/OceanFocus_Focus_DeepWork_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27367264,
      "sha256": "e16b197f0e175569294fc68f41d51d614486f87279eb61340d445d733a3d26c4",
      "download_error": null
    },
    {
      "track_id": "64302b8823c3be9e553fb311",
      "name": "Majestic Tide",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.99,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/MajesticTide_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=k0aoMVYqcj2%2F2eMDV7m4VC%2BjccLpeSaCdS%2BH%2FVRfINc%3D",
      "cdn_url": "https://audio2.brain.fm/MajesticTide_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MajesticTide_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MajesticTide_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/MajesticTide_Focus_Creativity_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28208834,
      "sha256": "aff5b2f5af562d3d3ba08e52a5eb5ec5779bd12d043d79b4ce58b1c5469e89e5",
      "download_error": null
    },
    {
      "track_id": "64302a4e5ee24cb895a05957",
      "name": "Edenic Shores",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.99,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/EdenicShores_Focus_Creativity_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=o4Hh7TnPVS1cUu2sGs%2BKRBjwTU8Ck3%2FAc0pW3RDDu%2FE%3D",
      "cdn_url": "https://audio2.brain.fm/EdenicShores_Focus_Creativity_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EdenicShores_Focus_Creativity_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EdenicShores_Focus_Creativity_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/EdenicShores_Focus_Creativity_Beach_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27453258,
      "sha256": "f25d10afdf823a26ae77ab7296cfdd5d4ee56d0c5f23974cb2f83fa066a4040d",
      "download_error": null
    },
    {
      "track_id": "64302a225ee24c68dca0588c",
      "name": "Currents and Waves",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.83,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/CurrentsandWaves_Focus_Creativity_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=kPWgc9pu849P%2FKvQWMkqu3ZB8cg8TbFbBKmw8%2FfUUBQ%3D",
      "cdn_url": "https://audio2.brain.fm/CurrentsandWaves_Focus_Creativity_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CurrentsandWaves_Focus_Creativity_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CurrentsandWaves_Focus_Creativity_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/CurrentsandWaves_Focus_Creativity_Beach_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28070229,
      "sha256": "0d5b1e36039e9443384926e493a9e2831681f8372bab96bbd457f3da993bc51d",
      "download_error": null
    },
    {
      "track_id": "6430288823c3be4fc83fa59d",
      "name": "Aegean Sunset",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.78,
      "complexity_level": 0.64,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/AegeanSunset_Focus_Learning_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=KJLRtljle2FEhf8%2Ffupy7DYDEWznbIersoImJh%2BzAak%3D",
      "cdn_url": "https://audio2.brain.fm/AegeanSunset_Focus_Learning_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AegeanSunset_Focus_Learning_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AegeanSunset_Focus_Learning_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/AegeanSunset_Focus_Learning_Beach_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27336781,
      "sha256": "1a7bd6615db2eaf785db7e0cb74284429cfc5f92d272a3e7c93149c170715ffe",
      "download_error": null
    },
    {
      "track_id": "62b38a175924116cf9f53ea2",
      "name": "Broad Palms",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.73,
      "complexity_level": 0.67,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Beach%20Focus%201%20Conor_1.4_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=Z%2FXOjXxvX8h2036feXYMsHgUaMYaZ8yK%2Fk%2BIwO%2BkYb4%3D",
      "cdn_url": "https://audio2.brain.fm/Beach%20Focus%201%20Conor_1.4_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Beach Focus 1 Conor_1.4_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Beach-Focus-1-Conor_1.4_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Beach-Focus-1-Conor_1.4_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24100385,
      "sha256": "2f83aa01bba7f0cecd6ed641e6109064e7dad4eb2288226a4575ebf327dc57b4",
      "download_error": null
    },
    {
      "track_id": "62b38a165924110c18f53e85",
      "name": "Ocean Sails",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/BeachTemplate_FOCUS%203ac_1.0-KeepVol_VBR5.mp3?expiration=1792292104781&token=3EEfVcWCJO%2Biw3Bdqvt0072H9zFLr9lfG5%2FZZ2AXTWw%3D",
      "cdn_url": "https://audio2.brain.fm/BeachTemplate_FOCUS%203ac_1.0-KeepVol_VBR5.mp3",
      "remote_filename": "BeachTemplate_FOCUS 3ac_1.0-KeepVol_VBR5.mp3",
      "filename": "BeachTemplate_FOCUS-3ac_1.0-KeepVol_VBR5.mp3",
      "relative_path": "outputs/audio/beach/BeachTemplate_FOCUS-3ac_1.0-KeepVol_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30923174,
      "sha256": "290311161de4ef3764c8bd4175db756ac7d52b6e00085e698101e45900e589e7",
      "download_error": null
    },
    {
      "track_id": "62b389cd5924116705f536cb",
      "name": "Wave Crescendo",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.66,
      "complexity_level": 0.67,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Wave%20Crescendo%20Beach%20Focus%204%20Conor_1.4_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=OfgnlqAC%2BM4TX23MVMnjIqJFQuf9OlX50w%2FhxKeG9QU%3D",
      "cdn_url": "https://audio2.brain.fm/Wave%20Crescendo%20Beach%20Focus%204%20Conor_1.4_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Wave Crescendo Beach Focus 4 Conor_1.4_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Wave-Crescendo-Beach-Focus-4-Conor_1.4_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Wave-Crescendo-Beach-Focus-4-Conor_1.4_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26281386,
      "sha256": "bb63ffac00091f83706dc97a6d9343e0198e3f0916f73a83e8ca8bdfe5cf31fa",
      "download_error": null
    },
    {
      "track_id": "62b3896659241151a3f5362e",
      "name": "Oceanside Concentration",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.49,
      "complexity_level": 0.85,
      "style": "normal",
      "neural_effect_level": 0.49,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Oceanside%20Concentration%20Beach%20Focus%203%20Conor_1.2_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=oI%2FCNal%2BqIyBGQYl3ibx%2FSfGz8Yn1bXeg1qV2WdP25k%3D",
      "cdn_url": "https://audio2.brain.fm/Oceanside%20Concentration%20Beach%20Focus%203%20Conor_1.2_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Oceanside Concentration Beach Focus 3 Conor_1.2_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Oceanside-Concentration-Beach-Focus-3-Conor_1.2_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Oceanside-Concentration-Beach-Focus-3-Conor_1.2_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25172184,
      "sha256": "f1e19ad95815562ed01e03122d5ce03a9fd004f7ebfee9ee3b4b4be7642ae597",
      "download_error": null
    },
    {
      "track_id": "62b3894f592411108af53331",
      "name": "Sand & Sun",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.88,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Sand%20%26%20Sun%20Beach%204%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292104781&token=A8wwRNS5SQHc1CIV00AzWP5VXuBE5JkKBu%2FQ6RpyTIw%3D",
      "cdn_url": "https://audio2.brain.fm/Sand%20%26%20Sun%20Beach%204%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Sand & Sun Beach 4 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Sand-Sun-Beach-4-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Sand-Sun-Beach-4-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25081259,
      "sha256": "ee59db8671b0993fdef85fefde29db277f5b1fe4256cd01abca41497d1f6c4e1",
      "download_error": null
    },
    {
      "track_id": "62b388a45924118149f52570",
      "name": "White Sand",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.66,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.64,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Beach%20Focus%202%20Conor_1.4_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=LLKO2fdNAvcEkxemam8MEaWFfVA24BXDQo5e8RVEru4%3D",
      "cdn_url": "https://audio2.brain.fm/Beach%20Focus%202%20Conor_1.4_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Beach Focus 2 Conor_1.4_Nrmlzd2_VBR5.mp3",
      "filename": "Beach-Focus-2-Conor_1.4_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Beach-Focus-2-Conor_1.4_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24721590,
      "sha256": "66c88f171d8b4c719cecfb95cd84741c74d540dbd06df06b3f93fe210b7beff5",
      "download_error": null
    },
    {
      "track_id": "62b3876b592411a992f518f4",
      "name": "Sunset Skies",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.86,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Sunset%20Skies%20Beach%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292104781&token=Jr40H86oSdUcf9D4sqYzeTUyxhEwe7BP%2Bl%2FFJ0BGMV8%3D",
      "cdn_url": "https://audio2.brain.fm/Sunset%20Skies%20Beach%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Sunset Skies Beach 5 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Sunset-Skies-Beach-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Sunset-Skies-Beach-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25008467,
      "sha256": "3daf3e1ff326e264311033d6f4ab132b04fe751837b32dc277ea5ddfc8485ec1",
      "download_error": null
    },
    {
      "track_id": "62b38416592411411af4fd5d",
      "name": "Quiet Waves",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Quiet%20Waves%20Beach%201%20focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292104781&token=oGToqGw%2BlMU55QDhEWxYjP%2FBEkV2YqsIwlFySAKzAQc%3D",
      "cdn_url": "https://audio2.brain.fm/Quiet%20Waves%20Beach%201%20focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Quiet Waves Beach 1 focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Quiet-Waves-Beach-1-focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Quiet-Waves-Beach-1-focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21077796,
      "sha256": "9107cccb067b592320a59a4d1e07d742a18db6269ac4be5e0b577a0be324f9ba",
      "download_error": null
    },
    {
      "track_id": "62b380f459241126a8f4da3e",
      "name": "Foaming Seas",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.74,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Foaming%20Seas%20Beach%20Focus%20Conor%20MED%20NEL%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=QbPWx5G0IxZL%2BnyZoqLHKveze9QaZGttJHrUxQ%2FjG%2B0%3D",
      "cdn_url": "https://audio2.brain.fm/Foaming%20Seas%20Beach%20Focus%20Conor%20MED%20NEL%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Foaming Seas Beach Focus Conor MED NEL 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Foaming-Seas-Beach-Focus-Conor-MED-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Foaming-Seas-Beach-Focus-Conor-MED-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27734078,
      "sha256": "16d528c37ae1517c42b94f6afcdbcd9bafb0d6cacdc51ac2e8ab5a402e63eb51",
      "download_error": null
    },
    {
      "track_id": "62b380eb592411279bf4d798",
      "name": "Bay View",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.77,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.21,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/BeachTemplate_FOCUS1.1a-Normlzd-30min_VBR5.mp3?expiration=1792292104781&token=ZXXmvjQ0CRDPiNtoL50r5AFL7zvN%2BW0dVn1W8JPnJFg%3D",
      "cdn_url": "https://audio2.brain.fm/BeachTemplate_FOCUS1.1a-Normlzd-30min_VBR5.mp3",
      "remote_filename": "BeachTemplate_FOCUS1.1a-Normlzd-30min_VBR5.mp3",
      "filename": "BeachTemplate_FOCUS1.1a-Normlzd-30min_VBR5.mp3",
      "relative_path": "outputs/audio/beach/BeachTemplate_FOCUS1.1a-Normlzd-30min_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31395992,
      "sha256": "999f6558a864045afbccc9760bdc2f050302b131da293f3ff927437f35878fd0",
      "download_error": null
    },
    {
      "track_id": "62b380855924113014f4cd63",
      "name": "Sea Mist",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Sea%20Mist%20Beach%202%20focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292104781&token=CDSQ%2FI6hlXsN1OkxDtNvUFWPa3XYGDlsg14LXb2%2Fsd0%3D",
      "cdn_url": "https://audio2.brain.fm/Sea%20Mist%20Beach%202%20focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Sea Mist Beach 2 focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Sea-Mist-Beach-2-focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Sea-Mist-Beach-2-focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21141518,
      "sha256": "986df6e954262ec3afade620c5a18b00da13b8c2675db13aaaf316e8da50976a",
      "download_error": null
    },
    {
      "track_id": "62b3806e592411e859f4c8b3",
      "name": "Bubbling Surf",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.51,
      "complexity_level": 0.75,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Bubbling%20Surf%20Beach%20Focus%205%20Conor_1.7_MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=%2FTL2UArpgXB93fQrUQR8ZEqLmW2XQFtDfD2JR%2BbNhnU%3D",
      "cdn_url": "https://audio2.brain.fm/Bubbling%20Surf%20Beach%20Focus%205%20Conor_1.7_MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bubbling Surf Beach Focus 5 Conor_1.7_MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Bubbling-Surf-Beach-Focus-5-Conor_1.7_MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Bubbling-Surf-Beach-Focus-5-Conor_1.7_MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26101022,
      "sha256": "4ac3a43c7f78cfb1f0eb1ea86909acbf425f51fb33557d4efb5b81c4deac08b2",
      "download_error": null
    },
    {
      "track_id": "62b380625924119b50f4c111",
      "name": "Bright Waves",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.75,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/BeachTemplate_FOCUS%202.2ac-Nrmlzd_VBR5.mp3?expiration=1792292104781&token=MXwgePqrKruGN3B2RU%2FLiEJGD1qU2vM62QPVfO6KYgw%3D",
      "cdn_url": "https://audio2.brain.fm/BeachTemplate_FOCUS%202.2ac-Nrmlzd_VBR5.mp3",
      "remote_filename": "BeachTemplate_FOCUS 2.2ac-Nrmlzd_VBR5.mp3",
      "filename": "BeachTemplate_FOCUS-2.2ac-Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/beach/BeachTemplate_FOCUS-2.2ac-Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29330236,
      "sha256": "50d8a35adfc1236b19529258cc9a127095e8f9e7916cc6b8f9e623b7b0d78400",
      "download_error": null
    },
    {
      "track_id": "62b3803e592411021df4b673",
      "name": "White Sands",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/White%20Sands%20Beach%203%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292104781&token=MTDOuiPJh84e3zL8dko8HcN3%2Be505gT5eCW59iLpIdk%3D",
      "cdn_url": "https://audio2.brain.fm/White%20Sands%20Beach%203%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "White Sands Beach 3 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "White-Sands-Beach-3-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/beach/White-Sands-Beach-3-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25115063,
      "sha256": "e9540d1cfc08ce2a113f1860ad300e8acfe86271c14df88ffc8abe97a8487bb8",
      "download_error": null
    },
    {
      "track_id": "62b3803a5924114c3ef4b26a",
      "name": "Sailing Voyage",
      "category": "Beach",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.86,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/beach.json",
      "source_url": "https://audio2.brain.fm/Sailing%20Voyage%20Nature%20Focus%20Beach%20Deep%20Work%20Conor%20HIGH%20NEL%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292104781&token=XFHn5JkEQcQYFmgpTIkNFlSebBwV98Cbr%2Ff%2FYBsz9bg%3D",
      "cdn_url": "https://audio2.brain.fm/Sailing%20Voyage%20Nature%20Focus%20Beach%20Deep%20Work%20Conor%20HIGH%20NEL%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sailing Voyage Nature Focus Beach Deep Work Conor HIGH NEL 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Sailing-Voyage-Nature-Focus-Beach-Deep-Work-Conor-HIGH-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/beach/Sailing-Voyage-Nature-Focus-Beach-Deep-Work-Conor-HIGH-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28672954,
      "sha256": "382c16a7b48e78eb9de3a4123fa18d09463f12753be642ee554eb738dec22214",
      "download_error": null
    },
    {
      "track_id": "633d92e7840cdf12535783ed",
      "name": "Starfield",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.01,
      "complexity_level": 0.89,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Starfield_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=8fbbw6NK4Prg0i98%2F6zuhkNX0IFEdHpQQ9T0bmEAATE%3D",
      "cdn_url": "https://audio2.brain.fm/Starfield_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Starfield_Focus_Learning_Chimes&Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Starfield_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Starfield_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23206481,
      "sha256": "07f841c1099484d5457c1cf3f2f473a8f87f24920b99449e3ca92a470fd5d08c",
      "download_error": null
    },
    {
      "track_id": "633d92b983f4ff15a9a2b255",
      "name": "Height and Depth",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.03,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/HeightandDepth_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=Be4aWSpArVOVsPREtfthva7FrPhuXFQkH3ueQRLhuq8%3D",
      "cdn_url": "https://audio2.brain.fm/HeightandDepth_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HeightandDepth_Focus_Learning_Chimes&Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "HeightandDepth_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/HeightandDepth_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23816059,
      "sha256": "613142b063d7ea531c02e24a6f9068ec096a0d7f5a9d9514ad8e82f9c70a6ed9",
      "download_error": null
    },
    {
      "track_id": "633d928b840cdf2c7e57823e",
      "name": "Gentle Bells",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.12,
      "complexity_level": 0.33,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/GentleBells_Focus_Learning_Chimes%26Bowls_30_120bpm_Nmrlzd2_VBR5.mp3?expiration=1792292106435&token=tX9fGKNzQnH8aEoNvCEIleD1%2B2s5rtvpL9MQdnv3Xck%3D",
      "cdn_url": "https://audio2.brain.fm/GentleBells_Focus_Learning_Chimes%26Bowls_30_120bpm_Nmrlzd2_VBR5.mp3",
      "remote_filename": "GentleBells_Focus_Learning_Chimes&Bowls_30_120bpm_Nmrlzd2_VBR5.mp3",
      "filename": "GentleBells_Focus_Learning_Chimes-Bowls_30_120bpm_Nmrlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/GentleBells_Focus_Learning_Chimes-Bowls_30_120bpm_Nmrlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23549272,
      "sha256": "2594ffc0756a2413d9cdbe69dd1d1205b4193e35486404335ee117d9d13c9fed",
      "download_error": null
    },
    {
      "track_id": "633d9256840cdf962857812e",
      "name": "Ariadne",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.04,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Ariadne_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=4E9k4hnhA9%2Fv8Y4sUWgIqdlejzSFrSWCQw3dmyVCj4w%3D",
      "cdn_url": "https://audio2.brain.fm/Ariadne_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Ariadne_Focus_Learning_Chimes&Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Ariadne_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Ariadne_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23569269,
      "sha256": "94c6c3749241e9e84b2a291c1b25432859240f562eca7ccb792897589690fc10",
      "download_error": null
    },
    {
      "track_id": "633d921d83f4ff7327a2ad2a",
      "name": "Aetheric Bliss",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.02,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/AethericBliss_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=nWvU5VBN4YosC4EaRBgq%2BxIqjVfoFd%2BbHRnJqZl%2BWR4%3D",
      "cdn_url": "https://audio2.brain.fm/AethericBliss_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AethericBliss_Focus_Learning_Chimes&Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "AethericBliss_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/AethericBliss_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22884484,
      "sha256": "70933ef396e389091dc811449378a0f5b5e1731551c54a6c76e9bc43c5c5730f",
      "download_error": null
    },
    {
      "track_id": "633d91ec83f4ff39d9a2acbb",
      "name": "Absorption",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.42,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Absorption_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=K6JLRMtbaNq7lYcHbnQ8hS2edPrMhS4gS8Tbaw%2FJp30%3D",
      "cdn_url": "https://audio2.brain.fm/Absorption_Focus_Learning_Chimes%26Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Absorption_Focus_Learning_Chimes&Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Absorption_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Absorption_Focus_Learning_Chimes-Bowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24340180,
      "sha256": "8f809f8500ef49c65743b2f8e220bbec5f5f7e0083ac2e171f8dd54d9572ff89",
      "download_error": null
    },
    {
      "track_id": "633d9126840cdfb842577c60",
      "name": "Temple Edge",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.58,
      "complexity_level": 0.91,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Temple%20Edge_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=6OHgN5GRCRNRLfFMknA8%2BWsM8tTtCgdtJeMxsg3P%2BbM%3D",
      "cdn_url": "https://audio2.brain.fm/Temple%20Edge_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Temple Edge_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Temple-Edge_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Temple-Edge_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25896977,
      "sha256": "268afa8b73a2a1ce606a75cd768ed2f2f723d8ff6a527007347076a8c73b99a9",
      "download_error": null
    },
    {
      "track_id": "633d90f183f4ff6205a2a6ee",
      "name": "Sacred Deer",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.49,
      "complexity_level": 0.6,
      "style": "normal",
      "neural_effect_level": 0.64,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Sacred%20Deer_Focus_Creativity_ChimesandBowls_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=xB%2Bn0LPSuCv5wi2tY%2BxEwpW2pCS%2FaBsfWOSbUFd7Pvw%3D",
      "cdn_url": "https://audio2.brain.fm/Sacred%20Deer_Focus_Creativity_ChimesandBowls_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sacred Deer_Focus_Creativity_ChimesandBowls_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sacred-Deer_Focus_Creativity_ChimesandBowls_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Sacred-Deer_Focus_Creativity_ChimesandBowls_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25802930,
      "sha256": "3b19d839227fa9e3f3f9baf53661160e708f2deee9a8c8b31f869bc5a822a6f4",
      "download_error": null
    },
    {
      "track_id": "633d90bf83f4ff9028a2a691",
      "name": "New Awakening",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.57,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/New%20Awakening_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=euDM%2BiANDcPJBKcNASBBjCUpR5E6e1ptMceT1FIJpFo%3D",
      "cdn_url": "https://audio2.brain.fm/New%20Awakening_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "New Awakening_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "New-Awakening_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/New-Awakening_Focus_Creativity_ChimesandBowls_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27090911,
      "sha256": "f7f9f2615ab171efc78852bbe28a978091ce56cf72c97964919d4fd1717f39be",
      "download_error": null
    },
    {
      "track_id": "633d908c840cdfd9ff5776c0",
      "name": "Mountaintop Monastery",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.37,
      "complexity_level": 0.72,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Mountaintop%20Monastery_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=VCKlMKGixbLPV53hAAretIqVPo8MUGFHbjHM7THlJac%3D",
      "cdn_url": "https://audio2.brain.fm/Mountaintop%20Monastery_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Mountaintop Monastery_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Mountaintop-Monastery_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Mountaintop-Monastery_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25594927,
      "sha256": "d3bb356332acee8e34becb982deef0bbb4702f24252ba14d4a7d2f605da61f3d",
      "download_error": null
    },
    {
      "track_id": "633d9052840cdf654e577472",
      "name": "Haiga",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.31,
      "complexity_level": 0.46,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Haiga_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=rf%2FVaYk%2BCObmsEhAshKkC0z%2FzZdXJ%2BUu4VyzlCmf4Fg%3D",
      "cdn_url": "https://audio2.brain.fm/Haiga_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Haiga_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Haiga_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Haiga_Focus_Creativity_ChimesandBowls_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25569274,
      "sha256": "00f9276a58dbe25e1b8d787cf28538fdb62012cc65d358bea6d966b713cfb63c",
      "download_error": null
    },
    {
      "track_id": "62b38a3059241107e8f5419c",
      "name": "Super Alloy",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.25,
      "complexity_level": 0.67,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Super%20Alloy%20Bowls%20Focus%203%20Conor_1.4_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=tmzDWqYtdLozKqnjgfn%2FTh%2B1OXze51wpJ1oAfhrCr00%3D",
      "cdn_url": "https://audio2.brain.fm/Super%20Alloy%20Bowls%20Focus%203%20Conor_1.4_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Super Alloy Bowls Focus 3 Conor_1.4_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Super-Alloy-Bowls-Focus-3-Conor_1.4_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Super-Alloy-Bowls-Focus-3-Conor_1.4_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19290364,
      "sha256": "00a2dbb55eed33dc24642911bea266dda30a1231de3bdb89ad718d8ad6610bf1",
      "download_error": null
    },
    {
      "track_id": "62b38a145924116343f53e49",
      "name": "Opal",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.52,
      "style": "normal",
      "neural_effect_level": 0.89,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Opal%20Bowls%20Focus%205%20Conor_1.4_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=IrJyuhPUNWq0wZqKYjUTGbyq4Ldn%2Fei8%2Bj%2BUUcyGzgc%3D",
      "cdn_url": "https://audio2.brain.fm/Opal%20Bowls%20Focus%205%20Conor_1.4_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Opal Bowls Focus 5 Conor_1.4_Nrmlzd2_VBR5.mp3",
      "filename": "Opal-Bowls-Focus-5-Conor_1.4_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Opal-Bowls-Focus-5-Conor_1.4_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20006134,
      "sha256": "2c0572dc6f1adaed4fd993758075e122d7244857c886b741f3f1d1368993abf8",
      "download_error": null
    },
    {
      "track_id": "62b389d15924117341f53770",
      "name": "Eternity Ringing",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.18,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Eternity%20Ringing%20Bowls%20Focus%201%20Conor_1.2_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=6OtTB5fGfqom8SZRzGU0PXXCmn7EcxPkZ9nIK26jmSQ%3D",
      "cdn_url": "https://audio2.brain.fm/Eternity%20Ringing%20Bowls%20Focus%201%20Conor_1.2_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Eternity Ringing Bowls Focus 1 Conor_1.2_Nrmlzd2_VBR5.mp3",
      "filename": "Eternity-Ringing-Bowls-Focus-1-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Eternity-Ringing-Bowls-Focus-1-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19016401,
      "sha256": "c1bf331da7172c5687f71929ab58149d6813e808da8c954b31297a28cb9ae079",
      "download_error": null
    },
    {
      "track_id": "62b380705924113588f4c9b9",
      "name": "Chimes of Life",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.53,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Bowls_ForFOCUS_WithRolls_1-Nrmlzd_VBR5.mp3?expiration=1792292106435&token=C6RrJzInVKt4RcSoqQJoCRUibihv%2BPitQc%2Bgl38QDKU%3D",
      "cdn_url": "https://audio2.brain.fm/Bowls_ForFOCUS_WithRolls_1-Nrmlzd_VBR5.mp3",
      "remote_filename": "Bowls_ForFOCUS_WithRolls_1-Nrmlzd_VBR5.mp3",
      "filename": "Bowls_ForFOCUS_WithRolls_1-Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Bowls_ForFOCUS_WithRolls_1-Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24007745,
      "sha256": "7226fe44e8c78f5a368ab70f57b95defe247d8ae4c276ce68210232248f9ba4c",
      "download_error": null
    },
    {
      "track_id": "62b3806f59241121f9f4c93b",
      "name": "Sublime Bowls",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.4,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Bowls_ForFOCUS_1.4(diff%20than%201.5)-Nrmzld_VBR5.mp3?expiration=1792292106435&token=3UXonTU9u4nt7mNGv%2Bn4935MAgxgIGxGIimcjR5F9QA%3D",
      "cdn_url": "https://audio2.brain.fm/Bowls_ForFOCUS_1.4(diff%20than%201.5)-Nrmzld_VBR5.mp3",
      "remote_filename": "Bowls_ForFOCUS_1.4(diff than 1.5)-Nrmzld_VBR5.mp3",
      "filename": "Bowls_ForFOCUS_1.4-diff-than-1.5-Nrmzld_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Bowls_ForFOCUS_1.4-diff-than-1.5-Nrmzld_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21422950,
      "sha256": "86ff2254d6bdff7719ae95a007b463b08362c9f30ca652bb3bc1327053f20b30",
      "download_error": null
    },
    {
      "track_id": "62b38061592411df12f4c028",
      "name": "Expansion",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Expansion%20Bowls%20Focus%204%20Conor_1.5_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=0lYvxSGbqwVwbrjZPCxSbhKTbX08gPBDkjAV1uYmeQk%3D",
      "cdn_url": "https://audio2.brain.fm/Expansion%20Bowls%20Focus%204%20Conor_1.5_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Expansion Bowls Focus 4 Conor_1.5_Nrmlzd2_VBR5.mp3",
      "filename": "Expansion-Bowls-Focus-4-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Expansion-Bowls-Focus-4-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19602072,
      "sha256": "fc648a5210f333c2f39a1c150562c579bbfbff5baa444ae932e13a62e77f397f",
      "download_error": null
    },
    {
      "track_id": "62b3803d5924112d15f4b5a7",
      "name": "Crystalline Spirit",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.31,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Bowls_ForFOCUS_1.5ac_1-KeepVol_VBR5.mp3?expiration=1792292106435&token=tOkK%2BfMdZe67R3Vywy1zL0W0Q5NkyFaRkYJIiuVG9NI%3D",
      "cdn_url": "https://audio2.brain.fm/Bowls_ForFOCUS_1.5ac_1-KeepVol_VBR5.mp3",
      "remote_filename": "Bowls_ForFOCUS_1.5ac_1-KeepVol_VBR5.mp3",
      "filename": "Bowls_ForFOCUS_1.5ac_1-KeepVol_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Bowls_ForFOCUS_1.5ac_1-KeepVol_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20852313,
      "sha256": "9808959de9215a53b7e5c982270f4732e87ad5805d41ba49d7479897557a967a",
      "download_error": null
    },
    {
      "track_id": "62b3803b5924119887f4b46a",
      "name": "Precious Metals",
      "category": "Chimes & Bowls",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.62,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/chimes-and-bowls.json",
      "source_url": "https://audio2.brain.fm/Precious%20Metals%20Bowls%20Focus%202%20Conor_1.4_Nrmlzd2_VBR5.mp3?expiration=1792292106435&token=4sjBUL8iCV%2BJPH7FCCFIvxBHnb0M4iEOdc6%2F%2FUz64DU%3D",
      "cdn_url": "https://audio2.brain.fm/Precious%20Metals%20Bowls%20Focus%202%20Conor_1.4_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Precious Metals Bowls Focus 2 Conor_1.4_Nrmlzd2_VBR5.mp3",
      "filename": "Precious-Metals-Bowls-Focus-2-Conor_1.4_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/chimes-and-bowls/Precious-Metals-Bowls-Focus-2-Conor_1.4_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19355939,
      "sha256": "4d3086625cb0500b0299d36bba7db14327c5b0f66763413882d5a093b07ba380",
      "download_error": null
    },
    {
      "track_id": "6a4bb63e4518fc4e1e405de1",
      "name": "Goal Dependent",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 83,
      "brightness_level": 0.39,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/GoalDependent_Focus_Learning_Cinematic_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=36mlwaSor8ui3%2BaNA8nb5m9BYlx6ocJzbGGce%2FtGUm0%3D",
      "cdn_url": "https://audio2.brain.fm/GoalDependent_Focus_Learning_Cinematic_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GoalDependent_Focus_Learning_Cinematic_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GoalDependent_Focus_Learning_Cinematic_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/GoalDependent_Focus_Learning_Cinematic_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27613357,
      "sha256": "25e4834eb476f222dd5db39138b96139536a179b3d99f336c756bfd8d2af169b",
      "download_error": null
    },
    {
      "track_id": "6a42820978a0a113b2ff3f97",
      "name": "Unserious Words",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.42,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/UnseriousWords_Focus_DeepWork_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Y2BBvneA1ZvISdjhve7XFS5q3LxPl%2BNloIAxLXq%2FKWM%3D",
      "cdn_url": "https://audio2.brain.fm/UnseriousWords_Focus_DeepWork_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnseriousWords_Focus_DeepWork_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnseriousWords_Focus_DeepWork_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/UnseriousWords_Focus_DeepWork_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28772007,
      "sha256": "80436dfae7fa9ac6884d41771ff0e2e3a74512a224cbadc207a8383d79b3ff6f",
      "download_error": null
    },
    {
      "track_id": "6a3018197a8f5056573c968e",
      "name": "The Pattern Aligns",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 138,
      "brightness_level": 0.45,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ThePatternAligns_Focus_DeepWork_Cinematic_30_138BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=U8IO5TOiC1BWGhMw5Pz7wpGHW8MZoDJFRALSNu3ilOI%3D",
      "cdn_url": "https://audio2.brain.fm/ThePatternAligns_Focus_DeepWork_Cinematic_30_138BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThePatternAligns_Focus_DeepWork_Cinematic_30_138BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThePatternAligns_Focus_DeepWork_Cinematic_30_138BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ThePatternAligns_Focus_DeepWork_Cinematic_30_138BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27759477,
      "sha256": "7833c5b2aa94fa3b96a54221af0d8bbdc1be12a40bef45e9e8beee296b2d6359",
      "download_error": null
    },
    {
      "track_id": "6a30178f7a8f5056573c9180",
      "name": "Revontulet",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.64,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Revontulet_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=t%2FDci6zcSfN1DbQ0wWjojtNaqnzmguEf1Qi5kue3SUY%3D",
      "cdn_url": "https://audio2.brain.fm/Revontulet_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Revontulet_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Revontulet_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Revontulet_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32091897,
      "sha256": "968276d91b37d76932ccb0865d38f78de4b5fbd3c0763d559f385cd21b2ec895",
      "download_error": null
    },
    {
      "track_id": "6a3017347a8f5056573c8d38",
      "name": "In Complete Reverence",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.32,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/InCompleteReverence_Focus_DeepWork_Cinematic_30_112bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=8vKeZibWqARS4Ef3CC3cQf2aJQO294OxQQNf03%2BY1q8%3D",
      "cdn_url": "https://audio2.brain.fm/InCompleteReverence_Focus_DeepWork_Cinematic_30_112bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InCompleteReverence_Focus_DeepWork_Cinematic_30_112bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InCompleteReverence_Focus_DeepWork_Cinematic_30_112bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/InCompleteReverence_Focus_DeepWork_Cinematic_30_112bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28774513,
      "sha256": "867cf3c327b2db4c75c1b110b2a7fe0882a3e44472e0e31d8672f5603154596f",
      "download_error": null
    },
    {
      "track_id": "6a3017127a8f5056573c8bbd",
      "name": "To Bloom Again",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.46,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ToBloomAgain_Focus_DeepWork_Cinematic_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=G0Uqq6HZlkq0tCLofZQ7MHGSR3Hh6DtYTbvM4N5X%2B3M%3D",
      "cdn_url": "https://audio2.brain.fm/ToBloomAgain_Focus_DeepWork_Cinematic_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ToBloomAgain_Focus_DeepWork_Cinematic_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ToBloomAgain_Focus_DeepWork_Cinematic_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ToBloomAgain_Focus_DeepWork_Cinematic_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27230617,
      "sha256": "097beacf4b6f9658c86e518aa7460a822974cf6cb5a3abd97433b99b90a25989",
      "download_error": null
    },
    {
      "track_id": "6a1dcbfab7f8597b4612461b",
      "name": "Until Time Disappears",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.45,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/UntilTimeDisappears_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Railnn5uOIG4uLt5JzqjHL8%2BwSnTZfxFYT4dXZoL2GY%3D",
      "cdn_url": "https://audio2.brain.fm/UntilTimeDisappears_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UntilTimeDisappears_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UntilTimeDisappears_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/UntilTimeDisappears_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28181766,
      "sha256": "5065e6df83f6fe7e5821b54b04221960cf675525800b3121b4cd9163df0c1e98",
      "download_error": null
    },
    {
      "track_id": "6a1dcb4fb7f8597b46124047",
      "name": "In Reversion",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.62,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/InReversion_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=T0Xv%2F1GHc7Vraj3vvm1BKh3c3M25h%2FbxQz3NVHtqeTw%3D",
      "cdn_url": "https://audio2.brain.fm/InReversion_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InReversion_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InReversion_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/InReversion_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28724895,
      "sha256": "2b2f8c4d6441a58437f4dc2237cb31472ea493e0e2307cf0bc48ea4e1544c4e3",
      "download_error": null
    },
    {
      "track_id": "6a1dcb3ab7f8597b46123faf",
      "name": "The Shape Of Understanding",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.57,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TheShapeOfUnderstanding_Focus_Cinematic_Learning_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=SBU72Qnj6T2Ds14JQTtMIFkqfBqLRlFJNs%2BQmHBpJlk%3D",
      "cdn_url": "https://audio2.brain.fm/TheShapeOfUnderstanding_Focus_Cinematic_Learning_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheShapeOfUnderstanding_Focus_Cinematic_Learning_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheShapeOfUnderstanding_Focus_Cinematic_Learning_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TheShapeOfUnderstanding_Focus_Cinematic_Learning_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27474375,
      "sha256": "f06348abc23ac61530b107bf878733e9fadfd1db66b294849d2e1854e2f8df20",
      "download_error": null
    },
    {
      "track_id": "6a1dcabdb7f8597b46123ba7",
      "name": "Strange Peace",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.41,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/StrangePeace_Focus_Learning_Cinematic_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=nvH8fQXiL9SOBzlr8SBfN0tvAImDEH9dSOq7S%2BPFf5Y%3D",
      "cdn_url": "https://audio2.brain.fm/StrangePeace_Focus_Learning_Cinematic_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StrangePeace_Focus_Learning_Cinematic_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StrangePeace_Focus_Learning_Cinematic_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/StrangePeace_Focus_Learning_Cinematic_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27499264,
      "sha256": "f42cb468e6b2026223295401c961024cf5d98f8950a597db627ff7b8f4477c1c",
      "download_error": null
    },
    {
      "track_id": "6a0b8b5ce6017bccd74b7da6",
      "name": "Great Expectations",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/GreatExpectations_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=HP4XUluZfTee626SeaBKGLSOpBvibzGSx8A74bf4ue0%3D",
      "cdn_url": "https://audio2.brain.fm/GreatExpectations_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GreatExpectations_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GreatExpectations_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/GreatExpectations_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29324012,
      "sha256": "b56d8ba14ca2f40fb04e0373ad899ec6a9daea8629b1e8952c99153648990b53",
      "download_error": null
    },
    {
      "track_id": "6a0b8b4fe6017bccd74b7d42",
      "name": "Beneath The Ice",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.41,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/BeneathTheIce_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=D1gGCIj9GiEbupdd8rJEnyEm%2FVbbUDq2ZUaupEIc8bA%3D",
      "cdn_url": "https://audio2.brain.fm/BeneathTheIce_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BeneathTheIce_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BeneathTheIce_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/BeneathTheIce_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27558662,
      "sha256": "6d2a1bf5fbeeb50afadefc2c29a04b9d676bac6b4e5837d08a585405ff7647b4",
      "download_error": null
    },
    {
      "track_id": "6a0b8ad4e6017bccd74b77f2",
      "name": "Orbital Drift",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.51,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/OrbitalDrift_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Jp%2BM4F7aKRCRWmECgB810fcE%2BuQ24kqFjkfOElo%2FE5s%3D",
      "cdn_url": "https://audio2.brain.fm/OrbitalDrift_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OrbitalDrift_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OrbitalDrift_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/OrbitalDrift_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32326317,
      "sha256": "044e4160d2f1a2064cadbfea1039b130efc101cfd67480cccf56ed6c28803cad",
      "download_error": null
    },
    {
      "track_id": "69f8b8fc1c706aff1baf0fc1",
      "name": "Locked In It",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.49,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.87,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/LockedInIt_Focus_DeepWork_Cinematic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Fra02bRbed79%2FQ473OP4clwkRDYN3b1NCJHqXtlA86Q%3D",
      "cdn_url": "https://audio2.brain.fm/LockedInIt_Focus_DeepWork_Cinematic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LockedInIt_Focus_DeepWork_Cinematic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LockedInIt_Focus_DeepWork_Cinematic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/LockedInIt_Focus_DeepWork_Cinematic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29389131,
      "sha256": "73db127a654e71aacba7049c0215493b888c319ad9e2d0af29af9ee71d683d66",
      "download_error": null
    },
    {
      "track_id": "69f8b8661c706aff1baf0a01",
      "name": "Lightwatch",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.32,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Lightwatch_Focus_Creativity_Cinematic_112_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=6jQdIO8eOa%2BD3D0KsK%2BpObcsJTs2MD%2BtB4%2FpTRU2r%2Fs%3D",
      "cdn_url": "https://audio2.brain.fm/Lightwatch_Focus_Creativity_Cinematic_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lightwatch_Focus_Creativity_Cinematic_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Lightwatch_Focus_Creativity_Cinematic_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Lightwatch_Focus_Creativity_Cinematic_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28798549,
      "sha256": "1cb03cda6ef7ba11d8f0d70a26ceb4a567d6d4e426d9333d90470fb513cbaaa6",
      "download_error": null
    },
    {
      "track_id": "69f8b7f61c706aff1baf068d",
      "name": "Exponential Growth",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 104,
      "brightness_level": 0.43,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ExponentialGrowth_Focus_Learning_Cinematic_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=6IM%2FdL6%2FC0oYWIXq40Wfd3V9amDfYSS3nWWKw5H4SR4%3D",
      "cdn_url": "https://audio2.brain.fm/ExponentialGrowth_Focus_Learning_Cinematic_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ExponentialGrowth_Focus_Learning_Cinematic_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ExponentialGrowth_Focus_Learning_Cinematic_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ExponentialGrowth_Focus_Learning_Cinematic_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27737175,
      "sha256": "2c0d3a165b2ee7d79319389d312432c66c6081466cb9c6f0bf1dcff28376e3f0",
      "download_error": null
    },
    {
      "track_id": "69e68604dce2120639c6e872",
      "name": "Underneath The Layers",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 145,
      "brightness_level": 0.48,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/UnderneathTheLayers_Focus_Cinematic_DeepWork_30_145BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=go3%2BS1vepYJ0ZMMVSlOlScaoOr4L1F5jDOOW4LbJGzM%3D",
      "cdn_url": "https://audio2.brain.fm/UnderneathTheLayers_Focus_Cinematic_DeepWork_30_145BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnderneathTheLayers_Focus_Cinematic_DeepWork_30_145BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnderneathTheLayers_Focus_Cinematic_DeepWork_30_145BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/UnderneathTheLayers_Focus_Cinematic_DeepWork_30_145BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27797819,
      "sha256": "407a2c9d0eb1d1380ef579fa10d8c3cc6cf01096ddab0b9c97edf43787597725",
      "download_error": null
    },
    {
      "track_id": "69e68549dce2120639c6e2ec",
      "name": "Conflicts",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.48,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Conflicts_Focus_Creativity_Cinematic_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=5JgiHWEYN6vCKueUll8Fox%2FTM3NX3d8CVXATPOqr7x8%3D",
      "cdn_url": "https://audio2.brain.fm/Conflicts_Focus_Creativity_Cinematic_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Conflicts_Focus_Creativity_Cinematic_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Conflicts_Focus_Creativity_Cinematic_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Conflicts_Focus_Creativity_Cinematic_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28355126,
      "sha256": "afae7b95dfc42de2fcb83d8b93d2db247896849169e55ddb1976fc9c240db845",
      "download_error": null
    },
    {
      "track_id": "69d027479b9914998a32d4a8",
      "name": "On The Cusp Of Change",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.57,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/OnTheCuspOfChange_Focus_Cinematic_Learning_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=gOVel%2FZHX6musIdTqy9SsulR8FaACCkUeZKvEvuJzwE%3D",
      "cdn_url": "https://audio2.brain.fm/OnTheCuspOfChange_Focus_Cinematic_Learning_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OnTheCuspOfChange_Focus_Cinematic_Learning_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OnTheCuspOfChange_Focus_Cinematic_Learning_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/OnTheCuspOfChange_Focus_Cinematic_Learning_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28705759,
      "sha256": "7dae1405e4840c23ba1596f77b7c2ad7662e54f620a6f99190ecf872de7741f0",
      "download_error": null
    },
    {
      "track_id": "69d027199b9914998a32d314",
      "name": "The Real Reason",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.49,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TheRealReason_Focus_DeepWork_Cinematic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=39vsH8FQlh0SI8WMGyOh%2Bt6HyGY56D71B19TDqBC94o%3D",
      "cdn_url": "https://audio2.brain.fm/TheRealReason_Focus_DeepWork_Cinematic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheRealReason_Focus_DeepWork_Cinematic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheRealReason_Focus_DeepWork_Cinematic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TheRealReason_Focus_DeepWork_Cinematic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29553985,
      "sha256": "f698bab24018b816a805e2f629eaecae99af43273133fb5ec6717b0d221a4237",
      "download_error": null
    },
    {
      "track_id": "69c2bd851b6ecfe6c4a7294f",
      "name": "Triskelion",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.16,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Triskelion_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=cq5TIHbny4mMrl0Zop6zuTAkgZIYJP6jOVJOeyY2q4Q%3D",
      "cdn_url": "https://audio2.brain.fm/Triskelion_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Triskelion_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Triskelion_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Triskelion_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29793897,
      "sha256": "8964a8ffc185181f3353f8f064fe1496e905dee1061215832525c920ce695761",
      "download_error": null
    },
    {
      "track_id": "69c2bbd01b6ecfe6c4a719e0",
      "name": "Systems Coming To Life",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.39,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/SystemsComingToLife_Focus_Cinematic_Learning_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=XMBk3Fw8WSKdViyX8oBpE4CiY9epSml%2B9Lul5DzscdY%3D",
      "cdn_url": "https://audio2.brain.fm/SystemsComingToLife_Focus_Cinematic_Learning_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SystemsComingToLife_Focus_Cinematic_Learning_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SystemsComingToLife_Focus_Cinematic_Learning_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/SystemsComingToLife_Focus_Cinematic_Learning_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27758317,
      "sha256": "459b82b742cc83ec74fb2a6700086c75f8ee31f019ced0e8e7e1a8335b7d831c",
      "download_error": null
    },
    {
      "track_id": "69c2bbbd1b6ecfe6c4a7191a",
      "name": "The Day Drifts On",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.43,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TheDayDriftsOn_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=aSxvSF0aJpxCCwCYpgUCYGbGs20oyFqDpG1jItXEBws%3D",
      "cdn_url": "https://audio2.brain.fm/TheDayDriftsOn_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheDayDriftsOn_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheDayDriftsOn_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TheDayDriftsOn_Focus_DeepWork_Cinematic_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29852719,
      "sha256": "d2c457ad07b46fd887276ba255cae20c81a0b915f816ff1de940fbc654770e84",
      "download_error": null
    },
    {
      "track_id": "69aee1a873bfe2099d517463",
      "name": "The Becoming",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TheBecoming_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=NIzU%2FxgdLHl%2Fb86v%2BnH6GRiy9aoqGCGWkalY1%2B%2FLxdg%3D",
      "cdn_url": "https://audio2.brain.fm/TheBecoming_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheBecoming_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheBecoming_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TheBecoming_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28016208,
      "sha256": "0237cc5e3f829d13c116aed7e6a2a619ef8e378956cb4d795a0fa162d5433e73",
      "download_error": null
    },
    {
      "track_id": "69aee19073bfe2099d5173a5",
      "name": "Drifting Through The Haze",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/DriftingThroughTheHaze_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=jz0qOow4WClu9h0ykgX9DyZdZlfVakRbDNfrPIxqLR8%3D",
      "cdn_url": "https://audio2.brain.fm/DriftingThroughTheHaze_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DriftingThroughTheHaze_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DriftingThroughTheHaze_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/DriftingThroughTheHaze_Focus_DeepWork_Cinematic_30_100BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24691069,
      "sha256": "125f54094abf2c2205a8ee208bf6cddfc2e10f5013e2243402f7a44304c71e07",
      "download_error": null
    },
    {
      "track_id": "69aee11c73bfe2099d517076",
      "name": "The Journey Back",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.41,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TheJourneyBack_Focus_Learning_Cinematic_30_94BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=VY4qPrj9a63V3UQOeLqPlmg51Wm%2BLKNcMmB74rGkUPI%3D",
      "cdn_url": "https://audio2.brain.fm/TheJourneyBack_Focus_Learning_Cinematic_30_94BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheJourneyBack_Focus_Learning_Cinematic_30_94BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheJourneyBack_Focus_Learning_Cinematic_30_94BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TheJourneyBack_Focus_Learning_Cinematic_30_94BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27950166,
      "sha256": "24aba2ad27cf624d3555842d266dc95c83e42a25522981aa52cd5d02777d5c82",
      "download_error": null
    },
    {
      "track_id": "699cac6b9033fe9e7ccfa008",
      "name": "Breaking the Barrier",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.39,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/BreakingTheBarrier_Focus_DeepWork_Cinematic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=7PySZyWPg0n1VTCl%2BtG6pjMihoolxV71pfYSAznJUHU%3D",
      "cdn_url": "https://audio2.brain.fm/BreakingTheBarrier_Focus_DeepWork_Cinematic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BreakingTheBarrier_Focus_DeepWork_Cinematic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BreakingTheBarrier_Focus_DeepWork_Cinematic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/BreakingTheBarrier_Focus_DeepWork_Cinematic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26621203,
      "sha256": "86e2536c62271979bc539e3d55ac934b72625689f139d451ae7c446e134ad49e",
      "download_error": null
    },
    {
      "track_id": "699cac309033fe9e7ccf9d87",
      "name": "Bottled Garden",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.51,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/BottledGarden_Focus_Creativity_Cinematic_110_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=q6c07IUqc2aNU2TtsfinmjM5K4Ka0pZxa4x6hV%2BC%2BkA%3D",
      "cdn_url": "https://audio2.brain.fm/BottledGarden_Focus_Creativity_Cinematic_110_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BottledGarden_Focus_Creativity_Cinematic_110_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BottledGarden_Focus_Creativity_Cinematic_110_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/BottledGarden_Focus_Creativity_Cinematic_110_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30059869,
      "sha256": "9b502b7cbdc6dd058f5b3f794686e5efd830c69da81c791ef46e8b689f127bf4",
      "download_error": null
    },
    {
      "track_id": "698a15708a4a8f35be5836db",
      "name": "Seizing The Moment",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.54,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/SeizingTheMoment_Focus_DeepWork_Cinematic_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Z98%2FveB%2BcbFIN6bAnbWhK%2FWt467hrf6khN%2BAqmzW3D4%3D",
      "cdn_url": "https://audio2.brain.fm/SeizingTheMoment_Focus_DeepWork_Cinematic_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SeizingTheMoment_Focus_DeepWork_Cinematic_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SeizingTheMoment_Focus_DeepWork_Cinematic_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/SeizingTheMoment_Focus_DeepWork_Cinematic_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28978817,
      "sha256": "893becc8d262f88946f0b6da10df6552dd17a4b2b484d8d59704b870f84b1cac",
      "download_error": null
    },
    {
      "track_id": "698a152b8a4a8f35be583442",
      "name": "Foreshadowing",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.41,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Foreshadowing_Focus_Creativity_Cinematic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=kpjtUNLHROjH1OmbSsE7mvGuk0yxxQLykGvPnVXcbu0%3D",
      "cdn_url": "https://audio2.brain.fm/Foreshadowing_Focus_Creativity_Cinematic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Foreshadowing_Focus_Creativity_Cinematic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Foreshadowing_Focus_Creativity_Cinematic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Foreshadowing_Focus_Creativity_Cinematic_30_110BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26887993,
      "sha256": "de4f75f13a466d7802bb02850bed7444e49246d2ccf093b91b21ad7d79f958c9",
      "download_error": null
    },
    {
      "track_id": "6977c0da236f65de4c7e5eb2",
      "name": "Halogen Light",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.46,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/HalogenLight_Focus_DeepWork_Cinematic_130_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=wCmNJ8N7G6Qx8DfI410ndRfs6GvAuwvcacZzYuf0SO4%3D",
      "cdn_url": "https://audio2.brain.fm/HalogenLight_Focus_DeepWork_Cinematic_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HalogenLight_Focus_DeepWork_Cinematic_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HalogenLight_Focus_DeepWork_Cinematic_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/HalogenLight_Focus_DeepWork_Cinematic_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32199996,
      "sha256": "2191ad32e1f98c4d795258ae25df55b254e92e5d8556d92503145d862956b296",
      "download_error": null
    },
    {
      "track_id": "6977b656236f65de4c7e3321",
      "name": "Searching Through The Noise",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.48,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/SearchingThroughTheNoise_Focus_Cinematic_DeepWork_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=AowJZ33PcWUoXhZobH8vcKK%2B0UkLVCIp57SaKZdZVkU%3D",
      "cdn_url": "https://audio2.brain.fm/SearchingThroughTheNoise_Focus_Cinematic_DeepWork_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SearchingThroughTheNoise_Focus_Cinematic_DeepWork_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SearchingThroughTheNoise_Focus_Cinematic_DeepWork_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/SearchingThroughTheNoise_Focus_Cinematic_DeepWork_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26817800,
      "sha256": "7c432a2106cb767cb9103bf1e8297dd3b10ee06c0359696c86bada811d3e0f71",
      "download_error": null
    },
    {
      "track_id": "6977b5ee597917b519504d5c",
      "name": "What's On The Other Side",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.58,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/WhatsOnTheSide_Focus_Learning_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=xX2dN5UqS5rWWsB%2FXP6aVMmU41ml42kJxMiHcx6MZlg%3D",
      "cdn_url": "https://audio2.brain.fm/WhatsOnTheSide_Focus_Learning_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WhatsOnTheSide_Focus_Learning_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WhatsOnTheSide_Focus_Learning_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/WhatsOnTheSide_Focus_Learning_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28160866,
      "sha256": "480a9b9aa0738c47cd6c75f16f4852a3d3ac0df86b0b98ed8e575fa32aa8b250",
      "download_error": null
    },
    {
      "track_id": "69655b00212c8d55194eea54",
      "name": "Laws of Nature",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.41,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/LawsOfNature_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=PbXt3j%2BJhD2anMCvNIoEowal7j1xvDd%2BqjKPE5YQNXE%3D",
      "cdn_url": "https://audio2.brain.fm/LawsOfNature_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LawsOfNature_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LawsOfNature_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/LawsOfNature_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30170284,
      "sha256": "11320b66af9d2c10dcc8763b7088549da7b6fe5270e5a7143928d708db6b4229",
      "download_error": null
    },
    {
      "track_id": "69655a708afa49f5711b9009",
      "name": "A Healing Process",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.41,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/AHealingProcess_Focus_DeepWork_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=b%2F7VjnUxFA6YXuU%2FF9bX0z8BHJPlzPIc9YscNv5DF0c%3D",
      "cdn_url": "https://audio2.brain.fm/AHealingProcess_Focus_DeepWork_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AHealingProcess_Focus_DeepWork_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AHealingProcess_Focus_DeepWork_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/AHealingProcess_Focus_DeepWork_Cinematic_30_84BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26555327,
      "sha256": "1f496f22b767a8a7c00e28fa37f3ac9ca35401e6abda4bf5c2e732ed66ebaafc",
      "download_error": null
    },
    {
      "track_id": "69655a5b212c8d55194ee68c",
      "name": "Insighted",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 89,
      "brightness_level": 0.52,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Insighted_Focus_Creativity_Cinematic_30_89bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=vtAg1zRYm%2FP8UA%2B7ZH5G9ZDACFznZHTulTOw4atoJq0%3D",
      "cdn_url": "https://audio2.brain.fm/Insighted_Focus_Creativity_Cinematic_30_89bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Insighted_Focus_Creativity_Cinematic_30_89bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Insighted_Focus_Creativity_Cinematic_30_89bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Insighted_Focus_Creativity_Cinematic_30_89bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28564144,
      "sha256": "49da91e59663dc5e425a9ca95bd0c2dc962bb80b61009a2be854a7c72a2128db",
      "download_error": null
    },
    {
      "track_id": "6952f3aab1c39edafb0debef",
      "name": "From The Inside",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 102,
      "brightness_level": 0.49,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/FromTheInside_Focus_DeepWork_Cinematic_30_102bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Oez30XgZeo%2B2nPs0SStAGBhriVEONuxbHEV8Xr6ErEo%3D",
      "cdn_url": "https://audio2.brain.fm/FromTheInside_Focus_DeepWork_Cinematic_30_102bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FromTheInside_Focus_DeepWork_Cinematic_30_102bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FromTheInside_Focus_DeepWork_Cinematic_30_102bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/FromTheInside_Focus_DeepWork_Cinematic_30_102bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28297259,
      "sha256": "5bd27d3c5ee64e2ea56de0449dd99500912984e6447dbcdc47d0f5c90d02e2ab",
      "download_error": null
    },
    {
      "track_id": "6952f2f79e729f65562d0f58",
      "name": "Connecting The Dots",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 102,
      "brightness_level": 0.46,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ConnectingTheDots_Focus_Learning_Cinematic_30_102BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=j%2BYc82eKvrMiAHDiJhyziaibMDgpMf%2BEFkZOCgc56hI%3D",
      "cdn_url": "https://audio2.brain.fm/ConnectingTheDots_Focus_Learning_Cinematic_30_102BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ConnectingTheDots_Focus_Learning_Cinematic_30_102BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ConnectingTheDots_Focus_Learning_Cinematic_30_102BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ConnectingTheDots_Focus_Learning_Cinematic_30_102BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29148616,
      "sha256": "5751cb3f9d0b44983e2ea590a7791433a775da08abcc3879352ecc69d3f72a7a",
      "download_error": null
    },
    {
      "track_id": "694059be76a1c1f80ff939b9",
      "name": "Government Efficiency",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.41,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/GovernmentEfficiency_Focus_Learning_Cinematic_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=dP%2FOxRRkc3yGBPh4h4scybgrphhvV32v8cUD%2FBs%2B%2FTM%3D",
      "cdn_url": "https://audio2.brain.fm/GovernmentEfficiency_Focus_Learning_Cinematic_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GovernmentEfficiency_Focus_Learning_Cinematic_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GovernmentEfficiency_Focus_Learning_Cinematic_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/GovernmentEfficiency_Focus_Learning_Cinematic_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28104690,
      "sha256": "a08a76ad7bcc2dcdc2126cbd4922edc2686269ac5b901cedfae3ed7cfc6f908e",
      "download_error": null
    },
    {
      "track_id": "694059aa76a1c1f80ff93945",
      "name": "Moss Beach",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.42,
      "complexity_level": 0.55,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/MossBeach_Focus_Creativity_Cinematic_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=tovuyeOimJeT0nUWsbkVAFdTSrqcTxJqYz0HRgBil2M%3D",
      "cdn_url": "https://audio2.brain.fm/MossBeach_Focus_Creativity_Cinematic_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MossBeach_Focus_Creativity_Cinematic_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MossBeach_Focus_Creativity_Cinematic_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/MossBeach_Focus_Creativity_Cinematic_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28706393,
      "sha256": "e84754ddf1d18a511d5ace727d5eb2f27e3262a9edcc27a1ff03cb536678a76f",
      "download_error": null
    },
    {
      "track_id": "692dbeb866ea27cd5c911b7b",
      "name": "A New Rulebook",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.45,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ANewRulebook_Focus_Creativity_Cinematic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=34M38VNvP%2BGWaQ63QCwuaZP2RLoO%2Boe3BUPs2jsh9a8%3D",
      "cdn_url": "https://audio2.brain.fm/ANewRulebook_Focus_Creativity_Cinematic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ANewRulebook_Focus_Creativity_Cinematic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ANewRulebook_Focus_Creativity_Cinematic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ANewRulebook_Focus_Creativity_Cinematic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28555691,
      "sha256": "84762c622ad48aef9906cf5e3cfed65c00969c3b56f406902bc26d45006d4dce",
      "download_error": null
    },
    {
      "track_id": "692dbcf366ea27cd5c911310",
      "name": "Something is Amiss",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.32,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/SomethingIsAmiss_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=0qfeX8F%2B9%2BMXzTTe%2B3fNBM%2Buz52a4xcFA4ArVqEyWuQ%3D",
      "cdn_url": "https://audio2.brain.fm/SomethingIsAmiss_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SomethingIsAmiss_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SomethingIsAmiss_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/SomethingIsAmiss_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25913824,
      "sha256": "c0d83daca0b998654454e2e695e2c0dd9a574de69da641e74b4ec5066633020f",
      "download_error": null
    },
    {
      "track_id": "691b3c59331c372ce8748450",
      "name": "Well of Galaxies",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.38,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/WellOfGalaxies_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=p3yCwZTjAtvAfR3SJ%2FEp6TDRKDji9uvNDh05UPFJOKE%3D",
      "cdn_url": "https://audio2.brain.fm/WellOfGalaxies_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WellOfGalaxies_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WellOfGalaxies_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/WellOfGalaxies_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24754942,
      "sha256": "52feaa97d358725df81d94244e746053eb09734cadaa4f9a55f4dd3b857fc82b",
      "download_error": null
    },
    {
      "track_id": "691b3c43331c372ce87483d5",
      "name": "Unmasked",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.35,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/UnMasked_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=qmRA4T%2FrH4uGxq2cK2ENHoiGQ0nclmsqC6%2BCvksGm90%3D",
      "cdn_url": "https://audio2.brain.fm/UnMasked_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnMasked_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnMasked_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/UnMasked_Focus_DeepWork_Cinematic_30_108BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26590443,
      "sha256": "5603f034ad12e56f41ebd9a857eecf52d662f425e543fcdb7c43d35e2ef08b95",
      "download_error": null
    },
    {
      "track_id": "690919bf312eb1fe04659560",
      "name": "To See The Light Again",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 106,
      "brightness_level": 0.45,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ToSeeTheLightAgain_Focus_Learning_Cinematic_30_106BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=sCEcxUx4l24MI5jHt2O6%2FrqVEX2eoNYrsjit0pRNWw8%3D",
      "cdn_url": "https://audio2.brain.fm/ToSeeTheLightAgain_Focus_Learning_Cinematic_30_106BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ToSeeTheLightAgain_Focus_Learning_Cinematic_30_106BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ToSeeTheLightAgain_Focus_Learning_Cinematic_30_106BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ToSeeTheLightAgain_Focus_Learning_Cinematic_30_106BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27849119,
      "sha256": "4117a74115cc9bd90798c5a5f69f79c0ee6d659620ce4dc663778fb9806d51c7",
      "download_error": null
    },
    {
      "track_id": "690918d126bc41a99c8633ec",
      "name": "The Seeker",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.46,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TheSeeker_Focus_Learning_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=bUKu1Id3KU%2BnigIkvVsL0tnjENV9KdSr0rE%2Fkd85bZg%3D",
      "cdn_url": "https://audio2.brain.fm/TheSeeker_Focus_Learning_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheSeeker_Focus_Learning_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheSeeker_Focus_Learning_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TheSeeker_Focus_Learning_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30249934,
      "sha256": "f73f748cbcda539c430c1fa8369eb7eedc2f67954db8cb19a95a0b35d4b0649a",
      "download_error": null
    },
    {
      "track_id": "690918b7312eb1fe04659099",
      "name": "Any Other Origin",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 107,
      "brightness_level": 0.51,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/AnyOtherOrigin_Focus_Creativity_Cinematic_30_107bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Q%2Bar35pdG%2BfgVQ30%2B9aLL9InmjlSWoYeMjhysBIMfGw%3D",
      "cdn_url": "https://audio2.brain.fm/AnyOtherOrigin_Focus_Creativity_Cinematic_30_107bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AnyOtherOrigin_Focus_Creativity_Cinematic_30_107bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AnyOtherOrigin_Focus_Creativity_Cinematic_30_107bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/AnyOtherOrigin_Focus_Creativity_Cinematic_30_107bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28719855,
      "sha256": "7dbaf72ae53c7902539a55759dcd1a6fb4d64b02fe85254cfc95ca5563051bb2",
      "download_error": null
    },
    {
      "track_id": "68f66574e8a4cc0a7401c214",
      "name": "Deep Dive Down",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 145,
      "brightness_level": 0.48,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/DeepDiveDown_Focus_Cinematic_DeepWork_30_145BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=zLYvKCfmDTT9ncaNfF6LB5PI%2FXD5z3WthTNrEhxtLho%3D",
      "cdn_url": "https://audio2.brain.fm/DeepDiveDown_Focus_Cinematic_DeepWork_30_145BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DeepDiveDown_Focus_Cinematic_DeepWork_30_145BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DeepDiveDown_Focus_Cinematic_DeepWork_30_145BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/DeepDiveDown_Focus_Cinematic_DeepWork_30_145BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29084523,
      "sha256": "06de8c643a2b369dfdac52652cf348285823dde9c856ff24cdddca0a14178735",
      "download_error": null
    },
    {
      "track_id": "68f664f8c7a40a338f845d2f",
      "name": "Exogen",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.51,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Exogen_Focus_Learning_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=x2TAR1qNZdQrjaGPWH641RVy0REaKkSwbnij%2FmrW6Tg%3D",
      "cdn_url": "https://audio2.brain.fm/Exogen_Focus_Learning_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Exogen_Focus_Learning_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Exogen_Focus_Learning_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Exogen_Focus_Learning_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31126285,
      "sha256": "9de241566894249210873e932d2349878cfb1aed35a2445b6ff92abd0ddfe0db",
      "download_error": null
    },
    {
      "track_id": "68e3d73c2d873930bbbf7b33",
      "name": "Gearing Up",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.59,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/GearingUp_Focus_Learning_Cinematic_30_90BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=9tfPMCn9dFJ%2BzchKHR%2BXQHf%2FXoCIjPfN2yz8qtiAaK0%3D",
      "cdn_url": "https://audio2.brain.fm/GearingUp_Focus_Learning_Cinematic_30_90BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GearingUp_Focus_Learning_Cinematic_30_90BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GearingUp_Focus_Learning_Cinematic_30_90BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/GearingUp_Focus_Learning_Cinematic_30_90BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29646820,
      "sha256": "ed1d3d419ff61c0238969c8fc7466ebfa9e7a859a54c13ee67060d6eac38a61d",
      "download_error": null
    },
    {
      "track_id": "68e3d72e2d873930bbbf7acd",
      "name": "Horizon Breach",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.45,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/HorizonBreach_Focus_Creativity_Cinematic_124_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=bOpmNm3QjZndLfPMEattymWQ%2B%2FbzpTSdiUn6xz%2BXqao%3D",
      "cdn_url": "https://audio2.brain.fm/HorizonBreach_Focus_Creativity_Cinematic_124_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HorizonBreach_Focus_Creativity_Cinematic_124_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HorizonBreach_Focus_Creativity_Cinematic_124_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/HorizonBreach_Focus_Creativity_Cinematic_124_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29747373,
      "sha256": "e03c460c0e3d921f41e3f1d38a1e3411d0c6fdd83a1ce2f5891761ccf24b6012",
      "download_error": null
    },
    {
      "track_id": "68d1796cd9158d8853b17458",
      "name": "Duality Lens",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/DualityLens_Focus_Creativity_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=BT1i9CARrLOJp4zFK75yDOfxrmGpjUCeNM8qc03DNM8%3D",
      "cdn_url": "https://audio2.brain.fm/DualityLens_Focus_Creativity_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DualityLens_Focus_Creativity_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DualityLens_Focus_Creativity_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/DualityLens_Focus_Creativity_Cinematic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27558481,
      "sha256": "def45093c99b4f02b71940b1bf7154429b46498a44d74b120c13f5857207baa2",
      "download_error": null
    },
    {
      "track_id": "68d178dad9158d8853b1726c",
      "name": "Secret Locations",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.38,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/SecretLocations_Focus_DeepWork_Cinematic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=ob8xcnlZgrdNIIWFNn%2Fdm6A4GK7qpkMOC8rFGB06h%2Fo%3D",
      "cdn_url": "https://audio2.brain.fm/SecretLocations_Focus_DeepWork_Cinematic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SecretLocations_Focus_DeepWork_Cinematic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SecretLocations_Focus_DeepWork_Cinematic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/SecretLocations_Focus_DeepWork_Cinematic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27701229,
      "sha256": "5671fc9ee07dac351571a78f8e636a3c9b446ab6fce9e724433fbd2b759770b7",
      "download_error": null
    },
    {
      "track_id": "68bf24a3bab547755c787596",
      "name": "Fortified",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.49,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Fortified_Focus_DeepWork_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=xtMXdFmeVxMeT3zMn9aFsMH5iLWOmLHg3Aue8AfJ7%2F4%3D",
      "cdn_url": "https://audio2.brain.fm/Fortified_Focus_DeepWork_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fortified_Focus_DeepWork_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fortified_Focus_DeepWork_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Fortified_Focus_DeepWork_Cinematic_112_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29468942,
      "sha256": "b212f32ac7623afef449589b5f7563151c9496414f2517fe245213fddf117933",
      "download_error": null
    },
    {
      "track_id": "68bf245695e372361f91f459",
      "name": "Cylinder",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.32,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Cylinder_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=4fcm9Eb2n%2BV3hDcwa3WBoGePDed5Z9F3SVIA44olqFk%3D",
      "cdn_url": "https://audio2.brain.fm/Cylinder_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Cylinder_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Cylinder_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Cylinder_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 34999664,
      "sha256": "9abe4ed1aa4fad639e93ec25fc845bdd036ce8e964e2d6c35a81c15b01f7195b",
      "download_error": null
    },
    {
      "track_id": "68bf23ea95e372361f91f2a8",
      "name": "The Hunter",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.46,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TheHunter_Focus_Learning_Cinematic_30_92BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=f5zra4LpaRpKHH1kSYi6ugYMAwaD%2FxbK9VZoHfn4KUc%3D",
      "cdn_url": "https://audio2.brain.fm/TheHunter_Focus_Learning_Cinematic_30_92BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheHunter_Focus_Learning_Cinematic_30_92BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheHunter_Focus_Learning_Cinematic_30_92BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TheHunter_Focus_Learning_Cinematic_30_92BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27342382,
      "sha256": "6115dfc42c2114d706b4cfa7399c753603344c57d5563ac9174d2b67b13f030d",
      "download_error": null
    },
    {
      "track_id": "68aca4f4605d1de9ea68bd6b",
      "name": "Triodus",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 113,
      "brightness_level": 0.23,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Triodus_Focus_DeepWork_Cinematic_113_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=jrkW9EqBTt%2BT6svt%2F99%2FbOsxJnsGK9aTTpAT3JuWpD0%3D",
      "cdn_url": "https://audio2.brain.fm/Triodus_Focus_DeepWork_Cinematic_113_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Triodus_Focus_DeepWork_Cinematic_113_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Triodus_Focus_DeepWork_Cinematic_113_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Triodus_Focus_DeepWork_Cinematic_113_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31196226,
      "sha256": "5dd69acbdb67c8bcc514c2022d2bcfc5507009dbf3d6aec400491d58d35a5faa",
      "download_error": null
    },
    {
      "track_id": "68aca4b2605d1de9ea68bc1d",
      "name": "Abandoned Warehouse",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.38,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/AbandonedWarehouse_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=NnDRkywJe4n9JVMVTkazQluLtdLYL4dJsrBqwWthgVQ%3D",
      "cdn_url": "https://audio2.brain.fm/AbandonedWarehouse_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AbandonedWarehouse_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AbandonedWarehouse_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/AbandonedWarehouse_Focus_DeepWork_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27287205,
      "sha256": "686d37487cd0f75b701220aea71e6090586f171e4bf6fa5500b149a694bd6299",
      "download_error": null
    },
    {
      "track_id": "689a234a9446c76349a3b5f8",
      "name": "From Every Corner",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.38,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/FromEveryCorner_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Z1iD6Bm1afffz7bL4sj1q%2B3syaumhg5AhLA65u1FYFY%3D",
      "cdn_url": "https://audio2.brain.fm/FromEveryCorner_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FromEveryCorner_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FromEveryCorner_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/FromEveryCorner_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28169955,
      "sha256": "c291ad593e6f8e0da4de70992a5eabde9ded9c79b66e7472d61aca0e24d26e23",
      "download_error": null
    },
    {
      "track_id": "689a228acc7f78cc36b7b8f1",
      "name": "Wood and Tide",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.65,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/WoodAndTide_Focus_DeepWork_Cinematic_96_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=v3uJ2TdMl%2F5AeY4jxEWGmvVOuBc9bbKJ5mNePyTx1pc%3D",
      "cdn_url": "https://audio2.brain.fm/WoodAndTide_Focus_DeepWork_Cinematic_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WoodAndTide_Focus_DeepWork_Cinematic_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WoodAndTide_Focus_DeepWork_Cinematic_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/WoodAndTide_Focus_DeepWork_Cinematic_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30853441,
      "sha256": "6a4152c2e1fd1de84758ee6dc401edc928255e522a3ae547cb7f742c37a82608",
      "download_error": null
    },
    {
      "track_id": "6888c946b997579cf699b914",
      "name": "Alternate Endings",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.46,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/AlternateEndings_Focus_Learning_Cinematic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=zSNE8B%2FFlVNafsf9RruAEfE0WtFnB8q78KXcdfHmh4s%3D",
      "cdn_url": "https://audio2.brain.fm/AlternateEndings_Focus_Learning_Cinematic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AlternateEndings_Focus_Learning_Cinematic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AlternateEndings_Focus_Learning_Cinematic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/AlternateEndings_Focus_Learning_Cinematic_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28075959,
      "sha256": "5b64bac3de4272eb1a3f7cc848cd5446d7044ea22acc8e6ec43b6a721c19a953",
      "download_error": null
    },
    {
      "track_id": "6888c8a2c24bb893747ef547",
      "name": "Esoterica",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 77,
      "brightness_level": 0.47,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Esoterica_Focus_DeepWork_Cinematic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=x94Xp1fhrX4LdkXBjzviIBIU8j3VlG%2Fq8jUDSbVfBpE%3D",
      "cdn_url": "https://audio2.brain.fm/Esoterica_Focus_DeepWork_Cinematic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Esoterica_Focus_DeepWork_Cinematic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Esoterica_Focus_DeepWork_Cinematic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Esoterica_Focus_DeepWork_Cinematic_30_77bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30123696,
      "sha256": "feb1dc78d9490d31fec11bbe368047d04bec3ed9ef0d26cf272c7507fe298f00",
      "download_error": null
    },
    {
      "track_id": "687551373b891fead18abb7d",
      "name": "Reflecting Pool",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.29,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ReflectingPool_Focus_Creativity_Cinematic_108_LowNELNrmlzd2_VBR5.mp3?expiration=1792292124471&token=l1wvYtZvuNjCGSzXKCOVa7QQvmHYnWEAH6HaGXdI1Z4%3D",
      "cdn_url": "https://audio2.brain.fm/ReflectingPool_Focus_Creativity_Cinematic_108_LowNELNrmlzd2_VBR5.mp3",
      "remote_filename": "ReflectingPool_Focus_Creativity_Cinematic_108_LowNELNrmlzd2_VBR5.mp3",
      "filename": "ReflectingPool_Focus_Creativity_Cinematic_108_LowNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ReflectingPool_Focus_Creativity_Cinematic_108_LowNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29183942,
      "sha256": "d7cf8706f6eb650dffbe463f3bbee12f12bea4a77e2cc1298e74134c692825fe",
      "download_error": null
    },
    {
      "track_id": "687550fc7e95e87bea729a74",
      "name": "Snowblind",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.52,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/TightTwist_Focus_Creativity_Electronic_30_118BPM_HighNEL_VBR5.mp3?expiration=1792292124471&token=2d8%2B4eTgWyVNRqnHeWllcfDLIH8O0ot654p6uIR5lM8%3D",
      "cdn_url": "https://audio2.brain.fm/TightTwist_Focus_Creativity_Electronic_30_118BPM_HighNEL_VBR5.mp3",
      "remote_filename": "TightTwist_Focus_Creativity_Electronic_30_118BPM_HighNEL_VBR5.mp3",
      "filename": "TightTwist_Focus_Creativity_Electronic_30_118BPM_HighNEL_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/TightTwist_Focus_Creativity_Electronic_30_118BPM_HighNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28529459,
      "sha256": "5153ef00c28cf493b1ef1532b3ea435cb2485697903a557d248c1f596d2fc9ce",
      "download_error": null
    },
    {
      "track_id": "687550cb3b891fead18ab920",
      "name": "Lay Low",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 106,
      "brightness_level": 0.52,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/LayLow_Focus_Learning_Cinematic_106_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=69%2BrWMp6xL28FAk5gBcM6SXToezUsnY22bO7NeO6Tvo%3D",
      "cdn_url": "https://audio2.brain.fm/LayLow_Focus_Learning_Cinematic_106_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LayLow_Focus_Learning_Cinematic_106_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LayLow_Focus_Learning_Cinematic_106_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/LayLow_Focus_Learning_Cinematic_106_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30839655,
      "sha256": "a0f7fb13b6a81d3fe24dd152c97dd7cf63be19fb0fb48cfcacd2c9641a697c93",
      "download_error": null
    },
    {
      "track_id": "687550bd3b891fead18ab8b5",
      "name": "Coral Colonnade",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.36,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/CoralColonnade_Focus_DeepWork_Cinematic_112_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=OhvcDY9Y7NwfZT6bh9WX%2FcYO1mZA%2BjQ0uCPgUyj3000%3D",
      "cdn_url": "https://audio2.brain.fm/CoralColonnade_Focus_DeepWork_Cinematic_112_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CoralColonnade_Focus_DeepWork_Cinematic_112_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CoralColonnade_Focus_DeepWork_Cinematic_112_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/CoralColonnade_Focus_DeepWork_Cinematic_112_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29448398,
      "sha256": "ad1bc1baa110c61b86001ae2d348e67eb11cb0700453d099fb90ac332af81ee4",
      "download_error": null
    },
    {
      "track_id": "6862eff3da2d247f1a9c75e6",
      "name": "Forbidden Files",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.45,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ForbiddenFiles_Focus_DeepWork_Cinematic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=uZTuXB8vi%2BseokohviGw2HD%2F7y6KNm8zVQcFIyCnvS4%3D",
      "cdn_url": "https://audio2.brain.fm/ForbiddenFiles_Focus_DeepWork_Cinematic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ForbiddenFiles_Focus_DeepWork_Cinematic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ForbiddenFiles_Focus_DeepWork_Cinematic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ForbiddenFiles_Focus_DeepWork_Cinematic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28234333,
      "sha256": "155c961585b32615ad173a2a81d44ffe34a49198d96814177d473faea2f2cfea",
      "download_error": null
    },
    {
      "track_id": "6862ef70b0ad537cfff5cf44",
      "name": "Lucky Roll",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.59,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/LuckyRoll_Focus_Creativity_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=%2FAH0VkuKUZAbgyBP4kLnP4M7uY47oI%2FUl1KNSXSHRoU%3D",
      "cdn_url": "https://audio2.brain.fm/LuckyRoll_Focus_Creativity_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LuckyRoll_Focus_Creativity_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LuckyRoll_Focus_Creativity_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/LuckyRoll_Focus_Creativity_Cinematic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30157160,
      "sha256": "f89416b3bc6d5f1d3a1434cf4c46f5d3e4d3df71f274b676325c1af9ef4b29e3",
      "download_error": null
    },
    {
      "track_id": "6862ef4eda2d247f1a9c7425",
      "name": "A House on Jupiter",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.46,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/A%20House%20On%20Jupiter_Focus_Creativity_Cinematic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=8xlgh6JPcyUY1%2B6Lp94ccplj4QGSSsWNsAnM6ejWUZk%3D",
      "cdn_url": "https://audio2.brain.fm/A%20House%20On%20Jupiter_Focus_Creativity_Cinematic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "A House On Jupiter_Focus_Creativity_Cinematic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "A-House-On-Jupiter_Focus_Creativity_Cinematic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/A-House-On-Jupiter_Focus_Creativity_Cinematic_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28073748,
      "sha256": "f191bc2bafd43ba92c9cd20ebb62757027c4f19d4e9b0373f15f248ba0933427",
      "download_error": null
    },
    {
      "track_id": "68505bd8f6a8ec8278221660",
      "name": "Radiant Paths",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.36,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/RadiantPaths_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=qRGJMwgWjTGXzVKMbgbn0JuXpQItuKgPi0EXLKkPzWg%3D",
      "cdn_url": "https://audio2.brain.fm/RadiantPaths_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RadiantPaths_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RadiantPaths_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/RadiantPaths_Focus_Learning_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29149716,
      "sha256": "f30751ae2939fbeeca3e8f8d45159a3fe1a8944b60aede09651dadc2e755ccdb",
      "download_error": null
    },
    {
      "track_id": "68505b995de2e833e430af34",
      "name": "Octavian",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.38,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Octavian_Focus_DeepWork_Cinematic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=nZEBkRAqDKCJ5YYi3dyI0Lmrj0Myj%2FFxnfrdgSSSNmM%3D",
      "cdn_url": "https://audio2.brain.fm/Octavian_Focus_DeepWork_Cinematic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Octavian_Focus_DeepWork_Cinematic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Octavian_Focus_DeepWork_Cinematic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Octavian_Focus_DeepWork_Cinematic_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28171241,
      "sha256": "cfe445ddc958272a84acda1d76165f3307b85f8aa24b376a7da4e94ef9cf837f",
      "download_error": null
    },
    {
      "track_id": "683dc84a7e70e7db4e0af2bc",
      "name": "Lunar Rays",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.29,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/LunarRays_Focus_Learning_Cinematic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=WzlcI6McnyeqRJZbDhh8f138VejAK%2B%2Bo%2F4RhsAWsEyM%3D",
      "cdn_url": "https://audio2.brain.fm/LunarRays_Focus_Learning_Cinematic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LunarRays_Focus_Learning_Cinematic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LunarRays_Focus_Learning_Cinematic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/LunarRays_Focus_Learning_Cinematic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25904822,
      "sha256": "f0f29c7be89b0c6b66edd735f2838baa92d691fdf940541a1cbb8f9ed9f8cc18",
      "download_error": null
    },
    {
      "track_id": "683dc71d7e70e7db4e0aeefc",
      "name": "Lifelong",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.53,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Lifelong_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=9hk9sqdppMgEH1hsfQsq5shfSCybYQwAyjmucRPPZ7k%3D",
      "cdn_url": "https://audio2.brain.fm/Lifelong_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lifelong_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Lifelong_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Lifelong_Focus_Creativity_Cinematic_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25463109,
      "sha256": "9cbd9d156ec1e4216423f600d4a129fc1ac116c2cdc5e936ec303829206ab5e2",
      "download_error": null
    },
    {
      "track_id": "683dc681dd2246ed9c7c7e3b",
      "name": "Similarities Emerge",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.36,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/SimilaritiesEmerge_Focus_Learning_Cinematic_96_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=IOuWFeBesmjIDW4qGIrwbSzKPtDXlfM0oW5ajrfnOVk%3D",
      "cdn_url": "https://audio2.brain.fm/SimilaritiesEmerge_Focus_Learning_Cinematic_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SimilaritiesEmerge_Focus_Learning_Cinematic_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SimilaritiesEmerge_Focus_Learning_Cinematic_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/SimilaritiesEmerge_Focus_Learning_Cinematic_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28540279,
      "sha256": "382e494add7148d0e04f5626205db8bf416a344a7781170c6bab1de2c58c7bce",
      "download_error": null
    },
    {
      "track_id": "682b56a2d2f1d1682decf945",
      "name": "On Wings",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/OnWings_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=93lFiQPxpx64WH9Cl9tvO5kbdSc1hciMtdu4KrcvegY%3D",
      "cdn_url": "https://audio2.brain.fm/OnWings_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OnWings_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OnWings_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/OnWings_Focus_Learning_Cinematic_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28060580,
      "sha256": "4cb01392895b77214e951b276a1d0d21ae7b9a708801d26085c1e3363fb5491a",
      "download_error": null
    },
    {
      "track_id": "682b5682d2f1d1682decf8a9",
      "name": "Lines of Vision",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.33,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/LinesOfVision_Focus_Creativity_Cinematic_100_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Rs5lnWmoIc3Tj%2FgLwFn0EhIqHDkJVaATs%2FBHmR%2BYIf4%3D",
      "cdn_url": "https://audio2.brain.fm/LinesOfVision_Focus_Creativity_Cinematic_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LinesOfVision_Focus_Creativity_Cinematic_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LinesOfVision_Focus_Creativity_Cinematic_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/LinesOfVision_Focus_Creativity_Cinematic_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28619552,
      "sha256": "e63ed483d653fd5861a92b9b7585a0d4d49074eef76a187edb4b602409e069b7",
      "download_error": null
    },
    {
      "track_id": "682b5565d2f1d1682decf4d0",
      "name": "An Easy Test",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.38,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/An%20Easy%20Test_Focus_Creativity_Cinematic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=LR%2FzQbMPC2sE%2F8lYA6XyN9wGumVD0ObqzzolYKZxlWs%3D",
      "cdn_url": "https://audio2.brain.fm/An%20Easy%20Test_Focus_Creativity_Cinematic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "An Easy Test_Focus_Creativity_Cinematic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "An-Easy-Test_Focus_Creativity_Cinematic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/An-Easy-Test_Focus_Creativity_Cinematic_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27057909,
      "sha256": "86436208e08e1e573916ab0ea629317993d6e09621c60de8efd7a40563405e42",
      "download_error": null
    },
    {
      "track_id": "6818d14ec7fc795ec060ecd7",
      "name": "Extrospected",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.24,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Extrospected_Focus_Deep_Work_Cinematic_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=XZX31rU0%2FAiU%2BIhWctKQCsiAdLN%2BhWxA5AR%2BrS3W54Y%3D",
      "cdn_url": "https://audio2.brain.fm/Extrospected_Focus_Deep_Work_Cinematic_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Extrospected_Focus_Deep_Work_Cinematic_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Extrospected_Focus_Deep_Work_Cinematic_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Extrospected_Focus_Deep_Work_Cinematic_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27819511,
      "sha256": "b51f59e02174d00e07b70ba27f4c65dae6aa91d000370d792d38ababd9cdc9d1",
      "download_error": null
    },
    {
      "track_id": "68065a5d563464c2de5fb865",
      "name": "Looking Back",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.24,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Looking_Back_Focus_Deep_Work_Cinematic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=JzNXRAzitq9T%2BeWwPjru7upfv%2FURCHhJtyEelhqOhsc%3D",
      "cdn_url": "https://audio2.brain.fm/Looking_Back_Focus_Deep_Work_Cinematic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Looking_Back_Focus_Deep_Work_Cinematic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Looking_Back_Focus_Deep_Work_Cinematic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Looking_Back_Focus_Deep_Work_Cinematic_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27875970,
      "sha256": "364f8c6c4afdd425b588647c2b35a238c3c4076fa7bb4fe3199e9e7034a7843f",
      "download_error": null
    },
    {
      "track_id": "67f3eafba0de2348f748e1b6",
      "name": "Potions",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.24,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Potions_Focus_DeepWork_Cinematic_30_72bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=qhZQbmkogNkyzPxkCb%2FebOzHpaXI4jIJ88c3r8WvylE%3D",
      "cdn_url": "https://audio2.brain.fm/Potions_Focus_DeepWork_Cinematic_30_72bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Potions_Focus_DeepWork_Cinematic_30_72bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Potions_Focus_DeepWork_Cinematic_30_72bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Potions_Focus_DeepWork_Cinematic_30_72bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28813841,
      "sha256": "14f2121498232cb350e3f95d0f3bce6f8172c552ed91b8ac28aefea8f94a3a7d",
      "download_error": null
    },
    {
      "track_id": "67e17df75177e5bfbd17f7b6",
      "name": "Cell By Cell",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.42,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/CellByCell_Focus_DeepWork_Cinematic_100_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=vEHMpM9LIsL1fxpH6SMQFK6dIYjRCorieQJc52kGgGA%3D",
      "cdn_url": "https://audio2.brain.fm/CellByCell_Focus_DeepWork_Cinematic_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CellByCell_Focus_DeepWork_Cinematic_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CellByCell_Focus_DeepWork_Cinematic_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/CellByCell_Focus_DeepWork_Cinematic_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29217473,
      "sha256": "188d33a05510f66ba37fc90571de8cfd377aa220f9a4d3a78c4e48d1029fe91e",
      "download_error": null
    },
    {
      "track_id": "67cf053b593aad5348b96548",
      "name": "Inspector",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.47,
      "complexity_level": 1,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Inspector_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=g4yDx18dmRZDkVbUa1O9pWqtUYaMg%2FnHQiH3tBPZdww%3D",
      "cdn_url": "https://audio2.brain.fm/Inspector_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Inspector_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Inspector_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Inspector_Focus_DeepWork_Cinematic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30061664,
      "sha256": "db6a8f8b3f8fe9ca59b93180758b7d9953cb395cda9100567951da157d9f2b0f",
      "download_error": null
    },
    {
      "track_id": "67bc887edd31a1be17726909",
      "name": "Joy and Comfort",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.33,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/JoyandComfort_Focus_DeepWork_Cinematic_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=xET2IHeA25jNKsbfZ0KQnyuXE9Mot6GIXQwV%2F6L%2BiGg%3D",
      "cdn_url": "https://audio2.brain.fm/JoyandComfort_Focus_DeepWork_Cinematic_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JoyandComfort_Focus_DeepWork_Cinematic_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "JoyandComfort_Focus_DeepWork_Cinematic_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/JoyandComfort_Focus_DeepWork_Cinematic_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27453894,
      "sha256": "8ca6c93a6ed4e5674f8d549ec753483a6d37faa4bbedf50e8b2182ea6374d23d",
      "download_error": null
    },
    {
      "track_id": "67aa5b9755e93dd34369237e",
      "name": "Broken Silence",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.42,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/BrokenSilence_Focus_DeepWork_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=kBq%2FNMDTJfRDmz6HuFsLVHDJBYpaBF2k5etqXD3%2FZEE%3D",
      "cdn_url": "https://audio2.brain.fm/BrokenSilence_Focus_DeepWork_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BrokenSilence_Focus_DeepWork_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BrokenSilence_Focus_DeepWork_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/BrokenSilence_Focus_DeepWork_Cinematic_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30157771,
      "sha256": "c6e389c1db33610d814a086d791cc615babc7b6366b4e80820ac13dd6633b7d6",
      "download_error": null
    },
    {
      "track_id": "67aa5b3eae67ac1cf074e9f9",
      "name": "Beyond the Light",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.36,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/BeyondTheLight_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=wD6P6JCtjcxKFLH82L%2FcpohGBQsYMQim5aQJ1ONayWc%3D",
      "cdn_url": "https://audio2.brain.fm/BeyondTheLight_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BeyondTheLight_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BeyondTheLight_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/BeyondTheLight_Focus_Creativity_Cinematic_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28953060,
      "sha256": "45d062001c9b7de4f924c528808b534b47e70106557ee9c4355e9b65d7c4479b",
      "download_error": null
    },
    {
      "track_id": "67a10f4303677edafb63f32e",
      "name": "A Sense of Verticality",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.31,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ASenseOfVerticality_Focus_DeepWork_Cinematic_30_112bpm_MedNel_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=890c2DIhR7aXSIFyS%2F3cTEQfQ7iICTe4yxIUcoTKOUw%3D",
      "cdn_url": "https://audio2.brain.fm/ASenseOfVerticality_Focus_DeepWork_Cinematic_30_112bpm_MedNel_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ASenseOfVerticality_Focus_DeepWork_Cinematic_30_112bpm_MedNel_Nrmlzd2_VBR5.mp3",
      "filename": "ASenseOfVerticality_Focus_DeepWork_Cinematic_30_112bpm_MedNel_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ASenseOfVerticality_Focus_DeepWork_Cinematic_30_112bpm_MedNel_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29541464,
      "sha256": "03f1b8efb307cc83654ab91833287e1e41874245e6bf90f55458d01a758fb707",
      "download_error": null
    },
    {
      "track_id": "67855b66f76968728486ad79",
      "name": "Cloud of Unknowing",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.45,
      "complexity_level": 0.53,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/CloudofUnknowing_Focus_DeepWork_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=k5dUcdKzwIuICdDPflQnPMw92sWkHH6PiwXhpYcvang%3D",
      "cdn_url": "https://audio2.brain.fm/CloudofUnknowing_Focus_DeepWork_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CloudofUnknowing_Focus_DeepWork_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CloudofUnknowing_Focus_DeepWork_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/CloudofUnknowing_Focus_DeepWork_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28802996,
      "sha256": "4a8eaad84a11230de38cda45ef0eef472200e5d4447f63c85013a386a0e8ba5e",
      "download_error": null
    },
    {
      "track_id": "674ddf8e657c71542c99973a",
      "name": "Serenades of Sand",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.32,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Serenades%20of%20Sand_Focus_Creativity_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=rgOGGD0w6qkG3OubdB%2BbSSMey3RRI7kE%2FmJQrGBHwPA%3D",
      "cdn_url": "https://audio2.brain.fm/Serenades%20of%20Sand_Focus_Creativity_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Serenades of Sand_Focus_Creativity_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Serenades-of-Sand_Focus_Creativity_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Serenades-of-Sand_Focus_Creativity_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26302842,
      "sha256": "27417fdbc21a28ec6f2f1323c065467e919d7e74c8283636b5d042cb7706223b",
      "download_error": null
    },
    {
      "track_id": "673b5ef481e56c199c2a9fd8",
      "name": "Reverence",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.75,
      "complexity_level": 0.52,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Reverence_Focus_Creativity_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Exnocv1%2FrRPhO%2Fv9vYZ9AydOm0GTx10DaQ2Wzh1k2Lc%3D",
      "cdn_url": "https://audio2.brain.fm/Reverence_Focus_Creativity_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Reverence_Focus_Creativity_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Reverence_Focus_Creativity_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Reverence_Focus_Creativity_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28689623,
      "sha256": "8d5c6a4102b4c0907dc684742a69e67dfffdca1d04e1a0395382eb4fc1234c63",
      "download_error": null
    },
    {
      "track_id": "673b5eea593072f908bc78fb",
      "name": "Echo Horizons",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.59,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Echo%20Horizons_Focus_Learning_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=GE9uvm%2Bf14yo6rqSALi%2B5Z5uVZ3wXIFGNglpijkFS1I%3D",
      "cdn_url": "https://audio2.brain.fm/Echo%20Horizons_Focus_Learning_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Echo Horizons_Focus_Learning_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Echo-Horizons_Focus_Learning_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Echo-Horizons_Focus_Learning_Cinematic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28004610,
      "sha256": "bd5e856d4592259f0931363d8322ae366575620f33b0c4246d2ffa17f2a3d419",
      "download_error": null
    },
    {
      "track_id": "6728ebc18bc23988fd6470ef",
      "name": "Mirages",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.59,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Mirages_Focus_Learning_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=EWiS8k6QxVWiDvD7kbTSuivs%2FTiEtdBUXcuxcWrJFpQ%3D",
      "cdn_url": "https://audio2.brain.fm/Mirages_Focus_Learning_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Mirages_Focus_Learning_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Mirages_Focus_Learning_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Mirages_Focus_Learning_Cinematic_30_94bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27536599,
      "sha256": "1e07304d641ae10f84641ca5d2d0e526b8915714dad158c19b9faea354333734",
      "download_error": null
    },
    {
      "track_id": "6716a16fae8c98e954dc5a33",
      "name": "Embers Along The Way",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.62,
      "complexity_level": 0.75,
      "style": "normal",
      "neural_effect_level": 0.65,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Embers%20Along%20The%20Way_Focus_Creativity_Cinematic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=GdU0GCGz46L7GsZEhJF591ixJbIYmYGawOkSdza5S4E%3D",
      "cdn_url": "https://audio2.brain.fm/Embers%20Along%20The%20Way_Focus_Creativity_Cinematic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Embers Along The Way_Focus_Creativity_Cinematic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Embers-Along-The-Way_Focus_Creativity_Cinematic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Embers-Along-The-Way_Focus_Creativity_Cinematic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28603285,
      "sha256": "dc8194d7a8628b3c0c32c9f7548345816c2111967b1a341562cfbad48d7982e8",
      "download_error": null
    },
    {
      "track_id": "6716a165ae8c98e954dc59dd",
      "name": "Above Starlight",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.69,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Beyond_Stars_Focus_DeepWork_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=LvNyXJogYSfvL6JKfilZFNa5haRU7rR51IhQTJ73Iec%3D",
      "cdn_url": "https://audio2.brain.fm/Beyond_Stars_Focus_DeepWork_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Beyond_Stars_Focus_DeepWork_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Beyond_Stars_Focus_DeepWork_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Beyond_Stars_Focus_DeepWork_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28589934,
      "sha256": "e8a9540d28a77df230cdc6eac58636aef6d53d90016fab1c1b5ed654a44396be",
      "download_error": null
    },
    {
      "track_id": "6716a15bae8c98e954dc5998",
      "name": "Siren Lament",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.55,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Siren%20Lament_Focus_DeepWork_Cinematic_30_90bpm_MedNELNrmlzd2_VBR5.mp3?expiration=1792292124471&token=eK11YwiQ3pak%2Bylp8mwq%2FZGpGh7Gw4X8Or5zWFsJ0WE%3D",
      "cdn_url": "https://audio2.brain.fm/Siren%20Lament_Focus_DeepWork_Cinematic_30_90bpm_MedNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Siren Lament_Focus_DeepWork_Cinematic_30_90bpm_MedNELNrmlzd2_VBR5.mp3",
      "filename": "Siren-Lament_Focus_DeepWork_Cinematic_30_90bpm_MedNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Siren-Lament_Focus_DeepWork_Cinematic_30_90bpm_MedNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27637795,
      "sha256": "49667a47619ce65f2be0df1c10f5c01221c21031270dd1cf7ad2de8ebb7e2db7",
      "download_error": null
    },
    {
      "track_id": "6703e339a1f0c0804124fe14",
      "name": "Descension",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.38,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Descension_Focus_Deep_Work_Cinematic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=YSN89eswmZxnGGQgrOF6nuA3M4hV1pkFsF4AlqpE0Do%3D",
      "cdn_url": "https://audio2.brain.fm/Descension_Focus_Deep_Work_Cinematic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Descension_Focus_Deep_Work_Cinematic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Descension_Focus_Deep_Work_Cinematic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Descension_Focus_Deep_Work_Cinematic_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27518029,
      "sha256": "94e97f42f33691d2f32e1c1ce43af0889ece15a78c54cd6679cf2a9f79f8b4e6",
      "download_error": null
    },
    {
      "track_id": "6703e32ea1f0c0804124fdd6",
      "name": "Wind Whispers",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.75,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/WindWhispers_Focus_Creativity_Cinematic_30_96bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Q6s3c2TO%2BpVJSlOob3Bj4FmPg98B%2FXnf2Fom%2BVTqDqA%3D",
      "cdn_url": "https://audio2.brain.fm/WindWhispers_Focus_Creativity_Cinematic_30_96bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WindWhispers_Focus_Creativity_Cinematic_30_96bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WindWhispers_Focus_Creativity_Cinematic_30_96bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/WindWhispers_Focus_Creativity_Cinematic_30_96bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30068744,
      "sha256": "2867c0e36fd97831fff1b50e5e22a09cb353ee8c5dc4c7c4a1502920050307a8",
      "download_error": null
    },
    {
      "track_id": "6703e308a1f0c0804124fd0b",
      "name": "Shade and Hue",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.42,
      "complexity_level": 0.52,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/ShadeAndHue_Focus_Learning_Cinematic_85_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=tSaTd0m2OBSbpRJWoF50TBfiG0edxmYGRW8DJIM0zCE%3D",
      "cdn_url": "https://audio2.brain.fm/ShadeAndHue_Focus_Learning_Cinematic_85_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ShadeAndHue_Focus_Learning_Cinematic_85_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ShadeAndHue_Focus_Learning_Cinematic_85_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/ShadeAndHue_Focus_Learning_Cinematic_85_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29251287,
      "sha256": "41b74121df46b60032708a8b60c9da8c04d21a3b3415789b399d5d1cf8a2f0bb",
      "download_error": null
    },
    {
      "track_id": "66f17864d7073bdb17919999",
      "name": "Solar Cascade",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.46,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Solar%20Cascade_Focus_Learning_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=ANZn7K8bj9UJBQCRpKXabF%2FHMU8R2Se%2BAEJijiVB8g8%3D",
      "cdn_url": "https://audio2.brain.fm/Solar%20Cascade_Focus_Learning_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Solar Cascade_Focus_Learning_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Solar-Cascade_Focus_Learning_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Solar-Cascade_Focus_Learning_Cinematic_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28921374,
      "sha256": "43fca896d71c01a95d9e9b461c9d3519857e56547bfbd9249a6c951e50c3b673",
      "download_error": null
    },
    {
      "track_id": "66f17639d7073bdb17919435",
      "name": "Holographs",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.32,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Holographs_Focus_Deep_Work_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=Wv6yY6x%2BPS5C7LD9fYUiSpiRWUC14s0DcSLBmXjufyQ%3D",
      "cdn_url": "https://audio2.brain.fm/Holographs_Focus_Deep_Work_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Holographs_Focus_Deep_Work_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Holographs_Focus_Deep_Work_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Holographs_Focus_Deep_Work_Cinematic_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26228184,
      "sha256": "7c6cc63a0c3ba997298893fb18eaa2a35ec5f3d33978aef4e0ddc896e6cc1302",
      "download_error": null
    },
    {
      "track_id": "66df02dbedad688793836f14",
      "name": "Phantom Forest",
      "category": "Cinematic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.35,
      "complexity_level": 0.41,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/cinematic.json",
      "source_url": "https://audio2.brain.fm/Phantom%20Forest_Focus_DeepWork_Cinematic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292124471&token=QXm93Mz2knRMbiNVztv8jqANLkAGk6jE40spsi21vk4%3D",
      "cdn_url": "https://audio2.brain.fm/Phantom%20Forest_Focus_DeepWork_Cinematic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Phantom Forest_Focus_DeepWork_Cinematic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Phantom-Forest_Focus_DeepWork_Cinematic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/cinematic/Phantom-Forest_Focus_DeepWork_Cinematic_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27230291,
      "sha256": "7c1510cd624570add51375fa3efe6805f4480d1b9f1f7aeb63dd82a029ba9a0a",
      "download_error": null
    },
    {
      "track_id": "6a4bb6b54518fc4e1e406191",
      "name": "Marchioness",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.35,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Marchioness_Focus_Learning_Classical_110_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=3QhUkoyf56UkOqtD%2BS3HQ8Nhm75Z5rcqY2VybzY%2FIts%3D",
      "cdn_url": "https://audio2.brain.fm/Marchioness_Focus_Learning_Classical_110_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Marchioness_Focus_Learning_Classical_110_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Marchioness_Focus_Learning_Classical_110_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Marchioness_Focus_Learning_Classical_110_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29332846,
      "sha256": "c9d83b5a69174a627a7aec87dc002cea3779fa41d6e86f426b20391562b10836",
      "download_error": null
    },
    {
      "track_id": "6a4281e578a0a113b2ff3e5d",
      "name": "Lanthorn Street",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.57,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/LanthornStreet_Focus_Learning_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=%2FGLc1FGoVva8xAw30fhXCgeX%2FXOtZFaJenX9xX%2BhNG8%3D",
      "cdn_url": "https://audio2.brain.fm/LanthornStreet_Focus_Learning_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LanthornStreet_Focus_Learning_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LanthornStreet_Focus_Learning_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/LanthornStreet_Focus_Learning_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28343942,
      "sha256": "69657bbb25b037369ae669cde6e5d4b666909d9443e1863e83b2335eed10d2d5",
      "download_error": null
    },
    {
      "track_id": "6a30180c7a8f5056573c95f3",
      "name": "Zephyrline",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.36,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Zephyrline_Focus_DeepWork_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=jmklNYwwP9hsy5aaKnKCS2ulA%2FwDWWZdpZSIJeFgejc%3D",
      "cdn_url": "https://audio2.brain.fm/Zephyrline_Focus_DeepWork_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Zephyrline_Focus_DeepWork_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Zephyrline_Focus_DeepWork_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Zephyrline_Focus_DeepWork_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27770387,
      "sha256": "29089904056439f9f9a58782870ffc290d02deeaa59ee84614c9e553f0ee35ab",
      "download_error": null
    },
    {
      "track_id": "6a0b8bdde6017bccd74b83f9",
      "name": "Prosymna",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.52,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Prosymna_Focus_DeepWork_Classical_72_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=%2F8Ka%2B45v7kXg4wHVgyXhx7xWYH%2BF8MrxTP6pLRyM7Q0%3D",
      "cdn_url": "https://audio2.brain.fm/Prosymna_Focus_DeepWork_Classical_72_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Prosymna_Focus_DeepWork_Classical_72_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Prosymna_Focus_DeepWork_Classical_72_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Prosymna_Focus_DeepWork_Classical_72_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30788562,
      "sha256": "ba68921819189d49f79e8614a62d732ad86c224244018a13bcbb8658f5236f1b",
      "download_error": null
    },
    {
      "track_id": "69d0276f9b9914998a32d64f",
      "name": "Practitioner",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Practitioner_Focus_Learning_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=M1OrRNL0y69%2BNqIKCUWJsbNtuaQjCYMD2Xtqf66Dc%2BU%3D",
      "cdn_url": "https://audio2.brain.fm/Practitioner_Focus_Learning_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Practitioner_Focus_Learning_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Practitioner_Focus_Learning_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Practitioner_Focus_Learning_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28433019,
      "sha256": "41d8163c5aaafb27b5ffb324513b31fe9fec3aae955784b929b4add6b31205c1",
      "download_error": null
    },
    {
      "track_id": "69c2bd3b1b6ecfe6c4a7262b",
      "name": "Jupiter Reef",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 175,
      "brightness_level": 0.52,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/JupiterReef_Focus_DeepWork_Classical_175_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=b52gqtO8G6gvcrkfuyCKgkDFFh%2Bq2e0iWftE%2Fqdjass%3D",
      "cdn_url": "https://audio2.brain.fm/JupiterReef_Focus_DeepWork_Classical_175_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JupiterReef_Focus_DeepWork_Classical_175_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "JupiterReef_Focus_DeepWork_Classical_175_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/JupiterReef_Focus_DeepWork_Classical_175_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29744376,
      "sha256": "9b0ff4f8b11b0dfb4a17823493dd87f3bcbda04b6a12b952270f2fdc5d96dffc",
      "download_error": null
    },
    {
      "track_id": "69c2bcf11b6ecfe6c4a72333",
      "name": "Lacewing",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.28,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Lacewing_Focus_DeepWork_Classical_86_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=reKar5EIBfnAxxkfsLRPRhQjnUG6VltP2QIv80Khs34%3D",
      "cdn_url": "https://audio2.brain.fm/Lacewing_Focus_DeepWork_Classical_86_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lacewing_Focus_DeepWork_Classical_86_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Lacewing_Focus_DeepWork_Classical_86_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Lacewing_Focus_DeepWork_Classical_86_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25718422,
      "sha256": "46aafc1c81ccb84896ab7a3794a6567fa8807b5d0634153b67a72d7ed83865fb",
      "download_error": null
    },
    {
      "track_id": "69aee30673bfe2099d517e86",
      "name": "Panamint Range",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.33,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/PanamintRange_Focus_DeepWork_Classical_118_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=ZxSSXKTmFwpJ7NRy2loM3AWKccWSCDkUx6qFPNnHa%2Bo%3D",
      "cdn_url": "https://audio2.brain.fm/PanamintRange_Focus_DeepWork_Classical_118_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PanamintRange_Focus_DeepWork_Classical_118_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PanamintRange_Focus_DeepWork_Classical_118_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/PanamintRange_Focus_DeepWork_Classical_118_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28335306,
      "sha256": "ed32d8b6985752da5bf844fd5eba70eb52fa0a4df9ecd118fd52274f3023f1c3",
      "download_error": null
    },
    {
      "track_id": "69aee2c573bfe2099d517ba1",
      "name": "Perdita",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.36,
      "complexity_level": 12,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Perdita_Focus_Creativity_Classical_105_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=1au5OR7UqRTmToonFEluDt0KpQhkDVTeG6RRtGGrRlE%3D",
      "cdn_url": "https://audio2.brain.fm/Perdita_Focus_Creativity_Classical_105_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Perdita_Focus_Creativity_Classical_105_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Perdita_Focus_Creativity_Classical_105_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Perdita_Focus_Creativity_Classical_105_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28779183,
      "sha256": "dcc7ab398b918096370505365f75024c7a10e122411be74154fc5edb9536ec8f",
      "download_error": null
    },
    {
      "track_id": "699caf8e9033fe9e7ccfb9dd",
      "name": "The Gliding Year",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.46,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TheGlidingYear_Focus_Learning_Classical_100_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=Tgb6drwq0OtJvSfGkZPqbYaE6CjAIyAwYuM4Seur%2F4Q%3D",
      "cdn_url": "https://audio2.brain.fm/TheGlidingYear_Focus_Learning_Classical_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheGlidingYear_Focus_Learning_Classical_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheGlidingYear_Focus_Learning_Classical_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TheGlidingYear_Focus_Learning_Classical_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28580274,
      "sha256": "53f40a7dd9e43112582986c29bc6d1f0cf1530d46be70fd6a8155fff80955df1",
      "download_error": null
    },
    {
      "track_id": "6977c05e236f65de4c7e5cd9",
      "name": "Athlin",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.65,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Athlin_Focus_DeepWork_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=jCyCmTio3lPVwzG6ap7y8zH0UsIndQbR5DkGTQq5JSQ%3D",
      "cdn_url": "https://audio2.brain.fm/Athlin_Focus_DeepWork_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Athlin_Focus_DeepWork_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Athlin_Focus_DeepWork_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Athlin_Focus_DeepWork_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27380217,
      "sha256": "a91469bc59803c5f20f1a5da0265a19bec0d93298d4cef6cd63a48c68003a4b7",
      "download_error": null
    },
    {
      "track_id": "69655b7e8afa49f5711b94aa",
      "name": "Castle Dunbayne",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.38,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/CastleDunbayne_Focus_DeepWork_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=1C7FHF4lKxJqlMZjawTu%2BwLUtR288Whvl5dQJBlPclY%3D",
      "cdn_url": "https://audio2.brain.fm/CastleDunbayne_Focus_DeepWork_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CastleDunbayne_Focus_DeepWork_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CastleDunbayne_Focus_DeepWork_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/CastleDunbayne_Focus_DeepWork_Classical_100_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29708871,
      "sha256": "f59aaeaae0adbeac806de736542d6f1fe2254b049321a3c1c4bff9cd2c89b19b",
      "download_error": null
    },
    {
      "track_id": "6952f3e39e729f65562d1346",
      "name": "Menhir",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.28,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Menhir_Focus_DeepWork_Classical_90_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=k9ndmq85IqTLajXr515ZmrGCZyT%2B%2BOMJ1zdxVA%2FcpDU%3D",
      "cdn_url": "https://audio2.brain.fm/Menhir_Focus_DeepWork_Classical_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Menhir_Focus_DeepWork_Classical_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Menhir_Focus_DeepWork_Classical_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Menhir_Focus_DeepWork_Classical_90_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27996508,
      "sha256": "6b482248cb6b449ef07d085fcba885bb39e1a7e00f72c47e46dc29a7f9ccf180",
      "download_error": null
    },
    {
      "track_id": "6952f356b1c39edafb0deae2",
      "name": "Every Afternoon",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.43,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/EveryAfternoon_Focus_Learning_Classical_80_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=Aq%2Fop%2BKp3fw4zZ0%2F9%2F7V0Lx%2FfOMIgnSJ4GRqePmwmww%3D",
      "cdn_url": "https://audio2.brain.fm/EveryAfternoon_Focus_Learning_Classical_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EveryAfternoon_Focus_Learning_Classical_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EveryAfternoon_Focus_Learning_Classical_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/EveryAfternoon_Focus_Learning_Classical_80_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28124995,
      "sha256": "0cf073afce02ce4609efc2000941e25724e03641dfe99b1f15f978064f93427e",
      "download_error": null
    },
    {
      "track_id": "69405a1f913e2d2bff955b06",
      "name": "Common Thyme",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 128,
      "brightness_level": 0.33,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.49,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/CommonThyme_Focus_Learning_Classical_128_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=xEf7WcT7wNCtTFGoChot%2FTqWosqeF3XBqBauOJqg2xk%3D",
      "cdn_url": "https://audio2.brain.fm/CommonThyme_Focus_Learning_Classical_128_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CommonThyme_Focus_Learning_Classical_128_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CommonThyme_Focus_Learning_Classical_128_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/CommonThyme_Focus_Learning_Classical_128_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28154747,
      "sha256": "f1ab84ca25163e136426d2347110bff179bb038673c6a7e062605edef037227e",
      "download_error": null
    },
    {
      "track_id": "691b3c16a1c962ea641efbeb",
      "name": "Immeasurable",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.51,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Immeasurable_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=yOYJRjIlR2b2%2F6QNM6c4SRzgtLoejOoKj2ZuzNRIVS8%3D",
      "cdn_url": "https://audio2.brain.fm/Immeasurable_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Immeasurable_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Immeasurable_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Immeasurable_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29517194,
      "sha256": "84ee805328d5b31bddc596fae0d929a766d5d8ae26ee78e55ce322a9a17bec7b",
      "download_error": null
    },
    {
      "track_id": "69091a19312eb1fe046596fa",
      "name": "The Orrery",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.42,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TheOrrery_Focus_Learning_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=rQakgLWbCNF9JBf9YB46aYFyl3R37uWfYbvD02XTJwg%3D",
      "cdn_url": "https://audio2.brain.fm/TheOrrery_Focus_Learning_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheOrrery_Focus_Learning_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheOrrery_Focus_Learning_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TheOrrery_Focus_Learning_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29146106,
      "sha256": "6abab3a750cf664cc4baa16282286f71dcf5855c167ea7689021e02f270c3f4b",
      "download_error": null
    },
    {
      "track_id": "68f66562c7a40a338f845ff0",
      "name": "Antiquarian",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.52,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Antiquarian_Focus_Learning_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=6cVYAraEjI%2Bnozi0oLVSH5T%2B%2BCCX%2FEdZyCzFIAVzONc%3D",
      "cdn_url": "https://audio2.brain.fm/Antiquarian_Focus_Learning_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Antiquarian_Focus_Learning_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Antiquarian_Focus_Learning_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Antiquarian_Focus_Learning_Classical_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29028314,
      "sha256": "5dbf2997aca56dae14114f45e23ec9efcbc54d553330985f12813fe9d9854df2",
      "download_error": null
    },
    {
      "track_id": "68e3d7832d873930bbbf7c24",
      "name": "Carpathia",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.46,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Carpathia_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=sD%2FomfGLvr%2F1sjDG6mr64xfLOojamz0ZKU8Y04m2cqg%3D",
      "cdn_url": "https://audio2.brain.fm/Carpathia_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Carpathia_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Carpathia_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Carpathia_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28068904,
      "sha256": "467def6e627c6500787cb11c1da4f76dd3ecf281098712ee825f4c420c769dfb",
      "download_error": null
    },
    {
      "track_id": "68d17947d9158d8853b173d4",
      "name": "New Foyer",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.48,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/NewFoyer_Focus_DeepWork_Classical_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=RPxAEj4DlbU%2BhrBdLNSfS3DdV40%2BaKluVgh5JNKp1Uw%3D",
      "cdn_url": "https://audio2.brain.fm/NewFoyer_Focus_DeepWork_Classical_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NewFoyer_Focus_DeepWork_Classical_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NewFoyer_Focus_DeepWork_Classical_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/NewFoyer_Focus_DeepWork_Classical_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28400017,
      "sha256": "c8a0a38cd30e0fac9863a763dc2fb159edab4f8e3fb710265df28d258754b5a4",
      "download_error": null
    },
    {
      "track_id": "68bf23f695e372361f91f2e3",
      "name": "Cloud Masquerade",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 140,
      "brightness_level": 0.45,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.49,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/CloudMasquerade_Focus_DeepWork_Classical_140_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=bE68xtRli7McqTguJ0dKZeBXU91zqZjFvCYSsQAOu%2Bw%3D",
      "cdn_url": "https://audio2.brain.fm/CloudMasquerade_Focus_DeepWork_Classical_140_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CloudMasquerade_Focus_DeepWork_Classical_140_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CloudMasquerade_Focus_DeepWork_Classical_140_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/CloudMasquerade_Focus_DeepWork_Classical_140_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29398093,
      "sha256": "58bb1368ed32206a1a1e22af59dab41953a8739638e59448ef71252bfc695962",
      "download_error": null
    },
    {
      "track_id": "68aca503870c986ca59c0ac1",
      "name": "Barchessa",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.33,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Barchessa_Focus_DeepWork_Classical_130_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=Q1bmUeoncNVSsPoXVXmTmYbnXCs%2F0Nx2swfkAOsq7po%3D",
      "cdn_url": "https://audio2.brain.fm/Barchessa_Focus_DeepWork_Classical_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Barchessa_Focus_DeepWork_Classical_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Barchessa_Focus_DeepWork_Classical_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Barchessa_Focus_DeepWork_Classical_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29490341,
      "sha256": "dc1749e59d7c443ebd272fbccae1194caebc9d24010906806c95936ac624c643",
      "download_error": null
    },
    {
      "track_id": "689a23a09446c76349a3b774",
      "name": "Uncharted Waters",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.45,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/UnchartedWaters_Focus_DeepWork_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=fGtG%2B49Maxx%2B8ulfx3gWUJkgi9lxxyuvdIqTkM48K38%3D",
      "cdn_url": "https://audio2.brain.fm/UnchartedWaters_Focus_DeepWork_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnchartedWaters_Focus_DeepWork_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnchartedWaters_Focus_DeepWork_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/UnchartedWaters_Focus_DeepWork_Classical_110_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28576147,
      "sha256": "abc00a3f175881e9f4834134074956ef1d1a6a9ce015aa9c9a92a1263d1c15d8",
      "download_error": null
    },
    {
      "track_id": "687551513b891fead18abbd3",
      "name": "In A Broad Sense",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/InABroadSense_Focus_Learning_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=lymkRfyWEWAmj%2BaDunUhEZKatcInMcL7Stv%2BCMWH6UI%3D",
      "cdn_url": "https://audio2.brain.fm/InABroadSense_Focus_Learning_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InABroadSense_Focus_Learning_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InABroadSense_Focus_Learning_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/InABroadSense_Focus_Learning_Classical_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29613785,
      "sha256": "d75c05c46a77c47dbb22c71fe8e9f7218913fdadfa5abbfa8853b6d7321af2d0",
      "download_error": null
    },
    {
      "track_id": "6862efadda2d247f1a9c74f9",
      "name": "Tea Garden",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.51,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TeaGarden_Focus_DeepWork_Classical_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=bbeS6uc%2BGYl1i6ccEKfC2dyvSJuBTtqKtH0AXmANN04%3D",
      "cdn_url": "https://audio2.brain.fm/TeaGarden_Focus_DeepWork_Classical_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TeaGarden_Focus_DeepWork_Classical_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TeaGarden_Focus_DeepWork_Classical_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TeaGarden_Focus_DeepWork_Classical_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26708171,
      "sha256": "cf54909255ebcea22858167447d4ea77a2479baf6adc4d6169330707ea6eff9e",
      "download_error": null
    },
    {
      "track_id": "683dc8627e70e7db4e0af31f",
      "name": "Caravel",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 148,
      "brightness_level": 0.48,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Caravel_Focus_DeepWork_Classical_148_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=Q1f8xPfiwu5UFGTnKk5cd5ZpMhCRr4BfCsdHOLP7C0Q%3D",
      "cdn_url": "https://audio2.brain.fm/Caravel_Focus_DeepWork_Classical_148_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Caravel_Focus_DeepWork_Classical_148_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Caravel_Focus_DeepWork_Classical_148_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Caravel_Focus_DeepWork_Classical_148_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28452068,
      "sha256": "2f1475522ae412acfca8dec83e7a6a94b1064d0a9ccbbd129269010017510d1a",
      "download_error": null
    },
    {
      "track_id": "68065ae20216c6755a0be86e",
      "name": "The View From The Terrace",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.35,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TheViewFromTheTerrace_Focus_DeepWork_Classical_88_MedNELNrmlzd2_VBR5.mp3?expiration=1792292126584&token=ZP3uz%2FHhLyeZctVxREPjemTgXIrE15iNJW5NDys681Y%3D",
      "cdn_url": "https://audio2.brain.fm/TheViewFromTheTerrace_Focus_DeepWork_Classical_88_MedNELNrmlzd2_VBR5.mp3",
      "remote_filename": "TheViewFromTheTerrace_Focus_DeepWork_Classical_88_MedNELNrmlzd2_VBR5.mp3",
      "filename": "TheViewFromTheTerrace_Focus_DeepWork_Classical_88_MedNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TheViewFromTheTerrace_Focus_DeepWork_Classical_88_MedNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29087761,
      "sha256": "73120b94cb24fb3b48ebcd7432c1fa0e0dc70e30610f0962a37960d923faf7cd",
      "download_error": null
    },
    {
      "track_id": "67f3ebbaa0de2348f748e78d",
      "name": "The Estate",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.6,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TheEstate_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=MloHS7QIMg0vvsrFdPvqxmZVLqIxg4XQ%2BJ6zMG9BnWI%3D",
      "cdn_url": "https://audio2.brain.fm/TheEstate_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheEstate_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheEstate_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TheEstate_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28440800,
      "sha256": "1a7ecad827c398d384b3484cbca90b4ed120d16a3da228e87023329d0c123256",
      "download_error": null
    },
    {
      "track_id": "67e17e9e5177e5bfbd17fd79",
      "name": "Amberjack",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.45,
      "complexity_level": 0.86,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Amberjack_Focus_DeepWork_Classical_108_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=yC560cgMRHyhjVHc0hXXM29rQHb2uIpmEM8ZpmUjKRk%3D",
      "cdn_url": "https://audio2.brain.fm/Amberjack_Focus_DeepWork_Classical_108_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Amberjack_Focus_DeepWork_Classical_108_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Amberjack_Focus_DeepWork_Classical_108_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Amberjack_Focus_DeepWork_Classical_108_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29410972,
      "sha256": "6c010a54337f9fde99a17462796406b4528e7dac7693733454babee89430b1d9",
      "download_error": null
    },
    {
      "track_id": "67cf054c593aad5348b9660d",
      "name": "Seamstress",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.82,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Seamstress_Focus_DeepWork_Classical_100_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=baZ5MbybY9qlwSMT6pIHizbRTG2%2FrNkhkdUH9NhT3XQ%3D",
      "cdn_url": "https://audio2.brain.fm/Seamstress_Focus_DeepWork_Classical_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Seamstress_Focus_DeepWork_Classical_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Seamstress_Focus_DeepWork_Classical_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Seamstress_Focus_DeepWork_Classical_100_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30575312,
      "sha256": "3a65fef8d7b502fdf74c798d1e1fcec434fbab2f476d7ff62538cc813a802f51",
      "download_error": null
    },
    {
      "track_id": "6716a1e1ae8c98e954dc5cf6",
      "name": "Endless Acres",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.69,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/EndlessAcres_Focus_Learning_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=1nVP4cEA5KFCiHv9DXjnRRzvewdLQEWDmre26qVnxmU%3D",
      "cdn_url": "https://audio2.brain.fm/EndlessAcres_Focus_Learning_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EndlessAcres_Focus_Learning_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EndlessAcres_Focus_Learning_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/EndlessAcres_Focus_Learning_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29165326,
      "sha256": "d8bb1d18cd9f61f108d593d4848de397e0ac8a14336e3c6f1cf45404f02ed014",
      "download_error": null
    },
    {
      "track_id": "66f1774ad7073bdb179196e9",
      "name": "Natural Measures",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.72,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/NaturalMeasures_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=nVdNSUTuzV4wo0fTPcYsjEuNBAoC0DtZdUU%2BiXyCp1g%3D",
      "cdn_url": "https://audio2.brain.fm/NaturalMeasures_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NaturalMeasures_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NaturalMeasures_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/NaturalMeasures_Focus_DeepWork_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29086568,
      "sha256": "0f8f3648328ec8d780e449d61f4664a93941265043b75da225d7c21e81105b84",
      "download_error": null
    },
    {
      "track_id": "66f173d8eeda0376352f2c40",
      "name": "Before Returning",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.86,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/BeforeReturning_Focus_Creativity_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=EVZO5MwDc%2BQTRg0yTltEr43fWQpxzlIe8dxNtXxSf%2Fc%3D",
      "cdn_url": "https://audio2.brain.fm/BeforeReturning_Focus_Creativity_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BeforeReturning_Focus_Creativity_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BeforeReturning_Focus_Creativity_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/BeforeReturning_Focus_Creativity_Classical_120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29997140,
      "sha256": "8f8cdab70bd4b91306db5503dd9de4d3594476ea4c9023e6e68a5ee49dad54f5",
      "download_error": null
    },
    {
      "track_id": "66cc938847ed87e8383b7242",
      "name": "Wind Trio No. 1",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.65,
      "complexity_level": 0.33,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/WindTrioNo.1_Focus_Creativity_Classical_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=xnwRG9zSi6btVaAmOyqP8CFCYwsmdUcNn6WA7kg0kJY%3D",
      "cdn_url": "https://audio2.brain.fm/WindTrioNo.1_Focus_Creativity_Classical_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WindTrioNo.1_Focus_Creativity_Classical_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WindTrioNo.1_Focus_Creativity_Classical_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/WindTrioNo.1_Focus_Creativity_Classical_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28999401,
      "sha256": "7905dcd32d4567063b4ce6beab8092654373278bc97dc47de50e6ad767728fc4",
      "download_error": null
    },
    {
      "track_id": "66918b9fde19d0f1c74ea7b7",
      "name": "Tender Heart",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.61,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TenderHeart_Focus_DeepWork_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=cbczIgGJP5IdtWs5PzOU07OzZ2404xYPVa%2F2z4jZMD0%3D",
      "cdn_url": "https://audio2.brain.fm/TenderHeart_Focus_DeepWork_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TenderHeart_Focus_DeepWork_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TenderHeart_Focus_DeepWork_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TenderHeart_Focus_DeepWork_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26894738,
      "sha256": "427e093793114c013ad12c578a3d8a122414fe7e20182b7136396c5e53abe6b6",
      "download_error": null
    },
    {
      "track_id": "6683fda2d98e4183c363e8ca",
      "name": "The Light Returns",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.72,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TheLightReturns_Focus_DeepWork_Classical_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=oN85xtkRFY%2BP0roZsvFbMP9g8OidQkHJDgu1KJb%2Bjco%3D",
      "cdn_url": "https://audio2.brain.fm/TheLightReturns_Focus_DeepWork_Classical_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheLightReturns_Focus_DeepWork_Classical_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheLightReturns_Focus_DeepWork_Classical_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TheLightReturns_Focus_DeepWork_Classical_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27579030,
      "sha256": "23416e0b5f0095eeb226b9a065b0ff2adebd9a858d6e2e6cfa443ace63656fa1",
      "download_error": null
    },
    {
      "track_id": "665a226f4dfb90cc19dcd9a3",
      "name": "Fluttering Forest",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.65,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/FlutteringForest_Focus_DeepWork_Classical_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=ASnuG1RyNS%2B7dEJQ6mHHQLOiPF6DrWOalNNOZR4LRfc%3D",
      "cdn_url": "https://audio2.brain.fm/FlutteringForest_Focus_DeepWork_Classical_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FlutteringForest_Focus_DeepWork_Classical_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FlutteringForest_Focus_DeepWork_Classical_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/FlutteringForest_Focus_DeepWork_Classical_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27555319,
      "sha256": "0f4093c8964d23b828808195a15baa0f648e1cae60d805d592e60e191531c2e6",
      "download_error": null
    },
    {
      "track_id": "65d9206f636e0500086cb330",
      "name": "Snowdrops",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.74,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Snowdrops_Focus_DeepWork_Classical_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=SQVGL5b%2FPHTLMK25XcbGmv7Oo8NVsCY1LT7570k81yE%3D",
      "cdn_url": "https://audio2.brain.fm/Snowdrops_Focus_DeepWork_Classical_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Snowdrops_Focus_DeepWork_Classical_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Snowdrops_Focus_DeepWork_Classical_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Snowdrops_Focus_DeepWork_Classical_30_114bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28015621,
      "sha256": "71bf52c810c39009a13ec95823915ff140fe33f3a9abb657796e1002299d6026",
      "download_error": null
    },
    {
      "track_id": "65c6915911ce62000864c21c",
      "name": "Edict",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.74,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Edict_Focus_DeepWork_Classical_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=e%2Fxov5dGXzsfVr4WioKJLbGI4h%2BbnVniDUDOD29X%2FDY%3D",
      "cdn_url": "https://audio2.brain.fm/Edict_Focus_DeepWork_Classical_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Edict_Focus_DeepWork_Classical_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Edict_Focus_DeepWork_Classical_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Edict_Focus_DeepWork_Classical_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26741809,
      "sha256": "28338d8300b4c4d14768ad6939e9cee18dda7d1ecc50e850a689d765b380797d",
      "download_error": null
    },
    {
      "track_id": "65c6914511ce62000864c1cb",
      "name": "Romance for String Orchestra",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.95,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.86,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/RomanceforStringOrchestra_Focus_Creativity_Classical_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=nK2JbLOO6TepHKjfvOBTnvYYcBrc3qqzhtQscGODX%2Bw%3D",
      "cdn_url": "https://audio2.brain.fm/RomanceforStringOrchestra_Focus_Creativity_Classical_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RomanceforStringOrchestra_Focus_Creativity_Classical_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RomanceforStringOrchestra_Focus_Creativity_Classical_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/RomanceforStringOrchestra_Focus_Creativity_Classical_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28441161,
      "sha256": "ee804a926309524bb081a08012a6aa552b5cff44ceb7b749dd3f79cf5340c608",
      "download_error": null
    },
    {
      "track_id": "65b3fa86349c8a0009283ee8",
      "name": "Wanderer",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.41,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.95,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Wanderer_Focus_DeepWork_Classical_30_88bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=mCOHMFYQmB%2FE8KtrelBhKBWbsIKDOuZ912SoZN4woHI%3D",
      "cdn_url": "https://audio2.brain.fm/Wanderer_Focus_DeepWork_Classical_30_88bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Wanderer_Focus_DeepWork_Classical_30_88bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Wanderer_Focus_DeepWork_Classical_30_88bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Wanderer_Focus_DeepWork_Classical_30_88bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28896175,
      "sha256": "82d7739818fde186496104e1920e49a10714f5a4fe754a2bfd1c5e1e51ef0063",
      "download_error": null
    },
    {
      "track_id": "65a035326f05fa0008c15a0d",
      "name": "Luminous Day",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.68,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/LuminousDay_Focus_DeepWork_Classical_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=Py5FVztSldyQT2zp17vKmxsdlDlLJnpeKySHXbzFZ10%3D",
      "cdn_url": "https://audio2.brain.fm/LuminousDay_Focus_DeepWork_Classical_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LuminousDay_Focus_DeepWork_Classical_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LuminousDay_Focus_DeepWork_Classical_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/LuminousDay_Focus_DeepWork_Classical_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27526531,
      "sha256": "456e114f936a18e410b6f5bf4fa92ac9ddb51104ae8af4ded4dd805aa2ae8cd3",
      "download_error": null
    },
    {
      "track_id": "658c903f7a6b3300085e0cbf",
      "name": "Harvest",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.89,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Harvest_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=QHqgrHxXAxdwZWTwz%2BLNbk6YZKTXG5rAyccv%2BsYoVkQ%3D",
      "cdn_url": "https://audio2.brain.fm/Harvest_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Harvest_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Harvest_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Harvest_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27827958,
      "sha256": "34aa5014c114142ac6fe276636e7d65fcbcb27a97197d45b58898c649b27b7f8",
      "download_error": null
    },
    {
      "track_id": "658c902a9a74fb00089d441a",
      "name": "Concerto Variations No. 2",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 134,
      "brightness_level": 0.88,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ConcertoVariationsNo.2_Focus_Creativity_Classical_30_134bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=uRGSw5Ir6OW1FdYApomhLGBbzEaHj8nu12fsfmkZ6tg%3D",
      "cdn_url": "https://audio2.brain.fm/ConcertoVariationsNo.2_Focus_Creativity_Classical_30_134bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ConcertoVariationsNo.2_Focus_Creativity_Classical_30_134bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ConcertoVariationsNo.2_Focus_Creativity_Classical_30_134bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ConcertoVariationsNo.2_Focus_Creativity_Classical_30_134bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29075326,
      "sha256": "9b21eada8e14846bdeeb5122acc4584bd47c8d62337cf0cc5da40b169b91c317",
      "download_error": null
    },
    {
      "track_id": "655bc7c5f30817771abb061c",
      "name": "Colors of Autumn",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.96,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ColorsofAutumn_Focus_DeepWork_Classical_30_94bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=SywJODLHghvnP%2B2MkfCcentilfcILtbzsBkF%2Fw99kLc%3D",
      "cdn_url": "https://audio2.brain.fm/ColorsofAutumn_Focus_DeepWork_Classical_30_94bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ColorsofAutumn_Focus_DeepWork_Classical_30_94bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ColorsofAutumn_Focus_DeepWork_Classical_30_94bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ColorsofAutumn_Focus_DeepWork_Classical_30_94bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29018085,
      "sha256": "23df190aa58f5d17a718f45e60271926585fc1f5ddc4fb65ec03b6f6ca3252bc",
      "download_error": null
    },
    {
      "track_id": "654aa8436986436bbfb415a4",
      "name": "Sonata for Harp (Extended Mix)",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 7068,
      "beats_per_minute": 124,
      "brightness_level": 0.57,
      "complexity_level": 0.63,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/SonataforHarp_Focus_Creativity_Classical_30_124bpm_LowNEL_Nrmlzd2_expanded_VBR5.mp3?expiration=1792292126584&token=HVu0hwBQzikIZh0mj3gFlX7uHStcpZ57b3CwI2y9Ejc%3D",
      "cdn_url": "https://audio2.brain.fm/SonataforHarp_Focus_Creativity_Classical_30_124bpm_LowNEL_Nrmlzd2_expanded_VBR5.mp3",
      "remote_filename": "SonataforHarp_Focus_Creativity_Classical_30_124bpm_LowNEL_Nrmlzd2_expanded_VBR5.mp3",
      "filename": "SonataforHarp_Focus_Creativity_Classical_30_124bpm_LowNEL_Nrmlzd2_expanded_VBR5.mp3",
      "relative_path": "outputs/audio/classical/SonataforHarp_Focus_Creativity_Classical_30_124bpm_LowNEL_Nrmlzd2_expanded_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 115373146,
      "sha256": "abfff5f517830c23d774895b591a1c64c3d76caf0c1a4ff878bd78d12a7f6a63",
      "download_error": null
    },
    {
      "track_id": "654aa83562cef5755a8bb60b",
      "name": "Sonata for Harp",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.57,
      "complexity_level": 0.63,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/SonataforHarp_Focus_Creativity_Classical_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=%2FMYq1pZfkJj%2BSA1foQ6aeaY4%2Fb%2Bpn9F2BIAISupkOuw%3D",
      "cdn_url": "https://audio2.brain.fm/SonataforHarp_Focus_Creativity_Classical_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SonataforHarp_Focus_Creativity_Classical_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SonataforHarp_Focus_Creativity_Classical_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/SonataforHarp_Focus_Creativity_Classical_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29212063,
      "sha256": "5522c3d10648813eceb51582af2c67b30ea5c741fbbdb45367146865073a6259",
      "download_error": null
    },
    {
      "track_id": "65316413bab2d65fb019e458",
      "name": "Spring Tide",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.44,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/SpringTide_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=PBJPjIxf8b4PgeqouqP8m41hGAOBVaa5x0KjyDdGdiU%3D",
      "cdn_url": "https://audio2.brain.fm/SpringTide_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SpringTide_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SpringTide_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/SpringTide_Focus_DeepWork_Classical_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28366431,
      "sha256": "4f051e5a8bcb3c5ba19ffabcb3f29406f6b382034786057c1fd4b363cdb927bf",
      "download_error": null
    },
    {
      "track_id": "651ddb477f63d37dc515868a",
      "name": "Waiting Game",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.64,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/WaitingGame_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=gjZAG8fAJyhdp8X1oIidcY7fFc5ud%2Fdy1q1as7CpaFQ%3D",
      "cdn_url": "https://audio2.brain.fm/WaitingGame_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WaitingGame_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WaitingGame_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/WaitingGame_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27647525,
      "sha256": "1b3c9671725258c95ebeae46fba8d3a15e68c24497c08f5bbe95b0c00e129ad7",
      "download_error": null
    },
    {
      "track_id": "64f9e8f00faeaa8ca7bd62eb",
      "name": "Duet for Cello & Bass",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.68,
      "complexity_level": 0.53,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/DuetforCello%26Bass_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=JwbPgkrMK3EOUrhCVb4bwKMMjSebntd9Ew5%2BH1zpfho%3D",
      "cdn_url": "https://audio2.brain.fm/DuetforCello%26Bass_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DuetforCello&Bass_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DuetforCello-Bass_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/DuetforCello-Bass_Focus_Creativity_Classical_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27868572,
      "sha256": "e3fe113bd88220a77d4e3ef51dd83145ffcd2ee0e78fa05a700452559d9baf7d",
      "download_error": null
    },
    {
      "track_id": "64dcff2f3a44d072388cbd2f",
      "name": "Living Proof",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 117,
      "brightness_level": 0.82,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/LivingProof_Focus_DeepWork_Classical_30_117bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=yXr4Nlhzp9vISGELiT8OxmK7IV%2F9zSwYyC1kZX8Wk%2BE%3D",
      "cdn_url": "https://audio2.brain.fm/LivingProof_Focus_DeepWork_Classical_30_117bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LivingProof_Focus_DeepWork_Classical_30_117bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LivingProof_Focus_DeepWork_Classical_30_117bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/LivingProof_Focus_DeepWork_Classical_30_117bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28105381,
      "sha256": "785f796dabeed835be0cda7857a2ebcdefb008e191243779a6be58d5a4b0be9b",
      "download_error": null
    },
    {
      "track_id": "64dcfed53a44d018c68cbbd2",
      "name": "Concerto Variations No. 1",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.88,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ConcertoVariationsNo.1_Focus_Creativity_Classical_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=otSRUXTpJCNMqcLRbaX8zNd6sSz7fppyVkjaphiDGlA%3D",
      "cdn_url": "https://audio2.brain.fm/ConcertoVariationsNo.1_Focus_Creativity_Classical_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ConcertoVariationsNo.1_Focus_Creativity_Classical_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ConcertoVariationsNo.1_Focus_Creativity_Classical_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ConcertoVariationsNo.1_Focus_Creativity_Classical_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27758421,
      "sha256": "d44e7126c6b813e96082ad62fd964b1a2afd61b1c54e7e4ef52e4fbd9e355e8f",
      "download_error": null
    },
    {
      "track_id": "646f7479c393a757b973e12c",
      "name": "The Crucible",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.72,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/TheCrucible_Focus_DeepWork_Classical_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=zboTefDccmia4nl6bEgV88ZbuJQ%2FeKPEkt9VyKRQIE0%3D",
      "cdn_url": "https://audio2.brain.fm/TheCrucible_Focus_DeepWork_Classical_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheCrucible_Focus_DeepWork_Classical_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheCrucible_Focus_DeepWork_Classical_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/TheCrucible_Focus_DeepWork_Classical_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27107001,
      "sha256": "77c093e45dfe90b4949d1b9142852033fefd80fbf4a136d2dcdb9b4e05462760",
      "download_error": null
    },
    {
      "track_id": "646f746bc393a76dd873e0ff",
      "name": "Ascending Parnassus",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.65,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/AscendingParnassus_Focus_Creativity_Classical_30_112bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=%2Fs5FnVdchKQ32zeIWL1I5tc6FGlgdKJJz7OclNd0HHM%3D",
      "cdn_url": "https://audio2.brain.fm/AscendingParnassus_Focus_Creativity_Classical_30_112bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AscendingParnassus_Focus_Creativity_Classical_30_112bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AscendingParnassus_Focus_Creativity_Classical_30_112bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/AscendingParnassus_Focus_Creativity_Classical_30_112bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27240513,
      "sha256": "ba8741a9248d65c667d33fe7f6ed84c3624e71a3472a03781aa5229d7749023e",
      "download_error": null
    },
    {
      "track_id": "646f745cfd5c84b6e4a11e80",
      "name": "Sonata Sensitivo",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.31,
      "complexity_level": 0.64,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/SonataSensitivo_Focus_Creativity_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=9nVQpJfigCjwPUg4BrTnoBKcsQe8gTVv9To2J%2BLAurk%3D",
      "cdn_url": "https://audio2.brain.fm/SonataSensitivo_Focus_Creativity_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SonataSensitivo_Focus_Creativity_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SonataSensitivo_Focus_Creativity_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/SonataSensitivo_Focus_Creativity_Classical_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23636496,
      "sha256": "bf3c1c5323d0a23c60b8680163a8f43887da86a08df1c0e505829f7bfe1ea4d6",
      "download_error": null
    },
    {
      "track_id": "64302ca023c3be701c3fb962",
      "name": "Pieces for String Orchestra",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.93,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Pieces%20for%20String%20Orchestra%20by%20Felix%20Mendelssohn%20and%20Edward%20Elgar%20Classical%20Focus%20Study%20Conor_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=GwCiG3urPC0Z4oAMhBjMypQfnY8RSVWmUInguOk%2Bl20%3D",
      "cdn_url": "https://audio2.brain.fm/Pieces%20for%20String%20Orchestra%20by%20Felix%20Mendelssohn%20and%20Edward%20Elgar%20Classical%20Focus%20Study%20Conor_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pieces for String Orchestra by Felix Mendelssohn and Edward Elgar Classical Focus Study Conor_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Pieces-for-String-Orchestra-by-Felix-Mendelssohn-and-Edward-Elgar-Classical-Focus-Study-Conor_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Pieces-for-String-Orchestra-by-Felix-Mendelssohn-and-Edward-Elgar-Classical-Focus-Study-Conor_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28528851,
      "sha256": "386d80a5ec11e0dcfea2d21a14568a503a884aaca462da25a0e1b280187c373b",
      "download_error": null
    },
    {
      "track_id": "6430280c23c3be030c3fa329",
      "name": "5 Pieces for the Piano",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.33,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Album%20of%205%20Pieces%20for%20the%20Piano%20by%20Claude%20Debussy%20Classical%20Focus%20Study%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=NAehL4%2FW3sJVEJNvo0BbJl5P%2FVH7O7%2BSpZZpRmcay14%3D",
      "cdn_url": "https://audio2.brain.fm/Album%20of%205%20Pieces%20for%20the%20Piano%20by%20Claude%20Debussy%20Classical%20Focus%20Study%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Album of 5 Pieces for the Piano by Claude Debussy Classical Focus Study Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Album-of-5-Pieces-for-the-Piano-by-Claude-Debussy-Classical-Focus-Study-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Album-of-5-Pieces-for-the-Piano-by-Claude-Debussy-Classical-Focus-Study-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23918796,
      "sha256": "819e212df33a17717de37e9f8ae9390605ea6736c581d036e1bf424ab772734b",
      "download_error": null
    },
    {
      "track_id": "633d960683f4ff0a8ea2cb90",
      "name": "Vivaldi Cello Sonata",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.61,
      "complexity_level": 0.74,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/VivaldiCelloSonata_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=bIBnu2xPsFqIlB5dwHl1Vk2fpD4lsQTML1qosNjE54A%3D",
      "cdn_url": "https://audio2.brain.fm/VivaldiCelloSonata_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "VivaldiCelloSonata_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "VivaldiCelloSonata_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/VivaldiCelloSonata_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23948109,
      "sha256": "069e387662fa5e0fe19e84655b29d217946bd8450069e3f1936f8a739bc6d070",
      "download_error": null
    },
    {
      "track_id": "633d95d3840cdf3e04578f23",
      "name": "Violin Sonata in E Major",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.99,
      "complexity_level": 0.92,
      "style": "normal",
      "neural_effect_level": 0.29,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Bach%20Violin%20Sonata%20in%20E%20Major_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=7p7F0mm%2FuC8%2Fl%2F%2FcYtUsvRQ8mHYvXzpeHEH65yv0Huk%3D",
      "cdn_url": "https://audio2.brain.fm/Bach%20Violin%20Sonata%20in%20E%20Major_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bach Violin Sonata in E Major_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "filename": "Bach-Violin-Sonata-in-E-Major_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Bach-Violin-Sonata-in-E-Major_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28338291,
      "sha256": "9986f21cd12aca62ff8ac55e1d878249fcd1b70a6f7a9cfd77d5637ffd70637e",
      "download_error": null
    },
    {
      "track_id": "633d95a083f4ff8b6ca2c9ed",
      "name": "Scarlatti Sonata Collection 3",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.33,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ScarlattiSonataCollection3_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=BNX8TSQWZwLjRfi5gBBYa4LsEoN4mIrX08xg%2FySamrY%3D",
      "cdn_url": "https://audio2.brain.fm/ScarlattiSonataCollection3_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ScarlattiSonataCollection3_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "ScarlattiSonataCollection3_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ScarlattiSonataCollection3_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26517164,
      "sha256": "8e39447b768b5256e50fca788c8c1cf90338d5ecb925b6790616982ad111ef60",
      "download_error": null
    },
    {
      "track_id": "633d9567840cdfb3d9578d47",
      "name": "Scarlatti Sonata Collection 2",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.19,
      "complexity_level": 0.67,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ScarlattiSonataCollection2_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=vfYBuUaQGEKd8xkSbt%2FrAZJUE1lFdU%2BAEQwCs1cdnuU%3D",
      "cdn_url": "https://audio2.brain.fm/ScarlattiSonataCollection2_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ScarlattiSonataCollection2_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "ScarlattiSonataCollection2_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ScarlattiSonataCollection2_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25555727,
      "sha256": "c346042f3e7cac54fac311059653eea1d7d56e3798308b9fe806b1e76ccfba1f",
      "download_error": null
    },
    {
      "track_id": "633d953c840cdf54ce578cb8",
      "name": "Scarlatti Sonata Collection 1",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.36,
      "complexity_level": 0.8,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ScarlattiSonataCollection1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=7XfSRLFYlMr0%2F5UHZjgG5H9KtAIncqZ42BjqhDYjVoE%3D",
      "cdn_url": "https://audio2.brain.fm/ScarlattiSonataCollection1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ScarlattiSonataCollection1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "ScarlattiSonataCollection1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ScarlattiSonataCollection1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26607896,
      "sha256": "f0367ed3a7b1f66d0a1294d727ad36f25b0e28322268089f033da086afe20fda",
      "download_error": null
    },
    {
      "track_id": "633d9508840cdf59dd578c1c",
      "name": "Romanzen und Balladen",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.69,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/RomanzenundBalladen1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=XEzUNH0vH6fpJeSGgJ%2BwqrnaOYdwga3K87PxRJSMD0E%3D",
      "cdn_url": "https://audio2.brain.fm/RomanzenundBalladen1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RomanzenundBalladen1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "RomanzenundBalladen1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/RomanzenundBalladen1_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25825792,
      "sha256": "020aadaf5eeb90b2ec6e4feb9c1c80542cf91ff8da504a2bbb3e6ac092921d05",
      "download_error": null
    },
    {
      "track_id": "633d94bd83f4ff28b3a2c079",
      "name": "Preludes for Harp",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.56,
      "complexity_level": 0.81,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/PreludesforHarp_Focus_Creativity_Classical_30_variablebpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=7z3LghKKwDi4HNYl02Wladc6Qv%2BS54rWmFw5vPwlNDs%3D",
      "cdn_url": "https://audio2.brain.fm/PreludesforHarp_Focus_Creativity_Classical_30_variablebpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PreludesforHarp_Focus_Creativity_Classical_30_variablebpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PreludesforHarp_Focus_Creativity_Classical_30_variablebpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/PreludesforHarp_Focus_Creativity_Classical_30_variablebpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27454700,
      "sha256": "205e21e81d3992c86c25d0a9b0746db5879e79455e774ef26b5af8230bd992e1",
      "download_error": null
    },
    {
      "track_id": "633d945683f4ff4072a2be14",
      "name": "Pieces for Violin and Piano",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.73,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/PiecesforViolinandPiano_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=MG8qPXctWbCAUur2FrR45dFmzam%2F0VFv26lwKONe8Hs%3D",
      "cdn_url": "https://audio2.brain.fm/PiecesforViolinandPiano_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PiecesforViolinandPiano_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "PiecesforViolinandPiano_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/PiecesforViolinandPiano_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28015013,
      "sha256": "2442b0351087aae70ae23516595431c5649883a76deffe261544fd0081581584",
      "download_error": null
    },
    {
      "track_id": "633d942283f4ff3a0ca2bcab",
      "name": "Pieces for Harp and Flute",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.46,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/PiecesforHarpandFlute_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=sqHB61dWSmQuIK28k37gnkRHmYMqMcDOj2Pj4L9iGig%3D",
      "cdn_url": "https://audio2.brain.fm/PiecesforHarpandFlute_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PiecesforHarpandFlute_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "PiecesforHarpandFlute_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/PiecesforHarpandFlute_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27893250,
      "sha256": "4eca310b17552b7f4d75b239fb3dbdf8d9e03d05ad894d467ec8aa79ccc910e4",
      "download_error": null
    },
    {
      "track_id": "633d93eb83f4ffc296a2ba1f",
      "name": "Mompou Pieces for Piano",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.06,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.98,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/MompouPiecesforPiano_Focus_Creativity_Classical_30_variablebpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=4CeTBVuatkJOBRjp0CYR9vA9LnY1xiUFT7nqvBmJ6bE%3D",
      "cdn_url": "https://audio2.brain.fm/MompouPiecesforPiano_Focus_Creativity_Classical_30_variablebpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MompouPiecesforPiano_Focus_Creativity_Classical_30_variablebpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MompouPiecesforPiano_Focus_Creativity_Classical_30_variablebpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/MompouPiecesforPiano_Focus_Creativity_Classical_30_variablebpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23484443,
      "sha256": "5055a340cc745695cd66f3fff886606c81ad2877ef390492158c198dee606cba",
      "download_error": null
    },
    {
      "track_id": "633d93bb840cdf853e5787d4",
      "name": "Five Nocturnes",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.17,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/5%20Nocturnes%20by%20Erik%20Satie_Focus_CreativeFlow_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=ASfH%2B3wJ5rnwOJIVtA9Mdeh3z0MaN4ZCW2MCjn3E4Ds%3D",
      "cdn_url": "https://audio2.brain.fm/5%20Nocturnes%20by%20Erik%20Satie_Focus_CreativeFlow_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "remote_filename": "5 Nocturnes by Erik Satie_Focus_CreativeFlow_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "filename": "5-Nocturnes-by-Erik-Satie_Focus_CreativeFlow_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/5-Nocturnes-by-Erik-Satie_Focus_CreativeFlow_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27217201,
      "sha256": "9103cfadadfe50ed325261a6f46e4b12627f352ce4a35a941176861d3e1e052e",
      "download_error": null
    },
    {
      "track_id": "633d9384840cdf7580578706",
      "name": "Concerto for Two Violins",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 1,
      "complexity_level": 0.84,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Vivaldi%20Concerto%20for%202%20Violins_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=lBMpPamgyZhlNJTMObSjcB4AyHgBXnbBcU7bS0E9meA%3D",
      "cdn_url": "https://audio2.brain.fm/Vivaldi%20Concerto%20for%202%20Violins_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Vivaldi Concerto for 2 Violins_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "filename": "Vivaldi-Concerto-for-2-Violins_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Vivaldi-Concerto-for-2-Violins_Focus_Creativity_Classical_30_VariableBPM_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30087732,
      "sha256": "98e6c185a02ac35dc410aecd0c7bc080b26a458d96549703f3b290eee065b3bd",
      "download_error": null
    },
    {
      "track_id": "633d934b83f4ff1d26a2b7d4",
      "name": "Cello and Piano Suites",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.59,
      "complexity_level": 0.97,
      "style": "normal",
      "neural_effect_level": 0.62,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/CelloandPianoSuites_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=tYZmxM%2F7zKyNT202cVapiEjj9TWExRlUj3buhzZwPEo%3D",
      "cdn_url": "https://audio2.brain.fm/CelloandPianoSuites_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CelloandPianoSuites_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "CelloandPianoSuites_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/CelloandPianoSuites_Focus_Creativity_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25997959,
      "sha256": "f00c9f47c4dfde2d7bc1bc60f9aed349553195fce5c9b367bd4034094fd4a613",
      "download_error": null
    },
    {
      "track_id": "631229b52d3936406e9c0e2a",
      "name": "Missa Pange Lingua",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.8,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/MissPangeLingua_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=yJC9KNzQ71xo8wA%2BEWhNOA6vv31%2Brj%2FtY%2BdTPl74LwE%3D",
      "cdn_url": "https://audio2.brain.fm/MissPangeLingua_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MissPangeLingua_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "MissPangeLingua_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/MissPangeLingua_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29264098,
      "sha256": "a09d357a81d482055b01fae83c2fa34ebd62899ba3b3db4b8759bdbae8d8b902",
      "download_error": null
    },
    {
      "track_id": "631229872d3936ad529c0d0f",
      "name": "Mass for Strings",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.98,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/MassForStrings_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=%2BL%2FSCeMPRlRwIpQAHf8uTdODNdgYL6R2KbW2wD1kRNI%3D",
      "cdn_url": "https://audio2.brain.fm/MassForStrings_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MassForStrings_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "MassForStrings_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/MassForStrings_Focus_DeepWork_Classical_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28628442,
      "sha256": "9944264ce0d5ecf5c7007d5617a6e7569dcbddafaafe2edec7cf82b1f57582f4",
      "download_error": null
    },
    {
      "track_id": "6312295198e7cbe63d303d7c",
      "name": "Mahler Adagietto",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 40,
      "brightness_level": 0.64,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/MahlerAdagietto_Focus_DeepWork_Classical_30_40bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=Xel8ak5fWkoGWiikFvmXTGB30pIINa9maX2mzxOWoaM%3D",
      "cdn_url": "https://audio2.brain.fm/MahlerAdagietto_Focus_DeepWork_Classical_30_40bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MahlerAdagietto_Focus_DeepWork_Classical_30_40bpm_Nrmlzd2_VBR5.mp3",
      "filename": "MahlerAdagietto_Focus_DeepWork_Classical_30_40bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/MahlerAdagietto_Focus_DeepWork_Classical_30_40bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27675838,
      "sha256": "7032aed2224e84fc0b0a16ddd33f506252a880dbb63991eaa7351e0ee02e34b9",
      "download_error": null
    },
    {
      "track_id": "6312290e2d39361fb29c09fb",
      "name": "Byrd Mass Medley",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.83,
      "complexity_level": 0.87,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ByrdMassMedley_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=nYmNgclaMPU23Jum9DNjK%2BEVK2Mr5nPNWzHilbdPURU%3D",
      "cdn_url": "https://audio2.brain.fm/ByrdMassMedley_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ByrdMassMedley_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "ByrdMassMedley_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ByrdMassMedley_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27594298,
      "sha256": "c478f5370a7de2f352f9e58d20d2ef95c4c313af66c8819be57210093c39991a",
      "download_error": null
    },
    {
      "track_id": "631228d72d393646b79c084f",
      "name": "Pieces for Piano by Amy Beach",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 1,
      "brightness_level": 0.16,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Eskimos_Focus_DeepWork_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=idAHT3AgmJ5WzmYdNTzg460xwy4MGMOQH7ulQNz3s5U%3D",
      "cdn_url": "https://audio2.brain.fm/Eskimos_Focus_DeepWork_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Eskimos_Focus_DeepWork_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "Eskimos_Focus_DeepWork_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Eskimos_Focus_DeepWork_Classical_30_variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23476783,
      "sha256": "4eb3cf4f46562f73a812e44ea97eab9c0a51ade1720b128aa4fcaea7b5d7ece6",
      "download_error": null
    },
    {
      "track_id": "6312286a98e7cbaf9e30366a",
      "name": "Nocturnes for Strings",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 55,
      "brightness_level": 0.84,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/NocturnesforStrings_Focus_DeepWork_Classical_30_55bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=iS2YmUY40WQSx2FQJG9sLoXQXtZpC%2BeIkYD%2F1bQG3X0%3D",
      "cdn_url": "https://audio2.brain.fm/NocturnesforStrings_Focus_DeepWork_Classical_30_55bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NocturnesforStrings_Focus_DeepWork_Classical_30_55bpm_Nrmlzd2_VBR5.mp3",
      "filename": "NocturnesforStrings_Focus_DeepWork_Classical_30_55bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/NocturnesforStrings_Focus_DeepWork_Classical_30_55bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28545971,
      "sha256": "60d5b7ddd0ac48e10a57c9d385cf25006f2d145ea280eb332e17b70f603dc71b",
      "download_error": null
    },
    {
      "track_id": "6312282c2d3936e3829c062c",
      "name": "Missa de Beata Virgine",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.7,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/MissadeBeataVirgine_Focus_DeepWork_Classical_30_96bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=zisNJl4G6SEXkJjdeJghgkwFBY%2F%2FjsZJjRMKez%2B%2B6wk%3D",
      "cdn_url": "https://audio2.brain.fm/MissadeBeataVirgine_Focus_DeepWork_Classical_30_96bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MissadeBeataVirgine_Focus_DeepWork_Classical_30_96bpm_Nrmlzd2_VBR5.mp3",
      "filename": "MissadeBeataVirgine_Focus_DeepWork_Classical_30_96bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/MissadeBeataVirgine_Focus_DeepWork_Classical_30_96bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28690150,
      "sha256": "7f41e0e146d9964683fd124459bfc8b32b8e2633bcbde34e1a625b00ec5caabe",
      "download_error": null
    },
    {
      "track_id": "6312280098e7cb792b3033eb",
      "name": "Byrd Mass a 5",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.71,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ByrdMassa5_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=d4rCZfgqwQ3qLQfjADCMwjcm0xOxkLNdw9GzP0C8yLI%3D",
      "cdn_url": "https://audio2.brain.fm/ByrdMassa5_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ByrdMassa5_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "ByrdMassa5_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ByrdMassa5_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28304113,
      "sha256": "6a27eeb178b4ce4a329968dda83628c21909ce9f13a894366e7a4115248f2411",
      "download_error": null
    },
    {
      "track_id": "631227d498e7cb7439303355",
      "name": "Byrd Mass a 3",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.96,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/ByrdMassa3_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=s8hSbf1pQOtWKE%2BX5mv21HlGY0hWnlGiYhnFrqmB95o%3D",
      "cdn_url": "https://audio2.brain.fm/ByrdMassa3_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ByrdMassa3_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "ByrdMassa3_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/ByrdMassa3_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29046601,
      "sha256": "044df2f65ae3675c59237ac25dfb1995c2b5c735986db8c55cd5f2f2ed882c15",
      "download_error": null
    },
    {
      "track_id": "6312279c98e7cb25673032e3",
      "name": "Missa ad Fugum",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.76,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/MissaadFugum_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=9NA5XZbuGK%2Fo2d6H%2BckoYHDOWzaBTa8M12XOJQQxcsU%3D",
      "cdn_url": "https://audio2.brain.fm/MissaadFugum_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MissaadFugum_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "MissaadFugum_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/MissaadFugum_Focus_DeepWork_Classical_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28903659,
      "sha256": "ca378dd2b96f1e43dfab0d0fbe3a4d31a2be93c3a56ad53729a9fcf05ecf758f",
      "download_error": null
    },
    {
      "track_id": "62b391ab59241107ebf561f6",
      "name": "Elegies for Strings by Piotr Tchaikovsky and FS Kelly",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Elegies%20for%20Strings%20by%20Piotr%20Tchaikovsky%20and%20FS%20Kelly%201.1%20Classical%20Focus%20Creative%20Flow%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=yBPjer8bUp%2BDSc3iT%2BoLe%2BtnBtRPzFiMJbIUPpHUt7E%3D",
      "cdn_url": "https://audio2.brain.fm/Elegies%20for%20Strings%20by%20Piotr%20Tchaikovsky%20and%20FS%20Kelly%201.1%20Classical%20Focus%20Creative%20Flow%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Elegies for Strings by Piotr Tchaikovsky and FS Kelly 1.1 Classical Focus Creative Flow Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Elegies-for-Strings-by-Piotr-Tchaikovsky-and-FS-Kelly-1.1-Classical-Focus-Creative-Flow-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Elegies-for-Strings-by-Piotr-Tchaikovsky-and-FS-Kelly-1.1-Classical-Focus-Creative-Flow-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28747294,
      "sha256": "8079d20dee1d30ddfa6ef52904e30a3007451ea35c2183ac260c8b7ff504a6b1",
      "download_error": null
    },
    {
      "track_id": "62b38c205924112f11f555c2",
      "name": "Bach Medley",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.43,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Bach%201%20Classical%20Focus%20Chris_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=8eA%2BfHRv19ccjnuhkPdwnoCuOdHwBZq174PaEqBQ2e8%3D",
      "cdn_url": "https://audio2.brain.fm/Bach%201%20Classical%20Focus%20Chris_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bach 1 Classical Focus Chris_Nrmlzd2_VBR5.mp3",
      "filename": "Bach-1-Classical-Focus-Chris_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Bach-1-Classical-Focus-Chris_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21226232,
      "sha256": "8a81c523253ce2d98100041d01bdf59f5650e79cb43dc9013f89ead4ebb7fc41",
      "download_error": null
    },
    {
      "track_id": "62b38ae1592411ef33f54b7e",
      "name": "Woodwind Quintet No. 1",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.77,
      "complexity_level": 0.37,
      "style": "normal",
      "neural_effect_level": 0,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Giuseppe%20Maria%20Cambini%20Woodwind%20Quintet%20No.%201%20in%20B%20Flat%20Major%20Classical%20Focus%20Light%20Work%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=uZZw5Xu5iv6ltAKQR9LjXQ5y%2FGLSrJ545I5mXc%2BP8XU%3D",
      "cdn_url": "https://audio2.brain.fm/Giuseppe%20Maria%20Cambini%20Woodwind%20Quintet%20No.%201%20in%20B%20Flat%20Major%20Classical%20Focus%20Light%20Work%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Giuseppe Maria Cambini Woodwind Quintet No. 1 in B Flat Major Classical Focus Light Work Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Giuseppe-Maria-Cambini-Woodwind-Quintet-No.-1-in-B-Flat-Major-Classical-Focus-Light-Work-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Giuseppe-Maria-Cambini-Woodwind-Quintet-No.-1-in-B-Flat-Major-Classical-Focus-Light-Work-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25707472,
      "sha256": "6faa5032704dc66c0b020220f067d089a4480969188b0cd45cfcdb54466fac88",
      "download_error": null
    },
    {
      "track_id": "62b38a8d5924111de5f5478d",
      "name": "Brahms Piano Collection",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.21,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Piano%20Classical%202%20Brahms_1.8%20FINAL_1.15_Nrmlzd_VBR5.mp3?expiration=1792292126584&token=nLMPU5eKJPqtHAQuIP8Ke5VU6NvKQM2sYyZDSTU0HgY%3D",
      "cdn_url": "https://audio2.brain.fm/Piano%20Classical%202%20Brahms_1.8%20FINAL_1.15_Nrmlzd_VBR5.mp3",
      "remote_filename": "Piano Classical 2 Brahms_1.8 FINAL_1.15_Nrmlzd_VBR5.mp3",
      "filename": "Piano-Classical-2-Brahms_1.8-FINAL_1.15_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Piano-Classical-2-Brahms_1.8-FINAL_1.15_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20503519,
      "sha256": "b3f443a9657e4511cbe8a5c53adac34c46c757f9afbbb1be1b9b818d874e4231",
      "download_error": null
    },
    {
      "track_id": "62b38a77592411bf86f544cc",
      "name": "Baroque Medley",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Baroque%20Medley%20Anonymous%20Classical%20Focus%20Conor_1.1_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=dk5K5m2XD2n7P%2FwuHlU1S7BsLMu2OskLsEidMgFA6EA%3D",
      "cdn_url": "https://audio2.brain.fm/Baroque%20Medley%20Anonymous%20Classical%20Focus%20Conor_1.1_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Baroque Medley Anonymous Classical Focus Conor_1.1_Nrmlzd2_VBR5.mp3",
      "filename": "Baroque-Medley-Anonymous-Classical-Focus-Conor_1.1_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Baroque-Medley-Anonymous-Classical-Focus-Conor_1.1_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21664912,
      "sha256": "54ad0fa5e46c9c36217b787e9b83fac3e15ed3f0c360178560d32824ef482504",
      "download_error": null
    },
    {
      "track_id": "62b38a755924117515f5448a",
      "name": "Mozart Piano Collection 4",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.37,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Classical%208%20Mozart%204_1.4_Nrmlzd_VBR5.mp3?expiration=1792292126584&token=X9xhsS6JNGfW5%2BQTVeHIIC%2BbHTvEEDDrekjSbwJVouw%3D",
      "cdn_url": "https://audio2.brain.fm/Classical%208%20Mozart%204_1.4_Nrmlzd_VBR5.mp3",
      "remote_filename": "Classical 8 Mozart 4_1.4_Nrmlzd_VBR5.mp3",
      "filename": "Classical-8-Mozart-4_1.4_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Classical-8-Mozart-4_1.4_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18622033,
      "sha256": "6c066fe84e48e8da2ba86ae745cbe8505b571ff1a0e34c86b227e3fd3fd0d3ae",
      "download_error": null
    },
    {
      "track_id": "62b38a13592411bde2f53e1c",
      "name": "Pieces for the Piano",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.56,
      "complexity_level": 0.57,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Pieces%20for%20the%20Piano%20by%20Ralph%20Vaughan%20Williams%20and%20Arthur%20Hartmann%20Classical%20Focus%20Light%20Work%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=MxlCR3WftOftk9cncccIUTRgAvtZfxMPaUzxO%2BhADGA%3D",
      "cdn_url": "https://audio2.brain.fm/Pieces%20for%20the%20Piano%20by%20Ralph%20Vaughan%20Williams%20and%20Arthur%20Hartmann%20Classical%20Focus%20Light%20Work%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pieces for the Piano by Ralph Vaughan Williams and Arthur Hartmann Classical Focus Light Work Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Pieces-for-the-Piano-by-Ralph-Vaughan-Williams-and-Arthur-Hartmann-Classical-Focus-Light-Work-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Pieces-for-the-Piano-by-Ralph-Vaughan-Williams-and-Arthur-Hartmann-Classical-Focus-Light-Work-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23444316,
      "sha256": "8b1dae36380a1361a24d92ad4489b65c0ae1a63d6720b618749b4bafc255f2f4",
      "download_error": null
    },
    {
      "track_id": "62b389f259241164def53b81",
      "name": "Sinfonia in D Major",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.8,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Sinfonia%20in%20D%20Major%20for%20String%20Orchestra%20by%20Felix%20Mendelssohn%20Classical%20Focus%20Light%20Work%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=RnVLL9hNC5Rf3bBlSlwxz0wPt8MKAztvnPW3dyJuJBc%3D",
      "cdn_url": "https://audio2.brain.fm/Sinfonia%20in%20D%20Major%20for%20String%20Orchestra%20by%20Felix%20Mendelssohn%20Classical%20Focus%20Light%20Work%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sinfonia in D Major for String Orchestra by Felix Mendelssohn Classical Focus Light Work Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Sinfonia-in-D-Major-for-String-Orchestra-by-Felix-Mendelssohn-Classical-Focus-Light-Work-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Sinfonia-in-D-Major-for-String-Orchestra-by-Felix-Mendelssohn-Classical-Focus-Light-Work-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28795555,
      "sha256": "f0e45d31eddf0eaea5a630fffb68ca2bbdf2646c960dfb3fb34986341206593d",
      "download_error": null
    },
    {
      "track_id": "62b389e45924114952f5398c",
      "name": "Elegies for Strings",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Elegies%20for%20Strings%20by%20Piotr%20Tchaikovsky%20and%20FS%20Kelly%20Classical%20Focus%20Creative%20Flow%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=8UZJbEDefc30DtdX1WDys4jVXE%2Bk3MboY7wCsaZ4WcQ%3D",
      "cdn_url": "https://audio2.brain.fm/Elegies%20for%20Strings%20by%20Piotr%20Tchaikovsky%20and%20FS%20Kelly%20Classical%20Focus%20Creative%20Flow%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Elegies for Strings by Piotr Tchaikovsky and FS Kelly Classical Focus Creative Flow Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Elegies-for-Strings-by-Piotr-Tchaikovsky-and-FS-Kelly-Classical-Focus-Creative-Flow-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Elegies-for-Strings-by-Piotr-Tchaikovsky-and-FS-Kelly-Classical-Focus-Creative-Flow-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28747294,
      "sha256": "8079d20dee1d30ddfa6ef52904e30a3007451ea35c2183ac260c8b7ff504a6b1",
      "download_error": null
    },
    {
      "track_id": "62b389e259241199d2f5396f",
      "name": "Beethoven Piano Collection",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.29,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Piano%20Classical%203%20Beethoven_1.7%20FInal_1.35_Nrmlzd_VBR5.mp3?expiration=1792292126584&token=%2BXmQxJvxywzDekPj58%2Fwk6d6Agm%2FlCk6peXkXAQ3Bew%3D",
      "cdn_url": "https://audio2.brain.fm/Piano%20Classical%203%20Beethoven_1.7%20FInal_1.35_Nrmlzd_VBR5.mp3",
      "remote_filename": "Piano Classical 3 Beethoven_1.7 FInal_1.35_Nrmlzd_VBR5.mp3",
      "filename": "Piano-Classical-3-Beethoven_1.7-FInal_1.35_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Piano-Classical-3-Beethoven_1.7-FInal_1.35_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21220123,
      "sha256": "cf913c48b9007b4fefabfb7fb5b3f156821479fc43702469da1038e616481b65",
      "download_error": null
    },
    {
      "track_id": "62b38967592411a4bef53657",
      "name": "Jean Sibelius Piano Works",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.51,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Sibelius%20Piano%20Works%20Classical%20Focus%20Light%20Work%20Conor%20100bpm%20MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=44hW9CyhYGVoGg7vHN0HNR5VBhICmfAtJiM1o1AOqQk%3D",
      "cdn_url": "https://audio2.brain.fm/Sibelius%20Piano%20Works%20Classical%20Focus%20Light%20Work%20Conor%20100bpm%20MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sibelius Piano Works Classical Focus Light Work Conor 100bpm MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sibelius-Piano-Works-Classical-Focus-Light-Work-Conor-100bpm-MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Sibelius-Piano-Works-Classical-Focus-Light-Work-Conor-100bpm-MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22007471,
      "sha256": "b0dc759812bb9604ea3fdac9c852e44f49e2684d8573253fd8c0f518eaa4ab8e",
      "download_error": null
    },
    {
      "track_id": "62b388d05924110f08f529df",
      "name": "Pieces for the Harp",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.63,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.61,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Pieces%20for%20the%20Harp%20by%20Bedrich%20Smetana%20and%20Camille%20Saint-Saens%20Classical%20Focus%20Deep%20Work%20Conor%20100bpm%20MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=z4n3xwsE4XlxFi3cPOEu5RjPtoHcNKA3NLFstPqpDcM%3D",
      "cdn_url": "https://audio2.brain.fm/Pieces%20for%20the%20Harp%20by%20Bedrich%20Smetana%20and%20Camille%20Saint-Saens%20Classical%20Focus%20Deep%20Work%20Conor%20100bpm%20MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pieces for the Harp by Bedrich Smetana and Camille Saint-Saens Classical Focus Deep Work Conor 100bpm MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Pieces-for-the-Harp-by-Bedrich-Smetana-and-Camille-Saint-Saens-Classical-Focus-Deep-Work-Conor-100bpm-MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Pieces-for-the-Harp-by-Bedrich-Smetana-and-Camille-Saint-Saens-Classical-Focus-Deep-Work-Conor-100bpm-MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24862817,
      "sha256": "d4d632f2b5d55ff6b3fccbbdbffff7ff1a3a02e5b265f46e815076d9132f6205",
      "download_error": null
    },
    {
      "track_id": "62b388bb592411017af528e1",
      "name": "Suite for String Orchestra",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.87,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Suite%20for%20String%20Orchestra%20by%20Leos%20Janacek%20Classical%20Focus%20Creative%20Flow%20Conor%20Variable%20BPM_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=Fku3yWBOgeKjc8w3gPfrm4gwkODYCy%2FBS5%2BXgpw7rfI%3D",
      "cdn_url": "https://audio2.brain.fm/Suite%20for%20String%20Orchestra%20by%20Leos%20Janacek%20Classical%20Focus%20Creative%20Flow%20Conor%20Variable%20BPM_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Suite for String Orchestra by Leos Janacek Classical Focus Creative Flow Conor Variable BPM_Nrmlzd2_VBR5.mp3",
      "filename": "Suite-for-String-Orchestra-by-Leos-Janacek-Classical-Focus-Creative-Flow-Conor-Variable-BPM_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Suite-for-String-Orchestra-by-Leos-Janacek-Classical-Focus-Creative-Flow-Conor-Variable-BPM_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29083793,
      "sha256": "c2e820fca4aaa5a3048cf77784d0c95b103d4c411990d142b57d1d8ed23e32f2",
      "download_error": null
    },
    {
      "track_id": "62b388b55924114ad8f52802",
      "name": "Lute Suite",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.39,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.21,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Bach%20Lute%20Suite%20Classical%20Focus%20Conor_1.1_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=3kjA79PXnFKMAISgyeHK7FfhklKn%2Fst8sgNDUhvG1vU%3D",
      "cdn_url": "https://audio2.brain.fm/Bach%20Lute%20Suite%20Classical%20Focus%20Conor_1.1_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bach Lute Suite Classical Focus Conor_1.1_Nrmlzd2_VBR5.mp3",
      "filename": "Bach-Lute-Suite-Classical-Focus-Conor_1.1_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Bach-Lute-Suite-Classical-Focus-Conor_1.1_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19245189,
      "sha256": "8ec79f330f7e5fab19cc6b4f72a22c96ee85cf05783b64a8d9c0b7f6ffb6f71b",
      "download_error": null
    },
    {
      "track_id": "62b388b05924113f66f52740",
      "name": "Bach Concerto",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.7,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Focus-Classical-Loud-bachconc9_VBR5.mp3?expiration=1792292126584&token=6BbRF%2BdEgbyERJ404NsD47gzlMyOZAZXcXvfBTeNYaQ%3D",
      "cdn_url": "https://audio2.brain.fm/Focus-Classical-Loud-bachconc9_VBR5.mp3",
      "remote_filename": "Focus-Classical-Loud-bachconc9_VBR5.mp3",
      "filename": "Focus-Classical-Loud-bachconc9_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Focus-Classical-Loud-bachconc9_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26824879,
      "sha256": "f6ed405c64887848f0947c67afc99cb3a4b28e5f6f8b9c431ba22465b63bf854",
      "download_error": null
    },
    {
      "track_id": "62b387795924114059f51b79",
      "name": "Sinfonia 9 in C Major",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.84,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Sinfonia%209%20in%20C%20Major%20by%20Felix%20Mendelssohn%20Classical%20Focus%20Study%20Conor%20Variablebpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=EDAJmmclTBQCgKldI3Ept1R6Fdclz3XRF7h8qjCXDlw%3D",
      "cdn_url": "https://audio2.brain.fm/Sinfonia%209%20in%20C%20Major%20by%20Felix%20Mendelssohn%20Classical%20Focus%20Study%20Conor%20Variablebpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sinfonia 9 in C Major by Felix Mendelssohn Classical Focus Study Conor Variablebpm_Nrmlzd2_VBR5.mp3",
      "filename": "Sinfonia-9-in-C-Major-by-Felix-Mendelssohn-Classical-Focus-Study-Conor-Variablebpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Sinfonia-9-in-C-Major-by-Felix-Mendelssohn-Classical-Focus-Study-Conor-Variablebpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29682876,
      "sha256": "1c34058e6fe80f3711612fc11ea631de72f8b193eeb748056014a4a9db58989e",
      "download_error": null
    },
    {
      "track_id": "62b38775592411f76cf51aff",
      "name": "Concerto Grosso in C Major",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.92,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Concerto%20Grosso%20in%20C%20Major%20and%20Sonata%20a%20Quattro%20by%20Arcangelo%20Corelli%20Classical%20Focus%20Deep%20Work%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=OBmcMq2Ze4oZx%2FF%2Fr7ur15CTMdS9cK3Z%2FTJ%2B0OnnS6E%3D",
      "cdn_url": "https://audio2.brain.fm/Concerto%20Grosso%20in%20C%20Major%20and%20Sonata%20a%20Quattro%20by%20Arcangelo%20Corelli%20Classical%20Focus%20Deep%20Work%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Concerto Grosso in C Major and Sonata a Quattro by Arcangelo Corelli Classical Focus Deep Work Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Concerto-Grosso-in-C-Major-and-Sonata-a-Quattro-by-Arcangelo-Corelli-Classical-Focus-Deep-Work-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Concerto-Grosso-in-C-Major-and-Sonata-a-Quattro-by-Arcangelo-Corelli-Classical-Focus-Deep-Work-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29110102,
      "sha256": "d800e79d8fb5be9f53d1de536cb8402cf90720823c187f1f8998de954b8bc210",
      "download_error": null
    },
    {
      "track_id": "62b3843e59241144a3f50579",
      "name": "Missa Ecce Ancilla Domine",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.84,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Missa%20Ecce%20Ancilla%20Domine%20by%20Guillaume%20Dufay%20Classical%20Focus%20Deep%20Work%20Conor%2086bpm_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=rPXzowenOGmz%2FiI6UGQpgKwgW9oIutrJs2F2DLAN%2FnQ%3D",
      "cdn_url": "https://audio2.brain.fm/Missa%20Ecce%20Ancilla%20Domine%20by%20Guillaume%20Dufay%20Classical%20Focus%20Deep%20Work%20Conor%2086bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Missa Ecce Ancilla Domine by Guillaume Dufay Classical Focus Deep Work Conor 86bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Missa-Ecce-Ancilla-Domine-by-Guillaume-Dufay-Classical-Focus-Deep-Work-Conor-86bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Missa-Ecce-Ancilla-Domine-by-Guillaume-Dufay-Classical-Focus-Deep-Work-Conor-86bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28033239,
      "sha256": "66799b89ae20443a4b771d07042bf93c8560def1097d30e2a0c1cd50e8a52d7d",
      "download_error": null
    },
    {
      "track_id": "62b384295924113cb6f5012c",
      "name": "Two Keyboard Sonatas",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 0,
      "brightness_level": 0.47,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Two%20Keyboard%20Sonatas%20by%20CPE%20Bach%20Classical%20Focus%20Deep%20Work%20Conor%20MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=A2uqO8MnYFbJvTrAZUZgRw8I%2FaKqIb0bB9OfDj2Ve%2B4%3D",
      "cdn_url": "https://audio2.brain.fm/Two%20Keyboard%20Sonatas%20by%20CPE%20Bach%20Classical%20Focus%20Deep%20Work%20Conor%20MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Two Keyboard Sonatas by CPE Bach Classical Focus Deep Work Conor MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Two-Keyboard-Sonatas-by-CPE-Bach-Classical-Focus-Deep-Work-Conor-MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Two-Keyboard-Sonatas-by-CPE-Bach-Classical-Focus-Deep-Work-Conor-MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23139559,
      "sha256": "77f540002d15dbfdc072ebc3f788ff9f490acec476125c54edaed06e27465f10",
      "download_error": null
    },
    {
      "track_id": "62b3841f592411362cf4ff49",
      "name": "Woodwind Quintet No. 3",
      "category": "Classical",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.81,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/classical.json",
      "source_url": "https://audio2.brain.fm/Giuseppe%20Maria%20Cambini%20Woodwind%20Quintet%20No.%203%20in%20F%20Major%20Classical%20Focus%20Creative%20Flow%20Conor_Nrmlzd2_VBR5.mp3?expiration=1792292126584&token=ojHiVN8Tps0ZaYfh9aH04ZFKVxd54Aq%2F9iZDuALi3FI%3D",
      "cdn_url": "https://audio2.brain.fm/Giuseppe%20Maria%20Cambini%20Woodwind%20Quintet%20No.%203%20in%20F%20Major%20Classical%20Focus%20Creative%20Flow%20Conor_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Giuseppe Maria Cambini Woodwind Quintet No. 3 in F Major Classical Focus Creative Flow Conor_Nrmlzd2_VBR5.mp3",
      "filename": "Giuseppe-Maria-Cambini-Woodwind-Quintet-No.-3-in-F-Major-Classical-Focus-Creative-Flow-Conor_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/classical/Giuseppe-Maria-Cambini-Woodwind-Quintet-No.-3-in-F-Major-Classical-Focus-Creative-Flow-Conor_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25734251,
      "sha256": "3fd164cf71d04e9cadb48e80e1ff514740ba7b1c1d10b25c32838891d05ae541",
      "download_error": null
    },
    {
      "track_id": "674ddf49ed827e850ea89940",
      "name": "A New Drop",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/A%20New%20Drop%20-%20NewDrone1_1.28_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=8BlRafOZDiUitziT2N6EZvV6rKvmlI9vVG8VrS8plls%3D",
      "cdn_url": "https://audio2.brain.fm/A%20New%20Drop%20-%20NewDrone1_1.28_Nrmlzd2_VBR5.mp3",
      "remote_filename": "A New Drop - NewDrone1_1.28_Nrmlzd2_VBR5.mp3",
      "filename": "A-New-Drop-NewDrone1_1.28_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/A-New-Drop-NewDrone1_1.28_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20797416,
      "sha256": "3379f9d0e83063ef5dc4cec7c9b90822db9bd0d4ffda5126ef9e0b8050dece02",
      "download_error": null
    },
    {
      "track_id": "66cc939547ed87e8383b727a",
      "name": "Dwelling Within",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.28,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.86,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/DwellingWithin_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=%2F55GmwMxMm4wVJ5HIjz5Vtf9Szj%2B0R9aOBSxtdSEuKA%3D",
      "cdn_url": "https://audio2.brain.fm/DwellingWithin_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DwellingWithin_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DwellingWithin_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/DwellingWithin_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23975256,
      "sha256": "982e3f091d9cb3e1db285edc462e2404ef9f9bb4422a43abab3c16573793db15",
      "download_error": null
    },
    {
      "track_id": "66b662f187e215f954f17c65",
      "name": "Aglow",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.46,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Aglow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=HamMuqEWhkAgfom3LKsaw29IGETe1TfYZOTUD3VWZXg%3D",
      "cdn_url": "https://audio2.brain.fm/Aglow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Aglow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Aglow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Aglow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24410160,
      "sha256": "a33224614b3cda95062a9f933fab4ba516d7ecec180c4ce3ea12b8c77b93c0fe",
      "download_error": null
    },
    {
      "track_id": "66b662d687e215f954f17c27",
      "name": "Cosmic Debris",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.66,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/CosmicDebris_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=x5zFLP4EPPvqFZkBURr1gWR63b20Z06ijchKplpOsR0%3D",
      "cdn_url": "https://audio2.brain.fm/CosmicDebris_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CosmicDebris_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CosmicDebris_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/CosmicDebris_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26661936,
      "sha256": "da3511504adb7dc4ed20315c2c104da43add65f20936fa72b40949b96ab4b263",
      "download_error": null
    },
    {
      "track_id": "66a3fda00108b74ee9959b85",
      "name": "Ambient Ascent",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.52,
      "complexity_level": 0.41,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/AmbientAscent_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=y55JkEeH6D0mz7GeM8zvJ6jkWsMqrDkQkTP2Yj9aOow%3D",
      "cdn_url": "https://audio2.brain.fm/AmbientAscent_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AmbientAscent_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AmbientAscent_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/AmbientAscent_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25698528,
      "sha256": "16514cd5ceffa5edf20a2892d08c0830a5d4bbbd340e541ddddfa83a77a84740",
      "download_error": null
    },
    {
      "track_id": "66918bd8de19d0f1c74ea89f",
      "name": "Trance State",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.47,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/TranceState_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=FVgSq4GykqP4%2FCmC%2FR%2FB00XysNtstCbjmV9ZyfFoWuA%3D",
      "cdn_url": "https://audio2.brain.fm/TranceState_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TranceState_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TranceState_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/TranceState_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27408984,
      "sha256": "c3430bf946d26e9d72cad5efd163713c347dca38cc43275b787329d9e0606dec",
      "download_error": null
    },
    {
      "track_id": "66918bc0de19d0f1c74ea874",
      "name": "Starfall",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.84,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Starfall_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=Pui6%2Bu1vBnHzD1sd59sC0nt4O069iUBjIqwkmv%2Bhv90%3D",
      "cdn_url": "https://audio2.brain.fm/Starfall_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Starfall_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Starfall_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Starfall_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27355104,
      "sha256": "dc6508200cbcf29d273e87f4286f439ee2ce04cf7cd26608be6d3b09c5c0ab17",
      "download_error": null
    },
    {
      "track_id": "6683fe2bd98e4183c363ed00",
      "name": "Shekinah",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.46,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.98,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Shekinah_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=p9JtC55fV9Inn5jA3%2FRYiKBMQVnYAWW01317K7TM9S4%3D",
      "cdn_url": "https://audio2.brain.fm/Shekinah_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Shekinah_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Shekinah_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Shekinah_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28002744,
      "sha256": "309803b1d64f68fc7efd395452838d81bca1ef45c98308c3224519e60e7ec5ac",
      "download_error": null
    },
    {
      "track_id": "665a22f14dfb90cc19dcdce0",
      "name": "Magus",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Magus_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=fWDcFNnQmB5Id7HrQWwqyum2uLPAYK4H8tD0b3wKimw%3D",
      "cdn_url": "https://audio2.brain.fm/Magus_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Magus_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Magus_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Magus_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29731656,
      "sha256": "2f8768039bc5575d0b64332ed84958a0bf5d00f32add9e96bfe9ce898d055ad1",
      "download_error": null
    },
    {
      "track_id": "665a22d74dfb90cc19dcdc53",
      "name": "Abyssal Flux",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.85,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/AbyssalFlux_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=DBhKHzhT%2F9vdqt3zcjsKTy%2B%2BNizJcubLF3RxnsGb9k8%3D",
      "cdn_url": "https://audio2.brain.fm/AbyssalFlux_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AbyssalFlux_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AbyssalFlux_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/AbyssalFlux_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28980888,
      "sha256": "2a0a2833d2ef86ab9182484d41eaf5c3487e35ddbb856d1642212575f8b26aa2",
      "download_error": null
    },
    {
      "track_id": "66477ab630b208e2323edbb2",
      "name": "Phase Shift",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.56,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/PhaseShift_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=u%2BajEkFT%2ByjU4e7jCpPd5I1OhcJ%2Fd55aSXOkTJsaNr4%3D",
      "cdn_url": "https://audio2.brain.fm/PhaseShift_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PhaseShift_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PhaseShift_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/PhaseShift_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28281192,
      "sha256": "36d524a9bcf7ac4fa2409bd20dd309f03cbd31637cdd547db775bccc7447a084",
      "download_error": null
    },
    {
      "track_id": "66477aab30b208e2323edb59",
      "name": "Obsidian Mirror",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.59,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/ObsidianMirror_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=03R1OGJ1WfrMc61rbFgqj8ht%2F6km4tzwuBOY31NP8W4%3D",
      "cdn_url": "https://audio2.brain.fm/ObsidianMirror_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ObsidianMirror_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ObsidianMirror_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/ObsidianMirror_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28537824,
      "sha256": "9f79fa59c17dad4ca0261e1cb465b22943a152777666999432b26ec4a340ddb8",
      "download_error": null
    },
    {
      "track_id": "66477a9130b208e2323edad4",
      "name": "Afterimage",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.44,
      "complexity_level": 0.55,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Afterimage_Focus_DeepWork_Drone_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=DtLBhMZF5cXdgH8tfY%2FD3JA10CrUEo2YrQtGRyaqAd0%3D",
      "cdn_url": "https://audio2.brain.fm/Afterimage_Focus_DeepWork_Drone_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Afterimage_Focus_DeepWork_Drone_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Afterimage_Focus_DeepWork_Drone_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Afterimage_Focus_DeepWork_Drone_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26317412,
      "sha256": "6ad411c2a73f1f255dcee7e1a7dfbcf426c6f5af28e8ba249be8512126bd5aeb",
      "download_error": null
    },
    {
      "track_id": "663537464eae15761ad50620",
      "name": "Star Trail",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.64,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/StarTrail_Focus_DeepWork_Drone_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=sCaYW0%2FQDoKTb6HmI2ph0D6H3E36Iednpk0AwbbQFKo%3D",
      "cdn_url": "https://audio2.brain.fm/StarTrail_Focus_DeepWork_Drone_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StarTrail_Focus_DeepWork_Drone_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StarTrail_Focus_DeepWork_Drone_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/StarTrail_Focus_DeepWork_Drone_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27232367,
      "sha256": "cd5207825b44f9c1b60224a0c421b756a95ce985e7e088c3480817a6427818e4",
      "download_error": null
    },
    {
      "track_id": "661063bf88d74c5142fdfdf9",
      "name": "Above and Below",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.39,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/AboveandBelow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=0rs7FNYJuFgffjvXvMMbyDEWchRNM4UbKzhXH1XzZXY%3D",
      "cdn_url": "https://audio2.brain.fm/AboveandBelow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AboveandBelow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AboveandBelow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/AboveandBelow_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25713360,
      "sha256": "34ad42ec7e3538bffec742ee5dd1450864e9eb186d574521ee33df2eff13f294",
      "download_error": null
    },
    {
      "track_id": "65fdaa3acc7d1e000a587c5b",
      "name": "Heart Centre",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.44,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/HeartCentre_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=RtPK6F%2FayfIjngCmDpQ5RBJuGDFflljp50wVdHgy1%2Fo%3D",
      "cdn_url": "https://audio2.brain.fm/HeartCentre_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HeartCentre_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HeartCentre_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/HeartCentre_Focus_Learning_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28491960,
      "sha256": "0e4adfb412342c21f0fa7785ba2d204bdf5265e8e3969b1f74a0f0877e74f442",
      "download_error": null
    },
    {
      "track_id": "65d920dd636e0500086cb48a",
      "name": "Echo Location",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.67,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/EchoLocation_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=WD9Y8KbJ65SSEqwiGBQFQnfIusu%2FESkHPc9TuhOkZGI%3D",
      "cdn_url": "https://audio2.brain.fm/EchoLocation_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EchoLocation_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EchoLocation_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/EchoLocation_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28152336,
      "sha256": "743eed6b197497187573ffa887d6bb19a3b6b24a65cc1e2aa7ff4568c84b83d9",
      "download_error": null
    },
    {
      "track_id": "65d920ab636e0500086cb3ce",
      "name": "Barren Lands",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.49,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/BarrenLands_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=eshxii%2B5YBqmp88TMyhCOvsDeEIdGh9YT5hHjcZdUOs%3D",
      "cdn_url": "https://audio2.brain.fm/BarrenLands_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BarrenLands_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BarrenLands_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/BarrenLands_Focus_DeepWork_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27852264,
      "sha256": "0908b33019c8316abb0d9b8aac46b33c2a2f87231b96fbad2243b4f4a5b08b80",
      "download_error": null
    },
    {
      "track_id": "64302cd123c3be04503fbb32",
      "name": "Sahara",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.39,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.89,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Sahara_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=5hYKscOoy6%2FMeCUCnJ9ERJgNcTpzOdYXlPPEUmTOfD0%3D",
      "cdn_url": "https://audio2.brain.fm/Sahara_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sahara_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sahara_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Sahara_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26095200,
      "sha256": "c5203fbe60cb5c43149a7b30517d7191056cb4ac641e70ddc77f800e13adeda5",
      "download_error": null
    },
    {
      "track_id": "64302cb85ee24c793da06bb1",
      "name": "Regulus",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.66,
      "complexity_level": 0.52,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Regulus_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=4wOK34VvPgHfBlMMTUwbIPpVF8TuIO88mEP59zEVWqk%3D",
      "cdn_url": "https://audio2.brain.fm/Regulus_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Regulus_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Regulus_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Regulus_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29654278,
      "sha256": "205adf468d4643a67ee4512a7454ecc087ff5891f129e1f3579bfb6a9b79d1c4",
      "download_error": null
    },
    {
      "track_id": "64302bd323c3beb4d53fb433",
      "name": "Mystic Mountain",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.74,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.61,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/MysticMountain_Focus_Creativity_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=Vg%2FGTpXd%2FC13alaidrzdneWCregtcy5bWToIuX0pSzM%3D",
      "cdn_url": "https://audio2.brain.fm/MysticMountain_Focus_Creativity_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MysticMountain_Focus_Creativity_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MysticMountain_Focus_Creativity_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/MysticMountain_Focus_Creativity_Drones_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29845290,
      "sha256": "0df26075093c5eb3e63943cf9253876943f7ed406a15ed6dc3a9d216a5698596",
      "download_error": null
    },
    {
      "track_id": "64302add23c3be830d3fb048",
      "name": "Idyllic Landscapes",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.52,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/IdyllicLandscapes_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=pR9U6dzyaL419QrihGHxQ%2F1dT%2BhUhMrohH%2BrrWN%2BxxI%3D",
      "cdn_url": "https://audio2.brain.fm/IdyllicLandscapes_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "IdyllicLandscapes_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "IdyllicLandscapes_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/IdyllicLandscapes_Focus_DeepWork_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25853427,
      "sha256": "69503fbc941157c6ad10129c9f86b3be14b30e6d1085c0b39d14196384caceb9",
      "download_error": null
    },
    {
      "track_id": "64302a8b5ee24c67e8a05af0",
      "name": "Essential Nature",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.83,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.98,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/EssentialNature_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=siTFvvBdLBt5WvaOrMhpnGcrWB85FgRWPHqh%2BVC1x9Q%3D",
      "cdn_url": "https://audio2.brain.fm/EssentialNature_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EssentialNature_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EssentialNature_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/EssentialNature_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28512883,
      "sha256": "0e1fbf4416cc9519f5b855a298e9dc692051ea98583a501e6e8f1659545f1478",
      "download_error": null
    },
    {
      "track_id": "64302a1523c3bea4683fadb9",
      "name": "Conscious Mind",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.45,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.87,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/ConsciousMind_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=j5KefPztX0PE3S0nk02cxY4TfgRTNiD3BOKGXXQ8fAo%3D",
      "cdn_url": "https://audio2.brain.fm/ConsciousMind_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ConsciousMind_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ConsciousMind_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/ConsciousMind_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28154918,
      "sha256": "81b3b3865d02ca402c105afab1d7f2bd5ac719e68e164925623ea5ccde908a0d",
      "download_error": null
    },
    {
      "track_id": "643029f65ee24c7fc0a05805",
      "name": "Clairvoyant",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.72,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Clarivoyant_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=iPfU9c653E5K3nf%2BloPXNLEpXeCdB2mcywkdPPQZA50%3D",
      "cdn_url": "https://audio2.brain.fm/Clarivoyant_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Clarivoyant_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Clarivoyant_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Clarivoyant_Focus_Learning_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28325293,
      "sha256": "f12cfce6f6377e685d24a2f8c8085104028b5c8b024a388bf603e20bcf1f368a",
      "download_error": null
    },
    {
      "track_id": "643029dd5ee24ca7e1a057a0",
      "name": "Chrysanthemum",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.6,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Chrystanthemum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=vJvHlpL4M%2F9ZitGdy8KU4azgYOaCf5UGn%2B86hP81fCk%3D",
      "cdn_url": "https://audio2.brain.fm/Chrystanthemum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Chrystanthemum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Chrystanthemum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Chrystanthemum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26230865,
      "sha256": "ff11b435da69b426cdf4afb26f6f12298ac8368fada66750d3bbbda5b086cd10",
      "download_error": null
    },
    {
      "track_id": "643029bf5ee24c40faa056d9",
      "name": "Celestial Spheres",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.41,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/CelestialSpheres_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=jyK%2FkxrjgnXW0VJ7CXZdpw6m5lqURT%2Bp4MZUSrPw9kE%3D",
      "cdn_url": "https://audio2.brain.fm/CelestialSpheres_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CelestialSpheres_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CelestialSpheres_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/CelestialSpheres_Focus_DeepWork_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24143546,
      "sha256": "e073ef522b868fcc60c4b981074bf3fb9946e607e85d8e180494a5b6d3e52e86",
      "download_error": null
    },
    {
      "track_id": "643029b15ee24c6f4fa0569c",
      "name": "Cascading Fire",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.97,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/CascadingFire_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=npnjp%2BewlYW0ZZkhlg4SK1M6lVeULMSXCR8ToVxGtlA%3D",
      "cdn_url": "https://audio2.brain.fm/CascadingFire_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CascadingFire_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CascadingFire_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/CascadingFire_Focus_Creativity_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29599530,
      "sha256": "bf8df7d9740e9211ee3fefd8f0aa29bb2173613c0dbe900c1b8bac4d826fa1fd",
      "download_error": null
    },
    {
      "track_id": "6430294b23c3be94823faa3f",
      "name": "Ascent and Descent",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.76,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/AscentandDescent_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=ktXGmvcWdFgf2aG687O1xCxW7sXfsOfjb0TB0MSX2lg%3D",
      "cdn_url": "https://audio2.brain.fm/AscentandDescent_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AscentandDescent_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AscentandDescent_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/AscentandDescent_Focus_Creativity_Drones_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28405175,
      "sha256": "7d411b6451d906784f8f222135ee2c9fdb9abb137dcd85ad490ba7b9180c0c49",
      "download_error": null
    },
    {
      "track_id": "643028705ee24ce4dfa05261",
      "name": "Ad Infinitum",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.49,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/AdInfinitum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=CY5Rr%2BFlJYhDfr2vA%2FvITctWpxEgojjnSYAyk2sAzAQ%3D",
      "cdn_url": "https://audio2.brain.fm/AdInfinitum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AdInfinitum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AdInfinitum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/AdInfinitum_Focus_Learning_Drones_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25346998,
      "sha256": "34de5c790ac6a236a018820550666acec785abc4574a9f83c59654e8cfa6aab5",
      "download_error": null
    },
    {
      "track_id": "633d9e04840cdf77d057d521",
      "name": "The Clearing",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.24,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/The%20Clearing_Focus_Learning_Drones_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=hK8EpnNhdN0T8WkDNVAFQwUH9YgCttlWFRDoDlrYACE%3D",
      "cdn_url": "https://audio2.brain.fm/The%20Clearing_Focus_Learning_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "The Clearing_Focus_Learning_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "The-Clearing_Focus_Learning_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/The-Clearing_Focus_Learning_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24076532,
      "sha256": "ea41ceb821d83e2852d737352d9e025dfe362bfed1cc623e1394a3a3fcadb8e0",
      "download_error": null
    },
    {
      "track_id": "633d9dd983f4ff5fcca30355",
      "name": "Temple Doors",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.2,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.83,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Temple%20Doors_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=EmII7acBPLj6BNwoxpY2zPDgZ1s4BIsrP5LLuPntUqg%3D",
      "cdn_url": "https://audio2.brain.fm/Temple%20Doors_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Temple Doors_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Temple-Doors_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Temple-Doors_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25859259,
      "sha256": "3f899d0924c08139ed66e4102495535247129e4ecc8423386ae3e894ae3fa1ff",
      "download_error": null
    },
    {
      "track_id": "633d9da983f4ff3ddda30204",
      "name": "Sunsen",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.34,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Sunsen_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=Z7KVzVgX8b3NN9BTGOuE17m7qB7UnRKxoM5uJNawFoI%3D",
      "cdn_url": "https://audio2.brain.fm/Sunsen_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sunsen_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Sunsen_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Sunsen_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25387419,
      "sha256": "c3a92131a38789a9ef6675d331221acbd300d3ad52176bf686841453650b3885",
      "download_error": null
    },
    {
      "track_id": "633d9d7c83f4ff2101a3002d",
      "name": "Spiral Orchard",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.14,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Spiral%20Orchard_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=Cihxbajr82SuEEjhJr41tToMtCm0gTeopCN6NSmqcEA%3D",
      "cdn_url": "https://audio2.brain.fm/Spiral%20Orchard_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Spiral Orchard_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Spiral-Orchard_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Spiral-Orchard_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24620038,
      "sha256": "37a7a994aa50cad52f2e890bd74379b2f24e120ddb094f40d9b1b77b21dbd945",
      "download_error": null
    },
    {
      "track_id": "633d9d4a840cdf57ba57cb5a",
      "name": "Salt Flats",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.08,
      "complexity_level": 0.01,
      "style": "normal",
      "neural_effect_level": 0.87,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Salt%20Flats_Focus_Drone_Learning_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=r5jdjgYpi4ImOPdoYTI5VJvgl%2B9cStan4PgEdnuCz%2FU%3D",
      "cdn_url": "https://audio2.brain.fm/Salt%20Flats_Focus_Drone_Learning_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Salt Flats_Focus_Drone_Learning_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Salt-Flats_Focus_Drone_Learning_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Salt-Flats_Focus_Drone_Learning_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24369311,
      "sha256": "b013c287d76390efe7b3c2427211db974c73976a7830cce658f065116ffb51bb",
      "download_error": null
    },
    {
      "track_id": "633d9d14840cdfc26157c9ff",
      "name": "Qanat",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.13,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Qanat_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=WCIHz%2F4SuiAfESSrS1RAdmbtiNu1Dy7cB1Tv1Cd4kWw%3D",
      "cdn_url": "https://audio2.brain.fm/Qanat_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Qanat_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Qanat_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Qanat_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25060050,
      "sha256": "aa04bda22abddcf93e79187624211e73ad593edf24843efae9d2aa4cf2522424",
      "download_error": null
    },
    {
      "track_id": "633d9ce7840cdff70557c94c",
      "name": "Phantasmas",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.18,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Phantasmas_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=o%2BQYDbL4kRYbULpWpa1dQNnh8H%2FDsMrrb%2BiZ9KxyPbM%3D",
      "cdn_url": "https://audio2.brain.fm/Phantasmas_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Phantasmas_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Phantasmas_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Phantasmas_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25241242,
      "sha256": "f009e67616dd510601a7d232abbe8faa2484101dae423479b59e503723dfac2b",
      "download_error": null
    },
    {
      "track_id": "633d9cba840cdfa9b657c7ba",
      "name": "Molten",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.1,
      "complexity_level": 0.76,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Molten_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=Pxa1RKpUJzRHiGpQ4RWGtCHAx2kXXcjD7J7WGPw7Ry8%3D",
      "cdn_url": "https://audio2.brain.fm/Molten_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Molten_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Molten_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Molten_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25388570,
      "sha256": "82298b323cc82ded30a1299a8608b8ae6d58d632851169c33386aec93829a3ed",
      "download_error": null
    },
    {
      "track_id": "633d9c9083f4ffada8a2f52a",
      "name": "Lyres",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.52,
      "complexity_level": 0.86,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Lyres_Focus_Learning_Drone_30_112bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=J9GJT7jVSImpBraOkq19GZfLpgU%2BNIyLqnStS3Pbfp8%3D",
      "cdn_url": "https://audio2.brain.fm/Lyres_Focus_Learning_Drone_30_112bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lyres_Focus_Learning_Drone_30_112bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Lyres_Focus_Learning_Drone_30_112bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Lyres_Focus_Learning_Drone_30_112bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27421647,
      "sha256": "c74df5ebe6ec4f5494c8e67711224d7d222abd9bf06d0ddbb836d3aafd66a0dd",
      "download_error": null
    },
    {
      "track_id": "633d9c59840cdf548157c420",
      "name": "Cottonwood",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.38,
      "complexity_level": 0.53,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Cottonwood_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=DuvwTnw6UAxPxjSC6RD7mvrAbTTR%2BFqKPeP%2FI9sysSU%3D",
      "cdn_url": "https://audio2.brain.fm/Cottonwood_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Cottonwood_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Cottonwood_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Cottonwood_Focus_Learning_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25771583,
      "sha256": "1dbd6cd6c116b21d969a2068601f5674c20b560675db1277fd70dfb7208391dc",
      "download_error": null
    },
    {
      "track_id": "633d9c1d840cdf717b57c31d",
      "name": "Western Basin",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.51,
      "complexity_level": 0.71,
      "style": "normal",
      "neural_effect_level": 0.98,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Western%20Basin_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=GsExlcA2e6c4WzSE5Tc8%2BJJQa8h4j4IxRgloLYSaeiI%3D",
      "cdn_url": "https://audio2.brain.fm/Western%20Basin_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Western Basin_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Western-Basin_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Western-Basin_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27675575,
      "sha256": "589b1cc9a74d99ec3eabb2f233a063d3c23a5fbef0b033ce23f0e38606cfe403",
      "download_error": null
    },
    {
      "track_id": "633d9bf083f4ffe5cda2f029",
      "name": "Prime Meridian",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.57,
      "complexity_level": 0.37,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Prime%20Meridian_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=YfzxNrnmOYdMJQI0kVqNkwOhhIjxCwOU5Sg0gBT%2FQQc%3D",
      "cdn_url": "https://audio2.brain.fm/Prime%20Meridian_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Prime Meridian_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Prime-Meridian_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Prime-Meridian_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26435999,
      "sha256": "3bb97f3307d4d5ecf38475c7786e9de7d220115496e14776e8cf98d721abf837",
      "download_error": null
    },
    {
      "track_id": "633d9bc0840cdfbb9857c02c",
      "name": "Origin Myth",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.54,
      "complexity_level": 0.43,
      "style": "normal",
      "neural_effect_level": 0.89,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Origin%20Myth_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=Q0jHczCGEehdKtwpxvL9YujL%2F3zvJJTsYjleP4F15%2Fg%3D",
      "cdn_url": "https://audio2.brain.fm/Origin%20Myth_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Origin Myth_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Origin-Myth_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Origin-Myth_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26302091,
      "sha256": "839d0977fda987fb7135a60c9b95aabfd49a48c23ef7f2ef1ec013e28bd09147",
      "download_error": null
    },
    {
      "track_id": "633d9b8f840cdf468a57bfbc",
      "name": "Linen",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.39,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Linen_Focus_Creativity_Drones_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=uXHwDgMW%2FVWzTf%2FbHvbvSMwf0aNq0ruEST%2F3Y1YmjBM%3D",
      "cdn_url": "https://audio2.brain.fm/Linen_Focus_Creativity_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Linen_Focus_Creativity_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Linen_Focus_Creativity_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Linen_Focus_Creativity_Drones_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24609651,
      "sha256": "1cac096dc0cf53698c466469e2a73cfd831a58bacdc98a05f04caca30c493c8a",
      "download_error": null
    },
    {
      "track_id": "633d9b6183f4ffcd98a2ea12",
      "name": "Lilac Chaser",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.4,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.78,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Lilac%20Chaser_Focus_Drone_Creativity_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=vxPmAKWkTq1sgG%2FeeMUeU2icXkD0WTaw32nvsGCBpyk%3D",
      "cdn_url": "https://audio2.brain.fm/Lilac%20Chaser_Focus_Drone_Creativity_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lilac Chaser_Focus_Drone_Creativity_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Lilac-Chaser_Focus_Drone_Creativity_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Lilac-Chaser_Focus_Drone_Creativity_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23759385,
      "sha256": "eed1a16e2aa171e53898ed31c460692694fe51e08d94c6e725198b5b3e6a6fb7",
      "download_error": null
    },
    {
      "track_id": "633d9b1383f4fffe3ba2e7d8",
      "name": "Iona",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.47,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Iona_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=Z0xXQz8ri0Jqh0v41Ghs2ZdgCdkqoA00guTN9hVCKGo%3D",
      "cdn_url": "https://audio2.brain.fm/Iona_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Iona_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Iona_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Iona_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26122065,
      "sha256": "7d7780a7dd751b1090187b47b9912357469aa8b777581a917803411814af6a3c",
      "download_error": null
    },
    {
      "track_id": "633d9ae283f4ff1e05a2e750",
      "name": "Fulcrum",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.43,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Fulcrum_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=v6xQZHV1Wm3wkwGKbkd80akaklzxVlctyJ4WO6ph5Gg%3D",
      "cdn_url": "https://audio2.brain.fm/Fulcrum_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fulcrum_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Fulcrum_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Fulcrum_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25491125,
      "sha256": "bd7d6762a1da242c754661422f3573544fd397ff330436ff554eb6753ab14a9c",
      "download_error": null
    },
    {
      "track_id": "633d9ab483f4ff5c86a2e6af",
      "name": "Fata Morgana",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.23,
      "complexity_level": 0.78,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Fata%20Morgana_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=fJVzuqtPBCNtZU8ijT0Xslibkn%2FyyQcp30mhKgMnpds%3D",
      "cdn_url": "https://audio2.brain.fm/Fata%20Morgana_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fata Morgana_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Fata-Morgana_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Fata-Morgana_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24235155,
      "sha256": "6d11f473540822ed39ab340b10857fe96ccafa535536667c1bccd377404828cc",
      "download_error": null
    },
    {
      "track_id": "633d9a8683f4ff69bba2e3f7",
      "name": "Bluebird",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.11,
      "complexity_level": 0.99,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Bluebird_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=QBRjqO8NxjIjxLe7chtnGLlbqRyr3ffO%2BWw7B3IFM4Q%3D",
      "cdn_url": "https://audio2.brain.fm/Bluebird_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bluebird_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Bluebird_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Bluebird_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24308549,
      "sha256": "f41e1c368ce0dc78f16207756cc92010f750043e732bb5b9bb8fe2d7d2313fcb",
      "download_error": null
    },
    {
      "track_id": "633d9a58840cdfb24857b4c3",
      "name": "Balearica",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.07,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Balearica_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=RBQyc8tm3DEsx%2BfyPoBUoDqE3d%2FpIJLQCx99Ppc%2FTUI%3D",
      "cdn_url": "https://audio2.brain.fm/Balearica_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Balearica_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Balearica_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Balearica_Focus_Creativity_Drone_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26227176,
      "sha256": "345ae62ba9c1bb67dac22f2f94ccf389803f0b837b8cef2fced2af705080516f",
      "download_error": null
    },
    {
      "track_id": "62b38a3a5924116a9ef542de",
      "name": "Zero Gravity",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.12,
      "complexity_level": 0.68,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Drones5_1.59_VBR5.mp3?expiration=1792292128759&token=v8FeFEQ9Og93Ioxy3A31viAAzcRzUxpISBPUp9pya04%3D",
      "cdn_url": "https://audio2.brain.fm/Drones5_1.59_VBR5.mp3",
      "remote_filename": "Drones5_1.59_VBR5.mp3",
      "filename": "Drones5_1.59_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Drones5_1.59_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20188111,
      "sha256": "cbab056df792e80877774f48dce48295905c5864b1dc096d0d1fff55d9b9b52e",
      "download_error": null
    },
    {
      "track_id": "62b388e6592411170ff52d6c",
      "name": "Particle and Wave",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.28,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/DRONE%20-%20DoubleVocalsLessStrings_Template3_1.92_VBR5.mp3?expiration=1792292128759&token=UZ0V%2BoBmG9fwqzwh3VnHxAkenuT2fWsLR47xNC4lNaQ%3D",
      "cdn_url": "https://audio2.brain.fm/DRONE%20-%20DoubleVocalsLessStrings_Template3_1.92_VBR5.mp3",
      "remote_filename": "DRONE - DoubleVocalsLessStrings_Template3_1.92_VBR5.mp3",
      "filename": "DRONE-DoubleVocalsLessStrings_Template3_1.92_VBR5.mp3",
      "relative_path": "outputs/audio/drone/DRONE-DoubleVocalsLessStrings_Template3_1.92_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20364823,
      "sha256": "36a077c7912de1bff76e91f1490ff453bdace02b3c097ecc16a204b83e253d6c",
      "download_error": null
    },
    {
      "track_id": "62b388ad592411b378f526d7",
      "name": "Bull's Eye",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.11,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.22,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/DRONE%20-%20VocalsStringsWind_Template3_1.55_VBR5.mp3?expiration=1792292128759&token=Q9%2F0tjtdA%2BGOnsR6enWfFUPFBqQlJQBvlxwQqoPbB9M%3D",
      "cdn_url": "https://audio2.brain.fm/DRONE%20-%20VocalsStringsWind_Template3_1.55_VBR5.mp3",
      "remote_filename": "DRONE - VocalsStringsWind_Template3_1.55_VBR5.mp3",
      "filename": "DRONE-VocalsStringsWind_Template3_1.55_VBR5.mp3",
      "relative_path": "outputs/audio/drone/DRONE-VocalsStringsWind_Template3_1.55_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20009115,
      "sha256": "dbff4c263c9387444a31dfd626d54ff9aad3dbe12909e70f878411515f6d6ea8",
      "download_error": null
    },
    {
      "track_id": "62b388a2592411808bf52536",
      "name": "Beyond Depths",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.14,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Deep%20Stirrings%20-%20NewDrone1_1.30_Nrmlzd2_VBR5.mp3?expiration=1792292128759&token=yJBp1TkNFRZUQufIjIuuqcGhuvmjc%2FSqG7pz9GJm2Ws%3D",
      "cdn_url": "https://audio2.brain.fm/Deep%20Stirrings%20-%20NewDrone1_1.30_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Deep Stirrings - NewDrone1_1.30_Nrmlzd2_VBR5.mp3",
      "filename": "Deep-Stirrings-NewDrone1_1.30_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Deep-Stirrings-NewDrone1_1.30_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20821892,
      "sha256": "e19efae641f5fe78c1fccaaf004b452e7d7585c0ded2942b2970259d26bea5fc",
      "download_error": null
    },
    {
      "track_id": "62b387b75924116375f51feb",
      "name": "Subtle Sublimity",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.43,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/DRONE%20-%20DoubleVocal_Template3_1.94_VBR5.mp3?expiration=1792292128759&token=EtafxfVsu5rYj7tv%2FoP55xpIZKEquh45KGxwtfOrrz4%3D",
      "cdn_url": "https://audio2.brain.fm/DRONE%20-%20DoubleVocal_Template3_1.94_VBR5.mp3",
      "remote_filename": "DRONE - DoubleVocal_Template3_1.94_VBR5.mp3",
      "filename": "DRONE-DoubleVocal_Template3_1.94_VBR5.mp3",
      "relative_path": "outputs/audio/drone/DRONE-DoubleVocal_Template3_1.94_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20040420,
      "sha256": "ba23db0f675f95611a6de5614397b5d500fecbcc795ced00c4bcafae2359fe37",
      "download_error": null
    },
    {
      "track_id": "62b384435924110bf0f50666",
      "name": "Outside the Box",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.21,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/DRONE%20-%20DoubleVocal_Template3_1.105_VBR5.mp3?expiration=1792292128759&token=ZSoNXRUYAszZiNF3T2hfJ6Tx4HcpJjdTTkQc9ePaaGQ%3D",
      "cdn_url": "https://audio2.brain.fm/DRONE%20-%20DoubleVocal_Template3_1.105_VBR5.mp3",
      "remote_filename": "DRONE - DoubleVocal_Template3_1.105_VBR5.mp3",
      "filename": "DRONE-DoubleVocal_Template3_1.105_VBR5.mp3",
      "relative_path": "outputs/audio/drone/DRONE-DoubleVocal_Template3_1.105_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19592122,
      "sha256": "cd2b4f73de034f5e32ab5de808afd1ce23129629b7411dcdb77723567deadb74",
      "download_error": null
    },
    {
      "track_id": "62b3812159241132d3f4e706",
      "name": "Icebreaker",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.1,
      "complexity_level": 0.58,
      "style": "normal",
      "neural_effect_level": 0.78,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Drones3_wLeads_1.47_VBR5.mp3?expiration=1792292128759&token=bRckwzQXKRkpOGrx1H3Igf6hJbaYZrnjcPUe%2FtnbMAg%3D",
      "cdn_url": "https://audio2.brain.fm/Drones3_wLeads_1.47_VBR5.mp3",
      "remote_filename": "Drones3_wLeads_1.47_VBR5.mp3",
      "filename": "Drones3_wLeads_1.47_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Drones3_wLeads_1.47_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18916587,
      "sha256": "ef45894465b973995b4e63aa9a4d4676c00d3eab874eada008fec3aac4cb9633",
      "download_error": null
    },
    {
      "track_id": "62b3810c592411251df4e1d8",
      "name": "Strings of Thought",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Drone%20-%20JustStrings_Template3_1.48_VBR5.mp3?expiration=1792292128759&token=J86hSz3OdJBqOE1NaFQ%2B%2FL3qbvcmkBJrVc5fyMYI2OE%3D",
      "cdn_url": "https://audio2.brain.fm/Drone%20-%20JustStrings_Template3_1.48_VBR5.mp3",
      "remote_filename": "Drone - JustStrings_Template3_1.48_VBR5.mp3",
      "filename": "Drone-JustStrings_Template3_1.48_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Drone-JustStrings_Template3_1.48_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22782586,
      "sha256": "5806b4cb496b69848b1452f1bbc2fef74e4bb4969256ed5385b439d4f183f387",
      "download_error": null
    },
    {
      "track_id": "62b380ff5924111ceef4ddb2",
      "name": "Cloudless Sky",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.16,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Drones4_1.53_VBR5.mp3?expiration=1792292128759&token=Z1o2VpyK9yW2SWsbWmWMAh0CVDdbp2s8hZVw1Cj%2Br5s%3D",
      "cdn_url": "https://audio2.brain.fm/Drones4_1.53_VBR5.mp3",
      "remote_filename": "Drones4_1.53_VBR5.mp3",
      "filename": "Drones4_1.53_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Drones4_1.53_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19831917,
      "sha256": "6db19f20cb6b466469d653a600cfe37ce7f29ef4766b3b456c6972fe4490789f",
      "download_error": null
    },
    {
      "track_id": "62b3808e59241142e8f4d095",
      "name": "Woven Threads",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.32,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.29,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/Drones2_1.16_VBR5.mp3?expiration=1792292128759&token=88btM661NINuG0yXZf%2BvggjP8NtHWP3uTcK8mebp8Dk%3D",
      "cdn_url": "https://audio2.brain.fm/Drones2_1.16_VBR5.mp3",
      "remote_filename": "Drones2_1.16_VBR5.mp3",
      "filename": "Drones2_1.16_VBR5.mp3",
      "relative_path": "outputs/audio/drone/Drones2_1.16_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20473512,
      "sha256": "63c1f103c5ae9b31682735024d105d1353558d803f2299169feb99f2134923fd",
      "download_error": null
    },
    {
      "track_id": "62b380745924117b60f4cb53",
      "name": "Open Valley",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.41,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/DRONE%20-%20VocalsStringsWind_Template3_1.72_VBR5.mp3?expiration=1792292128759&token=H%2Bt0sYJQ9D0OXP3VjR41mHlEIjUkyFwYx%2Fe788%2B7JGA%3D",
      "cdn_url": "https://audio2.brain.fm/DRONE%20-%20VocalsStringsWind_Template3_1.72_VBR5.mp3",
      "remote_filename": "DRONE - VocalsStringsWind_Template3_1.72_VBR5.mp3",
      "filename": "DRONE-VocalsStringsWind_Template3_1.72_VBR5.mp3",
      "relative_path": "outputs/audio/drone/DRONE-VocalsStringsWind_Template3_1.72_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20761360,
      "sha256": "dcf38ef013a22a64854144b2ed3597ded346c6acca6359d0f935fbc16b842020",
      "download_error": null
    },
    {
      "track_id": "62b3806f592411ea8ff4c8f9",
      "name": "Hidden Cove",
      "category": "Drone",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.22,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/drone.json",
      "source_url": "https://audio2.brain.fm/SimpleDrone1_1.61_VBR5.mp3?expiration=1792292128759&token=iGu5LXdxjxcWPjmD%2FD6pOCDejPfhD86evIyAInIaD%2Bc%3D",
      "cdn_url": "https://audio2.brain.fm/SimpleDrone1_1.61_VBR5.mp3",
      "remote_filename": "SimpleDrone1_1.61_VBR5.mp3",
      "filename": "SimpleDrone1_1.61_VBR5.mp3",
      "relative_path": "outputs/audio/drone/SimpleDrone1_1.61_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18184583,
      "sha256": "6382fac30ad53384fc46c3640865c0bcff25586c123cba85f46277d60a2d90af",
      "download_error": null
    },
    {
      "track_id": "6a54f6916ff4d0026250278b",
      "name": "Break That Beat",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.67,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/BreakThatBeat_Focus_Creativity_Electronic_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=WpwgjNMmq1mRh0iIN%2Bs%2FrsK9p9ZiiJT7ODUUxMIIMuo%3D",
      "cdn_url": "https://audio2.brain.fm/BreakThatBeat_Focus_Creativity_Electronic_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BreakThatBeat_Focus_Creativity_Electronic_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BreakThatBeat_Focus_Creativity_Electronic_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/BreakThatBeat_Focus_Creativity_Electronic_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28979865,
      "sha256": "aecc72e439f2d7b9f818091dabe6c0c7067b8cc289173e49f7146c2db7de9da3",
      "download_error": null
    },
    {
      "track_id": "6a54f62e6ff4d002625024ee",
      "name": "Tokyo Hotel",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 131,
      "brightness_level": 0.64,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/TokyoHotel_Focus_Creativity_Electronic_30_131BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=tQkzIQsb%2FXUSETwHRx1G8hfwFM7MbenQ21fpZfW3vC0%3D",
      "cdn_url": "https://audio2.brain.fm/TokyoHotel_Focus_Creativity_Electronic_30_131BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TokyoHotel_Focus_Creativity_Electronic_30_131BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TokyoHotel_Focus_Creativity_Electronic_30_131BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/TokyoHotel_Focus_Creativity_Electronic_30_131BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28407166,
      "sha256": "e85251c5e2619079b46b35498107179e654683892c2dedb209ddb16ecd69b655",
      "download_error": null
    },
    {
      "track_id": "6a4bb6cf4518fc4e1e4061fb",
      "name": "Good To Go",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.68,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/GoodToGo_Focus_Learning_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=gkHZeS6Os3NorTqZq9yIZs6ZQaIlFk4mr8QBTLux2K8%3D",
      "cdn_url": "https://audio2.brain.fm/GoodToGo_Focus_Learning_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GoodToGo_Focus_Learning_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GoodToGo_Focus_Learning_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/GoodToGo_Focus_Learning_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29289634,
      "sha256": "05937cc59176b3d744b13468e7ad2fbe0b7739194fa424d0a0f03eed29fcb37b",
      "download_error": null
    },
    {
      "track_id": "6a4bb67b4518fc4e1e405fe8",
      "name": "Stranger Than Fiction",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 172,
      "brightness_level": 0.81,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/StrangerThanFiction_Focus_Creativity_Electronic_30_172BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=svKih6Yxujer9UnwDknlThVNJDhUenoIGoJyML5ri9I%3D",
      "cdn_url": "https://audio2.brain.fm/StrangerThanFiction_Focus_Creativity_Electronic_30_172BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StrangerThanFiction_Focus_Creativity_Electronic_30_172BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StrangerThanFiction_Focus_Creativity_Electronic_30_172BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/StrangerThanFiction_Focus_Creativity_Electronic_30_172BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29817373,
      "sha256": "d38e1f25bb18a3673191af56de16584206830b8daef7549284f84349f781aa60",
      "download_error": null
    },
    {
      "track_id": "6a4bb6544518fc4e1e405eb7",
      "name": "Created Spaces",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 89,
      "brightness_level": 0.58,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/CreatedSpaces_Focus_DeepWork_Electronic_30_89bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=sKQjmJeGT6t4cSqZoXgk9zYZl8R6Owtgezkyd8QqhXg%3D",
      "cdn_url": "https://audio2.brain.fm/CreatedSpaces_Focus_DeepWork_Electronic_30_89bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CreatedSpaces_Focus_DeepWork_Electronic_30_89bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CreatedSpaces_Focus_DeepWork_Electronic_30_89bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/CreatedSpaces_Focus_DeepWork_Electronic_30_89bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32097153,
      "sha256": "c387fbf8d956c5bc3d6d7bbd14ef1da5db389b4b473e4cb9a747e691f53845b9",
      "download_error": null
    },
    {
      "track_id": "6a42823978a0a113b2ff41a8",
      "name": "Forbidden Fruit",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.67,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/ForbiddenFruitFocus_Learning_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=LIxwlmCIk3vwEwu9cjxXyojv6xxJn0WXUXpy1x4s92c%3D",
      "cdn_url": "https://audio2.brain.fm/ForbiddenFruitFocus_Learning_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ForbiddenFruitFocus_Learning_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ForbiddenFruitFocus_Learning_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/ForbiddenFruitFocus_Learning_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28144831,
      "sha256": "3dcef70df093638611e9991eaee9645b8206fa6fb973f2a0103d847f5ad96623",
      "download_error": null
    },
    {
      "track_id": "6a30177a7a8f5056573c90ee",
      "name": "Soft Snow",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 135,
      "brightness_level": 0.59,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/SoftSnow_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=26Mj3Y4lnLT1kqJTc0qN5d%2BDp9nhFsEw%2FkD9RLvr6bE%3D",
      "cdn_url": "https://audio2.brain.fm/SoftSnow_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SoftSnow_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SoftSnow_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/SoftSnow_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29166003,
      "sha256": "74de790582109096f351c7c0e75445f0d7e83177b46110d5c1e8062917b331f3",
      "download_error": null
    },
    {
      "track_id": "6a3017487a8f5056573c8e64",
      "name": "Happy Panda",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 135,
      "brightness_level": 0.74,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/HappyPanda_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=bpXYJeLHPfWj2pYyJUaQAjZO3KX%2F4OtyBB6K6GEvkHY%3D",
      "cdn_url": "https://audio2.brain.fm/HappyPanda_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HappyPanda_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HappyPanda_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/HappyPanda_Focus_DeepWork_Electronic_30_135BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29567780,
      "sha256": "fd53c21110c2f8e03d7c1e91e8b6bc5119e2a96b3d46cab867121bbf2863bc77",
      "download_error": null
    },
    {
      "track_id": "6a3014ce7a8f5056573c7bf9",
      "name": "Light Dimmer",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.36,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/LightDimmer_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=gEXTnwxYyzy6%2FWCVxkBJMjxcRrfSguZr7xR5lrypFDY%3D",
      "cdn_url": "https://audio2.brain.fm/LightDimmer_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LightDimmer_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LightDimmer_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/LightDimmer_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25549681,
      "sha256": "d4b87ab794079ccf7be6d2f05ae6017159ffdb8d7f8729f1877a8e1aa31b8f24",
      "download_error": null
    },
    {
      "track_id": "6a1dcbb7b7f8597b461243f5",
      "name": "Soft Winters",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.45,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/SoftWinters_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=JsOgpGKFxkyapHjk23aqA4YT4lMoAaEf80X7oGsceA4%3D",
      "cdn_url": "https://audio2.brain.fm/SoftWinters_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SoftWinters_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SoftWinters_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/SoftWinters_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26883940,
      "sha256": "e7c75fafe262b87e70c284134aea7d5f777a7ca91f3c0411b873fff886595edb",
      "download_error": null
    },
    {
      "track_id": "6a1dcb98b7f8597b461242af",
      "name": "Dustlight",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.36,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Dustlight_Focus_DeepWork_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=3G%2Fmj1PFG8N3%2FBWJoWpwJ0ovf7iozvMmit5%2BYzRAI0o%3D",
      "cdn_url": "https://audio2.brain.fm/Dustlight_Focus_DeepWork_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dustlight_Focus_DeepWork_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dustlight_Focus_DeepWork_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Dustlight_Focus_DeepWork_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26975221,
      "sha256": "c9f89528108029ab5ed7a799614a3024ce2f580c2a8542d1d7fa7802f9c20ec8",
      "download_error": null
    },
    {
      "track_id": "6a1dcb67b7f8597b46124131",
      "name": "Breaking The Sequence",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 132,
      "brightness_level": 0.77,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/BreakingTheSequence_Focus_Electronic_Creativity_30_132BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=gATtKiIGb1unoKpTT1gJ7W6I4BL2QCgqFcBeZL1EHx0%3D",
      "cdn_url": "https://audio2.brain.fm/BreakingTheSequence_Focus_Electronic_Creativity_30_132BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BreakingTheSequence_Focus_Electronic_Creativity_30_132BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BreakingTheSequence_Focus_Electronic_Creativity_30_132BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/BreakingTheSequence_Focus_Electronic_Creativity_30_132BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28778466,
      "sha256": "295d9f1356900c9b65089f640bd7b7aa31667cd2dfcd9858e06bb0a03447b08e",
      "download_error": null
    },
    {
      "track_id": "6a1dca94b7f8597b461239e9",
      "name": "Happy Accidents",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.59,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/HappyAccidents_Focus_Creativity_Electronic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=1AHI8nk9SNpdx3qHXZnNA1fJvUsm7mt9xiGvFGkmB%2F8%3D",
      "cdn_url": "https://audio2.brain.fm/HappyAccidents_Focus_Creativity_Electronic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HappyAccidents_Focus_Creativity_Electronic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HappyAccidents_Focus_Creativity_Electronic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/HappyAccidents_Focus_Creativity_Electronic_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28470469,
      "sha256": "e4b95749f5ed1e98052aa1d743fb4170d00e535e8983436c5c38d00f6243a8b9",
      "download_error": null
    },
    {
      "track_id": "6a1dca6fb7f8597b46123847",
      "name": "Tehran",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.68,
      "complexity_level": 0.55,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Tehran_Focus_Creativity_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=iVfCVJSZtxUsct5relQRosl8UWbYIGp2j0CE6AC679k%3D",
      "cdn_url": "https://audio2.brain.fm/Tehran_Focus_Creativity_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tehran_Focus_Creativity_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Tehran_Focus_Creativity_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Tehran_Focus_Creativity_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32871576,
      "sha256": "6b1f966d805805a668f9aa83b4bcaa4ced66cc99e3136257a531aca57e857376",
      "download_error": null
    },
    {
      "track_id": "6a0b8b98e6017bccd74b80a8",
      "name": "Neon Dancer",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.49,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/NeonDancer_Focus_DeepWork_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=rO4MLnKiy9mKBOfKYamLvfetGMUQEPug50q35HT3TJ0%3D",
      "cdn_url": "https://audio2.brain.fm/NeonDancer_Focus_DeepWork_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NeonDancer_Focus_DeepWork_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NeonDancer_Focus_DeepWork_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/NeonDancer_Focus_DeepWork_Electronic_30_115BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25730341,
      "sha256": "7cce1e8c604d34b272342a5c0a6274d631d09c9b54cdac739a72f8ebb2094115",
      "download_error": null
    },
    {
      "track_id": "6a0b8ae5e6017bccd74b78c8",
      "name": "Submission",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 175,
      "brightness_level": 0.74,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Submission_Focus_Creativity_Electronic_30_175BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=sBrwV81xr3bUsBjbRO%2B58AzPzJpVsZRscH626nkYM9E%3D",
      "cdn_url": "https://audio2.brain.fm/Submission_Focus_Creativity_Electronic_30_175BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Submission_Focus_Creativity_Electronic_30_175BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Submission_Focus_Creativity_Electronic_30_175BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Submission_Focus_Creativity_Electronic_30_175BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29293507,
      "sha256": "afc3babab090dfd70951cd0f0b4bb00afc2db21334bda79fbe9ffbd234abad8e",
      "download_error": null
    },
    {
      "track_id": "69f8b9081c706aff1baf1037",
      "name": "The Art Of Feeling",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.57,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/TheArtOfFeeling_Focus_DeepWork_Electronic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=byAIacU3QJjdZ70ZCb28sJLqlbaG7qTLX046V9q5Bh4%3D",
      "cdn_url": "https://audio2.brain.fm/TheArtOfFeeling_Focus_DeepWork_Electronic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheArtOfFeeling_Focus_DeepWork_Electronic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheArtOfFeeling_Focus_DeepWork_Electronic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/TheArtOfFeeling_Focus_DeepWork_Electronic_30_124BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29678673,
      "sha256": "86ce0ac3dee88c6f0b3d2b3f5f1572467d1ab718671506617c17020d03b88bd4",
      "download_error": null
    },
    {
      "track_id": "69f8b8bb1c706aff1baf0d83",
      "name": "Into The Halls Of Dance",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 138,
      "brightness_level": 0.64,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/IntoTheHallsOfDance_Focus_Learning_Electronic_30_138BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=qRYVdN6YB8VCKU84BAFpnClgE1LpCce70IZ6vefhies%3D",
      "cdn_url": "https://audio2.brain.fm/IntoTheHallsOfDance_Focus_Learning_Electronic_30_138BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "IntoTheHallsOfDance_Focus_Learning_Electronic_30_138BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "IntoTheHallsOfDance_Focus_Learning_Electronic_30_138BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/IntoTheHallsOfDance_Focus_Learning_Electronic_30_138BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29092088,
      "sha256": "4bf12972f12996edf7c369709b534305d376b3083807c4027b3ddc931abc01ad",
      "download_error": null
    },
    {
      "track_id": "69f8b7e41c706aff1baf0594",
      "name": "Late Nights",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 128,
      "brightness_level": 0.52,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/LateNights_Focus_Creativity_Electronic_30_128BPM_LowNEL_VBR5.mp3?expiration=1792292131707&token=Ok86151c7EbpdhJgYkpGmdj8xrSPAW3B0Ex%2BZqx0bWc%3D",
      "cdn_url": "https://audio2.brain.fm/LateNights_Focus_Creativity_Electronic_30_128BPM_LowNEL_VBR5.mp3",
      "remote_filename": "LateNights_Focus_Creativity_Electronic_30_128BPM_LowNEL_VBR5.mp3",
      "filename": "LateNights_Focus_Creativity_Electronic_30_128BPM_LowNEL_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/LateNights_Focus_Creativity_Electronic_30_128BPM_LowNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28578604,
      "sha256": "17d129d28835fd972339b4dec4fd3ea4de3ba328ce02a6dac2e82bb224c3de83",
      "download_error": null
    },
    {
      "track_id": "69e68655dce2120639c6eba0",
      "name": "Three Sisters",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 146,
      "brightness_level": 0.58,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/ThreeSisters_Focus_Learning_Electronic_30_146BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=hx5k8xWCWjsOuDFRK4qWf2MPcWZckLSSYdWiGcpXQIs%3D",
      "cdn_url": "https://audio2.brain.fm/ThreeSisters_Focus_Learning_Electronic_30_146BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThreeSisters_Focus_Learning_Electronic_30_146BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThreeSisters_Focus_Learning_Electronic_30_146BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/ThreeSisters_Focus_Learning_Electronic_30_146BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27987230,
      "sha256": "8b361384e58bc5a4fe96139c1bf7d68ec3b3e924a87971c2b18516669bafb948",
      "download_error": null
    },
    {
      "track_id": "69e68517dce2120639c6e12d",
      "name": "Somaticize",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 160,
      "brightness_level": 0.51,
      "complexity_level": 1,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Somaticize_Focus_Learning_Electronic_30_160BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=Ce3bk8bQfHBVmqAyCE6Z6mPg3E9mF0y9jmzl0EyCm90%3D",
      "cdn_url": "https://audio2.brain.fm/Somaticize_Focus_Learning_Electronic_30_160BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Somaticize_Focus_Learning_Electronic_30_160BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Somaticize_Focus_Learning_Electronic_30_160BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Somaticize_Focus_Learning_Electronic_30_160BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27457729,
      "sha256": "e88a3ca03ceae525526b0a85166b7ac33d5d2f53160d6d7cf0cb7f342d588ffb",
      "download_error": null
    },
    {
      "track_id": "69d028379b9914998a32dc91",
      "name": "Living Joy",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.49,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/LivingJoy_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=BlpYgUEw91aKo3O%2F2UZTKRGJhg1SIzbXOzKbS7H4o4Y%3D",
      "cdn_url": "https://audio2.brain.fm/LivingJoy_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LivingJoy_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LivingJoy_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/LivingJoy_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29282190,
      "sha256": "44a65a69eacdb09488f117ffb296f13c070c1ca2645c51824c1dfe430ed51558",
      "download_error": null
    },
    {
      "track_id": "69d0275f9b9914998a32d581",
      "name": "Three Bodies",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 135,
      "brightness_level": 0.64,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/ThreeBodies_Focus_Electronic_Creativity_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=M8OVq5otY6caBIQrxudEuy%2B%2FyOkHeC2I9%2BHjTtbhbXs%3D",
      "cdn_url": "https://audio2.brain.fm/ThreeBodies_Focus_Electronic_Creativity_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThreeBodies_Focus_Electronic_Creativity_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThreeBodies_Focus_Electronic_Creativity_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/ThreeBodies_Focus_Electronic_Creativity_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29730150,
      "sha256": "2309cbaca80385cfea9b09161a546501adf60a490f01626a0de2bb391b6b6acd",
      "download_error": null
    },
    {
      "track_id": "69d026a79b9914998a32cf6f",
      "name": "Colours Of The Mind",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 129,
      "brightness_level": 0.7,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/ColoursOfTheMind_Focus_Creativity_Electronic_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=RXkU8dbSfjVEqkT3J0A51%2BuyncZ%2FEeZyr2wDNs272Ao%3D",
      "cdn_url": "https://audio2.brain.fm/ColoursOfTheMind_Focus_Creativity_Electronic_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ColoursOfTheMind_Focus_Creativity_Electronic_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ColoursOfTheMind_Focus_Creativity_Electronic_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/ColoursOfTheMind_Focus_Creativity_Electronic_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29484568,
      "sha256": "0e73c875853b5b104f8425ae21046f539e1643ac114470d47afb260a224092bd",
      "download_error": null
    },
    {
      "track_id": "69d026589b9914998a32cc95",
      "name": "Twin Pines",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.49,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/TwinPines_Focus_Learning_Electronic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=qff%2Bo%2BwEU4nVRhIg6fUAWpNN%2FUz8e285U%2FnCoButga0%3D",
      "cdn_url": "https://audio2.brain.fm/TwinPines_Focus_Learning_Electronic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TwinPines_Focus_Learning_Electronic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TwinPines_Focus_Learning_Electronic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/TwinPines_Focus_Learning_Electronic_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28656568,
      "sha256": "c211b3e43447308d136bc74bca00f76d3ef6547b0478a97db0676864ba2cdc9b",
      "download_error": null
    },
    {
      "track_id": "69c2bd661b6ecfe6c4a72806",
      "name": "Dark Shifter",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 125,
      "brightness_level": 0.45,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/DarkShifter_Focus_DeepWork_Electronic_30_125BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=hkd7p7luKhb6Po2NZXSvdJGFS25t%2F1BV%2FOShEyxYD%2BI%3D",
      "cdn_url": "https://audio2.brain.fm/DarkShifter_Focus_DeepWork_Electronic_30_125BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DarkShifter_Focus_DeepWork_Electronic_30_125BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DarkShifter_Focus_DeepWork_Electronic_30_125BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/DarkShifter_Focus_DeepWork_Electronic_30_125BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27735459,
      "sha256": "8fcd85141ed830b0cfb3b80273bd123f256183973237fd2d01a5115b0985dbcd",
      "download_error": null
    },
    {
      "track_id": "69c2bd191b6ecfe6c4a72467",
      "name": "Deep Dish",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 97,
      "brightness_level": 0.41,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/DeepDish_Focus_DeepWork_Electronic_30_97BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=R1jqlCkwS%2B%2BwlPBoxHWTQXinjzhKIyCzDOsEeTAt3TQ%3D",
      "cdn_url": "https://audio2.brain.fm/DeepDish_Focus_DeepWork_Electronic_30_97BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DeepDish_Focus_DeepWork_Electronic_30_97BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DeepDish_Focus_DeepWork_Electronic_30_97BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/DeepDish_Focus_DeepWork_Electronic_30_97BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28896465,
      "sha256": "c3df452166caec97b4738f6f98f876f49dbea6dd32ca6b988e1ed0abfe8d49ea",
      "download_error": null
    },
    {
      "track_id": "69c2bcda1b6ecfe6c4a72266",
      "name": "Shake The Floor",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.61,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/ShakeTheFloor_Focus_Creativity_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=n9bwjEIXnM29zTj8gadWwKYixaAz%2FsBeVdveooLxIAQ%3D",
      "cdn_url": "https://audio2.brain.fm/ShakeTheFloor_Focus_Creativity_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ShakeTheFloor_Focus_Creativity_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ShakeTheFloor_Focus_Creativity_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/ShakeTheFloor_Focus_Creativity_Electronic_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30296569,
      "sha256": "5d12dc021c4257dcb90a239e0d27580f05e765a32f05aa2799345d0a9f28a6a1",
      "download_error": null
    },
    {
      "track_id": "69c2bb671b6ecfe6c4a715d3",
      "name": "Fine Job",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.57,
      "complexity_level": 0.43,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Fine%20Job_Focus_Learning_Electronic_30_126bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=wrq0P6YIyayI4G%2B8m6cQ2E%2Bw6wK5WP7MHownxtWFAAI%3D",
      "cdn_url": "https://audio2.brain.fm/Fine%20Job_Focus_Learning_Electronic_30_126bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fine Job_Focus_Learning_Electronic_30_126bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fine-Job_Focus_Learning_Electronic_30_126bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Fine-Job_Focus_Learning_Electronic_30_126bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31999923,
      "sha256": "8585019d091a557c8d0f8ead23cd73f151e6af785c7b8c98318d70de860d988f",
      "download_error": null
    },
    {
      "track_id": "69aee2f673bfe2099d517dc9",
      "name": "Soft Blue Shades",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.65,
      "complexity_level": 0.37,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/SoftBlueShades_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=rXqb8kg87HPC7FLQsTZ6TutX5aRNDWU%2BLApSw7LlgaA%3D",
      "cdn_url": "https://audio2.brain.fm/SoftBlueShades_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SoftBlueShades_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SoftBlueShades_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/SoftBlueShades_Focus_DeepWork_Electronic_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25115086,
      "sha256": "2a47fb57bdbb82ddba476bd3ac6b40bf09b95f45fe20b0a92aa8a884aec27ac5",
      "download_error": null
    },
    {
      "track_id": "69aee28e73bfe2099d5179fe",
      "name": "Torontario",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.41,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Torontario_Focus_DeepWork_Electronic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=u23G1Gw4jeyBNVG%2BGSktzfeuuMmRdQ792N280kyxps4%3D",
      "cdn_url": "https://audio2.brain.fm/Torontario_Focus_DeepWork_Electronic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Torontario_Focus_DeepWork_Electronic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Torontario_Focus_DeepWork_Electronic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Torontario_Focus_DeepWork_Electronic_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29097979,
      "sha256": "d96dfa6097e1e34588fbd951cca7ef6c8ed00932fd2d36b5511f6caaf8cb3e91",
      "download_error": null
    },
    {
      "track_id": "69aee1df73bfe2099d51762e",
      "name": "High Altitude",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 111,
      "brightness_level": 0.65,
      "complexity_level": 0.33,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/HighAltitude_Focus_Electronic_Creativity_30_111BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=BaQnCv1FMWhRLB4QW3G5k%2FL%2FuYrnbxfksPic0wK1DQE%3D",
      "cdn_url": "https://audio2.brain.fm/HighAltitude_Focus_Electronic_Creativity_30_111BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HighAltitude_Focus_Electronic_Creativity_30_111BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HighAltitude_Focus_Electronic_Creativity_30_111BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/HighAltitude_Focus_Electronic_Creativity_30_111BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31440950,
      "sha256": "722bce817d5d19021dfb986512ec52d5b81c0042c8206fe1025b8c21086d0816",
      "download_error": null
    },
    {
      "track_id": "699caf719033fe9e7ccfb884",
      "name": "Reasonable Dust",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 81,
      "brightness_level": 0.48,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/ReasonableDust_Focus_DeepWork_Electronic_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=X2v5TzLdsltqQsa2%2BDi87cWNmsCHNeSpd9%2FeNGbRLQs%3D",
      "cdn_url": "https://audio2.brain.fm/ReasonableDust_Focus_DeepWork_Electronic_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ReasonableDust_Focus_DeepWork_Electronic_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ReasonableDust_Focus_DeepWork_Electronic_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/ReasonableDust_Focus_DeepWork_Electronic_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28737582,
      "sha256": "bf6452352e0338465a958dc77a2317612f58a200fa9699ff50d6b0b99c1535b3",
      "download_error": null
    },
    {
      "track_id": "699cacb19033fe9e7ccfa202",
      "name": "Slow Descent",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.52,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/SlowDescent_Focus_Electronic_DeepWork_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=hvdKQkO1gIb1HZ6CQdlepFds6EtsMF7MYPk4YKirNMw%3D",
      "cdn_url": "https://audio2.brain.fm/SlowDescent_Focus_Electronic_DeepWork_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SlowDescent_Focus_Electronic_DeepWork_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SlowDescent_Focus_Electronic_DeepWork_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/SlowDescent_Focus_Electronic_DeepWork_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29056318,
      "sha256": "82247a88444fdaf7e0c0afe803ea241a49184a7e2e3fcb72ea7d3ad57f336ec9",
      "download_error": null
    },
    {
      "track_id": "699cab6a9033fe9e7ccf9646",
      "name": "Swirling",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 111,
      "brightness_level": 0.49,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Swirling_Focus_Learning_Electronic_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=PDhKLyJUGz4P6uKS%2F8kHpxsGomgl7j138SBy09RdVP8%3D",
      "cdn_url": "https://audio2.brain.fm/Swirling_Focus_Learning_Electronic_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Swirling_Focus_Learning_Electronic_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Swirling_Focus_Learning_Electronic_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Swirling_Focus_Learning_Electronic_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28661045,
      "sha256": "bd8bf68210fc3459e2f44fb35518b5cc19b2acb7319600f6c372d3eb5e698a97",
      "download_error": null
    },
    {
      "track_id": "699cab3c9033fe9e7ccf948a",
      "name": "Get Moving",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 136,
      "brightness_level": 0.41,
      "complexity_level": 0.93,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/GetMoving_Focus_DeepWork_Electronic_30_136BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=oaLfHvAyWKfGTeztG8LCRE657Lgh0ZyEpmXMIc%2F7EFo%3D",
      "cdn_url": "https://audio2.brain.fm/GetMoving_Focus_DeepWork_Electronic_30_136BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GetMoving_Focus_DeepWork_Electronic_30_136BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GetMoving_Focus_DeepWork_Electronic_30_136BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/GetMoving_Focus_DeepWork_Electronic_30_136BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28098148,
      "sha256": "72380ee8534de61cac1392c4e7b7e5de7a7e1d57789d87e31b2b48a3b310b614",
      "download_error": null
    },
    {
      "track_id": "698a17b28a4a8f35be585087",
      "name": "Direct Current",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.42,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/DirectCurrent_Focus_Learning_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=7XTnNwMGzII8X%2F20rOls2zk2wCAfNdcpmhWHPBY%2FoKM%3D",
      "cdn_url": "https://audio2.brain.fm/DirectCurrent_Focus_Learning_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DirectCurrent_Focus_Learning_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DirectCurrent_Focus_Learning_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/DirectCurrent_Focus_Learning_Electronic_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30228200,
      "sha256": "46c43ce15a84afb1d1cb47c2d76c32fd7d4097a8f16854b2f69860e5c6dd4d55",
      "download_error": null
    },
    {
      "track_id": "698a15538a4a8f35be583543",
      "name": "Dark & Light",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 123,
      "brightness_level": 0.54,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Dark%26Light_Focus_Creativity_Electronic_30_123BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=ONemPs%2BehidspAW30a8SNbg1Tine6VxzLLeJtqV3QXQ%3D",
      "cdn_url": "https://audio2.brain.fm/Dark%26Light_Focus_Creativity_Electronic_30_123BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dark&Light_Focus_Creativity_Electronic_30_123BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dark-Light_Focus_Creativity_Electronic_30_123BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Dark-Light_Focus_Creativity_Electronic_30_123BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29889843,
      "sha256": "95e1ec3f8db5aed7542c7e051500e3e6771ab07bf14a30ff60e84cf08e55fc01",
      "download_error": null
    },
    {
      "track_id": "698a15058a4a8f35be58322c",
      "name": "Assigned Elements",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 135,
      "brightness_level": 0.39,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/AssignedElements_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=WnmVjjbhdz4l1p%2BELPlY4hDaEjCEsdcOdWZt4YeiNbU%3D",
      "cdn_url": "https://audio2.brain.fm/AssignedElements_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AssignedElements_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AssignedElements_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/AssignedElements_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28732092,
      "sha256": "a816beb96b1ea3ef9ab7b80865ca694de3174cd5f618374b987fc9b3020a8443",
      "download_error": null
    },
    {
      "track_id": "6977b670236f65de4c7e340a",
      "name": "Amber Phases",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.35,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/AmberPhases_Focus_Electronic_DeepWork_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=cRjbwHSE1ASn83b3XMOthJ4lHPU4x%2FFTQvKk8XWyf3M%3D",
      "cdn_url": "https://audio2.brain.fm/AmberPhases_Focus_Electronic_DeepWork_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AmberPhases_Focus_Electronic_DeepWork_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AmberPhases_Focus_Electronic_DeepWork_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/AmberPhases_Focus_Electronic_DeepWork_30_115BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32308550,
      "sha256": "22aac885ff458860e72a8d785ad9d9c2a304219c72886e60078b69989d70d372",
      "download_error": null
    },
    {
      "track_id": "6977b610597917b519504e71",
      "name": "Crossing Mountains",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 140,
      "brightness_level": 0.33,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/CrossingMountains_Focus_Electronic_Creativity_30_140BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=D2HPwdj%2FuvFuwwUH9gQTp67mcZ0BaVV%2Fod3T5k8VQrI%3D",
      "cdn_url": "https://audio2.brain.fm/CrossingMountains_Focus_Electronic_Creativity_30_140BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CrossingMountains_Focus_Electronic_Creativity_30_140BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CrossingMountains_Focus_Electronic_Creativity_30_140BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/CrossingMountains_Focus_Electronic_Creativity_30_140BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29500153,
      "sha256": "57122e0f0c1c55b0e9dbd6f3b2168d92259baddee9d68f3b2dedbfd87b571e33",
      "download_error": null
    },
    {
      "track_id": "6977b5dd597917b519504ce7",
      "name": "Balinese Gold Bricks",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.43,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/BalineseGoldBricks_Focus_Learning_Electronic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=AsqA8mkecm0lKvVUNklkw6Xu5m8H8fW3Sn%2FoQUq8Hk8%3D",
      "cdn_url": "https://audio2.brain.fm/BalineseGoldBricks_Focus_Learning_Electronic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BalineseGoldBricks_Focus_Learning_Electronic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BalineseGoldBricks_Focus_Learning_Electronic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/BalineseGoldBricks_Focus_Learning_Electronic_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29873159,
      "sha256": "ef81678a71ced43c4c4800f2a9c4565ec10275a3bbe84a89fff176787a17df55",
      "download_error": null
    },
    {
      "track_id": "6977b59f236f65de4c7e2f88",
      "name": "Endless Rain",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 152,
      "brightness_level": 0.67,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/EndlessRain_Focus_Learning_Electronic_30_152BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=Bqk6iMY41LDSJ6nICjM7HYOBXWcmGSA5p7Gtg85BvE8%3D",
      "cdn_url": "https://audio2.brain.fm/EndlessRain_Focus_Learning_Electronic_30_152BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EndlessRain_Focus_Learning_Electronic_30_152BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EndlessRain_Focus_Learning_Electronic_30_152BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/EndlessRain_Focus_Learning_Electronic_30_152BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29427083,
      "sha256": "0497c74db38eef2251c390b4c73a300a08b3acb6b52ed678555a7dd477a5e90c",
      "download_error": null
    },
    {
      "track_id": "69655b6a212c8d55194eec37",
      "name": "Proteins",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.67,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Proteins_Focus_Electronic_Learning_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=aBfSxUhKaPq3LreihSk%2BsH0RYiB15%2Bt1mF8FjO1De%2Bk%3D",
      "cdn_url": "https://audio2.brain.fm/Proteins_Focus_Electronic_Learning_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Proteins_Focus_Electronic_Learning_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Proteins_Focus_Electronic_Learning_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Proteins_Focus_Electronic_Learning_30_108BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29958144,
      "sha256": "67cd33879118a75bdaa45e03df33e0dc304e15302c6b1f2562e4565fc16f835c",
      "download_error": null
    },
    {
      "track_id": "69655aeb212c8d55194ee9c1",
      "name": "The Ledge",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 129,
      "brightness_level": 0.65,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/TheLedge_Focus_Electronic_DeepWork_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=3xek0gVXtaMKIAXXegEju%2FrOfU1UfTvHpxPrs2r2Qdk%3D",
      "cdn_url": "https://audio2.brain.fm/TheLedge_Focus_Electronic_DeepWork_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheLedge_Focus_Electronic_DeepWork_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheLedge_Focus_Electronic_DeepWork_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/TheLedge_Focus_Electronic_DeepWork_30_129BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28016847,
      "sha256": "5477ab0418160bc2f4f3b3c4cb6a59dd4dba23a5a3357672cd31f122d096664d",
      "download_error": null
    },
    {
      "track_id": "69655a1f8afa49f5711b8e99",
      "name": "Askew",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.61,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Askew_Focus_Deep%20Work_Electronic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=b1cOjIopZeY4n91OmtG5Nb6icT%2F0lwWsWI4ZsivzlDw%3D",
      "cdn_url": "https://audio2.brain.fm/Askew_Focus_Deep%20Work_Electronic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Askew_Focus_Deep Work_Electronic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Askew_Focus_Deep-Work_Electronic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Askew_Focus_Deep-Work_Electronic_30_126bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29840261,
      "sha256": "0c6787baf42b1b4440d8196c88f63f6dd352f52a47072e927d1129bb56713d97",
      "download_error": null
    },
    {
      "track_id": "6952f3809e729f65562d11a1",
      "name": "Cut & Copy",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 111,
      "brightness_level": 0.59,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Cut%26Copy_Focus_Electronic_Learning_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=1HNBO%2FjGgbOnxQf9uad1G6OH6Ft7k3yvYxGM20ZHU%2Fk%3D",
      "cdn_url": "https://audio2.brain.fm/Cut%26Copy_Focus_Electronic_Learning_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Cut&Copy_Focus_Electronic_Learning_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Cut-Copy_Focus_Electronic_Learning_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Cut-Copy_Focus_Electronic_Learning_30_111BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29600001,
      "sha256": "00e7dae971b22cb7b4178e052f39ad6f48ea805a866555d5b9348b1480fb0237",
      "download_error": null
    },
    {
      "track_id": "6952f3629e729f65562d1127",
      "name": "Nine After Nine",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.67,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/NineAfterNine_Focus_Electronic_Creativity_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=YMdflL7i%2FPuUehf74vWYKxxugknnydMt7GWHlU6ODmE%3D",
      "cdn_url": "https://audio2.brain.fm/NineAfterNine_Focus_Electronic_Creativity_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NineAfterNine_Focus_Electronic_Creativity_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NineAfterNine_Focus_Electronic_Creativity_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/NineAfterNine_Focus_Electronic_Creativity_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26703894,
      "sha256": "f8c3ea858dafcf6d33d1856540ead18de14fa2942c21ded941bda996f0c032a4",
      "download_error": null
    },
    {
      "track_id": "6952eebfb1c39edafb0de00a",
      "name": "Winner Takes All",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.71,
      "complexity_level": 0.94,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/WinnerTakesAll_Focus_DeepWork_Electronic_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=aD6QHq6RBiY75RfKeZpnwvPtM4IYTPEX4uuLU5cYa6w%3D",
      "cdn_url": "https://audio2.brain.fm/WinnerTakesAll_Focus_DeepWork_Electronic_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WinnerTakesAll_Focus_DeepWork_Electronic_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WinnerTakesAll_Focus_DeepWork_Electronic_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/WinnerTakesAll_Focus_DeepWork_Electronic_30_124BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29309432,
      "sha256": "1855caabc289a47ca9121f8b2ca18feead882e2e52792ef1748bd848d0b27c2d",
      "download_error": null
    },
    {
      "track_id": "6940592976a1c1f80ff93665",
      "name": "Lost Highway",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.59,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/LostHighWay_Focus_Creativity_Electronic_30_116BPM_HighNEL_VBR5.mp3?expiration=1792292131707&token=e260bHubTG6XngKo%2B2vnwxFScWoujJ%2B37V%2F0JVnMx8k%3D",
      "cdn_url": "https://audio2.brain.fm/LostHighWay_Focus_Creativity_Electronic_30_116BPM_HighNEL_VBR5.mp3",
      "remote_filename": "LostHighWay_Focus_Creativity_Electronic_30_116BPM_HighNEL_VBR5.mp3",
      "filename": "LostHighWay_Focus_Creativity_Electronic_30_116BPM_HighNEL_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/LostHighWay_Focus_Creativity_Electronic_30_116BPM_HighNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27976579,
      "sha256": "183c5a5989b220e7812be04fe58cf18d938f371fc5d59012185f692f775897c0",
      "download_error": null
    },
    {
      "track_id": "6940590f76a1c1f80ff935ab",
      "name": "Sequential",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.29,
      "complexity_level": 0.37,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Sequential_Focus_DeepWork_Electronic_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=UAkSPHrCIU%2Bq3dJK9QwkBYnFsIuqtHX20BkkaW5gC6A%3D",
      "cdn_url": "https://audio2.brain.fm/Sequential_Focus_DeepWork_Electronic_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sequential_Focus_DeepWork_Electronic_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sequential_Focus_DeepWork_Electronic_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Sequential_Focus_DeepWork_Electronic_30_116BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25590285,
      "sha256": "8fd1ccc0398f2a321e9aa67ccce31670efca587d0bc00f3a1cd7d9db28ba1f08",
      "download_error": null
    },
    {
      "track_id": "692dbe4c66ea27cd5c911915",
      "name": "Crisp Air",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 123,
      "brightness_level": 0.51,
      "complexity_level": 0.35,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/CrispAir_Focus_Electronic_DeepWork_30_123BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=qRb9COlW6%2F9nz2T%2Bk7d8IBJOSwerTJKboCjaTzyVR0I%3D",
      "cdn_url": "https://audio2.brain.fm/CrispAir_Focus_Electronic_DeepWork_30_123BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CrispAir_Focus_Electronic_DeepWork_30_123BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CrispAir_Focus_Electronic_DeepWork_30_123BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/CrispAir_Focus_Electronic_DeepWork_30_123BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29011789,
      "sha256": "d4a5b83f58142012aa8a7246100ac54c9bde1546e148579acf41866676037dd3",
      "download_error": null
    },
    {
      "track_id": "691b3bae331c372ce87481a0",
      "name": "Mirror Purity",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 122,
      "brightness_level": 0.39,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/MirrorPurity_Focus_DeepWork_Electronic_30_122BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=n2%2BKvnilPRR2Fbbp0Iro1BweVqK5Pe2fSONZpJUNs4Q%3D",
      "cdn_url": "https://audio2.brain.fm/MirrorPurity_Focus_DeepWork_Electronic_30_122BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MirrorPurity_Focus_DeepWork_Electronic_30_122BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MirrorPurity_Focus_DeepWork_Electronic_30_122BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/MirrorPurity_Focus_DeepWork_Electronic_30_122BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27956733,
      "sha256": "6c9d9e50c12fa806de995b526dfde68f3bf9f2418c3e1821992a27e87abfc015",
      "download_error": null
    },
    {
      "track_id": "6909184926bc41a99c8631cf",
      "name": "Isfahan",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.64,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Isfahan_Focus_DeepWork_Electronic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=9pyRQJoBYxjmLBAELRcMrvvRlHONRRfhPaatXwWEQ4w%3D",
      "cdn_url": "https://audio2.brain.fm/Isfahan_Focus_DeepWork_Electronic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Isfahan_Focus_DeepWork_Electronic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Isfahan_Focus_DeepWork_Electronic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Isfahan_Focus_DeepWork_Electronic_30_108bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30972336,
      "sha256": "6f4c5ed9dd3aca57e7e57cec633e89e936604af6e211a300d621d18b86ec7393",
      "download_error": null
    },
    {
      "track_id": "68f665a5c7a40a338f8461b1",
      "name": "De La Noche",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.65,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/DeLaNoche_Focus_Electronic_Creativity_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=gfh2t9DKhta6QZUOyKbBR3LzEwF1p3ffYRNMkjLGPAA%3D",
      "cdn_url": "https://audio2.brain.fm/DeLaNoche_Focus_Electronic_Creativity_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DeLaNoche_Focus_Electronic_Creativity_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DeLaNoche_Focus_Electronic_Creativity_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/DeLaNoche_Focus_Electronic_Creativity_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28187923,
      "sha256": "90f1156d1e05baf91fe076ece490396d7c78c41f38b0701ccc88a623dc169005",
      "download_error": null
    },
    {
      "track_id": "68f6651ec7a40a338f845dfa",
      "name": "Intelligencia",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 144,
      "brightness_level": 0.62,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Intelligencia_Focus_Electronic_Creativity_30_144BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=4BumnkpmbQxDLtLkPbjSuZZdDPytL1CBIXkTLTLVAU0%3D",
      "cdn_url": "https://audio2.brain.fm/Intelligencia_Focus_Electronic_Creativity_30_144BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Intelligencia_Focus_Electronic_Creativity_30_144BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Intelligencia_Focus_Electronic_Creativity_30_144BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Intelligencia_Focus_Electronic_Creativity_30_144BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29582067,
      "sha256": "708d5ea4f00306ce96c66cd98089a0a516ca80144efa79c9f4e21ad4079441c2",
      "download_error": null
    },
    {
      "track_id": "68e3d7532d873930bbbf7b91",
      "name": "Scraping",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.58,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Scraping_Focus_Learning_Electronic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=iMtdtI3JiM%2BWNTefyJzlG%2FuQorUJ1vbjA%2FV2DNPdA2M%3D",
      "cdn_url": "https://audio2.brain.fm/Scraping_Focus_Learning_Electronic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Scraping_Focus_Learning_Electronic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Scraping_Focus_Learning_Electronic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Scraping_Focus_Learning_Electronic_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31022534,
      "sha256": "83b840729d1f9191ec790ab9373f5fa0ad28527a869e6a316282d9b8fea32caa",
      "download_error": null
    },
    {
      "track_id": "68e3d6cfc1aa1a1dfaaec825",
      "name": "New Dawn",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 138,
      "brightness_level": 0.48,
      "complexity_level": 0.41,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/NewDawn_Focus_DeepWork_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=dZWUHTt83EQ%2BFUpYlcBp6md%2BnQlRkBMjXNDvX28DpEI%3D",
      "cdn_url": "https://audio2.brain.fm/NewDawn_Focus_DeepWork_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NewDawn_Focus_DeepWork_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NewDawn_Focus_DeepWork_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/NewDawn_Focus_DeepWork_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26737606,
      "sha256": "00abf6f2fa89e71bf557a90dc73fb178a091f10ea6bfb8d356610f446a817ecb",
      "download_error": null
    },
    {
      "track_id": "68e3d6c0c1aa1a1dfaaec7c5",
      "name": "Swimming",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.35,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Swimming_Focus_DeepWork_Electronic_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=PwqgpySRhXErtd6IS6rv8CfsRjWa4iiMMixqLobcxgE%3D",
      "cdn_url": "https://audio2.brain.fm/Swimming_Focus_DeepWork_Electronic_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Swimming_Focus_DeepWork_Electronic_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Swimming_Focus_DeepWork_Electronic_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Swimming_Focus_DeepWork_Electronic_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29234150,
      "sha256": "03be207cefcd78148f3ee544d2d4d64561c6acc75bd910d0ddabc072d7a31e2e",
      "download_error": null
    },
    {
      "track_id": "68e3d6b22d873930bbbf78d7",
      "name": "Owsey",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.55,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Owsey_Focus_Creativity_Electronic_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=U6vMAESnB63YwSRXPLM8mrFmAvYBROqVLExhDrr6CbQ%3D",
      "cdn_url": "https://audio2.brain.fm/Owsey_Focus_Creativity_Electronic_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Owsey_Focus_Creativity_Electronic_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Owsey_Focus_Creativity_Electronic_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Owsey_Focus_Creativity_Electronic_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31959840,
      "sha256": "3de3d10b18c571db9dfcd6ec9fd1d80eef1027453da680fb47c6d53cc0258c00",
      "download_error": null
    },
    {
      "track_id": "68d1775cd9158d8853b16d27",
      "name": "Ignition",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.55,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Ignition_Focus_Creativity_Electronic_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=JsL2pyYJklx9FoBRY6VE0I4Aw70B3MgoksXvoBcjFAs%3D",
      "cdn_url": "https://audio2.brain.fm/Ignition_Focus_Creativity_Electronic_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Ignition_Focus_Creativity_Electronic_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Ignition_Focus_Creativity_Electronic_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Ignition_Focus_Creativity_Electronic_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29206299,
      "sha256": "e2fb810bb6c5da895d1e9eb538711156c13dea49db4df5868f24a50f7bf622a6",
      "download_error": null
    },
    {
      "track_id": "68d17723a2277468b10cd0dd",
      "name": "Placements",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.42,
      "complexity_level": 0.78,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Placements_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=6VED%2FDlSmHPtjLLDkZjqpTMtAHHxKoXRLvr2mQIHy60%3D",
      "cdn_url": "https://audio2.brain.fm/Placements_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Placements_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Placements_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Placements_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30457152,
      "sha256": "e5c998b321aa9b8856f736360c3f640e6cca4221c20e4ce25219883d54852e47",
      "download_error": null
    },
    {
      "track_id": "68bf247b95e372361f91f509",
      "name": "Peppy",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 170,
      "brightness_level": 0.55,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Peppy_Focus_Creativity_Electronic_30_170BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=5vYcc9DbnYndHKX%2FNW8IAUMdHiJuD%2F7DaDYBVgRYisM%3D",
      "cdn_url": "https://audio2.brain.fm/Peppy_Focus_Creativity_Electronic_30_170BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Peppy_Focus_Creativity_Electronic_30_170BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Peppy_Focus_Creativity_Electronic_30_170BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Peppy_Focus_Creativity_Electronic_30_170BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28409957,
      "sha256": "732ff2da1444860b686ff7301c250db0d9e55c96d20bb1e564891077bbb3b5f3",
      "download_error": null
    },
    {
      "track_id": "68bf2374bab547755c78716d",
      "name": "Sunken Frigate",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 172,
      "brightness_level": 0.52,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Sunken%20Frigate_Focus_Deep%20Work_Electronic_30_172bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=6ST1v1hPq93%2FV7Mx%2BwmM%2FY%2BS1JypcKZn%2F5bKMrg0a1o%3D",
      "cdn_url": "https://audio2.brain.fm/Sunken%20Frigate_Focus_Deep%20Work_Electronic_30_172bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sunken Frigate_Focus_Deep Work_Electronic_30_172bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sunken-Frigate_Focus_Deep-Work_Electronic_30_172bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Sunken-Frigate_Focus_Deep-Work_Electronic_30_172bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28384701,
      "sha256": "ad11f97c07c77962f7fd92c19a6916a17186f9a70a3d3f5d7e3561659155c8ce",
      "download_error": null
    },
    {
      "track_id": "68aca3e2605d1de9ea68b8ce",
      "name": "Misspelled Monologue",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 125,
      "brightness_level": 0.67,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Misspelled%20Monologue_Focus_Learning_Electronic_30_125bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=GlOBBMbRhz7ln48St7Ta7hu8NuN1sQzTGqdje7MG7Qk%3D",
      "cdn_url": "https://audio2.brain.fm/Misspelled%20Monologue_Focus_Learning_Electronic_30_125bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Misspelled Monologue_Focus_Learning_Electronic_30_125bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Misspelled-Monologue_Focus_Learning_Electronic_30_125bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Misspelled-Monologue_Focus_Learning_Electronic_30_125bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28900621,
      "sha256": "cb7d8e045a88650446e98a9d1d5d83e8ae6c51ffbc759b331b6806cf9129f9e7",
      "download_error": null
    },
    {
      "track_id": "689a227d9446c76349a3b26c",
      "name": "Tied In Strings",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.38,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Tied_In_Strings_Focus_Deep_Work_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=EUhVgPFGjabkrXNnsO%2Fs38LX%2B5jyzLAqHYmxAgQkTrU%3D",
      "cdn_url": "https://audio2.brain.fm/Tied_In_Strings_Focus_Deep_Work_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tied_In_Strings_Focus_Deep_Work_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Tied_In_Strings_Focus_Deep_Work_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Tied_In_Strings_Focus_Deep_Work_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31697239,
      "sha256": "a7d3054da07d80aa26a2e9020e926d60e377c9cf5bcb7a087db3ef7f52f7323e",
      "download_error": null
    },
    {
      "track_id": "6888c88ec24bb893747ef4f1",
      "name": "Liftoff",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.51,
      "complexity_level": 0.97,
      "style": "normal",
      "neural_effect_level": 0.21,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/LiftOff_Focus_Creativity_Electronic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=ATkrR0Lbx6%2BxZkuVWOz0pqeeXO7%2FLgAu41osB5TKXeo%3D",
      "cdn_url": "https://audio2.brain.fm/LiftOff_Focus_Creativity_Electronic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LiftOff_Focus_Creativity_Electronic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LiftOff_Focus_Creativity_Electronic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/LiftOff_Focus_Creativity_Electronic_30_116BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28945785,
      "sha256": "6f193839875aafe4f0327a6cac6c54238b95cd3e6f93b74653bf7c06a27ced9c",
      "download_error": null
    },
    {
      "track_id": "6888c839b997579cf699b5a3",
      "name": "Magic Eights",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.67,
      "complexity_level": 0.96,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/MagicEights_Focus_DeepWork_Electronic_30_110BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=OUAGZDMr7Ob8Axp06mCbIbstP3KuO7MYU3cC%2BsPNEt8%3D",
      "cdn_url": "https://audio2.brain.fm/MagicEights_Focus_DeepWork_Electronic_30_110BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MagicEights_Focus_DeepWork_Electronic_30_110BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MagicEights_Focus_DeepWork_Electronic_30_110BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/MagicEights_Focus_DeepWork_Electronic_30_110BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28461526,
      "sha256": "8ade05851d9bb44d7ac20715db0cf5fb5fa091d6cb6e8d6fde4b07662bd2769c",
      "download_error": null
    },
    {
      "track_id": "6888c80cb997579cf699b4f6",
      "name": "Autumnal Colors",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.62,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/AutumnalColors_Focus_Learning_Electronic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=X5HVvPPbuI6Z9g01sNEFulSTiYfQmTUjWAbu8bx9wFc%3D",
      "cdn_url": "https://audio2.brain.fm/AutumnalColors_Focus_Learning_Electronic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AutumnalColors_Focus_Learning_Electronic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AutumnalColors_Focus_Learning_Electronic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/AutumnalColors_Focus_Learning_Electronic_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27263960,
      "sha256": "35ba0605d5abceba2e8bb3f5cbbd4e6d2cba9c5b8c1eaa54d9ae210093fe6a1e",
      "download_error": null
    },
    {
      "track_id": "6875510c3b891fead18abaa2",
      "name": "Tight Twist",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.25,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Moonstruck_Focus_DeepWork_Piano_30_85BPM_MediumNEL_VBR5.mp3?expiration=1792292131707&token=hHzVQZkM%2FVkNvBaUjroHLHZAd3CkZVM2jXBfRpNnyfM%3D",
      "cdn_url": "https://audio2.brain.fm/Moonstruck_Focus_DeepWork_Piano_30_85BPM_MediumNEL_VBR5.mp3",
      "remote_filename": "Moonstruck_Focus_DeepWork_Piano_30_85BPM_MediumNEL_VBR5.mp3",
      "filename": "Moonstruck_Focus_DeepWork_Piano_30_85BPM_MediumNEL_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Moonstruck_Focus_DeepWork_Piano_30_85BPM_MediumNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24736626,
      "sha256": "baaedc90c42e9bdd2939671d648184adc79e23891d3b863b7c24db68ca59c038",
      "download_error": null
    },
    {
      "track_id": "687550957e95e87bea7298f9",
      "name": "Panettone",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 170,
      "brightness_level": 0.68,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Panettone_Focus_Creativity_Electronic_30_170BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=GdmvW638m8ABjsGQDr0tLu5CaEnQXJd8mcKVl6n6Ic4%3D",
      "cdn_url": "https://audio2.brain.fm/Panettone_Focus_Creativity_Electronic_30_170BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Panettone_Focus_Creativity_Electronic_30_170BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Panettone_Focus_Creativity_Electronic_30_170BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Panettone_Focus_Creativity_Electronic_30_170BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29924857,
      "sha256": "02f7170bc5f9a1e457c842e9e5a30edaf1c27a97145e1223c4da06d7ca125130",
      "download_error": null
    },
    {
      "track_id": "687550857e95e87bea7298a0",
      "name": "Golden Hill",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 122,
      "brightness_level": 0.51,
      "complexity_level": 0.55,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Feathered_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=VJ191PTXnxxuYUknvv9tb9YM%2FwR%2FzJGrvHAyuOslhtc%3D",
      "cdn_url": "https://audio2.brain.fm/Feathered_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Feathered_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Feathered_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Feathered_Focus_DeepWork_Electronic_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30987624,
      "sha256": "39545bb174e95f872b84db5470c81e4fece3194053b0bd3286e5a48785ddc80c",
      "download_error": null
    },
    {
      "track_id": "687550787e95e87bea729855",
      "name": "Feathered",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.52,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/GoldenHill_Focus_DeepWork_Electronic_30_122bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=LBcAIbyK81eJr%2FVZwdxJIxtqsEroDjRsmNjuayRAhGw%3D",
      "cdn_url": "https://audio2.brain.fm/GoldenHill_Focus_DeepWork_Electronic_30_122bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GoldenHill_Focus_DeepWork_Electronic_30_122bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GoldenHill_Focus_DeepWork_Electronic_30_122bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/GoldenHill_Focus_DeepWork_Electronic_30_122bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31680840,
      "sha256": "aa2ccaf39e0e00973d638ae0370ab68c4da72e6bbdc7d7e590e7d2af295809ec",
      "download_error": null
    },
    {
      "track_id": "6875504c7e95e87bea729769",
      "name": "Water World",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.41,
      "complexity_level": 0.68,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/WaterWorld_Focus_Learning_Electronic_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=drnYyUcBZjb1vkFqo2kma26B4lgl5j4QN2KdycolpiQ%3D",
      "cdn_url": "https://audio2.brain.fm/WaterWorld_Focus_Learning_Electronic_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WaterWorld_Focus_Learning_Electronic_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WaterWorld_Focus_Learning_Electronic_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/WaterWorld_Focus_Learning_Electronic_30_80BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27118879,
      "sha256": "e02a8a1d966630bf1d45e0115a208fd9118234eb9e7343d9732647be51aa6aac",
      "download_error": null
    },
    {
      "track_id": "6862ed98da2d247f1a9c7007",
      "name": "Lopsided",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 135,
      "brightness_level": 0.45,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Lopsided_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=unJ%2BZ7JskrGHKGxncZNblKxKrYZ3%2FnrihqhgvXo7Pos%3D",
      "cdn_url": "https://audio2.brain.fm/Lopsided_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lopsided_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Lopsided_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Lopsided_Focus_Learning_Electronic_30_135bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29206273,
      "sha256": "3fe1fa641ad5024c6a41c6012a2202c953f11b0cfd25be0a7674d633d7424d57",
      "download_error": null
    },
    {
      "track_id": "6862ec74b0ad537cfff5c835",
      "name": "On Duplication",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 111,
      "brightness_level": 0.59,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/On_Duplication_Focus_Deep_Work_Electronic_30_111bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=fO0jYTVy3NOONr%2BnW7ScXE56owwfiBoJfITrYm7TmUM%3D",
      "cdn_url": "https://audio2.brain.fm/On_Duplication_Focus_Deep_Work_Electronic_30_111bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "On_Duplication_Focus_Deep_Work_Electronic_30_111bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "On_Duplication_Focus_Deep_Work_Electronic_30_111bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/On_Duplication_Focus_Deep_Work_Electronic_30_111bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28188639,
      "sha256": "afd91c0945371f8bcb40bd9e7c3e951c7c25ff0340f32c3684aa30106e3bd3a1",
      "download_error": null
    },
    {
      "track_id": "68505cb4f6a8ec8278221972",
      "name": "Energy Bursts",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 138,
      "brightness_level": 0.48,
      "complexity_level": 0.55,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/EnergyBursts_Focus_Creativity_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=kpU3v8Lqy3z8U%2BbYlaZRhAQizLYGNqMp348GeZrSSd8%3D",
      "cdn_url": "https://audio2.brain.fm/EnergyBursts_Focus_Creativity_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EnergyBursts_Focus_Creativity_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EnergyBursts_Focus_Creativity_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/EnergyBursts_Focus_Creativity_Electronic_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27996701,
      "sha256": "9d28e1d961f7cd15f1e7bd14d75856bc30ee06b8b1a999c748739d0997e697ef",
      "download_error": null
    },
    {
      "track_id": "68505c6a5de2e833e430b278",
      "name": "Twin Souls",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.77,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/TwinSouls_Focus_DeepWork_Electronic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=%2BF9YTNfyW53A%2FcYXbruvrLKiqyKM3OwS9d5HiwAw3Lg%3D",
      "cdn_url": "https://audio2.brain.fm/TwinSouls_Focus_DeepWork_Electronic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TwinSouls_Focus_DeepWork_Electronic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TwinSouls_Focus_DeepWork_Electronic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/TwinSouls_Focus_DeepWork_Electronic_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30535656,
      "sha256": "26bab59f29bbf922b3252a81e65ac3d6e46f986de6d49db053863614741c323b",
      "download_error": null
    },
    {
      "track_id": "68505b81f6a8ec8278221529",
      "name": "Gen Alpha",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 121,
      "brightness_level": 0.62,
      "complexity_level": 0.77,
      "style": "normal",
      "neural_effect_level": 0.21,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/GenAlpha_Focus_DeepWork_Electronic_30_121BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=4IWAIhw5nZBA58vVPRc8%2BmjMo64LOFmZ%2FjgDFLKlZg0%3D",
      "cdn_url": "https://audio2.brain.fm/GenAlpha_Focus_DeepWork_Electronic_30_121BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GenAlpha_Focus_DeepWork_Electronic_30_121BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GenAlpha_Focus_DeepWork_Electronic_30_121BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/GenAlpha_Focus_DeepWork_Electronic_30_121BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30552790,
      "sha256": "7e22b6417295e01b99feac8bffffc12f8d235bde18ad785893041df99cbd5b93",
      "download_error": null
    },
    {
      "track_id": "68505b3bf6a8ec827822142c",
      "name": "Mixed Metals",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.47,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/MixedMetals_Focus_Creativity_Electronic_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=hjdMKhvYHb9BL3SVDsTEflx6WUbj%2F98BL9%2BmBgqjunw%3D",
      "cdn_url": "https://audio2.brain.fm/MixedMetals_Focus_Creativity_Electronic_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MixedMetals_Focus_Creativity_Electronic_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MixedMetals_Focus_Creativity_Electronic_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/MixedMetals_Focus_Creativity_Electronic_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29760860,
      "sha256": "2ee707f910262d9fab22464fcbe390b1f2681d86738f564c628bae7c7694bc9e",
      "download_error": null
    },
    {
      "track_id": "683dc6f3dd2246ed9c7c800a",
      "name": "Black Lights",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.44,
      "complexity_level": 0.77,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/BlackLights_Focus_DeepWork_Electronic_30_116BPM_HMedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=1EVdaAvL0mn%2BXJ5y1CoeUmrO%2BxZ%2FI3owgkyaSHRp1%2FM%3D",
      "cdn_url": "https://audio2.brain.fm/BlackLights_Focus_DeepWork_Electronic_30_116BPM_HMedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BlackLights_Focus_DeepWork_Electronic_30_116BPM_HMedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BlackLights_Focus_DeepWork_Electronic_30_116BPM_HMedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/BlackLights_Focus_DeepWork_Electronic_30_116BPM_HMedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29281461,
      "sha256": "f4daee4e84b395f09470de1eef29f6c207c7d0adb26d0a96a69ec942d160ef80",
      "download_error": null
    },
    {
      "track_id": "683dc6d17e70e7db4e0aee00",
      "name": "Shearwater",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.2,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Shearwater_Focus_Deep_Work_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=kJwT5waVpuGd8u42Kt9BGxLZr6Qe1sAv1B%2Btoh8FWbY%3D",
      "cdn_url": "https://audio2.brain.fm/Shearwater_Focus_Deep_Work_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Shearwater_Focus_Deep_Work_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Shearwater_Focus_Deep_Work_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Shearwater_Focus_Deep_Work_Electronic_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30627011,
      "sha256": "5bcd3d4d1d904e645aaae4104d152da7679acb7a3ad8bee5d10794ff87e41606",
      "download_error": null
    },
    {
      "track_id": "682b55dd8ab5a645af483e92",
      "name": "Casting Spells",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 124,
      "brightness_level": 0.52,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/CastingSpells_Focus_DeepWork_Electronic_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=z4nNsqkZF2c1%2Fty7NDi%2FfXIRUkYErjYCxD6Ksz52CXE%3D",
      "cdn_url": "https://audio2.brain.fm/CastingSpells_Focus_DeepWork_Electronic_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CastingSpells_Focus_DeepWork_Electronic_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CastingSpells_Focus_DeepWork_Electronic_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/CastingSpells_Focus_DeepWork_Electronic_30_124bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31051704,
      "sha256": "a57b50ac532943a2d5c12f0da2c436bbbb88a65c3e33a8362179b262c07932dd",
      "download_error": null
    },
    {
      "track_id": "682b5523d2f1d1682decf371",
      "name": "Pure Sky",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.78,
      "complexity_level": 0.72,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/PureSky_Focus_DeepWork_Electronic_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=Z4n7heyGIqw9O9GKWx4LFXv%2BpyJFqb0CGaBkAUbXb0w%3D",
      "cdn_url": "https://audio2.brain.fm/PureSky_Focus_DeepWork_Electronic_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PureSky_Focus_DeepWork_Electronic_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PureSky_Focus_DeepWork_Electronic_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/PureSky_Focus_DeepWork_Electronic_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27739621,
      "sha256": "64e0fc5e09757b54e205c4054c95856df8153687342602628d8eebe95eb4e725",
      "download_error": null
    },
    {
      "track_id": "682b54fad2f1d1682decf2c9",
      "name": "Downtown",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.62,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/DownTown_Focus_Learning_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=zIF4W2d21ToZiQjE%2BLnqU1AeNf0bWWzIRMtsqYcbHRg%3D",
      "cdn_url": "https://audio2.brain.fm/DownTown_Focus_Learning_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DownTown_Focus_Learning_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DownTown_Focus_Learning_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/DownTown_Focus_Learning_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29499261,
      "sha256": "09ed19f15d63e86851c5a5fc8388a8c56ea3d47577d5ab96d3be7351cf4d8455",
      "download_error": null
    },
    {
      "track_id": "6818d1c5c7fc795ec060ef51",
      "name": "In Triage",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 128,
      "brightness_level": 0.32,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/In%20Triage_Focus_Deep%20Work_Electronic_30_128bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=1Kem2nD01CtvBa8TE3JZUfqt92XdikUguv4B%2FrZ%2FUgo%3D",
      "cdn_url": "https://audio2.brain.fm/In%20Triage_Focus_Deep%20Work_Electronic_30_128bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "In Triage_Focus_Deep Work_Electronic_30_128bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "In-Triage_Focus_Deep-Work_Electronic_30_128bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/In-Triage_Focus_Deep-Work_Electronic_30_128bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28563708,
      "sha256": "aa81b7b1a3b848e902fc9c8d9c98d054fb76605c990048bc69b1c4f12f2d6ed8",
      "download_error": null
    },
    {
      "track_id": "6818d168c7fc795ec060ed65",
      "name": "Bouquet",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.78,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Bouquet_Focus_Learning_Electronic_30_86BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=V0CKCGCsSA25U4LYQxbv3mA3QRAycKXvP7UHZdbdx4A%3D",
      "cdn_url": "https://audio2.brain.fm/Bouquet_Focus_Learning_Electronic_30_86BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bouquet_Focus_Learning_Electronic_30_86BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Bouquet_Focus_Learning_Electronic_30_86BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Bouquet_Focus_Learning_Electronic_30_86BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29116055,
      "sha256": "86dbf30ff8f86bf394298396d9107ce60ccb3a6035d1b3bba22d862f2cd676e6",
      "download_error": null
    },
    {
      "track_id": "68065a25563464c2de5fb704",
      "name": "Sunrays",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 135,
      "brightness_level": 0.65,
      "complexity_level": 0.93,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Sunrays_Focus_Creativity_Electronic_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=yf3R78TzP1t4o5DQ9CmV6G2trAi1yZO7IYLFnApBcRg%3D",
      "cdn_url": "https://audio2.brain.fm/Sunrays_Focus_Creativity_Electronic_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sunrays_Focus_Creativity_Electronic_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sunrays_Focus_Creativity_Electronic_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Sunrays_Focus_Creativity_Electronic_30_135BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25996585,
      "sha256": "c97af884fef4b6055f21bdb8dae6c49a7ef8ab96fef50e58f9cab4291ca3bc85",
      "download_error": null
    },
    {
      "track_id": "67f3ea52a0de2348f748dcf8",
      "name": "Shimmering",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.96,
      "complexity_level": 0.8,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Shimmering_Focus_Creativity_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=SJuKlGWsUcl5zmPuHqCSS5D%2FcRhyrAyQuHOnCW%2Fu3uY%3D",
      "cdn_url": "https://audio2.brain.fm/Shimmering_Focus_Creativity_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Shimmering_Focus_Creativity_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Shimmering_Focus_Creativity_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Shimmering_Focus_Creativity_Electronic_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32493867,
      "sha256": "23c1b4f74ab0cd975ef7f4dd511a3dad645396a30ec032da91d2f1b9d5078b4c",
      "download_error": null
    },
    {
      "track_id": "67e17e575177e5bfbd17fb13",
      "name": "Endless Dusk",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.4,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/EndlessDusk_Focus_DeepWork_Electronic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=UmAsuCQLuyo3%2F%2FEr%2B58wFP5kZvkBRq8nt7zxkeWErOI%3D",
      "cdn_url": "https://audio2.brain.fm/EndlessDusk_Focus_DeepWork_Electronic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EndlessDusk_Focus_DeepWork_Electronic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EndlessDusk_Focus_DeepWork_Electronic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/EndlessDusk_Focus_DeepWork_Electronic_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29770128,
      "sha256": "e1fb44b9fc10b5be468962a58d738c4aa8b770766571acb840f7b7e577c2f2b3",
      "download_error": null
    },
    {
      "track_id": "67e17d905177e5bfbd17f488",
      "name": "Dunes",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 128,
      "brightness_level": 0.57,
      "complexity_level": 0.68,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Dunes_Focus_Creativity_Electronic_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=%2FWTJ1xHLaaS8GhXkL1CmWKi1b%2BxM6kXHeGWvO9sh%2BKI%3D",
      "cdn_url": "https://audio2.brain.fm/Dunes_Focus_Creativity_Electronic_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dunes_Focus_Creativity_Electronic_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dunes_Focus_Creativity_Electronic_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Dunes_Focus_Creativity_Electronic_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27884340,
      "sha256": "09e2942fa414722f61e7ff9e684264d5ac0a540f9a4488bee2ab704db1255d65",
      "download_error": null
    },
    {
      "track_id": "67cf0334593aad5348b95c15",
      "name": "Me and My Nine Oh Nine",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 135,
      "brightness_level": 0.82,
      "complexity_level": 0.76,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/MeAndMyNineOhNine_Focus_Creativity_Electronic_30_135BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=bLytGPCpzBw9K0W%2F5k1wm3Q7VeqQEC6F7GwSsL3LKVE%3D",
      "cdn_url": "https://audio2.brain.fm/MeAndMyNineOhNine_Focus_Creativity_Electronic_30_135BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MeAndMyNineOhNine_Focus_Creativity_Electronic_30_135BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MeAndMyNineOhNine_Focus_Creativity_Electronic_30_135BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/MeAndMyNineOhNine_Focus_Creativity_Electronic_30_135BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29426147,
      "sha256": "fc380bf48ad93d6ac593965b3669c1ff3d4a22b4768f668510da5a87ac66c3b4",
      "download_error": null
    },
    {
      "track_id": "67cf0315593aad5348b95b65",
      "name": "Berghein",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.53,
      "complexity_level": 0.37,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Berghein_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=ZUwW012YlDoMdJl6A1X2jNRdptj8PIT%2FC8q5pnJOgHQ%3D",
      "cdn_url": "https://audio2.brain.fm/Berghein_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Berghein_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Berghein_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Berghein_Focus_DeepWork_Electronic_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27679196,
      "sha256": "b9809cbaba307ce17d6d601ef9c0338f32c203451477d921571b1918072c1ba7",
      "download_error": null
    },
    {
      "track_id": "67bc893daebfd9a384a2b66d",
      "name": "Happy Elevens",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.71,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/HappyElevens_Focus_Learning_Electronic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=SgZ8S5kVEU5swyLT9bgKkTnhgZu335nLD5hhoYbv5yI%3D",
      "cdn_url": "https://audio2.brain.fm/HappyElevens_Focus_Learning_Electronic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HappyElevens_Focus_Learning_Electronic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HappyElevens_Focus_Learning_Electronic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/HappyElevens_Focus_Learning_Electronic_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27890852,
      "sha256": "7e8d8d63b0d43476c8d52f524dc1fdee5bb3bd94a5ca495cbb88b8b7f6acfba7",
      "download_error": null
    },
    {
      "track_id": "67bc8905aebfd9a384a2b526",
      "name": "Blue Clouds",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.49,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/BlueClouds_Focus_Creativity_Electronic_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=QotQCJYE%2BoaTG7pbbuYnMF5Z5%2Fzv5E1fcA26AJ3%2BesI%3D",
      "cdn_url": "https://audio2.brain.fm/BlueClouds_Focus_Creativity_Electronic_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BlueClouds_Focus_Creativity_Electronic_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BlueClouds_Focus_Creativity_Electronic_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/BlueClouds_Focus_Creativity_Electronic_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27024553,
      "sha256": "15d0cdb523cc4ae9048a06357bf05d335f28f099c2c268e73d22da59f0689d11",
      "download_error": null
    },
    {
      "track_id": "67aa5b8055e93dd3436922c6",
      "name": "Cinnamon Sand",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 145,
      "brightness_level": 0.58,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/CinnamonSand_Focus_DeepWork_Electronic_145_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=Sk0TCZe1WXNKdyFw6WHwyq0sqp8%2BoLKZwNHKKEs1YJY%3D",
      "cdn_url": "https://audio2.brain.fm/CinnamonSand_Focus_DeepWork_Electronic_145_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CinnamonSand_Focus_DeepWork_Electronic_145_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CinnamonSand_Focus_DeepWork_Electronic_145_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/CinnamonSand_Focus_DeepWork_Electronic_145_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30771547,
      "sha256": "d9c23d70c5889470d03b2efbaab5abde2e5e40bc65bf020efcbc8d16e05bf168",
      "download_error": null
    },
    {
      "track_id": "67aa5b6b55e93dd343692237",
      "name": "Veil of Light",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 70,
      "brightness_level": 0.57,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/VeilOfLight_Focus_Creativity_Electronic_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=jZ8lwmVtlnazs%2F4POzJ898Y79%2BC8YXHzbNxm2FegWuA%3D",
      "cdn_url": "https://audio2.brain.fm/VeilOfLight_Focus_Creativity_Electronic_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "VeilOfLight_Focus_Creativity_Electronic_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "VeilOfLight_Focus_Creativity_Electronic_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/VeilOfLight_Focus_Creativity_Electronic_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28169773,
      "sha256": "9073e2a48b225788616f401b18c4c2b5720be53761909b5dd1231f2c96d64f58",
      "download_error": null
    },
    {
      "track_id": "67a10f9603677edafb63f595",
      "name": "Waves Overhead",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 136,
      "brightness_level": 0.82,
      "complexity_level": 0.87,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/WavesOverhead_Focus_DeepWork_Electronic_136_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=%2BolqXoUo5I7wP4ibKAAM6%2BSQBKMRwiFIvk4lw%2FQTr0M%3D",
      "cdn_url": "https://audio2.brain.fm/WavesOverhead_Focus_DeepWork_Electronic_136_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WavesOverhead_Focus_DeepWork_Electronic_136_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WavesOverhead_Focus_DeepWork_Electronic_136_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/WavesOverhead_Focus_DeepWork_Electronic_136_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32552319,
      "sha256": "0c21bc4597b5cdeb572f0125f3ddaefbbfec76f5b43aa7f7bf5a37819978e9f4",
      "download_error": null
    },
    {
      "track_id": "67a10f8903677edafb63f50c",
      "name": "Light Forms",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 131,
      "brightness_level": 0.22,
      "complexity_level": 1,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/LightForms_Focus_Creativity_Electronic_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=Z747d81A9nWKXv7Duz04J%2BpQfn9kJlw7q5FIqWDUGRg%3D",
      "cdn_url": "https://audio2.brain.fm/LightForms_Focus_Creativity_Electronic_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LightForms_Focus_Creativity_Electronic_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LightForms_Focus_Creativity_Electronic_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/LightForms_Focus_Creativity_Electronic_30_131BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28420445,
      "sha256": "bcbb87c4bb31098d6b0bbe9106ea984efbbf935e91bb56e3fd3b0dc1eb46b973",
      "download_error": null
    },
    {
      "track_id": "67855b48f76968728486ac64",
      "name": "Discoteque",
      "category": "Electronic",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 113,
      "brightness_level": 0.67,
      "complexity_level": 0.92,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/electronic.json",
      "source_url": "https://audio2.brain.fm/Discoteque_Focus_DeepWork_Electronic_30_113BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292131707&token=kBWf6Qce%2BBjyFiadVhyxgBzrjMxZxO9r6N9BhuZovAU%3D",
      "cdn_url": "https://audio2.brain.fm/Discoteque_Focus_DeepWork_Electronic_30_113BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Discoteque_Focus_DeepWork_Electronic_30_113BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Discoteque_Focus_DeepWork_Electronic_30_113BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/electronic/Discoteque_Focus_DeepWork_Electronic_30_113BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29325619,
      "sha256": "46ad3388b13f2aed72a8223c3606c0ad16e9ce26557e3649761e3086869cd3fd",
      "download_error": null
    },
    {
      "track_id": "6952f38ab1c39edafb0deb70",
      "name": "Quiet Grove",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.67,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/QuietGrove_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=j%2FCPCuuiRT08eMj4vlxAG7VFNTMjr4tKNgxA1dRUQ7k%3D",
      "cdn_url": "https://audio2.brain.fm/QuietGrove_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "QuietGrove_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "QuietGrove_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/QuietGrove_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24075305,
      "sha256": "bdeb49fbc24c8ec714150ffc9f4e2e86fa7ceee7c04908d63fced65c3fc8e076",
      "download_error": null
    },
    {
      "track_id": "692dbe7fb8f361da92eba295",
      "name": "Roots & Ember",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.55,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Roots%26Ember_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=teEMLXt0EGYHhHOoH7jNy6S8W87ZSqeXx1DkQKgK78g%3D",
      "cdn_url": "https://audio2.brain.fm/Roots%26Ember_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Roots&Ember_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Roots-Ember_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Roots-Ember_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21970851,
      "sha256": "febf1818597e7f28e34b691a6de788c93ee62791ae970c53a95787193c4f69aa",
      "download_error": null
    },
    {
      "track_id": "692dbe5e66ea27cd5c91199a",
      "name": "Dewlight",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.45,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Dewlight_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=gokgKvI%2F80aGrKXVbzFgpZ91VwlIpNQfcvF0MwYPPnQ%3D",
      "cdn_url": "https://audio2.brain.fm/Dewlight_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dewlight_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dewlight_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Dewlight_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26289716,
      "sha256": "da00b7c279ae507482e2302837543404bc98d93e94690694852363618a4fd145",
      "download_error": null
    },
    {
      "track_id": "64302d5623c3be0ee83fbe53",
      "name": "Sterling Forest",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.64,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/SterlingForest_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=gLC6prJf3p3ivF3MsfpyMjZfHPcN0%2B8WeSeSgFwdJYM%3D",
      "cdn_url": "https://audio2.brain.fm/SterlingForest_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SterlingForest_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SterlingForest_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/SterlingForest_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26548250,
      "sha256": "b13d593bd3ffe7d17cfdd2e2a9003b42293a0ad8b184d071579e9c050a154500",
      "download_error": null
    },
    {
      "track_id": "64302cc45ee24c3469a06bff",
      "name": "Sacred Grove",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.85,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.89,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/SacredGrove_Focus_Learning_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=xF%2FNXBGss%2BFo0Er8%2FGSEBL964CA%2B%2FQwIL7oy%2FwcQYxI%3D",
      "cdn_url": "https://audio2.brain.fm/SacredGrove_Focus_Learning_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SacredGrove_Focus_Learning_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SacredGrove_Focus_Learning_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/SacredGrove_Focus_Learning_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26823196,
      "sha256": "06a6e50f85e3a40e5f9b7fdad0fa17e9fb99e5d6162c28d456ffdd9931f0f417",
      "download_error": null
    },
    {
      "track_id": "64302c6f23c3bee4743fb8ed",
      "name": "Nottingham",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.99,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Nottingham_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=W7kgJagpA1r1KgxFmEg%2BWs%2BPGoaqea2TRT97UnBx%2FEk%3D",
      "cdn_url": "https://audio2.brain.fm/Nottingham_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Nottingham_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Nottingham_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Nottingham_Focus_DeepWork_Forest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28823923,
      "sha256": "073b8af6c92fc34bee0615d2e93ac7eea8695df12fe6f759c40434b38cd45a44",
      "download_error": null
    },
    {
      "track_id": "64302ae85ee24c3b7da06081",
      "name": "In the Valley",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.62,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/IntheValley_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=xhqgnwpMNd07ljgxeyowrXF0aEZL2LIG27mCypvY7OA%3D",
      "cdn_url": "https://audio2.brain.fm/IntheValley_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "IntheValley_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "IntheValley_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/IntheValley_Focus_Learning_Forest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25134914,
      "sha256": "0c51f53d9a77659869c5b1a14e261fe3f911a9bde0216af89c39575730f78a50",
      "download_error": null
    },
    {
      "track_id": "64302a9623c3bed6203faf48",
      "name": "Falling Forest",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.45,
      "complexity_level": 0.79,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/FallingForest_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=KpNYDeObjx6at8mdYG5DS33%2F7APYVMlVrtBzszj%2FEMA%3D",
      "cdn_url": "https://audio2.brain.fm/FallingForest_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FallingForest_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FallingForest_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/FallingForest_Focus_DeepWork_Forest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24461615,
      "sha256": "e8ad3da72c4d014480f9f7cdb4145dfc9ffde2e4d92ea6523e1edd2dac84c9f5",
      "download_error": null
    },
    {
      "track_id": "62b38c085924116c86f552fb",
      "name": "Broadleaf",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.4,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Broadleaf%20Forest%20Focus%204%20Conor_1.2_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=GLTDSwAEoP8dLZI%2FNphtBFsTrjXDGf8kk32eA0s%2FRHs%3D",
      "cdn_url": "https://audio2.brain.fm/Broadleaf%20Forest%20Focus%204%20Conor_1.2_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Broadleaf Forest Focus 4 Conor_1.2_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Broadleaf-Forest-Focus-4-Conor_1.2_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Broadleaf-Forest-Focus-4-Conor_1.2_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24656551,
      "sha256": "b8b3d850ed77e24ff34a817139cf7e73687cc589f53b68dbb867a23cf638afe7",
      "download_error": null
    },
    {
      "track_id": "62b38c07592411544df552d8",
      "name": "Falling Leaves",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.5,
      "complexity_level": 0.81,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Forest%20Focus%201%20Conor_1.8_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=QrvsQjPZS4JOHTr%2BIdO316IzvXfBWIz6VeGrkdG7pK0%3D",
      "cdn_url": "https://audio2.brain.fm/Forest%20Focus%201%20Conor_1.8_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Forest Focus 1 Conor_1.8_Nrmlzd2_VBR5.mp3",
      "filename": "Forest-Focus-1-Conor_1.8_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Forest-Focus-1-Conor_1.8_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26217772,
      "sha256": "54ab61ac7d6e4800f55ce90bce8263755981436ff91ecd2722cb4197db171732",
      "download_error": null
    },
    {
      "track_id": "62b38a2159241169d7f53fc7",
      "name": "Boreal Ridge",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.89,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Boreal%20Ridge%20Nature%20Focus%20Forest%20Deep%20Work%20Conor%20HIGH%20NEL%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=6tHkRN%2F6EVy5KjcQQxDFDYbVheBCtnFREv2hh7f%2BCbU%3D",
      "cdn_url": "https://audio2.brain.fm/Boreal%20Ridge%20Nature%20Focus%20Forest%20Deep%20Work%20Conor%20HIGH%20NEL%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Boreal Ridge Nature Focus Forest Deep Work Conor HIGH NEL 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Boreal-Ridge-Nature-Focus-Forest-Deep-Work-Conor-HIGH-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Boreal-Ridge-Nature-Focus-Forest-Deep-Work-Conor-HIGH-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28564913,
      "sha256": "0fcd228a36f70fb01fd69d54df9475010ba14a2877398192a6e3e12860f05b73",
      "download_error": null
    },
    {
      "track_id": "62b388a85924111522f52621",
      "name": "Northern Moss",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.72,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Forrest-Ambience-FOC.2-nrmlzd_VBR5.mp3?expiration=1792292108011&token=jvV5SBANnXjVcpnz5hEak8Td6u2IKYyyWNloRiNgzoA%3D",
      "cdn_url": "https://audio2.brain.fm/Forrest-Ambience-FOC.2-nrmlzd_VBR5.mp3",
      "remote_filename": "Forrest-Ambience-FOC.2-nrmlzd_VBR5.mp3",
      "filename": "Forrest-Ambience-FOC.2-nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Forrest-Ambience-FOC.2-nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29773841,
      "sha256": "861fbb3434e3a766f3bac5ee2ac8134ea6ff833e1ae3d3220242b3c3b75937c3",
      "download_error": null
    },
    {
      "track_id": "62b387c359241169dcf521e1",
      "name": "Songbird",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.63,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Songbird%20Forest%202%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292108011&token=M%2BhUQAL9%2FTGOu6apikZVpG5jmywEvsj3HZMGsZxlvbQ%3D",
      "cdn_url": "https://audio2.brain.fm/Songbird%20Forest%202%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Songbird Forest 2 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Songbird-Forest-2-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Songbird-Forest-2-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23215387,
      "sha256": "270f55ac0f9a782ab4741090e1cea1f7e47e1a1b3ab45944b3dee6a3992a79f8",
      "download_error": null
    },
    {
      "track_id": "62b387b55924111630f51f8e",
      "name": "Through the Oaks",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Through%20the%20Woods%20Forest%201%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292108011&token=Okcapwm0uvhOWbL9%2BZhp7Dp4mUFauPAai5KhBjFLEWo%3D",
      "cdn_url": "https://audio2.brain.fm/Through%20the%20Woods%20Forest%201%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Through the Woods Forest 1 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Through-the-Woods-Forest-1-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Through-the-Woods-Forest-1-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22698401,
      "sha256": "1bcecb4b7b402000186393cb287da55a181cb135a76cf9f744cdee8932d36a62",
      "download_error": null
    },
    {
      "track_id": "62b387b05924118ce0f51e8e",
      "name": "Olive Grove",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.46,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Forrest-Ambience-FOCUS2_VBR5.mp3?expiration=1792292108011&token=8e8ybWJpauEtzaN3z7RG759QzzfWZLRs1VXUcNx6Dog%3D",
      "cdn_url": "https://audio2.brain.fm/Forrest-Ambience-FOCUS2_VBR5.mp3",
      "remote_filename": "Forrest-Ambience-FOCUS2_VBR5.mp3",
      "filename": "Forrest-Ambience-FOCUS2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Forrest-Ambience-FOCUS2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27908258,
      "sha256": "67777b4b444bd7d6a4e06b1d2e6b9514a56742de159f2c4c756a9faed48e4ac1",
      "download_error": null
    },
    {
      "track_id": "62b380e8592411b02df4d62d",
      "name": "Spirit of the Woods",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Spirit%20of%20the%20Woods%20Nature%20Focus%20Forest%20Deep%20Work%20Conor%20MED%20NEL%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=GkzOy%2FDq%2FOe2Qoi70lMCzbjkmc%2Bq%2Bb3ZhyvH9wDOc3Y%3D",
      "cdn_url": "https://audio2.brain.fm/Spirit%20of%20the%20Woods%20Nature%20Focus%20Forest%20Deep%20Work%20Conor%20MED%20NEL%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Spirit of the Woods Nature Focus Forest Deep Work Conor MED NEL 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Spirit-of-the-Woods-Nature-Focus-Forest-Deep-Work-Conor-MED-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Spirit-of-the-Woods-Nature-Focus-Forest-Deep-Work-Conor-MED-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27771700,
      "sha256": "18cfdad1894f170ff69611dff03d50716d288163caff08e921e45b98bc9f0434",
      "download_error": null
    },
    {
      "track_id": "62b380885924117ce1f4ce7a",
      "name": "Needleleaf",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.54,
      "complexity_level": 0.81,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Needleleaf%20Forest%20Focus%205%20Conor_1.7_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=1JuMBvbfEaqmdKn0ZVFe9y6teFjsKW2cY2VC9lT5rak%3D",
      "cdn_url": "https://audio2.brain.fm/Needleleaf%20Forest%20Focus%205%20Conor_1.7_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Needleleaf Forest Focus 5 Conor_1.7_Nrmlzd2_VBR5.mp3",
      "filename": "Needleleaf-Forest-Focus-5-Conor_1.7_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Needleleaf-Forest-Focus-5-Conor_1.7_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25880480,
      "sha256": "17c94ed4eb0ba40f77f3238f798be913fee722b00026702733333e9790d664d8",
      "download_error": null
    },
    {
      "track_id": "62b380735924110666f4cb07",
      "name": "Cedar Grove",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.64,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Forrest%20-%20FOCUS%20template%202.0-ElectronicBeatAmbience-Nrmlzd_VBR5.mp3?expiration=1792292108011&token=rED4DPqe333K%2FAcm5us00JWCGjkqik%2FzSTp3IHUx8oI%3D",
      "cdn_url": "https://audio2.brain.fm/Forrest%20-%20FOCUS%20template%202.0-ElectronicBeatAmbience-Nrmlzd_VBR5.mp3",
      "remote_filename": "Forrest - FOCUS template 2.0-ElectronicBeatAmbience-Nrmlzd_VBR5.mp3",
      "filename": "Forrest-FOCUS-template-2.0-ElectronicBeatAmbience-Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Forrest-FOCUS-template-2.0-ElectronicBeatAmbience-Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27700175,
      "sha256": "8ce0d40b53e79c3a451096e01762a673596142b4d33af397b76253e6659684ed",
      "download_error": null
    },
    {
      "track_id": "62b3806e592411a159f4c846",
      "name": "Norway Spruce",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.57,
      "complexity_level": 0.63,
      "style": "normal",
      "neural_effect_level": 0.65,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Norway%20Spruce%20Forest%20Focus%203%20Conor_1.2_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=%2FnMPzGH6p0SDqu9YkmRgBU6aYm%2F9G90oivCSMt6z%2BUE%3D",
      "cdn_url": "https://audio2.brain.fm/Norway%20Spruce%20Forest%20Focus%203%20Conor_1.2_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Norway Spruce Forest Focus 3 Conor_1.2_Nrmlzd2_VBR5.mp3",
      "filename": "Norway-Spruce-Forest-Focus-3-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Norway-Spruce-Forest-Focus-3-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26586059,
      "sha256": "89d5751cb77a98750a1802b9df5a6c2d0d970c710418c18229f59ec071fea55a",
      "download_error": null
    },
    {
      "track_id": "62b3805d59241167f7f4bda9",
      "name": "Canopy",
      "category": "Forest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.58,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/forest.json",
      "source_url": "https://audio2.brain.fm/Forest%20Focus%202%20Conor_1.8_Nrmlzd2_VBR5.mp3?expiration=1792292108011&token=Z9nhB3mLbjV63hQJoLvfs4CRxA0pT8LW%2FVMvXyFjrbA%3D",
      "cdn_url": "https://audio2.brain.fm/Forest%20Focus%202%20Conor_1.8_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Forest Focus 2 Conor_1.8_Nrmlzd2_VBR5.mp3",
      "filename": "Forest-Focus-2-Conor_1.8_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/forest/Forest-Focus-2-Conor_1.8_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25750349,
      "sha256": "031cc56e26a301433f898d5fc5c2e24dd35d8b3c8b6f2a63a6459a18766b38b5",
      "download_error": null
    },
    {
      "track_id": "6a54f6ac6ff4d00262502888",
      "name": "Story Mode",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.59,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/StoryMode_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=oCNERYf%2F8osMjgb6Nbd2BQ0juURV3i6v2F2i2wxMUWI%3D",
      "cdn_url": "https://audio2.brain.fm/StoryMode_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StoryMode_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StoryMode_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/StoryMode_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31094088,
      "sha256": "7eb400fdaeea0a351d2bec2f5961912de76bd2fa330be1a26f9367538f28facf",
      "download_error": null
    },
    {
      "track_id": "6a54f63e6ff4d00262502546",
      "name": "Melty",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.59,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Melty_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Ih1RVzA8FknW%2Btpv8jvyb24Z%2FO%2B1YrfHrDORQr%2FW0RQ%3D",
      "cdn_url": "https://audio2.brain.fm/Melty_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Melty_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Melty_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Melty_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 33905952,
      "sha256": "40bec78a264b402f1e9f2138c6bb92237757e69005fd800b25570eca4c2bad9a",
      "download_error": null
    },
    {
      "track_id": "6a4bb6f94518fc4e1e4062bf",
      "name": "Tensai",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.33,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Tensai_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=zR8RymYnX3K1J2Q4seaksPtjhmrjm2XhWksZssW1p8Y%3D",
      "cdn_url": "https://audio2.brain.fm/Tensai_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tensai_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Tensai_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Tensai_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31485960,
      "sha256": "71e9a691669cd9aba871c229bd27561357ab94a06c80aff754a1f9b7b8d6bdb7",
      "download_error": null
    },
    {
      "track_id": "6a42822978a0a113b2ff40d5",
      "name": "Effervescent Essence",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.74,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/EffervescentEssence_Focus_DeepWork_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Q5DEJLkEcR4qWWdKZfSAwFa6MvRYhguEO7e9Wk3W8z4%3D",
      "cdn_url": "https://audio2.brain.fm/EffervescentEssence_Focus_DeepWork_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EffervescentEssence_Focus_DeepWork_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EffervescentEssence_Focus_DeepWork_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/EffervescentEssence_Focus_DeepWork_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32528544,
      "sha256": "4b6158e087676120aeea11a483c3d313b66d6d340984e214eace91c62a6da637",
      "download_error": null
    },
    {
      "track_id": "6a3017ec7a8f5056573c94d9",
      "name": "Paradise Cove",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.42,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/ParadiseCove_Focus_DeepWork_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=yyltdr9rR0YpebokGhZPA%2F3ZTmNSJiQEgF7TQsC%2FcGI%3D",
      "cdn_url": "https://audio2.brain.fm/ParadiseCove_Focus_DeepWork_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ParadiseCove_Focus_DeepWork_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ParadiseCove_Focus_DeepWork_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/ParadiseCove_Focus_DeepWork_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29379246,
      "sha256": "e07cbd79709fd671d33d8664139c5b52ada680e6d4d1dc24091d8459faa7701b",
      "download_error": null
    },
    {
      "track_id": "6a3017d37a8f5056573c93b6",
      "name": "Sunbathing",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.64,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Sunbathing_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=z%2FDmYdAEh2Lr9IAr8B4UCS5VYwG23bwZLTT9nu86izs%3D",
      "cdn_url": "https://audio2.brain.fm/Sunbathing_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sunbathing_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sunbathing_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Sunbathing_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31237512,
      "sha256": "1e7572916be1c788d2a0aeff2e156c50344f6cbac7172ec0bf5d7d8e1e5c25ad",
      "download_error": null
    },
    {
      "track_id": "6a3014e37a8f5056573c7ce7",
      "name": "Tomorrow Today",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.42,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/TomorrowToday_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=q7QOor8V7%2BmUln1F9dE0zm25b6qXDvMb9ueaKe8ENao%3D",
      "cdn_url": "https://audio2.brain.fm/TomorrowToday_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TomorrowToday_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TomorrowToday_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/TomorrowToday_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30736819,
      "sha256": "73f8a4c8b25564b9a4a0632b49058f5ee9208245224c59ef3fedf22c4b8216c6",
      "download_error": null
    },
    {
      "track_id": "6a1dcbdcb7f8597b46124510",
      "name": "Saffron City",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.51,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SaffronCity_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=ii5CHF4v8KqUg882yP2hz%2FmuAeD%2BW7xDpARGM0aU4Pk%3D",
      "cdn_url": "https://audio2.brain.fm/SaffronCity_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SaffronCity_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SaffronCity_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SaffronCity_Focus_Learning_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29124553,
      "sha256": "e8f9e463371fc22c8ce3d8c31044cab341e85d72b8b0a99c90b9583161498a3c",
      "download_error": null
    },
    {
      "track_id": "6a1dcba7b7f8597b46124355",
      "name": "Signature Support",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.59,
      "complexity_level": 0.43,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SignatureSupport_Focus_DeepWork_Grooves_30_115bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Aj7g5Gmi%2FJyuDyFG7sWsAE%2Bnrr8e0rhjeVnT0%2BiE7Rs%3D",
      "cdn_url": "https://audio2.brain.fm/SignatureSupport_Focus_DeepWork_Grooves_30_115bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SignatureSupport_Focus_DeepWork_Grooves_30_115bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SignatureSupport_Focus_DeepWork_Grooves_30_115bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SignatureSupport_Focus_DeepWork_Grooves_30_115bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31140543,
      "sha256": "8997c666619b450314c1678bc27e7aab021173503f7486156a67464762e88b4c",
      "download_error": null
    },
    {
      "track_id": "6a1dcad2b7f8597b46123c08",
      "name": "Skip Rocks",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 106,
      "brightness_level": 0.2,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SkipRocks_Focus_Learning_Grooves_30_106BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=YuAyWn0jJO3uNeZ7JWtPlghQjtECCUzt7%2BgMPrhCTiQ%3D",
      "cdn_url": "https://audio2.brain.fm/SkipRocks_Focus_Learning_Grooves_30_106BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SkipRocks_Focus_Learning_Grooves_30_106BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SkipRocks_Focus_Learning_Grooves_30_106BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SkipRocks_Focus_Learning_Grooves_30_106BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 33141658,
      "sha256": "df3940e70f4d8e3e59311ff468316890bbce65a67a8583dfcd9faab1f8dfa58c",
      "download_error": null
    },
    {
      "track_id": "6a0b8bc3e6017bccd74b82e7",
      "name": "Eyes To The Sky",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.71,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/EyesToTheSky_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=dR8t33Tb87TFvc9R1Suz2qgu28nD7tE0DM7QTP4dBnc%3D",
      "cdn_url": "https://audio2.brain.fm/EyesToTheSky_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EyesToTheSky_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EyesToTheSky_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/EyesToTheSky_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31250256,
      "sha256": "f2e28cb72b3ac5d8fa52937097665efa6257cbd7257e11b88c740c539660bbb0",
      "download_error": null
    },
    {
      "track_id": "6a0b8b15e6017bccd74b7a97",
      "name": "Lifted Hold",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.64,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/LiftedHold_Focus_DeepWork_Grooves_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=TmoTQ9q%2BOAlG6WbxBH%2BQBRmKTclAKplKn4XJWOVp7hY%3D",
      "cdn_url": "https://audio2.brain.fm/LiftedHold_Focus_DeepWork_Grooves_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LiftedHold_Focus_DeepWork_Grooves_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LiftedHold_Focus_DeepWork_Grooves_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/LiftedHold_Focus_DeepWork_Grooves_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31467988,
      "sha256": "6743c2f44f062a75011743212de56b95660ed08dddab4ff1c3b74a92302827b8",
      "download_error": null
    },
    {
      "track_id": "6a0b8af3e6017bccd74b7973",
      "name": "Sun Dance",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.32,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SunDance_Focus_Learning_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=WQ%2FMX61X4ntsXbq%2B2TaKsT2ueR%2BOId%2BZ6qYn88%2F%2B74M%3D",
      "cdn_url": "https://audio2.brain.fm/SunDance_Focus_Learning_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SunDance_Focus_Learning_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SunDance_Focus_Learning_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SunDance_Focus_Learning_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28544021,
      "sha256": "9ad4a6607e27cbf699e47c5ce351a8896260591465cc7372aafcbe9c04fbdff6",
      "download_error": null
    },
    {
      "track_id": "69f8b94e1c706aff1baf1382",
      "name": "Take Inventory",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.45,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/TakeInventory_Focus_DeepWork_Grooves_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=fumqg65lNJ%2Fv4nhrhDDnXGunFIC47y9c3LXVfBnKraM%3D",
      "cdn_url": "https://audio2.brain.fm/TakeInventory_Focus_DeepWork_Grooves_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TakeInventory_Focus_DeepWork_Grooves_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TakeInventory_Focus_DeepWork_Grooves_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/TakeInventory_Focus_DeepWork_Grooves_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30689256,
      "sha256": "761a74d7fe2588c9704af77c6f2841f85d5b8f0d4b36ca534ff09b2024d8f0ca",
      "download_error": null
    },
    {
      "track_id": "69f8b8f11c706aff1baf0f42",
      "name": "A Full Break",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.65,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/AFullBreak_DeepWork_Grooves_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=9vsnD8%2FQ3ijZHJwmFXbsUbM9cZBxdZxM6U1nQrTZI4k%3D",
      "cdn_url": "https://audio2.brain.fm/AFullBreak_DeepWork_Grooves_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AFullBreak_DeepWork_Grooves_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AFullBreak_DeepWork_Grooves_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/AFullBreak_DeepWork_Grooves_30_105bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30887086,
      "sha256": "ae4cb9e167cf2fd2cf21b6cc13862c358cd314870d946b6f65d7dfcbc0976bd7",
      "download_error": null
    },
    {
      "track_id": "69f8b8c71c706aff1baf0e06",
      "name": "Saunter On One Side",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.61,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SaunterOnOneSide_Focus_Creativity_Grooves_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=MEcK6ipxSx0Ne%2B%2B4ZDBhBedCCkVdzL6hfYrt3IdzpRE%3D",
      "cdn_url": "https://audio2.brain.fm/SaunterOnOneSide_Focus_Creativity_Grooves_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SaunterOnOneSide_Focus_Creativity_Grooves_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SaunterOnOneSide_Focus_Creativity_Grooves_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SaunterOnOneSide_Focus_Creativity_Grooves_30_98bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31663403,
      "sha256": "141d9fc0fc94a4f7924896ffbc33a1447ba6fcc5e7bc7206efcbe6a26340735d",
      "download_error": null
    },
    {
      "track_id": "69e686e2dce2120639c6f041",
      "name": "Showtime",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.41,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Showtime_Focus_DeepWork_Grooves_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=p65EGu2JkdAOC2xAChDzoG1AwLVoVBMKJNC1IXlbcIo%3D",
      "cdn_url": "https://audio2.brain.fm/Showtime_Focus_DeepWork_Grooves_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Showtime_Focus_DeepWork_Grooves_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Showtime_Focus_DeepWork_Grooves_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Showtime_Focus_DeepWork_Grooves_30_92bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26541627,
      "sha256": "953cf91305d466b9ab2923d3e163c07905f55fcb0874d99f5b25e12ecd812981",
      "download_error": null
    },
    {
      "track_id": "69e686cfdce2120639c6efc9",
      "name": "Acquiescence",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Acquiescence_Focus_Learning_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=jDh7kaaxodSWz9WPqHqmZKpqgB%2BM330Sw6B2Mpd7r%2FM%3D",
      "cdn_url": "https://audio2.brain.fm/Acquiescence_Focus_Learning_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Acquiescence_Focus_Learning_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Acquiescence_Focus_Learning_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Acquiescence_Focus_Learning_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28492680,
      "sha256": "fec60bdf824f9238adc235513a3adb8da51205f95f04b5d54ccc65519de48e8c",
      "download_error": null
    },
    {
      "track_id": "69d0282b9b9914998a32dc11",
      "name": "Expectancies",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.61,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Expectancies_Focus_DeepWork_Grooves_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=GyvITwXoWoA8GZK2fh4GV8RBysU5i1TLSkwyVhAmK4E%3D",
      "cdn_url": "https://audio2.brain.fm/Expectancies_Focus_DeepWork_Grooves_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Expectancies_Focus_DeepWork_Grooves_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Expectancies_Focus_DeepWork_Grooves_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Expectancies_Focus_DeepWork_Grooves_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31175532,
      "sha256": "6187507f0997582af9a9e6b067afeda853d797f9ba017a0dcf8e09b8b111dd91",
      "download_error": null
    },
    {
      "track_id": "69d0281d9b9914998a32dbad",
      "name": "Guiding Light",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.48,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/GuidingLight_Focus_Creativity_Grooves_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=i9oa6HsFG3LA%2FXyouAJo0zSpuwHM%2FGrYoy0t1T9SCik%3D",
      "cdn_url": "https://audio2.brain.fm/GuidingLight_Focus_Creativity_Grooves_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GuidingLight_Focus_Creativity_Grooves_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GuidingLight_Focus_Creativity_Grooves_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/GuidingLight_Focus_Creativity_Grooves_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29259168,
      "sha256": "06cacd673006d1c1e7f8630a7617a46b4ce77cbdbfdff5523a428e882fa76af3",
      "download_error": null
    },
    {
      "track_id": "69c2bd541b6ecfe6c4a72743",
      "name": "Unretained",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.58,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Unretained_Focus_DeepWork_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=VRNPwZ2q1l1uYJCMYCpnLYITMgK%2BxfHzvQeRwa%2BYN84%3D",
      "cdn_url": "https://audio2.brain.fm/Unretained_Focus_DeepWork_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unretained_Focus_DeepWork_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unretained_Focus_DeepWork_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Unretained_Focus_DeepWork_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30847285,
      "sha256": "d6d0f98d894a38c2f7234c5aaeca881d7a015a940b7150a0648430efd6cff213",
      "download_error": null
    },
    {
      "track_id": "69c2bd031b6ecfe6c4a723c1",
      "name": "Quarter Century",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.42,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/QuarterCentury_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=7Xj17ufxGbhydhjwDLnPKmYl4LEsy4oIT8FcXKyWNzw%3D",
      "cdn_url": "https://audio2.brain.fm/QuarterCentury_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "QuarterCentury_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "QuarterCentury_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/QuarterCentury_Focus_DeepWork_Grooves_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28060397,
      "sha256": "f99f29129928bcf5212c89adea336d7de61f07ada0e34a259115d06bdf7300c9",
      "download_error": null
    },
    {
      "track_id": "69aee2e973bfe2099d517d33",
      "name": "Haneda",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Haneda_Focus_Creativity_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=lggka9K2hNa30O6x%2FZZOJF0qf3FJuk8u%2Bu2XPU5NeVA%3D",
      "cdn_url": "https://audio2.brain.fm/Haneda_Focus_Creativity_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Haneda_Focus_Creativity_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Haneda_Focus_Creativity_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Haneda_Focus_Creativity_Grooves_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31557216,
      "sha256": "0c4f89e0a7f6cae138369c2a1426750d542efb64f0e783e3b3cf5d99b5d0becd",
      "download_error": null
    },
    {
      "track_id": "69aee2d873bfe2099d517c97",
      "name": "Ad Hoc Gridlock",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.36,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/AdHocGridlock_DeepWork_Grooves_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=gSKp41nNi3B%2FEUeN0kA1tghCc1sVt%2BKlnOZmjuQlhJ0%3D",
      "cdn_url": "https://audio2.brain.fm/AdHocGridlock_DeepWork_Grooves_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AdHocGridlock_DeepWork_Grooves_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AdHocGridlock_DeepWork_Grooves_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/AdHocGridlock_DeepWork_Grooves_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31270851,
      "sha256": "56676d5306d3dba5ee3c480b847db03db8d8a438eb03580635567830969ae8f8",
      "download_error": null
    },
    {
      "track_id": "69aee24473bfe2099d517891",
      "name": "Messenger",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.62,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Messenger_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=imFKRZCiREVlUOG%2BmubkBALWvFYLE4UGqZgLADcpKpk%3D",
      "cdn_url": "https://audio2.brain.fm/Messenger_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Messenger_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Messenger_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Messenger_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30602672,
      "sha256": "317a5896912aff84bb55e385dfb1c7861be6ca540928227772ee68109226f85b",
      "download_error": null
    },
    {
      "track_id": "699cad699033fe9e7ccfa85f",
      "name": "Rose Gold",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.48,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/RoseGold_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=2sGKn7i%2Bo1t6Bkq6D6tsRhHrRRGkiFvQCp2%2B1tCWP6c%3D",
      "cdn_url": "https://audio2.brain.fm/RoseGold_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RoseGold_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RoseGold_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/RoseGold_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30125370,
      "sha256": "6a15abb7710e7aef4dcc6cb962cc2871ac45be27600b6d0d4d89f3039fb18f47",
      "download_error": null
    },
    {
      "track_id": "699cac489033fe9e7ccf9e65",
      "name": "Raveolution",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 133,
      "brightness_level": 0.43,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Raveolution_Focus_Creativity_Grooves_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=YSoNP5BxjZmzjiUvnMRyT%2BGGxUQ%2BjwEeUl6TNT08LIA%3D",
      "cdn_url": "https://audio2.brain.fm/Raveolution_Focus_Creativity_Grooves_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Raveolution_Focus_Creativity_Grooves_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Raveolution_Focus_Creativity_Grooves_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Raveolution_Focus_Creativity_Grooves_30_133BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28969929,
      "sha256": "0be440ce8467353c4d9aed4228e736f65a9afe19671cb6620c652ef7a7e8e8bc",
      "download_error": null
    },
    {
      "track_id": "698a15e68a4a8f35be583cc1",
      "name": "An Achievement",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.48,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/AnAchievement_Focus_DeepWork_Grooves_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Yyez58AXAIRj19TKQOWjhCeAYH1Qc7CVlKpDk8ICf%2FM%3D",
      "cdn_url": "https://audio2.brain.fm/AnAchievement_Focus_DeepWork_Grooves_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AnAchievement_Focus_DeepWork_Grooves_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AnAchievement_Focus_DeepWork_Grooves_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/AnAchievement_Focus_DeepWork_Grooves_30_105bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29928633,
      "sha256": "a970771c0479516c8a3addf2d053d8048ef626becad38c7b389423cb3cd88ca3",
      "download_error": null
    },
    {
      "track_id": "698a15d98a4a8f35be583bf0",
      "name": "Far Fetched",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 93,
      "brightness_level": 0.54,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/FarFetched_Focus_Creativity_Grooves_30_93BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=8z6SN4xoWO1Rx3sXzbqHXvBYOX8jFr%2BYt1%2B92nfnfsY%3D",
      "cdn_url": "https://audio2.brain.fm/FarFetched_Focus_Creativity_Grooves_30_93BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FarFetched_Focus_Creativity_Grooves_30_93BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FarFetched_Focus_Creativity_Grooves_30_93BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/FarFetched_Focus_Creativity_Grooves_30_93BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29269098,
      "sha256": "dbbdfe33a14b99f006aba050530dcdd5757d9c75f2937b59899f96fd6efb09ac",
      "download_error": null
    },
    {
      "track_id": "6977c18a597917b519507d0a",
      "name": "In a Hold",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.64,
      "complexity_level": 0.37,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/InAHold_Focus_Creativity_Grooves_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=8GvZPV4ROJHD2rk8nOi0qUs%2BVDfuTBMZvYq7eY1rAU4%3D",
      "cdn_url": "https://audio2.brain.fm/InAHold_Focus_Creativity_Grooves_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InAHold_Focus_Creativity_Grooves_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InAHold_Focus_Creativity_Grooves_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/InAHold_Focus_Creativity_Grooves_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30795653,
      "sha256": "78bafcb4187d049ff38eaaae7ab1f9452c4deb498c8098567742ea3739e36d51",
      "download_error": null
    },
    {
      "track_id": "6977c164597917b519507c0e",
      "name": "Nothing Left To It",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.61,
      "complexity_level": 0.43,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/NothingLeftToIt_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=uah0gG%2FG%2BpExgxhH5j5KV48Xc8RZa519rRFXeSzqfEg%3D",
      "cdn_url": "https://audio2.brain.fm/NothingLeftToIt_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NothingLeftToIt_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NothingLeftToIt_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/NothingLeftToIt_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31937449,
      "sha256": "5470b736cce70d153004ef99ee246b0736622151d14abd723292ee4f8a2cee32",
      "download_error": null
    },
    {
      "track_id": "6977c13a236f65de4c7e60a0",
      "name": "Slow Rolling",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 97,
      "brightness_level": 0.57,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.61,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SlowRolling_Focus_Grooves_DeepWork_30_97BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=RDQwTBdVyv4nTO1ZtaxgscYHotbfxCxalVKfVGtC0oA%3D",
      "cdn_url": "https://audio2.brain.fm/SlowRolling_Focus_Grooves_DeepWork_30_97BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SlowRolling_Focus_Grooves_DeepWork_30_97BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SlowRolling_Focus_Grooves_DeepWork_30_97BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SlowRolling_Focus_Grooves_DeepWork_30_97BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28761645,
      "sha256": "621286dd967056ae25d36867ebf2f76bc05296fa243c55d0436da55e972104cc",
      "download_error": null
    },
    {
      "track_id": "69655bc98afa49f5711b9626",
      "name": "In The Afters",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.54,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/InTheAfters_Focus_DeepWork_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=xCElj%2BVtR1tvWmitw%2F6HebanN7iMoPJqUwIoEXNjOEI%3D",
      "cdn_url": "https://audio2.brain.fm/InTheAfters_Focus_DeepWork_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InTheAfters_Focus_DeepWork_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InTheAfters_Focus_DeepWork_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/InTheAfters_Focus_DeepWork_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32880823,
      "sha256": "7c34600972b5dc48dfe3b3d02a12859ba812c63f95a25aec92f91b60d9179c39",
      "download_error": null
    },
    {
      "track_id": "69655ad88afa49f5711b918d",
      "name": "Nonstandard Config",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.54,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/NonstandardConfig_Focus_Creativity_Grooves_30_114bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=z5zrkZCbGFgDbWSCVLr7aFQbRKW2ISONaqT2dwNKaCQ%3D",
      "cdn_url": "https://audio2.brain.fm/NonstandardConfig_Focus_Creativity_Grooves_30_114bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NonstandardConfig_Focus_Creativity_Grooves_30_114bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NonstandardConfig_Focus_Creativity_Grooves_30_114bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/NonstandardConfig_Focus_Creativity_Grooves_30_114bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28732347,
      "sha256": "51c99d687662b6ae99c981b7f33f9c2673db78a4de29f6316acd1b23962763c5",
      "download_error": null
    },
    {
      "track_id": "6952f3c89e729f65562d12d1",
      "name": "Back Pocket",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.57,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/BackPocket_Focus_Learning_Grooves_30_96BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=HQlkrBzACwUujCWZIIuCgp2jpKA84b0H%2BugV7kHC5Mo%3D",
      "cdn_url": "https://audio2.brain.fm/BackPocket_Focus_Learning_Grooves_30_96BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BackPocket_Focus_Learning_Grooves_30_96BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BackPocket_Focus_Learning_Grooves_30_96BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/BackPocket_Focus_Learning_Grooves_30_96BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 33298604,
      "sha256": "c7f88aa875f2da47cbda63ddd4d34d5ac6cf4c48bb6b56abc31ef293f628e1b1",
      "download_error": null
    },
    {
      "track_id": "6952f3b49e729f65562d1275",
      "name": "Dub Daze",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.57,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/DubDaze_Focus_Grooves_DeepWork_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=vZKxcCWZSVi6cQMI0%2FhaTaugQE2M3ifXyNMpHlSkeKo%3D",
      "cdn_url": "https://audio2.brain.fm/DubDaze_Focus_Grooves_DeepWork_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DubDaze_Focus_Grooves_DeepWork_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DubDaze_Focus_Grooves_DeepWork_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/DubDaze_Focus_Grooves_DeepWork_30_130BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28532940,
      "sha256": "7a4fbb50814212b2dcc80027a42bcdcce8f63d0e0d2adced6ca79dc839f79b30",
      "download_error": null
    },
    {
      "track_id": "69405a7276a1c1f80ff93d64",
      "name": "Ceramicism",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.3,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Ceramicism_Focus_Learning_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=0dNRCOWxd122OUx%2Bx1ifv2Xip9mcwibey%2Fbqnx1fWWo%3D",
      "cdn_url": "https://audio2.brain.fm/Ceramicism_Focus_Learning_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Ceramicism_Focus_Learning_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Ceramicism_Focus_Learning_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Ceramicism_Focus_Learning_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28375992,
      "sha256": "90e00734201f64baf38d973935062864b8bede592a7fb668102da23413d5a049",
      "download_error": null
    },
    {
      "track_id": "69405a61913e2d2bff955c3a",
      "name": "Just In Place",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.48,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/JustInPlace_Focus_DeepWork_Grooves_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=S5CM29qIjTMK4lYNdteuR153yyeV7hpcJw%2Bs6EzwHQc%3D",
      "cdn_url": "https://audio2.brain.fm/JustInPlace_Focus_DeepWork_Grooves_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JustInPlace_Focus_DeepWork_Grooves_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "JustInPlace_Focus_DeepWork_Grooves_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/JustInPlace_Focus_DeepWork_Grooves_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30474573,
      "sha256": "05f42b185c743ec40386bef4346e540f3e2fb2128347919a34ac4028a70cfaa5",
      "download_error": null
    },
    {
      "track_id": "692dbea566ea27cd5c911aec",
      "name": "Jungle Hunt",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.57,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/JungleHunt_Focus_Grooves_DeepWork_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=kPC%2FW7gM5KVawVOlUff9b1TV4QkhJF2H57yOX2nkJUc%3D",
      "cdn_url": "https://audio2.brain.fm/JungleHunt_Focus_Grooves_DeepWork_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JungleHunt_Focus_Grooves_DeepWork_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "JungleHunt_Focus_Grooves_DeepWork_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/JungleHunt_Focus_Grooves_DeepWork_30_110BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28537420,
      "sha256": "1b5575aad1c453296b7643530d062e0bb90193ec8819af5d9e52dbad9e4232c6",
      "download_error": null
    },
    {
      "track_id": "692dbddb66ea27cd5c9116dd",
      "name": "Zori",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.57,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Zori_Focus_DeepWork_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Aag4eKB8EkjWzvsJsTc3fcU1n4qESM1fowqdMbwzJ74%3D",
      "cdn_url": "https://audio2.brain.fm/Zori_Focus_DeepWork_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Zori_Focus_DeepWork_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Zori_Focus_DeepWork_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Zori_Focus_DeepWork_Grooves_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30514955,
      "sha256": "6c334ad459cd891bd1fae598ac2135f27ac5847d7665ddeb96c2e85b2692d961",
      "download_error": null
    },
    {
      "track_id": "692dbda266ea27cd5c9115fc",
      "name": "Pseudo",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.7,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Pseudo_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=B4EnoIuIkj0wHrSRnUCmhSLq7ZoLHo97Ubxof0KT0Lo%3D",
      "cdn_url": "https://audio2.brain.fm/Pseudo_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pseudo_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Pseudo_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Pseudo_Focus_Learning_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30085277,
      "sha256": "c95aa30b3424aecef9c5442eaf3f49df4e4d9f96b388900bb4a246d164a28bf9",
      "download_error": null
    },
    {
      "track_id": "691b3cfaa1c962ea641efff1",
      "name": "Humidor",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.78,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Humidor_Focus_Creativity_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=yx%2B8KCNsTTLk%2F%2FM61p9a0JFV56m4FCsK541fAW3UfwA%3D",
      "cdn_url": "https://audio2.brain.fm/Humidor_Focus_Creativity_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Humidor_Focus_Creativity_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Humidor_Focus_Creativity_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Humidor_Focus_Creativity_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32399186,
      "sha256": "8310f34296bfdb8e1067e584ccc25952641428ffcce08b9a80b3f9376bdf8655",
      "download_error": null
    },
    {
      "track_id": "691b3ce6a1c962ea641eff60",
      "name": "Calendula",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.33,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Calendula_Focus_DeepWork_Grooves_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=fKkneVJz4haRcD0PM81ghSbFlskzwTOrcXLeJjhxT%2Fw%3D",
      "cdn_url": "https://audio2.brain.fm/Calendula_Focus_DeepWork_Grooves_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Calendula_Focus_DeepWork_Grooves_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Calendula_Focus_DeepWork_Grooves_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Calendula_Focus_DeepWork_Grooves_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26706997,
      "sha256": "858c37ec13c5b562d61b4389916c7752cb016529aaac249b45c9cb186c18b41d",
      "download_error": null
    },
    {
      "track_id": "691b3ca2a1c962ea641efe67",
      "name": "Mochi",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.62,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.83,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Mochi_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=4Kbh3U4BqwZhYQb3lPxGofDqPUkK77oNRtBy%2FD%2FPBHY%3D",
      "cdn_url": "https://audio2.brain.fm/Mochi_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Mochi_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Mochi_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Mochi_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29713763,
      "sha256": "a1da67d3b7b3393fc4c6279aabe26fcd72591fa6132f3cd8f704930e1e034b51",
      "download_error": null
    },
    {
      "track_id": "691b3c8ca1c962ea641efe05",
      "name": "Chump Change",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.48,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/ChumpChange_Focus_DeepWork_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=AlDP9L03AJq%2BxFizZPWz1VSXe%2BoesY8d1hixixfB%2Bjg%3D",
      "cdn_url": "https://audio2.brain.fm/ChumpChange_Focus_DeepWork_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ChumpChange_Focus_DeepWork_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ChumpChange_Focus_DeepWork_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/ChumpChange_Focus_DeepWork_Grooves_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28405539,
      "sha256": "6c200449c252eeef7f72a9bc5894edc94f4bc21eafc5cd80b7e0f81c1bd79b9e",
      "download_error": null
    },
    {
      "track_id": "691b3c7b331c372ce87484e8",
      "name": "Degraded Film",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.68,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/DegradedFilm_Focus_Creativity_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=C0z0XouHt5%2Fg42d2Zc%2BcT%2FhOv3x%2BXNJwyqtNKeL4%2Fzw%3D",
      "cdn_url": "https://audio2.brain.fm/DegradedFilm_Focus_Creativity_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DegradedFilm_Focus_Creativity_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DegradedFilm_Focus_Creativity_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/DegradedFilm_Focus_Creativity_Grooves_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28168122,
      "sha256": "491ab1c0eaa651eecf9c4c6246f923f6a0f000df3990b2fd6b59a1e4383074bd",
      "download_error": null
    },
    {
      "track_id": "691b3beda1c962ea641efae9",
      "name": "Float Along",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.68,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/FloatAlong_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=jLr8lsh2H3CkhnxtloLT1UUBMtrtWpGcOTi%2FOnpMhao%3D",
      "cdn_url": "https://audio2.brain.fm/FloatAlong_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FloatAlong_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FloatAlong_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/FloatAlong_Focus_DeepWork_Grooves_30_94bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28306904,
      "sha256": "894b6252064f15a2aec00023a45b8ff1910d02fcfe56cfb0efa6c629d9f10944",
      "download_error": null
    },
    {
      "track_id": "69091a0026bc41a99c863937",
      "name": "Fool's Joy",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.9,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Fool'sJoy_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=DaJ8gaf5DOyPobMJcLU%2BsFKl6N84g8teMeDo7%2FaE9tw%3D",
      "cdn_url": "https://audio2.brain.fm/Fool'sJoy_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fool'sJoy_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fool-sJoy_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Fool-sJoy_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31294082,
      "sha256": "79027a91fe41ae8aacd7e93dabbecaef179fb39cd596617c82cdb1d57edc2a6a",
      "download_error": null
    },
    {
      "track_id": "6909198626bc41a99c863726",
      "name": "Maravilha",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.52,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Maravilha_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=YRVqy085f4beAJwlfxCXCOX4CeokMgBcz82wqQwhT30%3D",
      "cdn_url": "https://audio2.brain.fm/Maravilha_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Maravilha_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Maravilha_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Maravilha_Focus_DeepWork_Grooves_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30185553,
      "sha256": "38b4275e20a99739b611aaee09979063f0642d0730d818ffeffabff70c357a1c",
      "download_error": null
    },
    {
      "track_id": "6909194d312eb1fe04659328",
      "name": "Milky",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.61,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Milky_Focus_Creativity_Grooves_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=43aCFPsjzEyM9ZROWSYkyb4XBdkP5dHqRo3FNX0SAwc%3D",
      "cdn_url": "https://audio2.brain.fm/Milky_Focus_Creativity_Grooves_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Milky_Focus_Creativity_Grooves_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Milky_Focus_Creativity_Grooves_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Milky_Focus_Creativity_Grooves_30_114BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27225111,
      "sha256": "e2f7475d6e3ca3c32177a1417f6ab41cc57cff3aa930a0e012d2f0fd34eb5915",
      "download_error": null
    },
    {
      "track_id": "68f66593c7a40a338f846104",
      "name": "No Myths",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.57,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/NoMyths_Focus_Creativity_Grooves_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=xsnR9z0x5zmbY5Ends8V7KKnasXyXn1JyLgVHtkLVFw%3D",
      "cdn_url": "https://audio2.brain.fm/NoMyths_Focus_Creativity_Grooves_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NoMyths_Focus_Creativity_Grooves_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NoMyths_Focus_Creativity_Grooves_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/NoMyths_Focus_Creativity_Grooves_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30416919,
      "sha256": "2204717f11138958072d887acdcde9bbfbf96eb3488d98c65771f9e4e76ba1c7",
      "download_error": null
    },
    {
      "track_id": "68f6652ec7a40a338f845e97",
      "name": "Stone Unturned",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 1.04,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/StoneUnturned_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=cA%2B9QsZZMS3QDMzQk0Gc5wqp2BDTERnTUE3chGoLnNQ%3D",
      "cdn_url": "https://audio2.brain.fm/StoneUnturned_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StoneUnturned_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StoneUnturned_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/StoneUnturned_Focus_Learning_Grooves_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31129450,
      "sha256": "8476ef19d554322132e4e2d397e753705e2682106760a2027d6708533865eb62",
      "download_error": null
    },
    {
      "track_id": "68f6646de8a4cc0a7401bd6c",
      "name": "Beauty in Gloom",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 128,
      "brightness_level": 0.52,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/BeautyInGloom_Focus_DeepWork_Grooves_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Mh%2F%2FKWgyKJmtDMlyXaA8WVE9UJQ%2BYluUWl%2F4JDxM5NA%3D",
      "cdn_url": "https://audio2.brain.fm/BeautyInGloom_Focus_DeepWork_Grooves_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BeautyInGloom_Focus_DeepWork_Grooves_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BeautyInGloom_Focus_DeepWork_Grooves_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/BeautyInGloom_Focus_DeepWork_Grooves_30_128BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28565079,
      "sha256": "da8a854e07a8809706019d5a77633be319b5820f631cf90cfc0e787b79dc40e6",
      "download_error": null
    },
    {
      "track_id": "68e3d7b52d873930bbbf7d49",
      "name": "Pastures",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.74,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Pastures_Focus_Learning_Grooves_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=OIKU4wOLmR2CmBo6BVap3ZpA7GkZys8qz3O3vw4NCo8%3D",
      "cdn_url": "https://audio2.brain.fm/Pastures_Focus_Learning_Grooves_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pastures_Focus_Learning_Grooves_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Pastures_Focus_Learning_Grooves_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Pastures_Focus_Learning_Grooves_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 33035719,
      "sha256": "f22183079fc0a87ee26a9517a5dd14ef95165337d16760622353610800843ea5",
      "download_error": null
    },
    {
      "track_id": "68e3d79c2d873930bbbf7cc5",
      "name": "The Perfect Beach",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.57,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.29,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/ThePerfectBeach_Focus_Grooves_Creativity_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=90gnFv0c7zsT%2F29g7JExDlWvlhCyEaGvyxOq2s1jfvE%3D",
      "cdn_url": "https://audio2.brain.fm/ThePerfectBeach_Focus_Grooves_Creativity_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThePerfectBeach_Focus_Grooves_Creativity_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThePerfectBeach_Focus_Grooves_Creativity_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/ThePerfectBeach_Focus_Grooves_Creativity_30_112BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27968401,
      "sha256": "22d1b21b806a99c997f96545adf6d3ef6cb45fd143031be48cf699f8cf415bf1",
      "download_error": null
    },
    {
      "track_id": "68d179f6a2277468b10cda42",
      "name": "It's Giving",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.48,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/It'sGiving_Focus_Learning_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=uGEqVTqr5C8DoWEMbM8aLXp%2BDn8d3zhYOlgznoB5fEw%3D",
      "cdn_url": "https://audio2.brain.fm/It'sGiving_Focus_Learning_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "It'sGiving_Focus_Learning_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "It-sGiving_Focus_Learning_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/It-sGiving_Focus_Learning_Grooves_30_95bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29403675,
      "sha256": "cefec8eae1791a9664b8cfa19de379c120691ca1497c9b2a4a85a6c671cfe53c",
      "download_error": null
    },
    {
      "track_id": "68d178f8d9158d8853b172d8",
      "name": "Day Dreaming",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.41,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/DayDreaming_Focus_DeepWork_Grooves_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=d5hFasu%2F3VnQvqlPHcWBsGd26K3SROmqvV9mZTZIih4%3D",
      "cdn_url": "https://audio2.brain.fm/DayDreaming_Focus_DeepWork_Grooves_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DayDreaming_Focus_DeepWork_Grooves_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DayDreaming_Focus_DeepWork_Grooves_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/DayDreaming_Focus_DeepWork_Grooves_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28345926,
      "sha256": "634ef55de5b65db8dfe6cd7d04111c2b04dd364d522fc1a7835f6d99d8ac0b0c",
      "download_error": null
    },
    {
      "track_id": "68bf2b3ebab547755c788983",
      "name": "Simple Answer",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.11,
      "complexity_level": 0.65,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SimpleAnswer_Focus_Learning_Grooves_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=82N%2FZ3CXKnGQwsALMU0rLbu%2FEYbPl%2BQZnCWxqjF7sS0%3D",
      "cdn_url": "https://audio2.brain.fm/SimpleAnswer_Focus_Learning_Grooves_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SimpleAnswer_Focus_Learning_Grooves_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SimpleAnswer_Focus_Learning_Grooves_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SimpleAnswer_Focus_Learning_Grooves_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32717533,
      "sha256": "cf210be0a89a14d08a24d5a9e67ec4d08cae4fb612a0fdceb449ae8dc19d882d",
      "download_error": null
    },
    {
      "track_id": "68bf240ebab547755c787353",
      "name": "Colloquially",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.65,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Colloquially_Focus_DeepWork_Grooves_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Km97udVNUFu6ACsJMfoBPL1NXj0kajp%2FgnF%2FWuoJsgI%3D",
      "cdn_url": "https://audio2.brain.fm/Colloquially_Focus_DeepWork_Grooves_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Colloquially_Focus_DeepWork_Grooves_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Colloquially_Focus_DeepWork_Grooves_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Colloquially_Focus_DeepWork_Grooves_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30716785,
      "sha256": "055ed568d889cb0de8b849b725aa68dcf53717f7929a4b1a3357571891af1aae",
      "download_error": null
    },
    {
      "track_id": "68bf23ab95e372361f91f1a0",
      "name": "Little Pushes",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.61,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Little%20Pushes_Focus_DeepWork_Grooves_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=l%2F86TZBNbw97nvGJaMDJ1jtK8fPchRRD%2B7dbOCFhcRc%3D",
      "cdn_url": "https://audio2.brain.fm/Little%20Pushes_Focus_DeepWork_Grooves_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Little Pushes_Focus_DeepWork_Grooves_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Little-Pushes_Focus_DeepWork_Grooves_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Little-Pushes_Focus_DeepWork_Grooves_30_95bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29025571,
      "sha256": "633fb62c8a26a97f63859324f626cda2802084014ece704772761e398f2f85b9",
      "download_error": null
    },
    {
      "track_id": "68bf2385bab547755c7871cd",
      "name": "Apollo",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.68,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Apollo_Focus_DeepWork_Grooves_30_88bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=lmfuoN1Z7D%2BZWsuY1dXmPe%2B3VNtbFtVaFUQA9RqAFMc%3D",
      "cdn_url": "https://audio2.brain.fm/Apollo_Focus_DeepWork_Grooves_30_88bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Apollo_Focus_DeepWork_Grooves_30_88bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Apollo_Focus_DeepWork_Grooves_30_88bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Apollo_Focus_DeepWork_Grooves_30_88bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28751214,
      "sha256": "34cb75661d551af1264728b984e362ff46891e11926d4c3b015735e9d5e5f8ca",
      "download_error": null
    },
    {
      "track_id": "68aca53c605d1de9ea68be7e",
      "name": "Flyby",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 93,
      "brightness_level": 0.65,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Flyby_Focus_Learning_Grooves_30_93bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=o1dr2tUpuk9zEXrUdfwkJL0%2F9oEzy0WpJxScvIZ7KHA%3D",
      "cdn_url": "https://audio2.brain.fm/Flyby_Focus_Learning_Grooves_30_93bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Flyby_Focus_Learning_Grooves_30_93bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Flyby_Focus_Learning_Grooves_30_93bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Flyby_Focus_Learning_Grooves_30_93bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31402663,
      "sha256": "1c60de3af4cbda867be7e28d4d76a88a3e307f43e38c75ade774e687fa7774dd",
      "download_error": null
    },
    {
      "track_id": "68aca4cd605d1de9ea68bcce",
      "name": "Jibber Jabber",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 103,
      "brightness_level": 0.52,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.89,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/JibberJabber_Focus_Learning_Grooves_30_103bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=o%2FFWfFyacrBkYimodfd3CZmLZ4z7Cu9cxRpuI3hRkFw%3D",
      "cdn_url": "https://audio2.brain.fm/JibberJabber_Focus_Learning_Grooves_30_103bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JibberJabber_Focus_Learning_Grooves_30_103bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "JibberJabber_Focus_Learning_Grooves_30_103bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/JibberJabber_Focus_Learning_Grooves_30_103bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30345535,
      "sha256": "00c0232b43f96119fcbf92e02f00f7e2344d5a436e4ee7069e06df8500328301",
      "download_error": null
    },
    {
      "track_id": "68aca48d870c986ca59c0886",
      "name": "Rabbit's Foot",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.72,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Rabbit'sFoot_Focus_Learning_Grooves_30_87BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=kDBdMsJyPBOKFlQTC1Iv7eWcKQWOQlr0o0t5c4FAp3M%3D",
      "cdn_url": "https://audio2.brain.fm/Rabbit'sFoot_Focus_Learning_Grooves_30_87BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Rabbit'sFoot_Focus_Learning_Grooves_30_87BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Rabbit-sFoot_Focus_Learning_Grooves_30_87BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Rabbit-sFoot_Focus_Learning_Grooves_30_87BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32449940,
      "sha256": "1df596bacd2d9df2be2ad2ff7c91ae9445c98cbf5afea0fab946404ca514d0d0",
      "download_error": null
    },
    {
      "track_id": "68aca3f4870c986ca59c0589",
      "name": "Slow Shake",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.71,
      "complexity_level": 0.95,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SlowShake_Focus_DeepWork_Grooves_30_116bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=pRFDqy29yHjDBEnlVFqs3dWv2fX9C7pMZxNqUAOigqw%3D",
      "cdn_url": "https://audio2.brain.fm/SlowShake_Focus_DeepWork_Grooves_30_116bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SlowShake_Focus_DeepWork_Grooves_30_116bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SlowShake_Focus_DeepWork_Grooves_30_116bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SlowShake_Focus_DeepWork_Grooves_30_116bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30274602,
      "sha256": "6a72749dbaf59baeb76f63693aa465c8d323c88cdcb5e159d1b536d4149da066",
      "download_error": null
    },
    {
      "track_id": "689a23cbcc7f78cc36b7bd51",
      "name": "Blue Radiance",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.38,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/BlueRadiance_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=VDUoEMzOGwDQULHXV8ZBq7GEy0ZGJXEviKOqzcVm6c0%3D",
      "cdn_url": "https://audio2.brain.fm/BlueRadiance_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BlueRadiance_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BlueRadiance_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/BlueRadiance_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32318990,
      "sha256": "73ffd72ff68751433cdd281a9d9f2c5b25ef29c57dfcbab34c60216a68739b67",
      "download_error": null
    },
    {
      "track_id": "689a2375cc7f78cc36b7bc3a",
      "name": "Freedom Ring",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.9,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/FreedomRing_Focus_Learning_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=vD8odY0kiIFQXv7MphLTj5Ku8UQl8%2BEkF40FTiPPoyM%3D",
      "cdn_url": "https://audio2.brain.fm/FreedomRing_Focus_Learning_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FreedomRing_Focus_Learning_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FreedomRing_Focus_Learning_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/FreedomRing_Focus_Learning_Grooves_30_105BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 33325615,
      "sha256": "e469b1ab28809d84e0a2fa99342e40a0c7c28e87a39054ac09d83c9f63290846",
      "download_error": null
    },
    {
      "track_id": "689a22d89446c76349a3b41c",
      "name": "Mango Lassi",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.65,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/MangoLassi_Focus_DeepWork_Grooves_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=npegDII7k0jc4Dq8SdqIGYpZd14hYQBpBRZjvT2il9I%3D",
      "cdn_url": "https://audio2.brain.fm/MangoLassi_Focus_DeepWork_Grooves_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MangoLassi_Focus_DeepWork_Grooves_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MangoLassi_Focus_DeepWork_Grooves_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/MangoLassi_Focus_DeepWork_Grooves_30_118BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28039427,
      "sha256": "f5fbb72475d81b7886e2f89c7848ef06df53b97589ba93bbf7ae0f41cd9226d0",
      "download_error": null
    },
    {
      "track_id": "689a22a59446c76349a3b333",
      "name": "Back in the Saddle",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 125,
      "brightness_level": 0.65,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/BackInTheSaddle_Focus_Creativity_Grooves_30_125BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=KJHI6uEZJm55544pEnG2VvaT3z0MmutXfssccJquTtQ%3D",
      "cdn_url": "https://audio2.brain.fm/BackInTheSaddle_Focus_Creativity_Grooves_30_125BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BackInTheSaddle_Focus_Creativity_Grooves_30_125BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BackInTheSaddle_Focus_Creativity_Grooves_30_125BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/BackInTheSaddle_Focus_Creativity_Grooves_30_125BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29554078,
      "sha256": "9a66603a60345bc8812162d4ed533e4062882028072198ad60fdae53ad1dbcc1",
      "download_error": null
    },
    {
      "track_id": "6888c90ec24bb893747ef6ad",
      "name": "Blue Rose",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 70,
      "brightness_level": 0.61,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/BlueRose_Focus_Creativity_Grooves_30_70BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=4T7rN2fTaPkYS3LA6yCEQYjPDtFUfKrWWyE1dRs65ZE%3D",
      "cdn_url": "https://audio2.brain.fm/BlueRose_Focus_Creativity_Grooves_30_70BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BlueRose_Focus_Creativity_Grooves_30_70BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BlueRose_Focus_Creativity_Grooves_30_70BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/BlueRose_Focus_Creativity_Grooves_30_70BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28308798,
      "sha256": "5ed269839423ac680ee82128b9613e1ab2e1f26a1dceb678a3433d61c29ad70a",
      "download_error": null
    },
    {
      "track_id": "6888c901b997579cf699b844",
      "name": "Signs & Wonders",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.55,
      "complexity_level": 0.35,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Signs%26Wonders_Focus_DeepWork_Grooves_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=TOtGGGWsRZyNCA9BLoI7FB3FWBvsKDwhNWrlP%2FcpB7M%3D",
      "cdn_url": "https://audio2.brain.fm/Signs%26Wonders_Focus_DeepWork_Grooves_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Signs&Wonders_Focus_DeepWork_Grooves_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Signs-Wonders_Focus_DeepWork_Grooves_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Signs-Wonders_Focus_DeepWork_Grooves_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32955660,
      "sha256": "421807dc45dd2d533becfd2c8a6a3ccb8c144d8cd851404b4fea7a66a0e612c4",
      "download_error": null
    },
    {
      "track_id": "6888c8f6c24bb893747ef676",
      "name": "Canyon Lake",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.46,
      "complexity_level": 0.72,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/CanyonLake_Focus_DeepWork_Grooves_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=OM%2BHu60ILIqfUMpWGmLlAH5PwB64WgWSDUrxCpZYaCg%3D",
      "cdn_url": "https://audio2.brain.fm/CanyonLake_Focus_DeepWork_Grooves_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CanyonLake_Focus_DeepWork_Grooves_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CanyonLake_Focus_DeepWork_Grooves_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/CanyonLake_Focus_DeepWork_Grooves_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27719068,
      "sha256": "32a2ad4a201eccbf14305db6e11a16c6a6ca0351d05eb88375b8357873239393",
      "download_error": null
    },
    {
      "track_id": "6888c8d9b997579cf699b785",
      "name": "My House",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 122,
      "brightness_level": 0.61,
      "complexity_level": 0.35,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/MyHouse_Focus_DeepWork_Grooves_30_122BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Hall%2B4C4Luuo%2F74Rt8uASVArWdYLfovxQP5gx5s25HM%3D",
      "cdn_url": "https://audio2.brain.fm/MyHouse_Focus_DeepWork_Grooves_30_122BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MyHouse_Focus_DeepWork_Grooves_30_122BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MyHouse_Focus_DeepWork_Grooves_30_122BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/MyHouse_Focus_DeepWork_Grooves_30_122BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28175307,
      "sha256": "04283dc4e7f76c4f58f78e8e8a1d6274a1733eb5636aa310161ca7251d2723a0",
      "download_error": null
    },
    {
      "track_id": "6862f0c97689f5af5f0455e2",
      "name": "Twin Bouquets",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.65,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/TwinBouquets_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=PyllYtm%2BBswOWiiiQUzD6b8EmT1ApZwfpX%2BqTcr6kFc%3D",
      "cdn_url": "https://audio2.brain.fm/TwinBouquets_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TwinBouquets_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TwinBouquets_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/TwinBouquets_Focus_Learning_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28124619,
      "sha256": "3c6ed23cfcbc0de62c01adc7c8d9f5fb7a9a22cd73a67cedd3810afbde6e0eb2",
      "download_error": null
    },
    {
      "track_id": "6862ef87da2d247f1a9c74b3",
      "name": "New Tradition",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.78,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/NewTradition_Focus_DeepWork_Grooves_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=IylzY%2Bx5ImFOhGJqW8x7JrUWucG5LFHr6Ka8aBI6kEU%3D",
      "cdn_url": "https://audio2.brain.fm/NewTradition_Focus_DeepWork_Grooves_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NewTradition_Focus_DeepWork_Grooves_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NewTradition_Focus_DeepWork_Grooves_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/NewTradition_Focus_DeepWork_Grooves_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30648142,
      "sha256": "188f20f451ebb730514d7eb47625b891ad4dc5de20987d9bf3a0d161081dec97",
      "download_error": null
    },
    {
      "track_id": "6862eb6bb0ad537cfff5c5b3",
      "name": "Little Elephant",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 126,
      "brightness_level": 0.64,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/LittleElephant_Focus_DeepWork_Grooves_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=FdplazjCu0IF3Ramo6JmEhrzuxcbIQmRQ6Xt9WXxbh4%3D",
      "cdn_url": "https://audio2.brain.fm/LittleElephant_Focus_DeepWork_Grooves_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LittleElephant_Focus_DeepWork_Grooves_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LittleElephant_Focus_DeepWork_Grooves_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/LittleElephant_Focus_DeepWork_Grooves_30_126BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28064789,
      "sha256": "d753ca1f8f9317cf9c6b849410681b88c43594a68dfd8615a0a3b527be8e687a",
      "download_error": null
    },
    {
      "track_id": "68505d805de2e833e430b655",
      "name": "Shivering Light",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.54,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/ShiveringLight_Focus_Creativity_Grooves_30_100BPM_HighNEL_VBR5.mp3?expiration=1792292134248&token=Ze8TcEY7XoGORJb8A2zEP9C9hbIaMHxej5oeUeLIsQg%3D",
      "cdn_url": "https://audio2.brain.fm/ShiveringLight_Focus_Creativity_Grooves_30_100BPM_HighNEL_VBR5.mp3",
      "remote_filename": "ShiveringLight_Focus_Creativity_Grooves_30_100BPM_HighNEL_VBR5.mp3",
      "filename": "ShiveringLight_Focus_Creativity_Grooves_30_100BPM_HighNEL_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/ShiveringLight_Focus_Creativity_Grooves_30_100BPM_HighNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27584741,
      "sha256": "c59f9f3ad2511056bb121faad72030ad843b58660f5c5a75ae4a8460ff99e90f",
      "download_error": null
    },
    {
      "track_id": "68505d28f6a8ec8278221b21",
      "name": "Water Memory",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.77,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/WaterMemory_Focus_Creativity_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=KoGZQV0a4VPTTG3NrvQcGTSX7owjkd9ecpkfjODbpmA%3D",
      "cdn_url": "https://audio2.brain.fm/WaterMemory_Focus_Creativity_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WaterMemory_Focus_Creativity_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WaterMemory_Focus_Creativity_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/WaterMemory_Focus_Creativity_Grooves_30_105BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28029652,
      "sha256": "31c5b442587b90eeac9ea129d9d4ccdab127ee0103c13b5155227d8bc71587cd",
      "download_error": null
    },
    {
      "track_id": "683dc8bddd2246ed9c7c8661",
      "name": "On the Return",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.43,
      "complexity_level": 1.06,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/OnTheReturn_Focus_Deep%20Work_Grooves_30_114bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=07YfYk7OX9CQ1nwe1HGcC32eATJ10QbR4SVFsI18etU%3D",
      "cdn_url": "https://audio2.brain.fm/OnTheReturn_Focus_Deep%20Work_Grooves_30_114bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OnTheReturn_Focus_Deep Work_Grooves_30_114bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OnTheReturn_Focus_Deep-Work_Grooves_30_114bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/OnTheReturn_Focus_Deep-Work_Grooves_30_114bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29394238,
      "sha256": "aa33119e13b5397110f075948905de5d193d9cac5e42fdbc8c0958ce23dc336a",
      "download_error": null
    },
    {
      "track_id": "683dc895dd2246ed9c7c85d3",
      "name": "Kukicha",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.61,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.78,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Kukicha_Focus_DeepWork_Grooves_30_115BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=RJCSGEufvSEl1bwqLpQNf7SJsPX7Axg9zpnCTSwMoH0%3D",
      "cdn_url": "https://audio2.brain.fm/Kukicha_Focus_DeepWork_Grooves_30_115BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Kukicha_Focus_DeepWork_Grooves_30_115BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Kukicha_Focus_DeepWork_Grooves_30_115BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Kukicha_Focus_DeepWork_Grooves_30_115BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30266590,
      "sha256": "efbf47047c1706f5fb68732d892a17148402289d40b0bd4eeee4abb77630c1ac",
      "download_error": null
    },
    {
      "track_id": "682b56e08ab5a645af484219",
      "name": "Antibes",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 132,
      "brightness_level": 0.59,
      "complexity_level": 0.33,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Antibes_Focus_Creativity_Grooves_30_132BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=zNdf1IXHnTVhHRdMQ6LaiiLzTxu2DrPeVyPulmBA%2B1g%3D",
      "cdn_url": "https://audio2.brain.fm/Antibes_Focus_Creativity_Grooves_30_132BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Antibes_Focus_Creativity_Grooves_30_132BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Antibes_Focus_Creativity_Grooves_30_132BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Antibes_Focus_Creativity_Grooves_30_132BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28462904,
      "sha256": "21d212f1e2d7751c6d477bb5dcf319e86c0c58fcf80b37e1ba42d0534f367e1e",
      "download_error": null
    },
    {
      "track_id": "682b566bd2f1d1682decf848",
      "name": "Solar Return",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.75,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SolarReturn_Focus_Creativity_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=mNe8aWNqfYc93tE6Ulo0N5m244Qk8VcJODcQa5lIR3g%3D",
      "cdn_url": "https://audio2.brain.fm/SolarReturn_Focus_Creativity_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SolarReturn_Focus_Creativity_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SolarReturn_Focus_Creativity_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SolarReturn_Focus_Creativity_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29758411,
      "sha256": "2a57c6723b75149e776d663c1ae61cd3468c11c68941692412a4d86482582bf4",
      "download_error": null
    },
    {
      "track_id": "682b56448ab5a645af48400e",
      "name": "Blunders",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 70,
      "brightness_level": 0.68,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Blunders_Focus_Learning_Grooves_30_70BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=IXuv6UruAABUvQWeCR4JQ2kbHOGQvZdB%2Fiyk%2F7lFj%2Fw%3D",
      "cdn_url": "https://audio2.brain.fm/Blunders_Focus_Learning_Grooves_30_70BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Blunders_Focus_Learning_Grooves_30_70BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Blunders_Focus_Learning_Grooves_30_70BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Blunders_Focus_Learning_Grooves_30_70BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27912496,
      "sha256": "f7e0a2a40c15d43e008a249b2f27d27a67b32a691336b88692fe12a53477dcda",
      "download_error": null
    },
    {
      "track_id": "682b5580d2f1d1682decf539",
      "name": "Gatherings",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.9,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Gatherings_Focus_Creativity_Grooves_30_115BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=kMDGBdoewjmgkVS7oWN7oX0N4l8Mmchn%2FqXoEPVLDro%3D",
      "cdn_url": "https://audio2.brain.fm/Gatherings_Focus_Creativity_Grooves_30_115BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Gatherings_Focus_Creativity_Grooves_30_115BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Gatherings_Focus_Creativity_Grooves_30_115BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Gatherings_Focus_Creativity_Grooves_30_115BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30373794,
      "sha256": "1f7ecaf6bf30f021a0fc3471721b0128df242e41339e57026721d77e57882004",
      "download_error": null
    },
    {
      "track_id": "6818d1dac7fc795ec060efc6",
      "name": "Raising Stakes",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.54,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/RaisingStakes_Focus_DeepWork_Grooves_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Jto6EJVsyWYNjx%2BXSJFwMru45xbnYv71EjnEPeu0AQY%3D",
      "cdn_url": "https://audio2.brain.fm/RaisingStakes_Focus_DeepWork_Grooves_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RaisingStakes_Focus_DeepWork_Grooves_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RaisingStakes_Focus_DeepWork_Grooves_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/RaisingStakes_Focus_DeepWork_Grooves_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30955035,
      "sha256": "85aee093ea8a3a439cdeac7257bbde45400ae56b3e2fd42756324adb5c352e50",
      "download_error": null
    },
    {
      "track_id": "68065ac1303af13618e35150",
      "name": "In Step",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.81,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/InStep_Focus_Learning_Grooves_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=6K1oty6U%2FwN3%2BYL7wn9AGeOhUJWCrMq7OFTeg9XcD4Y%3D",
      "cdn_url": "https://audio2.brain.fm/InStep_Focus_Learning_Grooves_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InStep_Focus_Learning_Grooves_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InStep_Focus_Learning_Grooves_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/InStep_Focus_Learning_Grooves_30_130BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32432224,
      "sha256": "31d21a9dd31de183edc721ed4f5206afd104a3e18b3c5f0892d04a45f3a0f286",
      "download_error": null
    },
    {
      "track_id": "67f3ebd6a0de2348f748e83b",
      "name": "Messengers",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 70,
      "brightness_level": 0.84,
      "complexity_level": 0.85,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Messengers_Focus_DeepWork_Grooves_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=lXDLQWCSXdvqRngjjv8IEKhA%2B%2FAcwfop6O0Cp2mGurU%3D",
      "cdn_url": "https://audio2.brain.fm/Messengers_Focus_DeepWork_Grooves_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Messengers_Focus_DeepWork_Grooves_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Messengers_Focus_DeepWork_Grooves_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Messengers_Focus_DeepWork_Grooves_30_70BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30315698,
      "sha256": "74d5efab5928f425f8229460f8b868a45e5e1ff0d6458165d01fded237537d73",
      "download_error": null
    },
    {
      "track_id": "67f3eba2a0de2348f748e6c3",
      "name": "Skip Nouveau",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.92,
      "complexity_level": 0.97,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/SkipNouveau_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=J2%2BOO1GW6cC4OWBS3Idhq0KEdAHmtNxZCOlpdzSzWtA%3D",
      "cdn_url": "https://audio2.brain.fm/SkipNouveau_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SkipNouveau_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SkipNouveau_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/SkipNouveau_Focus_DeepWork_Grooves_30_96BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32400768,
      "sha256": "05d8393c873de646ef6f69b01edb741c0ee6817989111a43e59e877f5da1acd7",
      "download_error": null
    },
    {
      "track_id": "67e17e2c5177e5bfbd17f9c1",
      "name": "Botanic Rhythm",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.87,
      "complexity_level": 0.6,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/BotanicRhythm_Focus_DeepWork_Grooves_30_94BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=mn7HpFDSFo0zpD%2FlxyncPGy0cIe8dQ%2Bx0Li9PuIMGZM%3D",
      "cdn_url": "https://audio2.brain.fm/BotanicRhythm_Focus_DeepWork_Grooves_30_94BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BotanicRhythm_Focus_DeepWork_Grooves_30_94BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BotanicRhythm_Focus_DeepWork_Grooves_30_94BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/BotanicRhythm_Focus_DeepWork_Grooves_30_94BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31897610,
      "sha256": "e13c13af33fc1c632f9c87fd0186eb1d1a16f6c476259b4fb6ad6ea626f3fb48",
      "download_error": null
    },
    {
      "track_id": "67cf055b593aad5348b96663",
      "name": "Autofocus",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 1,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Autofocus_Focus_Learning_Grooves_30_120BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=itUAfEmlUlQR%2F1jNPKMeVbjt8oJkOOZwtBjx%2Bdxb1NU%3D",
      "cdn_url": "https://audio2.brain.fm/Autofocus_Focus_Learning_Grooves_30_120BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Autofocus_Focus_Learning_Grooves_30_120BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Autofocus_Focus_Learning_Grooves_30_120BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Autofocus_Focus_Learning_Grooves_30_120BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32281603,
      "sha256": "fbbd1960cb48682cb7122cb842d17aae3952d2df237bd86475233eaeddd8c3fe",
      "download_error": null
    },
    {
      "track_id": "67aa5b8b55e93dd343692330",
      "name": "The Walk",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 79,
      "brightness_level": 0.71,
      "complexity_level": 0.95,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/TheWalk_Focus_Learning_Grooves_30_79BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=DmxTbMgnTlmPXXZt%2BWg4kIY4ZgoqP1dHAAk4GG2UyyM%3D",
      "cdn_url": "https://audio2.brain.fm/TheWalk_Focus_Learning_Grooves_30_79BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheWalk_Focus_Learning_Grooves_30_79BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheWalk_Focus_Learning_Grooves_30_79BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/TheWalk_Focus_Learning_Grooves_30_79BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31827024,
      "sha256": "2760846c60d20f3ede4e8786144e36bfac1b91e4cf5b8ff9fd7c4132142c9d49",
      "download_error": null
    },
    {
      "track_id": "67a10fa403677edafb63f607",
      "name": "Clean Sweep",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.6,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/CleanSweep_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Zwm1EtvzLd6WFNXwHfzKLOPEcRE2sYMBZQ0aIFVrm54%3D",
      "cdn_url": "https://audio2.brain.fm/CleanSweep_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CleanSweep_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CleanSweep_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/CleanSweep_Focus_DeepWork_Grooves_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30009384,
      "sha256": "5a70d08af36363e6b6fa0126c0d26b47d93a2e04d4f344896deb0796befe1cd2",
      "download_error": null
    },
    {
      "track_id": "67855b33f76968728486ab89",
      "name": "High Simmer",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.95,
      "complexity_level": 1,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/HighSimmer_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=q3CR7M4X0Xjgiz4AIDREGYsysk%2F70qKs%2F44ohn3FxRw%3D",
      "cdn_url": "https://audio2.brain.fm/HighSimmer_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HighSimmer_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HighSimmer_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/HighSimmer_Focus_Creativity_Grooves_30_130BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 33399264,
      "sha256": "cc713e3c6de2eaccb04300fb450b847e9e02533957fd22238975910541840d3f",
      "download_error": null
    },
    {
      "track_id": "6773002c0c139ab77519e7ac",
      "name": "Beach Hammock",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.97,
      "complexity_level": 0.87,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/BeachHammock_Focus_DeepWork_Grooves_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=opdDEaAEQyYx1ZERnPRsJtN53vCt4cV6r1czJe7jpHs%3D",
      "cdn_url": "https://audio2.brain.fm/BeachHammock_Focus_DeepWork_Grooves_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BeachHammock_Focus_DeepWork_Grooves_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BeachHammock_Focus_DeepWork_Grooves_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/BeachHammock_Focus_DeepWork_Grooves_30_92bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31058952,
      "sha256": "865e38479f0e80cb394336b700363641457c24ea975176726ebee1a2818fbf5c",
      "download_error": null
    },
    {
      "track_id": "67603f4ab9509f31638d20c3",
      "name": "Groove Machine",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.84,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Groove%20Machine_Focus_Creativity_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=Nu%2BVBv9dOnJlURNmoxnCmsKDuGEoIF9%2FTr1%2FQZzoG6k%3D",
      "cdn_url": "https://audio2.brain.fm/Groove%20Machine_Focus_Creativity_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Groove Machine_Focus_Creativity_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Groove-Machine_Focus_Creativity_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Groove-Machine_Focus_Creativity_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30696151,
      "sha256": "0923583256237bfa14d25faf469a3276d8583917b41cbcf838cb43c6706e063a",
      "download_error": null
    },
    {
      "track_id": "67603f3dd01940844b3b447a",
      "name": "Digitized Funk",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.75,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Digitized%20Funk_Focus_Creativity_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=8nS7GDME7PWKumODzUPMREi7pyC8gjsjE6ZaJFimZJk%3D",
      "cdn_url": "https://audio2.brain.fm/Digitized%20Funk_Focus_Creativity_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Digitized Funk_Focus_Creativity_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Digitized-Funk_Focus_Creativity_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Digitized-Funk_Focus_Creativity_Grooves_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29981554,
      "sha256": "9cdf4d8f10bf94cb024303bcc453cbcf4c423ca0a14eac94ac53c2978a7ce745",
      "download_error": null
    },
    {
      "track_id": "67603f314e4445c8c4dba372",
      "name": "Iconic",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.62,
      "complexity_level": 0.93,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Iconic_Focus_Creativity_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=aX7g0K%2FXSMd9u3fdiZTabt68RLYuXAo7iAEHmjfO3kM%3D",
      "cdn_url": "https://audio2.brain.fm/Iconic_Focus_Creativity_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Iconic_Focus_Creativity_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Iconic_Focus_Creativity_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Iconic_Focus_Creativity_Grooves_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30287707,
      "sha256": "999cdc7f3371b9b0c850d1ed6af3e6c8a97cc97672ea17014909127087a9aae6",
      "download_error": null
    },
    {
      "track_id": "674de021657c71542c999a6c",
      "name": "Renegade Solution",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.95,
      "complexity_level": 0.92,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/RenegadeSolution_Focus_DeepWork_Grooves_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=fEH2ZToxM05nCO6ifMSvobDF%2BqJoi26jSrsPKypZQzM%3D",
      "cdn_url": "https://audio2.brain.fm/RenegadeSolution_Focus_DeepWork_Grooves_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RenegadeSolution_Focus_DeepWork_Grooves_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RenegadeSolution_Focus_DeepWork_Grooves_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/RenegadeSolution_Focus_DeepWork_Grooves_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32776056,
      "sha256": "57382beb433ade926c6b6f27767ce2e79d7a6e35911e87b50bf298bf9d5e7c39",
      "download_error": null
    },
    {
      "track_id": "674ddff6657c71542c999954",
      "name": "Celebrations",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.87,
      "complexity_level": 0.99,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Celebrations_Focus_DeepWork_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=7gAgG0Hs8LoVJb42du8yT1FdmMhaWpvTk0R5nqZYZRA%3D",
      "cdn_url": "https://audio2.brain.fm/Celebrations_Focus_DeepWork_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Celebrations_Focus_DeepWork_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Celebrations_Focus_DeepWork_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Celebrations_Focus_DeepWork_Grooves_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31305504,
      "sha256": "7c2d29ae4e3c44375513e3fc3ae08d49668cd54b65cdb84ed5830216bf71dee0",
      "download_error": null
    },
    {
      "track_id": "674ddf575dec417226950a1b",
      "name": "Oranges and Cream",
      "category": "Grooves",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.68,
      "complexity_level": 0.93,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/grooves.json",
      "source_url": "https://audio2.brain.fm/Oranges%20and%20Cream%20Grooves%20Focus%20Study%20Conor%2090bpm_Nrmlzd2_VBR5.mp3?expiration=1792292134248&token=%2F5zike%2BbePbx%2FvcwKUkn0cpVS%2FOLyVU5T3Wi%2B1xLs6Y%3D",
      "cdn_url": "https://audio2.brain.fm/Oranges%20and%20Cream%20Grooves%20Focus%20Study%20Conor%2090bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Oranges and Cream Grooves Focus Study Conor 90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Oranges-and-Cream-Grooves-Focus-Study-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/grooves/Oranges-and-Cream-Grooves-Focus-Study-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29740462,
      "sha256": "49581a0f6665c3ecafa2c5bc7b798c43d57e6a8b8251bdaf7a61e3c073eb2817",
      "download_error": null
    },
    {
      "track_id": "6a54f6536ff4d002625025c7",
      "name": "4 Track Mind",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.35,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.61,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/4TrackMind_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=tRD8R9ws9ejMljxHOrZ8m4z4bG%2BhfAXVU3xrdFkl8KA%3D",
      "cdn_url": "https://audio2.brain.fm/4TrackMind_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "4TrackMind_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "4TrackMind_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/4TrackMind_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27265896,
      "sha256": "fdad102ff5df0b280311a50c9919366ae1ccfb96e929dccad2ece8fb182cd001",
      "download_error": null
    },
    {
      "track_id": "6a54f61a6ff4d00262502495",
      "name": "Bifocals",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.42,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Bifocals_Focus_Learning_Lofi_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=STO2xjDikavvGmvLHP%2F%2FjR9Z1idWAZTtiKVDpBWXOrk%3D",
      "cdn_url": "https://audio2.brain.fm/Bifocals_Focus_Learning_Lofi_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bifocals_Focus_Learning_Lofi_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Bifocals_Focus_Learning_Lofi_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Bifocals_Focus_Learning_Lofi_30_88BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25827204,
      "sha256": "f09e5ba697d315b61bb684b9efe38bdd83db5ceb3c6713081b89c61eb549cd4b",
      "download_error": null
    },
    {
      "track_id": "6a4bb68d4518fc4e1e40605f",
      "name": "Shabondama",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.46,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Shabondama_Focus_DeepWork_Lofi_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=gPzQBQYUtWpclJdVi32dVpDKZYot%2F%2FDjmPoewTMx1DU%3D",
      "cdn_url": "https://audio2.brain.fm/Shabondama_Focus_DeepWork_Lofi_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Shabondama_Focus_DeepWork_Lofi_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Shabondama_Focus_DeepWork_Lofi_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Shabondama_Focus_DeepWork_Lofi_30_95BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28008888,
      "sha256": "a85713e23d8dace2a59c5bba48fd8c4d35685b59eb06a06999b3e820cb70b20d",
      "download_error": null
    },
    {
      "track_id": "6a4bb66b4518fc4e1e405f63",
      "name": "Unmetered Metrics",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 74,
      "brightness_level": 0.42,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/UnmeteredMetrics_Focus_DeepWork_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=QcEQ8EVPtuFLN0NsGAq6CRTNzKVTOGJxSqqgpu%2B3K%2Fw%3D",
      "cdn_url": "https://audio2.brain.fm/UnmeteredMetrics_Focus_DeepWork_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnmeteredMetrics_Focus_DeepWork_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnmeteredMetrics_Focus_DeepWork_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/UnmeteredMetrics_Focus_DeepWork_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28824892,
      "sha256": "cf45f77a531a85fcdf2da03913659292dbba0b13cf6419e9c4e99e3adabd4166",
      "download_error": null
    },
    {
      "track_id": "6a42821978a0a113b2ff3ff9",
      "name": "My Tribe",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.61,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/MyTribe_Focus_DeepWork_LoFi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=kQfKazpS%2FSvc%2Fy4XAvYw4F5ERw%2BGSHXe5L6TQZNwdsY%3D",
      "cdn_url": "https://audio2.brain.fm/MyTribe_Focus_DeepWork_LoFi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MyTribe_Focus_DeepWork_LoFi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MyTribe_Focus_DeepWork_LoFi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/MyTribe_Focus_DeepWork_LoFi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28305045,
      "sha256": "70db85abefdc02ac9d4c4c5e8ff4afa3b77621b1010d85404d94637d247a8c0c",
      "download_error": null
    },
    {
      "track_id": "6a4281d578a0a113b2ff3dda",
      "name": "Street Food",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.36,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/StreetFood_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=08I%2BCxpYn680t06G44ieW1T719spHF8W%2FMBw5xgy5Ts%3D",
      "cdn_url": "https://audio2.brain.fm/StreetFood_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StreetFood_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StreetFood_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/StreetFood_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28571952,
      "sha256": "680e7d4afe8d903f900f8ed40d79155cd139e6ce02b8c35ce239f52262ccded9",
      "download_error": null
    },
    {
      "track_id": "6a42819c78a0a113b2ff3bff",
      "name": "Vibrecho",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.49,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Vibrecho_Focus_Creativity_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=u2CUgFD3qPnkHtTnA0dTcmpViJEu9yfaOJ47nzdP7C4%3D",
      "cdn_url": "https://audio2.brain.fm/Vibrecho_Focus_Creativity_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Vibrecho_Focus_Creativity_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Vibrecho_Focus_Creativity_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Vibrecho_Focus_Creativity_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28986503,
      "sha256": "73d095def0d9693aeb6c5c46ec664eb2d8d27191131ed4f0270ae33aedb6469e",
      "download_error": null
    },
    {
      "track_id": "6a3017be7a8f5056573c92d1",
      "name": "Emptied and Muted",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.43,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.61,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/EmptiedAndMuted_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=Q2nUcrSuHo6A00RK%2BEJ1RnG9aRwYkzfdMCw1Hef%2FCt0%3D",
      "cdn_url": "https://audio2.brain.fm/EmptiedAndMuted_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EmptiedAndMuted_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EmptiedAndMuted_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/EmptiedAndMuted_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28794262,
      "sha256": "711a75d1e57dc7aeb63cd353672abfb60e7fe94f33d3d28d51c66005bc8e75fc",
      "download_error": null
    },
    {
      "track_id": "6a1dcb78b7f8597b461241ca",
      "name": "Creaks",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 78,
      "brightness_level": 0.46,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Creaks_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=T9eZFMyp6Mz7HLMnB3oWNhMvoJhcjxJAqX4aKU6BIeo%3D",
      "cdn_url": "https://audio2.brain.fm/Creaks_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Creaks_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Creaks_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Creaks_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28000650,
      "sha256": "c37012ab230fd40cf7c9cf73604161cd2c4523ebaf80a5139921db0572d10094",
      "download_error": null
    },
    {
      "track_id": "6a1dcb2ab7f8597b46123ee2",
      "name": "Refresher",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.48,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.89,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Refresher_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=udk69Nu1iLaY2T4qmQIuYsn8JKymi9MHBteD40rPByU%3D",
      "cdn_url": "https://audio2.brain.fm/Refresher_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Refresher_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Refresher_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Refresher_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29267064,
      "sha256": "7ac1e6e980943ca7455c3b92c078e1d0725f162296715da2eca2b6e561f87ce2",
      "download_error": null
    },
    {
      "track_id": "6a1dcb1bb7f8597b46123e60",
      "name": "Symbiote",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.22,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Symbiote_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=tqiO21F9gxNn50YqQYjPDzsUfxosPRIl4KCv4D48sfw%3D",
      "cdn_url": "https://audio2.brain.fm/Symbiote_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Symbiote_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Symbiote_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Symbiote_Focus_Learning_Lofi_30_94BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27919325,
      "sha256": "35bcefdd3f2b11ac393f843e6035b40255bd51e1ca44a06193c43068c73f0f9e",
      "download_error": null
    },
    {
      "track_id": "6a0b8bf5e6017bccd74b855b",
      "name": "Only Scribbles",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.46,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/OnlyScribbles_Focus_Creativity_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=l3Qg6IjB4vuYqqzEbFzIcZLdtrt8A6rvuqA5hMbUK9E%3D",
      "cdn_url": "https://audio2.brain.fm/OnlyScribbles_Focus_Creativity_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OnlyScribbles_Focus_Creativity_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OnlyScribbles_Focus_Creativity_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/OnlyScribbles_Focus_Creativity_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28355863,
      "sha256": "5740fd5c26a95e4f8f5a323bbd92017c568465e56313660812852a2e0133aec6",
      "download_error": null
    },
    {
      "track_id": "6a0b8bb3e6017bccd74b8216",
      "name": "Likely Friendship",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.75,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/LikelyFriendship_Focus_DeepWork_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=uxVjKqiMEgmT2mPS9P%2FfZvz71YxFY787WU%2F%2F2p4yvJw%3D",
      "cdn_url": "https://audio2.brain.fm/LikelyFriendship_Focus_DeepWork_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LikelyFriendship_Focus_DeepWork_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LikelyFriendship_Focus_DeepWork_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/LikelyFriendship_Focus_DeepWork_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29436192,
      "sha256": "60e9aa99bd959829958aa1351544a2e0591c9e0032eec4127ccb2c193e8648f8",
      "download_error": null
    },
    {
      "track_id": "6a0b8b31e6017bccd74b7bfe",
      "name": "Refueling",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.58,
      "complexity_level": 0.35,
      "style": "normal",
      "neural_effect_level": 0.21,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Refueling_Focus_Learning_Lofi_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=e5SVrPL%2Fq0QuFg84jrC8g3JkiVB3KG%2BQu9mz2L5gVek%3D",
      "cdn_url": "https://audio2.brain.fm/Refueling_Focus_Learning_Lofi_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Refueling_Focus_Learning_Lofi_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Refueling_Focus_Learning_Lofi_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Refueling_Focus_Learning_Lofi_30_87BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29081712,
      "sha256": "a434dd24eab1ae47c071773a02a8557494083c0795e70195ec1e905506f4cddd",
      "download_error": null
    },
    {
      "track_id": "69f8b9311c706aff1baf123c",
      "name": "Below The Lily Pads",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.29,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/BelowTheLilyPads_Focus_DeepWork_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=TvsOEaHeVmO6k6jWOyOOEJFkI4vCuPzAxGfay6IhJZ4%3D",
      "cdn_url": "https://audio2.brain.fm/BelowTheLilyPads_Focus_DeepWork_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BelowTheLilyPads_Focus_DeepWork_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BelowTheLilyPads_Focus_DeepWork_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/BelowTheLilyPads_Focus_DeepWork_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28042488,
      "sha256": "a1941ccf2664c60b6c36addbb29a23561ea147c1ffded6668e222d89197f688d",
      "download_error": null
    },
    {
      "track_id": "69f8b8e41c706aff1baf0eb3",
      "name": "Demonstrative Poise",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.49,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/DemonstrativePoise_Focus_Deepwork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=Xzu4yTMgbRKXxS3LY%2BeuAriyrlZoqsVrjwW6ERqEimw%3D",
      "cdn_url": "https://audio2.brain.fm/DemonstrativePoise_Focus_Deepwork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DemonstrativePoise_Focus_Deepwork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DemonstrativePoise_Focus_Deepwork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/DemonstrativePoise_Focus_Deepwork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28829151,
      "sha256": "62baf4266fb5be310c308e608557792433db53b28baa7c0f208c05443fb8d433",
      "download_error": null
    },
    {
      "track_id": "69f8b8541c706aff1baf0952",
      "name": "Distillation",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 97,
      "brightness_level": 0.41,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Distillation_Focus_Learning_Lofi_30_97BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=y3qGBtjdYvWH%2FG2%2FZbUBhOtxP%2FTn2pVSkX9bFWXcH3A%3D",
      "cdn_url": "https://audio2.brain.fm/Distillation_Focus_Learning_Lofi_30_97BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Distillation_Focus_Learning_Lofi_30_97BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Distillation_Focus_Learning_Lofi_30_97BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Distillation_Focus_Learning_Lofi_30_97BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28008072,
      "sha256": "bb72604f4b8bd6fe8bafe5929acdf9ddcb88180c4a31ffcab9c21c11a010f195",
      "download_error": null
    },
    {
      "track_id": "69e68947dce2120639c70208",
      "name": "Soft Walk",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.36,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.83,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/SoftWalk_Focus_DeepWork_LoFi_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=FRnfj3dvTq3TXewZrtbBAnPTRN3mFvOVu2iU0PvrEMM%3D",
      "cdn_url": "https://audio2.brain.fm/SoftWalk_Focus_DeepWork_LoFi_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SoftWalk_Focus_DeepWork_LoFi_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SoftWalk_Focus_DeepWork_LoFi_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/SoftWalk_Focus_DeepWork_LoFi_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28253778,
      "sha256": "995ca8b570656d97b8c861f8b79f60a6f763c330fec948a1eb7046616c2e5fc5",
      "download_error": null
    },
    {
      "track_id": "69e68630dce2120639c6ea5b",
      "name": "Nightlights",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 74,
      "brightness_level": 0.32,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Nightlights_Focus_DeepWork_LoFi_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=muH1%2BrA00yaD2awf%2BzRrdsbFx7WK1rKUQyxBQC1sEr4%3D",
      "cdn_url": "https://audio2.brain.fm/Nightlights_Focus_DeepWork_LoFi_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Nightlights_Focus_DeepWork_LoFi_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Nightlights_Focus_DeepWork_LoFi_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Nightlights_Focus_DeepWork_LoFi_30_74bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26665068,
      "sha256": "7865724e7369571288822245d10312fc1bfbca0bd265daec58d74575e149ceae",
      "download_error": null
    },
    {
      "track_id": "69e6861ddce2120639c6e996",
      "name": "Who Knows Me Like You",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.58,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/WhoKnowsMeLikeYou_Focus_Creativity_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=cGc9Mrt4A2cPKNUzZTyruJ%2Bqh9iQXs3W3G9Tc%2BvxZzc%3D",
      "cdn_url": "https://audio2.brain.fm/WhoKnowsMeLikeYou_Focus_Creativity_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WhoKnowsMeLikeYou_Focus_Creativity_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WhoKnowsMeLikeYou_Focus_Creativity_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/WhoKnowsMeLikeYou_Focus_Creativity_Lofi_30_82BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32510746,
      "sha256": "88ff57c152d3af774eb398a0673219274a38b49ebeaa8296634dfffd852e0b0c",
      "download_error": null
    },
    {
      "track_id": "69d028059b9914998a32dac5",
      "name": "Unbound",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.46,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.87,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Unbound_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=12NuT3BKRaE8%2BzaXu8YiFG1ulJKZ7pZ7qGWrNRLQahk%3D",
      "cdn_url": "https://audio2.brain.fm/Unbound_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unbound_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unbound_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Unbound_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29022864,
      "sha256": "f3389f4e66c3d203b21de955d4fefc069b079967d3731d54960adb4ed5bce204",
      "download_error": null
    },
    {
      "track_id": "69d026dd9b9914998a32d14f",
      "name": "Dialing In",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.61,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Dialingin_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=BWQNqGEiiUjwv0%2BOGDtKjrHX9BhfPUnYaIndcsgGfGo%3D",
      "cdn_url": "https://audio2.brain.fm/Dialingin_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dialingin_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dialingin_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Dialingin_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29201887,
      "sha256": "0a57617b9a5ccb8767ba6d4e00343330061f44a0daa3b68767c2ab47223422c8",
      "download_error": null
    },
    {
      "track_id": "69c2bd731b6ecfe6c4a72895",
      "name": "If It Moves You",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.42,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/IfItMovesYou_Focus_DeepWork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=JJHuDRVFaRornQmGkuceR%2Btk6j5gEikaPBTyeq%2BzXZA%3D",
      "cdn_url": "https://audio2.brain.fm/IfItMovesYou_Focus_DeepWork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "IfItMovesYou_Focus_DeepWork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "IfItMovesYou_Focus_DeepWork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/IfItMovesYou_Focus_DeepWork_Lofi_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28950552,
      "sha256": "305b4f65dc384cb557d350f9d08ef4fd03b0a3a626c30b7ff0596aac94848408",
      "download_error": null
    },
    {
      "track_id": "69c2bcc01b6ecfe6c4a721ed",
      "name": "Umbrella",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 62,
      "brightness_level": 0.48,
      "complexity_level": 0.41,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Umbrella_Focus_Learning_LoFi_30_62bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=GXqYQzEiwZckq8%2BLPIPLca5OtLkt7B813XA8zmm7GCo%3D",
      "cdn_url": "https://audio2.brain.fm/Umbrella_Focus_Learning_LoFi_30_62bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Umbrella_Focus_Learning_LoFi_30_62bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Umbrella_Focus_Learning_LoFi_30_62bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Umbrella_Focus_Learning_LoFi_30_62bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27251281,
      "sha256": "6c7c9f1e7589992a709a3808b18dd97da0186642dbbd353c9de784e9f3138407",
      "download_error": null
    },
    {
      "track_id": "69c2bb7e1b6ecfe6c4a7171a",
      "name": "Crafty Controller",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.33,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/CraftyController_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=a3ZSUQpKuxDYn8hXd4I%2BdvLA%2FNT7aT9ZPxn%2B%2FamiRhg%3D",
      "cdn_url": "https://audio2.brain.fm/CraftyController_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CraftyController_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CraftyController_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/CraftyController_Focus_DeepWork_LoFi_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26916167,
      "sha256": "5c7c4b51c158023d21c34aa4616317d818366d94b4b3ce14f1bcaf61effeea10",
      "download_error": null
    },
    {
      "track_id": "69aee2a273bfe2099d517a68",
      "name": "Destination",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.48,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Destination_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=Vj%2Bsykfy3Ddj%2BaDQk8jfTq0n8Wjv6quIeqz4g1tR3hM%3D",
      "cdn_url": "https://audio2.brain.fm/Destination_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Destination_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Destination_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Destination_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28389369,
      "sha256": "af22c6402f50d711ffdd6b491d564772fa6028d0f36f7ee06901add5797982c5",
      "download_error": null
    },
    {
      "track_id": "69aee17a73bfe2099d5172c4",
      "name": "Spraypaint Logo",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 78,
      "brightness_level": 0.54,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/SpraypaintLogo_Focus_Creativity_LoFi_30_78bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=KEEvaVgOlD7EGPETcKoqUbz%2FPi%2BjWui9NE%2FlT4M2s1Y%3D",
      "cdn_url": "https://audio2.brain.fm/SpraypaintLogo_Focus_Creativity_LoFi_30_78bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SpraypaintLogo_Focus_Creativity_LoFi_30_78bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SpraypaintLogo_Focus_Creativity_LoFi_30_78bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/SpraypaintLogo_Focus_Creativity_LoFi_30_78bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29673233,
      "sha256": "ffeed853e6a62224df9858738cff96360aa8eac619e6d879a991555c4b06f163",
      "download_error": null
    },
    {
      "track_id": "69aee0d273bfe2099d516eb9",
      "name": "Heritage",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 83,
      "brightness_level": 0.32,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Heritage_Focus_Learning_LoFi_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=XrSuZ8SgGrvzQ96acmAfcAZA%2F4vA%2BS6nrvXlIGdcdYc%3D",
      "cdn_url": "https://audio2.brain.fm/Heritage_Focus_Learning_LoFi_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Heritage_Focus_Learning_LoFi_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Heritage_Focus_Learning_LoFi_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Heritage_Focus_Learning_LoFi_30_83bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27801001,
      "sha256": "41704bae8c19790afd3ce26e851d11ce93a89c9b96dbadf1859ae8b294032b7b",
      "download_error": null
    },
    {
      "track_id": "699cafa19033fe9e7ccfba7c",
      "name": "Shugendo",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.39,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Shugendo_Focus_DeepWork_LoFi_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=u%2BhSEsfTI%2B6Zc8MtDr1VFkHl5KrcSg5vdZq4q6AOOl0%3D",
      "cdn_url": "https://audio2.brain.fm/Shugendo_Focus_DeepWork_LoFi_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Shugendo_Focus_DeepWork_LoFi_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Shugendo_Focus_DeepWork_LoFi_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Shugendo_Focus_DeepWork_LoFi_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26890914,
      "sha256": "25d3f2c4cd70a52cbbef072396958f0754717e6aae14b8ad5b350cdf0cfbdb63",
      "download_error": null
    },
    {
      "track_id": "699caf3b9033fe9e7ccfb6ee",
      "name": "Low Heat",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.32,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/LowHeat_Focus_Learning_Lofi_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=7yrIwg%2FKfL68zeTEJeF%2BWbx%2BFiL8iQtQtwf5a04Gsos%3D",
      "cdn_url": "https://audio2.brain.fm/LowHeat_Focus_Learning_Lofi_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LowHeat_Focus_Learning_Lofi_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LowHeat_Focus_Learning_Lofi_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/LowHeat_Focus_Learning_Lofi_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26158001,
      "sha256": "5c2ea7efbd032651a0cfe91e4b89c95307173fbfbb34546084d6ad82add753c4",
      "download_error": null
    },
    {
      "track_id": "699cabc89033fe9e7ccf998d",
      "name": "A Healthy Skeptic",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.52,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/A_Healthy_Skeptic_Focus_Learning_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=lVrZBP%2FUoMfEpfnovm4ah%2FkUgCcPnp%2BfNqLfdBL3%2Fdc%3D",
      "cdn_url": "https://audio2.brain.fm/A_Healthy_Skeptic_Focus_Learning_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "A_Healthy_Skeptic_Focus_Learning_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "A_Healthy_Skeptic_Focus_Learning_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/A_Healthy_Skeptic_Focus_Learning_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29490295,
      "sha256": "5c871bb2c3bc50bd49d9d14d4d7c4e0bce1283b34610158afa2ba0bcebd69ce5",
      "download_error": null
    },
    {
      "track_id": "698a16228a4a8f35be583fea",
      "name": "Courtyard",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 64,
      "complexity_level": 14.5,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Courtyard_Focus_DeepWork_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=3Rin6x0yA%2FJZgZ6fD7oxVTOhHXdc7TFW%2BBPYoq5pWKI%3D",
      "cdn_url": "https://audio2.brain.fm/Courtyard_Focus_DeepWork_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Courtyard_Focus_DeepWork_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Courtyard_Focus_DeepWork_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Courtyard_Focus_DeepWork_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26906193,
      "sha256": "1aa313d0f704d770e5a1b1deac332fa922ede917f1356deaad1df8f9862b77b4",
      "download_error": null
    },
    {
      "track_id": "698a15808a4a8f35be58376a",
      "name": "Flower Food",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.54,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/FlowerFood_Focus_Learning_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=mzEFXHFrJHDDrKCKOY26TTurTcKRF7erRIWesJ9Uyis%3D",
      "cdn_url": "https://audio2.brain.fm/FlowerFood_Focus_Learning_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FlowerFood_Focus_Learning_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FlowerFood_Focus_Learning_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/FlowerFood_Focus_Learning_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27157237,
      "sha256": "5bb3700b20857bda9c2da239df111260a77c684bd6789eaea3db31796501c4a6",
      "download_error": null
    },
    {
      "track_id": "698a155f8a4a8f35be5835e9",
      "name": "Slowly Backwards",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/SlowlyBackwards_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=kvvP3QHkregLI9L0aAwQ3IngnEIUP1Jy%2F8EOA%2Bhjm8U%3D",
      "cdn_url": "https://audio2.brain.fm/SlowlyBackwards_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SlowlyBackwards_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SlowlyBackwards_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/SlowlyBackwards_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31112927,
      "sha256": "7c9327374a730966b591310ef60613470e52e72c885fc5554616c99cdb5d179a",
      "download_error": null
    },
    {
      "track_id": "6977c0af597917b51950796e",
      "name": "Moss Tone",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.45,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/MossTone_Focus_DeepWork_Lofi_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=%2FuoBuc%2F8pSVUE65E9Cxp8MAuSew4dWbwno1vbsmtgnU%3D",
      "cdn_url": "https://audio2.brain.fm/MossTone_Focus_DeepWork_Lofi_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MossTone_Focus_DeepWork_Lofi_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MossTone_Focus_DeepWork_Lofi_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/MossTone_Focus_DeepWork_Lofi_30_84BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28601546,
      "sha256": "d2c8bcc5c4b2d2075bbe214bc2803a1afbd45312900959e98258831fdd6463ed",
      "download_error": null
    },
    {
      "track_id": "6977c087236f65de4c7e5d63",
      "name": "Graceful Exit",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.33,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/GracefulExit_Focus_DeepWork_Lofi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=AxLq9%2BSHMXctYqyYH2rLvNqmBBlyerwzTH3%2FRjzeKWw%3D",
      "cdn_url": "https://audio2.brain.fm/GracefulExit_Focus_DeepWork_Lofi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GracefulExit_Focus_DeepWork_Lofi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GracefulExit_Focus_DeepWork_Lofi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/GracefulExit_Focus_DeepWork_Lofi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28611660,
      "sha256": "c55236a43e06ef10a348664fc4c1d2c6a0c3c70eee854a53a0daf2b9f50ba3a5",
      "download_error": null
    },
    {
      "track_id": "6977b5b4236f65de4c7e303b",
      "name": "Paw Prints",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.35,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/PawPrints_Focus_Creativity_Lofi_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=5NtOzFjAMHZYfhytySNDCSKXBfMOliMZ7jrKVHmrvRw%3D",
      "cdn_url": "https://audio2.brain.fm/PawPrints_Focus_Creativity_Lofi_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PawPrints_Focus_Creativity_Lofi_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PawPrints_Focus_Creativity_Lofi_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/PawPrints_Focus_Creativity_Lofi_30_98BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26958837,
      "sha256": "69c6db1aed3461e6b41765bf208dd25543e1d85b1f26f90241e72e2bf96f1e07",
      "download_error": null
    },
    {
      "track_id": "69655b9e8afa49f5711b953e",
      "name": "Thrifty",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.3,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Thrifty_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=Rwy4Au%2BHuKx1FeBP%2BSVPOvQKuVdkIPMaxGPj8kNuqbM%3D",
      "cdn_url": "https://audio2.brain.fm/Thrifty_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Thrifty_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Thrifty_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Thrifty_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25362750,
      "sha256": "8f5f63bc4345b2e6b8cf0192cd99f20c9eb03f5b4abee81772674432f9305118",
      "download_error": null
    },
    {
      "track_id": "69655b568afa49f5711b9406",
      "name": "In Stride",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/InStride_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=D6neDMKJmU3cVbkkqgOnaSJXnMsxXjrFJ8WY5sU1bl4%3D",
      "cdn_url": "https://audio2.brain.fm/InStride_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InStride_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InStride_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/InStride_Focus_DeepWork_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26999110,
      "sha256": "02644ce7a6408ee7ebccfbda103779251de9ddd2c9cb0dc65bf9f601bd256bcc",
      "download_error": null
    },
    {
      "track_id": "6952f3ffb1c39edafb0ded51",
      "name": "Regeneration",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.46,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Regeneration_Focus_Learning_Lofi_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=gjhiPTPLAhO2blLKsancIsxA24QcSJGOB2qx1T0Wc1M%3D",
      "cdn_url": "https://audio2.brain.fm/Regeneration_Focus_Learning_Lofi_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Regeneration_Focus_Learning_Lofi_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Regeneration_Focus_Learning_Lofi_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Regeneration_Focus_Learning_Lofi_30_110BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27556920,
      "sha256": "428ad02f234a4bc4c0c498556c9b4bf10009a7e23a979d1a28775b043318dac5",
      "download_error": null
    },
    {
      "track_id": "6952f324b1c39edafb0dea27",
      "name": "Studio Visit",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.46,
      "complexity_level": 0.35,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/StudioVisit_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=XNjDNFLUohOEk3c4QPlqCHZwv2MuuZct9uCvlxeNKZQ%3D",
      "cdn_url": "https://audio2.brain.fm/StudioVisit_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StudioVisit_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StudioVisit_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/StudioVisit_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30660820,
      "sha256": "011508fe95493e9706c2a2553abec5b42c735e08320c490898c4b0ea2eaab284",
      "download_error": null
    },
    {
      "track_id": "694059d076a1c1f80ff93a11",
      "name": "Simpleton",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.41,
      "complexity_level": 30,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Simpleton_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=WIWyqEEMZHpDHFExk246WUOFAPtk8%2BzI%2F%2Fmy2W%2FoN4g%3D",
      "cdn_url": "https://audio2.brain.fm/Simpleton_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Simpleton_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Simpleton_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Simpleton_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28238523,
      "sha256": "88de4b56c2ad54913926e4eb4b2c697e32445f13799c44d2d66cc66fd71267b8",
      "download_error": null
    },
    {
      "track_id": "692dbe0cb8f361da92eba058",
      "name": "Freshener",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Freshener_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=MsyqZfYOcK3YzbbDsqN6UK40%2BAxtbKwmaBWq1sbLhvE%3D",
      "cdn_url": "https://audio2.brain.fm/Freshener_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Freshener_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Freshener_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Freshener_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29550359,
      "sha256": "6438772bdbbe9a48f05db22351ddc476a38411e9b2884850dc0e02a0f79de64f",
      "download_error": null
    },
    {
      "track_id": "691b3d25a1c962ea641f0079",
      "name": "Gathering",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.42,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Gathering_Focus_Learning_Lofi_30_93BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=O3bSdhRhKDDj8WK5l580lAs%2BAhKBl1MAjmz2xuZykR0%3D",
      "cdn_url": "https://audio2.brain.fm/Gathering_Focus_Learning_Lofi_30_93BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Gathering_Focus_Learning_Lofi_30_93BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Gathering_Focus_Learning_Lofi_30_93BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Gathering_Focus_Learning_Lofi_30_93BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25881732,
      "sha256": "d0dd2c132d13f52f054f9d7314e3ab5a94f6f94439167acde474ef1160437cc9",
      "download_error": null
    },
    {
      "track_id": "691b3cb6331c372ce8748603",
      "name": "Empty Search",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 1.04,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.79,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/EmptySearch_Focus_Learning_LoFi_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=ckMNgKCq5I45WFaB8VGSZiexnS3cUfo3XbkvKcDUP84%3D",
      "cdn_url": "https://audio2.brain.fm/EmptySearch_Focus_Learning_LoFi_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EmptySearch_Focus_Learning_LoFi_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EmptySearch_Focus_Learning_LoFi_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/EmptySearch_Focus_Learning_LoFi_30_75bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27484207,
      "sha256": "b234412fc7cfe1e4301a775e6047d301732e1ec4ec1ab51fc06a0f27d0185537",
      "download_error": null
    },
    {
      "track_id": "691b3bd6a1c962ea641efa75",
      "name": "Dusky",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.55,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Dusky_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=xniIQnQ9yaKDwllYm8VA3o%2BIir5uY95dj5cciyJDKH8%3D",
      "cdn_url": "https://audio2.brain.fm/Dusky_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dusky_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Dusky_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Dusky_Focus_DeepWork_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29130165,
      "sha256": "c6dfbc01d5de46973050493f94d4b6d96a7622b5499b6792fc9dd6c58d134b96",
      "download_error": null
    },
    {
      "track_id": "6909185a26bc41a99c863234",
      "name": "Light Bends",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.45,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/LightBends_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=VL4o1ZbxKgJD2MN%2FRGwPyjYOpnu6QxKBq46ETvghmFs%3D",
      "cdn_url": "https://audio2.brain.fm/LightBends_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LightBends_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LightBends_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/LightBends_Focus_DeepWork_Lofi_30_85BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28433198,
      "sha256": "25cc1023977871c50aee0df53fb315ffba49891c07b83bef1de3c1b32e306246",
      "download_error": null
    },
    {
      "track_id": "68f66583e8a4cc0a7401c28a",
      "name": "Unlaced",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.46,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Unlaced_Focus_Learning_Lofi_30_92BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=eMzeZSmK8WtTkI1bEA8f23jBxf%2FbJ3sUTAR40XOKhXw%3D",
      "cdn_url": "https://audio2.brain.fm/Unlaced_Focus_Learning_Lofi_30_92BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unlaced_Focus_Learning_Lofi_30_92BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unlaced_Focus_Learning_Lofi_30_92BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Unlaced_Focus_Learning_Lofi_30_92BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29023894,
      "sha256": "cf70b1f2e81caa1569eff128bf8da77819309b0a409711300b9d439f39a4b196",
      "download_error": null
    },
    {
      "track_id": "68f66456e8a4cc0a7401bcb9",
      "name": "Recurrence",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.26,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Recurrence_Focus_Creativity_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=3PvJAuix8gSj2oIUDPqnOAY7uZOHwEb9zVNQbIfIe8g%3D",
      "cdn_url": "https://audio2.brain.fm/Recurrence_Focus_Creativity_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Recurrence_Focus_Creativity_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Recurrence_Focus_Creativity_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Recurrence_Focus_Creativity_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24207256,
      "sha256": "a8b65efdca05962d819901ab9dee24c83362819cb96ef447520f050c38b45297",
      "download_error": null
    },
    {
      "track_id": "68e3d779c1aa1a1dfaaecaa0",
      "name": "Lock In",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.55,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/LockIn_Focus_Learning_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=dJRh5zE0jlFN7KL6%2BXxS3lts7PAEEGBsHiWzj5JGHm4%3D",
      "cdn_url": "https://audio2.brain.fm/LockIn_Focus_Learning_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LockIn_Focus_Learning_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LockIn_Focus_Learning_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/LockIn_Focus_Learning_Lofi_30_100BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29834106,
      "sha256": "d4607b3a6af6e6c2b0be33e280f65c8eb0fa21c14a531878a3ad504849270467",
      "download_error": null
    },
    {
      "track_id": "68e3d76dc1aa1a1dfaaeca62",
      "name": "Dial Tone",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.22,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/DialTone_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=s3QfdQ0JA0y4hS8hYyoYKmrNpkRlRXOQtVmiu0GPJ7s%3D",
      "cdn_url": "https://audio2.brain.fm/DialTone_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DialTone_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DialTone_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/DialTone_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25820412,
      "sha256": "a57d797df532e8dbb0cee05dbb6ad2691eda2ff3f19dde1b5f3c72de80d3996c",
      "download_error": null
    },
    {
      "track_id": "68e3d6e6c1aa1a1dfaaec8a4",
      "name": "Imprinted",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.42,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Imprinted_Focus_DeepWork_LoFi_30_82bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=MfkWIvH88rxtA5PhQJUvW6HjhTKjn5ADRp7FAxSzzN4%3D",
      "cdn_url": "https://audio2.brain.fm/Imprinted_Focus_DeepWork_LoFi_30_82bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Imprinted_Focus_DeepWork_LoFi_30_82bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Imprinted_Focus_DeepWork_LoFi_30_82bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Imprinted_Focus_DeepWork_LoFi_30_82bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28328269,
      "sha256": "597c65c6107024902c06417ed1df1812d898336b5c1efe11a81c587623306435",
      "download_error": null
    },
    {
      "track_id": "68d17a31a2277468b10cdb48",
      "name": "No Intent",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 74,
      "brightness_level": 0.36,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/NoIntent_Focus_Learning_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=Sj8v%2BmT88P58jl69IbnI6pnDVyrG5HSaRuIb73p%2F2sE%3D",
      "cdn_url": "https://audio2.brain.fm/NoIntent_Focus_Learning_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NoIntent_Focus_Learning_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NoIntent_Focus_Learning_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/NoIntent_Focus_Learning_LoFi_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26874452,
      "sha256": "79ffa5c5008112d3bc0d2e42cdedb4de426486f9b418335d09ae5e5933d9371f",
      "download_error": null
    },
    {
      "track_id": "68d17990d9158d8853b174de",
      "name": "Night Light",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.58,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/NightLight_Focus_Creativity_Lofi_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=zJy3PFErZ4lf6sH2EKmHAvJXyR%2F6Drcm%2FVwoT%2BgR5Ls%3D",
      "cdn_url": "https://audio2.brain.fm/NightLight_Focus_Creativity_Lofi_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NightLight_Focus_Creativity_Lofi_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NightLight_Focus_Creativity_Lofi_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/NightLight_Focus_Creativity_Lofi_30_75BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31786122,
      "sha256": "307629dd94b792675defa427ed8699a28c9633105c883557dc5634c801c3f8ea",
      "download_error": null
    },
    {
      "track_id": "68d1782aa2277468b10cd3a8",
      "name": "New Neighbors",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.22,
      "complexity_level": 1.17,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/NewNeighbors_Focus_DeepWork_Lofi_30_85BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=t9Op4VcKAoRLt%2FGGS0dBxPZnKnSkhv1MEl0BlmC5EQ8%3D",
      "cdn_url": "https://audio2.brain.fm/NewNeighbors_Focus_DeepWork_Lofi_30_85BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NewNeighbors_Focus_DeepWork_Lofi_30_85BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NewNeighbors_Focus_DeepWork_Lofi_30_85BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/NewNeighbors_Focus_DeepWork_Lofi_30_85BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24366703,
      "sha256": "52e06a813c361c9b9609282c3df9a3eb0597d239ab2230279cbbdc65721a75db",
      "download_error": null
    },
    {
      "track_id": "68d177b4d9158d8853b16e67",
      "name": "Misty Morning",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.45,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/MistyMorning_Focus_DeepWork_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=2D61%2FvwdNAZlVabGXLwdT7Tmc4g7XaPbyvf38iXV74g%3D",
      "cdn_url": "https://audio2.brain.fm/MistyMorning_Focus_DeepWork_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MistyMorning_Focus_DeepWork_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MistyMorning_Focus_DeepWork_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/MistyMorning_Focus_DeepWork_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28860481,
      "sha256": "3e73ee90ff3eea8c5c34c4ccb7e21bdce16620cb5e96029f52b39be2a67d0edd",
      "download_error": null
    },
    {
      "track_id": "68bf249095e372361f91f5af",
      "name": "A Lazy Wiggle",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.55,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/ALazyWiggle_Focus_Creativity_LoFi_30_75bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=6Gu8gB31g7mwBzmkvEdtuo%2FS9%2FwhnM5q6bLMkcY3gE4%3D",
      "cdn_url": "https://audio2.brain.fm/ALazyWiggle_Focus_Creativity_LoFi_30_75bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ALazyWiggle_Focus_Creativity_LoFi_30_75bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ALazyWiggle_Focus_Creativity_LoFi_30_75bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/ALazyWiggle_Focus_Creativity_LoFi_30_75bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29634409,
      "sha256": "fafc82105670831c22b0a6048b958ef5bef8e6fee096b6632e825781d866e7a0",
      "download_error": null
    },
    {
      "track_id": "68bf239f95e372361f91f160",
      "name": "Star Hopping",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.45,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/StarHopping_Focus_Creativity_Lofi_30_90BPM_LowNELNrmlzd2_VBR5.mp3?expiration=1792292136580&token=nHcCv71tbFx7PLSnY7nZgyQhp76AOnmM4FNKZFZUjZM%3D",
      "cdn_url": "https://audio2.brain.fm/StarHopping_Focus_Creativity_Lofi_30_90BPM_LowNELNrmlzd2_VBR5.mp3",
      "remote_filename": "StarHopping_Focus_Creativity_Lofi_30_90BPM_LowNELNrmlzd2_VBR5.mp3",
      "filename": "StarHopping_Focus_Creativity_Lofi_30_90BPM_LowNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/StarHopping_Focus_Creativity_Lofi_30_90BPM_LowNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29138114,
      "sha256": "b99f566acdd174c9bd8b7f34ae5d30491e52f6abcb239fee849e6eeae0537c99",
      "download_error": null
    },
    {
      "track_id": "68aca4c1605d1de9ea68bc79",
      "name": "Ctrl+Z",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.55,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Ctrl%2BZ_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=w3ZX7AEnMIYoLw970LT7mCyXMgB7s3%2BcZOoCyLNgeY4%3D",
      "cdn_url": "https://audio2.brain.fm/Ctrl%2BZ_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Ctrl+Z_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Ctrl-Z_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Ctrl-Z_Focus_Learning_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27163125,
      "sha256": "173cdbc5ed199ef7145981ec7e504dcfed1f99284a57c2e8a9ac76495e2f2c46",
      "download_error": null
    },
    {
      "track_id": "68aca402870c986ca59c05db",
      "name": "Maybe Hang A Minute",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 79,
      "brightness_level": 0.43,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Maybe%20Hang%20A%20Minute_Focus_Creativity_LoFi_30_79bpm_MedNELNrmlzd2_VBR5.mp3?expiration=1792292136580&token=CW4lbstVJ87KJ2uJ5DZxvYtxKk9jGOHnKta4ehzRX2g%3D",
      "cdn_url": "https://audio2.brain.fm/Maybe%20Hang%20A%20Minute_Focus_Creativity_LoFi_30_79bpm_MedNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Maybe Hang A Minute_Focus_Creativity_LoFi_30_79bpm_MedNELNrmlzd2_VBR5.mp3",
      "filename": "Maybe-Hang-A-Minute_Focus_Creativity_LoFi_30_79bpm_MedNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Maybe-Hang-A-Minute_Focus_Creativity_LoFi_30_79bpm_MedNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28254332,
      "sha256": "624a542bd7bea68ff5edb109b9544342bc8c67c575cb730a32be9df2c9b2cac4",
      "download_error": null
    },
    {
      "track_id": "689a23679446c76349a3b6a4",
      "name": "Vibe Dosage",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.7,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/VibeDosage_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=UE63TemPTj1PSZ9P6jIMTb6um3N%2F3Pn7otUea0Ia%2By8%3D",
      "cdn_url": "https://audio2.brain.fm/VibeDosage_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "VibeDosage_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "VibeDosage_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/VibeDosage_Focus_Creativity_Lofi_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30691610,
      "sha256": "1ceaf09b6869f860412b5c3496662d40f3c15d146f4e656b72d84bfd14a0327b",
      "download_error": null
    },
    {
      "track_id": "689a235b9446c76349a3b65a",
      "name": "Half A Percent",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.65,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/HalfAPercent_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=%2BHUauUkO%2B0uNOXv7xyDBMeAAfWndDUZVS%2BX1YTcpDGc%3D",
      "cdn_url": "https://audio2.brain.fm/HalfAPercent_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HalfAPercent_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HalfAPercent_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/HalfAPercent_Focus_Learning_LoFi_30_85bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28418331,
      "sha256": "34eb5b89363264fe98f836ef9a6b0c6385acbc21d31839c570b5d0091ff7c8fa",
      "download_error": null
    },
    {
      "track_id": "6888c8e5b997579cf699b7de",
      "name": "Atoms",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 67,
      "brightness_level": 0.49,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Atoms_Focus_DeepWork_LoFi_30_67bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=QHGSFzgWcdAye09wNhwm6cCRyd6LMbVmMif6uhhe%2BYM%3D",
      "cdn_url": "https://audio2.brain.fm/Atoms_Focus_DeepWork_LoFi_30_67bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Atoms_Focus_DeepWork_LoFi_30_67bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Atoms_Focus_DeepWork_LoFi_30_67bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Atoms_Focus_DeepWork_LoFi_30_67bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28272871,
      "sha256": "08efa6ee1773d25545dc850d19e0d00fed819caa1e59fb64f9b577d91819561a",
      "download_error": null
    },
    {
      "track_id": "6888c8cac24bb893747ef5f7",
      "name": "Cloudwalker",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.35,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Cloudwalker_Focus_DeepWork_LoFi_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=hmjB1bsWfIfKkoBBanu9LXkrCPlzPra20%2Bf7N0pQXmM%3D",
      "cdn_url": "https://audio2.brain.fm/Cloudwalker_Focus_DeepWork_LoFi_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Cloudwalker_Focus_DeepWork_LoFi_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Cloudwalker_Focus_DeepWork_LoFi_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Cloudwalker_Focus_DeepWork_LoFi_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27937320,
      "sha256": "f358825ece508672e583958748dcbdd5452acaffaa40df99e89352f240256377",
      "download_error": null
    },
    {
      "track_id": "687550ad3b891fead18ab868",
      "name": "Eros",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.64,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Eros_Focus_DeepWork_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=ZcVRDnFXCxP4nvnqKwfCv6weC0f4rupx4Y9QOCFbPXM%3D",
      "cdn_url": "https://audio2.brain.fm/Eros_Focus_DeepWork_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Eros_Focus_DeepWork_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Eros_Focus_DeepWork_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Eros_Focus_DeepWork_LoFi_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28910642,
      "sha256": "9d44b220356ec69544c4a70b5ffedfe2dbba6e1ae2d7a44ddbe8274870e4187e",
      "download_error": null
    },
    {
      "track_id": "687550a07e95e87bea729941",
      "name": "Miles Away",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.49,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.11,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/MilesAway_Focus_DeepWork_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=JyP4tCNYUr4WZmzscvJUWjKhtEQEel7iRyV293Vfi7Q%3D",
      "cdn_url": "https://audio2.brain.fm/MilesAway_Focus_DeepWork_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MilesAway_Focus_DeepWork_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MilesAway_Focus_DeepWork_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/MilesAway_Focus_DeepWork_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29457317,
      "sha256": "df1527d1813daca1e759c007500303f8ff31a3480ca4628c9ed45fbf296900fa",
      "download_error": null
    },
    {
      "track_id": "687550693b891fead18ab7b1",
      "name": "Time Crunch",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 73,
      "brightness_level": 0.43,
      "complexity_level": 0.89,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/TimeCrunch_Focus_DeepWork_Lofi_30_73BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=AJnoqhsbviOZYOJIOQdptbhE7BhCr%2BZpmXeYtWCi8B4%3D",
      "cdn_url": "https://audio2.brain.fm/TimeCrunch_Focus_DeepWork_Lofi_30_73BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TimeCrunch_Focus_DeepWork_Lofi_30_73BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TimeCrunch_Focus_DeepWork_Lofi_30_73BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/TimeCrunch_Focus_DeepWork_Lofi_30_73BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28182432,
      "sha256": "3232c85e22bd7a80c4778f3ba4a9c1eeeba671572ec10f1c1e3137b925c45cb8",
      "download_error": null
    },
    {
      "track_id": "6862f093b0ad537cfff5d1b3",
      "name": "Migrated Data",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 77,
      "brightness_level": 0.45,
      "complexity_level": 0.54,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/MigratedData_Focus_Learning_LoFi_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=cOnavQAfyxs5QwFOalzcx9wPwe8Z7jx%2BJeamOXPEIMI%3D",
      "cdn_url": "https://audio2.brain.fm/MigratedData_Focus_Learning_LoFi_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MigratedData_Focus_Learning_LoFi_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MigratedData_Focus_Learning_LoFi_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/MigratedData_Focus_Learning_LoFi_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28073015,
      "sha256": "29d020c0c59d734ad02da41c13ba898954f4f6a13c39cb24394472a80fa882c8",
      "download_error": null
    },
    {
      "track_id": "6862ee8bda2d247f1a9c720c",
      "name": "Kindling",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.35,
      "complexity_level": 11,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Kindling_Focus_Creativity_Lofi_30_80BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292136580&token=CQQuIGtml4l6PY8646ZlepakZVsUmjFujSb0%2BUZZ3KU%3D",
      "cdn_url": "https://audio2.brain.fm/Kindling_Focus_Creativity_Lofi_30_80BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Kindling_Focus_Creativity_Lofi_30_80BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "Kindling_Focus_Creativity_Lofi_30_80BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Kindling_Focus_Creativity_Lofi_30_80BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28385481,
      "sha256": "e4e39a4d0964d7da72a69eaae0188e9badac5160f53f5aeb3fb3a8abd7c66963",
      "download_error": null
    },
    {
      "track_id": "68505d42f6a8ec8278221b89",
      "name": "Tricky Layup",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.41,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/TrickyLayup_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=%2BcHR9FyJS7rAsmHJ2QL7d7sWC9KhgzRBpoBhU0YhiN0%3D",
      "cdn_url": "https://audio2.brain.fm/TrickyLayup_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TrickyLayup_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TrickyLayup_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/TrickyLayup_Focus_Creativity_Lofi_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29124755,
      "sha256": "211e4ab4c875b64bf964afbf2ffd9dfc1516c5ce6768109008834d73e8068fbe",
      "download_error": null
    },
    {
      "track_id": "68505cd45de2e833e430b400",
      "name": "Twilight Idols",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.46,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/TwilightIdols_Focus_DeepWork_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=6W6XIrn4uepjhSrYifYznJdzOtMqENC8NomUWc9zb58%3D",
      "cdn_url": "https://audio2.brain.fm/TwilightIdols_Focus_DeepWork_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TwilightIdols_Focus_DeepWork_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TwilightIdols_Focus_DeepWork_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/TwilightIdols_Focus_DeepWork_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28684183,
      "sha256": "11936c6e6197f4ac3f63fd2ab1835eb689756bb1439770d7dc56f12d51661265",
      "download_error": null
    },
    {
      "track_id": "683dc87fdd2246ed9c7c856b",
      "name": "Out of Imagination",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 78,
      "brightness_level": 0.52,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.84,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Out%20of%20Imagination_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=VOkr%2F1ny0sSg8SHisPqGkoKv2wnJWtd0yDzyAmmSYY8%3D",
      "cdn_url": "https://audio2.brain.fm/Out%20of%20Imagination_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Out of Imagination_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Out-of-Imagination_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Out-of-Imagination_Focus_Learning_LoFi_30_78bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26314811,
      "sha256": "a8d98f46114b782d9e78c2c0c37055eee09212aaeae31f575f5a8e8767d38456",
      "download_error": null
    },
    {
      "track_id": "683dc7f9dd2246ed9c7c83df",
      "name": "Just Making Sure",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.33,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Just%20Making%20Sure_Focus_Creativity_LoFi_30_85bpm_HighNELNrmlzd2_VBR5.mp3?expiration=1792292136580&token=ZG5AKrS1vAaT%2BnDbBG6GOTH4HcbtsPquaPJwRyUdp0k%3D",
      "cdn_url": "https://audio2.brain.fm/Just%20Making%20Sure_Focus_Creativity_LoFi_30_85bpm_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Just Making Sure_Focus_Creativity_LoFi_30_85bpm_HighNELNrmlzd2_VBR5.mp3",
      "filename": "Just-Making-Sure_Focus_Creativity_LoFi_30_85bpm_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Just-Making-Sure_Focus_Creativity_LoFi_30_85bpm_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27156904,
      "sha256": "fcf98faa26710e9e17a2a5524bb1c5a51928d0906c40800f4d118a7bb204e7f6",
      "download_error": null
    },
    {
      "track_id": "683dc78cdd2246ed9c7c8262",
      "name": "Alternative Origins",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.45,
      "complexity_level": 0.78,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/AlternateOrigins_Focus_DeepWork_Lofi_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=NhemsAZFBQr6v7O4i799We75vO20hs25ML9TptkIqso%3D",
      "cdn_url": "https://audio2.brain.fm/AlternateOrigins_Focus_DeepWork_Lofi_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AlternateOrigins_Focus_DeepWork_Lofi_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AlternateOrigins_Focus_DeepWork_Lofi_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/AlternateOrigins_Focus_DeepWork_Lofi_30_88BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31015440,
      "sha256": "ba4ce71464ae5a9ca4fbeaec1335f2b90b2bfbfb613ca2edb33c68a626d8d8da",
      "download_error": null
    },
    {
      "track_id": "682b5609d2f1d1682decf6c4",
      "name": "Stoop Dreams",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.38,
      "complexity_level": 0.94,
      "style": "normal",
      "neural_effect_level": 0.86,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/StoopDreams_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=AWFWLNyam2Niuhbt6AbrMvvDegsaoDMzrm43FQs2bFE%3D",
      "cdn_url": "https://audio2.brain.fm/StoopDreams_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StoopDreams_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StoopDreams_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/StoopDreams_Focus_DeepWork_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25734396,
      "sha256": "2e2d75a78d09e31e1d4fbc5ec53502e75b1c5ba4d543918d09c253e8b373ced6",
      "download_error": null
    },
    {
      "track_id": "682b559a8ab5a645af483d82",
      "name": "Crosseyed",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 88,
      "brightness_level": 0.42,
      "complexity_level": 0.72,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Crosseyed_Focus_Deep%20Work_LoFi_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=neCF8WGQfmAe7bLQn8mhehPPmM4cQgiyzogRbCheKfw%3D",
      "cdn_url": "https://audio2.brain.fm/Crosseyed_Focus_Deep%20Work_LoFi_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Crosseyed_Focus_Deep Work_LoFi_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Crosseyed_Focus_Deep-Work_LoFi_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Crosseyed_Focus_Deep-Work_LoFi_30_88bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27036527,
      "sha256": "f0d234cd62b43b260d2c6ec58dccda548427434357992ad12445b23f7e3275a7",
      "download_error": null
    },
    {
      "track_id": "682b554dd2f1d1682decf432",
      "name": "Namesake",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.4,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Namesake_Focus_Creativity_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=eyDvllH2vubsFJ78%2BsyIlhoggbF6BdxWGHhd1WNzxgw%3D",
      "cdn_url": "https://audio2.brain.fm/Namesake_Focus_Creativity_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Namesake_Focus_Creativity_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Namesake_Focus_Creativity_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Namesake_Focus_Creativity_Lofi_30_80BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28685253,
      "sha256": "42aaa995ede17af2f814421f0a067a34e3c2aaee65990ea9dff8a8293a93dd89",
      "download_error": null
    },
    {
      "track_id": "6818d20bc7fc795ec060f1da",
      "name": "Flight Credits",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.57,
      "complexity_level": 1.39,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/FlightCredits_Focus_Creativity_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=5yMLuJGLwkA79F60HdXNMmqtRdz4YyeWGQ0eFKH1w%2BY%3D",
      "cdn_url": "https://audio2.brain.fm/FlightCredits_Focus_Creativity_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FlightCredits_Focus_Creativity_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FlightCredits_Focus_Creativity_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/FlightCredits_Focus_Creativity_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31710948,
      "sha256": "85bad07ffd4b7405761d7c1d115280c68e48c2ee63145f404e164eb6fe33aa34",
      "download_error": null
    },
    {
      "track_id": "680682fa0a06e7da75c9785c",
      "name": "Soquarius",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.28,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Soquarius_Focus_Deep%20Work_LoFi_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=bKAEga31N%2BGGeAaBfemKVf0DJBk%2Bz4Mz8qEZYf58xWk%3D",
      "cdn_url": "https://audio2.brain.fm/Soquarius_Focus_Deep%20Work_LoFi_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Soquarius_Focus_Deep Work_LoFi_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Soquarius_Focus_Deep-Work_LoFi_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Soquarius_Focus_Deep-Work_LoFi_30_84bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24618509,
      "sha256": "34c001bdf044988f3e3b9257af16b9a0c9facdc89b5eb64c425030edc7eae301",
      "download_error": null
    },
    {
      "track_id": "67e17e7d5177e5bfbd17fc09",
      "name": "Prophecy",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.53,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Prophecy_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=n9guI4AwiCB3kk6LashIN0o3PRXCkRk7zurEAS%2FzPjE%3D",
      "cdn_url": "https://audio2.brain.fm/Prophecy_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Prophecy_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Prophecy_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Prophecy_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29178457,
      "sha256": "4a1683e4878cf58bdcc9e1dc38a6040a9ebe79a7fe8439498803bb4b96b4c31c",
      "download_error": null
    },
    {
      "track_id": "67e17e115177e5bfbd17f8b1",
      "name": "Uneven Ground",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.27,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/UnevenGround_Focus_Deepwork_Lofi_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=PgOfPlYvU07HjDKwS0VEDz0c6SXF3lZzHXQh5%2B84zqA%3D",
      "cdn_url": "https://audio2.brain.fm/UnevenGround_Focus_Deepwork_Lofi_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnevenGround_Focus_Deepwork_Lofi_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnevenGround_Focus_Deepwork_Lofi_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/UnevenGround_Focus_Deepwork_Lofi_30_95BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30822860,
      "sha256": "f7d68cf1e0887b0be5bfbd9bcc42f9ef4f56e4909954b93e53732f63e7c15d0a",
      "download_error": null
    },
    {
      "track_id": "67e17db65177e5bfbd17f56f",
      "name": "Odd Step",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.42,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/OddStep_Focus_Learning_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=O3HzF2S4ZDkHaJImJQfrFRJLtHwm5Qy3pY%2BX2kgC5AA%3D",
      "cdn_url": "https://audio2.brain.fm/OddStep_Focus_Learning_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OddStep_Focus_Learning_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OddStep_Focus_Learning_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/OddStep_Focus_Learning_Lofi_30_90BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27999224,
      "sha256": "e92a36f8ddb24ec6c6ce257428947b1a689504482427b361dc702f382495ce39",
      "download_error": null
    },
    {
      "track_id": "67cf0571593aad5348b966de",
      "name": "How It Went Down",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.69,
      "complexity_level": 0.89,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/How_It_Went_Down_Focus_Deep_Work_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=Zn%2BOeY9Iw5QUQ%2FSU6qZilo6idg1ubMZas5s1%2FjuRfsM%3D",
      "cdn_url": "https://audio2.brain.fm/How_It_Went_Down_Focus_Deep_Work_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "How_It_Went_Down_Focus_Deep_Work_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "How_It_Went_Down_Focus_Deep_Work_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/How_It_Went_Down_Focus_Deep_Work_LoFi_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28685627,
      "sha256": "ae4ba3b427309285fdaf04990fd82e8c364d2569802c7d38a49a58c7e440afc0",
      "download_error": null
    },
    {
      "track_id": "67bc892aaebfd9a384a2b602",
      "name": "Through It All",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.65,
      "complexity_level": 0.99,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/ThroughItAll_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=N8YP%2BVlq77rnRbq3%2BGyrrmgv6BWOaCd3kOmTq3gs4nk%3D",
      "cdn_url": "https://audio2.brain.fm/ThroughItAll_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThroughItAll_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThroughItAll_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/ThroughItAll_Focus_Learning_Lofi_30_90BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30182808,
      "sha256": "7d43a662112e529d7fffc13ca351a2bdac45a76c2d3490e431726bfd6894e8ac",
      "download_error": null
    },
    {
      "track_id": "67aa5bb955e93dd34369249c",
      "name": "Shoe Strings",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.62,
      "complexity_level": 1,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/ShoeStrings_Focus_DeepWork_Lofi_30_82BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=FKRLtWvGEw4YliMU6IRQj4VAhA3BEcvlluP77SbTxp0%3D",
      "cdn_url": "https://audio2.brain.fm/ShoeStrings_Focus_DeepWork_Lofi_30_82BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ShoeStrings_Focus_DeepWork_Lofi_30_82BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ShoeStrings_Focus_DeepWork_Lofi_30_82BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/ShoeStrings_Focus_DeepWork_Lofi_30_82BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29651496,
      "sha256": "439ac1c49e746d024dd16d69dbd7149e3427aedbe477e8fd307e1af64bb30704",
      "download_error": null
    },
    {
      "track_id": "67aa5b4c55e93dd34369212c",
      "name": "Ace of Cups",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.42,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Ace%20Of%20Cups_Focus_Creativity_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=P%2BW5msJJf4d2EqHp%2FB2nWIHDHltLs7WrTbR2G%2FiXLRA%3D",
      "cdn_url": "https://audio2.brain.fm/Ace%20Of%20Cups_Focus_Creativity_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Ace Of Cups_Focus_Creativity_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Ace-Of-Cups_Focus_Creativity_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Ace-Of-Cups_Focus_Creativity_Lofi_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27989384,
      "sha256": "bf7565448d0e7b5e7d21e75d9c6ca0ae6f6466c72277bddce9a01d6d19a33adf",
      "download_error": null
    },
    {
      "track_id": "67a10f5303677edafb63f3a0",
      "name": "Book Mill",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.36,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/BookMill_Focus_DeepWork_Lofi_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=R4PXVk2uxDAVjZb4eGx8M%2BXRsQQggKPkBGNXR9kKVaE%3D",
      "cdn_url": "https://audio2.brain.fm/BookMill_Focus_DeepWork_Lofi_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BookMill_Focus_DeepWork_Lofi_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BookMill_Focus_DeepWork_Lofi_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/BookMill_Focus_DeepWork_Lofi_30_130BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30470120,
      "sha256": "c95df1a44d116b4cf6cc0e68491149dfcbde0f777520ca4c5da079d7d919b1ba",
      "download_error": null
    },
    {
      "track_id": "67a10f3403677edafb63f248",
      "name": "Less Than Not",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.45,
      "complexity_level": 0.92,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Less%20Than%20Not_Focus_Deep%20Work_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=gUZh%2FhFhyD9SV%2BxC22yaAW1jsH7Rc0MA7qk8qgIse1w%3D",
      "cdn_url": "https://audio2.brain.fm/Less%20Than%20Not_Focus_Deep%20Work_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Less Than Not_Focus_Deep Work_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Less-Than-Not_Focus_Deep-Work_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Less-Than-Not_Focus_Deep-Work_LoFi_30_84bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28454031,
      "sha256": "bae8ef0d257b9bc833beb8513ebc365f8d1d26e08da17136bf44a37125f5fd9b",
      "download_error": null
    },
    {
      "track_id": "67855b16f76968728486aace",
      "name": "Organics",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.84,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Organics_Focus_Deep%20Work_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=5P1As5mkE7DP5HYLif%2BC3IbwRB3AfRxIasFP6PUvMCQ%3D",
      "cdn_url": "https://audio2.brain.fm/Organics_Focus_Deep%20Work_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Organics_Focus_Deep Work_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Organics_Focus_Deep-Work_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Organics_Focus_Deep-Work_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30044385,
      "sha256": "0a7f2e4375d102104716097c70a1e523371bcb69a4f4fb7bb9ffb9447b57f75a",
      "download_error": null
    },
    {
      "track_id": "673b5ea8593072f908bc7863",
      "name": "The Main One",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.4,
      "complexity_level": 0.62,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/The_Main_One_Focus_Creativity_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=LVOy%2FbeGfclnvuixVxOUCB96%2F4FrhavE5sumUes%2Bs64%3D",
      "cdn_url": "https://audio2.brain.fm/The_Main_One_Focus_Creativity_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "The_Main_One_Focus_Creativity_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "The_Main_One_Focus_Creativity_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/The_Main_One_Focus_Creativity_LoFi_30_90bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27080867,
      "sha256": "e680609670320d5b3f88fbe95ffc8735596a961069ddba3ff646d788202824df",
      "download_error": null
    },
    {
      "track_id": "673b5e9281e56c199c2a9eb0",
      "name": "No Mistakes",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.5,
      "complexity_level": 0.58,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/No_Mistakes_Focus_Creativity_LoFi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=ENV37JSGaSHeCp%2Fk4UQTBXdJlSLRQZT0BQyv5GAQaXc%3D",
      "cdn_url": "https://audio2.brain.fm/No_Mistakes_Focus_Creativity_LoFi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "No_Mistakes_Focus_Creativity_LoFi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "No_Mistakes_Focus_Creativity_LoFi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/No_Mistakes_Focus_Creativity_LoFi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27678203,
      "sha256": "1abebbf568cf7688291e86dc185e2e9cfc09b1a638fb5c437212d0aa11aa47aa",
      "download_error": null
    },
    {
      "track_id": "6728ebe4a39954546e6e551d",
      "name": "Om Pace",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.42,
      "complexity_level": 0.79,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/OmPace_Focus_Learning_Lofi_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=aAQulsVo2Wp%2BSFx3uLdlClyEWqRdhJPppQq6iIy118Y%3D",
      "cdn_url": "https://audio2.brain.fm/OmPace_Focus_Learning_Lofi_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OmPace_Focus_Learning_Lofi_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OmPace_Focus_Learning_Lofi_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/OmPace_Focus_Learning_Lofi_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25506064,
      "sha256": "5494de258b7751a858e8e8ff55c8dd46ca6b18efb70f8c8113bd2892fd1e264b",
      "download_error": null
    },
    {
      "track_id": "6728eb91ebed2a29b0df43fa",
      "name": "Junction",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.37,
      "complexity_level": 0.85,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Junction%20LoFi%20Focus%20Study%20Conor%2090bpm_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=3nD5CxaV%2Ba9oYpcbF%2B5mIkwj6HFwdoYv5VFwbfd3dMM%3D",
      "cdn_url": "https://audio2.brain.fm/Junction%20LoFi%20Focus%20Study%20Conor%2090bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Junction LoFi Focus Study Conor 90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Junction-LoFi-Focus-Study-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Junction-LoFi-Focus-Study-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25037380,
      "sha256": "478f7ed745e4ba4f496f2a7417e0331c70b7a1c068843c383ccb6a12012b1490",
      "download_error": null
    },
    {
      "track_id": "6716a1caae8c98e954dc5c2f",
      "name": "Clear Fog",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.69,
      "complexity_level": 0.7,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/ClearFog_Focus_DeepWork_Lofi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=j3MgWNyr9tmnVzyPAs2%2BSGzpztrNo3fQ6FTHKJpmrXY%3D",
      "cdn_url": "https://audio2.brain.fm/ClearFog_Focus_DeepWork_Lofi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ClearFog_Focus_DeepWork_Lofi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ClearFog_Focus_DeepWork_Lofi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/ClearFog_Focus_DeepWork_Lofi_30_86bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28665821,
      "sha256": "1d630950843dc11dfb3434008ad1cf052966a66476bfbc0bf94a6569dfcee3d0",
      "download_error": null
    },
    {
      "track_id": "6716a1b0ae8c98e954dc5b80",
      "name": "Laid Back",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 94,
      "brightness_level": 0.8,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/LaidBack_Focus_Creativity_LoFi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=aLPdHT%2Bw8risbc0h2odZf4WDBSUB4IJ9yxreuU6z1ks%3D",
      "cdn_url": "https://audio2.brain.fm/LaidBack_Focus_Creativity_LoFi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LaidBack_Focus_Creativity_LoFi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LaidBack_Focus_Creativity_LoFi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/LaidBack_Focus_Creativity_LoFi_30_94BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27600122,
      "sha256": "a8db312fc57eefd2d3c1147eb986a30bd5ebab7d059fe2be99cc5dea15c60ca9",
      "download_error": null
    },
    {
      "track_id": "6703e316a1f0c0804124fd47",
      "name": "Retinacea",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.44,
      "complexity_level": 0.76,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Retinacea_Focus_Creativity_Lofi_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=nNZqEgB9NQHj9E%2Bc4%2FWSPyc78rD5YTiJFO5r7%2BmATIE%3D",
      "cdn_url": "https://audio2.brain.fm/Retinacea_Focus_Creativity_Lofi_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Retinacea_Focus_Creativity_Lofi_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Retinacea_Focus_Creativity_Lofi_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Retinacea_Focus_Creativity_Lofi_30_100BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26124438,
      "sha256": "93f21101071626fa2fb37c9e71d6ada4e2049c6ae3cb9d3fe31addd53e3d2494",
      "download_error": null
    },
    {
      "track_id": "6703e2fda1f0c0804124fcda",
      "name": "Glowified",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.42,
      "complexity_level": 0.52,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Glowified_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=OH65jMoq2ZKBEuO3B20cJnAqONPlbHpbc0lgKS2yI9M%3D",
      "cdn_url": "https://audio2.brain.fm/Glowified_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Glowified_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Glowified_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Glowified_Focus_Deep_Work_LoFi_30_87bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27910951,
      "sha256": "69c6e60f9ce3dd76fbd8b15e0db12175812ba1a66c0f6167a839ee0af95c50ff",
      "download_error": null
    },
    {
      "track_id": "6703e2e7a1f0c0804124fc62",
      "name": "Morning Person",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.35,
      "complexity_level": 0.64,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Morning%20Person_Focus_Learning_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=dLUl%2FyPvRD%2FdWvG18lOoSuN%2FTOWjf7NE2grdwTakVjM%3D",
      "cdn_url": "https://audio2.brain.fm/Morning%20Person_Focus_Learning_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Morning Person_Focus_Learning_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Morning-Person_Focus_Learning_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Morning-Person_Focus_Learning_LoFi_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26859877,
      "sha256": "5e53c249cb9035a8e42aadf3d670c0aa54255b965c1701d6a47a1f23a19a09dc",
      "download_error": null
    },
    {
      "track_id": "66f1772bd7073bdb17919679",
      "name": "Midsummer Soulstice",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.35,
      "complexity_level": 0.88,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Midsummer%20Soulstice_Focus_Deep%20Work_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=feVxMbzL%2FCzxlZwKD3NE7pUmjC6LBZrvma65FB6MtN0%3D",
      "cdn_url": "https://audio2.brain.fm/Midsummer%20Soulstice_Focus_Deep%20Work_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Midsummer Soulstice_Focus_Deep Work_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Midsummer-Soulstice_Focus_Deep-Work_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Midsummer-Soulstice_Focus_Deep-Work_LoFi_30_86bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26586077,
      "sha256": "39ad65c3918aaa839971f11795638b30d2bd1ebbf0fc6edb0254fd97774e64fb",
      "download_error": null
    },
    {
      "track_id": "66f17499d7073bdb17919107",
      "name": "Chance Encounter",
      "category": "Lofi",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.57,
      "complexity_level": 0.76,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/lofi.json",
      "source_url": "https://audio2.brain.fm/Chance%20Encounter_Focus_Learning_LoFi_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292136580&token=keh5snbZrQCf36RkIP0xqFzN1DH6jg2SouDzGSynL0s%3D",
      "cdn_url": "https://audio2.brain.fm/Chance%20Encounter_Focus_Learning_LoFi_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Chance Encounter_Focus_Learning_LoFi_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Chance-Encounter_Focus_Learning_LoFi_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/lofi/Chance-Encounter_Focus_Learning_LoFi_30_84bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29393572,
      "sha256": "7813b1798908f440f65a7d2a896e5d7492340d696710386771d96b1e0acbe5ef",
      "download_error": null
    },
    {
      "track_id": "64302d265ee24c4799a06e19",
      "name": "Sleeping Forest",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.98,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/SleepingForest_Focus_DeepWork_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=YIwobXdrqwMzxlY9o%2FBIDPicYVxmAo2m5li0lc4Nkc0%3D",
      "cdn_url": "https://audio2.brain.fm/SleepingForest_Focus_DeepWork_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SleepingForest_Focus_DeepWork_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SleepingForest_Focus_DeepWork_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/SleepingForest_Focus_DeepWork_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27052081,
      "sha256": "1f3851f42c93ac4e6433125238366bceccd28ade8e9d3087da2c0d7c9682a221",
      "download_error": null
    },
    {
      "track_id": "64302c625ee24c35d9a06ac1",
      "name": "Nocturnal Stillness",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/NocturnalStillness_Focus_DeepWork_Nightsounds_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=CSYgH7es46G3KWoxN%2FhMygOP7JLMRBzJJTAjFRS9GVc%3D",
      "cdn_url": "https://audio2.brain.fm/NocturnalStillness_Focus_DeepWork_Nightsounds_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NocturnalStillness_Focus_DeepWork_Nightsounds_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NocturnalStillness_Focus_DeepWork_Nightsounds_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/NocturnalStillness_Focus_DeepWork_Nightsounds_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31362951,
      "sha256": "c791d033d3affcefc876c300bc73b7fe13949f1cbed33de726dc76f1d9b7f835",
      "download_error": null
    },
    {
      "track_id": "64302a2e5ee24c7892a058c5",
      "name": "Deep of Night",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.64,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/DeepofNight_Focus_DeepWork_Nightsounds_30_HIGHNEL_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=b8ExJricTlVXvwODGxVTigUkZY9Kr660ytV4rIXiMCU%3D",
      "cdn_url": "https://audio2.brain.fm/DeepofNight_Focus_DeepWork_Nightsounds_30_HIGHNEL_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DeepofNight_Focus_DeepWork_Nightsounds_30_HIGHNEL_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "DeepofNight_Focus_DeepWork_Nightsounds_30_HIGHNEL_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/DeepofNight_Focus_DeepWork_Nightsounds_30_HIGHNEL_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28710458,
      "sha256": "1b6b21524ec7f84ede7df52bb7f4bd2318e796355e47715ec2b77b6f3710acec",
      "download_error": null
    },
    {
      "track_id": "643029e95ee24ccf23a057c9",
      "name": "Cicada Song",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.97,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/CicadaSong_Focus_Creativity_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=KId0v0aE1AgwFF7kiMRqaXNLubpeGX1i89UpNmXH%2Fhg%3D",
      "cdn_url": "https://audio2.brain.fm/CicadaSong_Focus_Creativity_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CicadaSong_Focus_Creativity_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CicadaSong_Focus_Creativity_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/CicadaSong_Focus_Creativity_Nightsounds_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30978584,
      "sha256": "0f0b6420775908b45bd10c20086d8496b08b59b262857867bfb8d51a06c345ec",
      "download_error": null
    },
    {
      "track_id": "62b38c17592411202ef554a2",
      "name": "In the Night",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.7,
      "complexity_level": 0.84,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Nightsounds%20Focus%202%20Conor_1.6_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=2tiNfyRS%2BTg173zpp6TjBJk6OLvw5gRdNKJ%2B83KZP3o%3D",
      "cdn_url": "https://audio2.brain.fm/Nightsounds%20Focus%202%20Conor_1.6_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Nightsounds Focus 2 Conor_1.6_Nrmlzd2_VBR5.mp3",
      "filename": "Nightsounds-Focus-2-Conor_1.6_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Nightsounds-Focus-2-Conor_1.6_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26514361,
      "sha256": "8a4e5d696a1e12617026d377abd9d5a442aa28f11ae1f8753df7aed5680f4984",
      "download_error": null
    },
    {
      "track_id": "62b38c0059241112c6f55243",
      "name": "Nighttime Energy",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Nighttime%20Energy%20Nightsounds%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292109533&token=XjRx7H9gJ6KeVaWM6bIevhF80X1pvn6kGf%2B43OWEcA8%3D",
      "cdn_url": "https://audio2.brain.fm/Nighttime%20Energy%20Nightsounds%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Nighttime Energy Nightsounds 5 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Nighttime-Energy-Nightsounds-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Nighttime-Energy-Nightsounds-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27258017,
      "sha256": "30c7159f322a4441dbae6cf5c6176a163c1541733b0b71468b46c91662153eb7",
      "download_error": null
    },
    {
      "track_id": "62b38afe5924117e53f54ea7",
      "name": "Boreal Night",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.86,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Boreal%20Night%20Nature%20Focus%20Nightsounds%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=JWgdFlMGwyKkTRNFwTDhgtg4AgQKKzDrqKyJ0Eswc3A%3D",
      "cdn_url": "https://audio2.brain.fm/Boreal%20Night%20Nature%20Focus%20Nightsounds%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Boreal Night Nature Focus Nightsounds Study Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Boreal-Night-Nature-Focus-Nightsounds-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Boreal-Night-Nature-Focus-Nightsounds-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28756270,
      "sha256": "a182768ae2f8e0d6432d7ee197be4f74b96145004c3dcc6adc134b5a50b691da",
      "download_error": null
    },
    {
      "track_id": "62b38af35924116cb0f54d57",
      "name": "Twilight Breeze",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.72,
      "complexity_level": 0.38,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Twilight%20Mist%20Nightsounds%204%20Focus%20Chris%20120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=xeJOZBxf7dRLmwPjG5KCkArx1rneVmP%2B16NwGb8Pa80%3D",
      "cdn_url": "https://audio2.brain.fm/Twilight%20Mist%20Nightsounds%204%20Focus%20Chris%20120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Twilight Mist Nightsounds 4 Focus Chris 120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Twilight-Mist-Nightsounds-4-Focus-Chris-120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Twilight-Mist-Nightsounds-4-Focus-Chris-120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26656859,
      "sha256": "bae5f8ab5ef5b9701146e19e01c838b3d18bbfcdb67ec5be772182cb783f6a75",
      "download_error": null
    },
    {
      "track_id": "62b38aef5924117878f54cfa",
      "name": "All Night",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/All%20Night%20Nightsounds%206%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292109533&token=iN6SGrKqaCs87CW3DAQRBswUc3QjD22lhEbf5geWhPQ%3D",
      "cdn_url": "https://audio2.brain.fm/All%20Night%20Nightsounds%206%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "All Night Nightsounds 6 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "All-Night-Nightsounds-6-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/All-Night-Nightsounds-6-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27303711,
      "sha256": "34dd35eb32a314017fdfed9b9fcb1cb86d8924d4e6e15626075c41e2b909228a",
      "download_error": null
    },
    {
      "track_id": "62b38a375924118491f54279",
      "name": "Lunar Cycle",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.8,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Lunar%20Cycle%20Nature%20Focus%20Nightsounds%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=NX6LROjIU4Nc7mXRQooKflosEcrdS6GNPkF3eKwgh%2Fs%3D",
      "cdn_url": "https://audio2.brain.fm/Lunar%20Cycle%20Nature%20Focus%20Nightsounds%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lunar Cycle Nature Focus Nightsounds Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Lunar-Cycle-Nature-Focus-Nightsounds-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Lunar-Cycle-Nature-Focus-Nightsounds-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28337895,
      "sha256": "fa5ffd7dca019315ec7794718081e8db482cedaedca7c2979bb188dc1fe1bcd5",
      "download_error": null
    },
    {
      "track_id": "62b389df592411decbf53914",
      "name": "Still of the Night",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.73,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Still%20of%20the%20Night%20Nightsounds%20Focus%201%20Chris_1.8_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=orV9ez5drUe4UAJIY8RzPpKpBjXnWovH1Oftmr3r7wY%3D",
      "cdn_url": "https://audio2.brain.fm/Still%20of%20the%20Night%20Nightsounds%20Focus%201%20Chris_1.8_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Still of the Night Nightsounds Focus 1 Chris_1.8_Nrmlzd2_VBR5.mp3",
      "filename": "Still-of-the-Night-Nightsounds-Focus-1-Chris_1.8_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Still-of-the-Night-Nightsounds-Focus-1-Chris_1.8_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27806695,
      "sha256": "1f0d9c510390e1e05c458ae6387cf884cff620dce64a68611ce137f60e54c6f1",
      "download_error": null
    },
    {
      "track_id": "62b389535924115d4cf53392",
      "name": "Cricket Chorus",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.31,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.65,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Cricket%20Chorus%20Nightsounds%203%20Focus%20Chris%20120_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=386lm2AW3MVTIf38CRIaXgYJxp%2B%2Baoscp90ZTeAlUWM%3D",
      "cdn_url": "https://audio2.brain.fm/Cricket%20Chorus%20Nightsounds%203%20Focus%20Chris%20120_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Cricket Chorus Nightsounds 3 Focus Chris 120_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Cricket-Chorus-Nightsounds-3-Focus-Chris-120_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Cricket-Chorus-Nightsounds-3-Focus-Chris-120_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25285861,
      "sha256": "b87a6b32634626c859f5e27bed028d5aad737dc91fa4334f9352773ecaaa7067",
      "download_error": null
    },
    {
      "track_id": "62b3894b5924113ae1f5328e",
      "name": "Midnight Moon",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.8,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/NightsoundsDrones-FOC.2-Nrmzld_VBR5.mp3?expiration=1792292109533&token=2PQWcknml%2FJUNqfPH%2FohAuXxdnIAbr4l6esQx%2BVo9mA%3D",
      "cdn_url": "https://audio2.brain.fm/NightsoundsDrones-FOC.2-Nrmzld_VBR5.mp3",
      "remote_filename": "NightsoundsDrones-FOC.2-Nrmzld_VBR5.mp3",
      "filename": "NightsoundsDrones-FOC.2-Nrmzld_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/NightsoundsDrones-FOC.2-Nrmzld_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30617865,
      "sha256": "05690b2945c42512804269914bc32d0ba91498c0bb802de8f7205b57e16fb5d1",
      "download_error": null
    },
    {
      "track_id": "62b38946592411889af531f1",
      "name": "Midnight Study",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.8,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/NightsoundsDrones-FOCUSTemplate2_VBR5.mp3?expiration=1792292109533&token=5yIKQ%2FRGjol9XlDTNIc7eEbo7gnHq8p0nyimrYvY4bM%3D",
      "cdn_url": "https://audio2.brain.fm/NightsoundsDrones-FOCUSTemplate2_VBR5.mp3",
      "remote_filename": "NightsoundsDrones-FOCUSTemplate2_VBR5.mp3",
      "filename": "NightsoundsDrones-FOCUSTemplate2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/NightsoundsDrones-FOCUSTemplate2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32899267,
      "sha256": "95e32f4f5ad45fb19289de87232d3c410f038d679fb5ccf0cf859aff0508f1a0",
      "download_error": null
    },
    {
      "track_id": "62b388f459241118cdf52f6b",
      "name": "Night Breeze",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.84,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Night%20Breeze%20Nightsounds%20Focus%202%20Chris_1.9_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=2WPqdHmqokmguI%2B%2FzKsP3yXUNgm%2B7zDII4425ioWGcc%3D",
      "cdn_url": "https://audio2.brain.fm/Night%20Breeze%20Nightsounds%20Focus%202%20Chris_1.9_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Night Breeze Nightsounds Focus 2 Chris_1.9_Nrmlzd2_VBR5.mp3",
      "filename": "Night-Breeze-Nightsounds-Focus-2-Chris_1.9_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Night-Breeze-Nightsounds-Focus-2-Chris_1.9_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28890727,
      "sha256": "aeb7b788ce5b7d3ffb3737aed8b97fe3553c6bf23dad8fedefb37e58d8ac75de",
      "download_error": null
    },
    {
      "track_id": "62b387c65924113f82f52263",
      "name": "Gazing at Stars",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.72,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Nightsounds%20Focus%201%20Conor_1.7_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=Q8TeUdmpd05jehE5GlXLx0BxF0Rg5tG74GQSqa8S%2BkY%3D",
      "cdn_url": "https://audio2.brain.fm/Nightsounds%20Focus%201%20Conor_1.7_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Nightsounds Focus 1 Conor_1.7_Nrmlzd2_VBR5.mp3",
      "filename": "Nightsounds-Focus-1-Conor_1.7_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Nightsounds-Focus-1-Conor_1.7_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28450359,
      "sha256": "9720988e8ebe94d33e5a89c41906434594bcb413da5443438735d790afa2b18c",
      "download_error": null
    },
    {
      "track_id": "62b387b85924112fcef52010",
      "name": "Dusk to Dawn",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.86,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Dusk%20to%20Dawn%20Nightsounds%207%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292109533&token=8vMShA8W2GiXLDO43sc9a7yPBrEeSjWUHDlT4usM0Rc%3D",
      "cdn_url": "https://audio2.brain.fm/Dusk%20to%20Dawn%20Nightsounds%207%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Dusk to Dawn Nightsounds 7 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Dusk-to-Dawn-Nightsounds-7-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Dusk-to-Dawn-Nightsounds-7-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27483966,
      "sha256": "a6ceeb79a5bf33894cfe709c79d54ad64d70b5dafe4d71508953c8d003614cef",
      "download_error": null
    },
    {
      "track_id": "62b3811a5924112f03f4e524",
      "name": "Nighttime Stream",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Nighttime%20Stream%20Nightsounds%201%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292109533&token=Alv5RQ6aLTLflaoQ9z91DaS0AZSPWljXMpLFr%2FvjXiU%3D",
      "cdn_url": "https://audio2.brain.fm/Nighttime%20Stream%20Nightsounds%201%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Nighttime Stream Nightsounds 1 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Nighttime-Stream-Nightsounds-1-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Nighttime-Stream-Nightsounds-1-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25175015,
      "sha256": "74e12ccda03324b046be645c5e264b26bfb2f14ef3446775018c5e9980334078",
      "download_error": null
    },
    {
      "track_id": "62b380f859241147a2f4dba0",
      "name": "Dusk",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.75,
      "complexity_level": 0.46,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Dusk%20Nightsounds%203%20Nature%20Focus%20Chris_1.4_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=9VZyBikegGk2A8JQr2N8PVEvCQPCj2xQ7hEI20P2kus%3D",
      "cdn_url": "https://audio2.brain.fm/Dusk%20Nightsounds%203%20Nature%20Focus%20Chris_1.4_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dusk Nightsounds 3 Nature Focus Chris_1.4_Nrmlzd2_VBR5.mp3",
      "filename": "Dusk-Nightsounds-3-Nature-Focus-Chris_1.4_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Dusk-Nightsounds-3-Nature-Focus-Chris_1.4_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20045112,
      "sha256": "3d63859d06c1ca211a075abe2028a75c1d0ff786dcf407fc33de077e378ed195",
      "download_error": null
    },
    {
      "track_id": "62b380f4592411315cf4da5d",
      "name": "Stargazing",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.76,
      "style": "normal",
      "neural_effect_level": 0.89,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Stargazing%20Nightsounds%20Focus%201%20Conor_1.7_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=tHofbva5HnJ%2FIHhCGZ1QNOXGC9O4sSb5oqVNCyvMjzI%3D",
      "cdn_url": "https://audio2.brain.fm/Stargazing%20Nightsounds%20Focus%201%20Conor_1.7_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Stargazing Nightsounds Focus 1 Conor_1.7_Nrmlzd2_VBR5.mp3",
      "filename": "Stargazing-Nightsounds-Focus-1-Conor_1.7_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Stargazing-Nightsounds-Focus-1-Conor_1.7_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28460421,
      "sha256": "587b4dcda2a6743e4227de07ecca581bd01919eeaba98c75cd7259bc16b5d813",
      "download_error": null
    },
    {
      "track_id": "62b380e0592411f5ccf4d368",
      "name": "Natural Satellite",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Natural%20Satellite%20Nature%20Focus%20Nightsounds%20Deep%20Work%20Conor%20MED%20NEL%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=XAH2mY1cXOVWHLU4%2FSlolSthmP2aTUeqr3KImOznUCI%3D",
      "cdn_url": "https://audio2.brain.fm/Natural%20Satellite%20Nature%20Focus%20Nightsounds%20Deep%20Work%20Conor%20MED%20NEL%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Natural Satellite Nature Focus Nightsounds Deep Work Conor MED NEL 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Natural-Satellite-Nature-Focus-Nightsounds-Deep-Work-Conor-MED-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Natural-Satellite-Nature-Focus-Nightsounds-Deep-Work-Conor-MED-NEL-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31255457,
      "sha256": "6218f10af7cc4856dedabfdd60c64ef9925b496152775c483221aa0eb589be2f",
      "download_error": null
    },
    {
      "track_id": "62b3808759241178d3f4ce3e",
      "name": "Path of Leaves",
      "category": "Nightsounds",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.58,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/nightsounds.json",
      "source_url": "https://audio2.brain.fm/Path%20of%20Leaves%20Nightsounds%202%20Focus%20Chris%20120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292109533&token=wHhQBG5DV4QA25ylFjGpNiWd6SaLpek3ElvQpb1ZfyU%3D",
      "cdn_url": "https://audio2.brain.fm/Path%20of%20Leaves%20Nightsounds%202%20Focus%20Chris%20120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Path of Leaves Nightsounds 2 Focus Chris 120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Path-of-Leaves-Nightsounds-2-Focus-Chris-120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/nightsounds/Path-of-Leaves-Nightsounds-2-Focus-Chris-120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24574231,
      "sha256": "c05321e9038d732e3e2f9d3cca9414e1b2f372bd6ee8c05d79267906c675b6ef",
      "download_error": null
    },
    {
      "track_id": "6a4bb69e4518fc4e1e40610f",
      "name": "Aventurine",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.39,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Aventurine_Focus_DeepWork_Piano_72_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=RUQ2O%2FtXYrOUOO92XixSGk3QD1ne%2BBclQ%2Bef%2Btd8LQA%3D",
      "cdn_url": "https://audio2.brain.fm/Aventurine_Focus_DeepWork_Piano_72_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Aventurine_Focus_DeepWork_Piano_72_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Aventurine_Focus_DeepWork_Piano_72_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Aventurine_Focus_DeepWork_Piano_72_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27834733,
      "sha256": "76ae6d326ca32750ea8762d3667797d1cbe66f94647500b0e3b3c8519187cd27",
      "download_error": null
    },
    {
      "track_id": "6a4281f978a0a113b2ff3ed8",
      "name": "Hidden Messages",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 138,
      "brightness_level": 0.19,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/HiddenMessagesFocus_DeepWork_Piano_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=miNaezstU5Iv2ltS1G%2BBssUiHSUMXdxUq6IoDliGpXU%3D",
      "cdn_url": "https://audio2.brain.fm/HiddenMessagesFocus_DeepWork_Piano_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "HiddenMessagesFocus_DeepWork_Piano_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "HiddenMessagesFocus_DeepWork_Piano_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/HiddenMessagesFocus_DeepWork_Piano_30_138BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23184230,
      "sha256": "3671a0f958b414469fd44803782d37706e84e82e94d827c8f62fcbe22fc52579",
      "download_error": null
    },
    {
      "track_id": "6a3017a57a8f5056573c9229",
      "name": "Vespers",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.16,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Vespers_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=PXt0ibTySsDxz%2BAyZZf5hYMm%2FsbnyFA%2FVd9LK%2F0SPO4%3D",
      "cdn_url": "https://audio2.brain.fm/Vespers_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Vespers_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Vespers_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Vespers_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21606357,
      "sha256": "c485a9ae238bcebe5c1833fdb55b49df3447c752d4a7bec86ff0ff02ea85bed9",
      "download_error": null
    },
    {
      "track_id": "6a0b8b8ee6017bccd74b8003",
      "name": "Imperishable",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 107,
      "brightness_level": 0.29,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Imperishable_Focus_Learning_Piano_107_HighNel_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=%2F3RhxxfrjernIlWSSJyDDt%2B9LHqUZXeV4ozRL5RWM7U%3D",
      "cdn_url": "https://audio2.brain.fm/Imperishable_Focus_Learning_Piano_107_HighNel_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Imperishable_Focus_Learning_Piano_107_HighNel_Nrmlzd2_VBR5.mp3",
      "filename": "Imperishable_Focus_Learning_Piano_107_HighNel_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Imperishable_Focus_Learning_Piano_107_HighNel_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27343880,
      "sha256": "e4622f3ea744c24f05f01f5bca5a8b370be9af3a373fae0c2feab1fb71f65b08",
      "download_error": null
    },
    {
      "track_id": "6a0b8b43e6017bccd74b7cb1",
      "name": "Vue Plongeante",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 154,
      "brightness_level": 0.32,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/VuePlongeante_Focus_DeepWork_Piano_154_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=DKR1QVO3DgmpMRWTpVyDCHFOVY2qc%2FCVzJEDBE1X4sM%3D",
      "cdn_url": "https://audio2.brain.fm/VuePlongeante_Focus_DeepWork_Piano_154_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "VuePlongeante_Focus_DeepWork_Piano_154_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "VuePlongeante_Focus_DeepWork_Piano_154_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/VuePlongeante_Focus_DeepWork_Piano_154_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27690168,
      "sha256": "59bc77b0fe9d640f98ad8d3cebb168cfd3016d3a1d31bc8921e3a619635c42aa",
      "download_error": null
    },
    {
      "track_id": "69f8b9401c706aff1baf12fd",
      "name": "Quiet Benediction",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.58,
      "complexity_level": 0.35,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/QuietBenediction_Focus_DeepWork_Piano_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=y3I1q4Dn4NuO6vdj8mtwocVskKbadUofEjA602Q6pt0%3D",
      "cdn_url": "https://audio2.brain.fm/QuietBenediction_Focus_DeepWork_Piano_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "QuietBenediction_Focus_DeepWork_Piano_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "QuietBenediction_Focus_DeepWork_Piano_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/QuietBenediction_Focus_DeepWork_Piano_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22527260,
      "sha256": "99083619a38fa9636fdfe889f7bc8b800377304041e29c3e08b98724ecfe7a16",
      "download_error": null
    },
    {
      "track_id": "69f8b9151c706aff1baf10be",
      "name": "Montane",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 160,
      "brightness_level": 0.26,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Montane_Focus_DeepWork_Piano_160_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=m%2Buy9QJwUCdJuvwNiX3SUphjwJD%2F7qDxNlRi7GvgVhs%3D",
      "cdn_url": "https://audio2.brain.fm/Montane_Focus_DeepWork_Piano_160_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Montane_Focus_DeepWork_Piano_160_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Montane_Focus_DeepWork_Piano_160_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Montane_Focus_DeepWork_Piano_160_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27688774,
      "sha256": "79db71924e96671cf1f6d05a7bac12a771682c743ec2e2f2ff0f5c0e7b8b7ef2",
      "download_error": null
    },
    {
      "track_id": "69f8b89b1c706aff1baf0c23",
      "name": "Tévennec",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.38,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.59,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Te%CC%81vennec_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=sPTEemlXJHSviZAU0%2FLg%2B1PZFSquHYj2Ef6xNBhR5tE%3D",
      "cdn_url": "https://audio2.brain.fm/Te%CC%81vennec_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tévennec_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Te-vennec_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Te-vennec_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27644604,
      "sha256": "58617062a6ebbf1fe9cf258175136fb3d30a443fb07eb797328569b5bc2a52f9",
      "download_error": null
    },
    {
      "track_id": "69e686bbdce2120639c6ef42",
      "name": "Espalier",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.3,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.87,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Espalier_Focus_DeepWork_Piano_130_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=t5TbBJAPvptx3gACtLRCp%2BsOsAuk8wW3uyCDOMFUXTI%3D",
      "cdn_url": "https://audio2.brain.fm/Espalier_Focus_DeepWork_Piano_130_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Espalier_Focus_DeepWork_Piano_130_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Espalier_Focus_DeepWork_Piano_130_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Espalier_Focus_DeepWork_Piano_130_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27501516,
      "sha256": "36c82b5b186f4324228dc5e008505fa10cb57dd698ce69775057ae85bb3b04ec",
      "download_error": null
    },
    {
      "track_id": "69e685bbdce2120639c6e611",
      "name": "Soft Sparkles",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.29,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.87,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SoftSparkles_Focus_Piano_Creativity_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=DK%2F1oP8%2B9QWgwvydWX%2FAh9vxzP%2Fj3UjJF09NN5pDpmM%3D",
      "cdn_url": "https://audio2.brain.fm/SoftSparkles_Focus_Piano_Creativity_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SoftSparkles_Focus_Piano_Creativity_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SoftSparkles_Focus_Piano_Creativity_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SoftSparkles_Focus_Piano_Creativity_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28071547,
      "sha256": "0ab85bc738302eb371de3774b85d01615dfb8d0ccc197aa0a7b687fa568bb61a",
      "download_error": null
    },
    {
      "track_id": "69aee20a73bfe2099d517740",
      "name": "Another Sun",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 78,
      "brightness_level": 0.28,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/AnotherSun_Focus_DeepWork_Piano_78_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=w188SqsEDcz0kEpMfzqCV1xyhgBKGuGd%2FhLtf2ZbszQ%3D",
      "cdn_url": "https://audio2.brain.fm/AnotherSun_Focus_DeepWork_Piano_78_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AnotherSun_Focus_DeepWork_Piano_78_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AnotherSun_Focus_DeepWork_Piano_78_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/AnotherSun_Focus_DeepWork_Piano_78_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27948353,
      "sha256": "fd0fb261abe14325f33ed6f0a8a780da0c0940e66a4c12532d5792c45674584f",
      "download_error": null
    },
    {
      "track_id": "69aee1c473bfe2099d517547",
      "name": "The Spectrum Of Colors",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/TheSpectrumOfColours_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=5hbWRw7wd%2BT12LizOzflu0cx2pnZerSMmrT%2FZgz9Wr8%3D",
      "cdn_url": "https://audio2.brain.fm/TheSpectrumOfColours_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheSpectrumOfColours_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheSpectrumOfColours_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/TheSpectrumOfColours_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27710716,
      "sha256": "3838fd7eb5b39aa24a987c3ae200374ee5b3691380225082f1ba31482d43cda2",
      "download_error": null
    },
    {
      "track_id": "6977c176597917b519507c75",
      "name": "Sails and Steam",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.2,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SailsAndSteam_Focus_DeepWork_Piano_82_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=eXylr4TnQjPyE%2BE%2FvOwVoh8%2BEhnZmvE2ikZUJ8Y%2Fk5s%3D",
      "cdn_url": "https://audio2.brain.fm/SailsAndSteam_Focus_DeepWork_Piano_82_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SailsAndSteam_Focus_DeepWork_Piano_82_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SailsAndSteam_Focus_DeepWork_Piano_82_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SailsAndSteam_Focus_DeepWork_Piano_82_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25575889,
      "sha256": "f45e96fabd7da53ee228281899e6a4c4738f12a28d4252711d4920435a52d45a",
      "download_error": null
    },
    {
      "track_id": "69655b41212c8d55194eeba2",
      "name": "Tiny Gradients",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 114,
      "brightness_level": 0.33,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/TinyGradients_Focus_Piano_DeepWork_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=n1L8qAFzvyDJu0YBnC5qG8Af%2BgdtJrEwNghw1xzXkYU%3D",
      "cdn_url": "https://audio2.brain.fm/TinyGradients_Focus_Piano_DeepWork_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TinyGradients_Focus_Piano_DeepWork_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TinyGradients_Focus_Piano_DeepWork_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/TinyGradients_Focus_Piano_DeepWork_30_114BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27846507,
      "sha256": "1a8c859f023bbffe5ebf49eab1deaec38a8cd437374408e0317c13d45cd18931",
      "download_error": null
    },
    {
      "track_id": "6952f3749e729f65562d117d",
      "name": "Still There",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 118,
      "brightness_level": 0.16,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/StillThere_Focus_Piano_DeepWork_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=sC%2FdSbvn8ihDpqddNL21VQOrCAe7FvvIxnh2to3q%2FHc%3D",
      "cdn_url": "https://audio2.brain.fm/StillThere_Focus_Piano_DeepWork_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "StillThere_Focus_Piano_DeepWork_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "StillThere_Focus_Piano_DeepWork_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/StillThere_Focus_Piano_DeepWork_30_118BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22787349,
      "sha256": "1e0bb2ae61526ae44d4eb072bc6f9fba25f8483dadc3aaab5572bf8f1b7880ee",
      "download_error": null
    },
    {
      "track_id": "6940595d76a1c1f80ff937de",
      "name": "Linger",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.14,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.82,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Linger_Focus_DeepWork_Piano_30_120BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292138658&token=fu6AH%2BkE76MOPq86gsqbuDxRb3UwH6eBVFrrF5OaTpg%3D",
      "cdn_url": "https://audio2.brain.fm/Linger_Focus_DeepWork_Piano_30_120BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Linger_Focus_DeepWork_Piano_30_120BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "Linger_Focus_DeepWork_Piano_30_120BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Linger_Focus_DeepWork_Piano_30_120BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21697765,
      "sha256": "301c0a8f6b4122d510e3d2bed368419e3dac86a5a9b4dc0359fc4691de135158",
      "download_error": null
    },
    {
      "track_id": "692dbd7166ea27cd5c911549",
      "name": "The Lightness Of Being",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.2,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.64,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/TheLightnessOfBeing_Focus_Piano_Creativity_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=q5ZThgzEiAf5b2cj33ScUrMW5v5Y5tVzdlWDjnMafSA%3D",
      "cdn_url": "https://audio2.brain.fm/TheLightnessOfBeing_Focus_Piano_Creativity_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheLightnessOfBeing_Focus_Piano_Creativity_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheLightnessOfBeing_Focus_Piano_Creativity_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/TheLightnessOfBeing_Focus_Piano_Creativity_30_116BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22668249,
      "sha256": "996b1f8bad2d31fa3b9e74b4878aecd38f962f97f09f4f13ea0450d30ee1f2cb",
      "download_error": null
    },
    {
      "track_id": "691b3c2ba1c962ea641efc3f",
      "name": "Fragile States",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.38,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/FragileStates_Focus_DeepWork_Piano_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=8nhCEzJmjmsxTEFeDS1jnVjvHA9lk9rfutdM09sSlSE%3D",
      "cdn_url": "https://audio2.brain.fm/FragileStates_Focus_DeepWork_Piano_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "FragileStates_Focus_DeepWork_Piano_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "FragileStates_Focus_DeepWork_Piano_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/FragileStates_Focus_DeepWork_Piano_30_120BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27162677,
      "sha256": "9596bd3750c44cce362a038f612f92e6b7b7dca1aac9a09f39640e7afccfb92b",
      "download_error": null
    },
    {
      "track_id": "69091a55312eb1fe04659840",
      "name": "Quiet Shifts",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.2,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/QuietShifts_Focus_Piano_DeepWork_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=n4RpuESlqTdWsxSQUAnaJVkfYS330YBxaO5LKtjFbWM%3D",
      "cdn_url": "https://audio2.brain.fm/QuietShifts_Focus_Piano_DeepWork_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "QuietShifts_Focus_Piano_DeepWork_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "QuietShifts_Focus_Piano_DeepWork_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/QuietShifts_Focus_Piano_DeepWork_30_112BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23556782,
      "sha256": "3fd8317f1dd5f5c1a6e2315056cf6921f29ea262f6c7a75f00140b6bfc761ba0",
      "download_error": null
    },
    {
      "track_id": "69091a4126bc41a99c863a69",
      "name": "Behind the Rain",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.59,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/BehindTheRain_Focus_Creativity_Piano_96_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=IqGFqxGWlDK20FAcKou0F%2BKpUXyS%2FH72q3P0Jm0UByA%3D",
      "cdn_url": "https://audio2.brain.fm/BehindTheRain_Focus_Creativity_Piano_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BehindTheRain_Focus_Creativity_Piano_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BehindTheRain_Focus_Creativity_Piano_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/BehindTheRain_Focus_Creativity_Piano_96_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26530913,
      "sha256": "dddf44528e0e11dc0dc9097860eae87197f8eda9948c09d2d81f90fffcd2ace7",
      "download_error": null
    },
    {
      "track_id": "68f664e6c7a40a338f845cd8",
      "name": "Emotional Cycles",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.2,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/EmotionalCycles_Focus_Piano_Learning_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=z6dfSE16uxzB6xbEvkEvWcvLoqwqWjHKf2lwFe2blCc%3D",
      "cdn_url": "https://audio2.brain.fm/EmotionalCycles_Focus_Piano_Learning_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "EmotionalCycles_Focus_Piano_Learning_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "EmotionalCycles_Focus_Piano_Learning_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/EmotionalCycles_Focus_Piano_Learning_30_112BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25953820,
      "sha256": "605fe5e55118f41cad3a16c23326bfd23232208bf783f1788ddba4d93eb88b31",
      "download_error": null
    },
    {
      "track_id": "68e3d78e2d873930bbbf7c7c",
      "name": "Sketches From Hills",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 68,
      "brightness_level": 0.51,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SketchesFromHills_Focus_Piano_Learning_30_68BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=J9WFf%2FtaSHR9lotV3YJoouz3r%2F%2Ft8ihfQrhbSlZh5F4%3D",
      "cdn_url": "https://audio2.brain.fm/SketchesFromHills_Focus_Piano_Learning_30_68BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SketchesFromHills_Focus_Piano_Learning_30_68BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SketchesFromHills_Focus_Piano_Learning_30_68BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SketchesFromHills_Focus_Piano_Learning_30_68BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28132929,
      "sha256": "8d3e7e61969699a490da133c5a607fdaed15a15e48814326b5a37c745a47edd6",
      "download_error": null
    },
    {
      "track_id": "68e3d7042d873930bbbf7a0e",
      "name": "Alone At Last",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.36,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/AloneAtLast_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=MhUVZDwtftU9zIJWv3vFMOEAacZr0aFTiIHIs7Fv6uM%3D",
      "cdn_url": "https://audio2.brain.fm/AloneAtLast_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AloneAtLast_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AloneAtLast_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/AloneAtLast_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27783546,
      "sha256": "7972a032f7cc85ba8466eaf03ca9bfc459cf590dd57e7b0dc0d41dd23ecffaec",
      "download_error": null
    },
    {
      "track_id": "68d17a4ca2277468b10cdbce",
      "name": "Miniature Feelings",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.2,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Miniature_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=gA%2BlxluUZcfT0HkdVhdzdRmsf4xYvBuEDD1jn6QrZVo%3D",
      "cdn_url": "https://audio2.brain.fm/Miniature_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Miniature_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Miniature_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Miniature_Focus_Piano_Creativity_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27837531,
      "sha256": "77b264c4efeb095a934838282b5871d69087b7ebd805297f04597dc4f21e9f7b",
      "download_error": null
    },
    {
      "track_id": "68d17916a2277468b10cd743",
      "name": "The Precipice of Change",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.29,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/ThePrecipieceOfChange_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=G5ngkJHfy2aVvQ0GODIRJ0n54XWHmDyZdQLUCHSpEXw%3D",
      "cdn_url": "https://audio2.brain.fm/ThePrecipieceOfChange_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThePrecipieceOfChange_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThePrecipieceOfChange_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/ThePrecipieceOfChange_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23640006,
      "sha256": "5c3ec24af70f82592d44d545fe6d6d98dc55d3444a05075e6947d6a44295a62d",
      "download_error": null
    },
    {
      "track_id": "68d178a7d9158d8853b17194",
      "name": "Inner Glow",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.22,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/InnerGlow_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=B1OBz7WDwg%2FKec0kQ%2FRLVWd3bawcsdKFwetB0fFkf%2F0%3D",
      "cdn_url": "https://audio2.brain.fm/InnerGlow_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InnerGlow_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InnerGlow_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/InnerGlow_Focus_DeepWork_Piano_30_120BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26892812,
      "sha256": "f997ff2d86b4169319146d783fcbaea9ed9a1adf725a40b8620fc0ba94f27b57",
      "download_error": null
    },
    {
      "track_id": "68bf24b595e372361f91f662",
      "name": "Clear Cut",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.25,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/ClearCut_Focus_DeepWork_Piano_80_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=TqpLnM7%2B2xkyNNNAAiOCIwJbko6Qr7WIpEQv%2FAL689M%3D",
      "cdn_url": "https://audio2.brain.fm/ClearCut_Focus_DeepWork_Piano_80_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ClearCut_Focus_DeepWork_Piano_80_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ClearCut_Focus_DeepWork_Piano_80_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/ClearCut_Focus_DeepWork_Piano_80_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27707724,
      "sha256": "511e0830e046746f924037d7e61d09887420517bddeaa495cf3771cb5d00a404",
      "download_error": null
    },
    {
      "track_id": "68bf240295e372361f91f330",
      "name": "Low Sun",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.43,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/LowSun_Focus_Learning_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=0cgujDkkzcPDvbK6sm0BoTEreWNkz8Ogt0A1w2XEepI%3D",
      "cdn_url": "https://audio2.brain.fm/LowSun_Focus_Learning_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LowSun_Focus_Learning_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LowSun_Focus_Learning_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/LowSun_Focus_Learning_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24807855,
      "sha256": "4ce4957d4eb3cf4b7c8c1ad0fbe8141c7dd11ab25a912d7546e867eaadf52418",
      "download_error": null
    },
    {
      "track_id": "68bf23b8bab547755c787276",
      "name": "Balconet",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.17,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Balconet_Focus_Learning_Piano_116_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=ygduLuFSbe0uJKv4QnrnqhRWAL39ZGWvxgSPLfOP5dI%3D",
      "cdn_url": "https://audio2.brain.fm/Balconet_Focus_Learning_Piano_116_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Balconet_Focus_Learning_Piano_116_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Balconet_Focus_Learning_Piano_116_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Balconet_Focus_Learning_Piano_116_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22669100,
      "sha256": "c103869180004fd73a4f3c7606d4a7ae4978a3b1003cf6bd64f3fde827f7bb49",
      "download_error": null
    },
    {
      "track_id": "68aca529870c986ca59c0b66",
      "name": "Celastrus",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 152,
      "brightness_level": 0.23,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.03,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Celastrus_Focus_Learning_Piano_152_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=981%2BwKtuT4XyD7UcdDvW5yiXboRyLZinrbJHwXEZxAw%3D",
      "cdn_url": "https://audio2.brain.fm/Celastrus_Focus_Learning_Piano_152_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Celastrus_Focus_Learning_Piano_152_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Celastrus_Focus_Learning_Piano_152_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Celastrus_Focus_Learning_Piano_152_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26284019,
      "sha256": "27abdfb310400c003150836a3ffc6a97ab724eaa2bec5143fe9835be69914894",
      "download_error": null
    },
    {
      "track_id": "68aca4d9870c986ca59c09d8",
      "name": "Towering Twilight",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.17,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/ToweringTwilight_Focus_Creativity_Piano_90_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=FHHsiseQ%2BVlQ0Kr5qzQknACJ5LbhuAAJD64kY50kI8s%3D",
      "cdn_url": "https://audio2.brain.fm/ToweringTwilight_Focus_Creativity_Piano_90_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ToweringTwilight_Focus_Creativity_Piano_90_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ToweringTwilight_Focus_Creativity_Piano_90_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/ToweringTwilight_Focus_Creativity_Piano_90_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27289100,
      "sha256": "d66be745d23216286478e2639178a20224255c9c11059625bb7e8f79827b455d",
      "download_error": null
    },
    {
      "track_id": "689a23ae9446c76349a3b7cd",
      "name": "Marchmont",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.26,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Marchmont_Focus_Learning_Piano_120_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=BSstmJjYRe7e4TTbcd4yaRw4N1CdsVX2o8DDtqTvd0k%3D",
      "cdn_url": "https://audio2.brain.fm/Marchmont_Focus_Learning_Piano_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Marchmont_Focus_Learning_Piano_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Marchmont_Focus_Learning_Piano_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Marchmont_Focus_Learning_Piano_120_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26280560,
      "sha256": "307a43b2d3a397172f6018e8ac9de899f63757c33a283c164cb87cd0d92af3c3",
      "download_error": null
    },
    {
      "track_id": "6888c92bb997579cf699b8a6",
      "name": "Gratuity",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.19,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Gratuity_Focus_DeepWork_Piano_30_90BPM_LowNEL_VBR5.mp3?expiration=1792292138658&token=pzH7rIcBwDpMQY51dT3np4eT3ccol29d%2BNK%2B4KOCkKw%3D",
      "cdn_url": "https://audio2.brain.fm/Gratuity_Focus_DeepWork_Piano_30_90BPM_LowNEL_VBR5.mp3",
      "remote_filename": "Gratuity_Focus_DeepWork_Piano_30_90BPM_LowNEL_VBR5.mp3",
      "filename": "Gratuity_Focus_DeepWork_Piano_30_90BPM_LowNEL_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Gratuity_Focus_DeepWork_Piano_30_90BPM_LowNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23838103,
      "sha256": "63d2f3d21d412c149870b9171676037858e3e811f8e97fbaa7185262a341d853",
      "download_error": null
    },
    {
      "track_id": "6888c91bc24bb893747ef6fb",
      "name": "Silent Harbor",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.25,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SilentHarbor_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=VjKoCpEg%2FFT8uDr%2BjrurECNLwIjqpMGToq9Zlge7hD0%3D",
      "cdn_url": "https://audio2.brain.fm/SilentHarbor_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SilentHarbor_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SilentHarbor_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SilentHarbor_Focus_Creativity_Piano_130_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27482021,
      "sha256": "681c91b908baa7a4b0753d319448727166c773d1806c130875ed9cb7fb2b930c",
      "download_error": null
    },
    {
      "track_id": "687550ee3b891fead18aba0d",
      "name": "Moonstruck",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.36,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Snowblind_Focus_Learning_Cinematic_124_MedNEL_VBR5.mp3?expiration=1792292138658&token=%2FoyaBN28iiOxOqJEnUtJQw%2FoaEdvr%2BERxMtjG1UHdY0%3D",
      "cdn_url": "https://audio2.brain.fm/Snowblind_Focus_Learning_Cinematic_124_MedNEL_VBR5.mp3",
      "remote_filename": "Snowblind_Focus_Learning_Cinematic_124_MedNEL_VBR5.mp3",
      "filename": "Snowblind_Focus_Learning_Cinematic_124_MedNEL_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Snowblind_Focus_Learning_Cinematic_124_MedNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30633411,
      "sha256": "2bbb9b9c3e3a1b7dd711d1cc81ede4a04b5c282f480f5fcf8d628e2e60c996e7",
      "download_error": null
    },
    {
      "track_id": "6862f12b7689f5af5f0456e0",
      "name": "Boxwood",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 76,
      "brightness_level": 0.17,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Boxwood_Focus_Learning_Piano_76_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=3gOIuKTL0O5VESeXQPx25mAmzDuCGLDdWBIP390WXqs%3D",
      "cdn_url": "https://audio2.brain.fm/Boxwood_Focus_Learning_Piano_76_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Boxwood_Focus_Learning_Piano_76_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Boxwood_Focus_Learning_Piano_76_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Boxwood_Focus_Learning_Piano_76_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24044739,
      "sha256": "39959325e03b03dd5b3fe6b1ec3f1620479b784268fd41430cf18d3df2fa87a2",
      "download_error": null
    },
    {
      "track_id": "68505d125de2e833e430b510",
      "name": "Plain As Water",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.2,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/PlainAsWater_Focus_DeepWork_Piano_86_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=C0OpFigEn%2FoxeKLbCFXes1pUKhfkBKxfxNOIKJJlfoU%3D",
      "cdn_url": "https://audio2.brain.fm/PlainAsWater_Focus_DeepWork_Piano_86_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PlainAsWater_Focus_DeepWork_Piano_86_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PlainAsWater_Focus_DeepWork_Piano_86_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/PlainAsWater_Focus_DeepWork_Piano_86_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26373554,
      "sha256": "cf01314e828e43bbe919f92185adf3ab69697a27c9e7331369f4284d0065b9c4",
      "download_error": null
    },
    {
      "track_id": "68505ceaf6a8ec8278221a42",
      "name": "Precise Movements",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.23,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/PreciseMovements_Focus_Learning_Piano_96_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=ou5Wau0bMGn2YAkG8gEOOFz9jFS%2FvTjh3sv8U1mHLHg%3D",
      "cdn_url": "https://audio2.brain.fm/PreciseMovements_Focus_Learning_Piano_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PreciseMovements_Focus_Learning_Piano_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PreciseMovements_Focus_Learning_Piano_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/PreciseMovements_Focus_Learning_Piano_96_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26798271,
      "sha256": "4151906679f899aff3fc5ec91828e7ac85f56908b53dad8df14bf2f7295964fb",
      "download_error": null
    },
    {
      "track_id": "68505c205de2e833e430b154",
      "name": "Morning Meadow",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.19,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/MorningMeadow_Focus_Creativity_Piano_112_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=AMub1NnweqIw7Dcn1TxD9XE2G7ngbPtkvaZ6FYkXrRQ%3D",
      "cdn_url": "https://audio2.brain.fm/MorningMeadow_Focus_Creativity_Piano_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MorningMeadow_Focus_Creativity_Piano_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MorningMeadow_Focus_Creativity_Piano_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/MorningMeadow_Focus_Creativity_Piano_112_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24627485,
      "sha256": "ede3f293378c74ef3b80fedaac0d6c86d99e51575293b8e3d3033e0abab37ed3",
      "download_error": null
    },
    {
      "track_id": "683dc8147e70e7db4e0af204",
      "name": "Drifting Echoes",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.19,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/DriftingEchoes_Focus_DeepWork_Piano_30_86BPM_LowNELNrmlzd2_VBR5.mp3?expiration=1792292138658&token=XLWFVT5kyN81r9aGmTP1093pKeKZnNK121OMxsIF%2FK0%3D",
      "cdn_url": "https://audio2.brain.fm/DriftingEchoes_Focus_DeepWork_Piano_30_86BPM_LowNELNrmlzd2_VBR5.mp3",
      "remote_filename": "DriftingEchoes_Focus_DeepWork_Piano_30_86BPM_LowNELNrmlzd2_VBR5.mp3",
      "filename": "DriftingEchoes_Focus_DeepWork_Piano_30_86BPM_LowNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/DriftingEchoes_Focus_DeepWork_Piano_30_86BPM_LowNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23525014,
      "sha256": "b57a04915f8b3d23a66031e4835b0ecc1c5a5da7d1d58965cdc5369afaaa5f32",
      "download_error": null
    },
    {
      "track_id": "682b562e8ab5a645af483f8d",
      "name": "Major Cycles",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 104,
      "brightness_level": 0.17,
      "complexity_level": 0.05,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/MajorCycles_Focus_DeepWork_Piano_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=iQYwZTNDwOgwmJji3loPNMXXv8RGSnEqkOJT4i6JiX0%3D",
      "cdn_url": "https://audio2.brain.fm/MajorCycles_Focus_DeepWork_Piano_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MajorCycles_Focus_DeepWork_Piano_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MajorCycles_Focus_DeepWork_Piano_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/MajorCycles_Focus_DeepWork_Piano_30_104BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24525784,
      "sha256": "28a93cbeb9c3aeebef4b84bb397e8c0160cce4a53a415eaf25d6e23f96fd0ee4",
      "download_error": null
    },
    {
      "track_id": "6818d1a3c7fc795ec060eed5",
      "name": "Over Time",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.25,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/OverTime_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=b%2FIyRV3ahemvoH9puKQC74mQ3uiThrVgfajKFg3BjV0%3D",
      "cdn_url": "https://audio2.brain.fm/OverTime_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OverTime_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "OverTime_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/OverTime_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24067888,
      "sha256": "9e6c3b6f2a69f404b22a22c6f814beb18e909cb1857e50654f5d98a27621708f",
      "download_error": null
    },
    {
      "track_id": "68065aaab22afee121312979",
      "name": "A Reflection On Time",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.2,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/AReflectionOnTime_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=7wvLeEcBXjj6ZG0GefthUg6J40vjK1j0Ejp2n8DQR%2BI%3D",
      "cdn_url": "https://audio2.brain.fm/AReflectionOnTime_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AReflectionOnTime_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AReflectionOnTime_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/AReflectionOnTime_Focus_DeepWork_Piano_30_120BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19104824,
      "sha256": "19ae8b30ce057c1eb39a9c684296e2f04e6123e358753c8230a203a250bfff8a",
      "download_error": null
    },
    {
      "track_id": "67f3eb8ca0de2348f748e62e",
      "name": "Untraced",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.04,
      "complexity_level": 0.08,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Untraced_Focus_DeepWork_Piano_30_108bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=VUt%2F4Q6BvWed1t6xOKHiEWmOXpCNggM7H6VpSDdgnzg%3D",
      "cdn_url": "https://audio2.brain.fm/Untraced_Focus_DeepWork_Piano_30_108bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Untraced_Focus_DeepWork_Piano_30_108bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Untraced_Focus_DeepWork_Piano_30_108bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Untraced_Focus_DeepWork_Piano_30_108bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26619932,
      "sha256": "a1bd8a13176f2a443bc75801df9c607d62b4f60f2d90a9d719e62d53c968a143",
      "download_error": null
    },
    {
      "track_id": "67cf0341593aad5348b95c59",
      "name": "Timelapsing",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 128,
      "brightness_level": 0.22,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Timelapsing_Focus_DeepWork_Piano_128_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=S7%2F1cztd2Basljfbz65Aqfl3je4TXPSSu1cMtT4Td6s%3D",
      "cdn_url": "https://audio2.brain.fm/Timelapsing_Focus_DeepWork_Piano_128_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Timelapsing_Focus_DeepWork_Piano_128_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Timelapsing_Focus_DeepWork_Piano_128_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Timelapsing_Focus_DeepWork_Piano_128_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26114628,
      "sha256": "68fd5c8adf762efe64b46d25c1484b4e0c95609aa2eba3ff4a831fe382fd9973",
      "download_error": null
    },
    {
      "track_id": "67855b5bf76968728486ad14",
      "name": "Windbent",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.45,
      "complexity_level": 0.53,
      "style": "normal",
      "neural_effect_level": 0.75,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Windbent_Focus_DeepWork_Piano_100_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=p9VqIjxm5P6pyg5f%2FRpQgvzC4uS3RrMkXpgXysO%2BOD0%3D",
      "cdn_url": "https://audio2.brain.fm/Windbent_Focus_DeepWork_Piano_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Windbent_Focus_DeepWork_Piano_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Windbent_Focus_DeepWork_Piano_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Windbent_Focus_DeepWork_Piano_100_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27506804,
      "sha256": "073292b61b52d127ed640f50d94581fa112c8e1aa726506c5d823598692c3001",
      "download_error": null
    },
    {
      "track_id": "6728ec2b8bc23988fd647176",
      "name": "Aurelian",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.2,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Aurelian_Focus_Creativity_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=EFm6cpcKi1Pg6cfV9cugbMGhpqVDMsJKGMTk4g0PAD8%3D",
      "cdn_url": "https://audio2.brain.fm/Aurelian_Focus_Creativity_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Aurelian_Focus_Creativity_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Aurelian_Focus_Creativity_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Aurelian_Focus_Creativity_Piano_130_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24311211,
      "sha256": "6e287c5320d5496cbcb0e25452ff484cda421b073153e93a04ad3815fec50489",
      "download_error": null
    },
    {
      "track_id": "6716a185ae8c98e954dc5aa0",
      "name": "Thinking Patterns",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.24,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/ThinkingPatterns_Focus_Creativity_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=8s8Oit0niPQE91I9yz8B3qBE91yvQfbumFSU21jsVzw%3D",
      "cdn_url": "https://audio2.brain.fm/ThinkingPatterns_Focus_Creativity_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ThinkingPatterns_Focus_Creativity_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ThinkingPatterns_Focus_Creativity_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/ThinkingPatterns_Focus_Creativity_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22941304,
      "sha256": "29674ea13714ffdb630a9cb72be585f9b3c8f33cd2d45c62feaad1b2788e8367",
      "download_error": null
    },
    {
      "track_id": "6703e35da1f0c0804124feb7",
      "name": "Spirited Solitude",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.27,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SpiritedSolitude_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=T8ie6MZ9xq1FK1fso8DVSaYqIrNf7R1ytzbo68uSDUQ%3D",
      "cdn_url": "https://audio2.brain.fm/SpiritedSolitude_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SpiritedSolitude_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SpiritedSolitude_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SpiritedSolitude_Focus_Learning_Piano_120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24403359,
      "sha256": "39578f7a0b4ad3894666f168def711f99cdc3f63db727995e8dc9bdabdbf3ef3",
      "download_error": null
    },
    {
      "track_id": "6703e351a1f0c0804124fe5a",
      "name": "Topography",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 132,
      "brightness_level": 0.24,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Topography_Focus_DeepWork_Piano_132_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=%2BFkHYWSSBYP80PVCqzwCCWMz39iSjlKY0ftvRjDPfds%3D",
      "cdn_url": "https://audio2.brain.fm/Topography_Focus_DeepWork_Piano_132_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Topography_Focus_DeepWork_Piano_132_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Topography_Focus_DeepWork_Piano_132_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Topography_Focus_DeepWork_Piano_132_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26503667,
      "sha256": "80984d8d08240334190c9b915f3ad9b204a1f142ce4fdb9a9ae3303165ba9691",
      "download_error": null
    },
    {
      "track_id": "6703e2a3a1f0c0804124fb6a",
      "name": "Prospects",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.22,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Prospects_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=thfg0gBrkGkBjPISU2lU%2BBI46yJODSWa159G2Zztc7g%3D",
      "cdn_url": "https://audio2.brain.fm/Prospects_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Prospects_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Prospects_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Prospects_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24956476,
      "sha256": "9754616bd833bc35e2ba4df9bc47e27d38bbff7bf66df37e4c9d06e079e52feb",
      "download_error": null
    },
    {
      "track_id": "66f178429ef5eee4a2c96884",
      "name": "Secrets Revealed",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.27,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SecretsRevealed_Focus_Learning_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=%2BrupVeUXwAtPHA2kSLq9CtXerL2Zg4xtTse%2FKy8HvMg%3D",
      "cdn_url": "https://audio2.brain.fm/SecretsRevealed_Focus_Learning_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SecretsRevealed_Focus_Learning_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SecretsRevealed_Focus_Learning_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SecretsRevealed_Focus_Learning_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24289131,
      "sha256": "c5ea8d4c3a7d4ab07efe9031543b1ade61a493a0de83410c2c684f10cfe431b8",
      "download_error": null
    },
    {
      "track_id": "66f17779d7073bdb17919772",
      "name": "Parting Company",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.24,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/PartingCompany_Focus_Learning_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=yehSlniXwR916LE5GnvLsZsY6TMdQ9YEuyFeBOShps4%3D",
      "cdn_url": "https://audio2.brain.fm/PartingCompany_Focus_Learning_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PartingCompany_Focus_Learning_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "PartingCompany_Focus_Learning_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/PartingCompany_Focus_Learning_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26184799,
      "sha256": "0eaf7878d4f83fb7aba8d2f6ebd723ee95048f45c6869e5fd315fb39a7040be3",
      "download_error": null
    },
    {
      "track_id": "66df0112edad68879383698f",
      "name": "Monumental Growth",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.27,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/MonumentalGrowth_Focus_Creativity_Piano_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=jQB2YEGoVchIJmTOAMY1nFOHR9Umh6bIH%2BuzaDumavo%3D",
      "cdn_url": "https://audio2.brain.fm/MonumentalGrowth_Focus_Creativity_Piano_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MonumentalGrowth_Focus_Creativity_Piano_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MonumentalGrowth_Focus_Creativity_Piano_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/MonumentalGrowth_Focus_Creativity_Piano_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23453985,
      "sha256": "bfd0861cc0a3c22f95cc2076d12cafbf57fb82226130a79664c7e42fe3736b47",
      "download_error": null
    },
    {
      "track_id": "66df0100edad688793836949",
      "name": "Remembrance",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.5,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Rememberance_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=NvE%2Fl6ia%2Foh09ChqW0BvUX2GjDdwd%2Fq%2FhiWDk5Gg3Qw%3D",
      "cdn_url": "https://audio2.brain.fm/Rememberance_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Rememberance_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Rememberance_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Rememberance_Focus_Creativity_Piano_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25832333,
      "sha256": "c5b6eb35dcc5cbce30dc4d3ec67c7645e44d5c1b0382e2484418b5265473f566",
      "download_error": null
    },
    {
      "track_id": "66918bfcde19d0f1c74ea944",
      "name": "Sophia",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.11,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Sophia_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=6S%2F9D97R1Z5Y8lFPN3K6923n7e4VJUWkoln%2ByB6a8Y0%3D",
      "cdn_url": "https://audio2.brain.fm/Sophia_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sophia_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sophia_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Sophia_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24586303,
      "sha256": "9428d07e79c880fb18b7de70490452d96614feb3966f9814b8a806ca63944b3b",
      "download_error": null
    },
    {
      "track_id": "666c9d17644ac8615d52ad2d",
      "name": "Nothing Remains",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.27,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/NothingRemains_Focus_DeepWork_Piano_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=nS6cXotQV4w2rBSdrZEuQjZy4ZXCCP%2B%2Fh5%2FK924QuA8%3D",
      "cdn_url": "https://audio2.brain.fm/NothingRemains_Focus_DeepWork_Piano_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NothingRemains_Focus_DeepWork_Piano_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NothingRemains_Focus_DeepWork_Piano_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/NothingRemains_Focus_DeepWork_Piano_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25642591,
      "sha256": "faa23972bb2e7965870c292535b28a39640932323f905086d35a7f3abeb9d51f",
      "download_error": null
    },
    {
      "track_id": "665a23424dfb90cc19dce007",
      "name": "Dying Ember",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.21,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/DyingEmber_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=c5UWJO4667Id%2BYe%2F4OFOetlc4ZcUrx7Bl0yEeoBTh3s%3D",
      "cdn_url": "https://audio2.brain.fm/DyingEmber_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DyingEmber_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DyingEmber_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/DyingEmber_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25371700,
      "sha256": "b870c45c00b2ceb36b6f11233a49bb92951bb1ce3f79930d39070211ca63bcd0",
      "download_error": null
    },
    {
      "track_id": "665a22cd4dfb90cc19dcdc16",
      "name": "Provincial",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.22,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Provincial_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=wyIwaf9Q7%2BFGUHgoiuh6OL6oLdTGwcE%2BonQI8ist3mU%3D",
      "cdn_url": "https://audio2.brain.fm/Provincial_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Provincial_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Provincial_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Provincial_Focus_DeepWork_Piano_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26193168,
      "sha256": "50876d2749291b550af9d43b25c1bd9dc1badd0f28d220cd9d3ea88ba30b8e58",
      "download_error": null
    },
    {
      "track_id": "663537304eae15761ad505e3",
      "name": "Sonus",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.23,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Sonus_Focus_DeepWork_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=T8Afc6a10PJCcvIdQTO306scXGV7zLKBbkhGGZTwEt4%3D",
      "cdn_url": "https://audio2.brain.fm/Sonus_Focus_DeepWork_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sonus_Focus_DeepWork_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sonus_Focus_DeepWork_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Sonus_Focus_DeepWork_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26010912,
      "sha256": "8c287b159b833d5a40e7a84bbaad3f44fa07a119c75b88f81c535e972b79a284",
      "download_error": null
    },
    {
      "track_id": "6622cf39918ea2b454f7a9dd",
      "name": "Glistening Tides",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.12,
      "complexity_level": 0.54,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/GlisteningTides_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=r45awriQUjO%2B5VCsBfa2xmeDBYYCuaUbaXOCoBsuagY%3D",
      "cdn_url": "https://audio2.brain.fm/GlisteningTides_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GlisteningTides_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GlisteningTides_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/GlisteningTides_Focus_DeepWork_Piano_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25636992,
      "sha256": "bc4bf56a4ee666afc696d623976728b57762efb1cabeca5532c5fb223352c947",
      "download_error": null
    },
    {
      "track_id": "65d9208d970b46000863edfe",
      "name": "Wabansia",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.32,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Wabansia_Focus_DeepWork_Piano_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=1Bvi55fgAMipcYyaEM92O6W7zbI1wpEoSnzqWSYir0k%3D",
      "cdn_url": "https://audio2.brain.fm/Wabansia_Focus_DeepWork_Piano_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Wabansia_Focus_DeepWork_Piano_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Wabansia_Focus_DeepWork_Piano_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Wabansia_Focus_DeepWork_Piano_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28012412,
      "sha256": "62b48a149d3671457af08e93345fe130e19c1db80d0171c74f5a4b973cb14eeb",
      "download_error": null
    },
    {
      "track_id": "658064a04368b916a7f903bd",
      "name": "In the Library",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 6493,
      "beats_per_minute": 126,
      "brightness_level": 0.29,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/IntheLibrary_Focus_Creativity_Piano_30_126bpm_MedNEL_Nrmlzd2_expanded_VBR5.mp3?expiration=1792292138658&token=MkiZVBAnW%2BZL442idQP0JWSOFmN5JwkhvetYx9J9lGc%3D",
      "cdn_url": "https://audio2.brain.fm/IntheLibrary_Focus_Creativity_Piano_30_126bpm_MedNEL_Nrmlzd2_expanded_VBR5.mp3",
      "remote_filename": "IntheLibrary_Focus_Creativity_Piano_30_126bpm_MedNEL_Nrmlzd2_expanded_VBR5.mp3",
      "filename": "IntheLibrary_Focus_Creativity_Piano_30_126bpm_MedNEL_Nrmlzd2_expanded_VBR5.mp3",
      "relative_path": "outputs/audio/piano/IntheLibrary_Focus_Creativity_Piano_30_126bpm_MedNEL_Nrmlzd2_expanded_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 95380264,
      "sha256": "6fc987e0690fb4d07ddab4f73f77229721db6e82a77774f6bb7661ea5f8b73f0",
      "download_error": null
    },
    {
      "track_id": "6531645abab2d69f4d19e52c",
      "name": "Corde Raide",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 129,
      "brightness_level": 0.21,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/CordeRaide_Focus_Learning_Piano_30_129bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=Jo0z0HhPGzr%2BIwywYoiUe6yp2r%2FTomA%2FsxEa3sgWMUw%3D",
      "cdn_url": "https://audio2.brain.fm/CordeRaide_Focus_Learning_Piano_30_129bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CordeRaide_Focus_Learning_Piano_30_129bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CordeRaide_Focus_Learning_Piano_30_129bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/CordeRaide_Focus_Learning_Piano_30_129bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24914476,
      "sha256": "522dbeb7e102d553c00154aad0e6411f74d67c82b952732a808505c083f3a978",
      "download_error": null
    },
    {
      "track_id": "651ddb2a4489f2dc850d95da",
      "name": "Mind Palace",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.64,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.95,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/MindPalace_Focus_Creativity_Piano_30_82bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=WySsHPbUOPPPjVFZl3eaJzDKLv%2BIyYIOpH9qxkOCjzE%3D",
      "cdn_url": "https://audio2.brain.fm/MindPalace_Focus_Creativity_Piano_30_82bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MindPalace_Focus_Creativity_Piano_30_82bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MindPalace_Focus_Creativity_Piano_30_82bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/MindPalace_Focus_Creativity_Piano_30_82bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26180851,
      "sha256": "ef4e43b0c2263b163fe40f3d40b173308398b04dc27848391a5c0c26f2df2212",
      "download_error": null
    },
    {
      "track_id": "64f9e910eea22bdd017fe1d6",
      "name": "See Glass",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 92,
      "brightness_level": 0.15,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SeeGlass_Focus_Creativity_Piano_30_92bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=%2BIraM%2FF8sEzEpElspIt1i4PVZxOyRgATCxn4%2BYjqa5o%3D",
      "cdn_url": "https://audio2.brain.fm/SeeGlass_Focus_Creativity_Piano_30_92bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SeeGlass_Focus_Creativity_Piano_30_92bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SeeGlass_Focus_Creativity_Piano_30_92bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SeeGlass_Focus_Creativity_Piano_30_92bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25625453,
      "sha256": "7b4bd1a22c6e67bc4f051237c326b2dfd1fa93f19b3f26371d06cdaa7920a893",
      "download_error": null
    },
    {
      "track_id": "64302df023c3beced23fc1a3",
      "name": "White Hills",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.23,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/WhiteHills_Focus_Learning_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=sEIjKHtMUj81rt2Fywb3joAwCKaTFqOKu8V2hUoFcY8%3D",
      "cdn_url": "https://audio2.brain.fm/WhiteHills_Focus_Learning_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WhiteHills_Focus_Learning_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WhiteHills_Focus_Learning_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/WhiteHills_Focus_Learning_Piano_30_110bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22273093,
      "sha256": "38058eaea8d719614cc9f177bac65954e0def5365e021b59446d8591f2a45fca",
      "download_error": null
    },
    {
      "track_id": "64302da45ee24c1d8da071b4",
      "name": "Unwavering",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.74,
      "complexity_level": 0.9,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Unwavering_Focus_Learning_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=fct98GSIWd34sQ6PjasADN7R63NsbtGaU%2BR7Svh07%2Bc%3D",
      "cdn_url": "https://audio2.brain.fm/Unwavering_Focus_Learning_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unwavering_Focus_Learning_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unwavering_Focus_Learning_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Unwavering_Focus_Learning_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25635016,
      "sha256": "8dc3b59aec7d9ed64199f9b26225d6ac7838f41da065cc234a5d2369e33a7360",
      "download_error": null
    },
    {
      "track_id": "64302d325ee24cae8ba06e4f",
      "name": "Somber Tones",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.3,
      "complexity_level": 0.63,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SomberTones_Focus_DeepWork_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=xLFPZFEbBpDWl4Yh01kL9mbtDGzIjhDPzGDqur80lgQ%3D",
      "cdn_url": "https://audio2.brain.fm/SomberTones_Focus_DeepWork_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SomberTones_Focus_DeepWork_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SomberTones_Focus_DeepWork_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SomberTones_Focus_DeepWork_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23961775,
      "sha256": "963945d713d99caa30a581eca8a273e55767d15392e892251ef930d912366518",
      "download_error": null
    },
    {
      "track_id": "64302cdf5ee24cfe14a06d83",
      "name": "Sandstone Cliffs",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 123,
      "brightness_level": 0.41,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/SandstoneCliffs_Focus_DeepWork_Piano_30_123bpm_MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=w55pQKBacQmW3588k%2Fm85FWwo9WeNyldW5dpG5gda8c%3D",
      "cdn_url": "https://audio2.brain.fm/SandstoneCliffs_Focus_DeepWork_Piano_30_123bpm_MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SandstoneCliffs_Focus_DeepWork_Piano_30_123bpm_MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "SandstoneCliffs_Focus_DeepWork_Piano_30_123bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/SandstoneCliffs_Focus_DeepWork_Piano_30_123bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27032448,
      "sha256": "f190c562bd1db7e8e6cfd80eb0613f8d02b8732f69dc6dd2d18c6f1575a19177",
      "download_error": null
    },
    {
      "track_id": "64302b935ee24c6b60a06341",
      "name": "Memories of Summer",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.24,
      "complexity_level": 2.2,
      "style": "normal",
      "neural_effect_level": 0.98,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/MemoriesofSummer_Focus_DeepWork_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=x1W0uXiSc3%2Bnti7Ub55v%2BsO%2BepaoRpijMQSuc9d%2BDYw%3D",
      "cdn_url": "https://audio2.brain.fm/MemoriesofSummer_Focus_DeepWork_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MemoriesofSummer_Focus_DeepWork_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MemoriesofSummer_Focus_DeepWork_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/MemoriesofSummer_Focus_DeepWork_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23335255,
      "sha256": "823328f77d21fb5f6f9ef38c3f266fcea5aba0e85866fac3b3529141507a3a5b",
      "download_error": null
    },
    {
      "track_id": "64302b5e23c3be2ccd3fb2a8",
      "name": "Light as a Feather",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 140,
      "brightness_level": 0.23,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/LightasaFeather_Focus_DeepWork_Piano_30_140bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=6XzJuwlDejtO65YqUPU0Eim8QK02ElVl3AN2N%2FceVHM%3D",
      "cdn_url": "https://audio2.brain.fm/LightasaFeather_Focus_DeepWork_Piano_30_140bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LightasaFeather_Focus_DeepWork_Piano_30_140bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LightasaFeather_Focus_DeepWork_Piano_30_140bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/LightasaFeather_Focus_DeepWork_Piano_30_140bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23919482,
      "sha256": "e0a39af910dcf8a60e4130b287684b075cc6bd76cdbfdb654675284de3ff4930",
      "download_error": null
    },
    {
      "track_id": "64302abd5ee24c3663a05dd9",
      "name": "Garden of Delights",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.17,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/GardenofDelights_Focus_Learning_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=lTA9QJMz%2BTJCbN4DU7pD1AUir7CwYgL%2FMAT2fPaI5aY%3D",
      "cdn_url": "https://audio2.brain.fm/GardenofDelights_Focus_Learning_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GardenofDelights_Focus_Learning_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GardenofDelights_Focus_Learning_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/GardenofDelights_Focus_Learning_Piano_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22825705,
      "sha256": "2201e99446fafb00657e0c4b78e38aa0182f3047d0069fd0824364c6ab85795c",
      "download_error": null
    },
    {
      "track_id": "64302ab35ee24c456fa05dac",
      "name": "Firmament",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.26,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.78,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Firmament_Focus_Creativity_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=oET9xLpg7dlG2IWx4XkWVhqYiCm1jF5O2qNJAO7emUA%3D",
      "cdn_url": "https://audio2.brain.fm/Firmament_Focus_Creativity_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Firmament_Focus_Creativity_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Firmament_Focus_Creativity_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Firmament_Focus_Creativity_Piano_30_130bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23925084,
      "sha256": "ddb99505b9107d709241604aaafe3bd6cec87a41111bd69a2cedcb0586f4a2e2",
      "download_error": null
    },
    {
      "track_id": "64302aa623c3be507f3faff2",
      "name": "Fireplace",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.26,
      "complexity_level": 0.43,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Fireplace_Focus_Learning_Piano_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=qpvmPO3%2FEJ9flMwQxaZH9wGtreeBH3IHg41fACisINM%3D",
      "cdn_url": "https://audio2.brain.fm/Fireplace_Focus_Learning_Piano_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fireplace_Focus_Learning_Piano_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fireplace_Focus_Learning_Piano_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Fireplace_Focus_Learning_Piano_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25770317,
      "sha256": "0cc0226b8d6fa09daac1529150d599267021148b463cc746e6339efe1f69d7c7",
      "download_error": null
    },
    {
      "track_id": "64302a7e23c3be7bef3faf08",
      "name": "Eleusis",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.48,
      "complexity_level": 0.84,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Eleusis_Focus_DeepWork_Piano_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=4kbW%2FaRGZFZiwXUGhW7sksOY8%2FJ1ii0RT9eh%2FvHYHxw%3D",
      "cdn_url": "https://audio2.brain.fm/Eleusis_Focus_DeepWork_Piano_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Eleusis_Focus_DeepWork_Piano_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Eleusis_Focus_DeepWork_Piano_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Eleusis_Focus_DeepWork_Piano_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25018464,
      "sha256": "58e576fb2fa6cbe59cf4f326451efdceb4bf66b3332fe26d28f1f38b48f4f68f",
      "download_error": null
    },
    {
      "track_id": "643029a25ee24cdf13a0565a",
      "name": "Canyons",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.13,
      "complexity_level": 0.13,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Canyons%20Piano%20Focus%20Creative%20Flow%20Conor_1.4_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=%2B9Af3bakrul8Dt%2FbVjwzX27IunUMQw%2FHVfFjugwxQEo%3D",
      "cdn_url": "https://audio2.brain.fm/Canyons%20Piano%20Focus%20Creative%20Flow%20Conor_1.4_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Canyons Piano Focus Creative Flow Conor_1.4_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Canyons-Piano-Focus-Creative-Flow-Conor_1.4_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Canyons-Piano-Focus-Creative-Flow-Conor_1.4_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26945611,
      "sha256": "253585e812109a374e07c42e2b60e0db1cc9e57f83d2ddeb706e832279a2c24b",
      "download_error": null
    },
    {
      "track_id": "643028b323c3be14123fa680",
      "name": "Albatross",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Albatross%20Piano%20Focus%20Creative%20Flow%20Conor_1.3_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=93Rf01ryfLkQVVrTSvyLGL3TxdaCA5oj7aL2vS1hTv4%3D",
      "cdn_url": "https://audio2.brain.fm/Albatross%20Piano%20Focus%20Creative%20Flow%20Conor_1.3_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Albatross Piano Focus Creative Flow Conor_1.3_Nrmlzd2_VBR5.mp3",
      "filename": "Albatross-Piano-Focus-Creative-Flow-Conor_1.3_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Albatross-Piano-Focus-Creative-Flow-Conor_1.3_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22667048,
      "sha256": "543c798936660e68dbfb6375fdf06a1d5396f226596c2895245c82da586d82cf",
      "download_error": null
    },
    {
      "track_id": "6303e91ac2945cf064eddb00",
      "name": "Eysas",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 86,
      "brightness_level": 0.21,
      "complexity_level": 0.7,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Eysas_Focus_Learning_Piano_30_86bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=nmLUOxpZZPfHa4TEFrzffTgkV0E8Nr0LTplqHI4SM8s%3D",
      "cdn_url": "https://audio2.brain.fm/Eysas_Focus_Learning_Piano_30_86bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Eysas_Focus_Learning_Piano_30_86bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Eysas_Focus_Learning_Piano_30_86bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Eysas_Focus_Learning_Piano_30_86bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27331606,
      "sha256": "4a58c7223a1741d8c1423ceddf36030194d653d33d394b61c72cf0783c048810",
      "download_error": null
    },
    {
      "track_id": "6303e8cd66486082aa1826ed",
      "name": "Sycamore",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.22,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Sycamore_Focus_Learning_Piano_30_130bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=lu%2BgN543al0Azrb4HyhAAqcT5idPFqMB%2BGBeoLKnBeE%3D",
      "cdn_url": "https://audio2.brain.fm/Sycamore_Focus_Learning_Piano_30_130bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sycamore_Focus_Learning_Piano_30_130bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Sycamore_Focus_Learning_Piano_30_130bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Sycamore_Focus_Learning_Piano_30_130bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26044784,
      "sha256": "bb8ee6d9f3c070ed2669f81e79732cc6804ca6379f58174d6b561f230a971fac",
      "download_error": null
    },
    {
      "track_id": "6303e80e6648606c07182108",
      "name": "Persephone",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.28,
      "complexity_level": 0.52,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Persephone_Focus_DeepWork_Piano_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=ldVkf6dU62lMMMpzf9dloTakK8SWQyWfwOfLHnlmWF4%3D",
      "cdn_url": "https://audio2.brain.fm/Persephone_Focus_DeepWork_Piano_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Persephone_Focus_DeepWork_Piano_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Persephone_Focus_DeepWork_Piano_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Persephone_Focus_DeepWork_Piano_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26608158,
      "sha256": "6108b8ea0bff6f19b047965642a71093199f8ac884a02f19940c5a701243d726",
      "download_error": null
    },
    {
      "track_id": "6303e72b664860edb5181c49",
      "name": "Demeter",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.3,
      "complexity_level": 0.41,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Demeter_Focus_DeepWork_Piano_30_80bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=CvFM8M40PftF%2F4w9Hbug5zoSpEWrol2tdHY3jTuZRVY%3D",
      "cdn_url": "https://audio2.brain.fm/Demeter_Focus_DeepWork_Piano_30_80bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Demeter_Focus_DeepWork_Piano_30_80bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Demeter_Focus_DeepWork_Piano_30_80bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Demeter_Focus_DeepWork_Piano_30_80bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26715834,
      "sha256": "034ffaba1c3502fdb6215af8556df067cb4fac776b142c8ff5a07dfb5ec7b385",
      "download_error": null
    },
    {
      "track_id": "6303e6a26648603d94181696",
      "name": "Waterfall Bridge",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.26,
      "complexity_level": 0.79,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Waterfall%20Bridge_Focus_Learning_Piano_30_112bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=oOffjuanSm2wC%2FNNM9dfRLsk3QjXL%2FQx7p8Muu9hizo%3D",
      "cdn_url": "https://audio2.brain.fm/Waterfall%20Bridge_Focus_Learning_Piano_30_112bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Waterfall Bridge_Focus_Learning_Piano_30_112bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Waterfall-Bridge_Focus_Learning_Piano_30_112bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Waterfall-Bridge_Focus_Learning_Piano_30_112bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26861506,
      "sha256": "f264140c7910cb5290597ed2a855500cb3eb1be0f7131cabb1b12ddb4761cd2e",
      "download_error": null
    },
    {
      "track_id": "6303e465c2945c6789edbc59",
      "name": "Keranga",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 106,
      "brightness_level": 0.44,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Keranga_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=UJAbiF3AN8budPL5VF9MFTxyIPixALTFtF0REJ0WHK0%3D",
      "cdn_url": "https://audio2.brain.fm/Keranga_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Keranga_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Keranga_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Keranga_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27336264,
      "sha256": "2382699d62280e1a1b8c062fe4f7d54fccc2244c64186bb27127734abbc3ed81",
      "download_error": null
    },
    {
      "track_id": "6303e3eac2945cbe28edb7ba",
      "name": "Juniper",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 106,
      "brightness_level": 0.29,
      "complexity_level": 0.54,
      "style": "normal",
      "neural_effect_level": 0.86,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Juniper_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=gRpfqD%2Fif8Kvyc4xtQMwNIBLQDLDNWV0%2Fr%2FV5%2B3QdwQ%3D",
      "cdn_url": "https://audio2.brain.fm/Juniper_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Juniper_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Juniper_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Juniper_Focus_Learning_Piano_30_106bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27618265,
      "sha256": "475bba6f31441d955fb6bee466d992ed99207989cbe89645881c03b928370772",
      "download_error": null
    },
    {
      "track_id": "6303de04c2945ceb05ed8cba",
      "name": "Belle Plaine",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.41,
      "complexity_level": 0.5,
      "style": "normal",
      "neural_effect_level": 0.9,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Belle%20Plaine_Focus_Learning_Piano_30_96bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=2gDbmLbQ1ULilw8I7YUY9KVk4j02UBfnD6MJNGiEO6s%3D",
      "cdn_url": "https://audio2.brain.fm/Belle%20Plaine_Focus_Learning_Piano_30_96bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Belle Plaine_Focus_Learning_Piano_30_96bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Belle-Plaine_Focus_Learning_Piano_30_96bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Belle-Plaine_Focus_Learning_Piano_30_96bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27094860,
      "sha256": "f8489ec3b28e33c992a11b0b6d30dfbacb68e91dbff4617ac57bfc39c5636f41",
      "download_error": null
    },
    {
      "track_id": "6303dc46664860d96617d064",
      "name": "Solis",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 102,
      "brightness_level": 0.53,
      "complexity_level": 0.63,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Solis_Focus_DeepWork_Piano_30_102bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=%2FpwUrC%2BNue7YbP%2B04R7kbki99rH8sxlwAtui4JYv4Qo%3D",
      "cdn_url": "https://audio2.brain.fm/Solis_Focus_DeepWork_Piano_30_102bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Solis_Focus_DeepWork_Piano_30_102bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Solis_Focus_DeepWork_Piano_30_102bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Solis_Focus_DeepWork_Piano_30_102bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26360877,
      "sha256": "cfd4ae7ab39621359421d8a6ae89c6e3372c1eb895fb328bf5c940f5b56d8725",
      "download_error": null
    },
    {
      "track_id": "6303db6c6648609b2e17c7d3",
      "name": "Lost in Translation",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 122,
      "brightness_level": 0.09,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/LostinTranslation_Focus_DeepWork_Piano_30_122bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=3VeekIklb3A1GGT2RRKMaMWaaD6zttAEpkM2Qdphlhc%3D",
      "cdn_url": "https://audio2.brain.fm/LostinTranslation_Focus_DeepWork_Piano_30_122bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LostinTranslation_Focus_DeepWork_Piano_30_122bpm_Nrmlzd2_VBR5.mp3",
      "filename": "LostinTranslation_Focus_DeepWork_Piano_30_122bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/LostinTranslation_Focus_DeepWork_Piano_30_122bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23995293,
      "sha256": "8ba792fb75924308fb19b15ae8208025493e01cdded8505042d288ca3aff0c12",
      "download_error": null
    },
    {
      "track_id": "62c8684408765a4760e8d432",
      "name": "Exaltation",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.27,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Exaltation_Focus_DeepWork_Piano_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=BhCem5CV4vBXMDOk%2BNiXyxjE%2FdpwTeQFt87UMyIOsW0%3D",
      "cdn_url": "https://audio2.brain.fm/Exaltation_Focus_DeepWork_Piano_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Exaltation_Focus_DeepWork_Piano_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Exaltation_Focus_DeepWork_Piano_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Exaltation_Focus_DeepWork_Piano_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24823175,
      "sha256": "771eed21e94f46062208806b29681fcd2567b258a257144675f22a062f1658fc",
      "download_error": null
    },
    {
      "track_id": "62b38a8d5924111de5f5478d",
      "name": "Brahms Piano Collection",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.21,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Piano%20Classical%202%20Brahms_1.8%20FINAL_1.15_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=igdymDXrWCzKpydRK5QuzzVZkjW220RR8IB50UfHCDI%3D",
      "cdn_url": "https://audio2.brain.fm/Piano%20Classical%202%20Brahms_1.8%20FINAL_1.15_Nrmlzd_VBR5.mp3",
      "remote_filename": "Piano Classical 2 Brahms_1.8 FINAL_1.15_Nrmlzd_VBR5.mp3",
      "filename": "Piano-Classical-2-Brahms_1.8-FINAL_1.15_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Piano-Classical-2-Brahms_1.8-FINAL_1.15_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20503519,
      "sha256": "b3f443a9657e4511cbe8a5c53adac34c46c757f9afbbb1be1b9b818d874e4231",
      "download_error": null
    },
    {
      "track_id": "62b38a7e592411fccef545e2",
      "name": "Thunderstorm",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.2,
      "complexity_level": 0.35,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Thunderstorm%20PIano%20Gen%20Session%207_1.2_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=iHrj81MUCTLqKj0rzAvt7v%2BE7Lf2x05SqmEmcJDh2xY%3D",
      "cdn_url": "https://audio2.brain.fm/Thunderstorm%20PIano%20Gen%20Session%207_1.2_Nrmlzd_VBR5.mp3",
      "remote_filename": "Thunderstorm PIano Gen Session 7_1.2_Nrmlzd_VBR5.mp3",
      "filename": "Thunderstorm-PIano-Gen-Session-7_1.2_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Thunderstorm-PIano-Gen-Session-7_1.2_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19290068,
      "sha256": "42a7841f66d8c92def3c6b0aa7aec5cebd6416f2979280b5060a5e66c1953482",
      "download_error": null
    },
    {
      "track_id": "62b38a7a592411af88f5454e",
      "name": "Coffee & Tea",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.32,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Coffee%20and%20Tea%20PIano%20Gen%20Session%208_1.3_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=%2BDNGYtycDvBOhZsjn9qMs9o0%2BcdOEQECfgUBjhwQ7G8%3D",
      "cdn_url": "https://audio2.brain.fm/Coffee%20and%20Tea%20PIano%20Gen%20Session%208_1.3_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Coffee and Tea PIano Gen Session 8_1.3_Nrmlzd2_VBR5.mp3",
      "filename": "Coffee-and-Tea-PIano-Gen-Session-8_1.3_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Coffee-and-Tea-PIano-Gen-Session-8_1.3_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19474216,
      "sha256": "790d89ab3d871ee392f5df834b8e0538f7e80d57b04e2da92cd550cef634273e",
      "download_error": null
    },
    {
      "track_id": "62b38a755924117515f5448a",
      "name": "Mozart Piano Collection 4",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.37,
      "complexity_level": 0.56,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Classical%208%20Mozart%204_1.4_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=7we3mJI0iYMeg5dgmhVmOpjF5lj7Y1FQeMZbymURuIs%3D",
      "cdn_url": "https://audio2.brain.fm/Classical%208%20Mozart%204_1.4_Nrmlzd_VBR5.mp3",
      "remote_filename": "Classical 8 Mozart 4_1.4_Nrmlzd_VBR5.mp3",
      "filename": "Classical-8-Mozart-4_1.4_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Classical-8-Mozart-4_1.4_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18622033,
      "sha256": "6c066fe84e48e8da2ba86ae745cbe8505b571ff1a0e34c86b227e3fd3fd0d3ae",
      "download_error": null
    },
    {
      "track_id": "62b38a3c5924113fddf5431c",
      "name": "Retribution",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.21,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Retribution%20Piano%20Focus%20Light%20Work%20Conor%20112bpm_1.2_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=jqP6sbDv6C7m7S8syFuEcOrdNxAFPTjHiua8CyxpexM%3D",
      "cdn_url": "https://audio2.brain.fm/Retribution%20Piano%20Focus%20Light%20Work%20Conor%20112bpm_1.2_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Retribution Piano Focus Light Work Conor 112bpm_1.2_Nrmlzd2_VBR5.mp3",
      "filename": "Retribution-Piano-Focus-Light-Work-Conor-112bpm_1.2_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Retribution-Piano-Focus-Light-Work-Conor-112bpm_1.2_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23504587,
      "sha256": "e4f1b89760ecf6b8172b9785cc0d7004e3f60d8d5340a755d88ef166afd3bc20",
      "download_error": null
    },
    {
      "track_id": "62b38a28592411ba29f5409f",
      "name": "Complete Revival",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.41,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.07,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Chris%20PianoSession1_1.22_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=AZtP0fJwhVmqGMJa7xvjteIfEEpHrrzGPB43bQFKsNY%3D",
      "cdn_url": "https://audio2.brain.fm/Chris%20PianoSession1_1.22_Nrmlzd_VBR5.mp3",
      "remote_filename": "Chris PianoSession1_1.22_Nrmlzd_VBR5.mp3",
      "filename": "Chris-PianoSession1_1.22_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Chris-PianoSession1_1.22_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19592523,
      "sha256": "cf8ceb5496bbed4fc0bbba08a19c94d2c82cc5c0ea74263f3e9d4f2cf0e8167b",
      "download_error": null
    },
    {
      "track_id": "62b389e65924118b50f539cc",
      "name": "Lush Paradise",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.25,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Chris%20Piano%20Session%202_1.15%20FINAL_1.5_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=ECPe%2FkY0Pp7pec%2FgXecoSLxRELjPUZeeUbfNMdt1XwA%3D",
      "cdn_url": "https://audio2.brain.fm/Chris%20Piano%20Session%202_1.15%20FINAL_1.5_Nrmlzd_VBR5.mp3",
      "remote_filename": "Chris Piano Session 2_1.15 FINAL_1.5_Nrmlzd_VBR5.mp3",
      "filename": "Chris-Piano-Session-2_1.15-FINAL_1.5_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Chris-Piano-Session-2_1.15-FINAL_1.5_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 20796999,
      "sha256": "149703d89f920439488396d052bda48492b9930a3fc79d261300dcfbd7aefd69",
      "download_error": null
    },
    {
      "track_id": "62b389e259241199d2f5396f",
      "name": "Beethoven Piano Collection",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.29,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Piano%20Classical%203%20Beethoven_1.7%20FInal_1.35_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=2KBNQg2fLXfHw0OZ6jBWxCmYsvd9C1eFPWZuDmBpfjA%3D",
      "cdn_url": "https://audio2.brain.fm/Piano%20Classical%203%20Beethoven_1.7%20FInal_1.35_Nrmlzd_VBR5.mp3",
      "remote_filename": "Piano Classical 3 Beethoven_1.7 FInal_1.35_Nrmlzd_VBR5.mp3",
      "filename": "Piano-Classical-3-Beethoven_1.7-FInal_1.35_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Piano-Classical-3-Beethoven_1.7-FInal_1.35_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21220123,
      "sha256": "cf913c48b9007b4fefabfb7fb5b3f156821479fc43702469da1038e616481b65",
      "download_error": null
    },
    {
      "track_id": "62b3895959241180f6f53469",
      "name": "Silent Words",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.43,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Silent%20Words%20Piano%2010%20No%20Melody_1.3_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=yEujSF39KMjohPvX%2BjW1gjwW7WrHr4XM3asTHMltmd8%3D",
      "cdn_url": "https://audio2.brain.fm/Silent%20Words%20Piano%2010%20No%20Melody_1.3_Nrmlzd_VBR5.mp3",
      "remote_filename": "Silent Words Piano 10 No Melody_1.3_Nrmlzd_VBR5.mp3",
      "filename": "Silent-Words-Piano-10-No-Melody_1.3_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Silent-Words-Piano-10-No-Melody_1.3_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18528168,
      "sha256": "f906445635ecf84c8dcd7f42197cbc64abf811cf588e3ece25ffdc2785ae250d",
      "download_error": null
    },
    {
      "track_id": "62b3895559241179eef533f1",
      "name": "Dream Bliss",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.42,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.22,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Falling%20Faster%20PIano%20Gen%20Session%205_1.2_Nrmlzd_VBR5.mp3?expiration=1792292138658&token=CZfJ%2FUt0cFGucbbRPT9GsA2VWTOM8bpbtKO7mRjgyFE%3D",
      "cdn_url": "https://audio2.brain.fm/Falling%20Faster%20PIano%20Gen%20Session%205_1.2_Nrmlzd_VBR5.mp3",
      "remote_filename": "Falling Faster PIano Gen Session 5_1.2_Nrmlzd_VBR5.mp3",
      "filename": "Falling-Faster-PIano-Gen-Session-5_1.2_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Falling-Faster-PIano-Gen-Session-5_1.2_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19255713,
      "sha256": "a0aeb2898b0819e6990f1313d1b1235e33841e292839dd6703f2e4c056f6e8a2",
      "download_error": null
    },
    {
      "track_id": "62b3894c5924118503f532bb",
      "name": "Surface Tension",
      "category": "Piano",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.33,
      "complexity_level": 0.01,
      "style": "normal",
      "neural_effect_level": 0.01,
      "source_json": "outputs/piano.json",
      "source_url": "https://audio2.brain.fm/Surface%20Tension%20Piano%20Focus%20Creative%20Flow%20Conor_1.2_Nrmlzd2_VBR5.mp3?expiration=1792292138658&token=PmNo7pezTpVWZGE2cxiVZLPs6%2F%2FbESjdzY6JEQ5Fpx4%3D",
      "cdn_url": "https://audio2.brain.fm/Surface%20Tension%20Piano%20Focus%20Creative%20Flow%20Conor_1.2_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Surface Tension Piano Focus Creative Flow Conor_1.2_Nrmlzd2_VBR5.mp3",
      "filename": "Surface-Tension-Piano-Focus-Creative-Flow-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/piano/Surface-Tension-Piano-Focus-Creative-Flow-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23165233,
      "sha256": "78c12adfae72e0a92af62dea0717214bfdc2b3d34a1ac20f17ca3655f68962fc",
      "download_error": null
    },
    {
      "track_id": "6a54f6a06ff4d00262502805",
      "name": "A Temporary Pause",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 77,
      "brightness_level": 0.51,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/ATemporaryPause_Focus_Learning_PostRock_30_77BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Ag5BbOpan8bq6y1phXKWW4ZSCC%2BfcnboIuwrKfePY%2FY%3D",
      "cdn_url": "https://audio2.brain.fm/ATemporaryPause_Focus_Learning_PostRock_30_77BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ATemporaryPause_Focus_Learning_PostRock_30_77BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ATemporaryPause_Focus_Learning_PostRock_30_77BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/ATemporaryPause_Focus_Learning_PostRock_30_77BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29111207,
      "sha256": "2a8fab597f873385de75b46a3e346ed1eca367010f76ab02abd1a3c2a5a3b712",
      "download_error": null
    },
    {
      "track_id": "6a4281b678a0a113b2ff3cb0",
      "name": "Aromatic Static",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.62,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/AromaticStatic_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=KCS%2BG6bFc5Rianig3s%2Bz0%2FtG3Q2k5tm%2FPELoOTjO4TM%3D",
      "cdn_url": "https://audio2.brain.fm/AromaticStatic_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "AromaticStatic_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "AromaticStatic_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/AromaticStatic_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29455632,
      "sha256": "6457cc8f1012d1628791270d0788e41b912c83a169ac5f0577c05ffb5696e3f0",
      "download_error": null
    },
    {
      "track_id": "6a3018577a8f5056573c9903",
      "name": "The Worst Excuse",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 81,
      "brightness_level": 0.48,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/TheWorstExcuse_Focus_DeepWork_PostRock_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=JAvIpvxLqK2aHD8OqQkb7%2FtR%2FC191iGZ%2FgP5WqcyeOE%3D",
      "cdn_url": "https://audio2.brain.fm/TheWorstExcuse_Focus_DeepWork_PostRock_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheWorstExcuse_Focus_DeepWork_PostRock_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheWorstExcuse_Focus_DeepWork_PostRock_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/TheWorstExcuse_Focus_DeepWork_PostRock_30_81bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28967818,
      "sha256": "45a11519cc63d38c00c20dc8bbf2e25db69f1ecefb76b2f05d5f12fda5aa4901",
      "download_error": null
    },
    {
      "track_id": "6a3018267a8f5056573c9723",
      "name": "Respective Timing",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.49,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/RespectiveTiming_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=F760hesf7YRVWCsSqMnH7fRpJ29axVH9wB1XvzzsvRc%3D",
      "cdn_url": "https://audio2.brain.fm/RespectiveTiming_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "RespectiveTiming_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "RespectiveTiming_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/RespectiveTiming_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29490590,
      "sha256": "7a682ac7367031bb007703ca45eb72de3408b4ded2a07ff6978d5454ed7da516",
      "download_error": null
    },
    {
      "track_id": "6a0b8bd1e6017bccd74b8395",
      "name": "Unwound Springs",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 83,
      "brightness_level": 0.33,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/UnwoundSprings_Focus_Creativity_PostRock_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=uiqMsM85PiojV7zKQd7wTVHweH9BrGq2fDeHGAKF%2BYc%3D",
      "cdn_url": "https://audio2.brain.fm/UnwoundSprings_Focus_Creativity_PostRock_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnwoundSprings_Focus_Creativity_PostRock_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnwoundSprings_Focus_Creativity_PostRock_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/UnwoundSprings_Focus_Creativity_PostRock_30_83bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30502648,
      "sha256": "e0e987e51c5e39ddb0b9f7745f92551f2a76d320d54eb7b727712d13249024b3",
      "download_error": null
    },
    {
      "track_id": "69f8b8aa1c706aff1baf0c8e",
      "name": "Tropio",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.52,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Tropio_Focus_Learning_PostRock_30_72bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=fPZPwVBGeBOTFDG5xycSvC6cMbU2d57u7iAW0XsXZvo%3D",
      "cdn_url": "https://audio2.brain.fm/Tropio_Focus_Learning_PostRock_30_72bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tropio_Focus_Learning_PostRock_30_72bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Tropio_Focus_Learning_PostRock_30_72bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Tropio_Focus_Learning_PostRock_30_72bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28122097,
      "sha256": "6692e42d1be8a30460a9c43366c0b7fb7be259efe077644d51f51cfb8b8eefa9",
      "download_error": null
    },
    {
      "track_id": "69e68728dce2120639c6f200",
      "name": "Magnification Axis",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 74,
      "brightness_level": 0.36,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/MagnificationAxis_Focus_DeepWork_PostRock_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=x0aFsvALTGwZQ7HZfU4MiQnsA4fuRVkFCNiVxASfFbU%3D",
      "cdn_url": "https://audio2.brain.fm/MagnificationAxis_Focus_DeepWork_PostRock_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MagnificationAxis_Focus_DeepWork_PostRock_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MagnificationAxis_Focus_DeepWork_PostRock_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/MagnificationAxis_Focus_DeepWork_PostRock_30_74bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26905259,
      "sha256": "8bee69c09f8c7f7d62c45ad51b6cb7d86cf7b5d4a9d2a848e28351fa17c5c890",
      "download_error": null
    },
    {
      "track_id": "69d0266e9b9914998a32cd7b",
      "name": "Live Again",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.35,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/LiveAgain_Focus_Learning_PostRock_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=iaqNDss%2FvM4SBReH%2FVxmRtb%2BIRwcQwL%2BIUKoLLfjKSg%3D",
      "cdn_url": "https://audio2.brain.fm/LiveAgain_Focus_Learning_PostRock_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LiveAgain_Focus_Learning_PostRock_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LiveAgain_Focus_Learning_PostRock_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/LiveAgain_Focus_Learning_PostRock_30_85BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27473163,
      "sha256": "3510a235d26879d63f6d0832e587de3c39ef208f8ff2fcf0919f48f21e65b754",
      "download_error": null
    },
    {
      "track_id": "69c2bc471b6ecfe6c4a71d30",
      "name": "Unturned",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.51,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Unturned_Focus_Deepwork_PostRock_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=0umQoel7TPzCAVvCZ%2BpiyzLS%2BE%2FnIo8yfHDSXDhmWvA%3D",
      "cdn_url": "https://audio2.brain.fm/Unturned_Focus_Deepwork_PostRock_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unturned_Focus_Deepwork_PostRock_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unturned_Focus_Deepwork_PostRock_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Unturned_Focus_Deepwork_PostRock_30_80BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26493337,
      "sha256": "b42ab48a500a0209397d4bd30a8b8a5af9f64b24d80a9b57e3f9f27bd92db101",
      "download_error": null
    },
    {
      "track_id": "69aee22573bfe2099d5177f9",
      "name": "A Separation",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 108,
      "brightness_level": 0.42,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/ASeparation_Focus_DeepWork_Post%20Rock_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=7N6KOfNoDqFSznSGrl8xHIwYTzc%2BweS%2FFXHYykmL%2Bcs%3D",
      "cdn_url": "https://audio2.brain.fm/ASeparation_Focus_DeepWork_Post%20Rock_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ASeparation_Focus_DeepWork_Post Rock_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ASeparation_Focus_DeepWork_Post-Rock_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/ASeparation_Focus_DeepWork_Post-Rock_30_108bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27316897,
      "sha256": "edd9b1fe98ab8d4e75cb77b70c3cf66734d7ba2c77c7f08f1fc104c09766f53d",
      "download_error": null
    },
    {
      "track_id": "699cac7c9033fe9e7ccfa09f",
      "name": "Good Measure",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.62,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.61,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/GoodMeasure_Focus_Creativity_PostRock_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=1pAgKfvZJWTaike8EI%2BoGTsOm%2FyovVYsu3zNslsjXoI%3D",
      "cdn_url": "https://audio2.brain.fm/GoodMeasure_Focus_Creativity_PostRock_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GoodMeasure_Focus_Creativity_PostRock_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GoodMeasure_Focus_Creativity_PostRock_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/GoodMeasure_Focus_Creativity_PostRock_30_100BPM_MediumNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29432711,
      "sha256": "c7c2dcc87c0cfa6f16df095f804f9dd4d0d7ab10c05833264c1cd2f3232df707",
      "download_error": null
    },
    {
      "track_id": "698a17a28a4a8f35be584fe6",
      "name": "Roadworn",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.46,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Roadworn_Focus_DeepWork_PostRock_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=0Zy9BO1ALfG5ng8jd5WYpjNWlJG4pA8yOJK7kGnaCNQ%3D",
      "cdn_url": "https://audio2.brain.fm/Roadworn_Focus_DeepWork_PostRock_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Roadworn_Focus_DeepWork_PostRock_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Roadworn_Focus_DeepWork_PostRock_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Roadworn_Focus_DeepWork_PostRock_30_90BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28441239,
      "sha256": "721e1588b865a79d280e7fa3369e24ff5beddb9b0c1a93c5c3043b9d8bca6a77",
      "download_error": null
    },
    {
      "track_id": "698a16018a4a8f35be583e3e",
      "name": "Make It Soothe",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.38,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/MakeItSoothe_Focus_DeepWork_Post%20Rock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=tQnT%2B%2BVHRP6bZIQ8%2Fnmyno9FJFHO7YzvfeRMt9Y8r0s%3D",
      "cdn_url": "https://audio2.brain.fm/MakeItSoothe_Focus_DeepWork_Post%20Rock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MakeItSoothe_Focus_DeepWork_Post Rock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MakeItSoothe_Focus_DeepWork_Post-Rock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/MakeItSoothe_Focus_DeepWork_Post-Rock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27159537,
      "sha256": "04f947a19858a66d30e05c706781754b5e7fa774d47c484d06c7afcf07d84576",
      "download_error": null
    },
    {
      "track_id": "698a15bf8a4a8f35be583ad1",
      "name": "Lapsed",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.57,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Lapsed_Focus_Creativity_PostRock_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Ep75p%2B7FVfE0dSgAT9e6JRhLUfSd%2Bronn6b9i9kx1Ws%3D",
      "cdn_url": "https://audio2.brain.fm/Lapsed_Focus_Creativity_PostRock_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lapsed_Focus_Creativity_PostRock_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Lapsed_Focus_Creativity_PostRock_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Lapsed_Focus_Creativity_PostRock_30_80bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29405538,
      "sha256": "471d92c4452c9bb96d417b088875056efa377bf98a515ac16db30dea68bf928b",
      "download_error": null
    },
    {
      "track_id": "69655bb3212c8d55194eed5b",
      "name": "La Frontine",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.58,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/LaFrontine_Focus_Learning_PostRock_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=ovzVivHmL155uGN%2BsS97xMCB5oPr5uCRRxDZ7f0EAtQ%3D",
      "cdn_url": "https://audio2.brain.fm/LaFrontine_Focus_Learning_PostRock_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LaFrontine_Focus_Learning_PostRock_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LaFrontine_Focus_Learning_PostRock_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/LaFrontine_Focus_Learning_PostRock_30_100bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28929799,
      "sha256": "d3e395e61db89399b6089d1a59c98e66eb517a2f5084714775a335f999cd5357",
      "download_error": null
    },
    {
      "track_id": "69655aae212c8d55194ee867",
      "name": "A Silent Map",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 75,
      "brightness_level": 0.64,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/ASilentMap_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=mfG%2BN9%2BFMvOeRLxUVUlvYJJermZBsVbnwJzmowOgEpk%3D",
      "cdn_url": "https://audio2.brain.fm/ASilentMap_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ASilentMap_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ASilentMap_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/ASilentMap_Focus_DeepWork_PostRock_30_75bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30039919,
      "sha256": "767ffe6317ed1412d96a471b256361c06bc522519583094655631655e0406866",
      "download_error": null
    },
    {
      "track_id": "6952f3139e729f65562d0fd4",
      "name": "Pitted",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.54,
      "complexity_level": 0.3,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Pitted_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=yoZmQMMiqcq7m3A3b1o4tkAINQdztyH%2FCmzupskPMYs%3D",
      "cdn_url": "https://audio2.brain.fm/Pitted_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pitted_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Pitted_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Pitted_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31317712,
      "sha256": "c3fd1c817cffa04ac745616e4825fb3d8da4ed2783b8e9ec4c610ffc9221a70b",
      "download_error": null
    },
    {
      "track_id": "692dbd90b8f361da92eb9e5c",
      "name": "1446",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 150,
      "brightness_level": 0.61,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/1446_Focus_DeepWork_PostRock_30_150bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=6jmw6C4CrAdCHmOLpJ542f7q7kMQhUs1TM3RLoJ5GJ0%3D",
      "cdn_url": "https://audio2.brain.fm/1446_Focus_DeepWork_PostRock_30_150bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "1446_Focus_DeepWork_PostRock_30_150bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "1446_Focus_DeepWork_PostRock_30_150bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/1446_Focus_DeepWork_PostRock_30_150bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30242566,
      "sha256": "1508652d42ac0fc8b57562dfb352d8dd8ace9726493f9ae0fffbd7422a8c9dad",
      "download_error": null
    },
    {
      "track_id": "691b3b90a1c962ea641ef987",
      "name": "I Could See The Possibility",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.48,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/I_Could_See_The_Possibility_Focus_Learning_Post_Rock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=C8dJxzBADvJQbokYsjAdOw0pUbYQ2YFUXxwbF4KfJyQ%3D",
      "cdn_url": "https://audio2.brain.fm/I_Could_See_The_Possibility_Focus_Learning_Post_Rock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "I_Could_See_The_Possibility_Focus_Learning_Post_Rock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "I_Could_See_The_Possibility_Focus_Learning_Post_Rock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/I_Could_See_The_Possibility_Focus_Learning_Post_Rock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27263057,
      "sha256": "dcd45e0c7f5b76bc513a7880232184c297ea71bed8a158193ec07751ac52734d",
      "download_error": null
    },
    {
      "track_id": "69091891312eb1fe04658fb8",
      "name": "Potentially",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.51,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.83,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Potentially_Focus_Learning_Post%20Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=cczO9e9qPlC8DUK3LkfZ35Va4gFZprxrx3YbwXdzaiw%3D",
      "cdn_url": "https://audio2.brain.fm/Potentially_Focus_Learning_Post%20Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Potentially_Focus_Learning_Post Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Potentially_Focus_Learning_Post-Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Potentially_Focus_Learning_Post-Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27728408,
      "sha256": "f9548cc867ed397d2b2591db4e6ffbbff17f2269e82030e8285bb63f6ea9c005",
      "download_error": null
    },
    {
      "track_id": "68f66541c7a40a338f845f32",
      "name": "Recapsulate",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 95,
      "brightness_level": 0.7,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.77,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Recapsulate_Focus_Creativity_PostRock_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Rf9l8sY0Bf4WjglZ4IwsGXVFfVzEjRbDAkedkhnXOYo%3D",
      "cdn_url": "https://audio2.brain.fm/Recapsulate_Focus_Creativity_PostRock_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Recapsulate_Focus_Creativity_PostRock_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Recapsulate_Focus_Creativity_PostRock_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Recapsulate_Focus_Creativity_PostRock_30_95BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27242224,
      "sha256": "401406de7fe22cde4ecd3b6eef6ae813913fb10a90cd90df9438d903c0348f72",
      "download_error": null
    },
    {
      "track_id": "68f664bde8a4cc0a7401bf1d",
      "name": "Icecaps",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 77,
      "brightness_level": 0.61,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Icecaps_Focus_Creativity_PostRock_30_77BPM_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=OehQMWUf6velUwyPuli3NtVm7SHNUheyXGjXlYhV3dU%3D",
      "cdn_url": "https://audio2.brain.fm/Icecaps_Focus_Creativity_PostRock_30_77BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Icecaps_Focus_Creativity_PostRock_30_77BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Icecaps_Focus_Creativity_PostRock_30_77BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Icecaps_Focus_Creativity_PostRock_30_77BPM_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29460388,
      "sha256": "271c49b5c956a505fc7b737eda420e6e29f5476c72ed43ff269c96a89806cda0",
      "download_error": null
    },
    {
      "track_id": "68e3d760c1aa1a1dfaaeca01",
      "name": "Split Spirit",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.41,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.72,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/SplitSpirit_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=2uNga77hlsNllOyMWO4kY4qO0rLxylW74WG%2F02cZ0Hg%3D",
      "cdn_url": "https://audio2.brain.fm/SplitSpirit_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SplitSpirit_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SplitSpirit_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/SplitSpirit_Focus_Creativity_PostRock_30_80BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28995954,
      "sha256": "d7cfe0d8fdd2e4ecbcdfa252649bc6acfc4f4288789c75dcd838b07a4a40e9f3",
      "download_error": null
    },
    {
      "track_id": "68e3d6a12d873930bbbf7878",
      "name": "Escalated",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 87,
      "brightness_level": 0.42,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Escalated_Focus_Learning_Post%20Rock_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=pb6xh8KZPCjS2HOGvF2HVBiTAusV6QvEyRjDH3euFLw%3D",
      "cdn_url": "https://audio2.brain.fm/Escalated_Focus_Learning_Post%20Rock_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Escalated_Focus_Learning_Post Rock_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Escalated_Focus_Learning_Post-Rock_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Escalated_Focus_Learning_Post-Rock_30_87bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25675673,
      "sha256": "ea4fba75c8ce22b9d85fa9c6729ed027a164e47cd3db8d46c36c076bab519a5f",
      "download_error": null
    },
    {
      "track_id": "68d178bcd9158d8853b171ee",
      "name": "Cleft Mountains",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.52,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Cleft%20Mountains_Focus_Deep%20Work_Post%20Rock_30_72bpm_MedNEL_VBR5.mp3?expiration=1792292140809&token=cSvyOnqU8wbTVCipXjvp93lahHLJkoA4PKw1QdTww9M%3D",
      "cdn_url": "https://audio2.brain.fm/Cleft%20Mountains_Focus_Deep%20Work_Post%20Rock_30_72bpm_MedNEL_VBR5.mp3",
      "remote_filename": "Cleft Mountains_Focus_Deep Work_Post Rock_30_72bpm_MedNEL_VBR5.mp3",
      "filename": "Cleft-Mountains_Focus_Deep-Work_Post-Rock_30_72bpm_MedNEL_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Cleft-Mountains_Focus_Deep-Work_Post-Rock_30_72bpm_MedNEL_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28271844,
      "sha256": "d673b26b3837edcf52cd9775791e513da293e80d4a334d1df265d37bcad1cf7a",
      "download_error": null
    },
    {
      "track_id": "68aca464870c986ca59c07b9",
      "name": "In Sympathetic Vibration",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 74,
      "brightness_level": 0.57,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/InSympatheticVibration_Focus_DeepWork_PostRock_30_74BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Ad73UOUNLcHytRBR1HzG89QXZhnAMCxgIrcgD54%2Bfkw%3D",
      "cdn_url": "https://audio2.brain.fm/InSympatheticVibration_Focus_DeepWork_PostRock_30_74BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "InSympatheticVibration_Focus_DeepWork_PostRock_30_74BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "InSympatheticVibration_Focus_DeepWork_PostRock_30_74BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/InSympatheticVibration_Focus_DeepWork_PostRock_30_74BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29467218,
      "sha256": "64739339179df8f91bb07eae27fce708b4aa9170a581057b29fd674a9d77f9a1",
      "download_error": null
    },
    {
      "track_id": "68aca3d4605d1de9ea68b87a",
      "name": "Underhead",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.51,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.39,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Underhead_Focus_Learning_Post%20Rock_30_91bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=NfZtSYjasBTmH8hFVM8bkqPMksx5BI%2Fpn8jy3j1C2us%3D",
      "cdn_url": "https://audio2.brain.fm/Underhead_Focus_Learning_Post%20Rock_30_91bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Underhead_Focus_Learning_Post Rock_30_91bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Underhead_Focus_Learning_Post-Rock_30_91bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Underhead_Focus_Learning_Post-Rock_30_91bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28607725,
      "sha256": "11b2fcd215b8980359f19a871d09ed606749a5b84e6fff1b1202adb04d5da4ae",
      "download_error": null
    },
    {
      "track_id": "689a23959446c76349a3b72b",
      "name": "Contrition",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 78,
      "brightness_level": 0.57,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Contrition_Focus_DeepWork_PostRock_30_78BPM_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=VQh3HggzNhyEYmfCtasB5HA2uCY1DxV529ngN6elYZE%3D",
      "cdn_url": "https://audio2.brain.fm/Contrition_Focus_DeepWork_PostRock_30_78BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Contrition_Focus_DeepWork_PostRock_30_78BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Contrition_Focus_DeepWork_PostRock_30_78BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Contrition_Focus_DeepWork_PostRock_30_78BPM_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30036680,
      "sha256": "eaacd7f5d40302cba9014c2a27021c3c81dd24b510193231f55b08720a6707ef",
      "download_error": null
    },
    {
      "track_id": "689a22b89446c76349a3b39b",
      "name": "Cataclysm",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.59,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Cataclysm_Focus_Learning_PostRock_30_90BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292140809&token=ffO8%2F%2B%2BYxOruQIbb%2B6cPMCSBS68WNCvjCD1Wc89stW4%3D",
      "cdn_url": "https://audio2.brain.fm/Cataclysm_Focus_Learning_PostRock_30_90BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Cataclysm_Focus_Learning_PostRock_30_90BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "Cataclysm_Focus_Learning_PostRock_30_90BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Cataclysm_Focus_Learning_PostRock_30_90BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28450003,
      "sha256": "ae4afdb5fd9c08e7f50371d85ea7ac8e0add9d775f4745bd3c0f3c9987b1b151",
      "download_error": null
    },
    {
      "track_id": "6888c86fb997579cf699b69d",
      "name": "Brackets",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.64,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Brackets_Focus_Deep_Work_Post_Rock_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Ui3SxgO4m4nIt2ob4cIkZPUiyAfMDqbd8nmdvlNju1E%3D",
      "cdn_url": "https://audio2.brain.fm/Brackets_Focus_Deep_Work_Post_Rock_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Brackets_Focus_Deep_Work_Post_Rock_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Brackets_Focus_Deep_Work_Post_Rock_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Brackets_Focus_Deep_Work_Post_Rock_30_85bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28453827,
      "sha256": "afe102f4bbcdabe99c66cddc8dc5c8f45477804a80e4d6bb9fcc3bbc772001f8",
      "download_error": null
    },
    {
      "track_id": "6888c852b997579cf699b617",
      "name": "Unconversion",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.33,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Unconversion_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=ZMlaPPSl4EFb7%2FQ0gjLq9alVeZpl1G22czyxdoaEVd8%3D",
      "cdn_url": "https://audio2.brain.fm/Unconversion_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unconversion_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unconversion_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Unconversion_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28500106,
      "sha256": "33d7dba7e86737826d12ba54a903bf857880c130480db1dae4e6e6e3a367d60f",
      "download_error": null
    },
    {
      "track_id": "68878959b997579cf6967923",
      "name": "Lunar Light",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.98,
      "complexity_level": 0.85,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/LunarLight_Focus_DeepWork_PostRock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=JLHQRq202XtnbOYUS3mQVLmForXZotjbfqf3NyFnRwY%3D",
      "cdn_url": "https://audio2.brain.fm/LunarLight_Focus_DeepWork_PostRock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LunarLight_Focus_DeepWork_PostRock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LunarLight_Focus_DeepWork_PostRock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/LunarLight_Focus_DeepWork_PostRock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28655369,
      "sha256": "aa69968e846905afbd95eaefae1b6c354e57f0f1aca6dd209684811d360bdc1a",
      "download_error": null
    },
    {
      "track_id": "687551173b891fead18abad6",
      "name": "Colored Sulfur",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.48,
      "complexity_level": 0.06,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Colored%20Sulfur_Focus_Deep%20Work_Post%20Rock_30_82bpm_LowNELNrmlzd2_VBR5.mp3?expiration=1792292140809&token=cqE5hDxCdWO9RKcnVRCHk9jg9wyNeA1WkVuXpyFLb94%3D",
      "cdn_url": "https://audio2.brain.fm/Colored%20Sulfur_Focus_Deep%20Work_Post%20Rock_30_82bpm_LowNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Colored Sulfur_Focus_Deep Work_Post Rock_30_82bpm_LowNELNrmlzd2_VBR5.mp3",
      "filename": "Colored-Sulfur_Focus_Deep-Work_Post-Rock_30_82bpm_LowNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Colored-Sulfur_Focus_Deep-Work_Post-Rock_30_82bpm_LowNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27557563,
      "sha256": "5c251e5799f8281cf0bbbe60b5a287f5569dac6d9c7865666fcdcc273588d091",
      "download_error": null
    },
    {
      "track_id": "6862ec3dda2d247f1a9c6d51",
      "name": "Self Help",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.59,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/SelfHelp_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=ajHBGEBFhtBv1Vf9%2FfpQJcOnTIdZBsiytRwabDZ%2F73s%3D",
      "cdn_url": "https://audio2.brain.fm/SelfHelp_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SelfHelp_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SelfHelp_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/SelfHelp_Focus_Learning_PostRock_30_105BPM_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28141053,
      "sha256": "f305ce17168030048fb6c3ce4cd26af574a5036111f15aa85500ae7865f299e5",
      "download_error": null
    },
    {
      "track_id": "68505bbd5de2e833e430af9f",
      "name": "Listen to the Clouds",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.38,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.06,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Listen_To_The_Clouds_Focus_Creativity_Post_Rock_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=FMy1PKglK4XwBtGiMOaoCSybVR%2BTMvbTwNdEpA0tdmU%3D",
      "cdn_url": "https://audio2.brain.fm/Listen_To_The_Clouds_Focus_Creativity_Post_Rock_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Listen_To_The_Clouds_Focus_Creativity_Post_Rock_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Listen_To_The_Clouds_Focus_Creativity_Post_Rock_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Listen_To_The_Clouds_Focus_Creativity_Post_Rock_30_80bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25198037,
      "sha256": "f4318186e0c608327eba0341b34d52484bd4e2633c712a66585c14b26994c19e",
      "download_error": null
    },
    {
      "track_id": "683f0b8d7e70e7db4e0e9bb1",
      "name": "In A Collapse",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 84,
      "brightness_level": 0.65,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/In_A_Collapse_Focus_Creativity_Post_Rock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=f%2Bl6bh6ZsswgvCK1pxkyY1HXiq6qpzHxugUTOd2rhZ0%3D",
      "cdn_url": "https://audio2.brain.fm/In_A_Collapse_Focus_Creativity_Post_Rock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "In_A_Collapse_Focus_Creativity_Post_Rock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "In_A_Collapse_Focus_Creativity_Post_Rock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/In_A_Collapse_Focus_Creativity_Post_Rock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26198125,
      "sha256": "7824719528bc9e309a1e613d05691d223b8735e9ac196be54dd321372146be1d",
      "download_error": null
    },
    {
      "track_id": "683dc7c87e70e7db4e0af127",
      "name": "New Spirits",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 96,
      "brightness_level": 0.42,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/NewSpirits_Focus_Learning_PostRock_30_95BPM_HighNELNrmlzd2_VBR5.mp3?expiration=1792292140809&token=SUGGKEXHXF26IE%2Bd5BHHnjeXMj2T9s8d8N0%2FMfdTsVs%3D",
      "cdn_url": "https://audio2.brain.fm/NewSpirits_Focus_Learning_PostRock_30_95BPM_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "NewSpirits_Focus_Learning_PostRock_30_95BPM_HighNELNrmlzd2_VBR5.mp3",
      "filename": "NewSpirits_Focus_Learning_PostRock_30_95BPM_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/NewSpirits_Focus_Learning_PostRock_30_95BPM_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27916820,
      "sha256": "6531ecd208f31b4f7429c527282d7bed6c02cf9a5c9855ca9ca214e46968f307",
      "download_error": null
    },
    {
      "track_id": "682b55c28ab5a645af483e2b",
      "name": "Just Barely",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 77,
      "brightness_level": 0.57,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Just%20Barely_Focus_Learning_Post%20Rock_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=7%2BGL%2BuQAPh%2FU0VdxMn3ahzzSlNpvUMXO25nZF2tHnTw%3D",
      "cdn_url": "https://audio2.brain.fm/Just%20Barely_Focus_Learning_Post%20Rock_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Just Barely_Focus_Learning_Post Rock_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Just-Barely_Focus_Learning_Post-Rock_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Just-Barely_Focus_Learning_Post-Rock_30_77bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26717310,
      "sha256": "87f25952ff886415cf88e4941509e4b0a77232f8bb2dcfc79b2649f4e1334602",
      "download_error": null
    },
    {
      "track_id": "6818d17cc7fc795ec060ee02",
      "name": "Greyed Out",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.41,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Greyed_Out_Focus_Learning_Post_Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=yDYH3RwRADA4Pogbmhfuo1fhnsUHP2KrjZjxiYA%2Bh%2BE%3D",
      "cdn_url": "https://audio2.brain.fm/Greyed_Out_Focus_Learning_Post_Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Greyed_Out_Focus_Learning_Post_Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Greyed_Out_Focus_Learning_Post_Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Greyed_Out_Focus_Learning_Post_Rock_30_90bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24409953,
      "sha256": "cb8604e3477b588cde4dfa475921cd215713b064d800109d42c75ea40266745c",
      "download_error": null
    },
    {
      "track_id": "68065986563464c2de5fb168",
      "name": "From the Middle",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 113,
      "brightness_level": 0.77,
      "complexity_level": 0.75,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/From_The_Middle_Focus_Creativity_Post_Rock_30_113bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=RMkc2F4FAWqWNm3SfKrs9Q%2FuXn88jERGpH%2BDNoK%2B2gQ%3D",
      "cdn_url": "https://audio2.brain.fm/From_The_Middle_Focus_Creativity_Post_Rock_30_113bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "From_The_Middle_Focus_Creativity_Post_Rock_30_113bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "From_The_Middle_Focus_Creativity_Post_Rock_30_113bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/From_The_Middle_Focus_Creativity_Post_Rock_30_113bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28109871,
      "sha256": "dab4482654459b833ce2e80359c5ce26319c8c5c500f0ac115cf7f98caeef3ff",
      "download_error": null
    },
    {
      "track_id": "67f3eb57a0de2348f748e459",
      "name": "Less Difficult",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.18,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Less_Difficult_Focus_Deep_Work_Post_Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=iIVlTfdOHyYnVl4r8VIdv7BTLvUv3RV%2BvEHT31AGDgU%3D",
      "cdn_url": "https://audio2.brain.fm/Less_Difficult_Focus_Deep_Work_Post_Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Less_Difficult_Focus_Deep_Work_Post_Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Less_Difficult_Focus_Deep_Work_Post_Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Less_Difficult_Focus_Deep_Work_Post_Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25290076,
      "sha256": "a31cc811d7072b0f30caffc68241272130413d6bbf5fa074b3800359ef1ffc28",
      "download_error": null
    },
    {
      "track_id": "67bc8915aebfd9a384a2b597",
      "name": "Quiet Force",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 77,
      "brightness_level": 0.76,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Quiet_Force_Focus_Deep_Work_Post_Rock_30_77bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=yiZYvXbGiBQlBqA62tCO1INeS5V6oSrLGukS4M%2FsZQk%3D",
      "cdn_url": "https://audio2.brain.fm/Quiet_Force_Focus_Deep_Work_Post_Rock_30_77bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Quiet_Force_Focus_Deep_Work_Post_Rock_30_77bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Quiet_Force_Focus_Deep_Work_Post_Rock_30_77bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Quiet_Force_Focus_Deep_Work_Post_Rock_30_77bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29082850,
      "sha256": "0c1e64246e0df38b509f9233f20162b652586681a87b253b05e260d65df05a7b",
      "download_error": null
    },
    {
      "track_id": "67730037698f763bc2b4598c",
      "name": "Skeletal",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.75,
      "complexity_level": 0.43,
      "style": "normal",
      "neural_effect_level": 0.49,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Skeletal_Focus_Creativity_Post_Rock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=EAaOOMJa3TACsk6jqWR3nOTB%2FQtKppYDcvc85V7vpTc%3D",
      "cdn_url": "https://audio2.brain.fm/Skeletal_Focus_Creativity_Post_Rock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Skeletal_Focus_Creativity_Post_Rock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Skeletal_Focus_Creativity_Post_Rock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Skeletal_Focus_Creativity_Post_Rock_30_100bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29153562,
      "sha256": "2057208a4ea5bb9df4b236a4177433caac0061e2c22b14b44ffcda3df463a88e",
      "download_error": null
    },
    {
      "track_id": "67730022698f763bc2b4595a",
      "name": "Misted",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 105,
      "brightness_level": 0.87,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.85,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Misted_Focus_Learning_Post_Rock_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=LziImjISfPj2q%2BtlAO%2F4dGKiA3yVuhoSNdBwKPcNzfg%3D",
      "cdn_url": "https://audio2.brain.fm/Misted_Focus_Learning_Post_Rock_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Misted_Focus_Learning_Post_Rock_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Misted_Focus_Learning_Post_Rock_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Misted_Focus_Learning_Post_Rock_30_105bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29388081,
      "sha256": "77779a670825eb0dec9f30735a7e638a08cf898d665af0c23df4a843903e8116",
      "download_error": null
    },
    {
      "track_id": "67603f6399a8ff2d4a85e9f4",
      "name": "Frostbite",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.72,
      "complexity_level": 0.9,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Frostbite_Focus_Deep%20Work_Post%20Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=A1pG80JQ%2FuRc0aGxdNSKCA7nxcgGXs01Rv1W5K8yKik%3D",
      "cdn_url": "https://audio2.brain.fm/Frostbite_Focus_Deep%20Work_Post%20Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Frostbite_Focus_Deep Work_Post Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Frostbite_Focus_Deep-Work_Post-Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Frostbite_Focus_Deep-Work_Post-Rock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29306323,
      "sha256": "c4ada917929b9c1b78ebc29b35ccbbab1e0141199a1e9d69451cbbc779d081ab",
      "download_error": null
    },
    {
      "track_id": "674de02d5dec417226950b25",
      "name": "Half Recovered",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.62,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Half%20Recovered_Focus_Learning_Post%20Rock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=gwxtHOIng96RceVpQN1RHtN5SmtQLNnj4tCLZ4iQkAc%3D",
      "cdn_url": "https://audio2.brain.fm/Half%20Recovered_Focus_Learning_Post%20Rock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Half Recovered_Focus_Learning_Post Rock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Half-Recovered_Focus_Learning_Post-Rock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Half-Recovered_Focus_Learning_Post-Rock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28845075,
      "sha256": "6a0fd61c519e37a7ce04a62b985fbb94e6aee6aa66da753865778b4229f2f07d",
      "download_error": null
    },
    {
      "track_id": "674ddfa6657c71542c9997d8",
      "name": "Reflection Chamber",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.93,
      "complexity_level": 0.97,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/ReflectionChamber_Focus_DeepWork_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=TV%2FyJb76N%2F6QFbFNje%2F7b4reRZ1ZjB%2Bk4ZCKarlEMXA%3D",
      "cdn_url": "https://audio2.brain.fm/ReflectionChamber_Focus_DeepWork_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ReflectionChamber_Focus_DeepWork_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ReflectionChamber_Focus_DeepWork_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/ReflectionChamber_Focus_DeepWork_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27053836,
      "sha256": "71a9ed7d8547653ab1a3c96e0521c4e9fc96d70df018236414d9dddc01c41f36",
      "download_error": null
    },
    {
      "track_id": "673b5e62593072f908bc77f9",
      "name": "Delayed Reaction",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.86,
      "complexity_level": 0.98,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/DelayedReaction_Focus_Learning_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=UkxHgZ2Eyz6ndaJCh4RP4aU1ZiXvg0cVRoBeiDpv7EI%3D",
      "cdn_url": "https://audio2.brain.fm/DelayedReaction_Focus_Learning_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DelayedReaction_Focus_Learning_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "DelayedReaction_Focus_Learning_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/DelayedReaction_Focus_Learning_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29458464,
      "sha256": "1cab9f7703f53b157d628beb813f8bffb2c7c931b25af3c1c3028f42abb82289",
      "download_error": null
    },
    {
      "track_id": "673b5e49593072f908bc77a2",
      "name": "Spiritualized",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.87,
      "complexity_level": 0.77,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Spiritualized_Focus_Creativity_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Ju6iQKkXyjOvfQBY6tsop%2B9V0g2x47hoy308JCZkoHs%3D",
      "cdn_url": "https://audio2.brain.fm/Spiritualized_Focus_Creativity_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Spiritualized_Focus_Creativity_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Spiritualized_Focus_Creativity_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Spiritualized_Focus_Creativity_PostRock_30_130bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28243929,
      "sha256": "c6bfb26532d2a560115fe06ebe1e1dfc3f2d1d63f014f6d825ffb36540dcb853",
      "download_error": null
    },
    {
      "track_id": "6728ec10ebed2a29b0df4530",
      "name": "Fractured Skies",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.87,
      "complexity_level": 0.68,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Fractured_Skies_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=xanD66XHFLFZY2LbYzR1r%2FXch9UKERjPkfCd2U6Vv5U%3D",
      "cdn_url": "https://audio2.brain.fm/Fractured_Skies_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Fractured_Skies_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Fractured_Skies_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Fractured_Skies_Focus_Deep_Work_Post_Rock_30_100bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29887523,
      "sha256": "1070c70a28d47bbad5faed8a399826ab81b4d004fa1639214a03bffe2c6506d8",
      "download_error": null
    },
    {
      "track_id": "6728eb9b8bc23988fd64708c",
      "name": "Leading Light",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.8,
      "complexity_level": 0.57,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/LeadingLight_Focus_DeepWork_PostRock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=C0LPFusy9pVsvNDoHJyIJxUnEVoKtKIq9uzPbjTfdyg%3D",
      "cdn_url": "https://audio2.brain.fm/LeadingLight_Focus_DeepWork_PostRock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LeadingLight_Focus_DeepWork_PostRock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LeadingLight_Focus_DeepWork_PostRock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/LeadingLight_Focus_DeepWork_PostRock_30_110bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27412978,
      "sha256": "4a61df75fb5e5142d33dd790a2f1fce8cb3d51b6d6b66920571c9e78b52b1619",
      "download_error": null
    },
    {
      "track_id": "6716a17cae8c98e954dc5a72",
      "name": "Unhinged",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.9,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Unhinged_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=5a8fPCp72ZDPXxxGRVi2DypXW7GQaWvqMHJYfw4cpNc%3D",
      "cdn_url": "https://audio2.brain.fm/Unhinged_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unhinged_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Unhinged_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Unhinged_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28431184,
      "sha256": "0899a177df57cfd01d95a27bc97b59219f5c556af3c000d4b09a5137c9e81c56",
      "download_error": null
    },
    {
      "track_id": "6703e2f2a1f0c0804124fc9a",
      "name": "Conscious Action",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.86,
      "complexity_level": 0.76,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/ConsciousAction_Focus_Learning_PostRock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=MuifVFRA%2BIuGZBPZiLSseK0CbPzS2fwkpyAEUrk16nw%3D",
      "cdn_url": "https://audio2.brain.fm/ConsciousAction_Focus_Learning_PostRock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ConsciousAction_Focus_Learning_PostRock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ConsciousAction_Focus_Learning_PostRock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/ConsciousAction_Focus_Learning_PostRock_30_115bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28982544,
      "sha256": "061e4c28527a1d45b4ed710f9b30af7a6185ae1168e8931ff6a729d8e3231161",
      "download_error": null
    },
    {
      "track_id": "6703e27ca1f0c0804124fb36",
      "name": "United at Last",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.84,
      "complexity_level": 0.96,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/UnitedAtLast_Focus_DeepWork_PostRock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=FldGDvMC%2FMU%2FpMFfLeqjas1Kk4QDSkHmsGfYdSL25eQ%3D",
      "cdn_url": "https://audio2.brain.fm/UnitedAtLast_Focus_DeepWork_PostRock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnitedAtLast_Focus_DeepWork_PostRock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnitedAtLast_Focus_DeepWork_PostRock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/UnitedAtLast_Focus_DeepWork_PostRock_30_90bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28985735,
      "sha256": "8106199ceae3d0ce7255b42e8ff06cdb7c20a7213556805d307eeca769182db2",
      "download_error": null
    },
    {
      "track_id": "66f178d7d7073bdb17919a9e",
      "name": "Sunset Haze",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.95,
      "complexity_level": 0.96,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/SunsetHaze_Focus_DeepWork_PostRock_30_130bpm_MedNELNrmlzd2_VBR5.mp3?expiration=1792292140809&token=hcqFVicYPTv1gAeUVoZI2%2FGULZ%2BP94SD9c4WS2PklE4%3D",
      "cdn_url": "https://audio2.brain.fm/SunsetHaze_Focus_DeepWork_PostRock_30_130bpm_MedNELNrmlzd2_VBR5.mp3",
      "remote_filename": "SunsetHaze_Focus_DeepWork_PostRock_30_130bpm_MedNELNrmlzd2_VBR5.mp3",
      "filename": "SunsetHaze_Focus_DeepWork_PostRock_30_130bpm_MedNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/SunsetHaze_Focus_DeepWork_PostRock_30_130bpm_MedNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28320926,
      "sha256": "e9da579e259cfcb13fe0fec999414a4d40e9c309758fd62b25c48fc89e0e3a8c",
      "download_error": null
    },
    {
      "track_id": "66f175fed7073bdb179193e0",
      "name": "Glacial Landscapes",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.62,
      "complexity_level": 0.65,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/GlacialLandscapes_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=bOJbV4a5MOfZzivtqcQnL7Y0MCC7dyUBkBGFK8Wvmw8%3D",
      "cdn_url": "https://audio2.brain.fm/GlacialLandscapes_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GlacialLandscapes_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GlacialLandscapes_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/GlacialLandscapes_Focus_Creativity_PostRock_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27537444,
      "sha256": "c6c10fbac4f66806be45503967061dbd3e4a3565033d532d173f658efac31f0c",
      "download_error": null
    },
    {
      "track_id": "66f17446d7073bdb1791905e",
      "name": "Candid Reflection",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 83,
      "brightness_level": 0.87,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.49,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/CandidReflection_Focus_DeepWork_PostRock_30_83bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=EfhxTnKNWyEsBzqT8IHGRCv9yFqBSc%2BoZw7CfHEXjhw%3D",
      "cdn_url": "https://audio2.brain.fm/CandidReflection_Focus_DeepWork_PostRock_30_83bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CandidReflection_Focus_DeepWork_PostRock_30_83bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CandidReflection_Focus_DeepWork_PostRock_30_83bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/CandidReflection_Focus_DeepWork_PostRock_30_83bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28650798,
      "sha256": "a0d838be5505bcda6d1e6879cc97423363923f50808390e90afc32b6486cd3ba",
      "download_error": null
    },
    {
      "track_id": "66df00d0edad688793836871",
      "name": "Unruly Action",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 110,
      "brightness_level": 0.87,
      "complexity_level": 0.65,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/UnrulyAction_Focus_DeepWork_PostRock_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=4osmIsfs687GzSj3dOeTB9Jln06qOdXYu7RUOXuXm5w%3D",
      "cdn_url": "https://audio2.brain.fm/UnrulyAction_Focus_DeepWork_PostRock_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "UnrulyAction_Focus_DeepWork_PostRock_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "UnrulyAction_Focus_DeepWork_PostRock_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/UnrulyAction_Focus_DeepWork_PostRock_30_110bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27013842,
      "sha256": "f1393decac2215449c557d9320c9930594cb5a1a8ba3c3b0d6ea497ab004a085",
      "download_error": null
    },
    {
      "track_id": "66df0092edad68879383677b",
      "name": "Stargazer",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.69,
      "complexity_level": 0.78,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Stargazer_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3?expiration=1792292140809&token=8P%2Fppy8GNIsxHreK6P9s5f4TFCaRb0qAjnXT00dpefw%3D",
      "cdn_url": "https://audio2.brain.fm/Stargazer_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "Stargazer_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "filename": "Stargazer_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Stargazer_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27411172,
      "sha256": "f53ebc12c1d5e01c79129469bd37ab9b80bad933c55e948f4a0325b331c5685f",
      "download_error": null
    },
    {
      "track_id": "6683feb0d98e4183c363f000",
      "name": "Clean Conscience",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.79,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/CleanConscience_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3?expiration=1792292140809&token=%2F3W1gay4JBP4ldFmc69Puswm%2Bds7X2hxgjEFgWQUIRU%3D",
      "cdn_url": "https://audio2.brain.fm/CleanConscience_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "remote_filename": "CleanConscience_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "filename": "CleanConscience_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/CleanConscience_Focus_DeepWork_PostRock_30_120bpm_HighNELNrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26236812,
      "sha256": "5069019d3b4994108b1c0d4f422f51c35dd863ed0ae470bbfe0eefbc2ff81b8d",
      "download_error": null
    },
    {
      "track_id": "6683fd86d98e4183c363e7d0",
      "name": "New Batteries",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": null,
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.81,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.81,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/New%20Batteries_Focus_PostRock_Study_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=N7APtjLyjhfvxysnVR7U0clzDoWSX9xG3eIwWOn7ikA%3D",
      "cdn_url": "https://audio2.brain.fm/New%20Batteries_Focus_PostRock_Study_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "New Batteries_Focus_PostRock_Study_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "New-Batteries_Focus_PostRock_Study_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/New-Batteries_Focus_PostRock_Study_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29170531,
      "sha256": "5ae43c4f1dfa4d9614a449d39c6a35193d4430b07da7128e864683ff4e58ea99",
      "download_error": null
    },
    {
      "track_id": "6610624988d74c5142fdefe0",
      "name": "Matter and Energy",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.78,
      "complexity_level": 0.77,
      "style": "normal",
      "neural_effect_level": 0.53,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Matter%20and%20Energy_Focus_DeepWork_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=GaLD3HiZLpyfGlR9AUfQKqqKT0Bb50LmHwP3DCf%2FPb8%3D",
      "cdn_url": "https://audio2.brain.fm/Matter%20and%20Energy_Focus_DeepWork_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Matter and Energy_Focus_DeepWork_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Matter-and-Energy_Focus_DeepWork_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Matter-and-Energy_Focus_DeepWork_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28046897,
      "sha256": "e74ccb63a9e2e78643f9518ae993d43a2e28e67d26123a10a665f1233d96a1e7",
      "download_error": null
    },
    {
      "track_id": "65eb69da63853a000a159b2c",
      "name": "Automaton",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.6,
      "complexity_level": 0.98,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Automaton_Focus_DeepWork_PostRock_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=ywgTNvjH1fEkbI8I68zC8NfoyWFB8TkjDlvbsgrtjlE%3D",
      "cdn_url": "https://audio2.brain.fm/Automaton_Focus_DeepWork_PostRock_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Automaton_Focus_DeepWork_PostRock_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Automaton_Focus_DeepWork_PostRock_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Automaton_Focus_DeepWork_PostRock_30_130bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25364559,
      "sha256": "150e38e4834d5cc9f198d3cd5568495fef28ea55491f909648f4109ea273baf2",
      "download_error": null
    },
    {
      "track_id": "65a034876f05fa0008c157f6",
      "name": "Rind",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.73,
      "complexity_level": 0.74,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Rind%20Post%20Rock%20Focus%20Study%20Conor%20100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=0sZPRUXLljXSkIMsRvOoAMZAZ4MAMmGcHgWcs7tY%2FUk%3D",
      "cdn_url": "https://audio2.brain.fm/Rind%20Post%20Rock%20Focus%20Study%20Conor%20100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Rind Post Rock Focus Study Conor 100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Rind-Post-Rock-Focus-Study-Conor-100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Rind-Post-Rock-Focus-Study-Conor-100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28808614,
      "sha256": "3bf4d613d282559328ece7f0cef730e27c7f019e81916e2f92cc1987e43b92d5",
      "download_error": null
    },
    {
      "track_id": "655bc75afdfce65ab07a93f1",
      "name": "Nightwalk",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.46,
      "complexity_level": 0.8,
      "style": "normal",
      "neural_effect_level": 0.4,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Nightwalk%20Post%20Rock%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=hwwlx3q%2FmPld6AOJ2Yamixfbb7bIAhmz68F0BrmibXU%3D",
      "cdn_url": "https://audio2.brain.fm/Nightwalk%20Post%20Rock%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Nightwalk Post Rock Focus Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Nightwalk-Post-Rock-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Nightwalk-Post-Rock-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26303794,
      "sha256": "9d08c8b14a48b56773ef4d8470d4ebefbefd9bef4f387b5981c53de13fd39f2c",
      "download_error": null
    },
    {
      "track_id": "654aa73e62cef568048bb216",
      "name": "Breathe In (Extended Mix)",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 5319,
      "beats_per_minute": 120,
      "brightness_level": 0.6,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.64,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Breathe%20In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_expanded_VBR5.mp3?expiration=1792292140809&token=qESOR%2BGgnBCpN17QT7YzieLXdvEukvn4Doqg%2B7IDtdE%3D",
      "cdn_url": "https://audio2.brain.fm/Breathe%20In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_expanded_VBR5.mp3",
      "remote_filename": "Breathe In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_expanded_VBR5.mp3",
      "filename": "Breathe-In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_expanded_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Breathe-In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_expanded_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 84484696,
      "sha256": "37ec425bb6d7a593950dd4e72d4ca403e6f3a5ad3db9a8c446a0a304c8d50c0f",
      "download_error": null
    },
    {
      "track_id": "654aa6c662cef542c78bb0b2",
      "name": "Breathe In",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.6,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.64,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Breathe%20In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=yu7Run%2FroilTwNmKOuNwVWKOFdmDSotL7wRETjT%2BrOs%3D",
      "cdn_url": "https://audio2.brain.fm/Breathe%20In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Breathe In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Breathe-In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Breathe-In_Focus_DeepWork_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28688372,
      "sha256": "ca4dc36a8d5b8c8c8f6d6a741dff9e83f2016da4990484b9e494e967e36b4e26",
      "download_error": null
    },
    {
      "track_id": "651dda974489f24ee40d945d",
      "name": "Last Wish",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.64,
      "complexity_level": 0.73,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/LastWish_Focus_Creativity_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=EjmBngLG5MhBhwPhrh2zZqS35l5YvkETbpozfKPcFig%3D",
      "cdn_url": "https://audio2.brain.fm/LastWish_Focus_Creativity_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LastWish_Focus_Creativity_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "LastWish_Focus_Creativity_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/LastWish_Focus_Creativity_PostRock_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26305331,
      "sha256": "cf07e52ccbbc4afd83d1c3a45821dd2068f0439c525423fada4bcb0dc8500cd9",
      "download_error": null
    },
    {
      "track_id": "650ca267073bc0265cd332f7",
      "name": "Backcountry",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 900,
      "beats_per_minute": 98,
      "brightness_level": 0.65,
      "complexity_level": 0.6,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Backcountry%20Post%20Rock%20Focus%20Deep%20Work%20Conor%2098bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=7PQjmsNNg%2BIhnB7ZxjZx7yMxy%2FVn2b8G2fqmw7d48N4%3D",
      "cdn_url": "https://audio2.brain.fm/Backcountry%20Post%20Rock%20Focus%20Deep%20Work%20Conor%2098bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Backcountry Post Rock Focus Deep Work Conor 98bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Backcountry-Post-Rock-Focus-Deep-Work-Conor-98bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Backcountry-Post-Rock-Focus-Deep-Work-Conor-98bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27958875,
      "sha256": "b18e5fc44a50f006f11cad541bbdafb8671ded2da2a8edddb27c438f7b6de512",
      "download_error": null
    },
    {
      "track_id": "64f9e8aceea22b1f1b7fe0e6",
      "name": "Catch and Release",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 85,
      "brightness_level": 0.72,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/CatchandRelease_Focus_Creativity_PostRock_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=JCbrvd7usQ%2FCNKmNrB3bxAGmDcP3C0nPSsUc4ZHunNY%3D",
      "cdn_url": "https://audio2.brain.fm/CatchandRelease_Focus_Creativity_PostRock_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CatchandRelease_Focus_Creativity_PostRock_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CatchandRelease_Focus_Creativity_PostRock_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/CatchandRelease_Focus_Creativity_PostRock_30_85bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28271880,
      "sha256": "0ba2b67a671186afc06c86011d1c5da6816a1d27e9db8b07507edb8cba86f929",
      "download_error": null
    },
    {
      "track_id": "64dcff0d177f87b4189c8cd4",
      "name": "Snow Blanket",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.35,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Snow%20Blanket%20Post%20Rock%20Focus%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=xqwxKrPQQwu9CMa%2Bh%2BHmkp3PugpO30TD%2FpuLuS7F9H4%3D",
      "cdn_url": "https://audio2.brain.fm/Snow%20Blanket%20Post%20Rock%20Focus%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Snow Blanket Post Rock Focus Study Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Snow-Blanket-Post-Rock-Focus-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Snow-Blanket-Post-Rock-Focus-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24620006,
      "sha256": "f184a0053b48c20a9e7e98591609405f6e1a61bea202a112a3fc2c1cbf429f19",
      "download_error": null
    },
    {
      "track_id": "64dcfe81177f8720cd9c8b03",
      "name": "Quieting",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.62,
      "complexity_level": 0.64,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Quieting%20Post%20Rock%20Focus%20Deep%20Work%20Conor%20100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=bStrdFfXERRe6fQwzZiTEYJLALE%2BW3QtoS1ahDzw0EM%3D",
      "cdn_url": "https://audio2.brain.fm/Quieting%20Post%20Rock%20Focus%20Deep%20Work%20Conor%20100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Quieting Post Rock Focus Deep Work Conor 100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Quieting-Post-Rock-Focus-Deep-Work-Conor-100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Quieting-Post-Rock-Focus-Deep-Work-Conor-100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28031847,
      "sha256": "9dd0a79465499c38b53d150e251ee2f697fd78434f66553c15963a72300834fc",
      "download_error": null
    },
    {
      "track_id": "649460872b77ac9643ae2a12",
      "name": "Granary",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.84,
      "complexity_level": 0.64,
      "style": "normal",
      "neural_effect_level": 0.76,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Granary_Focus_Learning_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=fhKwE5rzBmIeKkKVbnPr%2BkEDPpsrSID76yDR47CkrsM%3D",
      "cdn_url": "https://audio2.brain.fm/Granary_Focus_Learning_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Granary_Focus_Learning_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Granary_Focus_Learning_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Granary_Focus_Learning_PostRock_30_100bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29423527,
      "sha256": "b5cad7102877f2859687036d121bb94ae609c158ddb1b8dfc19fc7631d8d7d94",
      "download_error": null
    },
    {
      "track_id": "6494603c7dc7e2ee144a46a2",
      "name": "The Endless",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 115,
      "brightness_level": 0.85,
      "complexity_level": 0.79,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/TheEndless_Focus_Creativity_PostRock_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=rZdrTQSJ33ze%2FJJTZGrJOyKxRMIRZYAFK0SVH%2FoSxnA%3D",
      "cdn_url": "https://audio2.brain.fm/TheEndless_Focus_Creativity_PostRock_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "TheEndless_Focus_Creativity_PostRock_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "TheEndless_Focus_Creativity_PostRock_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/TheEndless_Focus_Creativity_PostRock_30_115bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26095381,
      "sha256": "785b842a2b4a284a7cff367d00d81e5f4cfca2e9bbc965db54ca1b0e1d99d7ca",
      "download_error": null
    },
    {
      "track_id": "644ad56d3ecf73732100d9e7",
      "name": "Wolfram",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.7,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.74,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Wolfram%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=x7LVWenEtynvdPiqMU0hTgBhmoOo4qvYVu1MvxMgaho%3D",
      "cdn_url": "https://audio2.brain.fm/Wolfram%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Wolfram Post Rock Focus Study Conor 90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Wolfram-Post-Rock-Focus-Study-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Wolfram-Post-Rock-Focus-Study-Conor-90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26637204,
      "sha256": "e97b2a37fc3664ddf48a0e8485ad199f47adba7a780654c4a987aec0b1480b96",
      "download_error": null
    },
    {
      "track_id": "64302d995ee24c9f87a070fc",
      "name": "Undone",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.74,
      "complexity_level": 0.9,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Undone_Focus_DeepWork_PostRock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=YagQhE%2FGQKYWT9hL45JJfwqSr3GbtPOqsTZ0aQMoEG8%3D",
      "cdn_url": "https://audio2.brain.fm/Undone_Focus_DeepWork_PostRock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Undone_Focus_DeepWork_PostRock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Undone_Focus_DeepWork_PostRock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Undone_Focus_DeepWork_PostRock_30_80bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27400539,
      "sha256": "dca4c5d3af2ad2afa4cf8fa675272e3843a7eacdae4946387293b2bb1d2eac4d",
      "download_error": null
    },
    {
      "track_id": "64302c5623c3be26d53fb899",
      "name": "Nightdrive",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 112,
      "brightness_level": 0.68,
      "complexity_level": 0.94,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Nightdrive_Focus_DeepWork_PostRock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=4Z2Rjv5GEk2BPyRqJLDQ2fsh%2BggPCtqwAiwtjrPew4Q%3D",
      "cdn_url": "https://audio2.brain.fm/Nightdrive_Focus_DeepWork_PostRock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Nightdrive_Focus_DeepWork_PostRock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Nightdrive_Focus_DeepWork_PostRock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Nightdrive_Focus_DeepWork_PostRock_30_112bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26343790,
      "sha256": "5f695815227e75c80d6bb48dc6583c8afc6ce76b2b7b610c7978949e0fdf574c",
      "download_error": null
    },
    {
      "track_id": "64258f697fc6945d3bae8814",
      "name": "Remedies",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 72,
      "brightness_level": 0.9,
      "complexity_level": 0.86,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Remedies_Focus_DeepWork_PostRock_30_72bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=uR1UiD%2B0WaDmw45pYvVECxyJFX3kK3FDBmmYZfBetic%3D",
      "cdn_url": "https://audio2.brain.fm/Remedies_Focus_DeepWork_PostRock_30_72bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Remedies_Focus_DeepWork_PostRock_30_72bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Remedies_Focus_DeepWork_PostRock_30_72bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Remedies_Focus_DeepWork_PostRock_30_72bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28647185,
      "sha256": "bd366a4d3e2525fe9ca0fc7723fcee2aa11f1a137203b2bfad71fd9991eebef5",
      "download_error": null
    },
    {
      "track_id": "63f3da0ae1e0581c7493ae52",
      "name": "Blacktop",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.71,
      "complexity_level": 0.77,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Blacktop_Focus_Creativity_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=sdACBt%2F%2Fq7V7s9knkhFVgCS6zvpbijD6DYH9v%2FC19MM%3D",
      "cdn_url": "https://audio2.brain.fm/Blacktop_Focus_Creativity_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Blacktop_Focus_Creativity_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Blacktop_Focus_Creativity_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Blacktop_Focus_Creativity_PostRock_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26445313,
      "sha256": "76016f828771491b060904edfe94f9262e0e66d86a6dac0f38db745b53586880",
      "download_error": null
    },
    {
      "track_id": "63f3da00c446aad423144fe2",
      "name": "Overseas",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 82,
      "brightness_level": 0.79,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Overseas_Focus_CreativeFlow_PostRock_30_82bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Sv5ibaHSYkOGB9jO4SsC73QHXnKHaGVSI24yJnRDHvk%3D",
      "cdn_url": "https://audio2.brain.fm/Overseas_Focus_CreativeFlow_PostRock_30_82bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Overseas_Focus_CreativeFlow_PostRock_30_82bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Overseas_Focus_CreativeFlow_PostRock_30_82bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Overseas_Focus_CreativeFlow_PostRock_30_82bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29165886,
      "sha256": "9327c111652abda64debec7f7565c4c180dec5236a4f7b1ddc88cc81a68d1c9c",
      "download_error": null
    },
    {
      "track_id": "63f3d9f5c446aa20b3144fae",
      "name": "Hall of Mirrors",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 80,
      "brightness_level": 0.82,
      "complexity_level": 0.87,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Hall%20of%20Mirrors%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%2080bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=omrkH7K5xF1%2Fic7qrWJ0OZUtld8RubJxOP7fivb9ZMs%3D",
      "cdn_url": "https://audio2.brain.fm/Hall%20of%20Mirrors%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%2080bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Hall of Mirrors Post Rock Focus Creative Flow Conor 80bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Hall-of-Mirrors-Post-Rock-Focus-Creative-Flow-Conor-80bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Hall-of-Mirrors-Post-Rock-Focus-Creative-Flow-Conor-80bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26241024,
      "sha256": "c1f0dfe3543f552febe4522e63cc32d81492308c7bfa1f24a5497d64a4d094f5",
      "download_error": null
    },
    {
      "track_id": "63f3d9e9e1e058131793addb",
      "name": "Return to Dust",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.72,
      "complexity_level": 0.79,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Return%20to%20Dust_Focus_CreativeFlow_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Nur2od2ABGwdWgFk6G%2Fm0woSHWNplLLqfheRId6o8js%3D",
      "cdn_url": "https://audio2.brain.fm/Return%20to%20Dust_Focus_CreativeFlow_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Return to Dust_Focus_CreativeFlow_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Return-to-Dust_Focus_CreativeFlow_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Return-to-Dust_Focus_CreativeFlow_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29252418,
      "sha256": "b92835b79026c0f9db106cc7ff7874a5818d7520d3222b51282d4c8134c147ca",
      "download_error": null
    },
    {
      "track_id": "637e62fbfa040bb2120db849",
      "name": "Diurnality",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 70,
      "brightness_level": 0.5,
      "complexity_level": 0.57,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Diurnality%20Post%20Rock%20Focus%20Deep%20Work%20Conor%2070bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=8tpO3EHk363BxQMW0dfbWBYkd6lzTMdPdE0TLa7L64c%3D",
      "cdn_url": "https://audio2.brain.fm/Diurnality%20Post%20Rock%20Focus%20Deep%20Work%20Conor%2070bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Diurnality Post Rock Focus Deep Work Conor 70bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Diurnality-Post-Rock-Focus-Deep-Work-Conor-70bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Diurnality-Post-Rock-Focus-Deep-Work-Conor-70bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28448317,
      "sha256": "c2fb8a05df0c56017ec7c93e80a53bc4c72e6e75a0a1bff31f66d44260688f59",
      "download_error": null
    },
    {
      "track_id": "63754ccb85485a1fb648246e",
      "name": "Semicolon",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 98,
      "brightness_level": 0.83,
      "complexity_level": 0.81,
      "style": "normal",
      "neural_effect_level": 0.69,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Semicolon_Focus_DeepWork_PostRock_30_98bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=Uy%2FOx81VJJU0%2B6fKHiSaX9gR5M7jrfNOAXrWldSZwSE%3D",
      "cdn_url": "https://audio2.brain.fm/Semicolon_Focus_DeepWork_PostRock_30_98bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Semicolon_Focus_DeepWork_PostRock_30_98bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Semicolon_Focus_DeepWork_PostRock_30_98bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Semicolon_Focus_DeepWork_PostRock_30_98bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28962124,
      "sha256": "647a73ffec71493ab3f3d48149ff6945cc76450d7a37600c0e1812a0ff864d18",
      "download_error": null
    },
    {
      "track_id": "636beea27161e733065f1bad",
      "name": "Vast Migration",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.73,
      "complexity_level": 0.83,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Vast%20Migration_Focus_DeepWork_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=XzByzu4CQ9KJC546EA%2BLjp66plGkZKZT9sIH8VrPjCo%3D",
      "cdn_url": "https://audio2.brain.fm/Vast%20Migration_Focus_DeepWork_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Vast Migration_Focus_DeepWork_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Vast-Migration_Focus_DeepWork_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Vast-Migration_Focus_DeepWork_PostRock_30_90bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29509653,
      "sha256": "87f527448924bd8c1d8d3a2d43f36f7ba64abaeb044fc980bfc6f42b717773e4",
      "download_error": null
    },
    {
      "track_id": "62b38c0b59241104aaf55360",
      "name": "Five Waters",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.07,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Five%20Waters%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_1.6_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=GmxyoxowQyA7QXZjw6hhRB%2FAaw8xgp30X7394ufwBCU%3D",
      "cdn_url": "https://audio2.brain.fm/Five%20Waters%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_1.6_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Five Waters Post Rock Focus Study Conor 90bpm_1.6_Nrmlzd2_VBR5.mp3",
      "filename": "Five-Waters-Post-Rock-Focus-Study-Conor-90bpm_1.6_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Five-Waters-Post-Rock-Focus-Study-Conor-90bpm_1.6_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26015204,
      "sha256": "9031af671063fc08537d7800b9be0612a9e0c22c7502fe97b0392886f4126d80",
      "download_error": null
    },
    {
      "track_id": "62b38a965924114d9cf5488f",
      "name": "Through the Mist",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.62,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Through%20the%20Mist%20Post%20Rock%20Multitask%20Session%202%20Chris%20120bpm_1.2_VBR5.mp3?expiration=1792292140809&token=EgtJM7z3L%2FT8ZZtsSzYgtr0POrOWayZPpmMdwJ1eAN8%3D",
      "cdn_url": "https://audio2.brain.fm/Through%20the%20Mist%20Post%20Rock%20Multitask%20Session%202%20Chris%20120bpm_1.2_VBR5.mp3",
      "remote_filename": "Through the Mist Post Rock Multitask Session 2 Chris 120bpm_1.2_VBR5.mp3",
      "filename": "Through-the-Mist-Post-Rock-Multitask-Session-2-Chris-120bpm_1.2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Through-the-Mist-Post-Rock-Multitask-Session-2-Chris-120bpm_1.2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23806293,
      "sha256": "a5d0c1dccb62c2ef57ed4c7ce82d8944ae56a92669794917f389af8fb94edca5",
      "download_error": null
    },
    {
      "track_id": "62b38a855924119b80f546cb",
      "name": "Solar Mist",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.57,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Solar%20Mist%20Post%20Rock%20Light%20Work%20Session%204%20Chris%20100bpm_VBR5.mp3?expiration=1792292140809&token=dn9EFmlZ3%2BhX59muItKfOuQOiuAaI2H1F8kwQ1%2BBxVs%3D",
      "cdn_url": "https://audio2.brain.fm/Solar%20Mist%20Post%20Rock%20Light%20Work%20Session%204%20Chris%20100bpm_VBR5.mp3",
      "remote_filename": "Solar Mist Post Rock Light Work Session 4 Chris 100bpm_VBR5.mp3",
      "filename": "Solar-Mist-Post-Rock-Light-Work-Session-4-Chris-100bpm_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Solar-Mist-Post-Rock-Light-Work-Session-4-Chris-100bpm_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25817677,
      "sha256": "bd0828775c70976dc9c68efaa092bc8446c9541062e583c462bda034a4a54bd4",
      "download_error": null
    },
    {
      "track_id": "62b38a845924112f14f5469e",
      "name": "Chasing Storms",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.4,
      "complexity_level": 0.5,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Chasing%20Storms%20Post%20Rock%20Focus%20Deep%20Work%20Conor%2090bpm_1.4_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=R1%2F0ET8J2brpm6%2Fx8BagKMLDwyyiKZml5YlTJGctPbE%3D",
      "cdn_url": "https://audio2.brain.fm/Chasing%20Storms%20Post%20Rock%20Focus%20Deep%20Work%20Conor%2090bpm_1.4_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Chasing Storms Post Rock Focus Deep Work Conor 90bpm_1.4_Nrmlzd2_VBR5.mp3",
      "filename": "Chasing-Storms-Post-Rock-Focus-Deep-Work-Conor-90bpm_1.4_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Chasing-Storms-Post-Rock-Focus-Deep-Work-Conor-90bpm_1.4_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26179472,
      "sha256": "bb5143b58c6a73830058e91e4343b2ab70f59d25237ecdf83c19fedeb38d8276",
      "download_error": null
    },
    {
      "track_id": "62b38a2e592411df7cf5416f",
      "name": "Shards of Light",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.05,
      "complexity_level": 0.01,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Slivers%20of%20Light%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_1.4_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=DunKRrciirIPSgyk57bDO4YbUBK0F85jpBhnRoQC2Zc%3D",
      "cdn_url": "https://audio2.brain.fm/Slivers%20of%20Light%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_1.4_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Slivers of Light Post Rock Focus Study Conor 90bpm_1.4_Nrmlzd2_VBR5.mp3",
      "filename": "Slivers-of-Light-Post-Rock-Focus-Study-Conor-90bpm_1.4_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Slivers-of-Light-Post-Rock-Focus-Study-Conor-90bpm_1.4_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24189546,
      "sha256": "3d0f9927b23d829dd7cd44ffdd8ca23beb1dd6ca3064cdf3501e2a467cdfa252",
      "download_error": null
    },
    {
      "track_id": "62b389f75924113949f53c13",
      "name": "Through the Stars",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.66,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Through%20the%20Stars%20Post%20Rock%20Multitask%20Session%209%20Chris%20120bpm_VBR5.mp3?expiration=1792292140809&token=ijwUyV8CXZAA4tKfZBvbLfroMDmMmMttiAUlPVXW7M0%3D",
      "cdn_url": "https://audio2.brain.fm/Through%20the%20Stars%20Post%20Rock%20Multitask%20Session%209%20Chris%20120bpm_VBR5.mp3",
      "remote_filename": "Through the Stars Post Rock Multitask Session 9 Chris 120bpm_VBR5.mp3",
      "filename": "Through-the-Stars-Post-Rock-Multitask-Session-9-Chris-120bpm_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Through-the-Stars-Post-Rock-Multitask-Session-9-Chris-120bpm_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25026220,
      "sha256": "f634af8f4f380d464571ebfeb92488ce8f05fe5c95474201ca237d14887ebe62",
      "download_error": null
    },
    {
      "track_id": "62b389f35924119b59f53b9e",
      "name": "New Day",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.39,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/New%20Day%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_1.2_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=RvagxHWJ5YKLx7yupTJh7fv1OtqS2jnbxDaua11wm%2FQ%3D",
      "cdn_url": "https://audio2.brain.fm/New%20Day%20Post%20Rock%20Focus%20Study%20Conor%2090bpm_1.2_Nrmlzd2_VBR5.mp3",
      "remote_filename": "New Day Post Rock Focus Study Conor 90bpm_1.2_Nrmlzd2_VBR5.mp3",
      "filename": "New-Day-Post-Rock-Focus-Study-Conor-90bpm_1.2_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/New-Day-Post-Rock-Focus-Study-Conor-90bpm_1.2_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24374430,
      "sha256": "fef8d6b0c739fb19db6a63c2727c9f3498d977e9e8257704224bc7ba024707cf",
      "download_error": null
    },
    {
      "track_id": "62b389d6592411f6f6f5381f",
      "name": "Sun Rises",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.45,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Sun%20Rises%20Post%20Rock%20Multitask%20Session%204%20Chris%20120bpm_VBR5.mp3?expiration=1792292140809&token=EnWvahJbR85uvWvtq4%2B5B3urOwDhSNImvji841zvdww%3D",
      "cdn_url": "https://audio2.brain.fm/Sun%20Rises%20Post%20Rock%20Multitask%20Session%204%20Chris%20120bpm_VBR5.mp3",
      "remote_filename": "Sun Rises Post Rock Multitask Session 4 Chris 120bpm_VBR5.mp3",
      "filename": "Sun-Rises-Post-Rock-Multitask-Session-4-Chris-120bpm_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Sun-Rises-Post-Rock-Multitask-Session-4-Chris-120bpm_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23268593,
      "sha256": "2d54decbd1d8e0542d10d0be5155c85b9d92267d4da61e644aa1f6f7594d49be",
      "download_error": null
    },
    {
      "track_id": "62b389d05924111d4df53751",
      "name": "Once More",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.74,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.62,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Once%20More%20Post%20Rock%20Multitask%20Session%208%20Chris%20100_VBR5.mp3?expiration=1792292140809&token=%2B43QoD%2BxXgbn384vNsHWTd%2FtJV4FoZehMGtaKEfQBGE%3D",
      "cdn_url": "https://audio2.brain.fm/Once%20More%20Post%20Rock%20Multitask%20Session%208%20Chris%20100_VBR5.mp3",
      "remote_filename": "Once More Post Rock Multitask Session 8 Chris 100_VBR5.mp3",
      "filename": "Once-More-Post-Rock-Multitask-Session-8-Chris-100_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Once-More-Post-Rock-Multitask-Session-8-Chris-100_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24927244,
      "sha256": "f6cf03bc7d1a5c94602affc6b8ff10a9c84d5903da6be9eef1bbb08b94547225",
      "download_error": null
    },
    {
      "track_id": "62b3894059241147daf530f2",
      "name": "Dark Matter",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.48,
      "complexity_level": 0.02,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Dark%20Matter%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%20100bpm_1.1_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=q752h0MUyKBMx%2BPBkqxyUWrV2zN1xfx%2BiVoXtuCFSQQ%3D",
      "cdn_url": "https://audio2.brain.fm/Dark%20Matter%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%20100bpm_1.1_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Dark Matter Post Rock Focus Creative Flow Conor 100bpm_1.1_Nrmlzd2_VBR5.mp3",
      "filename": "Dark-Matter-Post-Rock-Focus-Creative-Flow-Conor-100bpm_1.1_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Dark-Matter-Post-Rock-Focus-Creative-Flow-Conor-100bpm_1.1_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26670526,
      "sha256": "0090c791b9e3bf0ccd0da1877c1fc22471945f5c1e731070f0026aa99c176109",
      "download_error": null
    },
    {
      "track_id": "62b388ea592411183ef52ddd",
      "name": "Power Through",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.4,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Power%20Through%20Post%20Rock%20Deep%20Work%20Chris%20120bpm_VBR5.mp3?expiration=1792292140809&token=bvLNNTjMWF%2BWjotfRE%2FzTuY%2FIxWTMV32lKElqWZgEFY%3D",
      "cdn_url": "https://audio2.brain.fm/Power%20Through%20Post%20Rock%20Deep%20Work%20Chris%20120bpm_VBR5.mp3",
      "remote_filename": "Power Through Post Rock Deep Work Chris 120bpm_VBR5.mp3",
      "filename": "Power-Through-Post-Rock-Deep-Work-Chris-120bpm_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Power-Through-Post-Rock-Deep-Work-Chris-120bpm_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23344195,
      "sha256": "db31bff7e224c6bb705762f020071487ab4eb2db4c8e9c81f89f0da2e4282b05",
      "download_error": null
    },
    {
      "track_id": "62b388b359241193b5f5279d",
      "name": "Solitude",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.56,
      "complexity_level": 0.44,
      "style": "normal",
      "neural_effect_level": 0.04,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Solitude%20Post%20Rock%20Light%20Work%20Session%205%20Chris%2090_VBR5.mp3?expiration=1792292140809&token=0BWnhGKI6Z8YePDYmeySS3XhzPCiutmyNtl7SfK0irQ%3D",
      "cdn_url": "https://audio2.brain.fm/Solitude%20Post%20Rock%20Light%20Work%20Session%205%20Chris%2090_VBR5.mp3",
      "remote_filename": "Solitude Post Rock Light Work Session 5 Chris 90_VBR5.mp3",
      "filename": "Solitude-Post-Rock-Light-Work-Session-5-Chris-90_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Solitude-Post-Rock-Light-Work-Session-5-Chris-90_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25213274,
      "sha256": "204d94a0149daf0308a147b711e130ed948b79223eb31433fe37e6d3de95072c",
      "download_error": null
    },
    {
      "track_id": "62b388a5592411e8d8f5258d",
      "name": "Overdrive",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 116,
      "brightness_level": 0.72,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Overdrive%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%20116bpm_1.3_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=n9sPufQVCqjFYVtElAhwPkksNkLqAbH8nvHhomyvNXg%3D",
      "cdn_url": "https://audio2.brain.fm/Overdrive%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%20116bpm_1.3_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Overdrive Post Rock Focus Creative Flow Conor 116bpm_1.3_Nrmlzd2_VBR5.mp3",
      "filename": "Overdrive-Post-Rock-Focus-Creative-Flow-Conor-116bpm_1.3_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Overdrive-Post-Rock-Focus-Creative-Flow-Conor-116bpm_1.3_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28148525,
      "sha256": "0a22c75b6a635a0e2c579fd9dd79d2c6e6c9c4258b4d4098ad465319794f1d06",
      "download_error": null
    },
    {
      "track_id": "62b3889c59241151c8f52460",
      "name": "Gold Dust",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 100,
      "brightness_level": 0.71,
      "complexity_level": 0.04,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Gold%20Dust%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%20100bpm_1.3_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=TD4JBfDczU3wdwOF8Dcuow2LksUdwlVe%2BV8LbDy3I80%3D",
      "cdn_url": "https://audio2.brain.fm/Gold%20Dust%20Post%20Rock%20Focus%20Creative%20Flow%20Conor%20100bpm_1.3_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Gold Dust Post Rock Focus Creative Flow Conor 100bpm_1.3_Nrmlzd2_VBR5.mp3",
      "filename": "Gold-Dust-Post-Rock-Focus-Creative-Flow-Conor-100bpm_1.3_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Gold-Dust-Post-Rock-Focus-Creative-Flow-Conor-100bpm_1.3_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28788537,
      "sha256": "54e0b4b78ffc70ebaa265a28d1537c4b37b4ecd19b73a70a36ae2c9bc8aa7f4b",
      "download_error": null
    },
    {
      "track_id": "62b387bf592411bcdaf5212a",
      "name": "Lost and Found",
      "category": "Post Rock",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 90,
      "brightness_level": 0.7,
      "complexity_level": 0.09,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/post-rock.json",
      "source_url": "https://audio2.brain.fm/Lost%20and%20Found%20Post%20Rock%20Study%20Focus%20Conor%2090bpm_1.5_Nrmlzd2_VBR5.mp3?expiration=1792292140809&token=LZ3FMZG6DNGZ1ZvOfVtBxSGFerlrRC6woFD2rQ%2F05vI%3D",
      "cdn_url": "https://audio2.brain.fm/Lost%20and%20Found%20Post%20Rock%20Study%20Focus%20Conor%2090bpm_1.5_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Lost and Found Post Rock Study Focus Conor 90bpm_1.5_Nrmlzd2_VBR5.mp3",
      "filename": "Lost-and-Found-Post-Rock-Study-Focus-Conor-90bpm_1.5_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/post-rock/Lost-and-Found-Post-Rock-Study-Focus-Conor-90bpm_1.5_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25893677,
      "sha256": "5b5b914d9b18c50e3c4b6e636edbc2f20a813209bb40c29dbeb41ed725d179af",
      "download_error": null
    },
    {
      "track_id": "692dbe32b8f361da92eba140",
      "name": "Soothing Shower",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.01,
      "complexity_level": 0.03,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/SoothingShower_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=mXg7fWm14FNkctHq7z3DQcTnHZEfTOOsp2tMifhTB8k%3D",
      "cdn_url": "https://audio2.brain.fm/SoothingShower_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SoothingShower_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SoothingShower_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/SoothingShower_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27089542,
      "sha256": "716f47f2a284e90ada4db89d4e4cf320d0a842d37e56068b6e9046a47370f913",
      "download_error": null
    },
    {
      "track_id": "692dbe22b8f361da92eba0ce",
      "name": "Mist Valley",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.33,
      "complexity_level": 0.11,
      "style": "normal",
      "neural_effect_level": 0.45,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/MistValley_Focus_DeepWork_Nature_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=fk%2Bjb%2FOQAVo4OyJ0pMUyOa4i20kqk6SMeSITNOkSKEI%3D",
      "cdn_url": "https://audio2.brain.fm/MistValley_Focus_DeepWork_Nature_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MistValley_Focus_DeepWork_Nature_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MistValley_Focus_DeepWork_Nature_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/MistValley_Focus_DeepWork_Nature_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24310804,
      "sha256": "2f151d878ae74357a60b63e442a6c674768e5266c60618a9812c4e03e5552ba8",
      "download_error": null
    },
    {
      "track_id": "69091a66312eb1fe046598a7",
      "name": "Grey Horizon",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.01,
      "complexity_level": 0.07,
      "style": "normal",
      "neural_effect_level": 0.05,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/GreyHorizon_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=hak%2FZycNCUBkM3HZClDnGpwCVMsBZe%2FfVAGXXKZ8fUk%3D",
      "cdn_url": "https://audio2.brain.fm/GreyHorizon_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GreyHorizon_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GreyHorizon_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/GreyHorizon_Focus_DeepWork_Nature_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24835097,
      "sha256": "4ddd8b5accee3f17b20851d7a34352f57eecf80ceb078aeb1f0f24b9bea19235",
      "download_error": null
    },
    {
      "track_id": "64302d4823c3be12d23fbdc5",
      "name": "Spring Mist",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.99,
      "complexity_level": 0.52,
      "style": "normal",
      "neural_effect_level": 0.65,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/SpringMist_Focus_DeepWork_Rain_30_120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=FSkAGJk%2BVHcxb8nedugfnY3YsOucQG9%2FA3KdvTVa%2BgE%3D",
      "cdn_url": "https://audio2.brain.fm/SpringMist_Focus_DeepWork_Rain_30_120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SpringMist_Focus_DeepWork_Rain_30_120bpm_MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "SpringMist_Focus_DeepWork_Rain_30_120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/SpringMist_Focus_DeepWork_Rain_30_120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29009626,
      "sha256": "c90ffddbe3452893fce9ff19046f28975eb22d64e90a773640cf593e65b65108",
      "download_error": null
    },
    {
      "track_id": "64302d1923c3be633b3fbbfe",
      "name": "Shapes in the Rain",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.58,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/ShapesintheRain_Focus_DeepWork_Rain_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=m6jeOMdyVTdW%2FoSu7tOPMfKHAzOtVjSIoCyeyrB%2BrTs%3D",
      "cdn_url": "https://audio2.brain.fm/ShapesintheRain_Focus_DeepWork_Rain_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ShapesintheRain_Focus_DeepWork_Rain_30_120bpm_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "ShapesintheRain_Focus_DeepWork_Rain_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/ShapesintheRain_Focus_DeepWork_Rain_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28302630,
      "sha256": "a77681f3f78bc1efc2f815ec58d4ec53bdc5c1262e98dc3139058f8a1b579d7d",
      "download_error": null
    },
    {
      "track_id": "64302bed23c3be88453fb58f",
      "name": "Natural Presence",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.46,
      "style": "normal",
      "neural_effect_level": 0.15,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/NaturalPresence_Focus_Learning_Rain_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=fIJsPkGIHvSiNeIiqGU8jDz4vyZAeFTTPJEcHTv1A5U%3D",
      "cdn_url": "https://audio2.brain.fm/NaturalPresence_Focus_Learning_Rain_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NaturalPresence_Focus_Learning_Rain_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "NaturalPresence_Focus_Learning_Rain_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/NaturalPresence_Focus_Learning_Rain_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30882821,
      "sha256": "0fff66dd4fa4d45cc71a100dfea35e3a67937a58d7e1be76d289c879fe7a814a",
      "download_error": null
    },
    {
      "track_id": "64302a3b5ee24c877ea05903",
      "name": "Delicate Drops",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.85,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/DelicateDrops_Focus_DeepWork_Rain_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=qbIXOSrREuSBiw1Goar%2B%2BAC6fs7WtxfBd2L2HAN40jE%3D",
      "cdn_url": "https://audio2.brain.fm/DelicateDrops_Focus_DeepWork_Rain_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DelicateDrops_Focus_DeepWork_Rain_30_120bpm_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "DelicateDrops_Focus_DeepWork_Rain_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/DelicateDrops_Focus_DeepWork_Rain_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30582081,
      "sha256": "671b2c96fcd49922beb595d6cac38342db02c72525739c88cf46617f25bacdb7",
      "download_error": null
    },
    {
      "track_id": "64302a0723c3bed28d3fad75",
      "name": "Cleansing Showers",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.78,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/CleansingShowers_Focus_Learning_Rain_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=P6xjajDw2eTy%2BmuVVgKIYXDNeuTsBfQSK0oLJeGwkt8%3D",
      "cdn_url": "https://audio2.brain.fm/CleansingShowers_Focus_Learning_Rain_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "CleansingShowers_Focus_Learning_Rain_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "CleansingShowers_Focus_Learning_Rain_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/CleansingShowers_Focus_Learning_Rain_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27872004,
      "sha256": "799eda80ed105864cd398c5fb7d8721ec0f6149271fb6a1a076e04f5d9062b68",
      "download_error": null
    },
    {
      "track_id": "62b38ae0592411accaf54b5d",
      "name": "Bringing Life",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Life%20Giver%20Rain%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292111150&token=Y1uvp5ZYRiBL1WqyuZJdv9zq9GZvfK6JWfNPhNy8dqk%3D",
      "cdn_url": "https://audio2.brain.fm/Life%20Giver%20Rain%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Life Giver Rain 5 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Life-Giver-Rain-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Life-Giver-Rain-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29555956,
      "sha256": "4002fae5e0641d476a26d534e03a6ac0e5cbd7ac5c252faf063d8d1030b8e0f7",
      "download_error": null
    },
    {
      "track_id": "62b38ad6592411dc03f54a45",
      "name": "Living Rain",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.56,
      "complexity_level": 0.72,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Living%20Rain%20Rain%20Focus%205%20Conor_1.6_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=95myMDOIuJyTa%2FTkP5Wuz5mRP%2BQDJxBIURxFvH7%2FeJo%3D",
      "cdn_url": "https://audio2.brain.fm/Living%20Rain%20Rain%20Focus%205%20Conor_1.6_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Living Rain Rain Focus 5 Conor_1.6_Nrmlzd2_VBR5.mp3",
      "filename": "Living-Rain-Rain-Focus-5-Conor_1.6_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Living-Rain-Rain-Focus-5-Conor_1.6_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26165790,
      "sha256": "0244e018bd2fadf3676651fc4713617ee1da0ba9db5b66f2494e767907c5d943",
      "download_error": null
    },
    {
      "track_id": "62b38a8c592411c313f54770",
      "name": "Sky Blue",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Stratosphere%20Rain%204%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292111150&token=qLcMPeQ0W02Wng0Jlv8oArtclMY5jObmsUrm9LHumKg%3D",
      "cdn_url": "https://audio2.brain.fm/Stratosphere%20Rain%204%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Stratosphere Rain 4 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Stratosphere-Rain-4-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Stratosphere-Rain-4-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29522648,
      "sha256": "517275f505b139274c4b6d6c65985b79bab478b6b497588be009cb76ee97b97e",
      "download_error": null
    },
    {
      "track_id": "62b38a715924112599f54429",
      "name": "Afternoon Showers",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Afternoon%20Showers%20Rain%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=GoVKZf3o8OPN7%2Frr6Swn%2BVTWij8J1neh2s2RrEQ%2FlhE%3D",
      "cdn_url": "https://audio2.brain.fm/Afternoon%20Showers%20Rain%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Afternoon Showers Rain Focus Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Afternoon-Showers-Rain-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Afternoon-Showers-Rain-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29986790,
      "sha256": "b76cd912e716fa001ace15e9700f1bee035390fb2e0a377042b8b6b16c5bcdaa",
      "download_error": null
    },
    {
      "track_id": "62b389cb592411726bf536ac",
      "name": "Pluie",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.64,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.47,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Pluie%20Rain%20Focus%204%20Conor_1.3_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=Zorl98JEGC%2FK3Uvzc5F1UxOPvr6Qu5ucOaa%2FJ7dNjGQ%3D",
      "cdn_url": "https://audio2.brain.fm/Pluie%20Rain%20Focus%204%20Conor_1.3_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pluie Rain Focus 4 Conor_1.3_Nrmlzd2_VBR5.mp3",
      "filename": "Pluie-Rain-Focus-4-Conor_1.3_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Pluie-Rain-Focus-4-Conor_1.3_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26528376,
      "sha256": "2f4b38766b64f61187f3e46d3afb6e85c43b89442cb67f882377bc95259f0dc6",
      "download_error": null
    },
    {
      "track_id": "62b388b759241175d8f5283c",
      "name": "Sheets of Rain",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.72,
      "complexity_level": 0.58,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Sheets%20of%20Rain%20Rain%20Focus%203%20Conor_1.5_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=h3y7S2Q89XMniGzhmS8MsN2K3ydEbuD0PUWBrVNJamk%3D",
      "cdn_url": "https://audio2.brain.fm/Sheets%20of%20Rain%20Rain%20Focus%203%20Conor_1.5_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sheets of Rain Rain Focus 3 Conor_1.5_Nrmlzd2_VBR5.mp3",
      "filename": "Sheets-of-Rain-Rain-Focus-3-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Sheets-of-Rain-Rain-Focus-3-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26441285,
      "sha256": "0022e6cd37afe2cf4334225fa1167849e71ed37f503914fd7a271e10aa58184a",
      "download_error": null
    },
    {
      "track_id": "62b388b45924117f6df527be",
      "name": "Eye of the Storm",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 130,
      "brightness_level": 0.81,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.1,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Eye%20of%20the%20Storm%20Rain%203%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292111150&token=0iby6iPbd5M1HhKmlNhjsYbCmGDyfWaKcanBx4po5Vg%3D",
      "cdn_url": "https://audio2.brain.fm/Eye%20of%20the%20Storm%20Rain%203%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Eye of the Storm Rain 3 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Eye-of-the-Storm-Rain-3-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Eye-of-the-Storm-Rain-3-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29395394,
      "sha256": "daa5efb7532c6451d04260b8432f646d568e9ceeeb7751d1526747c372f68289",
      "download_error": null
    },
    {
      "track_id": "62b387b3592411692cf51f2f",
      "name": "Focused Drops",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Focused%20Drops%20Rain%202%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292111150&token=kO3ECxGTNtEqaRe7VVAGvDYRSiidWpHWb7X9%2BCylwn0%3D",
      "cdn_url": "https://audio2.brain.fm/Focused%20Drops%20Rain%202%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Focused Drops Rain 2 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Focused-Drops-Rain-2-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Focused-Drops-Rain-2-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28460898,
      "sha256": "090ec395dc4a30a3951b539a7691a3c87bfce10c9fbe99a6d5b14d312893216a",
      "download_error": null
    },
    {
      "track_id": "62b387ae592411e293f51e50",
      "name": "Opening Sky",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.77,
      "complexity_level": 0.65,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Opening%20Sky%20Rain%20Focus%202%20Conor_1.5_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=x13aCxz%2FNZkB8gCysdawf8FiAo0cUkfYE6Z0bgJU9Ok%3D",
      "cdn_url": "https://audio2.brain.fm/Opening%20Sky%20Rain%20Focus%202%20Conor_1.5_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Opening Sky Rain Focus 2 Conor_1.5_Nrmlzd2_VBR5.mp3",
      "filename": "Opening-Sky-Rain-Focus-2-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Opening-Sky-Rain-Focus-2-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26821459,
      "sha256": "be78f7d5c1f2745d2ba3c43d4a72f82902676b099440489635158b2e18409405",
      "download_error": null
    },
    {
      "track_id": "62b387ae5924112d27f51e2d",
      "name": "Coffee & Rain",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Rain-FOCUS-WithAmbience_VBR5.mp3?expiration=1792292111150&token=UZf0ct9FUZR%2FUM1N%2BBSOke2PTNwWcJ8RwdH6OiOb0gw%3D",
      "cdn_url": "https://audio2.brain.fm/Rain-FOCUS-WithAmbience_VBR5.mp3",
      "remote_filename": "Rain-FOCUS-WithAmbience_VBR5.mp3",
      "filename": "Rain-FOCUS-WithAmbience_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Rain-FOCUS-WithAmbience_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 33402931,
      "sha256": "a47e6d19509667595d852188bbb8dcb934a09eee4f29441f7e6a697607a5b81f",
      "download_error": null
    },
    {
      "track_id": "62b3875f592411c473f5164e",
      "name": "April Showers",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Rain-Drones-FOCUS-Nrmlzd_VBR5.mp3?expiration=1792292111150&token=ZSoG8xndShOdKHAZDKS9bHN%2BVNpnmQtzr5UTaSDP2oE%3D",
      "cdn_url": "https://audio2.brain.fm/Rain-Drones-FOCUS-Nrmlzd_VBR5.mp3",
      "remote_filename": "Rain-Drones-FOCUS-Nrmlzd_VBR5.mp3",
      "filename": "Rain-Drones-FOCUS-Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Rain-Drones-FOCUS-Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30730188,
      "sha256": "c0314ac9a065cebffc855e3b7c7d1a6a0f012c5c90511696ef7f2678f4ec0788",
      "download_error": null
    },
    {
      "track_id": "62b38108592411ea7af4e0a7",
      "name": "Studying the Rain",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Rain-DronesFOCUS1.0-Nrmlzd-5_VBR5.mp3?expiration=1792292111150&token=4Eu7Rmecr7epSeoLydkyUKH4OR5dCOrns2FAbmxwsJg%3D",
      "cdn_url": "https://audio2.brain.fm/Rain-DronesFOCUS1.0-Nrmlzd-5_VBR5.mp3",
      "remote_filename": "Rain-DronesFOCUS1.0-Nrmlzd-5_VBR5.mp3",
      "filename": "Rain-DronesFOCUS1.0-Nrmlzd-5_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Rain-DronesFOCUS1.0-Nrmlzd-5_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31155662,
      "sha256": "c87160cc84d8ee0dd0690ec037fdaf89735306840f4072b83115132abff48180",
      "download_error": null
    },
    {
      "track_id": "62b380f95924116bbdf4dbdc",
      "name": "Downpour",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.31,
      "style": "normal",
      "neural_effect_level": 0.23,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Downpour%20Rain%201%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292111150&token=1FEmCbXSLGHFyycoMDmOwbDHK%2FlUaC%2FG2hI%2FyBLsvRk%3D",
      "cdn_url": "https://audio2.brain.fm/Downpour%20Rain%201%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Downpour Rain 1 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Downpour-Rain-1-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Downpour-Rain-1-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32624645,
      "sha256": "31ed1e49b1eac0d7d99300d05d9e38487f77996dc75668c0042751c62b6b39eb",
      "download_error": null
    },
    {
      "track_id": "62b380e45924111e54f4d533",
      "name": "Driving Through",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.7,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Driving%20Through%20Rain%206%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292111150&token=FJwiTsfDdgyc1dgi1E%2BtGBolrj3kkzIFnhemOSzd4jU%3D",
      "cdn_url": "https://audio2.brain.fm/Driving%20Through%20Rain%206%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Driving Through Rain 6 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Driving-Through-Rain-6-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Driving-Through-Rain-6-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29615321,
      "sha256": "2d61d6f5b9ed2a0eededc898420b423fc73d8afbb88acb2724f616b9b2e92da6",
      "download_error": null
    },
    {
      "track_id": "62b380645924111a40f4c2a1",
      "name": "Falling Mist",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.65,
      "complexity_level": 0.71,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/Downpour%20Rain%20Focus%201%20Conor_1.2_Nrmlzd2_VBR5.mp3?expiration=1792292111150&token=8nJcVnB2qIWhRsR4rcZcIE1%2BG2D5Iwiblz%2BMYq4KWHI%3D",
      "cdn_url": "https://audio2.brain.fm/Downpour%20Rain%20Focus%201%20Conor_1.2_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Downpour Rain Focus 1 Conor_1.2_Nrmlzd2_VBR5.mp3",
      "filename": "Downpour-Rain-Focus-1-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/Downpour-Rain-Focus-1-Conor_1.2_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26959889,
      "sha256": "993b22db7046e55f76a1e1fc1b8259b753f6cf9249bd405337a81d00d32eb385",
      "download_error": null
    },
    {
      "track_id": "62b3806359241113fff4c219",
      "name": "Windowsill Drops",
      "category": "Rain",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.6,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/rain.json",
      "source_url": "https://audio2.brain.fm/TechnoUnkn2-RAIN-Template-1.2_VBR5.mp3?expiration=1792292111150&token=EaXixM6FDrdVWVwxHzpkNTpK86k7%2BoqVGehIzF0ezWI%3D",
      "cdn_url": "https://audio2.brain.fm/TechnoUnkn2-RAIN-Template-1.2_VBR5.mp3",
      "remote_filename": "TechnoUnkn2-RAIN-Template-1.2_VBR5.mp3",
      "filename": "TechnoUnkn2-RAIN-Template-1.2_VBR5.mp3",
      "relative_path": "outputs/audio/rain/TechnoUnkn2-RAIN-Template-1.2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22541802,
      "sha256": "776ed69d5dfb7ff8ecd513705e5dcf3a017b84d620acd84b2017e0306699d34c",
      "download_error": null
    },
    {
      "track_id": "69e6866bdce2120639c6ec73",
      "name": "Underleaf",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.59,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Underleaf_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=ehSze7NWUQ2DrDUbLjc5cBOS5RmId2ABVUEvWMtcfQ0%3D",
      "cdn_url": "https://audio2.brain.fm/Underleaf_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Underleaf_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Underleaf_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Underleaf_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28522032,
      "sha256": "1a8b3bd944b57a3b820d58b8ed0e5827a1a82e76d95c9350d8dbcdb74502361d",
      "download_error": null
    },
    {
      "track_id": "69c2bc791b6ecfe6c4a71eed",
      "name": "Quiet Canopy",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.39,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/QuietCanopy_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=kCAuGDLynLtgR8b8TKtYyUH4dM4rJuZ%2FLCuiLeh2FyU%3D",
      "cdn_url": "https://audio2.brain.fm/QuietCanopy_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "QuietCanopy_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "QuietCanopy_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/QuietCanopy_Focus_DeepWork_Rainforest_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27696700,
      "sha256": "b7063cad2f4f98c5aa912e91a84f579df2142ea6f29e420a466932d41a241dd1",
      "download_error": null
    },
    {
      "track_id": "64302d735ee24cd534a06fc1",
      "name": "Temperate",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.97,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Temperate_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=apFPuLCJBhcqFRpjp9T%2Fw1TdxuzRQytX7DIRHIjbvMo%3D",
      "cdn_url": "https://audio2.brain.fm/Temperate_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Temperate_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Temperate_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Temperate_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26730748,
      "sha256": "cfec27c2b9fac436c48f3c349aafa2242b8870b20dfda8e36c1099154acfb3fe",
      "download_error": null
    },
    {
      "track_id": "64302cea23c3be793c3fbb67",
      "name": "Santa Elena",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.95,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.31,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/SantaElena_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=1nSI0zkEZ%2FJmjgz5BpmBl355IN3Ac1TocyBrXrFmaJI%3D",
      "cdn_url": "https://audio2.brain.fm/SantaElena_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SantaElena_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SantaElena_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/SantaElena_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27030936,
      "sha256": "f94c6efc437fee71ddbbc4d304b2ece96935ea1d96b1f92461ae6f25bc9db3da",
      "download_error": null
    },
    {
      "track_id": "64302bdf5ee24c52e5a06670",
      "name": "Mystic River",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.97,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.71,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/MysticRiver_Focus_Creativity_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=t7ukJOjiXzpZSK0ERtj1xt3vE6SMW8iNUGdd%2FJtwUOs%3D",
      "cdn_url": "https://audio2.brain.fm/MysticRiver_Focus_Creativity_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MysticRiver_Focus_Creativity_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MysticRiver_Focus_Creativity_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/MysticRiver_Focus_Creativity_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26895475,
      "sha256": "70a3a6180ab6da7bb0c9b707638b9fe4d6b46d25987431ee21ffbdbe9f71c996",
      "download_error": null
    },
    {
      "track_id": "64302b9f23c3bef8a53fb347",
      "name": "Mongabay",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.64,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Mongabay_Focus_DeepWork_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=8kzli7jJJwFGG%2FNTjV%2BHUafiUmoRfNgHxrTLCoUWBig%3D",
      "cdn_url": "https://audio2.brain.fm/Mongabay_Focus_DeepWork_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Mongabay_Focus_DeepWork_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Mongabay_Focus_DeepWork_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Mongabay_Focus_DeepWork_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26573823,
      "sha256": "643559360f63ec2a98b22163481fbe79e666060222b57063b2714c5f7de13ee1",
      "download_error": null
    },
    {
      "track_id": "64302b0023c3be693f3fb0dd",
      "name": "Jungle Mist",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.94,
      "complexity_level": 0.12,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/JungleMist_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=eFycwqjmTxpD5Ptx3ByAn0hbrDloxfmNeW7bfNH7s3g%3D",
      "cdn_url": "https://audio2.brain.fm/JungleMist_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JungleMist_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "JungleMist_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/JungleMist_Focus_Learning_Rainforest_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26910596,
      "sha256": "bf2b4afdab61216ef8f2c9c30c64e4c7441c7cdef7d9dd72339f69e3ffddb9e0",
      "download_error": null
    },
    {
      "track_id": "64302a5a23c3bed0ee3fae7d",
      "name": "El Yunque",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.94,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/ElYunque_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=LceiABBnzS%2FsBCpAlN2D9MiJedUiIB6aL5RGaGD54OU%3D",
      "cdn_url": "https://audio2.brain.fm/ElYunque_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ElYunque_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "ElYunque_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/ElYunque_Focus_Creativity_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27991209,
      "sha256": "0eec33476d73c7adc17c7abfb47a390748f91ba74472bccfbeb8bf96e9e0739d",
      "download_error": null
    },
    {
      "track_id": "6430298023c3be61303fab20",
      "name": "Borneo Sunrise",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.78,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/BorneoSunrise_Focus_DeepWork_Rainforest_30_120bpm_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=VKI5xd3EfZKUShjNGI%2BGFQA4w057TbiaZb4VJ1vSdYU%3D",
      "cdn_url": "https://audio2.brain.fm/BorneoSunrise_Focus_DeepWork_Rainforest_30_120bpm_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BorneoSunrise_Focus_DeepWork_Rainforest_30_120bpm_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "BorneoSunrise_Focus_DeepWork_Rainforest_30_120bpm_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/BorneoSunrise_Focus_DeepWork_Rainforest_30_120bpm_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28649037,
      "sha256": "f6c0ef73eef54b17c956556b271aad5b19ba6912394a1c13ad62d46f5bca5224",
      "download_error": null
    },
    {
      "track_id": "6430296723c3be16503faae4",
      "name": "Below the Canopy",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.95,
      "complexity_level": 0.51,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/BelowtheCanopy_Focus_DeepWork_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=gRvBR31OE5MCqoNBuLN0ZlxCqjXKXhqvAF0DN0isvf0%3D",
      "cdn_url": "https://audio2.brain.fm/BelowtheCanopy_Focus_DeepWork_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BelowtheCanopy_Focus_DeepWork_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BelowtheCanopy_Focus_DeepWork_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/BelowtheCanopy_Focus_DeepWork_Rainforest_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26996498,
      "sha256": "b42b59c160b42dcf5f91e5fc60695d85c2ea6d9aabc6932ec17d76b9e84fc8d7",
      "download_error": null
    },
    {
      "track_id": "642ee9796d11ed75f8bac6bc",
      "name": "Gentle Creek",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.94,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/GentleCreek_Focus_Creativity_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=k6X0PQSRlI4fqk3E6pxGMJoQz7grDDIPiVv6lM1kPKc%3D",
      "cdn_url": "https://audio2.brain.fm/GentleCreek_Focus_Creativity_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "GentleCreek_Focus_Creativity_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "GentleCreek_Focus_Creativity_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/GentleCreek_Focus_Creativity_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31680649,
      "sha256": "81bdfd66ca582e39bdc62a215367b1e947addb643223e97ecbc4602ead7e8e6a",
      "download_error": null
    },
    {
      "track_id": "62b38c0f59241109eef553ea",
      "name": "Jungle Voyage",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Jungle%20Voyage%20Nature%20Focus%20Rainforest%20Deep%20Work%20Conor%20120bpm%20HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=Q8fSMeCDIcNLRtHVzWfutGDKARyOKB6TBgh9moT8UdY%3D",
      "cdn_url": "https://audio2.brain.fm/Jungle%20Voyage%20Nature%20Focus%20Rainforest%20Deep%20Work%20Conor%20120bpm%20HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Jungle Voyage Nature Focus Rainforest Deep Work Conor 120bpm HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Jungle-Voyage-Nature-Focus-Rainforest-Deep-Work-Conor-120bpm-HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Jungle-Voyage-Nature-Focus-Rainforest-Deep-Work-Conor-120bpm-HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28314247,
      "sha256": "3b62b8e7a548f56fbbfaf2bf3f93c17b6ef08cec4ef3fc3aaa2728b6e3962975",
      "download_error": null
    },
    {
      "track_id": "62b38b005924117376f54ee7",
      "name": "Forest Echoes",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Forest%20Echoes%20Nature%20Focus%20Rainforest%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=sAc9J2JhYskuoK%2BnrQ0FT2mc8U6BO9iZlugsW0rB81I%3D",
      "cdn_url": "https://audio2.brain.fm/Forest%20Echoes%20Nature%20Focus%20Rainforest%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Forest Echoes Nature Focus Rainforest Light Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Forest-Echoes-Nature-Focus-Rainforest-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Forest-Echoes-Nature-Focus-Rainforest-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25680666,
      "sha256": "0fba201e7bdcd8ebb91d34d30b6972760972eb2df196c17a05f5e8b8bf1a0b55",
      "download_error": null
    },
    {
      "track_id": "62b38aeb59241134bcf54c7e",
      "name": "After the Rain",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/After%20the%20Rain%20Nature%20Focus%20Rainforest%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=rVZfJrzLkcx0vrSoGyODoqJz8wmF7LBYvmXkKv5W2lQ%3D",
      "cdn_url": "https://audio2.brain.fm/After%20the%20Rain%20Nature%20Focus%20Rainforest%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "After the Rain Nature Focus Rainforest Creative Flow Conor 120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "After-the-Rain-Nature-Focus-Rainforest-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/After-the-Rain-Nature-Focus-Rainforest-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26720853,
      "sha256": "466e6fc04e64dc285472cce6315c05c7e1fcbfcfd8cd3e3d92d2289a142cf644",
      "download_error": null
    },
    {
      "track_id": "62b38ad7592411d3ecf54a68",
      "name": "Heart of Life",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.93,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Heart%20of%20Life%20Rainforest%201%20Focus%20Chris%20120_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=XnY3NKoGEOL1%2FzFeBybdIT7W9vwIvWAc1PwSuj5rnic%3D",
      "cdn_url": "https://audio2.brain.fm/Heart%20of%20Life%20Rainforest%201%20Focus%20Chris%20120_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Heart of Life Rainforest 1 Focus Chris 120_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Heart-of-Life-Rainforest-1-Focus-Chris-120_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Heart-of-Life-Rainforest-1-Focus-Chris-120_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22919506,
      "sha256": "e2964d7ba869e7e380eab275d97c4ef8ceed968090a2f00453708f7d7c0c2cd3",
      "download_error": null
    },
    {
      "track_id": "62b38a1a59241141a1f53eec",
      "name": "Through the Thick",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.89,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Through%20the%20Thick%20Rainforest%204%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292112619&token=zinQXT%2FYta2x95%2BzPz0h8f19yR0003fIbdQSf%2FpmuJo%3D",
      "cdn_url": "https://audio2.brain.fm/Through%20the%20Thick%20Rainforest%204%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Through the Thick Rainforest 4 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Through-the-Thick-Rainforest-4-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Through-the-Thick-Rainforest-4-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18412326,
      "sha256": "adfaf5465b7438f3b0e7d3ada36061ea1f8cceb6b42c11e1cc865895477311ff",
      "download_error": null
    },
    {
      "track_id": "62b389d25924116d7af53793",
      "name": "Tropical Journey",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.25,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Tropical%20Journey%20Nature%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=pPsDL2QZlC9dCS6CHzYBJflLNySbxuSbXRkKprn7ZxI%3D",
      "cdn_url": "https://audio2.brain.fm/Tropical%20Journey%20Nature%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tropical Journey Nature Focus Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Tropical-Journey-Nature-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Tropical-Journey-Nature-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30165639,
      "sha256": "8fdc411aa3f1666ebee8b3e4c1f40aa88cba54efe8e5190d19e9785e164a518f",
      "download_error": null
    },
    {
      "track_id": "62b384375924115131f50400",
      "name": "Verdant",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.93,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Verdent%20Atmosphere%20Rainforest%203%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292112619&token=FkJUif5R%2B5GgXV6AZXzy2VK1Wq6PX%2Fi%2FZsTYRdphiIw%3D",
      "cdn_url": "https://audio2.brain.fm/Verdent%20Atmosphere%20Rainforest%203%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Verdent Atmosphere Rainforest 3 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Verdent-Atmosphere-Rainforest-3-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Verdent-Atmosphere-Rainforest-3-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18478147,
      "sha256": "609fd616ccb4ba21ca9fe50c616be235e63ffa046f4820470d3eb88a33d6bc96",
      "download_error": null
    },
    {
      "track_id": "62b380fc5924117857f4dce6",
      "name": "Orchid Colony",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.55,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Orchid%20Colony%20Nature%20Focus%20Rainforest%20Study%20Conor%20120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=GB3h6PwSDK9%2FMMv1k5zy48S1D8lGKOyCAngUTQp7k2c%3D",
      "cdn_url": "https://audio2.brain.fm/Orchid%20Colony%20Nature%20Focus%20Rainforest%20Study%20Conor%20120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Orchid Colony Nature Focus Rainforest Study Conor 120bpm_MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Orchid-Colony-Nature-Focus-Rainforest-Study-Conor-120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Orchid-Colony-Nature-Focus-Rainforest-Study-Conor-120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26797112,
      "sha256": "940c8f03f4268dbac2699dfb2043f0e9a8822bd490c8b19fe05c971f36bb3586",
      "download_error": null
    },
    {
      "track_id": "62b380f45924117f3bf4da80",
      "name": "Unexplored Lands",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Wild%20Lands%20Nature%20Focus%20Rainforest%20Study%20Conor%20120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=Do0tO%2BFdBouyM9vGAk2vYbLF69Crc6LOWAPNWxeNQjE%3D",
      "cdn_url": "https://audio2.brain.fm/Wild%20Lands%20Nature%20Focus%20Rainforest%20Study%20Conor%20120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Wild Lands Nature Focus Rainforest Study Conor 120bpm_MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Wild-Lands-Nature-Focus-Rainforest-Study-Conor-120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Wild-Lands-Nature-Focus-Rainforest-Study-Conor-120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26395940,
      "sha256": "a9188c367020d6bfde6c64a1791c2e8b30db187d9d5214d6ea47b499eeba996f",
      "download_error": null
    },
    {
      "track_id": "62b3808e592411f075f4d076",
      "name": "Depths of the Jungle",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.68,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.09,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Depths%20of%20the%20Jungle%20Rainforest%202%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292112619&token=SJamuCgWIK%2Ftwkx05AL%2B38oSmr%2F%2FdnAXJSMKy6YdX5w%3D",
      "cdn_url": "https://audio2.brain.fm/Depths%20of%20the%20Jungle%20Rainforest%202%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Depths of the Jungle Rainforest 2 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Depths-of-the-Jungle-Rainforest-2-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Depths-of-the-Jungle-Rainforest-2-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 32460174,
      "sha256": "0483bf3cdc3329cd982d744da9790553bd908628316fb6b3d371f4f8bf0ebb95",
      "download_error": null
    },
    {
      "track_id": "62b3808c5924111927f4d011",
      "name": "Canopy Concentration",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Canopy%20Concentration%20Nature%20Focus%20Rainforest%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292112619&token=exK8r5pa4klw396Dz6h4sVhHp2%2BCSOIQNvxcAJ99X4Y%3D",
      "cdn_url": "https://audio2.brain.fm/Canopy%20Concentration%20Nature%20Focus%20Rainforest%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Canopy Concentration Nature Focus Rainforest Light Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Canopy-Concentration-Nature-Focus-Rainforest-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Canopy-Concentration-Nature-Focus-Rainforest-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28270745,
      "sha256": "308c86868a173f88df989d0157a01114f66b1bd7688b2f423ef1d925c8eeab6c",
      "download_error": null
    },
    {
      "track_id": "62b3803e592411172df4b6ce",
      "name": "Above the Ground",
      "category": "Rainforest",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/rainforest.json",
      "source_url": "https://audio2.brain.fm/Above%20the%20Ground%20Rainforest%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3?expiration=1792292112619&token=D6KT37K2DEHN3a1gQVbF2PN9BawrVWDlZPs8yiJ5eXY%3D",
      "cdn_url": "https://audio2.brain.fm/Above%20the%20Ground%20Rainforest%205%20Focus%20Chris%20120_Nrmlzd_VBR5.mp3",
      "remote_filename": "Above the Ground Rainforest 5 Focus Chris 120_Nrmlzd_VBR5.mp3",
      "filename": "Above-the-Ground-Rainforest-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/rainforest/Above-the-Ground-Rainforest-5-Focus-Chris-120_Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 18351626,
      "sha256": "830b3861c5d2714ad9058a5bafa4780b6aa5458c8ba13db50f4afae9c2457f91",
      "download_error": null
    },
    {
      "track_id": "6a3018367a8f5056573c97b2",
      "name": "Neith",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.17,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Neith_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=SOCBtoRJRGxREBPKnyg4nnODx3g6FcePT9FSOwoUqWY%3D",
      "cdn_url": "https://audio2.brain.fm/Neith_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Neith_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Neith_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Neith_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30227128,
      "sha256": "3ff1e6dedc8ec48f221391d3daa8b59b2cdfb0a81c6a9d6b7e6f95441c74af27",
      "download_error": null
    },
    {
      "track_id": "69e68932dce2120639c70186",
      "name": "Move Like Water",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.36,
      "complexity_level": 0.15,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/MoveLikeWater_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=ckkcwHsRGdzvSIp%2BYMBRUTB%2FurbaC05crz1APQ7Eyzw%3D",
      "cdn_url": "https://audio2.brain.fm/MoveLikeWater_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "MoveLikeWater_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "MoveLikeWater_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/MoveLikeWater_Focus_DeepWork_Nature_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30720008,
      "sha256": "474e63960ba1269448fbed034e28337dd43254b7195e760f7001f6b52b2656ef",
      "download_error": null
    },
    {
      "track_id": "64302dfc23c3be4ea43fc1d2",
      "name": "Winding Stream",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.98,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/WindingStream_Focus_Learning_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=3dbBK7L4fqGETRMo0Y13bJI0tTgE9Hc1Qw5s0laaEYs%3D",
      "cdn_url": "https://audio2.brain.fm/WindingStream_Focus_Learning_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "WindingStream_Focus_Learning_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "WindingStream_Focus_Learning_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/WindingStream_Focus_Learning_River_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26891163,
      "sha256": "76edef5b7c1b6221286bd2cff3f152f8b02ad6b7b583eb36b1bad6f51a2f5d2b",
      "download_error": null
    },
    {
      "track_id": "64302daf5ee24ccff1a072b6",
      "name": "Waterways",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.74,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Waterways_Focus_DeepWork_River_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=zLndUsDJ7ZvUDtw1LBWn2jTRWuqnS9eChzzIBHbMTf4%3D",
      "cdn_url": "https://audio2.brain.fm/Waterways_Focus_DeepWork_River_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Waterways_Focus_DeepWork_River_30_120bpm_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Waterways_Focus_DeepWork_River_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Waterways_Focus_DeepWork_River_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28268939,
      "sha256": "6ec8b73b1b0e7da987d9dd7a0221a2de07e900eb339f7c1afb204f510872c8b2",
      "download_error": null
    },
    {
      "track_id": "64302af423c3be5e6d3fb0b0",
      "name": "Jewel Blue",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.74,
      "complexity_level": 0.16,
      "style": "normal",
      "neural_effect_level": 0.32,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/JewelBlue_Focus_DeepWork_River_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=daczaZViGzz9689vND%2B8FEoa1l71scYlIfBpQ4TCQkg%3D",
      "cdn_url": "https://audio2.brain.fm/JewelBlue_Focus_DeepWork_River_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "JewelBlue_Focus_DeepWork_River_30_120bpm_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "JewelBlue_Focus_DeepWork_River_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/JewelBlue_Focus_DeepWork_River_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28453531,
      "sha256": "bfe76e1c6b76024efc6965f2d35cf355d7b84f5c0ab7426bb52b95940210b979",
      "download_error": null
    },
    {
      "track_id": "643029755ee24c70caa055ff",
      "name": "Blue Nile",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.89,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/BlueNile_Focus_Learning_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=AkSgto%2FeAHW0eYCaz95e2ZcXJlqnJydf9GM5jh6Yg7k%3D",
      "cdn_url": "https://audio2.brain.fm/BlueNile_Focus_Learning_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "BlueNile_Focus_Learning_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "BlueNile_Focus_Learning_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/BlueNile_Focus_Learning_River_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30633440,
      "sha256": "85857eef0ed01ff73fe7997cfbd2ead74fc5be9096bf98f4ef818be804919ceb",
      "download_error": null
    },
    {
      "track_id": "643028f25ee24c48dca05468",
      "name": "Alluvium",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.81,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.33,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Alluvium_Focus_DeepWork_River_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=EqbzORKauu51zHXXQ1cl3JC7xD2jVIpndYaU39eCPxY%3D",
      "cdn_url": "https://audio2.brain.fm/Alluvium_Focus_DeepWork_River_30_120bpm_LOW%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Alluvium_Focus_DeepWork_River_30_120bpm_LOW NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Alluvium_Focus_DeepWork_River_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Alluvium_Focus_DeepWork_River_30_120bpm_LOW-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28097580,
      "sha256": "3c5fbe3368d9c84e8f3a7c188f4f2c9d6bad295816a9757d513a0f08ffa1f0bc",
      "download_error": null
    },
    {
      "track_id": "62b38b03592411ee93f54f25",
      "name": "Downstream",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.83,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Downstream%20River%20Focus%201%20Conor_1.1_Nrmlzd3_VBR5.mp3?expiration=1792292114262&token=RiBui8%2BV%2BErvHWTejXDR9X74AG9vdXXUhNr0O69u%2B5k%3D",
      "cdn_url": "https://audio2.brain.fm/Downstream%20River%20Focus%201%20Conor_1.1_Nrmlzd3_VBR5.mp3",
      "remote_filename": "Downstream River Focus 1 Conor_1.1_Nrmlzd3_VBR5.mp3",
      "filename": "Downstream-River-Focus-1-Conor_1.1_Nrmlzd3_VBR5.mp3",
      "relative_path": "outputs/audio/river/Downstream-River-Focus-1-Conor_1.1_Nrmlzd3_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 35597796,
      "sha256": "1c1078fd6b92d1a53844b49673e07c1f5530e33af6ec508911f28f4fe3efb921",
      "download_error": null
    },
    {
      "track_id": "62b38af6592411546bf54dc0",
      "name": "Forked Rivers",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.88,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.21,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Forked%20Rivers%20Nature%20Focus%20River%20Creative%20Flow%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=rxYz%2Bt%2FQnVhetrS%2F8Y%2FbACnGyDsfySWWxyHfo2CPhgk%3D",
      "cdn_url": "https://audio2.brain.fm/Forked%20Rivers%20Nature%20Focus%20River%20Creative%20Flow%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Forked Rivers Nature Focus River Creative Flow Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Forked-Rivers-Nature-Focus-River-Creative-Flow-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Forked-Rivers-Nature-Focus-River-Creative-Flow-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28384887,
      "sha256": "4c6be82dcc88a7c39114ac809e3f3af02fa664686b94493224d5bda89028f72a",
      "download_error": null
    },
    {
      "track_id": "62b38af5592411ce49f54d9d",
      "name": "Water on the Rocks",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.85,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.18,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Water%20on%20the%20Rocks%20River%20Focus%203%20Conor_1.2_Nrmlzd3_VBR5.mp3?expiration=1792292114262&token=Z10JpVSeHKUqLyLtiV5GUPabdx3NU2UetpI1erUynBk%3D",
      "cdn_url": "https://audio2.brain.fm/Water%20on%20the%20Rocks%20River%20Focus%203%20Conor_1.2_Nrmlzd3_VBR5.mp3",
      "remote_filename": "Water on the Rocks River Focus 3 Conor_1.2_Nrmlzd3_VBR5.mp3",
      "filename": "Water-on-the-Rocks-River-Focus-3-Conor_1.2_Nrmlzd3_VBR5.mp3",
      "relative_path": "outputs/audio/river/Water-on-the-Rocks-River-Focus-3-Conor_1.2_Nrmlzd3_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28504759,
      "sha256": "4d07e7ef411205c070149d2d3903af837f38c2eb16d0fddb91e787dc77180eb4",
      "download_error": null
    },
    {
      "track_id": "62b38ae35924111138f54bb6",
      "name": "Estuary",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.89,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Estuary%20Nature%20Focus%20River%20Creative%20Flow%20Conor%20120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=kJhb5VItsa6OW9kmzKcZxRBWDI8vDU3py66uxjNzHtg%3D",
      "cdn_url": "https://audio2.brain.fm/Estuary%20Nature%20Focus%20River%20Creative%20Flow%20Conor%20120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Estuary Nature Focus River Creative Flow Conor 120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Estuary-Nature-Focus-River-Creative-Flow-Conor-120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Estuary-Nature-Focus-River-Creative-Flow-Conor-120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29503414,
      "sha256": "c23f16bbd65efdfaabadb34b920731e2d29d471383c6575dac9c592c8dab2ec3",
      "download_error": null
    },
    {
      "track_id": "62b38aa15924115660f549be",
      "name": "Shady Stream",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.85,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 1,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/River%20Focus%202%20Shady%20Stream%20Conor_1.1_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=JxrQWt070QqMIf51LZZBK5ipjSU%2B5UwUxPf72e1WPmU%3D",
      "cdn_url": "https://audio2.brain.fm/River%20Focus%202%20Shady%20Stream%20Conor_1.1_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "River Focus 2 Shady Stream Conor_1.1_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "River-Focus-2-Shady-Stream-Conor_1.1_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/River-Focus-2-Shady-Stream-Conor_1.1_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 31166783,
      "sha256": "8f4f059ba22786859cc519e29ea1bede95fba07c4872f459d1289ce86d0195f9",
      "download_error": null
    },
    {
      "track_id": "62b38a0f5924116eedf53d9c",
      "name": "Streams of Consciousness",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.17,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Streams%20of%20Consciousness%20Nature%20Focus%20River%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=ktuW37MOz4IcEHw0lz9y2jiVXDJjp6SYmQeTFJ0O%2Bn0%3D",
      "cdn_url": "https://audio2.brain.fm/Streams%20of%20Consciousness%20Nature%20Focus%20River%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Streams of Consciousness Nature Focus River Light Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Streams-of-Consciousness-Nature-Focus-River-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Streams-of-Consciousness-Nature-Focus-River-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29308814,
      "sha256": "ba11e09e145da3c77c2dc31d4ba216fbf4f778d8bf519930e4601045ccadf850",
      "download_error": null
    },
    {
      "track_id": "62b38a0e5924111c74f53d7d",
      "name": "Secret River",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.86,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.95,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Secret%20River%20Nature%20Focus%20River%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=qUnEnUKvk496D7%2B1%2BlVOgdXOK8WSC4gXasPSraqi%2Bzk%3D",
      "cdn_url": "https://audio2.brain.fm/Secret%20River%20Nature%20Focus%20River%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Secret River Nature Focus River Creative Flow Conor 120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Secret-River-Nature-Focus-River-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Secret-River-Nature-Focus-River-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27599810,
      "sha256": "3d002686e5f94d0ddfbd727106417cc7879e5e9ea4b9af559aa5536ad516eb72",
      "download_error": null
    },
    {
      "track_id": "62b384425924115faaf50645",
      "name": "Ephemeral River",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.88,
      "complexity_level": 0.24,
      "style": "normal",
      "neural_effect_level": 0.95,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/River%20Focus%204%20Ephemeral%20River%20Conor_1.2_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=n12%2BpL0DR9YWbavRvSGu9WybjWl2gSwRpCAx9Rj7fL8%3D",
      "cdn_url": "https://audio2.brain.fm/River%20Focus%204%20Ephemeral%20River%20Conor_1.2_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "River Focus 4 Ephemeral River Conor_1.2_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "River-Focus-4-Ephemeral-River-Conor_1.2_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/River-Focus-4-Ephemeral-River-Conor_1.2_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27852554,
      "sha256": "b84c15940efa02693f94ca6c2eee049d7d12467bd8303c756d48cb89ffc707b0",
      "download_error": null
    },
    {
      "track_id": "62b38112592411282ff4e315",
      "name": "Riverbanks",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.85,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/River%20Focus%205%20Riverbanks%20Conor_1.4_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=Frs68m92Hxb4VYbgk0Et%2BWAWiScMobJmig8FL9de%2BGc%3D",
      "cdn_url": "https://audio2.brain.fm/River%20Focus%205%20Riverbanks%20Conor_1.4_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "River Focus 5 Riverbanks Conor_1.4_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "River-Focus-5-Riverbanks-Conor_1.4_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/River-Focus-5-Riverbanks-Conor_1.4_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27940066,
      "sha256": "e5f29afff1d3e6ae473b6eddc2e2195bb3862d265dd2efc40814c00efd5ae470",
      "download_error": null
    },
    {
      "track_id": "62b380fc5924114dcbf4dcc7",
      "name": "Rushing River",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.83,
      "complexity_level": 0.26,
      "style": "normal",
      "neural_effect_level": 0.27,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Rushing%20River%20Nature%20Focus%20River%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=p%2BuGCUu%2F4K64pawqgKtSuLJTTbia8Q17QV74WdLaaqU%3D",
      "cdn_url": "https://audio2.brain.fm/Rushing%20River%20Nature%20Focus%20River%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Rushing River Nature Focus River Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Rushing-River-Nature-Focus-River-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Rushing-River-Nature-Focus-River-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27470108,
      "sha256": "200b4f2ac95f8db4f90bbbb56a3cef2fc41848b30fb1874147a15d5d386c6e5c",
      "download_error": null
    },
    {
      "track_id": "62b380e35924112e12f4d48a",
      "name": "Against the Current",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Against%20the%20Current%20Nature%20Focus%20River%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=oQ8gGBPj%2FFtRg1mW14jaiTWqnZ1ily7ImjH%2FR%2FmOxX4%3D",
      "cdn_url": "https://audio2.brain.fm/Against%20the%20Current%20Nature%20Focus%20River%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Against the Current Nature Focus River Light Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Against-the-Current-Nature-Focus-River-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Against-the-Current-Nature-Focus-River-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28313629,
      "sha256": "5a5394dc94597e5c52b039207b9051e1ec8360d4eca305afed92710064995e96",
      "download_error": null
    },
    {
      "track_id": "62b3807359241165caf4cae8",
      "name": "Flowing North",
      "category": "River",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/river.json",
      "source_url": "https://audio2.brain.fm/Flowing%20North%20Nature%20Focus%20River%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292114262&token=6EdIjTMAYyuy6s265qw%2FRwYLDDWc8wEy%2FMQES9I8NYQ%3D",
      "cdn_url": "https://audio2.brain.fm/Flowing%20North%20Nature%20Focus%20River%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Flowing North Nature Focus River Light Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Flowing-North-Nature-Focus-River-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/river/Flowing-North-Nature-Focus-River-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29011678,
      "sha256": "5bf9bc5e6df096bbbec685f9463e2f50392a0016b0f3732a1c0015dbca4bad5c",
      "download_error": null
    },
    {
      "track_id": "64302d6523c3be14e73fbe82",
      "name": "Summit of Olympus",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.27,
      "style": "normal",
      "neural_effect_level": 0.67,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/SummitofOlympus_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=xVfke0enI%2BZ3z6ap8xAml8UuCCjn1amnk02RMdZ5beA%3D",
      "cdn_url": "https://audio2.brain.fm/SummitofOlympus_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SummitofOlympus_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "SummitofOlympus_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/SummitofOlympus_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27682581,
      "sha256": "43aaf40bb3ed402c11f80de1ae190cd602fa7a01f1613f954020cf6a310c619e",
      "download_error": null
    },
    {
      "track_id": "64302cad5ee24c7518a06b88",
      "name": "Pymander",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.81,
      "complexity_level": 0.7,
      "style": "normal",
      "neural_effect_level": 0.68,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Pymander_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=Zs7GcZWXdfA%2Fu7QdijO7iTiCaQHpQ%2FfI7SlyHQcJuuM%3D",
      "cdn_url": "https://audio2.brain.fm/Pymander_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Pymander_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Pymander_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Pymander_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28249075,
      "sha256": "a04fef901f33a98e3ef6e82ba49f36038668a538a40f01df21c8ae3ef47c4d90",
      "download_error": null
    },
    {
      "track_id": "64302bc723c3be73023fb3f3",
      "name": "Monsoon",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.97,
      "complexity_level": 0.71,
      "style": "normal",
      "neural_effect_level": 0.35,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Monsoon_Focus_Learning_Thunder_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=LiDjjItOflWC4gO90pCyRCKA%2FjS%2FxjtRDN2%2Be6gETpE%3D",
      "cdn_url": "https://audio2.brain.fm/Monsoon_Focus_Learning_Thunder_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Monsoon_Focus_Learning_Thunder_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Monsoon_Focus_Learning_Thunder_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Monsoon_Focus_Learning_Thunder_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30054808,
      "sha256": "a5bc459d4121e0ae0106e1d1a5499a2153f3de678e44cdcdb6d7640fd7f00c18",
      "download_error": null
    },
    {
      "track_id": "6430295b23c3befb343faa85",
      "name": "Asclepius",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.96,
      "complexity_level": 0.69,
      "style": "normal",
      "neural_effect_level": 0.7,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Asclepius_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=CaMoDXrpmBy%2Bl66oMUZozf%2Bl3kMkW%2BsTmUNhsLXMYJQ%3D",
      "cdn_url": "https://audio2.brain.fm/Asclepius_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Asclepius_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Asclepius_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Asclepius_Focus_Learning_Thunder_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28160536,
      "sha256": "232ec5432033225182cdcd2bb463e10646ac9c361f2930bfc8fc07d6994e37cc",
      "download_error": null
    },
    {
      "track_id": "633dad7b83f4ff7467a382b4",
      "name": "Urizen",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.66,
      "complexity_level": 0.88,
      "style": "normal",
      "neural_effect_level": 0.46,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Urizen_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=BvEz%2BrSrgPEELvp%2BCyKy29XlUkd2BSoCM88TBPqDw3I%3D",
      "cdn_url": "https://audio2.brain.fm/Urizen_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Urizen_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Urizen_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Urizen_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28679112,
      "sha256": "af844733312670b87b29d3e82de3a3fff3cf5c7d2c866401f06908da9e04edd1",
      "download_error": null
    },
    {
      "track_id": "633dad4b840cdf40f7585bae",
      "name": "Unfazed",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.67,
      "complexity_level": 0.82,
      "style": "normal",
      "neural_effect_level": 0.5,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Unfazed_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=FMlD2%2F70jFI1QY17pGYQT0NnUi74nEm6gfp8%2BupbU5g%3D",
      "cdn_url": "https://audio2.brain.fm/Unfazed_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Unfazed_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Unfazed_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Unfazed_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28652780,
      "sha256": "510df540d785533fdd89bac8b39dc225bccc6ad5f89122189a7de221bc65ce30",
      "download_error": null
    },
    {
      "track_id": "633dad0e83f4ff0349a38058",
      "name": "Sowing the Seeds",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.5,
      "complexity_level": 0.77,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/SowingtheSeeds_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=2ETcmSNUG4%2B583lvn%2BrG6Wkr1PD3S0baFhLagfoI5Zg%3D",
      "cdn_url": "https://audio2.brain.fm/SowingtheSeeds_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "SowingtheSeeds_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "SowingtheSeeds_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/SowingtheSeeds_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26037115,
      "sha256": "6887e4e6f18a1e3b86eb91715bcf449f78f1e19dedca2d9f98ba8952e314dc34",
      "download_error": null
    },
    {
      "track_id": "633dace4840cdf83ad5858db",
      "name": "Perfect Mind",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.32,
      "complexity_level": 0.96,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/PerfectMind_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=5dGkWB8ofTqwjD7xEEQ%2FQtcr79AiHBg7O4Ink2W4K9s%3D",
      "cdn_url": "https://audio2.brain.fm/PerfectMind_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "PerfectMind_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "PerfectMind_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/PerfectMind_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25716343,
      "sha256": "e32be583434acb85d677437d50aa5d2c5e33dc563268a9ee9b357a6e94646ef3",
      "download_error": null
    },
    {
      "track_id": "633dacb7840cdff87a5855f9",
      "name": "Over the Ridge",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.79,
      "complexity_level": 0.64,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/OvertheRidge_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=rN654U49CMGNH3QNyTUA2LvxO4MnncwJdKaEFf7Vmzc%3D",
      "cdn_url": "https://audio2.brain.fm/OvertheRidge_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "OvertheRidge_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "OvertheRidge_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/OvertheRidge_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28132170,
      "sha256": "645f67508196df0ddef97a73952afbfdeab79941b10cc93726912141af7bbbdd",
      "download_error": null
    },
    {
      "track_id": "633dac8883f4ff02eca37b59",
      "name": "Lifting the Veil",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.62,
      "complexity_level": 0.62,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/LiftingtheVeil_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=Rkdu30GYchha4Ry8atWkjTOuwnQfdSOKNzScDaDmzLg%3D",
      "cdn_url": "https://audio2.brain.fm/LiftingtheVeil_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "LiftingtheVeil_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "LiftingtheVeil_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/LiftingtheVeil_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28456763,
      "sha256": "991d3cdbc1c0658461afee911c45226ea1e57998bc829ae0bf39ee2cc410fe2c",
      "download_error": null
    },
    {
      "track_id": "633dac5b83f4ff7fbfa3799d",
      "name": "Into the Storm",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.91,
      "complexity_level": 0.58,
      "style": "normal",
      "neural_effect_level": 0.19,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/IntotheStorm_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=tmq5brdTYvNkGmc%2FhQA5Nz03k4nd2gLMX6q1lZ6j9L8%3D",
      "cdn_url": "https://audio2.brain.fm/IntotheStorm_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "IntotheStorm_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "IntotheStorm_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/IntotheStorm_Focus_Creativity_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28067784,
      "sha256": "2abb251d99b99de47ae296a1db6ae851ad8a6ae3fa50b2c02120e9deca535ebc",
      "download_error": null
    },
    {
      "track_id": "633dac2c840cdf4705584e98",
      "name": "Apibus",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.87,
      "complexity_level": 0.93,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Apibus_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=rf6QMChl7nud7RaO7gMsRa4mTt04j3xxPr5L3364aso%3D",
      "cdn_url": "https://audio2.brain.fm/Apibus_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Apibus_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Apibus_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Apibus_Focus_Creativity_Thunder_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27746441,
      "sha256": "48d0931656c268c4b5b51b385cc1c134b9def26262fd411f60c2a51533a5c06b",
      "download_error": null
    },
    {
      "track_id": "631224222d39361d869be6ae",
      "name": "Tempest",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.68,
      "complexity_level": 0.94,
      "style": "normal",
      "neural_effect_level": 0.57,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Tempest_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=4CnC7SEPE%2FJtqWoYgPgVwq2RBg%2BhuS0ETYFh%2FSXuHb4%3D",
      "cdn_url": "https://audio2.brain.fm/Tempest_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tempest_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Tempest_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Tempest_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29210454,
      "sha256": "8844ea19c3ce0e89ac5d463d08f16d8a14da6c9a52516a90f956cfcc6667eb74",
      "download_error": null
    },
    {
      "track_id": "631223f12d3936d34f9be56b",
      "name": "Sardinia",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.6,
      "complexity_level": 0.98,
      "style": "normal",
      "neural_effect_level": 0.56,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Sardinia_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=7OBWo6oXdVamd06RJH0zHIu9M76Nl%2Be5D6rsNT7cn54%3D",
      "cdn_url": "https://audio2.brain.fm/Sardinia_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sardinia_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Sardinia_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Sardinia_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27865727,
      "sha256": "fe3348a8dc506cd35a1561579e6a00a6d42961849807c2a10d88417258fd81a1",
      "download_error": null
    },
    {
      "track_id": "631223c12d393683ad9be462",
      "name": "Natural State",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.74,
      "complexity_level": 0.68,
      "style": "normal",
      "neural_effect_level": 0.41,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/NaturalState_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=VKEZ0OFA6N5QwSYKnXAMy75xau0pKYiDPFhFputCpks%3D",
      "cdn_url": "https://audio2.brain.fm/NaturalState_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "NaturalState_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "NaturalState_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/NaturalState_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29483185,
      "sha256": "df79849111224c3775360be6616341b38ba04587403c9705c24a01c5b36e1971",
      "download_error": null
    },
    {
      "track_id": "6312238698e7cba269301be0",
      "name": "Quiet Storm",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.88,
      "complexity_level": 1,
      "style": "normal",
      "neural_effect_level": 0.22,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/QuietStorm_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=VA25ozlJAe4KOfg7UbohgxaxqyMUSBN1dtovk1htD5k%3D",
      "cdn_url": "https://audio2.brain.fm/QuietStorm_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "QuietStorm_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "QuietStorm_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/QuietStorm_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 30195074,
      "sha256": "5a98bf3c9b0974186a99ced94fb288a7c828f2c2b9aca9e458cc3e28b7360777",
      "download_error": null
    },
    {
      "track_id": "6312231998e7cb48003017ee",
      "name": "Distant Roar",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.63,
      "complexity_level": 0.9,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/DistantRoar_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=LDeiIky7lJHQk%2Bf25Ftw42HsvErZdUUSzSCkHl5qcpA%3D",
      "cdn_url": "https://audio2.brain.fm/DistantRoar_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "DistantRoar_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "DistantRoar_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/DistantRoar_Focus_DeepWork_Nature_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28066835,
      "sha256": "370c4ec071f56d94ccba1f39e9f16d85dac72386bddcf82b5e4335709277bc41",
      "download_error": null
    },
    {
      "track_id": "62b38c195924113037f554de",
      "name": "Brain Storm",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.56,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.52,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/FOCUS-Bassline-THUNDER-1.2_VBR5.mp3?expiration=1792292115584&token=Rzhp7Ae35mILuxIU3tEZygKLjURPdbf4WC7uuUACIBY%3D",
      "cdn_url": "https://audio2.brain.fm/FOCUS-Bassline-THUNDER-1.2_VBR5.mp3",
      "remote_filename": "FOCUS-Bassline-THUNDER-1.2_VBR5.mp3",
      "filename": "FOCUS-Bassline-THUNDER-1.2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/FOCUS-Bassline-THUNDER-1.2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23024817,
      "sha256": "543a67362544a44073b4b8f214c701c76c694433c7d322755f24aa1d2421cdd4",
      "download_error": null
    },
    {
      "track_id": "62b38ad5592411b77ff54a24",
      "name": "Stormscape",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.58,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Stormscape%20Thunder%20Focus%203%20Conor_1.5_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=MizfRirUcPGZArvXy2QgdfejSPY6QVTeA%2B%2BVAe%2BfEfY%3D",
      "cdn_url": "https://audio2.brain.fm/Stormscape%20Thunder%20Focus%203%20Conor_1.5_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Stormscape Thunder Focus 3 Conor_1.5_Nrmlzd2_VBR5.mp3",
      "filename": "Stormscape-Thunder-Focus-3-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Stormscape-Thunder-Focus-3-Conor_1.5_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23972999,
      "sha256": "6f34b78f91ed59ebaad96ed1f60c715d4283c86554e30d6db813ca3b03e87377",
      "download_error": null
    },
    {
      "track_id": "62b389ef59241146f0f53b07",
      "name": "Stormchaser",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.3,
      "complexity_level": 0.29,
      "style": "normal",
      "neural_effect_level": 0.16,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/ThunderFOCUS-TEMPLATE3-Nrmlzd_VBR5.mp3?expiration=1792292115584&token=sxO4zE4Bg5qztX5epxaN0UqUUyLTHdkBIpzD5gYVY%2FQ%3D",
      "cdn_url": "https://audio2.brain.fm/ThunderFOCUS-TEMPLATE3-Nrmlzd_VBR5.mp3",
      "remote_filename": "ThunderFOCUS-TEMPLATE3-Nrmlzd_VBR5.mp3",
      "filename": "ThunderFOCUS-TEMPLATE3-Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/ThunderFOCUS-TEMPLATE3-Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 35047429,
      "sha256": "5ee09d1f4cc6131973a61a2251ed26c346b279d5cf04b7a160f1182206dc3003",
      "download_error": null
    },
    {
      "track_id": "62b388eb5924116f4cf52e1f",
      "name": "Castle Mountain",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.55,
      "complexity_level": 0.72,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Castle%20Mountain%20Thunder%20Focus%202%20Conor_1.9_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=Kl4TUZpVRQl2S%2Bp1eiwQmO7vvua5DJ7aiGw6T1e4Yjk%3D",
      "cdn_url": "https://audio2.brain.fm/Castle%20Mountain%20Thunder%20Focus%202%20Conor_1.9_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Castle Mountain Thunder Focus 2 Conor_1.9_Nrmlzd2_VBR5.mp3",
      "filename": "Castle-Mountain-Thunder-Focus-2-Conor_1.9_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Castle-Mountain-Thunder-Focus-2-Conor_1.9_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21806081,
      "sha256": "081b8a63d843ea9a39a427c584c039ece51514a3b774b3e98bafb26be7713c0e",
      "download_error": null
    },
    {
      "track_id": "62b388db592411ca31f52b8b",
      "name": "Mount Olympus",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.65,
      "complexity_level": 0.37,
      "style": "normal",
      "neural_effect_level": 0.3,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/TechnoUnkn2-THUNDER-FOCUS-1.1_VBR5.mp3?expiration=1792292115584&token=FEFFWREYboqCmVDLyvIllg24%2BtuwTy6h74frsokdqGU%3D",
      "cdn_url": "https://audio2.brain.fm/TechnoUnkn2-THUNDER-FOCUS-1.1_VBR5.mp3",
      "remote_filename": "TechnoUnkn2-THUNDER-FOCUS-1.1_VBR5.mp3",
      "filename": "TechnoUnkn2-THUNDER-FOCUS-1.1_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/TechnoUnkn2-THUNDER-FOCUS-1.1_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22722295,
      "sha256": "9b9a420786428ec601f2ea3144115784fe196e354c78eeb186eea3cc3a061f7f",
      "download_error": null
    },
    {
      "track_id": "62b388af5924116a61f52719",
      "name": "Shifting Winds",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.63,
      "complexity_level": 0.41,
      "style": "normal",
      "neural_effect_level": 0.38,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/FOCUS-Bassline-THUNDER-ALT%20VERSION-1.1_VBR5.mp3?expiration=1792292115584&token=s6S7yqAc1oXdZSpGG%2FbK8L3E4lKnBSRcT7s%2FASIot%2FA%3D",
      "cdn_url": "https://audio2.brain.fm/FOCUS-Bassline-THUNDER-ALT%20VERSION-1.1_VBR5.mp3",
      "remote_filename": "FOCUS-Bassline-THUNDER-ALT VERSION-1.1_VBR5.mp3",
      "filename": "FOCUS-Bassline-THUNDER-ALT-VERSION-1.1_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/FOCUS-Bassline-THUNDER-ALT-VERSION-1.1_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24807572,
      "sha256": "a38cd4c283059f4b455d66229bf11b28dde9e98747132bfec27993afcfb94a65",
      "download_error": null
    },
    {
      "track_id": "62b38893592411810af522fb",
      "name": "Electric Energy",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.22,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/ThunderFOCUS-TEMPLATE1-fixedClipping_VBR5.mp3?expiration=1792292115584&token=vTR2N9ZYX0XQQlcRHnign68O7Z74OjZwipOrhCFvVd0%3D",
      "cdn_url": "https://audio2.brain.fm/ThunderFOCUS-TEMPLATE1-fixedClipping_VBR5.mp3",
      "remote_filename": "ThunderFOCUS-TEMPLATE1-fixedClipping_VBR5.mp3",
      "filename": "ThunderFOCUS-TEMPLATE1-fixedClipping_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/ThunderFOCUS-TEMPLATE1-fixedClipping_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22419601,
      "sha256": "b0e86c781a79288b32444658406a986d30383ac591436809dfcfa5608fb2f5fd",
      "download_error": null
    },
    {
      "track_id": "62b387b45924112813f51f4c",
      "name": "Lightning Strike",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.33,
      "complexity_level": 0.65,
      "style": "normal",
      "neural_effect_level": 0.25,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/ThunderFOCUS-TEMPLATE2.0-Nrmlzd_VBR5.mp3?expiration=1792292115584&token=p2giI4ZuOSE6Q244AwoW97p8FF7e4ZoKPuzu2ioeaok%3D",
      "cdn_url": "https://audio2.brain.fm/ThunderFOCUS-TEMPLATE2.0-Nrmlzd_VBR5.mp3",
      "remote_filename": "ThunderFOCUS-TEMPLATE2.0-Nrmlzd_VBR5.mp3",
      "filename": "ThunderFOCUS-TEMPLATE2.0-Nrmlzd_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/ThunderFOCUS-TEMPLATE2.0-Nrmlzd_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23074542,
      "sha256": "1b6c369e00a0872ad61bc3bbc05eafaafbb78457ac37f1b48e2fadb8eb47556e",
      "download_error": null
    },
    {
      "track_id": "62b387795924117ca5f51b9c",
      "name": "Timpani in the Sky",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.49,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.28,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Timpani%20in%20the%20Sky%20Thunder%20Focus%204%20Conor_1.12_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=Sy6XEDXsTsxDe8SwbfJ6oNepm8YNZCN7AIo%2Bs9vKdIU%3D",
      "cdn_url": "https://audio2.brain.fm/Timpani%20in%20the%20Sky%20Thunder%20Focus%204%20Conor_1.12_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Timpani in the Sky Thunder Focus 4 Conor_1.12_Nrmlzd2_VBR5.mp3",
      "filename": "Timpani-in-the-Sky-Thunder-Focus-4-Conor_1.12_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Timpani-in-the-Sky-Thunder-Focus-4-Conor_1.12_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23754176,
      "sha256": "c179a804f1d102fe95cfa9420bd231fdcd537f099e729d109f1bd1d3a0c585d2",
      "download_error": null
    },
    {
      "track_id": "62b3811659241120cef4e414",
      "name": "Full Force",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.61,
      "complexity_level": 0.6,
      "style": "normal",
      "neural_effect_level": 0.61,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Full%20Force%20Thunder%20Focus%201%20Chris_1.4_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=yzAq7RXwr7WUu5HQ9k0mOYNaJwrS0nof1xMAM72s3hE%3D",
      "cdn_url": "https://audio2.brain.fm/Full%20Force%20Thunder%20Focus%201%20Chris_1.4_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Full Force Thunder Focus 1 Chris_1.4_Nrmlzd2_VBR5.mp3",
      "filename": "Full-Force-Thunder-Focus-1-Chris_1.4_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Full-Force-Thunder-Focus-1-Chris_1.4_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25501578,
      "sha256": "09ebc2f307b8d40959efcc95f81853f2a31eb6f339ebfbfc3982053be05c8509",
      "download_error": null
    },
    {
      "track_id": "62b380f2592411d44bf4d995",
      "name": "Center of the Storm",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.59,
      "complexity_level": 0.63,
      "style": "normal",
      "neural_effect_level": 0.58,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/TechnoUnkn2-THUNDER--ALT%20VERSION--Template-1.4_VBR5.mp3?expiration=1792292115584&token=AhicbIDImleg29Ve7Wp48Va5mATkrWQYeljZ7%2BmxR%2BU%3D",
      "cdn_url": "https://audio2.brain.fm/TechnoUnkn2-THUNDER--ALT%20VERSION--Template-1.4_VBR5.mp3",
      "remote_filename": "TechnoUnkn2-THUNDER--ALT VERSION--Template-1.4_VBR5.mp3",
      "filename": "TechnoUnkn2-THUNDER-ALT-VERSION-Template-1.4_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/TechnoUnkn2-THUNDER-ALT-VERSION-Template-1.4_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22886222,
      "sha256": "fe2f71382cb09934c0ef0b2bb178550a6940ed4698217fcd9afe22b29d9bad68",
      "download_error": null
    },
    {
      "track_id": "62b380e95924110513f4d6c8",
      "name": "Potential Energy",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.85,
      "style": "normal",
      "neural_effect_level": 0.14,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Potential%20Energy%20Nature%20Focus%20Thunder%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=%2BnWGHI4z5XyhfjH5h167cuQa2Cp%2FyBDVe5BU6O2uFK0%3D",
      "cdn_url": "https://audio2.brain.fm/Potential%20Energy%20Nature%20Focus%20Thunder%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Potential Energy Nature Focus Thunder Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Potential-Energy-Nature-Focus-Thunder-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Potential-Energy-Nature-Focus-Thunder-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27149298,
      "sha256": "4f7112a2c40a5ff85e131bee9ed34fd67808f9bdd6c39ff8518348bc5040f457",
      "download_error": null
    },
    {
      "track_id": "62b380e659241187bef4d5ab",
      "name": "Thunder in the Valley",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.02,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Thunder%20in%20the%20Valley%20Thunder%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=LY58%2FEiJOupkGTgktxnPYMQhYM78SSoTxewh6I1faQU%3D",
      "cdn_url": "https://audio2.brain.fm/Thunder%20in%20the%20Valley%20Thunder%20Focus%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Thunder in the Valley Thunder Focus Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Thunder-in-the-Valley-Thunder-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Thunder-in-the-Valley-Thunder-Focus-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27617714,
      "sha256": "89afb929a569b5ce38fd42daa091075cd5298c4ac0a9d115bbcb8da5ff6dab1e",
      "download_error": null
    },
    {
      "track_id": "62b380e5592411faa2f4d554",
      "name": "Thunder Symphony",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.44,
      "complexity_level": 0.39,
      "style": "normal",
      "neural_effect_level": 0.8,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Thunder%20Symphony%20Thunder%20Focus%201%20Conor_1.8_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=08y6yCaULacle1ShliVRIHM0628DfYqdRZrRNTdoS9U%3D",
      "cdn_url": "https://audio2.brain.fm/Thunder%20Symphony%20Thunder%20Focus%201%20Conor_1.8_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Thunder Symphony Thunder Focus 1 Conor_1.8_Nrmlzd2_VBR5.mp3",
      "filename": "Thunder-Symphony-Thunder-Focus-1-Conor_1.8_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Thunder-Symphony-Thunder-Focus-1-Conor_1.8_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24958408,
      "sha256": "3bf933b8c17fc1d2c0b68edf8de4eb1147f93887cffd66f0858738bb663adcda",
      "download_error": null
    },
    {
      "track_id": "62b3802f592411ef0bf4b1ce",
      "name": "Western Winds",
      "category": "Thunder",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.89,
      "style": "normal",
      "neural_effect_level": 0.08,
      "source_json": "outputs/thunder.json",
      "source_url": "https://audio2.brain.fm/Western%20Winds%20Nature%20Focus%20Thunder%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292115584&token=QClwICxszU8AnlLtS2SkOhclbmnVHIUYhz%2F6zNfQYuw%3D",
      "cdn_url": "https://audio2.brain.fm/Western%20Winds%20Nature%20Focus%20Thunder%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Western Winds Nature Focus Thunder Study Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Western-Winds-Nature-Focus-Thunder-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/thunder/Western-Winds-Nature-Focus-Thunder-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 29987781,
      "sha256": "58776ac89243dcdfd363e84301f40b4c515fb35c3534bd8b1ecf34adc6d4f8be",
      "download_error": null
    },
    {
      "track_id": "64302cf95ee24c3d23a06dcc",
      "name": "Seamount",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.12,
      "complexity_level": 0.92,
      "style": "normal",
      "neural_effect_level": 0.37,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Seamount_Focus_Creativity_Underwater_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=0YJS4GUHHtpRu%2BpkHr2tOYMkRDS8HrdM%2FMDpUyaHu40%3D",
      "cdn_url": "https://audio2.brain.fm/Seamount_Focus_Creativity_Underwater_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Seamount_Focus_Creativity_Underwater_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Seamount_Focus_Creativity_Underwater_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Seamount_Focus_Creativity_Underwater_30_120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23478272,
      "sha256": "b01f7e8e5a976f3eaedd41629ba56b7c7d30f6fcdefc98b1306c825416288afa",
      "download_error": null
    },
    {
      "track_id": "643029135ee24c02eaa054c4",
      "name": "Arctic Midnight",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.14,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/ArcticMidnight_Focus_DeepWork_Underwater_30_120bpm_HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=0bkCDwMPAtDgKmak3i2JnSWbB%2BLhcq5qCJNJrI29xuo%3D",
      "cdn_url": "https://audio2.brain.fm/ArcticMidnight_Focus_DeepWork_Underwater_30_120bpm_HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "ArcticMidnight_Focus_DeepWork_Underwater_30_120bpm_HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "ArcticMidnight_Focus_DeepWork_Underwater_30_120bpm_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/ArcticMidnight_Focus_DeepWork_Underwater_30_120bpm_HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24832899,
      "sha256": "0b105bbb7941af72c9f613feea3da56c881cc6873e6a7ab19f9cd56d761933ee",
      "download_error": null
    },
    {
      "track_id": "6430285823c3bef1f23fa42d",
      "name": "Abyssopelagic",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.22,
      "complexity_level": 0.66,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Abyssopelagic_Focus_DeepWork_Underwater_30_120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=rBk9Uiln%2BUzDPyEcvviqtfHJJsd0if5gyQOcJQd%2FmFU%3D",
      "cdn_url": "https://audio2.brain.fm/Abyssopelagic_Focus_DeepWork_Underwater_30_120bpm_MED%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Abyssopelagic_Focus_DeepWork_Underwater_30_120bpm_MED NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Abyssopelagic_Focus_DeepWork_Underwater_30_120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Abyssopelagic_Focus_DeepWork_Underwater_30_120bpm_MED-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22407378,
      "sha256": "6c770c2e5e672436229eabec9df89e5e36a42ac5f7885875ba2d340ee9e38c2a",
      "download_error": null
    },
    {
      "track_id": "62b38c165924114767f55483",
      "name": "Diving Deep",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.01,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/UnderwaterJustWater-FOCUS-BeatBubbleAmbience-2.2_VBR5.mp3?expiration=1792292117206&token=EFkU5xDDQZF1NZ1XRG8%2FCDL6QB%2FPjftj0gPXbuyXKe8%3D",
      "cdn_url": "https://audio2.brain.fm/UnderwaterJustWater-FOCUS-BeatBubbleAmbience-2.2_VBR5.mp3",
      "remote_filename": "UnderwaterJustWater-FOCUS-BeatBubbleAmbience-2.2_VBR5.mp3",
      "filename": "UnderwaterJustWater-FOCUS-BeatBubbleAmbience-2.2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/UnderwaterJustWater-FOCUS-BeatBubbleAmbience-2.2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 39528107,
      "sha256": "533235116a5506fe425dea87cf4fa475e5f69f33ba4b583dba44a7c494cbc6f7",
      "download_error": null
    },
    {
      "track_id": "62b38bff5924111668f55228",
      "name": "Beneath the Waves",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.05,
      "complexity_level": 0.49,
      "style": "normal",
      "neural_effect_level": 0.36,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/UnderwaterJustWater-FOCUS-1.0_VBR5.mp3?expiration=1792292117206&token=tVyNpwp9lN8uvu7FGmoRPq0eRcCTLkCDVuWOLUPFwqE%3D",
      "cdn_url": "https://audio2.brain.fm/UnderwaterJustWater-FOCUS-1.0_VBR5.mp3",
      "remote_filename": "UnderwaterJustWater-FOCUS-1.0_VBR5.mp3",
      "filename": "UnderwaterJustWater-FOCUS-1.0_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/UnderwaterJustWater-FOCUS-1.0_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19151250,
      "sha256": "4eb351a41ed01926813cce5a1eeac712bbdd0c5d01bf01fc966814b050d3f32b",
      "download_error": null
    },
    {
      "track_id": "62b38afd592411f222f54e88",
      "name": "Submarine Exploration",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.02,
      "complexity_level": 0.61,
      "style": "normal",
      "neural_effect_level": 0.51,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Submarine%20Exploration%20Nature%20Focus%20Underwater%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=qz%2FTxhAG%2F2Ge90UaeeSBZeoJz5Nwe3Vzid%2Bv5XO%2FF8Y%3D",
      "cdn_url": "https://audio2.brain.fm/Submarine%20Exploration%20Nature%20Focus%20Underwater%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Submarine Exploration Nature Focus Underwater Study Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Submarine-Exploration-Nature-Focus-Underwater-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Submarine-Exploration-Nature-Focus-Underwater-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21551868,
      "sha256": "925e612984553c0023c3b36831f513ca9efd352a48557c670f544918c449f223",
      "download_error": null
    },
    {
      "track_id": "62b38afc592411b20df54e69",
      "name": "Midnight Realm",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.57,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.63,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Midnight%20Realm%20Nature%20Focus%20Underwater%20Study%20Conor%20120bpm_MedNEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=%2B9YFFtZrxJ%2BzQophsFFOsk9dJe6WcOnqU19dNrg5j%2B0%3D",
      "cdn_url": "https://audio2.brain.fm/Midnight%20Realm%20Nature%20Focus%20Underwater%20Study%20Conor%20120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Midnight Realm Nature Focus Underwater Study Conor 120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Midnight-Realm-Nature-Focus-Underwater-Study-Conor-120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Midnight-Realm-Nature-Focus-Underwater-Study-Conor-120bpm_MedNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24831080,
      "sha256": "b1bf4e4271d640e6456f384080873ab1d607cccdafaf5d8eab523de3982cdd71",
      "download_error": null
    },
    {
      "track_id": "62b38af1592411d481f54d38",
      "name": "Submarine",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.38,
      "complexity_level": 0.59,
      "style": "normal",
      "neural_effect_level": 0.42,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Submarine%20Nature%20Focus%20Underwater%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=%2FzUYo2AYsJ8BKxC0fxuwbwv0egNIXVaIxPxplPEToG4%3D",
      "cdn_url": "https://audio2.brain.fm/Submarine%20Nature%20Focus%20Underwater%20Light%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Submarine Nature Focus Underwater Light Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Submarine-Nature-Focus-Underwater-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Submarine-Nature-Focus-Underwater-Light-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 25753605,
      "sha256": "0b196952874f89ccb7cd2cc631d8d42578149528adf3437ffec6b9441e8cbabf",
      "download_error": null
    },
    {
      "track_id": "62b38ae95924119db4f54c5f",
      "name": "Treasure Undersea",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.51,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Treasure%20Undersea%20Nature%20Focus%20Underwater%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=KP0SrauQUSODVQxLpbeSc7JEEpOtkAXfwkz8J5dtTs8%3D",
      "cdn_url": "https://audio2.brain.fm/Treasure%20Undersea%20Nature%20Focus%20Underwater%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Treasure Undersea Nature Focus Underwater Creative Flow Conor 120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Treasure-Undersea-Nature-Focus-Underwater-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Treasure-Undersea-Nature-Focus-Underwater-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24623600,
      "sha256": "83db1920dfc2c9c037fb91f3905224b608ac3fa8b7d6cd569189a6d3e1b1f115",
      "download_error": null
    },
    {
      "track_id": "62b38aa2592411f5b9f549e3",
      "name": "Within Waves",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.52,
      "complexity_level": 0.54,
      "style": "normal",
      "neural_effect_level": 0.94,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Within%20Waves%20Nature%20Focus%20Underwater%20Light%20Work%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=9Z8FI5oF7gTNWxvxu0irjyZSPlPtGZLDkiC0beV9U5c%3D",
      "cdn_url": "https://audio2.brain.fm/Within%20Waves%20Nature%20Focus%20Underwater%20Light%20Work%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Within Waves Nature Focus Underwater Light Work Conor 120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Within-Waves-Nature-Focus-Underwater-Light-Work-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Within-Waves-Nature-Focus-Underwater-Light-Work-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 24249212,
      "sha256": "2186807f078d91c8ea513a5dba4fe9c9f26a50fbeeb6724fd925d76ab5e7362d",
      "download_error": null
    },
    {
      "track_id": "62b3895a5924117a53f53488",
      "name": "Ocean Depths",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.12,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.34,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Ocean%20Depths%20Nature%20Focus%20Underwater%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=b%2BAg8Uf0SdVpksBn%2FSZEvawyUZuug18XYIwWQdktngw%3D",
      "cdn_url": "https://audio2.brain.fm/Ocean%20Depths%20Nature%20Focus%20Underwater%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Ocean Depths Nature Focus Underwater Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Ocean-Depths-Nature-Focus-Underwater-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Ocean-Depths-Nature-Focus-Underwater-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21127249,
      "sha256": "4a41eba45d002de5c0b505528647828c7263c1b8a298273b30a93b36e3e24aa7",
      "download_error": null
    },
    {
      "track_id": "62b38445592411303bf506cd",
      "name": "Deep Sea Exploration",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.13,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/UnderwaterDeepDrones-FOCUS-1.0_VBR5.mp3?expiration=1792292117206&token=WOQNU%2FBdy1Ujlm128whvY1kEyoCRL%2B0%2BS0S8xGc%2FnWA%3D",
      "cdn_url": "https://audio2.brain.fm/UnderwaterDeepDrones-FOCUS-1.0_VBR5.mp3",
      "remote_filename": "UnderwaterDeepDrones-FOCUS-1.0_VBR5.mp3",
      "filename": "UnderwaterDeepDrones-FOCUS-1.0_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/UnderwaterDeepDrones-FOCUS-1.0_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 19675210,
      "sha256": "28b91c66043336d3bfebd4a256f1438868b7535ff520530106b78cecbfe298d0",
      "download_error": null
    },
    {
      "track_id": "62b3843f59241168f6f5059c",
      "name": "Coral Forest",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.25,
      "complexity_level": 0.6,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Coral%20Reef%20Nature%20Focus%20Underwater%20Study%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=9xtuODZz2s7sA7koWvYdAWpNZtea1V1WgPxuuv1%2FS64%3D",
      "cdn_url": "https://audio2.brain.fm/Coral%20Reef%20Nature%20Focus%20Underwater%20Study%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Coral Reef Nature Focus Underwater Study Conor 120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Coral-Reef-Nature-Focus-Underwater-Study-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Coral-Reef-Nature-Focus-Underwater-Study-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22604304,
      "sha256": "dd151adc8cb09104310fed4ffbfe17ff99af57821ecf4fa62d5fb6301b614223",
      "download_error": null
    },
    {
      "track_id": "62b380e959241102c4f4d6a9",
      "name": "Glacial Hideout",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.37,
      "complexity_level": 0.57,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Glacial%20Hideout%20Nature%20Focus%20Underwater%20Deep%20Work%20Conor%20120bpm%20HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=Pdj5lwDOrdICGjzm8eDf%2F%2BTwPoI5P3lrcV4X59aUB2U%3D",
      "cdn_url": "https://audio2.brain.fm/Glacial%20Hideout%20Nature%20Focus%20Underwater%20Deep%20Work%20Conor%20120bpm%20HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Glacial Hideout Nature Focus Underwater Deep Work Conor 120bpm HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Glacial-Hideout-Nature-Focus-Underwater-Deep-Work-Conor-120bpm-HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Glacial-Hideout-Nature-Focus-Underwater-Deep-Work-Conor-120bpm-HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23956912,
      "sha256": "15e4837e1ccd89c467b68f5c8d08e680ac570c70c127d46104d6f08a447497a1",
      "download_error": null
    },
    {
      "track_id": "62b38065592411d02cf4c306",
      "name": "Living Reef",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.34,
      "complexity_level": 0.45,
      "style": "normal",
      "neural_effect_level": 0.99,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Living%20Reef%20Nature%20Focus%20Underwater%20Deep%20Work%20Conor%20120bpm%20HIGH%20NEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=KPeC50cD3KXZqeOiRGXKd0HN6fcfjY21oJwZuxkbW3k%3D",
      "cdn_url": "https://audio2.brain.fm/Living%20Reef%20Nature%20Focus%20Underwater%20Deep%20Work%20Conor%20120bpm%20HIGH%20NEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Living Reef Nature Focus Underwater Deep Work Conor 120bpm HIGH NEL_Nrmlzd2_VBR5.mp3",
      "filename": "Living-Reef-Nature-Focus-Underwater-Deep-Work-Conor-120bpm-HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Living-Reef-Nature-Focus-Underwater-Deep-Work-Conor-120bpm-HIGH-NEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23515035,
      "sha256": "3f6fd76e7c99c8cc4581d52b57c920d60344ab504997575fd0bb81baff8a4dd4",
      "download_error": null
    },
    {
      "track_id": "62b380605924112a26f4bf85",
      "name": "Aquatic Perspective",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Light Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.14,
      "complexity_level": 0.47,
      "style": "normal",
      "neural_effect_level": 0.96,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Aquatic%20Perspective%20Nature%20Focus%20Underwater%20Light%20Work%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=JflUXIG1l29wJNbZW6MNYkUc0V7zc19360Roce%2Fdp0M%3D",
      "cdn_url": "https://audio2.brain.fm/Aquatic%20Perspective%20Nature%20Focus%20Underwater%20Light%20Work%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Aquatic Perspective Nature Focus Underwater Light Work Conor 120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Aquatic-Perspective-Nature-Focus-Underwater-Light-Work-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Aquatic-Perspective-Nature-Focus-Underwater-Light-Work-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 22943694,
      "sha256": "0ee366552a966f73dc416688b40b481f1dd8c5d8404ddc049be668aa5a4d20b6",
      "download_error": null
    },
    {
      "track_id": "62b3805b5924113992f4bb9e",
      "name": "Into the Deep",
      "category": "Underwater",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.19,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.97,
      "source_json": "outputs/underwater.json",
      "source_url": "https://audio2.brain.fm/Into%20the%20Deep%20Blue%20Nature%20Focus%20Underwater%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292117206&token=tpUPSOZ5nL3j0HK9a2WRrIididiuOff8l9Mb1u5kSmc%3D",
      "cdn_url": "https://audio2.brain.fm/Into%20the%20Deep%20Blue%20Nature%20Focus%20Underwater%20Creative%20Flow%20Conor%20120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Into the Deep Blue Nature Focus Underwater Creative Flow Conor 120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Into-the-Deep-Blue-Nature-Focus-Underwater-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/underwater/Into-the-Deep-Blue-Nature-Focus-Underwater-Creative-Flow-Conor-120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 23266885,
      "sha256": "4fa895ed47093f8c78ffef77fc7942da43178c0de0cc179d7811bf4010b13e1d",
      "download_error": null
    },
    {
      "track_id": "633dc12e840cdf1873591885",
      "name": "Zonda",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.89,
      "complexity_level": 0.34,
      "style": "normal",
      "neural_effect_level": 0.73,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Zonda_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=OaxEnalvld9jABU9jDKKBhMPNcrIX139mdBXsMS37%2Bk%3D",
      "cdn_url": "https://audio2.brain.fm/Zonda_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Zonda_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Zonda_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Zonda_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28733179,
      "sha256": "bedc937f6cf744cd39e4a3582aa175497de87d1b643d03cf603e349e44860ec7",
      "download_error": null
    },
    {
      "track_id": "633dc10883f4ff51f8a42da9",
      "name": "Mistral",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.81,
      "complexity_level": 0.23,
      "style": "normal",
      "neural_effect_level": 0.92,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Mistral_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=ay0HA1%2BPyh7vIPCAGCrzfOfvlXxPezxxaTQsiKYJ5pE%3D",
      "cdn_url": "https://audio2.brain.fm/Mistral_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Mistral_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Mistral_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Mistral_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26628316,
      "sha256": "929c0a5acf55ce0816c10c5647fc2b0d28b02b9c57229d0867c647e9e83f84ac",
      "download_error": null
    },
    {
      "track_id": "633dc0e583f4ff1427a42d49",
      "name": "Hinterland",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.97,
      "complexity_level": 0.14,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Hinterland_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=huV%2BK34WZxxN6vkK4g6Oo5kN7BMV4F5M42nZTDUuatk%3D",
      "cdn_url": "https://audio2.brain.fm/Hinterland_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Hinterland_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Hinterland_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Hinterland_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26914821,
      "sha256": "088be9dd23f5a4ad61cb4155e3ffbc4fd47e238b8ea6a37d166cbfe11cdcddfa",
      "download_error": null
    },
    {
      "track_id": "633dc0c583f4ff1e14a42cfe",
      "name": "Buran",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.93,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.6,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Buran_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=bjcCr%2F55GKCuLNdQBPB0lwde6RutZZ96%2BTmT0Wzxgbo%3D",
      "cdn_url": "https://audio2.brain.fm/Buran_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Buran_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Buran_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Buran_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28255680,
      "sha256": "6dcc6d16615fc207a616aa2cc026a1377394ec6af753ac465356d106e5b5c79b",
      "download_error": null
    },
    {
      "track_id": "633dc0a383f4ff20caa42bff",
      "name": "Bora",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.77,
      "complexity_level": 0.42,
      "style": "normal",
      "neural_effect_level": 0.54,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Bora_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=YptytzM%2FZjV0h%2FtkYvJK%2BzCB%2FP3ml4TFUgGAHbY4qIs%3D",
      "cdn_url": "https://audio2.brain.fm/Bora_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Bora_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Bora_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Bora_Focus_Learning_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27916587,
      "sha256": "39001d3f387b41d23524c23a4ac7ccf39de64f3f98b83e900200ea95d2fd0b31",
      "download_error": null
    },
    {
      "track_id": "633db66a840cdf23af58aef4",
      "name": "Zephyr",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.86,
      "complexity_level": 0.32,
      "style": "normal",
      "neural_effect_level": 0.66,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Zephyr_Focus_Creativity_Wind_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=NbTMJWKW6XuaznOf52VMQPHBTuVzS9wccN51pC%2FExqc%3D",
      "cdn_url": "https://audio2.brain.fm/Zephyr_Focus_Creativity_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Zephyr_Focus_Creativity_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Zephyr_Focus_Creativity_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Zephyr_Focus_Creativity_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26917275,
      "sha256": "199d28ecea260641a9f9118d00b3c60d58b63cad8b8a589b346404b16f5dff66",
      "download_error": null
    },
    {
      "track_id": "633db64683f4ff1c45a3cf1d",
      "name": "Sirocco",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.72,
      "complexity_level": 0.28,
      "style": "normal",
      "neural_effect_level": 0.13,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Sirocco_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=AlqOZRKg%2BBocuuU5RDmhd%2BEFra%2FozELPhAD%2F%2FPImWlw%3D",
      "cdn_url": "https://audio2.brain.fm/Sirocco_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Sirocco_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Sirocco_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Sirocco_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27028722,
      "sha256": "fceb80a1ea6a2dddb636470106aed29e002b4493d50d3c882dd1de6368749d6b",
      "download_error": null
    },
    {
      "track_id": "633db626840cdf6ef358ab25",
      "name": "Polar Easterlies",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.82,
      "complexity_level": 0.22,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Polar%20Easterlies_Focus_Creativity_Wind_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=JieHdUVnZ8tNfkKX91ZBX5SzsLTjT%2BXdxjgNSufsc2w%3D",
      "cdn_url": "https://audio2.brain.fm/Polar%20Easterlies_Focus_Creativity_Wind_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Polar Easterlies_Focus_Creativity_Wind_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Polar-Easterlies_Focus_Creativity_Wind_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Polar-Easterlies_Focus_Creativity_Wind_30_120bpm_HighNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26214013,
      "sha256": "797355ae138d811d3b0bef366a35db50db03ecae9f0bd2c0476569c60cf5fc2c",
      "download_error": null
    },
    {
      "track_id": "633db5ff83f4fffc67a3cc71",
      "name": "Khamseen",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.92,
      "complexity_level": 0.21,
      "style": "normal",
      "neural_effect_level": 0.91,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Khamseen_Focus_Creativity_Wind_30_120bpm_HighNEL_Test_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=6kliH4WFdhRCJR%2BwmKWJg2BhxpjEiVz4vYnfTeMPTbE%3D",
      "cdn_url": "https://audio2.brain.fm/Khamseen_Focus_Creativity_Wind_30_120bpm_HighNEL_Test_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Khamseen_Focus_Creativity_Wind_30_120bpm_HighNEL_Test_Nrmlzd2_VBR5.mp3",
      "filename": "Khamseen_Focus_Creativity_Wind_30_120bpm_HighNEL_Test_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Khamseen_Focus_Creativity_Wind_30_120bpm_HighNEL_Test_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27228742,
      "sha256": "5c644d20f63afc15cc637ed5b4e1c564f5432ae4ff5989db601f4a68f1fb9ab6",
      "download_error": null
    },
    {
      "track_id": "633db5db83f4ff1a1ba3ca49",
      "name": "Gibli",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.94,
      "complexity_level": 0.19,
      "style": "normal",
      "neural_effect_level": 0.2,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Gibli_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=VZ1IHZB48eIeDrNmK%2B3vG7v4Su6fc0TN1sOGgiux%2ByM%3D",
      "cdn_url": "https://audio2.brain.fm/Gibli_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Gibli_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Gibli_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Gibli_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 27210182,
      "sha256": "f734cd8b40afb308a945173e977de1e4eadaf9d03708786e94ab3163aa9f05d1",
      "download_error": null
    },
    {
      "track_id": "633db5b7840cdf527258a968",
      "name": "Coriolis",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Creative Flow",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.78,
      "complexity_level": 0.18,
      "style": "normal",
      "neural_effect_level": 0.29,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Coriolis_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=LVItB2FQ8MaO1l%2F93%2BuXv4hGpNpe7Hzf6HzBiTkkjM0%3D",
      "cdn_url": "https://audio2.brain.fm/Coriolis_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Coriolis_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "filename": "Coriolis_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Coriolis_Focus_Creativity_Wind_30_120bpm_LowNEL_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26115797,
      "sha256": "7dff0f96974cc19743f952890ccaf783d9e8e9e4c8ec487efdda9e0f2db7b2cb",
      "download_error": null
    },
    {
      "track_id": "6303db00c2945ce7e5ed76c1",
      "name": "Etesians",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.9,
      "complexity_level": 0.2,
      "style": "normal",
      "neural_effect_level": 0.43,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Etesians_Focus_Deep%20Work_Wind_30_120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=NC%2BleDPjcEc%2BG9E1ZAg31fndTuVBKBlSAdxANsdU9AY%3D",
      "cdn_url": "https://audio2.brain.fm/Etesians_Focus_Deep%20Work_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Etesians_Focus_Deep Work_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Etesians_Focus_Deep-Work_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Etesians_Focus_Deep-Work_Wind_30_120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 26998609,
      "sha256": "b032d2a561e210cf3e1f8d0047beaaffd3db48ea4950cad4648cc94df3345c46",
      "download_error": null
    },
    {
      "track_id": "62b38b085924114a86f54fa3",
      "name": "Tundra Winds",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Study & Read",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.85,
      "complexity_level": 0.36,
      "style": "normal",
      "neural_effect_level": 0.12,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Tundra%20Winds%20Nature%20Focus%20Wind%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=5GG9AGdOmM4exmnp1Vlv%2FZ%2FA0QaoTierOshe0aTExng%3D",
      "cdn_url": "https://audio2.brain.fm/Tundra%20Winds%20Nature%20Focus%20Wind%20Study%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Tundra Winds Nature Focus Wind Study Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Tundra-Winds-Nature-Focus-Wind-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Tundra-Winds-Nature-Focus-Wind-Study-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28188833,
      "sha256": "a03cf4130391bfcd5199b4d4dfd832733bc13a160be85c0b2243ad7bd08c116b",
      "download_error": null
    },
    {
      "track_id": "62b384465924114818f50703",
      "name": "Refreshing Breeze",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.79,
      "complexity_level": 0.4,
      "style": "normal",
      "neural_effect_level": 0.24,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Refreshing%20Breeze%20Nature%20Focus%20Wind%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=FrpDcxXNw0MQ3cBdyHsOyfjM8hsUsO86S6mNFTzOz2Y%3D",
      "cdn_url": "https://audio2.brain.fm/Refreshing%20Breeze%20Nature%20Focus%20Wind%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Refreshing Breeze Nature Focus Wind Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Refreshing-Breeze-Nature-Focus-Wind-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Refreshing-Breeze-Nature-Focus-Wind-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28265182,
      "sha256": "5cf1a85fac9fbafe5a5c76721a407958f7494586e8fbb3513ab532c042b223d5",
      "download_error": null
    },
    {
      "track_id": "62b38136592411e476f4ebe9",
      "name": "Afternoon Breeze",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.48,
      "complexity_level": 0.48,
      "style": "normal",
      "neural_effect_level": 0.48,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/Afternoon%20Breeze%20Nature%20Focus%20Wind%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3?expiration=1792292118630&token=Hz01GuU%2FQ27Di9CBVmbL85Q7oXwGHCs3wS%2Bydcm76bA%3D",
      "cdn_url": "https://audio2.brain.fm/Afternoon%20Breeze%20Nature%20Focus%20Wind%20Deep%20Work%20Conor%20120bpm_Nrmlzd2_VBR5.mp3",
      "remote_filename": "Afternoon Breeze Nature Focus Wind Deep Work Conor 120bpm_Nrmlzd2_VBR5.mp3",
      "filename": "Afternoon-Breeze-Nature-Focus-Wind-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "relative_path": "outputs/audio/wind/Afternoon-Breeze-Nature-Focus-Wind-Deep-Work-Conor-120bpm_Nrmlzd2_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 6270976,
      "sha256": "c6604ac5391bcc785ecd21c7b15489e52b977b2fec4c5d4f5440c1d4a1f7d030",
      "download_error": null
    },
    {
      "track_id": "62b380e7592411a00af4d5ca",
      "name": "Pacific Drift",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.58,
      "complexity_level": 0.6,
      "style": "normal",
      "neural_effect_level": 0.88,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/WindTemplateFOCUS.9_WithBeatAmbience_ac_1_VBR5.mp3?expiration=1792292118630&token=Jh7gC%2BIFpJa%2BAeEVpv9L0OMr2xJRyJi%2FyKazcVWLCjA%3D",
      "cdn_url": "https://audio2.brain.fm/WindTemplateFOCUS.9_WithBeatAmbience_ac_1_VBR5.mp3",
      "remote_filename": "WindTemplateFOCUS.9_WithBeatAmbience_ac_1_VBR5.mp3",
      "filename": "WindTemplateFOCUS.9_WithBeatAmbience_ac_1_VBR5.mp3",
      "relative_path": "outputs/audio/wind/WindTemplateFOCUS.9_WithBeatAmbience_ac_1_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 28356722,
      "sha256": "60a140f40fab0a4726d713ac040914dbc64f76ab4b07840e5f6c6c11b702e367",
      "download_error": null
    },
    {
      "track_id": "62b3808e5924114232f4d0d1",
      "name": "Charged Particles",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.29,
      "complexity_level": 0.01,
      "style": "normal",
      "neural_effect_level": 0.26,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/WindTemplateFOCUS.8-Ambience_ac_4_VBR5.mp3?expiration=1792292118630&token=yhVoF8vfbxGi6CVfVpdQ80fuHw2xvLphiriAc7b%2FQUo%3D",
      "cdn_url": "https://audio2.brain.fm/WindTemplateFOCUS.8-Ambience_ac_4_VBR5.mp3",
      "remote_filename": "WindTemplateFOCUS.8-Ambience_ac_4_VBR5.mp3",
      "filename": "WindTemplateFOCUS.8-Ambience_ac_4_VBR5.mp3",
      "relative_path": "outputs/audio/wind/WindTemplateFOCUS.8-Ambience_ac_4_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 47652426,
      "sha256": "0e1805345d800d4ccc71bfb5ee7632a416d989c55b9c96ed5e39a5f9064a546b",
      "download_error": null
    },
    {
      "track_id": "62b3805f592411aedcf4bf18",
      "name": "Sunflower Field",
      "category": "Wind",
      "mental_state": "Focus",
      "activity": "Deep Work",
      "duration_seconds": 1800,
      "beats_per_minute": 120,
      "brightness_level": 0.56,
      "complexity_level": 0.1,
      "style": "normal",
      "neural_effect_level": 0.44,
      "source_json": "outputs/wind.json",
      "source_url": "https://audio2.brain.fm/WindTemplateFOCUS.9_With(just)Ambience_ac_5_VBR5.mp3?expiration=1792292118630&token=bwBEnBrctXxozAs3sQ84Cou9QT305oWQwjtVNGxPG2I%3D",
      "cdn_url": "https://audio2.brain.fm/WindTemplateFOCUS.9_With(just)Ambience_ac_5_VBR5.mp3",
      "remote_filename": "WindTemplateFOCUS.9_With(just)Ambience_ac_5_VBR5.mp3",
      "filename": "WindTemplateFOCUS.9_With-just-Ambience_ac_5_VBR5.mp3",
      "relative_path": "outputs/audio/wind/WindTemplateFOCUS.9_With-just-Ambience_ac_5_VBR5.mp3",
      "download_status": "downloaded",
      "size_bytes": 21930423,
      "sha256": "500724a288b13003658c84278dd689b4a4ff130ab803267e0802ea95c76c3706",
      "download_error": null
    }
  ]
}
